import { BaseComponentLocalizer, BaseComponent, AlertType, PageRouteProvider, BaseInputType, ReactUtility, InputValidationRule, Justify, ch, MessageBoxButtons, MessageBoxIcon, DialogResult, Align, BaseAsyncComponent, DocumentPreviewModel, DocumentPreviewSize, LayoutBreak, PageRoute, StylesUtility, ArrayScope, ActionType, DescriptionModel, TextAlign, VerticalAlign, DataStorageType, UserInteractionDataStorage, JQueryUtility, BackButtonVisibility, CameraType, WebApplicationType, SwipeDirection, BasePageDefinitions, LinkTarget, PasswordValidationRule } from '@reapptor-apps/reapptor-react-common';
import React, { useRef, useCallback, useEffect } from 'react';
import { GeoCoordinate, AthenaeumConstants, Language, Utility, ServiceProvider, FileModel, GeoLocation, HashCodeUtility, StringUtility, BoolUtility, NumberUtility, TypeConverter, SortDirection } from '@reapptor-apps/reapptor-toolkit';
import ReactDOM from 'react-dom';
import SwiperCore, { Navigation, Pagination as Pagination$1 } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Dictionary } from 'typescript-collections';
import * as DatePickerLibrary from 'react-datepicker';
import DatePickerLibrary__default, { registerLocale, setDefaultLocale } from 'react-datepicker';
import SliderComponent, { createSliderWithTooltip, Range as Range$1 } from 'rc-slider';
import 'rc-slider/assets/index.css';
import queryString from 'query-string';
import 'react-datepicker/dist/react-datepicker.css';
import { BrowserQRCodeReader, BrowserCodeReader } from '@zxing/browser';
import { DecodeHintType, ArgumentException } from '@zxing/library';
import SignatureCanvas from 'react-signature-canvas';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { Helmet } from 'react-helmet';
import Cropper$1 from 'react-cropper';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class AthenaeumComponentsConstants extends AthenaeumConstants {}
AthenaeumComponentsConstants.applicationName = "Athenaeum";
// 10 MB
AthenaeumComponentsConstants.maxFileUploadSizeInBytes = 10 * 1024 * 1024;
// 50 MB
AthenaeumComponentsConstants.maxImageRequestSizeInBytes = 50 * 1024 * 1024;
AthenaeumComponentsConstants.alertAutoCloseDelay = 5000;
AthenaeumComponentsConstants.alertAnimationDelay = 500;
// Helsinki coordinates
AthenaeumComponentsConstants.defaultLocation = new GeoCoordinate(60.192059, 24.945831);
// "If user has been signed in more than 15 hours straight throw user out"
AthenaeumComponentsConstants.signOutExpirationTimeOut = 15;
// 255
AthenaeumComponentsConstants.maxTitleDescriptionLength = 255;

//Autogenerated
class AlertLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var AlertLocalizer$1 = new AlertLocalizer();

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$17 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-alert-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-alert-alert {\n  padding: 0 !important;\n  width: 100%;\n  display: flex;\n  max-height: calc(100% + 1px);\n  opacity: 1;\n  margin-top: 15px;\n}\n.athenaeum-alert-alert .athenaeum-alert-message {\n  width: 100%;\n  margin: 0.75rem 1.25rem;\n}\n.athenaeum-alert-alert .athenaeum-alert-message .athenaeum-alert-close {\n  float: right;\n  display: inline;\n  vertical-align: top;\n  cursor: pointer;\n  position: relative;\n  width: 21px;\n  height: 21px;\n  margin-right: -10px;\n  opacity: 0.5;\n}\n.athenaeum-alert-alert .athenaeum-alert-message .athenaeum-alert-close:hover {\n  opacity: 1;\n}\n.athenaeum-alert-alert .athenaeum-alert-message .athenaeum-alert-close > span {\n  position: absolute;\n  line-height: 0;\n  font-size: 24px;\n  top: 9px;\n  left: 5px;\n}\n.athenaeum-alert-alert .athenaeum-alert-message.athenaeum-alert-route {\n  cursor: pointer;\n}\n.athenaeum-alert-alert.athenaeum-alert-flyout {\n  position: fixed;\n  top: 46px;\n  border-radius: 0;\n  right: 1px;\n  width: 350px;\n  display: flex;\n  align-items: center;\n  transition: right 0.2s ease-in-out;\n  z-index: 1001;\n  margin: 0 !important;\n}\n.athenaeum-alert-alert.athenaeum-alert-flyout.athenaeum-alert-fadeOut {\n  right: -351px;\n}\n.athenaeum-alert-alert.athenaeum-alert-mobile {\n  width: 100%;\n  left: 1px;\n}\n\n.athenaeum-alert-dashboardAlert {\n  max-width: 628px;\n  margin-top: 0;\n  margin-bottom: 4px;\n  text-align: center;\n  background: rgba(234, 60, 0, 0.9);\n  border: none;\n  cursor: default;\n  color: white;\n  border-radius: 5px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-alert-dashboardAlert {\n    margin: 0 6px 8px 6px;\n  }\n}";
var styles$$ = {"font-renta":"athenaeum-alert-font-renta","alert":"athenaeum-alert-alert","message":"athenaeum-alert-message","close":"athenaeum-alert-close","route":"athenaeum-alert-route","flyout":"athenaeum-alert-flyout","fadeOut":"athenaeum-alert-fadeOut","mobile":"athenaeum-alert-mobile","dashboardAlert":"athenaeum-alert-dashboardAlert"};
styleInject(css_248z$17);

class Alert extends BaseComponent {
  get applyRouteStyles() {
    return this.model.route != null;
  }
  onCloseAlertAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      yield this.closeAlertAsync(true);
    });
  }
  closeAlertAsync(userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClose) {
        yield this.props.onClose(this, userInteraction);
      }
    });
  }
  closeWithDelayAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      const autoCloseDelay = (_a = this.model.autoCloseDelay) !== null && _a !== void 0 ? _a : AthenaeumComponentsConstants.alertAutoCloseDelay;
      yield Utility.wait(autoCloseDelay);
      this.fadeOut();
      yield this.closeAlertAsync(false);
    });
  }
  fadeOut() {
    const alertNode = this.getNode();
    alertNode.addClass(styles$$.fadeOut);
  }
  getAlertType() {
    switch (this.model.alertType) {
      case AlertType.Success:
        return "alert-success";
      case AlertType.Warning:
        return "alert-warning";
      case AlertType.Danger:
        return "alert-danger";
      case AlertType.Primary:
        return "alert-primary";
      case AlertType.Secondary:
        return "alert-secondary";
      case AlertType.Light:
        return "alert-light";
      case AlertType.Dark:
        return "alert-dark";
      default:
        return "alert-info";
    }
  }
  redirectAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.model.route) {
        yield PageRouteProvider.redirectAsync(this.model.route);
      }
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.model.autoClose) {
        yield this.closeWithDelayAsync();
      }
    });
  }
  get model() {
    return this.props.model;
  }
  render() {
    const mobileStyle = this.mobile && styles$$.mobile;
    const flyoutStyle = this.model.flyout && styles$$.flyout;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$$.alert, "alert", flyoutStyle, mobileStyle, this.getAlertType(), this.props.className),
      onClick: () => this.redirectAsync()
    }, React.createElement("span", {
      className: this.css(styles$$.message, this.applyRouteStyles && styles$$.route)
    }, this.model.dismissible && React.createElement("div", {
      className: this.css(styles$$.close),
      onClick: e => this.onCloseAlertAsync(e)
    }, React.createElement("span", null, "\u00D7")), this.toMultiLines(AlertLocalizer$1.get(this.model.message, ...(this.model.messageParams || [])))));
  }
}

var css_248z$16 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-live-validator-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-live-validator-liveValidator {\n  margin-top: 16px;\n  color: #008000;\n}\n.athenaeum-live-validator-liveValidator tr > td {\n  padding-right: 4px;\n}\n.athenaeum-live-validator-liveValidator tr.athenaeum-live-validator-invalid {\n  color: #a94442;\n}";
var styles$_ = {"font-renta":"athenaeum-live-validator-font-renta","liveValidator":"athenaeum-live-validator-liveValidator","invalid":"athenaeum-live-validator-invalid"};
styleInject(css_248z$16);

//Autogenerated
class PasswordInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.helpTextLengthLanguageItemName = `_13:0`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_13:0`, {
      l: `en`,
      v: `at least 8 characters long`
    }, {
      l: `uk`,
      v: `Не менше 8 символів`
    }, {
      l: `sv`,
      v: `åtminstone 8 tecken`
    }, {
      l: `ru`,
      v: `не менее 8 символов`
    }, {
      l: `pl`,
      v: `Co najmniej 8 znaków`
    }, {
      l: `nl`,
      v: `minimaal 8 tekens lang`
    }, {
      l: `nb`,
      v: `Minst 8 tegn`
    }, {
      l: `it`,
      v: `lungo almeno 8 caratteri`
    }, {
      l: `fr`,
      v: `au moins 8 caractères`
    }, {
      l: `fi`,
      v: `vähintään 8 merkkiä`
    }, {
      l: `es`,
      v: `Al menos 8 caracteres de longitud`
    }, {
      l: `de`,
      v: `Mindestens 8 Zeichen lang`
    }, {
      l: `da`,
      v: `Mindst 8 tegn lang`
    });
  }
  /**
  /* "HelpText.Length" (at least 8 characters long)
  /* "Localizer.helpTextLength"
  /* "Localizer.helpTextLengthLanguageItemName"
  */
  get helpTextLength() {
    return this.get(`_13:0`);
  }
}
//Singleton
var PasswordInputLocalizer$1 = new PasswordInputLocalizer();

class ValidationRow {
  constructor(regex, description, isValid = false) {
    this.regex = regex;
    this.description = description;
    this.isValid = isValid;
  }
}
class LiveValidator extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      validationRows: this.validationRows,
      isLengthValid: !this.props.validLength
    };
  }
  get validationRows() {
    return this.props.validationRows;
  }
  validateAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      const validationRows = this.state.validationRows.map(row => {
        if (new RegExp(row.regex).test(value)) {
          return Object.assign(Object.assign({}, row), {
            isValid: true
          });
        }
        return Object.assign(Object.assign({}, row), {
          isValid: false
        });
      });
      let isLengthValid = true;
      if (this.props.validLength) {
        isLengthValid = value.length >= this.props.validLength;
      }
      yield this.setState({
        validationRows,
        isLengthValid
      });
    });
  }
  get isValid() {
    return this.state.validationRows.every(row => row.isValid) && this.state.isLengthValid;
  }
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (nextProps.value !== this.props.value) {
        yield this.validateAsync(nextProps.value);
      }
      if (nextProps.validationRows !== this.props.validationRows) {
        yield this.setState({
          validationRows: nextProps.validationRows
        });
      }
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      yield this.validateAsync(this.props.value);
    });
  }
  render() {
    return React.createElement("div", {
      className: styles$_.liveValidator
    }, React.createElement("table", null, React.createElement("tbody", null, this.state.validationRows.map((validationRow, index) => React.createElement("tr", {
      key: index,
      className: this.css(validationRow.isValid ? styles$_.valid : styles$_.invalid)
    }, React.createElement("td", null, validationRow.isValid ? React.createElement("i", {
      className: "fa fa-check"
    }) : React.createElement("i", {
      className: "fa fa-times"
    })), React.createElement("td", null, validationRow.description))), this.props.validLength && React.createElement("tr", {
      className: this.css(this.state.isLengthValid ? styles$_.valid : styles$_.invalid)
    }, React.createElement("td", null, this.state.isLengthValid ? React.createElement("i", {
      className: "fa fa-check"
    }) : React.createElement("i", {
      className: "fa fa-times"
    })), React.createElement("td", null, PasswordInputLocalizer$1.helpTextLength)))));
  }
}

//Autogenerated
class BaseInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.validatorsRequiredLanguageItemName = `_3E:0`;
    this.validatorsLengthLanguageItemName = `_3E:1`;
    this.validatorsNumberRangeLanguageItemName = `_3E:2`;
    this.validatorsDocumentTypeNotSupportedLanguageItemName = `_3E:3`;
    this.validatorsDocumentTooBigLanguageItemName = `_3E:4`;
    this.validatorsTotalSizeTooBigLanguageItemName = `_3E:5`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_3E:0`, {
      l: `en`,
      v: `{0} is required`
    }, {
      l: `uk`,
      v: `Потрібно {0}`
    }, {
      l: `sv`,
      v: `{0} krävs`
    }, {
      l: `ru`,
      v: `Требуется {0}`
    }, {
      l: `pl`,
      v: `{0} jest wymagany`
    }, {
      l: `nl`,
      v: `{0} is vereist`
    }, {
      l: `nb`,
      v: `{0} er påkrevd`
    }, {
      l: `it`,
      v: `{0} è obbligatorio`
    }, {
      l: `fr`,
      v: `{0} est requis`
    }, {
      l: `fi`,
      v: `{0} on pakollinen`
    }, {
      l: `es`,
      v: `{0} es obligatorio`
    }, {
      l: `de`,
      v: `{0} ist erforderlich`
    }, {
      l: `da`,
      v: `{0} er påkrævet`
    });
    this.set(`_3E:1`, {
      l: `en`,
      v: `Text is too short`
    }, {
      l: `uk`,
      v: `Текст надто короткий`
    }, {
      l: `sv`,
      v: `Text för kort`
    }, {
      l: `ru`,
      v: `Текст слишком короткий`
    }, {
      l: `pl`,
      v: `Tekst za krótki`
    }, {
      l: `nl`,
      v: `Tekst is te kort`
    }, {
      l: `nb`,
      v: `Teksten er for kort`
    }, {
      l: `it`,
      v: `Il testo è troppo corto`
    }, {
      l: `fr`,
      v: `Le texte est trop court`
    }, {
      l: `fi`,
      v: `Teksti on liian lyhyt`
    }, {
      l: `es`,
      v: `El texto es demasiado corto.`
    }, {
      l: `de`,
      v: `Der Text ist zu kurz`
    }, {
      l: `da`,
      v: `Teksten er for kort`
    });
    this.set(`_3E:2`, {
      l: `en`,
      v: `Value must be in range {0} - {1}`
    }, {
      l: `uk`,
      v: `Значення має бути в діапазоні {0} - {1}`
    }, {
      l: `sv`,
      v: `Värde måste vara inom intervallet {0} - {1}`
    }, {
      l: `ru`,
      v: `Значение должно быть в диапазоне {0} - {1}`
    }, {
      l: `pl`,
      v: `Liczba musi się zawierać w przedziale {0} - {1}`
    }, {
      l: `nl`,
      v: `Waarde moet binnen het bereik {0} - {1} liggen`
    }, {
      l: `nb`,
      v: `Verdien må være mellom {0} - {1}`
    }, {
      l: `it`,
      v: `Il valore deve essere compreso nell'intervallo {0} - {1}`
    }, {
      l: `fr`,
      v: `La valeur doit être comprise entre {0} et {1}`
    }, {
      l: `fi`,
      v: `Arvon pitää olla väliltä {0} - {1}`
    }, {
      l: `es`,
      v: `El valor debe estar en el rango {0} - {1}`
    }, {
      l: `de`,
      v: `Der Wert muss im Bereich {0}–{1} liegen.`
    }, {
      l: `da`,
      v: `Værdien skal være i området {0} - {1}`
    });
    this.set(`_3E:3`, {
      l: `en`,
      v: `Document type is not supported, choose file with extension {0}`
    }, {
      l: `uk`,
      v: `Тип документа не підтримується, виберіть файл з розширенням {0}`
    }, {
      l: `sv`,
      v: `Dokumenttyp stöds inte. Välj dokument som är {0}.`
    }, {
      l: `ru`,
      v: `Тип документа не поддерживается, выберите файл с расширением {0}`
    }, {
      l: `pl`,
      v: `Format dokumentu nieprawidłowy. Wybierz dokument {0}`
    }, {
      l: `nl`,
      v: `Documenttype wordt niet ondersteund, kies een bestand met de extensie {0}`
    }, {
      l: `nb`,
      v: `Dokumenttype støttes ikke. Velg fil med filtypen {0}`
    }, {
      l: `it`,
      v: `Il tipo di documento non è supportato, scegli il file con estensione {0}`
    }, {
      l: `fr`,
      v: `Le type de document n'est pas pris en charge, choisissez un fichier avec l'extension {0}`
    }, {
      l: `fi`,
      v: `Dokumentin tyyppi ei ole tuettu. Valitse tiedosto, joka on {0}`
    }, {
      l: `es`,
      v: `El tipo de documento no es compatible; elija el archivo con extensión {0}`
    }, {
      l: `de`,
      v: `Der Dokumenttyp wird nicht unterstützt. Wählen Sie eine Datei mit der Erweiterung {0}.`
    }, {
      l: `da`,
      v: `Dokumenttype understøttes ikke. Vælg fil med udvidelse {0}`
    });
    this.set(`_3E:4`, {
      l: `en`,
      v: `Document file is too big`
    }, {
      l: `uk`,
      v: `Файл документа занадто великий`
    }, {
      l: `sv`,
      v: `Dokument filen är för stor`
    }, {
      l: `ru`,
      v: `Файл документа слишком большой`
    }, {
      l: `pl`,
      v: `Dokument jest za duży`
    }, {
      l: `nl`,
      v: `Documentbestand is te groot`
    }, {
      l: `nb`,
      v: `Dokumentfilen er for stor`
    }, {
      l: `it`,
      v: `Il file del documento è troppo grande`
    }, {
      l: `fr`,
      v: `Le fichier de document est trop volumineux`
    }, {
      l: `fi`,
      v: `Dokumentti-tiedoston koko on liian suuri`
    }, {
      l: `es`,
      v: `El archivo del documento es demasiado grande`
    }, {
      l: `de`,
      v: `Die Dokumentdatei ist zu groß`
    }, {
      l: `da`,
      v: `Dokumentfilen er for stor`
    });
    this.set(`_3E:5`, {
      l: `en`,
      v: `Total size of documents is too big`
    }, {
      l: `uk`,
      v: `Загальний розмір документів занадто великий`
    }, {
      l: `sv`,
      v: `Dokumentens totala storlek är för stor`
    }, {
      l: `ru`,
      v: `Общий размер документов слишком велик`
    }, {
      l: `pl`,
      v: `Rozmiar pliku za duży`
    }, {
      l: `nl`,
      v: `De totale grootte van de documenten is te groot`
    }, {
      l: `nb`,
      v: `Dokumentets totale størrelse er for stor`
    }, {
      l: `it`,
      v: `La dimensione totale dei documenti è eccessiva`
    }, {
      l: `fr`,
      v: `La taille totale des documents est trop grande`
    }, {
      l: `fi`,
      v: `Dokumenttien kokonaiskoko on liian suuri`
    }, {
      l: `es`,
      v: `El tamaño total de los documentos es demasiado grande.`
    }, {
      l: `de`,
      v: `Die Gesamtgröße der Dokumente ist zu groß`
    }, {
      l: `da`,
      v: `Den samlede størrelse af dokumenter er for stor`
    });
  }
  /**
  /* "Validators.Required" ({0} is required)
  /* "Localizer.validatorsRequired"
  /* "Localizer.validatorsRequiredLanguageItemName"
  */
  get validatorsRequired() {
    return this.get(`_3E:0`);
  }
  /**
  /* "Validators.Length" (Text is too short)
  /* "Localizer.validatorsLength"
  /* "Localizer.validatorsLengthLanguageItemName"
  */
  get validatorsLength() {
    return this.get(`_3E:1`);
  }
  /**
  /* "Validators.NumberRange" (Value must be in range {0} - {1})
  /* "Localizer.validatorsNumberRange"
  /* "Localizer.validatorsNumberRangeLanguageItemName"
  */
  get validatorsNumberRange() {
    return this.get(`_3E:2`);
  }
  /**
  /* "Validators.DocumentTypeNotSupported" (Document type is not supported, choose file with extension {0})
  /* "Localizer.validatorsDocumentTypeNotSupported"
  /* "Localizer.validatorsDocumentTypeNotSupportedLanguageItemName"
  */
  get validatorsDocumentTypeNotSupported() {
    return this.get(`_3E:3`);
  }
  /**
  /* "Validators.DocumentTooBig" (Document file is too big)
  /* "Localizer.validatorsDocumentTooBig"
  /* "Localizer.validatorsDocumentTooBigLanguageItemName"
  */
  get validatorsDocumentTooBig() {
    return this.get(`_3E:4`);
  }
  /**
  /* "Validators.TotalSizeTooBig" (Total size of documents is too big)
  /* "Localizer.validatorsTotalSizeTooBig"
  /* "Localizer.validatorsTotalSizeTooBigLanguageItemName"
  */
  get validatorsTotalSizeTooBig() {
    return this.get(`_3E:5`);
  }
}
//Singleton
var BaseInputLocalizer$1 = new BaseInputLocalizer();

var css_248z$15 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-form-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-form-numberInput, .athenaeum-form-inputContainer .athenaeum-form-number, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number {\n  position: relative;\n}\n.athenaeum-form-numberInput input[type=number]::-webkit-inner-spin-button, .athenaeum-form-inputContainer .athenaeum-form-number input[type=number]::-webkit-inner-spin-button, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number input[type=number]::-webkit-inner-spin-button, .athenaeum-form-numberInput input[type=number]::-webkit-outer-spin-button, .athenaeum-form-inputContainer .athenaeum-form-number input[type=number]::-webkit-outer-spin-button, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.athenaeum-form-numberInput .athenaeum-form-numberInputArrow, .athenaeum-form-inputContainer .athenaeum-form-number .athenaeum-form-numberInputArrow, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number .athenaeum-form-numberInputArrow {\n  position: absolute;\n  width: 20px;\n  border-left: 1px solid #d4d4d4;\n  border-right: 1px solid transparent;\n  color: #d4d4d4;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-form-numberInput .athenaeum-form-increaseArrow, .athenaeum-form-inputContainer .athenaeum-form-number .athenaeum-form-increaseArrow, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number .athenaeum-form-increaseArrow {\n  right: 0;\n  top: 0;\n  bottom: unset;\n  height: 50%;\n}\n.athenaeum-form-numberInput .athenaeum-form-decreaseArrow, .athenaeum-form-inputContainer .athenaeum-form-number .athenaeum-form-decreaseArrow, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number .athenaeum-form-decreaseArrow {\n  top: unset;\n  right: 0;\n  bottom: 0;\n  height: 50%;\n}\n\n.athenaeum-form-form {\n  width: 100%;\n}\n.athenaeum-form-form.athenaeum-form-inline {\n  width: auto;\n}\n.athenaeum-form-form .athenaeum-form-errorList {\n  padding-left: 17px;\n  margin-bottom: 8px;\n  color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup {\n  width: 100%;\n  margin-bottom: 15px !important;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup label {\n  display: block;\n  margin-bottom: 5px;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer {\n  width: 100%;\n  position: relative;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer input {\n  min-width: 70px;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer span.athenaeum-form-value {\n  height: calc(1.5em + 0.75rem + 2px);\n  display: flex;\n  align-items: center;\n  cursor: text;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer.athenaeum-form-validationError input {\n  border-color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer.athenaeum-form-validationError textarea {\n  border-color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-validationError {\n  color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-validationError.athenaeum-form-append {\n  border-color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-validationError.athenaeum-form-prepend {\n  border-color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-required {\n  margin-left: 2px;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-prepend {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-prepend > input {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-append {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: 0;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-append > input {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-focused {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  border-radius: 0.25rem;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-dropZone {\n  height: 200px;\n  background-color: aliceblue;\n  border: 2px dashed #ccc;\n  border-radius: 5px;\n  margin-bottom: 15px;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-dropZone label {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: copy;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-dropZone label .athenaeum-form-preview {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-dropZone label .athenaeum-form-preview .athenaeum-form-image {\n  height: 85%;\n  width: 85%;\n  margin: 0 auto;\n  background-position: center !important;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-selectedFile {\n  font-size: 1.5em;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-selectedFile i {\n  color: #a94442;\n  margin-left: 8px;\n  cursor: pointer;\n}\n.athenaeum-form-inlineInputGroup .athenaeum-form-inputGroup, .athenaeum-form-inlineInputGroup.athenaeum-form-inputGroup {\n  margin-bottom: 0 !important;\n}\n.athenaeum-form-inlineInputGroup .athenaeum-form-label label {\n  margin-bottom: 0;\n  padding-right: 0.25rem !important;\n}\n\n.athenaeum-form-inputContainer {\n  width: 100%;\n}\n.athenaeum-form-inputContainer input {\n  min-width: 70px;\n}\n.athenaeum-form-inputContainer span.athenaeum-form-value {\n  height: calc(1.5em + 0.75rem + 2px);\n  display: flex;\n  align-items: center;\n  cursor: text;\n}\n.athenaeum-form-inputContainer .athenaeum-form-slider {\n  width: 100%;\n}";
var styles$Z = {"font-renta":"athenaeum-form-font-renta","numberInput":"athenaeum-form-numberInput","inputContainer":"athenaeum-form-inputContainer","number":"athenaeum-form-number","form":"athenaeum-form-form","inputGroup":"athenaeum-form-inputGroup","numberInputArrow":"athenaeum-form-numberInputArrow","increaseArrow":"athenaeum-form-increaseArrow","decreaseArrow":"athenaeum-form-decreaseArrow","inline":"athenaeum-form-inline","errorList":"athenaeum-form-errorList","value":"athenaeum-form-value","validationError":"athenaeum-form-validationError","append":"athenaeum-form-append","prepend":"athenaeum-form-prepend","required":"athenaeum-form-required","focused":"athenaeum-form-focused","file":"athenaeum-form-file","dropZone":"athenaeum-form-dropZone","preview":"athenaeum-form-preview","image":"athenaeum-form-image","selectedFile":"athenaeum-form-selectedFile","inlineInputGroup":"athenaeum-form-inlineInputGroup","label":"athenaeum-form-label","slider":"athenaeum-form-slider"};
styleInject(css_248z$15);

class BaseValidator {
  static toString(value, format = null) {
    if (value != null) {
      if (typeof value === "string") {
        return value;
      }
      if (value instanceof FileModel || value.isFileModel) {
        return value.src;
      }
      if (typeof value === "number") {
        //return (value as number).toString();
        return Utility.formatValue(value, format);
      }
      if (typeof value === "boolean") {
        //return (value as boolean).toString();
        return Utility.formatValue(value, format);
      }
      if (value instanceof Date) {
        //return (value as Date).toDateString();
        return Utility.formatValue(value, format || "D");
      }
    }
    return null;
  }
}
class BaseFileValidator {
  static getSize(file) {
    return file != null ? file instanceof Array ? Utility.sum(file, item => this.getSize(item)) : file.size : null;
  }
  static getMimeType(file) {
    return file != null ? file.type.toLowerCase() : null;
  }
  static getFileExtension(file) {
    return file != null ? Utility.getFileExtension(file.name) : null;
  }
}
var BaseRegexValidatorErrorMessage;
(function (BaseRegexValidatorErrorMessage) {
  BaseRegexValidatorErrorMessage["validatorsEmailLanguageItemName"] = "Validators.Email";
  BaseRegexValidatorErrorMessage["validatorsUrlLanguageItemName"] = "Validators.Url";
  BaseRegexValidatorErrorMessage["validatorsPasswordLanguageItemName"] = "Validators.Password";
  BaseRegexValidatorErrorMessage["validatorsPhoneLanguageItemName"] = "Validators.Phone";
})(BaseRegexValidatorErrorMessage || (BaseRegexValidatorErrorMessage = {}));
class BaseRegexValidator extends BaseValidator {
  constructor(regex, errorMessage) {
    super();
    this.regex = new RegExp(regex);
    this.errorMessage = BaseInputLocalizer$1.get(errorMessage);
  }
  validate(value) {
    if (value) {
      const str = value;
      if (str != null) {
        if (!str.match(this.regex)) {
          return this.errorMessage;
        }
      }
    }
    return null;
  }
}
class RegexValidator extends BaseRegexValidator {
  static validator(regex, errorMessage) {
    const instance = new RegexValidator(regex, errorMessage);
    return value => instance.validate(value);
  }
}
class EmailValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Email, BaseRegexValidatorErrorMessage.validatorsEmailLanguageItemName);
  }
}
EmailValidator.instance = new EmailValidator();
EmailValidator.validator = value => EmailValidator.instance.validate(value);
class UrlValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Url, BaseRegexValidatorErrorMessage.validatorsUrlLanguageItemName);
  }
}
UrlValidator.instance = new UrlValidator();
UrlValidator.validator = value => UrlValidator.instance.validate(value);
class PasswordValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Password, BaseRegexValidatorErrorMessage.validatorsPasswordLanguageItemName);
  }
}
PasswordValidator.instance = new PasswordValidator();
PasswordValidator.validator = value => PasswordValidator.instance.validate(value);
class PhoneValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Phone, BaseRegexValidatorErrorMessage.validatorsPhoneLanguageItemName);
  }
}
PhoneValidator.instance = new PhoneValidator();
PhoneValidator.validator = value => PhoneValidator.instance.validate(value);
class RequiredValidator extends BaseValidator {
  constructor(message) {
    super();
    this._message = message;
  }
  getMessage() {
    return this._message || BaseInputLocalizer$1.validatorsRequiredLanguageItemName;
  }
  validate(value) {
    if (value != null && Array.isArray(value)) {
      return value.length === 0 ? this.getMessage() : null;
    }
    const str = BaseValidator.toString(value);
    if (str == null || str.length === 0) {
      return this.getMessage();
    }
    return null;
  }
  static customValidator(message) {
    return value => new RequiredValidator(message).validate(value);
  }
}
RequiredValidator.instance = new RequiredValidator();
RequiredValidator.validator = value => RequiredValidator.instance.validate(value);
class LengthValidator extends BaseValidator {
  constructor(minLength = 0) {
    super();
    this.minLength = minLength;
  }
  validate(value) {
    const str = BaseValidator.toString(value);
    if (this.minLength > 0 && (str == null || str.length < this.minLength)) {
      return BaseInputLocalizer$1.validatorsLength;
    }
    return null;
  }
  static validator(minLength = 0) {
    return value => new LengthValidator(minLength).validate(value);
  }
}
LengthValidator.instance = new LengthValidator();
class NumberRangeValidator extends BaseValidator {
  constructor(min = Number.NEGATIVE_INFINITY, max = Number.POSITIVE_INFINITY) {
    super();
    this.min = min;
    this.max = max;
  }
  validate(value) {
    if (value == null || value < this.min || value > this.max) {
      return Utility.format(BaseInputLocalizer$1.validatorsNumberRange, this.min, this.max);
    }
    return null;
  }
  static validator(min = Number.NEGATIVE_INFINITY, max = Number.POSITIVE_INFINITY) {
    return value => new NumberRangeValidator(min, max).validate(value);
  }
}
NumberRangeValidator.instance = new NumberRangeValidator();
class FileSizeValidator extends BaseFileValidator {
  constructor(maxSize = AthenaeumComponentsConstants.maxFileUploadSizeInBytes) {
    super();
    this.maxSize = maxSize;
  }
  validate(value) {
    if (value != null && this.maxSize > 0) {
      const files = value instanceof Array ? value : [value];
      const fileSizes = files.map(file => BaseFileValidator.getSize(file) || 0);
      if (fileSizes.some(fileSize => fileSize > this.maxSize)) {
        return BaseInputLocalizer$1.validatorsDocumentTooBig;
      }
    }
    return null;
  }
  static validator(maxSize = AthenaeumComponentsConstants.maxFileUploadSizeInBytes) {
    return value => new FileSizeValidator(maxSize).validate(value);
  }
}
FileSizeValidator.instance = new FileSizeValidator();
class FilesSizeValidator extends BaseFileValidator {
  constructor(maxSize = AthenaeumComponentsConstants.maxFileUploadSizeInBytes) {
    super();
    this.maxSize = maxSize;
  }
  validate(value) {
    if (value != null && this.maxSize > 0) {
      const files = value instanceof Array ? value : [value];
      const totalSize = BaseFileValidator.getSize(files) || 0;
      if (totalSize > this.maxSize) {
        return BaseInputLocalizer$1.validatorsTotalSizeTooBig;
      }
    }
    return null;
  }
  static validator(maxSize = AthenaeumComponentsConstants.maxFileUploadSizeInBytes) {
    return value => new FilesSizeValidator(maxSize).validate(value);
  }
}
FilesSizeValidator.instance = new FilesSizeValidator();
class FileTypeValidator extends BaseFileValidator {
  constructor(fileTypes = AthenaeumComponentsConstants.imageFileTypes) {
    super();
    this.fileTypes = fileTypes;
  }
  validate(value) {
    if (value != null && this.fileTypes.length > 0) {
      const files = value instanceof Array ? value : [value];
      const fileMimeTypes = files.map(file => BaseFileValidator.getMimeType(file) || "");
      const fileExtensions = files.map(file => BaseFileValidator.getFileExtension(file) || "");
      const validateByFileExtension = this.fileTypes.every(mimeType => mimeType.startsWith("."));
      //  if user gives fileTypes list of file extensions like [".img", ".jpg"]
      if (validateByFileExtension) {
        const areValidFileExtensions = fileExtensions.every(fileExtension => this.fileTypes.includes(fileExtension));
        if (areValidFileExtensions) {
          return null;
        }
        const allowedFileExtensionsToDisplay = this.fileTypes.map(fileExtensionWithDot => fileExtensionWithDot.replace(".", "")).join();
        return Utility.format(BaseInputLocalizer$1.validatorsDocumentTypeNotSupported, allowedFileExtensionsToDisplay);
      }
      //  if user gives fileTypes list of file extensions like ["images/jpg"]
      if (fileMimeTypes.length !== 0 && !fileMimeTypes.every(fileType => this.fileTypes.includes(fileType))) {
        return Utility.format(BaseInputLocalizer$1.validatorsDocumentTypeNotSupported, Utility.getExtensionsFromMimeTypes(this.fileTypes));
      }
    }
    return null;
  }
  static validator(fileTypes = AthenaeumComponentsConstants.imageFileTypes) {
    return value => new FileTypeValidator(fileTypes).validate(value);
  }
}
FileTypeValidator.instance = new FileTypeValidator();
class BaseInput extends BaseComponent {
  onInputContainerClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.clickToEdit) {
        yield this.showEditAsync();
      }
    });
  }
  setEditAsync(edit) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.clickToEdit && this.state.edit !== edit) {
        yield this.setState({
          edit: edit
        });
        if (edit) {
          yield this.onShowEditAsync();
        } else {
          yield this.onHideEditAsync();
        }
      }
    });
  }
  onLabelClick(e) {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  onShowEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  onHideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  onValuePropsChanged() {}
  parse(str) {
    return str;
  }
  getFormattedStr() {
    return Utility.formatValue(this.value, this.format);
  }
  ignoreValueProps() {
    return this.props.model != null;
  }
  get format() {
    return this.props.format || "";
  }
  static getCurrentLocalizerLanguage() {
    var _a, _b;
    return (_b = (_a = ServiceProvider.findLocalizer()) === null || _a === void 0 ? void 0 : _a.language) !== null && _b !== void 0 ? _b : "";
  }
  get inputElement() {
    if (this._inputContainerRef.current) {
      return this._inputContainerRef.current.querySelector("input") || this._inputContainerRef.current.querySelector("textarea") || null;
    }
    return null;
  }
  constructor(props) {
    var _a;
    super(props);
    this._inputContainerRef = React.createRef();
    this._liveValidatorRef = React.createRef();
    this._localizerLanguage = BaseInput.getCurrentLocalizerLanguage();
    const varProps = props;
    const model = (_a = props.model) !== null && _a !== void 0 ? _a : {
      value: null
    };
    if (props.value != null) {
      model.value = props.value;
    }
    const readonly = varProps.readonly || varProps.disabled || false;
    this.state = {
      model: model,
      edit: !this.props.clickToEdit,
      validationError: null,
      generation: 0,
      readonly: readonly
    };
  }
  getName() {
    return this.props.name || this.id;
  }
  getValue() {
    return this.value;
  }
  get inline() {
    return !!this.props.inline;
  }
  get value() {
    return this.state.model.value;
  }
  get str() {
    return BaseValidator.toString(this.value) || "";
  }
  get edit() {
    return this.state.edit;
  }
  isValid() {
    return !this.state.validationError && (!this.props.liveValidator || this._liveValidatorRef.current == null || this._liveValidatorRef.current.isValid);
  }
  focus() {
    const inputElement = this.inputElement;
    if (inputElement) {
      inputElement.focus();
    }
  }
  click() {
    const inputElement = this.inputElement;
    if (inputElement) {
      inputElement.click();
    }
  }
  get noValidate() {
    return !!this.props.noValidate || this.readonly;
  }
  get readonly() {
    return this.state.readonly;
  }
  setReadonlyAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value != this.state.readonly) {
        yield this.setState({
          readonly: value
        });
      }
    });
  }
  hideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setEditAsync(false);
    });
  }
  showEditAsync(select) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setEditAsync(true);
      const inputElement = this.inputElement;
      if (inputElement) {
        inputElement.focus();
        if (select) {
          inputElement.select();
        }
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.clickToEdit) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.hideEditAsync();
        }
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const varProps = this.props;
      const varNewProps = nextProps;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (this.isMounted) {
        const model = this.state.model;
        const nextModel = nextProps.model;
        const value = model.value;
        const nextValue = nextProps.value;
        const newReadonly = varProps.disabled != varNewProps.disabled || varProps.readonly != varNewProps.readonly;
        //Ensure validation localizations change when localizer language changes
        let resetValidator = !nextProps.required && !this.isValid();
        const currentLanguage = BaseInput.getCurrentLocalizerLanguage();
        if (currentLanguage !== this._localizerLanguage) {
          if (!this.isValid()) {
            resetValidator = true;
          }
          this._localizerLanguage = currentLanguage;
        }
        if (nextModel && nextModel.value !== model.value) {
          this.onValuePropsChanged();
          const value = nextModel.value != null ? nextModel.value : null;
          yield this.updateValueAsync(value, false);
        } else if (!this.ignoreValueProps() && value !== nextValue) {
          this.onValuePropsChanged();
          const value = nextValue != null ? nextValue : null;
          yield this.updateValueAsync(value, false);
        } else if (resetValidator) {
          yield this.validateAsync();
        }
        if (newReadonly) {
          const readonly = varNewProps.readonly || varNewProps.disabled || false;
          yield this.setReadonlyAsync(readonly);
        }
      }
    });
  }
  valueChangeHandlerAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      const str = event.currentTarget.value;
      const value = this.parse(str);
      yield this.updateValueAsync(value);
    });
  }
  updateValueAsync(value, validate = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const state = this.state;
      const model = state.model;
      if (model.value !== value) {
        model.value = value;
        if (validate) {
          this.validate();
        } else {
          state.validationError = null;
        }
        if (this.isMounted) {
          yield this.setState(state);
        }
      }
    });
  }
  valueBlurHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.validateAsync();
    });
  }
  validate() {
    var _a;
    if (this.noValidate) {
      return;
    }
    const value = this.value;
    const validators = [];
    if (this.props.required) {
      const requiredMessage = ((_a = this.getCustomRequiredValidationError) === null || _a === void 0 ? void 0 : _a.call(this)) || BaseInputLocalizer$1.validatorsRequiredLanguageItemName;
      validators.push(RequiredValidator.customValidator(requiredMessage));
    }
    validators.push(...this.getValidators());
    if (this.props.validators != null) {
      validators.push(...this.props.validators);
    }
    let error = null;
    validators.forEach(validator => {
      if (!error) {
        let validationError = validator(value);
        if (validationError) {
          if (this.props.onValidationError) {
            validationError = this.props.onValidationError(validator, value);
          }
          error = validationError;
        }
      }
    });
    error = error ? error : null;
    const state = this.state;
    state.validationError = error;
  }
  isInput() {
    return true;
  }
  getValidators() {
    return [];
  }
  validateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const error = this.state.validationError;
      this.validate();
      if (this.state.validationError !== error) {
        yield this.setState(this.state);
      }
    });
  }
  getInputId() {
    return `input_${this.id}`;
  }
  getType() {
    return BaseInputType.Text;
  }
  getContainerClassName() {
    return "";
  }
  renderValue() {
    const formattedStr = this.getFormattedStr();
    return React.createElement("span", {
      className: styles$Z.value,
      title: this.props.title || formattedStr
    }, formattedStr);
  }
  renderPrepend() {
    const prepend = typeof this.props.prepend === "function" ? this.props.prepend(this) : typeof this.props.prepend === "boolean" ? "" : this.props.prepend;
    const icon = typeof prepend === "string" && (prepend.startsWith("fa-") || prepend.includes(" fa-"));
    return React.createElement("div", {
      className: "input-group-prepend"
    }, icon ? React.createElement("i", {
      className: prepend
    }) : React.createElement("span", {
      className: this.css("input-group-text", styles$Z.prepend)
    }, prepend));
  }
  renderAppend() {
    const append = typeof this.props.append === "function" ? this.props.append(this) : typeof this.props.append === "boolean" ? "" : this.props.append;
    const icon = typeof append === "string" && (append.startsWith("fa-") || append.includes(" fa-"));
    return React.createElement("div", {
      className: "input-group-append"
    }, icon ? React.createElement("i", {
      className: append
    }) : React.createElement("span", {
      className: this.css("input-group-text", styles$Z.append)
    }, append));
  }
  render() {
    const label = this.props.label;
    const validationError = this.state.validationError;
    const labelText = label ? validationError ? BaseInputLocalizer$1.get(validationError, BaseInputLocalizer$1.get(label)) : BaseInputLocalizer$1.get(label) : "";
    let inputBorderRadius = "";
    if (this.props.prepend) {
      inputBorderRadius = styles$Z.prepend;
    }
    if (this.props.append) {
      inputBorderRadius = styles$Z.append;
    }
    if (this.props.prepend && this.props.append) {
      inputBorderRadius = this.css(styles$Z.append, styles$Z.prepend);
    }
    const inlineStyle = this.inline && "d-flex flex-row align-items-center " + styles$Z.inlineInputGroup;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$Z.inputGroup, inlineStyle, this.getContainerClassName(), this.props.className),
      hidden: this.props.hidden
    }, label && React.createElement("div", {
      className: this.css(styles$Z.label, "d-flex", "base-input-label", validationError && styles$Z.validationError)
    }, React.createElement("label", {
      htmlFor: this.getInputId(),
      className: this.css(validationError && "validation-error"),
      onClick: e => this.onLabelClick(e)
    }, ReactUtility.toMultiLines(labelText)), this.props.required && !this.noValidate && !validationError && React.createElement("span", {
      className: styles$Z.required
    }, "*")), React.createElement("div", {
      className: "d-flex h-100"
    }, this.props.prepend && this.renderPrepend(), React.createElement("div", {
      ref: this._inputContainerRef,
      className: this.css(styles$Z.inputContainer, inputBorderRadius, validationError && styles$Z.validationError),
      onClick: () => this.onInputContainerClickAsync()
    }, this.state.edit ? this.renderInput() : this.renderValue()), this.props.append && this.renderAppend()), this.props.liveValidator && this.value && React.createElement(LiveValidator, {
      ref: this._liveValidatorRef,
      validationRows: this.props.liveValidator,
      value: this.value || "",
      validLength: this.props.validLength
    }));
  }
}

var css_248z$14 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-text-area-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-text-area-input-textAreaInput {\n  position: relative;\n}\n.athenaeum-text-area-input-textAreaInput .athenaeum-text-area-input-progressBar {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  right: 1px;\n  overflow: hidden;\n}\n.athenaeum-text-area-input-textAreaInput .athenaeum-text-area-input-progressBar > div {\n  width: 0;\n  height: 3px;\n  background-color: #337ab7;\n  opacity: 0.5;\n  overflow: hidden;\n}";
var styles$Y = {"font-renta":"athenaeum-text-area-input-font-renta","textAreaInput":"athenaeum-text-area-input-textAreaInput","progressBar":"athenaeum-text-area-input-progressBar"};
styleInject(css_248z$14);

class TextAreaInput extends BaseInput {
  constructor() {
    super(...arguments);
    this._inputRef = React.createRef();
    this.state = {
      model: this.props.model || {
        value: this.props.value || ""
      },
      edit: true,
      readonly: this.props.readonly || false,
      validationError: ""
    };
  }
  progressBar() {
    const length = this.length;
    const maxLength = this.maxLength;
    const value = 100 - (maxLength - length) / maxLength * 100;
    return value + "%";
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      valueBlurHandlerAsync: {
        get: () => super.valueBlurHandlerAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.valueBlurHandlerAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  valueChangeHandlerAsync(event) {
    const _super = Object.create(null, {
      valueChangeHandlerAsync: {
        get: () => super.valueChangeHandlerAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.valueChangeHandlerAsync.call(this, event);
      if (this.props.onChange) {
        yield this.props.onChange(this, this.value);
      }
    });
  }
  getType() {
    return BaseInputType.TextArea;
  }
  getValidators() {
    return this.props.minLength ? [LengthValidator.validator(this.props.minLength)] : [];
  }
  get value() {
    return this.state.model.value || "";
  }
  focus() {
    if (this._inputRef.current) {
      this._inputRef.current.focus();
    }
  }
  setCursorPosition(position, focus = true) {
    const input = this._inputRef.current;
    if (input) {
      if (focus) {
        input.focus();
      }
      input.selectionStart = position;
      input.selectionEnd = position;
    }
  }
  scrollTop(focus = true) {
    const input = this._inputRef.current;
    if (input) {
      if (focus) {
        input.focus();
      }
      input.scrollTop = 0;
      this.setCursorPosition(0, false);
    }
  }
  scrollBottom(focus = true) {
    const input = this._inputRef.current;
    if (input) {
      if (focus) {
        input.focus();
      }
      input.scrollTop = input.scrollHeight;
      this.setCursorPosition(this.value.length, false);
    }
  }
  get maxLength() {
    return this.props.maxLength || 1000;
  }
  get length() {
    return this.str.length;
  }
  get noRemaining() {
    return this.props.noRemaining === true;
  }
  renderInput() {
    return React.createElement("div", {
      className: styles$Y.textAreaInput
    }, React.createElement("textarea", {
      id: this.getInputId(),
      ref: this._inputRef,
      className: "form-control",
      value: this.str,
      required: this.props.required,
      readOnly: this.readonly,
      rows: this.props.rows || 4,
      cols: this.props.cols,
      maxLength: this.maxLength,
      autoFocus: this.props.autoFocus,
      placeholder: this.props.placeholder,
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.valueChangeHandlerAsync(e);
      }),
      onBlur: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.valueBlurHandlerAsync();
      })
    }), !this.noRemaining && React.createElement("div", {
      className: styles$Y.progressBar
    }, React.createElement("div", {
      style: {
        width: this.progressBar()
      }
    })));
  }
}

//Autogenerated
class ConfirmationDialogLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.areYouSureLanguageItemName = `_6:0`;
    this.confirmButtonLanguageItemName = `_6:1`;
    this.closeButtonLanguageItemName = `_6:2`;
    this.commentLanguageItemName = `_6:3`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_6:0`, {
      l: `en`,
      v: `Are you sure?`
    }, {
      l: `uk`,
      v: `Ви впевнені?`
    }, {
      l: `sv`,
      v: `Är du säker?`
    }, {
      l: `ru`,
      v: `Вы уверены?`
    }, {
      l: `pl`,
      v: `Czy jesteś pewien?`
    }, {
      l: `nl`,
      v: `Weet je het zeker?`
    }, {
      l: `nb`,
      v: `Er du sikker?`
    }, {
      l: `it`,
      v: `Sei sicuro?`
    }, {
      l: `fr`,
      v: `Es-tu sûr?`
    }, {
      l: `fi`,
      v: `Oletko varma?`
    }, {
      l: `es`,
      v: `Estas seguro`
    }, {
      l: `de`,
      v: `Bist du sicher?`
    }, {
      l: `da`,
      v: `Er du sikker?`
    });
    this.set(`_6:1`, {
      l: `en`,
      v: `Confirm`
    }, {
      l: `uk`,
      v: `Підтвердети`
    }, {
      l: `sv`,
      v: `Bekräfta`
    }, {
      l: `ru`,
      v: `Подтвердить`
    }, {
      l: `pl`,
      v: `Potwierdź`
    }, {
      l: `nl`,
      v: `Bevestigen`
    }, {
      l: `nb`,
      v: `Bekreft`
    }, {
      l: `it`,
      v: `Confermare`
    }, {
      l: `fr`,
      v: `Confirmer`
    }, {
      l: `fi`,
      v: `Kyllä`
    }, {
      l: `es`,
      v: `Confirmar`
    }, {
      l: `de`,
      v: `Bestätigen`
    }, {
      l: `da`,
      v: `Bekræft`
    });
    this.set(`_6:2`, {
      l: `en`,
      v: `Close`
    }, {
      l: `uk`,
      v: `Закрити`
    }, {
      l: `sv`,
      v: `Stäng`
    }, {
      l: `ru`,
      v: `Отмена`
    }, {
      l: `pl`,
      v: `Zamknij`
    }, {
      l: `nl`,
      v: `Dichtbij`
    }, {
      l: `nb`,
      v: `Lukk`
    }, {
      l: `it`,
      v: `Vicino`
    }, {
      l: `fr`,
      v: `Fermer`
    }, {
      l: `fi`,
      v: `Ei`
    }, {
      l: `es`,
      v: `Cerca`
    }, {
      l: `de`,
      v: `Schließen`
    }, {
      l: `da`,
      v: `Luk`
    });
    this.set(`_6:3`, {
      l: `en`,
      v: `Please leave a comment`
    }, {
      l: `uk`,
      v: `Будьласка, залиште коментар`
    }, {
      l: `sv`,
      v: `Var vänlig och lämna en kommentar`
    }, {
      l: `ru`,
      v: `Пожалуйста, оставьте комментарий`
    }, {
      l: `pl`,
      v: `Dodaj komentarz`
    }, {
      l: `nl`,
      v: `Laat een reactie achter`
    }, {
      l: `nb`,
      v: `Vennligst legg igjen en kommentar`
    }, {
      l: `it`,
      v: `Per favore lascia un commento`
    }, {
      l: `fr`,
      v: `S'il vous plaît laissez un commentaire`
    }, {
      l: `fi`,
      v: `Ole hyvä ja kommentoi`
    }, {
      l: `es`,
      v: `Por favor deja un comentario`
    }, {
      l: `de`,
      v: `Bitte lass ein Kommentar da`
    }, {
      l: `da`,
      v: `Efterlad en kommentar`
    });
  }
  /**
  /* "AreYouSure" (Are you sure?)
  /* "Localizer.areYouSure"
  /* "Localizer.areYouSureLanguageItemName"
  */
  get areYouSure() {
    return this.get(`_6:0`);
  }
  /**
  /* "ConfirmButton" (Confirm)
  /* "Localizer.confirmButton"
  /* "Localizer.confirmButtonLanguageItemName"
  */
  get confirmButton() {
    return this.get(`_6:1`);
  }
  /**
  /* "CloseButton" (Close)
  /* "Localizer.closeButton"
  /* "Localizer.closeButtonLanguageItemName"
  */
  get closeButton() {
    return this.get(`_6:2`);
  }
  /**
  /* "Comment" (Please leave a comment)
  /* "Localizer.comment"
  /* "Localizer.commentLanguageItemName"
  */
  get comment() {
    return this.get(`_6:3`);
  }
}
//Singleton
var ConfirmationDialogLocalizer$1 = new ConfirmationDialogLocalizer();

//Autogenerated
class MessageBoxLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.okLanguageItemName = `_45:0`;
    this.areYouSureLanguageItemName = `_45:1`;
    this.commentLanguageItemName = `_45:2`;
    this.yesLanguageItemName = `_45:3`;
    this.noLanguageItemName = `_45:4`;
    this.abortLanguageItemName = `_45:5`;
    this.retryLanguageItemName = `_45:6`;
    this.ignoreLanguageItemName = `_45:7`;
    this.cancelLanguageItemName = `_45:8`;
    this.typeConfirmationWordLanguageItemName = `_45:9`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_45:0`, {
      l: `en`,
      v: `Ok`
    }, {
      l: `uk`,
      v: `Ok`
    }, {
      l: `sv`,
      v: `Ok`
    }, {
      l: `ru`,
      v: `Ок`
    }, {
      l: `pl`,
      v: `Ok`
    }, {
      l: `nl`,
      v: `Ok`
    }, {
      l: `nb`,
      v: `Ok`
    }, {
      l: `it`,
      v: `Ok`
    }, {
      l: `fr`,
      v: `D'accord`
    }, {
      l: `fi`,
      v: `Ok`
    }, {
      l: `es`,
      v: `De acuerdo`
    }, {
      l: `de`,
      v: `Ok`
    }, {
      l: `da`,
      v: `Ok`
    });
    this.set(`_45:1`, {
      l: `en`,
      v: `Are you sure?`
    }, {
      l: `uk`,
      v: `Ви впевнені?`
    }, {
      l: `sv`,
      v: `Är du säker?`
    }, {
      l: `ru`,
      v: `Вы уверены?`
    }, {
      l: `pl`,
      v: `Czy jesteś pewien?`
    }, {
      l: `nl`,
      v: `Weet je het zeker?`
    }, {
      l: `nb`,
      v: `Er du sikker?`
    }, {
      l: `it`,
      v: `Sei sicuro?`
    }, {
      l: `fr`,
      v: `Es-tu sûr?`
    }, {
      l: `fi`,
      v: `Oletko varma?`
    }, {
      l: `es`,
      v: `Estas seguro`
    }, {
      l: `de`,
      v: `Bist du sicher?`
    }, {
      l: `da`,
      v: `Er du sikker?`
    });
    this.set(`_45:2`, {
      l: `en`,
      v: `Please leave a comment`
    }, {
      l: `uk`,
      v: `Будьласка, залиште коментар`
    }, {
      l: `sv`,
      v: `Var vänlig och lämna en kommentar`
    }, {
      l: `ru`,
      v: `Пожалуйста, оставьте комментарий`
    }, {
      l: `pl`,
      v: `Dodaj komentarz`
    }, {
      l: `nl`,
      v: `Laat een reactie achter`
    }, {
      l: `nb`,
      v: `Vennligst legg igjen en kommentar`
    }, {
      l: `it`,
      v: `Per favore lascia un commento`
    }, {
      l: `fr`,
      v: `S'il vous plaît laissez un commentaire`
    }, {
      l: `fi`,
      v: `Ole hyvä ja kommentoi`
    }, {
      l: `es`,
      v: `Por favor deja un comentario`
    }, {
      l: `de`,
      v: `Bitte lass ein Kommentar da`
    }, {
      l: `da`,
      v: `Efterlad en kommentar`
    });
    this.set(`_45:3`, {
      l: `en`,
      v: `Yes`
    }, {
      l: `uk`,
      v: `Так`
    }, {
      l: `sv`,
      v: `Ja`
    }, {
      l: `ru`,
      v: `Да`
    }, {
      l: `pl`,
      v: `Tak`
    }, {
      l: `nl`,
      v: `Ja`
    }, {
      l: `nb`,
      v: `Ja`
    }, {
      l: `it`,
      v: `SÌ`
    }, {
      l: `fr`,
      v: `Oui`
    }, {
      l: `fi`,
      v: `Kyllä`
    }, {
      l: `es`,
      v: `Sí`
    }, {
      l: `de`,
      v: `Ja`
    }, {
      l: `da`,
      v: `Ja`
    });
    this.set(`_45:4`, {
      l: `en`,
      v: `No`
    }, {
      l: `uk`,
      v: `Ні`
    }, {
      l: `sv`,
      v: `Nej`
    }, {
      l: `ru`,
      v: `Нет`
    }, {
      l: `pl`,
      v: `Nie`
    }, {
      l: `nl`,
      v: `Nee`
    }, {
      l: `nb`,
      v: `Nei`
    }, {
      l: `it`,
      v: `No`
    }, {
      l: `fr`,
      v: `Non`
    }, {
      l: `fi`,
      v: `Ei`
    }, {
      l: `es`,
      v: `No`
    }, {
      l: `de`,
      v: `Nein`
    }, {
      l: `da`,
      v: `Nej`
    });
    this.set(`_45:5`, {
      l: `en`,
      v: `Abort`
    }, {
      l: `uk`,
      v: `Перервати`
    }, {
      l: `sv`,
      v: `Avbryt`
    }, {
      l: `ru`,
      v: `Прервать`
    }, {
      l: `pl`,
      v: `Anulować`
    }, {
      l: `nl`,
      v: `Afbreken`
    }, {
      l: `nb`,
      v: `Avbryte`
    }, {
      l: `it`,
      v: `Interrompere`
    }, {
      l: `fr`,
      v: `Avorter`
    }, {
      l: `fi`,
      v: `Keskeytä`
    }, {
      l: `es`,
      v: `Abortar`
    }, {
      l: `de`,
      v: `Abbrechen`
    }, {
      l: `da`,
      v: `Afbryd`
    });
    this.set(`_45:6`, {
      l: `en`,
      v: `Retry`
    }, {
      l: `uk`,
      v: `Повторити`
    }, {
      l: `sv`,
      v: `Försök igen`
    }, {
      l: `ru`,
      v: `Повторить`
    }, {
      l: `pl`,
      v: `Spróbuj ponownie`
    }, {
      l: `nl`,
      v: `Opnieuw proberen`
    }, {
      l: `nb`,
      v: `Prøv på nytt`
    }, {
      l: `it`,
      v: `Riprova`
    }, {
      l: `fr`,
      v: `Recommencez`
    }, {
      l: `fi`,
      v: `Yritä uudelleen`
    }, {
      l: `es`,
      v: `Rever`
    }, {
      l: `de`,
      v: `Wiederholen`
    }, {
      l: `da`,
      v: `Prøv igen`
    });
    this.set(`_45:7`, {
      l: `en`,
      v: `Ignore`
    }, {
      l: `uk`,
      v: `Нехтувати`
    }, {
      l: `sv`,
      v: `Ignorera`
    }, {
      l: `ru`,
      v: `Игнорировать`
    }, {
      l: `pl`,
      v: `Ignoruj`
    }, {
      l: `nl`,
      v: `Negeren`
    }, {
      l: `nb`,
      v: `Overse`
    }, {
      l: `it`,
      v: `Ignorare`
    }, {
      l: `fr`,
      v: `Ignorer`
    }, {
      l: `fi`,
      v: `Ohita`
    }, {
      l: `es`,
      v: `Ignorar`
    }, {
      l: `de`,
      v: `Ignorieren`
    }, {
      l: `da`,
      v: `Ignorer`
    });
    this.set(`_45:8`, {
      l: `en`,
      v: `Cancel`
    }, {
      l: `uk`,
      v: `Перервати`
    }, {
      l: `sv`,
      v: `Avbryt`
    }, {
      l: `ru`,
      v: `Отмена`
    }, {
      l: `pl`,
      v: `Anuluj`
    }, {
      l: `nl`,
      v: `Annuleren`
    }, {
      l: `nb`,
      v: `Avbryt`
    }, {
      l: `it`,
      v: `Annulla`
    }, {
      l: `fr`,
      v: `Annuler`
    }, {
      l: `fi`,
      v: `Peruuta`
    }, {
      l: `es`,
      v: `Cancelar`
    }, {
      l: `de`,
      v: `Stornieren`
    }, {
      l: `da`,
      v: `Annuller`
    });
    this.set(`_45:9`, {
      l: `en`,
      v: `Type <b>\"{0}\"</b> to confirm the action:`
    }, {
      l: `uk`,
      v: `Введіть <b>"{0}"</b>, щоб підтвердити дію:`
    }, {
      l: `sv`,
      v: `Skriv <b>"{0}"</b> för att bekräfta åtgärden:`
    }, {
      l: `ru`,
      v: `Введите <b>"{0}"</b>, чтобы подтвердить действие:`
    }, {
      l: `pl`,
      v: `Wpisz <b>"{0}</b>, aby potwierdzić czynność:`
    }, {
      l: `nl`,
      v: `Typ <b>\"{0}\"</b> om de actie te bevestigen:`
    }, {
      l: `nb`,
      v: `Skriv inn <b>"{0}"</b> for å bekrefte handlingen:`
    }, {
      l: `it`,
      v: `Digita <b>\"{0}\"</b> per confermare l'azione:`
    }, {
      l: `fr`,
      v: `Tapez <b>"{0}"</b> pour confirmer l'action :`
    }, {
      l: `fi`,
      v: `Vahvista toiminto kirjoittamalla <b>"{0}</b>":`
    }, {
      l: `es`,
      v: `Escriba <b>\"{0}\"</b> para confirmar la acción:`
    }, {
      l: `de`,
      v: `Geben Sie <b>\"{0}\"</b> ein, um die Aktion zu bestätigen:`
    }, {
      l: `da`,
      v: `Skriv <b>"{0}"</b> for at bekræfte handlingen:`
    });
  }
  /**
  /* "Ok" (Ok)
  /* "Localizer.ok"
  /* "Localizer.okLanguageItemName"
  */
  get ok() {
    return this.get(`_45:0`);
  }
  /**
  /* "AreYouSure" (Are you sure?)
  /* "Localizer.areYouSure"
  /* "Localizer.areYouSureLanguageItemName"
  */
  get areYouSure() {
    return this.get(`_45:1`);
  }
  /**
  /* "Comment" (Please leave a comment)
  /* "Localizer.comment"
  /* "Localizer.commentLanguageItemName"
  */
  get comment() {
    return this.get(`_45:2`);
  }
  /**
  /* "Yes" (Yes)
  /* "Localizer.yes"
  /* "Localizer.yesLanguageItemName"
  */
  get yes() {
    return this.get(`_45:3`);
  }
  /**
  /* "No" (No)
  /* "Localizer.no"
  /* "Localizer.noLanguageItemName"
  */
  get no() {
    return this.get(`_45:4`);
  }
  /**
  /* "Abort" (Abort)
  /* "Localizer.abort"
  /* "Localizer.abortLanguageItemName"
  */
  get abort() {
    return this.get(`_45:5`);
  }
  /**
  /* "Retry" (Retry)
  /* "Localizer.retry"
  /* "Localizer.retryLanguageItemName"
  */
  get retry() {
    return this.get(`_45:6`);
  }
  /**
  /* "Ignore" (Ignore)
  /* "Localizer.ignore"
  /* "Localizer.ignoreLanguageItemName"
  */
  get ignore() {
    return this.get(`_45:7`);
  }
  /**
  /* "Cancel" (Cancel)
  /* "Localizer.cancel"
  /* "Localizer.cancelLanguageItemName"
  */
  get cancel() {
    return this.get(`_45:8`);
  }
  /**
  /* "TypeConfirmationWord" (Type <b>\"{0}\"</b> to confirm the action:)
  /* "Localizer.typeConfirmationWord"
  /* "Localizer.typeConfirmationWordLanguageItemName"
  */
  get typeConfirmationWord() {
    return this.get(`_45:9`);
  }
}
//Singleton
var MessageBoxLocalizer$1 = new MessageBoxLocalizer();

var css_248z$13 = ".athenaeum-confirmation-dialog-confirmDialog {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1150;\n  display: none;\n}\n.athenaeum-confirmation-dialog-confirmDialog.athenaeum-confirmation-dialog-opened {\n  display: block;\n}\n.athenaeum-confirmation-dialog-confirmDialog.athenaeum-confirmation-dialog-processing {\n  cursor: wait;\n}\n.athenaeum-confirmation-dialog-confirmDialog.athenaeum-confirmation-dialog-processing textarea {\n  cursor: wait;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-dialogOverlay {\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  opacity: 0.5;\n  position: absolute;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-dialogContent {\n  width: 300px;\n  background-color: white;\n  position: relative;\n  top: 40%;\n  margin: auto;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  border-radius: 6px;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-dialogContent > h5 {\n  white-space: normal;\n  word-break: break-word;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-commentInput {\n  margin-bottom: 0.5rem;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-confirmActionPromptInput {\n  margin-bottom: 0.5rem;\n}";
var styles$X = {"confirmDialog":"athenaeum-confirmation-dialog-confirmDialog","opened":"athenaeum-confirmation-dialog-opened","processing":"athenaeum-confirmation-dialog-processing","dialogOverlay":"athenaeum-confirmation-dialog-dialogOverlay","dialogContent":"athenaeum-confirmation-dialog-dialogContent","commentInput":"athenaeum-confirmation-dialog-commentInput","confirmActionPromptInput":"athenaeum-confirmation-dialog-confirmActionPromptInput"};
styleInject(css_248z$13);

class ConfirmationDialog extends BaseComponent {
  constructor() {
    super(...arguments);
    this._model = null;
    this.state = {
      isOpened: false,
      comment: "",
      confirmActionPromptWord: "",
      processing: false
    };
    this._commentRef = React.createRef();
    this._confirmActionPromptRef = React.createRef();
    this._resolver = null;
  }
  toModel(title) {
    let model = {};
    let data = title;
    if (data) {
      if (typeof data === "function") {
        data = data();
      }
      if (typeof data === "string") {
        model.title = data;
      } else {
        model = data;
      }
    }
    if (!model.title) {
      model.title = ConfirmationDialogLocalizer$1.areYouSure;
    }
    return model;
  }
  get model() {
    return this._model || (this._model = this.toModel(this.props.title));
  }
  get hasComment() {
    return this.state.isOpened ? !!this.model.comment : false;
  }
  get hasConfirmActionPrompt() {
    return this.state.isOpened ? !!this.model.confirmActionPrompt && !!this.model.confirmActionPromptWord : false;
  }
  get minLength() {
    return this.state.isOpened ? this.props.minLength || this.model.minLength || 0 : 0;
  }
  get canConfirm() {
    var _a;
    const canConfirmComment = this.hasConfirmActionPrompt || !this.hasComment || this.state.comment.length > this.minLength;
    const canConfirmConfirmActionPrompt = !this.hasConfirmActionPrompt || ((_a = this.model.confirmActionPromptWord) === null || _a === void 0 ? void 0 : _a.length) == 0 || this.state.confirmActionPromptWord == this.model.confirmActionPromptWord;
    return canConfirmComment && canConfirmConfirmActionPrompt;
  }
  get processing() {
    return this.state.processing;
  }
  setCommentAsync(comment) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        comment
      });
    });
  }
  setConfirmActionPromptWordAsync(confirmActionPromptWord) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        confirmActionPromptWord
      });
    });
  }
  setDialogAsync(isOpened, nestedCheck = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.state.isOpened != isOpened) {
        if (nestedCheck) {
          if (isOpened && ConfirmationDialog._current) {
            yield ConfirmationDialog._current.setDialogAsync(false, false);
            ConfirmationDialog._previous = ConfirmationDialog._current;
          }
        }
        yield this.setState({
          isOpened
        });
        if (nestedCheck) {
          ConfirmationDialog._current = isOpened ? this : null;
          if (!isOpened && ConfirmationDialog._previous) {
            yield ConfirmationDialog._previous.setDialogAsync(true, false);
            ConfirmationDialog._previous = null;
          }
        }
      }
    });
  }
  setProcessingAsync(processing) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.setState({
          processing
        });
      }
    });
  }
  invokeCloseAsync(confirm = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (confirm) {
        if (this.props.callback) {
          if (!this.processing) {
            try {
              yield this.setProcessingAsync(true);
              yield this.props.callback(this, this.state.comment);
            } finally {
              yield this.setProcessingAsync(false);
            }
          }
        }
      } else if (this.props.onDecline) {
        if (!this.processing) {
          try {
            yield this.setProcessingAsync(true);
            yield this.props.onDecline(this);
          } finally {
            yield this.setProcessingAsync(false);
          }
        }
      }
      if (this._resolver) {
        this._resolver(confirm);
        this._resolver = null;
      }
      yield this.setDialogAsync(false);
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpened) {
        yield this.invokeCloseAsync();
      } else {
        yield this.openAsync();
      }
    });
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setDialogAsync(true);
      if (this._commentRef.current) {
        this._commentRef.current.focus();
      }
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeCloseAsync();
    });
  }
  confirmAsync(title) {
    return __awaiter(this, void 0, void 0, function* () {
      this._model = this.toModel(title);
      yield this.openAsync();
      return new Promise(resolve => {
        this._resolver = resolve;
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const targetNode = e.target;
      const outside = Utility.clickedOutside(targetNode, `confirmationContent-${this.id}`);
      if (outside) {
        yield this.invokeCloseAsync();
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasComment && !this.hasConfirmActionPrompt) {
        yield this.invokeCloseAsync();
      } else {
        if (e.keyCode === 27) {
          yield this.invokeCloseAsync();
        }
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._model = null;
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  renderDialog() {
    const openedStyle = this.state.isOpened && styles$X.opened;
    const processingStyle = this.processing && styles$X.processing;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$X.confirmDialog, openedStyle, processingStyle, this.props.className, this.model.className)
    }, React.createElement("div", {
      className: styles$X.dialogOverlay
    }), React.createElement("div", {
      id: `confirmationContent-${this.id}`,
      className: styles$X.dialogContent
    }, React.createElement("h5", null, this.toMultiLines(ConfirmationDialogLocalizer$1.get(this.model.title))), this.hasComment && React.createElement(TextAreaInput, {
      ref: this._commentRef,
      required: true,
      noValidate: true,
      rows: 3,
      placeholder: this.model.placeholder ? ConfirmationDialogLocalizer$1.get(this.model.placeholder) : ConfirmationDialogLocalizer$1.comment,
      className: styles$X.commentInput,
      value: this.state.comment,
      readonly: this.processing,
      onChange: (sender, value) => this.setCommentAsync(value)
    }), this.hasConfirmActionPrompt && React.createElement(TextInput, {
      ref: this._confirmActionPromptRef,
      label: MessageBoxLocalizer$1.typeConfirmationWord.format(this.model.confirmActionPromptWord),
      placeholder: this.model.confirmActionPromptWord,
      className: styles$X.confirmActionPromptInput,
      value: this.state.confirmActionPromptWord,
      readonly: this.processing,
      onChange: (sender, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.setConfirmActionPromptWordAsync(value);
      })
    }), React.createElement(Button, {
      block: true,
      id: "confirmation-dialog-confirm-" + this.id,
      label: this.props.confirmButtonLabel || ConfirmationDialogLocalizer$1.confirmButton,
      type: ButtonType.Orange,
      disabled: this.processing || !this.canConfirm,
      onClick: () => this.invokeCloseAsync(true)
    }), React.createElement(Button, {
      block: true,
      id: "confirmation-dialog-cancel-" + this.id,
      label: this.props.declineButtonLabel || ConfirmationDialogLocalizer$1.closeButton,
      type: ButtonType.Default,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync()
    })));
  }
  render() {
    return ReactDOM.createPortal(this.renderDialog(), document.body);
  }
}
ConfirmationDialog._current = null;
ConfirmationDialog._previous = null;

var css_248z$12 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-icon-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-icon-actions {\n  position: absolute;\n  min-width: calc(100% + 10px);\n  border-radius: 0.25rem;\n  border: 1px solid #ccc !important;\n  top: calc(100% + 1px);\n  right: 0;\n  text-align: left;\n  z-index: 10;\n  font-family: \"DINProMedium\", Arial, sans-serif;\n  font-size: 14px;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_grey {\n  background-color: white !important;\n  color: #333 !important;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_grey .athenaeum-icon-action:hover {\n  background-color: #e3e3e3 !important;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_orange {\n  background-color: rgb(254, 80, 0) !important;\n  color: white !important;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_orange .athenaeum-icon-action:hover {\n  background-color: rgba(240, 80, 0, 0.8) !important;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_unset {\n  color: #000000 !important;\n  background-color: #ffffff !important;\n  border-color: black;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_unset .athenaeum-icon-action:hover {\n  background-color: rgba(140, 140, 140, 0.8) !important;\n}\n.athenaeum-icon-actions .athenaeum-icon-action {\n  line-height: 1.5;\n  padding: 6px 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-icon-actions .athenaeum-icon-action span {\n  flex: 1;\n}\n.athenaeum-icon-actions .athenaeum-icon-action i:last-child {\n  padding-right: 0;\n}\n.athenaeum-icon-actions .athenaeum-icon-action > i {\n  padding-right: 12px;\n}\n.athenaeum-icon-actions .athenaeum-icon-action:hover {\n  filter: alpha(opacity=60);\n}";
var styles$W = {"font-renta":"athenaeum-icon-font-renta","actions":"athenaeum-icon-actions","color_grey":"athenaeum-icon-color_grey","action":"athenaeum-icon-action","color_orange":"athenaeum-icon-color_orange","color_unset":"athenaeum-icon-color_unset"};
styleInject(css_248z$12);

class IconAction extends BaseComponent {
  get hasIcon() {
    return !!this.props.icon;
  }
  get hasIconPosition() {
    return !!this.props.iconPosition;
  }
  get isIconPositionLeft() {
    return this.hasIcon && !this.hasIconPosition;
  }
  get isIconPositionRight() {
    return this.hasIcon && this.hasIconPosition && this.props.iconPosition == Justify.Right;
  }
  render() {
    return React.createElement("div", {
      className: styles$W.action,
      title: this.props.tooltip || undefined,
      onClick: () => this.props.onClick()
    }, this.isIconPositionLeft && React.createElement(Icon, Object.assign({}, this.props.icon)), React.createElement("span", null, this.props.title), this.isIconPositionRight && React.createElement(Icon, Object.assign({}, this.props.icon)));
  }
}

//Autogenerated
class IconLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var IconLocalizer$1 = new IconLocalizer();

var IconSize;
(function (IconSize) {
  IconSize[IconSize["Normal"] = 0] = "Normal";
  IconSize[IconSize["ExtraSmall"] = 1] = "ExtraSmall";
  IconSize[IconSize["Small"] = 2] = "Small";
  IconSize[IconSize["Large"] = 3] = "Large";
  IconSize[IconSize["X2"] = 4] = "X2";
  IconSize[IconSize["X3"] = 5] = "X3";
  IconSize[IconSize["X4"] = 6] = "X4";
  IconSize[IconSize["X5"] = 7] = "X5";
  IconSize[IconSize["X7"] = 8] = "X7";
  IconSize[IconSize["X10"] = 9] = "X10";
})(IconSize || (IconSize = {}));
var IconStyle;
(function (IconStyle) {
  IconStyle[IconStyle["Solid"] = 0] = "Solid";
  IconStyle[IconStyle["Regular"] = 1] = "Regular";
  IconStyle[IconStyle["Light"] = 2] = "Light";
  IconStyle[IconStyle["Brands"] = 3] = "Brands";
  IconStyle[IconStyle["Duotone"] = 4] = "Duotone";
})(IconStyle || (IconStyle = {}));
class Icon extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false
    };
    this._confirmDialogRef = React.createRef();
    this._actionLoading = false;
    this._onClickInvoking = false;
  }
  static get Action() {
    return IconAction;
  }
  static add(lowerClassName, className, style, asPrefix = false) {
    const includes = asPrefix ? lowerClassName.startsWith(style + " ") : lowerClassName.includes(style);
    if (!includes) {
      className += " " + style;
    }
    return className;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.hasActions) {
        yield this.reRenderAsync();
      }
    });
  }
  get actionsId() {
    return `${this.id}_actions`;
  }
  closeActions() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const outside = Utility.clickedOutside(target, this.id);
      if (outside && this.state.isOpen) {
        yield this.closeActions();
      }
    });
  }
  static addSize(lowerClassName, className, size) {
    if (size != null) {
      switch (size) {
        case IconSize.ExtraSmall:
          className = Icon.add(lowerClassName, className, "fa-xs");
          break;
        case IconSize.Small:
          className = Icon.add(lowerClassName, className, "fa-sm");
          break;
        case IconSize.Large:
          className = Icon.add(lowerClassName, className, "fa-lg");
          break;
        case IconSize.X2:
          className = Icon.add(lowerClassName, className, "fa-2x");
          break;
        case IconSize.X3:
          className = Icon.add(lowerClassName, className, "fa-3x");
          break;
        case IconSize.X4:
          className = Icon.add(lowerClassName, className, "fa-4x");
          break;
        case IconSize.X5:
          className = Icon.add(lowerClassName, className, "fa-5x");
          break;
        case IconSize.X7:
          className = Icon.add(lowerClassName, className, "fa-7x");
          break;
        case IconSize.X10:
          className = Icon.add(lowerClassName, className, "fa-10x");
          break;
      }
    }
    return className;
  }
  static addStyle(lowerClassName, className, style) {
    if (style != null) {
      switch (style) {
        case IconStyle.Solid:
          return Icon.add(lowerClassName, className, "fas");
        case IconStyle.Regular:
          return Icon.add(lowerClassName, className, "far");
        case IconStyle.Light:
          return Icon.add(lowerClassName, className, "fal");
        case IconStyle.Brands:
          return Icon.add(lowerClassName, className, "fab");
        case IconStyle.Duotone:
          return Icon.add(lowerClassName, className, "fad");
      }
    }
    return Icon.add(lowerClassName, className, "fa", true);
  }
  static getClassStyle(lowerName) {
    let classStyle = undefined;
    if (lowerName.startsWith("fas ")) {
      classStyle = IconStyle.Solid;
    } else if (lowerName.startsWith("far ")) {
      classStyle = IconStyle.Regular;
    } else if (lowerName.startsWith("fal ")) {
      classStyle = IconStyle.Light;
    } else if (lowerName.startsWith("fab ")) {
      classStyle = IconStyle.Brands;
    } else if (lowerName.startsWith("fad ")) {
      classStyle = IconStyle.Duotone;
    }
    return classStyle;
  }
  // overriding children's onClick 
  extendChildProps(element) {
    return {
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        yield this.onActionClickAsync(element.props);
      })
    };
  }
  onActionClickAsync(actionProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._actionLoading) {
        return;
      }
      this._actionLoading = true;
      yield this.reRenderAsync();
      try {
        yield actionProps.onClick();
      } finally {
        this._actionLoading = false;
        yield this.reRenderAsync();
      }
    });
  }
  getClassName() {
    let name = this.props.name;
    let className = this.css(this.props.className);
    const lowerClassName = className.toLowerCase();
    const lowerName = name.toLowerCase();
    const classStyle = Icon.getClassStyle(lowerName);
    if (classStyle != null) {
      name = name.substr(4);
    }
    if (!lowerName.startsWith("fa-") && !lowerName.includes(" fa-")) {
      className += " fa-";
    } else {
      className += " ";
    }
    className += name;
    className = Icon.addSize(lowerClassName, className, this.props.size);
    className = Icon.addStyle(lowerClassName, className, this.props.style || classStyle);
    className = className.trim();
    return className;
  }
  get disabledStyle() {
    return {
      opacity: 0.5,
      pointerEvents: "none"
    };
  }
  get dataTarget() {
    return this.props.dataTarget || "";
  }
  get dataModal() {
    return this.props.dataModal || "";
  }
  get dataToggleModal() {
    return this.props.toggleModal ? "modal" : "";
  }
  get dataDismissModal() {
    return this.props.dismissModal ? "modal" : "";
  }
  get hasActions() {
    return !!this.props.children;
  }
  toggleActions() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: !this.state.isOpen
      });
    });
  }
  get showActions() {
    return this.hasActions && this.state.isOpen;
  }
  invokeOnClickAsync(data = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._onClickInvoking) {
        try {
          this._onClickInvoking = true;
          if (this.props.onClick) {
            yield this.props.onClick(this, data);
          }
        } finally {
          this._onClickInvoking = false;
        }
      }
    });
  }
  onClickAsync(confirmed, data = null, e = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e != null && this.props.stopPropagation === true) {
        e.stopPropagation();
      }
      if (this.hasActions) {
        return yield this.toggleActions();
      }
      const confirmNeeded = !!this.props.confirm && !confirmed;
      if (confirmNeeded) {
        yield this._confirmDialogRef.current.openAsync();
      } else {
        yield this.invokeOnClickAsync(data);
      }
    });
  }
  static isIconName(name) {
    const lowerName = name.toLowerCase().trim();
    return lowerName.startsWith("fa-") || lowerName.includes(" fa-") || Icon.getClassStyle(lowerName) != null;
  }
  static getIconName(name) {
    if (!name) {
      return null;
    }
    const items = name.split(" ").where(item => !!item).select(item => item.trim().toLowerCase());
    const excludes = ["fa-", "fas", "far", "fab", "fad", "fa"];
    const excludePrefixes = ["fa-"];
    name = items.firstOrDefault(item => !excludes.any(exclude => item == exclude) && !excludePrefixes.any(exclude => item.startsWith(exclude)));
    return name || null;
  }
  static renderIcon(icon, className, size = IconSize.X2, onClick) {
    if (typeof icon === "string") {
      const isIcon = Icon.isIconName(icon);
      if (isIcon) {
        return React.createElement(Icon, {
          name: icon,
          size: size,
          className: className || undefined,
          onClick: onClick
        });
      }
      return React.createElement("img", {
        src: icon,
        alt: "",
        className: Utility.css(className),
        onClick: onClick
      });
    }
    const isFileModel = icon instanceof FileModel || icon.isFileModel;
    if (isFileModel) {
      const fileModel = icon;
      return React.createElement("img", {
        src: fileModel.src,
        alt: fileModel.name,
        className: Utility.css(className),
        onClick: onClick
      });
    }
    return React.createElement(Icon, Object.assign({}, icon, {
      size: size,
      className: Utility.css(className),
      onClick: onClick
    }));
  }
  render() {
    return React.createElement(React.Fragment, null, React.createElement("i", {
      id: this.id,
      style: this.props.customStyle ? this.props.customStyle : this.props.disabled ? this.disabledStyle : this.hasActions ? {
        position: "relative"
      } : {},
      className: this.getClassName(),
      title: IconLocalizer$1.get(this.props.tooltip),
      "data-target": `#${this.dataTarget}`,
      "data-toggle": this.dataToggleModal,
      "data-dismiss": this.dataDismissModal,
      "data-modal": this.dataModal,
      onClick: e => this.onClickAsync(false, null, e)
    }, this.children.length > 0 && React.createElement("div", {
      id: this.actionsId,
      className: this.css(styles$W.actions, styles$W.color_grey, "actions-container", !this.showActions && "invisible")
    }, " ", this.children)), this.props.confirm && React.createElement(ConfirmationDialog, {
      ref: this._confirmDialogRef,
      title: this.props.confirm,
      callback: (caller, data) => this.onClickAsync(true, data)
    }));
  }
}

var css_248z$11 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-button-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-button-button {\n  border-color: #ccc !important;\n  font-size: 14px !important;\n  white-space: nowrap;\n  position: relative;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  min-width: 35px;\n  min-height: 35px;\n}\n.athenaeum-button-button:focus {\n  box-shadow: none !important;\n}\n.athenaeum-button-button.athenaeum-button-hover:hover {\n  color: #333 !important;\n  background-color: rgb(227, 227, 227) !important;\n  border-color: #adadad;\n}\n.athenaeum-button-button i {\n  padding-right: 0;\n}\n.athenaeum-button-button.athenaeum-button-labelRightPadding i {\n  padding-right: 8px;\n}\n.athenaeum-button-button.athenaeum-button-labelLeftPadding i {\n  padding-left: 8px;\n}\n.athenaeum-button-button.athenaeum-button-small {\n  font-size: 0.8rem !important;\n  padding: 0.375rem;\n  height: auto;\n  min-width: 33px;\n  min-height: 33px;\n}\n.athenaeum-button-button.athenaeum-button-small.athenaeum-button-labelRightPadding {\n  padding-right: 0.7rem;\n}\n.athenaeum-button-button.athenaeum-button-small.athenaeum-button-labelLeftPadding {\n  padding-left: 0.7rem;\n}\n.athenaeum-button-button.athenaeum-button-disabled {\n  pointer-events: none;\n}\n.athenaeum-button-button.athenaeum-button-color_grey {\n  background-color: white;\n  color: #333;\n}\n.athenaeum-button-button.athenaeum-button-color_orange {\n  background-color: rgb(254, 80, 0);\n  color: white;\n}\n.athenaeum-button-button.athenaeum-button-color_unset {\n  color: #000000;\n  background-color: #8c8c8c;\n  border-color: black;\n}\n.athenaeum-button-button.athenaeum-button-text {\n  padding: 0;\n  border: 0;\n  color: rgb(254, 80, 0);\n}\n.athenaeum-button-button.athenaeum-button-text:hover {\n  background-color: inherit !important;\n  color: inherit !important;\n}\n.athenaeum-button-button.athenaeum-button-withActions {\n  padding-right: 24px;\n}\n.athenaeum-button-button.athenaeum-button-withActions .athenaeum-button-icon {\n  position: absolute;\n  top: 10px;\n  right: 0;\n  padding-right: 8px;\n}\n.athenaeum-button-button.athenaeum-button-withActions span {\n  flex-grow: 1;\n}\n.athenaeum-button-button .athenaeum-button-count {\n  position: absolute;\n  right: -10px;\n  top: -7px;\n  padding-left: 9px;\n  padding-right: 9px;\n  font-size: 12px;\n  background: #000000;\n  color: #fff;\n  vertical-align: top;\n  border-radius: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n}\n\n.athenaeum-button-actions {\n  position: absolute;\n  min-width: calc(100% + 2px);\n  border-radius: 0.25rem;\n  border: 1px solid #ccc !important;\n  top: 33px;\n  left: -1px;\n  text-align: left;\n  z-index: 10;\n}\n.athenaeum-button-actions.athenaeum-button-color_grey {\n  background-color: white !important;\n  color: #333 !important;\n}\n.athenaeum-button-actions.athenaeum-button-color_grey .athenaeum-button-action:hover {\n  background-color: #e3e3e3 !important;\n}\n.athenaeum-button-actions.athenaeum-button-color_orange {\n  background-color: rgb(254, 80, 0) !important;\n  color: white !important;\n}\n.athenaeum-button-actions.athenaeum-button-color_orange .athenaeum-button-action:hover {\n  background-color: rgba(240, 80, 0, 0.8) !important;\n}\n.athenaeum-button-actions.athenaeum-button-color_unset {\n  color: #000000 !important;\n  background-color: #8c8c8c !important;\n  border-color: black;\n}\n.athenaeum-button-actions.athenaeum-button-color_unset .athenaeum-button-action:hover {\n  background-color: rgba(140, 140, 140, 0.8) !important;\n}\n.athenaeum-button-actions .athenaeum-button-action {\n  padding: 6px 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-button-actions .athenaeum-button-action span {\n  flex: 1;\n}\n.athenaeum-button-actions .athenaeum-button-action i:last-child {\n  padding-right: 0;\n}\n.athenaeum-button-actions .athenaeum-button-action > i {\n  padding-right: 12px;\n}\n.athenaeum-button-actions .athenaeum-button-action:hover {\n  filter: alpha(opacity=60);\n}\n\n.athenaeum-button-hidden {\n  display: none;\n}";
var styles$V = {"font-renta":"athenaeum-button-font-renta","button":"athenaeum-button-button","hover":"athenaeum-button-hover","labelRightPadding":"athenaeum-button-labelRightPadding","labelLeftPadding":"athenaeum-button-labelLeftPadding","small":"athenaeum-button-small","disabled":"athenaeum-button-disabled","color_grey":"athenaeum-button-color_grey","color_orange":"athenaeum-button-color_orange","color_unset":"athenaeum-button-color_unset","text":"athenaeum-button-text","withActions":"athenaeum-button-withActions","icon":"athenaeum-button-icon","count":"athenaeum-button-count","actions":"athenaeum-button-actions","action":"athenaeum-button-action","hidden":"athenaeum-button-hidden"};
styleInject(css_248z$11);

class ButtonAction extends BaseComponent {
  get hasIcon() {
    return !!this.props.icon;
  }
  get hasIconPosition() {
    return !!this.props.iconPosition;
  }
  get isIconPositionLeft() {
    return this.hasIcon && !this.hasIconPosition;
  }
  get isIconPositionRight() {
    return this.hasIcon && this.hasIconPosition && this.props.iconPosition == Justify.Right;
  }
  render() {
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$V.action, this.props.className),
      title: this.props.tooltip || undefined,
      onClick: () => this.props.onClick()
    }, this.isIconPositionLeft && React.createElement(Icon, Object.assign({}, this.props.icon)), React.createElement("span", null, this.props.title), this.isIconPositionRight && React.createElement(Icon, Object.assign({}, this.props.icon)));
  }
}

//Autogenerated
class ButtonLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var ButtonLocalizer$1 = new ButtonLocalizer();

var ButtonType;
(function (ButtonType) {
  ButtonType[ButtonType["Default"] = 0] = "Default";
  ButtonType[ButtonType["Orange"] = 1] = "Orange";
  ButtonType[ButtonType["Blue"] = 2] = "Blue";
  ButtonType[ButtonType["Primary"] = 3] = "Primary";
  ButtonType[ButtonType["Secondary"] = 4] = "Secondary";
  ButtonType[ButtonType["Success"] = 5] = "Success";
  ButtonType[ButtonType["Danger"] = 6] = "Danger";
  ButtonType[ButtonType["Warning"] = 7] = "Warning";
  ButtonType[ButtonType["Info"] = 8] = "Info";
  ButtonType[ButtonType["Light"] = 9] = "Light";
  ButtonType[ButtonType["Dark"] = 10] = "Dark";
  ButtonType[ButtonType["Link"] = 11] = "Link";
  ButtonType[ButtonType["Unset"] = 12] = "Unset";
  ButtonType[ButtonType["Text"] = 13] = "Text";
})(ButtonType || (ButtonType = {}));
class Button extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false
    };
    this._confirmDialogRef = React.createRef();
    this._forcedWidth = null;
    this._actionLoading = false;
    this._actionProps = null;
    this._onClickInvoking = false;
  }
  static get Action() {
    return ButtonAction;
  }
  static registerOnClickCallback(callback) {
    this._onClickCallbacks.push(callback);
  }
  isButton() {
    return true;
  }
  getStyleColor() {
    switch (this.props.type) {
      case ButtonType.Orange:
        return styles$V.color_orange;
      case ButtonType.Blue:
      case ButtonType.Primary:
        return "btn-primary";
      case ButtonType.Secondary:
        return "btn-secondary";
      case ButtonType.Success:
        return "btn-success";
      case ButtonType.Danger:
        return "btn-danger";
      case ButtonType.Warning:
        return "btn-warning";
      case ButtonType.Info:
        return "btn-info";
      case ButtonType.Light:
        return "btn-light";
      case ButtonType.Dark:
        return "btn-dark";
      case ButtonType.Link:
        return "btn-link";
      case ButtonType.Unset:
        return styles$V.color_unset;
      case ButtonType.Text:
        return styles$V.text;
      default:
        return styles$V.color_grey;
    }
  }
  getButtonTypeName() {
    switch (this.props.type) {
      case ButtonType.Orange:
        return "Orange";
      case ButtonType.Blue:
        return "Blue";
      case ButtonType.Primary:
        return "Primary";
      case ButtonType.Secondary:
        return "Secondary";
      case ButtonType.Success:
        return "Success";
      case ButtonType.Danger:
        return "Danger";
      case ButtonType.Warning:
        return "Warning";
      case ButtonType.Info:
        return "Info";
      case ButtonType.Light:
        return "Light";
      case ButtonType.Dark:
        return "Dark";
      case ButtonType.Link:
        return "Link";
      case ButtonType.Unset:
        return "Unset";
      case ButtonType.Text:
        return "Text";
      default:
        return "Default";
    }
  }
  getCount() {
    return this.props.count != null ? typeof this.props.count === "function" ? this.props.count() : this.props.count : null;
  }
  getLeftSideIcon() {
    if (this._actionProps && this._actionProps.title && this._actionProps.icon && this._actionProps.iconPosition != Justify.Right) {
      return this._actionProps.icon;
    }
    if (this._actionProps && this._actionProps.title) {
      return null;
    }
    if (this.props.icon && this.iconPosition == Justify.Left) {
      return typeof this.props.icon === "string" ? {
        name: this.props.icon
      } : this.props.icon;
    }
    return null;
  }
  getRightSideIcon() {
    if (this._actionProps && this._actionProps.icon && this._actionProps.iconPosition == Justify.Right) {
      return this._actionProps.icon;
    }
    if (this._actionProps && this._actionProps.icon) {
      return null;
    }
    if (this.props.icon && this.iconPosition == Justify.Right) {
      return typeof this.props.icon === "string" ? {
        name: this.props.icon
      } : this.props.icon;
    }
    return null;
  }
  invokeOnClickAsync(data = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._onClickInvoking) {
        try {
          this._onClickInvoking = true;
          if (this.props.route) {
            yield PageRouteProvider.redirectAsync(this.props.route);
          }
          if (this.props.onClick) {
            yield this.props.onClick(this, data);
          }
          yield Utility.forEachAsync(Button._onClickCallbacks, callback => callback(this, data));
        } finally {
          this._onClickInvoking = false;
        }
      }
    });
  }
  onClickAsync(event = null, confirmed = true, data = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasActions) {
        return yield this.toggleActionsAsync();
      }
      if (event && this.props.stopPropagation) {
        event.stopPropagation();
      }
      const confirmNeeded = !!this.props.confirm && !confirmed;
      if (confirmNeeded) {
        yield this._confirmDialogRef.current.openAsync();
      } else {
        yield this.invokeOnClickAsync(data);
      }
    });
  }
  toggleActionsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: !this.state.isOpen
      });
    });
  }
  closeActionsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
    });
  }
  get actionsId() {
    return `${this.id}_actions`;
  }
  get dataTarget() {
    return this.props.dataTarget || "";
  }
  get dataModal() {
    return this.props.dataModal || "";
  }
  get dataToggleModal() {
    return this.props.toggleModal ? "modal" : "";
  }
  get dataDismissModal() {
    return this.props.dismissModal ? "modal" : "";
  }
  get hasActions() {
    return !!this.props.children;
  }
  get showActions() {
    return this.hasActions && this.state.isOpen;
  }
  get label() {
    var _a;
    return ((_a = this._actionProps) === null || _a === void 0 ? void 0 : _a.title) || this.props.label || null;
  }
  get title() {
    return this.props.title || null;
  }
  // overriding children's onClick
  extendChildProps(element) {
    return {
      onClick: () => this.onActionClickAsync(element.props)
    };
  }
  onActionClickAsync(actionProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._actionLoading) {
        return;
      }
      this._actionProps = actionProps;
      this._actionLoading = true;
      yield this.reRenderAsync();
      try {
        yield actionProps.onClick();
        yield Utility.forEachAsync(Button._onClickCallbacks, callback => callback(this, actionProps === null || actionProps === void 0 ? void 0 : actionProps.id));
      } finally {
        this._actionProps = null;
        this._actionLoading = false;
        yield this.reRenderAsync();
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpen) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.closeActionsAsync();
        }
      }
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.hasActions) {
        const actionsDiv = this.JQuery(`#${this.actionsId}`);
        const buttonWidth = this.outerWidth();
        const actionsWidth = actionsDiv.outerWidth() || 0;
        if (actionsWidth >= buttonWidth) {
          this._forcedWidth = actionsWidth;
        } else {
          this._forcedWidth = buttonWidth;
        }
        yield this.reRenderAsync();
      }
    });
  }
  get count() {
    return this.getCount();
  }
  get iconPosition() {
    var _a;
    return (_a = this.props.iconPosition) !== null && _a !== void 0 ? _a : Justify.Left;
  }
  get iconName() {
    var _a, _b;
    return ((_a = this.getLeftSideIcon()) === null || _a === void 0 ? void 0 : _a.name) || ((_b = this.getRightSideIcon()) === null || _b === void 0 ? void 0 : _b.name) || null;
  }
  get buttonType() {
    var _a;
    return (_a = this.props.type) !== null && _a !== void 0 ? _a : ButtonType.Default;
  }
  get buttonTypeName() {
    return this.getButtonTypeName();
  }
  render() {
    var _a;
    const count = this.getCount();
    const leftSideIcon = this.getLeftSideIcon();
    const rightSideIcon = this.getRightSideIcon();
    const showCaret = this.hasActions && !rightSideIcon && !((_a = this._actionProps) === null || _a === void 0 ? void 0 : _a.title);
    const blockStyle = this.props.block && "btn-block";
    const smallStyle = this.props.small && styles$V.small;
    const labelRightPaddingStyle = this.props.label && leftSideIcon && styles$V.labelRightPadding;
    const labelLeftPaddingStyle = this.props.label && rightSideIcon && styles$V.labelLeftPadding;
    const hoverStyle = this.desktop && styles$V.hover;
    const inlineStyles = this.props.style || {};
    if (this._forcedWidth) {
      inlineStyles.minWidth = this._forcedWidth;
    }
    if (this.props.minWidth) {
      inlineStyles.minWidth = this.props.minWidth;
    }
    return React.createElement(React.Fragment, null, React.createElement("button", {
      id: this.id,
      type: this.props.submit ? "submit" : "button",
      disabled: this.props.disabled,
      title: ButtonLocalizer$1.get(this.title),
      className: this.css("btn btn-default", this.getStyleColor(), blockStyle, smallStyle, labelRightPaddingStyle, labelLeftPaddingStyle, hoverStyle, styles$V.button, this.props.disabled && styles$V.disabled, this.props.className, this.hasActions && styles$V.withActions),
      style: inlineStyles,
      "data-target": `#${this.dataTarget}`,
      "data-modal": this.dataModal,
      "data-toggle": this.dataToggleModal,
      "data-dismiss": this.dataDismissModal,
      onClick: event => this.onClickAsync(event, false)
    }, leftSideIcon && React.createElement(Icon, Object.assign({}, leftSideIcon, {
      tooltip: ButtonLocalizer$1.get(this.title)
    })), React.createElement("span", null, ReactUtility.toTags(ButtonLocalizer$1.get(this.label))), rightSideIcon && React.createElement(Icon, Object.assign({}, rightSideIcon, {
      tooltip: ButtonLocalizer$1.get(this.title)
    })), showCaret && React.createElement(Icon, {
      className: this.css(styles$V.icon, "actions-icon"),
      name: "fa-caret-down",
      style: IconStyle.Solid
    }), this.children.length > 0 && React.createElement("div", {
      id: this.actionsId,
      className: this.css(styles$V.actions, this.getStyleColor(), "actions-container", !this.showActions && "invisible")
    }, this.children), count != null && React.createElement("div", {
      className: this.css(styles$V.count, this.props.countClassName)
    }, React.createElement("span", null, count))), this.props.confirm && React.createElement(ConfirmationDialog, {
      ref: this._confirmDialogRef,
      title: this.props.confirm,
      callback: (_, data) => this.onClickAsync(null, true, data)
    }));
  }
}
Button._onClickCallbacks = [];

var css_248z$10 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-button-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-button-container-buttonContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-row {\n  display: flex;\n  flex-wrap: wrap;\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-row.athenaeum-button-container-left {\n  justify-content: flex-start;\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-row.athenaeum-button-container-right {\n  justify-content: flex-end;\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-row.athenaeum-button-container-right.athenaeum-button-container-margin {\n  margin-left: 8px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-row.athenaeum-button-container-right.athenaeum-button-container-margin {\n    margin-left: 0 !important;\n    margin-top: 8px;\n  }\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-row.athenaeum-button-container-flexGrow {\n  flex-grow: 1;\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-row button {\n  margin-bottom: auto;\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-row button:not(.btn-block):not(:first-child) {\n  margin-left: 8px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-row {\n    width: 100%;\n  }\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-row button {\n    display: block;\n    width: 100%;\n  }\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-row button:not(.btn-block) {\n    margin-left: 0 !important;\n  }\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-row button:not(.btn-block):not(:first-child) {\n    margin-top: 8px;\n  }\n}";
var styles$U = {"font-renta":"athenaeum-button-container-font-renta","buttonContainer":"athenaeum-button-container-buttonContainer","row":"athenaeum-button-container-row","left":"athenaeum-button-container-left","right":"athenaeum-button-container-right","margin":"athenaeum-button-container-margin","flexGrow":"athenaeum-button-container-flexGrow"};
styleInject(css_248z$10);

class ButtonContainer extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  getButtons() {
    // noinspection UnnecessaryLocalVariableJS
    const buttons = React.Children.map(this.props.children, item => {
      return item;
    }) || [];
    return buttons;
  }
  getLeft(buttons) {
    const undefinedOrder = buttons.every(item => item.props.right == null);
    if (undefinedOrder) {
      return buttons.length > 1 ? buttons.slice(0, buttons.length - 1) : [];
    }
    return buttons.filter(item => item.props.right !== true);
  }
  getRight(buttons) {
    const undefinedOrder = buttons.every(item => item.props.right == null);
    if (undefinedOrder) {
      return buttons.length > 1 ? buttons.slice(buttons.length - 1) : buttons;
    }
    return buttons.filter(item => item.props.right === true);
  }
  render() {
    const buttons = this.getButtons();
    const left = this.getLeft(buttons);
    const right = this.getRight(buttons);
    const leftEmpty = left.length == 0;
    const rightEmpty = right.length == 0;
    const rightMargin = !leftEmpty && !rightEmpty;
    const leftFlexGrow = !leftEmpty;
    const rightFlexGrow = !leftFlexGrow && !rightEmpty;
    return React.createElement("div", {
      className: this.css(styles$U.buttonContainer, this.props.className)
    }, React.createElement("div", {
      className: this.css(styles$U.row, styles$U.left, leftEmpty && styles$U.empty, leftFlexGrow && styles$U.flexGrow)
    }, left), React.createElement("div", {
      className: this.css(styles$U.row, styles$U.right, rightEmpty && styles$U.empty, rightFlexGrow && styles$U.flexGrow, rightMargin && styles$U.margin)
    }, right));
  }
}

var css_248z$$ = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-carousel-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-carousel-carousel {\n  position: relative;\n}\n.athenaeum-carousel-carousel.athenaeum-carousel-paginationBottomOutside .swiper-container {\n  padding-bottom: 25px;\n}\n.athenaeum-carousel-carousel.athenaeum-carousel-paginationBottomOutside .swiper-container .swiper-pagination {\n  bottom: 1px;\n}\n.athenaeum-carousel-carousel.athenaeum-carousel-navigationOutside {\n  padding: 0 42px;\n}\n@media screen and (max-width: 640px) {\n  .athenaeum-carousel-carousel.athenaeum-carousel-navigationOutside {\n    padding: 0;\n  }\n}\n.athenaeum-carousel-carousel .swiper-pagination-bullet {\n  background-color: black;\n  opacity: 0.25;\n}\n.athenaeum-carousel-carousel .swiper-pagination-bullet:hover {\n  opacity: 0.5;\n}\n.athenaeum-carousel-carousel .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  opacity: 0.6;\n}\n.athenaeum-carousel-carousel .swiper-pagination-bullet.swiper-pagination-bullet-active:hover {\n  opacity: 0.8;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation {\n  position: absolute;\n  top: 50%;\n  margin-top: calc(0px - 42px / 2);\n  display: flex;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  color: black;\n  opacity: 0.6;\n  z-index: 1;\n  cursor: pointer;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation:hover {\n  opacity: 0.8;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation.athenaeum-carousel-next {\n  right: 0;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation.athenaeum-carousel-previous {\n  left: 0;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation.swiper-button-disabled {\n  opacity: 0.25;\n  cursor: initial;\n}\n@media screen and (max-width: 640px) {\n  .athenaeum-carousel-carousel .athenaeum-carousel-navigation {\n    display: none;\n  }\n}";
var styles$T = {"font-renta":"athenaeum-carousel-font-renta","carousel":"athenaeum-carousel-carousel","paginationBottomOutside":"athenaeum-carousel-paginationBottomOutside","navigationOutside":"athenaeum-carousel-navigationOutside","navigation":"athenaeum-carousel-navigation","next":"athenaeum-carousel-next","previous":"athenaeum-carousel-previous"};
styleInject(css_248z$$);

// Swiper modules need to be explicitly loaded
SwiperCore.use([Navigation, Pagination$1]);
// TODO:
//  If a child-elements width changes, Swiper slide width/snapping grid won't be updated.
//  Using Swiper in-built observer functionality does not help, as it does not notice changes in children width.
var CarouselNavigation;
(function (CarouselNavigation) {
  CarouselNavigation[CarouselNavigation["None"] = 0] = "None";
  CarouselNavigation[CarouselNavigation["Inside"] = 1] = "Inside";
  CarouselNavigation[CarouselNavigation["Outside"] = 2] = "Outside";
})(CarouselNavigation || (CarouselNavigation = {}));
var CarouselPagination;
(function (CarouselPagination) {
  CarouselPagination[CarouselPagination["None"] = 0] = "None";
  CarouselPagination[CarouselPagination["BottomInside"] = 1] = "BottomInside";
  CarouselPagination[CarouselPagination["BottomOutside"] = 2] = "BottomOutside";
})(CarouselPagination || (CarouselPagination = {}));
class Carousel extends BaseComponent {
  constructor() {
    // Inherited
    super(...arguments);
    this.state = {
      swiper: null
    };
    // Fields
    this._navigationNextId = "carousel_next" + ch.getId().toString();
    this._navigationPreviousId = "carousel_previous" + ch.getId().toString();
  }
  get children() {
    return this.props.children;
  }
  // Getters
  get className() {
    const navigationClass = this.navigation === CarouselNavigation.Outside ? styles$T.navigationOutside : null;
    const paginationClass = this.pagination === CarouselPagination.BottomOutside ? styles$T.paginationBottomOutside : null;
    return this.css(this.props.className, styles$T.carousel, navigationClass, paginationClass);
  }
  get initialSlideIndex() {
    return typeof this.props.initialSlideIndex === "number" ? this.props.initialSlideIndex : 0;
  }
  get loop() {
    return this.props.loop === true;
  }
  get navigation() {
    return Carousel.toNavigation(this.props.navigation);
  }
  get navigationOptions() {
    return this.navigation ? {
      nextEl: `#${this._navigationNextId}`,
      prevEl: `#${this._navigationPreviousId}`
    } : false;
  }
  get pagination() {
    return Carousel.toPagination(this.props.pagination);
  }
  get paginationOptions() {
    return this.pagination ? {
      clickable: true
    } : false;
  }
  get slidesPerView() {
    const slidesPerView = this.props.slidesPerView;
    return slidesPerView === "auto" || typeof slidesPerView === "number" && slidesPerView > 0 ? slidesPerView : 1;
  }
  get spaceBetweenSlides() {
    return typeof this.props.spaceBetweenSlides === "number" ? this.props.spaceBetweenSlides : 0;
  }
  get speed() {
    return typeof this.props.speed === "number" ? this.props.speed : 300;
  }
  get swiper() {
    return this.state.swiper;
  }
  // Sync-methods
  getSwiperSlideStyle(child) {
    // If slidesPerView has first been set to a number and then to "auto", the swiper-slide elements widths remain unchanged, and must be reset manually.
    var _a, _b;
    return this.slidesPerView === "auto" ? ((_b = (_a = child.props) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.width) ? {
      width: child.props.style.width
    } : {
      width: "auto"
    } : {};
  }
  // Async-methods
  onSwiperInitAsync(swiper) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        swiper
      });
      swiper.slideTo(this.initialSlideIndex, 0);
    });
  }
  // Public
  /**
   * Index of the currently active slide.
   */
  get currentSlideIndex() {
    return this.swiper.realIndex;
  }
  /**
   * Slide to a slide in the given index with the given speed.
   *
   * @param index Index of the slide to slide to.
   * @param speed Speed to slide with. Default is 300.
   */
  slideToAsync(index, speed = 300) {
    return __awaiter(this, void 0, void 0, function* () {
      this.swiper.slideTo(index, speed);
    });
  }
  /**
   * Run transition to previous slide.
   *
   * @param speed Transition duration (in ms). Default is 300.
   */
  slidePrevAsync(speed = 300) {
    return __awaiter(this, void 0, void 0, function* () {
      this.swiper.slidePrev(speed);
    });
  }
  /**
   * Run transition to next slide.
   *
   * @param speed Transition duration (in ms). Default is 300.
   */
  slideNextAsync(speed = 300) {
    return __awaiter(this, void 0, void 0, function* () {
      this.swiper.slideNext(speed);
    });
  }
  /**
   * Convert any value to a {@link CarouselNavigation} value.
   */
  static toNavigation(value) {
    switch (value) {
      case CarouselNavigation.Inside:
        return CarouselNavigation.Inside;
      case CarouselNavigation.Outside:
        return CarouselNavigation.Outside;
      default:
        return CarouselNavigation.None;
    }
  }
  /**
   * Convert any value to a {@link CarouselPagination} value.
   */
  static toPagination(value) {
    switch (value) {
      case CarouselPagination.BottomInside:
        return CarouselPagination.BottomInside;
      case CarouselPagination.BottomOutside:
        return CarouselPagination.BottomOutside;
      default:
        return CarouselPagination.None;
    }
  }
  // Renders
  render() {
    return React.createElement("div", {
      className: this.className,
      onClick: event => {
        var _a, _b;
        return (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
      }
    }, React.createElement(Swiper, {
      loop: this.loop,
      speed: this.speed,
      navigation: this.navigationOptions,
      pagination: this.paginationOptions,
      slidesPerView: this.slidesPerView,
      spaceBetween: this.spaceBetweenSlides,
      onInit: swiper => this.onSwiperInitAsync(swiper),
      onRealIndexChange: swiper => {
        var _a, _b;
        (_b = (_a = this.props).onSlideChange) === null || _b === void 0 ? void 0 : _b.call(_a, swiper.realIndex);
      }
    }, this.children.map((child, index) => {
      var _a, _b, _c;
      return React.createElement(SwiperSlide, {
        key: ((_c = (_b = (_a = child.key) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : "") + index,
        style: this.getSwiperSlideStyle(child)
      }, child);
    })), this.navigationOptions && React.createElement(React.Fragment, null, React.createElement("i", {
      id: this._navigationPreviousId,
      className: this.css("fa fa-angle-left fa-3x", styles$T.navigation, styles$T.previous)
    }), React.createElement("i", {
      id: this._navigationNextId,
      className: this.css("fa fa-angle-right fa-3x", styles$T.navigation, styles$T.next)
    })));
  }
}

var css_248z$_ = ".athenaeum-cookie-consent-cookieConsentBanner {\n  position: fixed;\n  left: 0;\n  z-index: 2147483645;\n  box-sizing: border-box;\n  width: 100%;\n  background-color: #F1F6F4;\n}\n\n.athenaeum-cookie-consent-top {\n  top: 0;\n}\n\n.athenaeum-cookie-consent-bottom {\n  bottom: 0;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerInner {\n  max-width: 960px;\n  margin: 0 24px auto;\n  padding: 32px 0;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerCopy {\n  margin-bottom: 16px;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerHeader {\n  margin-bottom: 8px;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerDescription {\n  font-weight: normal;\n  color: #838F93;\n  font-size: 16px;\n  line-height: 24px;\n}";
var styles$S = {"cookieConsentBanner":"athenaeum-cookie-consent-cookieConsentBanner","top":"athenaeum-cookie-consent-top","bottom":"athenaeum-cookie-consent-bottom","cookieConsentBannerInner":"athenaeum-cookie-consent-cookieConsentBannerInner","cookieConsentBannerCopy":"athenaeum-cookie-consent-cookieConsentBannerCopy","cookieConsentBannerHeader":"athenaeum-cookie-consent-cookieConsentBannerHeader","cookieConsentBannerDescription":"athenaeum-cookie-consent-cookieConsentBannerDescription"};
styleInject(css_248z$_);

/**
 * Position of a cookie-consent banner.
 */
var BannerPosition;
(function (BannerPosition) {
  /**
   * Banner is on the top of the window.
   */
  BannerPosition[BannerPosition["Top"] = 0] = "Top";
  /**
   * Banner is on the bottom of the window.
   */
  BannerPosition[BannerPosition["Bottom"] = 1] = "Bottom";
})(BannerPosition || (BannerPosition = {}));
/**
 * A cookie-consent banner.
 */
class CookieConsent extends BaseComponent {
  get bannerPosition() {
    var _a;
    return (_a = this.props.position) !== null && _a !== void 0 ? _a : BannerPosition.Top;
  }
  get cookieExpirationDate() {
    const propExpirationInDays = this.props.cookieExpirationInDays;
    if (typeof propExpirationInDays === "number" && propExpirationInDays > 0) {
      const expirationTimeInMilliseconds = propExpirationInDays * 24 * 60 * 60 * 1000;
      const expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + expirationTimeInMilliseconds);
      return expirationDate.toUTCString();
    }
    return CookieConsent.defaultExpirationDate;
  }
  get cookieName() {
    var _a;
    return (_a = this.props.cookieName) !== null && _a !== void 0 ? _a : CookieConsent.defaultCookieName;
  }
  saveCookieAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      document.cookie = this.cookieName + "=yes;expires=" + this.cookieExpirationDate + ";path=/";
      yield this.reRenderAsync();
    });
  }
  /**
   * Does the consent-cookie exist, meaning that the user has clicked "Accept cookies".
   */
  get cookieExists() {
    const cookieName = this.cookieName + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(cookieName) == 0) {
        return true;
      }
    }
    return false;
  }
  render() {
    const bannerStyle = this.bannerPosition === BannerPosition.Bottom ? styles$S.bottom : styles$S.top;
    return !this.cookieExists && React.createElement("div", {
      className: this.css(styles$S.cookieConsentBanner, bannerStyle)
    }, React.createElement("div", {
      className: styles$S.cookieConsentBannerInner
    }, React.createElement("div", {
      className: styles$S.cookieConsentBannerCopy
    }, React.createElement("div", {
      className: styles$S.cookieConsentBannerHeader
    }, this.toMultiLines(this.props.title)), this.props.description && React.createElement("div", {
      className: styles$S.cookieConsentBannerDescription
    }, this.toMultiLines(this.props.description))), React.createElement("div", null, React.createElement(Button, {
      label: this.props.acceptButtonText,
      type: ButtonType.Orange,
      onClick: () => this.saveCookieAsync()
    }))));
  }
}
/**
 * Default value of {@link ICookieConsentProps.cookieName}.
 */
CookieConsent.defaultCookieName = "consent";
/**
 * Default value of {@link ICookieConsentProps.cookieExpirationInDays}.
 */
CookieConsent.defaultExpirationDate = "Fri, 31 Dec 9999 23:59:59 GMT";

var css_248z$Z = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-message-box-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-message-box-messageBox {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1150;\n  display: none;\n}\n.athenaeum-message-box-messageBox.athenaeum-message-box-opened {\n  display: block;\n}\n.athenaeum-message-box-messageBox.athenaeum-message-box-processing {\n  cursor: wait;\n}\n.athenaeum-message-box-messageBox.athenaeum-message-box-processing textarea {\n  cursor: wait;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-overlay {\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  opacity: 0.5;\n  position: absolute;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content {\n  width: 300px;\n  background-color: white;\n  position: relative;\n  top: 40%;\n  margin: auto;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  border-radius: 6px;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption > i {\n  padding: 8px;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption > i.athenaeum-message-box-danger {\n  color: #a94442;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption > i.athenaeum-message-box-warning, .athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption > i.athenaeum-message-box-exclamation {\n  color: orange;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption > h5 {\n  white-space: normal;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-commentInput {\n  margin-bottom: 0.5rem;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-confirmActionPromptInput {\n  margin-bottom: 0.5rem;\n}";
var styles$R = {"font-renta":"athenaeum-message-box-font-renta","messageBox":"athenaeum-message-box-messageBox","opened":"athenaeum-message-box-opened","processing":"athenaeum-message-box-processing","overlay":"athenaeum-message-box-overlay","content":"athenaeum-message-box-content","caption":"athenaeum-message-box-caption","danger":"athenaeum-message-box-danger","warning":"athenaeum-message-box-warning","exclamation":"athenaeum-message-box-exclamation","commentInput":"athenaeum-message-box-commentInput","confirmActionPromptInput":"athenaeum-message-box-confirmActionPromptInput"};
styleInject(css_248z$Z);

class MessageBox extends BaseComponent {
  constructor() {
    super(...arguments);
    this._model = null;
    this.state = {
      isOpened: false,
      comment: "",
      confirmActionPromptWord: "",
      processing: false,
      model: null
    };
    this._commentRef = React.createRef();
    this._confirmActionPromptRef = React.createRef();
    this._resolver = null;
  }
  toModel(titleOrModel, caption, buttons, icon) {
    let model = {};
    let data = titleOrModel;
    if (data) {
      if (typeof data === "function") {
        data = data();
      }
      if (typeof data === "string") {
        model.title = data;
      } else {
        model = data;
      }
    }
    model.title = model.title || MessageBoxLocalizer$1.areYouSure;
    model.caption = caption || model.caption;
    model.icon = icon || model.icon;
    if (buttons) {
      if (typeof buttons === "object") {
        const initialized = !!buttons.okButton || !!buttons.cancelButton || !!buttons.abortButton || !!buttons.retryButton || !!buttons.ignoreButton || !!buttons.yesButton || !!buttons.noButton;
        if (initialized) {
          model.buttons = MessageBoxButtons.Custom;
          model.okButton = buttons.okButton;
          model.cancelButton = buttons.cancelButton;
          model.abortButton = buttons.abortButton;
          model.retryButton = buttons.retryButton;
          model.ignoreButton = buttons.ignoreButton;
          model.yesButton = buttons.yesButton;
          model.noButton = buttons.noButton;
        }
      } else {
        model.buttons = buttons;
      }
    }
    return model;
  }
  getButtonLabel(button, defaultLabel) {
    return button && typeof button === "string" ? button : MessageBoxLocalizer$1.get(defaultLabel);
  }
  getIconName(icon) {
    if (icon) {
      if (typeof icon === "string") {
        return icon;
      }
      switch (icon) {
        case MessageBoxIcon.Hand:
          return "far hand-paper";
        case MessageBoxIcon.Stop:
          return "far stop-circle";
        case MessageBoxIcon.Error:
          return "far times-circle";
        case MessageBoxIcon.Question:
          return "question";
        case MessageBoxIcon.Exclamation:
          return "exclamation-triangle";
        case MessageBoxIcon.Warning:
          return "exclamation";
        case MessageBoxIcon.Asterisk:
          return "asterisk";
        case MessageBoxIcon.Information:
          return "information";
      }
    }
    return null;
  }
  getIconClassName(icon) {
    switch (icon) {
      case MessageBoxIcon.Error:
        return styles$R.danger;
      case MessageBoxIcon.Warning:
        return styles$R.warning;
      case MessageBoxIcon.Exclamation:
        return styles$R.exclamation;
    }
    return null;
  }
  get model() {
    var _a;
    return (_a = this._model) !== null && _a !== void 0 ? _a : this._model = this.toModel(this.props.title);
  }
  get buttons() {
    var _a;
    return (_a = this.model.buttons) !== null && _a !== void 0 ? _a : MessageBoxButtons.OK;
  }
  get hasOkButton() {
    return !!this.model.okButton || this.buttons == MessageBoxButtons.OK || this.buttons == MessageBoxButtons.OKCancel;
  }
  get hasCancelButton() {
    return !!this.model.cancelButton || this.buttons == MessageBoxButtons.OKCancel || this.buttons == MessageBoxButtons.YesNoCancel || this.buttons == MessageBoxButtons.RetryCancel;
  }
  get hasYesButton() {
    return !!this.model.yesButton || this.buttons == MessageBoxButtons.YesNo || this.buttons == MessageBoxButtons.YesNoCancel;
  }
  get hasNoButton() {
    return !!this.model.noButton || this.buttons == MessageBoxButtons.YesNo || this.buttons == MessageBoxButtons.YesNoCancel;
  }
  get hasAbortButton() {
    return !!this.model.abortButton || this.buttons == MessageBoxButtons.AbortRetryIgnore;
  }
  get hasRetryButton() {
    return !!this.model.retryButton || this.buttons == MessageBoxButtons.AbortRetryIgnore || this.buttons == MessageBoxButtons.RetryCancel;
  }
  get hasIgnoreButton() {
    return !!this.model.ignoreButton || this.buttons == MessageBoxButtons.AbortRetryIgnore;
  }
  get hasComment() {
    return this.state.isOpened ? !!this.model.comment : false;
  }
  get hasConfirmActionPrompt() {
    return this.state.isOpened ? !!this.model.confirmActionPrompt && !!this.model.confirmActionPromptWord : false;
  }
  get minLength() {
    return this.state.isOpened ? this.props.minLength || this.model.minLength || 0 : 0;
  }
  get canAccept() {
    var _a;
    const canAcceptComment = this.hasConfirmActionPrompt || !this.hasComment || this.state.comment.length > this.minLength;
    const canAcceptConfirmActionPrompt = !this.hasConfirmActionPrompt || ((_a = this.model.confirmActionPromptWord) === null || _a === void 0 ? void 0 : _a.length) == 0 || this.state.confirmActionPromptWord == this.model.confirmActionPromptWord;
    return canAcceptComment && canAcceptConfirmActionPrompt;
  }
  get processing() {
    return this.state.processing;
  }
  setCommentAsync(comment) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        comment
      });
    });
  }
  setConfirmActionPromptWordAsync(confirmActionPromptWord) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        confirmActionPromptWord
      });
    });
  }
  setDialogAsync(isOpened, nestedCheck = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.state.isOpened != isOpened) {
        if (nestedCheck) {
          if (isOpened && MessageBox._current) {
            yield MessageBox._current.setDialogAsync(false, false);
            MessageBox._previous = MessageBox._current;
          }
        }
        yield this.setState({
          isOpened
        });
        if (nestedCheck) {
          MessageBox._current = isOpened ? this : null;
          if (!isOpened && MessageBox._previous) {
            yield MessageBox._previous.setDialogAsync(true, false);
            MessageBox._previous = null;
          }
        }
      }
    });
  }
  setProcessingAsync(processing) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.setState({
          processing
        });
      }
    });
  }
  invokeCloseAsync(dialogResult) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.callback) {
        if (!this.processing) {
          try {
            yield this.setProcessingAsync(true);
            yield this.props.callback(this, dialogResult, this.state.comment);
          } finally {
            yield this.setProcessingAsync(false);
          }
        }
      }
      if (this._resolver) {
        this._resolver(dialogResult);
        this._resolver = null;
      }
      yield this.setDialogAsync(false);
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpened) {
        yield this.invokeCloseAsync(DialogResult.None);
      } else {
        yield this.openAsync();
      }
    });
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setDialogAsync(true);
      if (this._commentRef.current) {
        this._commentRef.current.focus();
      }
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeCloseAsync(DialogResult.None);
    });
  }
  showAsync(titleOrModel, caption, buttons, icon) {
    return __awaiter(this, void 0, void 0, function* () {
      this._model = this.toModel(titleOrModel, caption, buttons, icon);
      yield this.openAsync();
      return new Promise(resolve => {
        this._resolver = resolve;
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const targetNode = e.target;
      const outside = Utility.clickedOutside(targetNode, `messageBox-content-${this.id}`);
      if (outside) {
        yield this.invokeCloseAsync(DialogResult.None);
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasComment && !this.hasConfirmActionPrompt) {
        yield this.invokeCloseAsync(DialogResult.None);
      } else {
        if (e.keyCode === 27) {
          yield this.invokeCloseAsync(DialogResult.None);
        }
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newProps = this.props.title != nextProps.title || this.props.minLength != nextProps.minLength;
      if (newProps) {
        this._model = null;
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  renderDialog() {
    const openedStyle = this.state.isOpened && styles$R.opened;
    const processingStyle = this.processing && styles$R.processing;
    const icon = this.getIconName(this.model.icon);
    const iconStyle = this.getIconClassName(this.model.icon);
    return React.createElement("div", {
      id: "messageBox-" + this.id,
      className: this.css(styles$R.messageBox, openedStyle, processingStyle)
    }, React.createElement("div", {
      className: styles$R.overlay
    }), React.createElement("div", {
      className: styles$R.content,
      id: `messageBox-content-${this.id}`
    }, React.createElement("div", {
      className: styles$R.caption
    }, icon && React.createElement(Icon, {
      name: icon,
      className: iconStyle || undefined,
      size: IconSize.X3
    }), React.createElement("h5", null, this.toMultiLines(this.model.title))), this.hasComment && React.createElement(TextAreaInput, {
      ref: this._commentRef,
      required: true,
      noValidate: true,
      rows: 3,
      placeholder: this.model.placeholder || MessageBoxLocalizer$1.comment,
      className: styles$R.commentInput,
      value: this.state.comment,
      readonly: this.processing,
      onChange: (sender, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.setCommentAsync(value);
      })
    }), this.hasConfirmActionPrompt && React.createElement(TextInput, {
      ref: this._confirmActionPromptRef,
      label: MessageBoxLocalizer$1.typeConfirmationWord.format(this.model.confirmActionPromptWord),
      placeholder: this.model.confirmActionPromptWord,
      className: styles$R.confirmActionPromptInput,
      value: this.state.confirmActionPromptWord,
      readonly: this.processing,
      onChange: (sender, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.setConfirmActionPromptWordAsync(value);
      })
    }), this.hasOkButton && React.createElement(Button, {
      block: true,
      id: "message-box-ok" + this.id,
      label: this.getButtonLabel(this.model.okButton, MessageBoxLocalizer$1.okLanguageItemName),
      type: ButtonType.Orange,
      disabled: this.processing || !this.canAccept,
      onClick: () => this.invokeCloseAsync(DialogResult.OK)
    }), this.hasYesButton && React.createElement(Button, {
      block: true,
      id: "message-box-yes" + this.id,
      label: this.getButtonLabel(this.model.yesButton, MessageBoxLocalizer$1.yesLanguageItemName),
      type: ButtonType.Orange,
      disabled: this.processing || !this.canAccept,
      onClick: () => this.invokeCloseAsync(DialogResult.Yes)
    }), this.hasAbortButton && React.createElement(Button, {
      block: true,
      id: "message-box-abort" + this.id,
      label: this.getButtonLabel(this.model.abortButton, MessageBoxLocalizer$1.abortLanguageItemName),
      type: ButtonType.Orange,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync(DialogResult.Abort)
    }), this.hasRetryButton && React.createElement(Button, {
      block: true,
      id: "message-box-retry" + this.id,
      label: this.getButtonLabel(this.model.retryButton, MessageBoxLocalizer$1.retryLanguageItemName),
      type: ButtonType.Orange,
      disabled: this.processing || !this.canAccept,
      onClick: () => this.invokeCloseAsync(DialogResult.Retry)
    }), this.hasIgnoreButton && React.createElement(Button, {
      block: true,
      id: "message-box-ignore" + this.id,
      label: this.getButtonLabel(this.model.ignoreButton, MessageBoxLocalizer$1.ignoreLanguageItemName),
      type: ButtonType.Blue,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync(DialogResult.Ignore)
    }), this.hasNoButton && React.createElement(Button, {
      block: true,
      id: "message-box-no" + this.id,
      label: this.getButtonLabel(this.model.noButton, MessageBoxLocalizer$1.noLanguageItemName),
      type: ButtonType.Blue,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync(DialogResult.No)
    }), this.hasCancelButton && React.createElement(Button, {
      block: true,
      id: "message-box-cancel" + this.id,
      label: this.getButtonLabel(this.model.cancelButton, MessageBoxLocalizer$1.cancelLanguageItemName),
      type: ButtonType.Default,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync(DialogResult.Cancel)
    })));
  }
  render() {
    return ReactDOM.createPortal(this.renderDialog(), document.body);
  }
}
MessageBox._current = null;
MessageBox._previous = null;

var css_248z$Y = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-popover-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-popover-popover {\n  position: relative;\n  display: none;\n}\n.athenaeum-popover-popover.athenaeum-popover-centered {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: 500px;\n}\n.athenaeum-popover-popover.athenaeum-popover-open {\n  display: block;\n}\n.athenaeum-popover-popover .athenaeum-popover-content {\n  position: absolute;\n  min-width: 200px;\n  background-color: white;\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  padding: 8px;\n  z-index: 1000;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-left {\n  right: 0;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-right {\n  left: 0;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-top {\n  bottom: 26px;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-bottom {\n  top: 0px;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-centered {\n  width: 500px;\n  margin: auto;\n  top: 50%;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-controls {\n  padding: 0.5rem;\n}";
var styles$Q = {"font-renta":"athenaeum-popover-font-renta","popover":"athenaeum-popover-popover","centered":"athenaeum-popover-centered","open":"athenaeum-popover-open","content":"athenaeum-popover-content","left":"athenaeum-popover-left","right":"athenaeum-popover-right","top":"athenaeum-popover-top","bottom":"athenaeum-popover-bottom","controls":"athenaeum-popover-controls"};
styleInject(css_248z$Y);

class Popover extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false,
      containerId: null
    };
  }
  toggleAsync(containerId = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (containerId) {
        const state = this.state;
        state.containerId = containerId;
      }
      if (this.state.isOpen) {
        yield this.closeAsync();
      } else {
        yield this.openAsync();
      }
    });
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: true
      });
      if (this.props.onToggle) {
        yield this.props.onToggle(this, true);
      }
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
      if (this.props.onToggle) {
        yield this.props.onToggle(this, false);
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const targetNode = e.target;
      const outside = Utility.clickedOutside(targetNode, this.id, this.state.containerId, "span");
      if (outside) {
        yield this.closeAsync();
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e.keyCode === 27) {
        yield this.closeAsync();
      }
    });
  }
  get positionStyles() {
    let positionStyles = "";
    if (this.props.align === Align.Top) {
      positionStyles += `${styles$Q.top}`;
    } else {
      positionStyles += `${styles$Q.bottom}`;
    }
    if (this.props.justify === Justify.Right) {
      positionStyles += ` ${styles$Q.right}`;
    } else {
      positionStyles += ` ${styles$Q.left}`;
    }
    if (this.props.center) {
      positionStyles += ` ${styles$Q.centered}`;
    }
    return positionStyles;
  }
  renderPopover() {
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$Q.popover, this.state.isOpen && styles$Q.open, this.props.center && styles$Q.centered, this.props.className)
    }, React.createElement("div", {
      className: this.css(styles$Q.content, this.positionStyles, this.props.controls && styles$Q.controls)
    }, this.props.children));
  }
  get isOpen() {
    return this.state.isOpen;
  }
  render() {
    if (this.state.isOpen) {
      const containerElement = this.state.containerId ? document.getElementById(this.state.containerId) : null;
      if (containerElement) {
        return ReactDOM.createPortal(this.renderPopover(), containerElement);
      }
    }
    return null;
  }
}
Popover.defaultProps = {
  align: Align.Bottom,
  justify: Justify.Left
};

var css_248z$X = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-spinner-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-spinner-spinner {\n  cursor: wait;\n  display: flex;\n  justify-content: center;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-overlay {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: black;\n  opacity: 0;\n  z-index: 1000;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-overlay.athenaeum-spinner-local {\n  z-index: 100;\n  position: absolute;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-container .athenaeum-spinner-background {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  border: 2px solid white;\n  border-radius: 50%;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-container .athenaeum-spinner-circle {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  border: 2px solid rgb(254, 80, 0);\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: athenaeum-spinner-spin 4s infinite linear;\n}\n@keyframes athenaeum-spinner-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}";
var styles$P = {"font-renta":"athenaeum-spinner-font-renta","spinner":"athenaeum-spinner-spinner","overlay":"athenaeum-spinner-overlay","local":"athenaeum-spinner-local","container":"athenaeum-spinner-container","background":"athenaeum-spinner-background","circle":"athenaeum-spinner-circle","spin":"athenaeum-spinner-spin"};
styleInject(css_248z$X);

const SPINNER_CURSOR_DELAY = 150;
const SPINNER_BACKGROUND_DELAY = 1000;
class Spinner extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      showCursor: false,
      showSpinner: false
    };
  }
  get noDelay() {
    return this.props.noDelay === true;
  }
  get opacity() {
    return this.props.noShading ? 0.00 : this.props.global ? 0.30 : 0.15;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      yield this.showSpinnerDelayAsync();
    });
  }
  showSpinnerDelayAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.wait(SPINNER_CURSOR_DELAY);
      if (this.isMounted) {
        if (this.noDelay) {
          yield this.setState({
            showCursor: true,
            showSpinner: true
          });
          if (this.props.onDelay) {
            yield this.props.onDelay();
          }
        } else {
          yield this.setState({
            showCursor: true
          });
          yield Utility.wait(SPINNER_BACKGROUND_DELAY);
          if (this.isMounted) {
            yield this.setState({
              showSpinner: true
            });
            if (this.props.onDelay) {
              yield this.props.onDelay();
            }
          }
        }
      }
    });
  }
  render() {
    if (this.state.showCursor) {
      const localStyle = !this.props.global && styles$P.local;
      const overlayStyle = {};
      const containerStyle = {};
      if (this.state.showSpinner) {
        overlayStyle.opacity = this.opacity;
        containerStyle.display = "flex";
      }
      return React.createElement("div", {
        className: styles$P.spinner
      }, React.createElement("div", {
        className: this.css(styles$P.overlay, localStyle),
        style: overlayStyle
      }), React.createElement("div", {
        className: styles$P.container,
        style: containerStyle
      }, React.createElement("span", {
        className: styles$P.background
      }), React.createElement("span", {
        className: styles$P.circle
      })));
    }
    return React.createElement(React.Fragment, null);
  }
}

var css_248z$W = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-document-preview-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-document-preview-documentPreview .athenaeum-document-preview-contentA4 {\n  background-color: #525659;\n  width: 35rem;\n  height: 52rem;\n}\n.athenaeum-document-preview-documentPreview iframe {\n  border: none;\n}";
var styles$O = {"font-renta":"athenaeum-document-preview-font-renta","documentPreview":"athenaeum-document-preview-documentPreview","contentA4":"athenaeum-document-preview-contentA4"};
styleInject(css_248z$W);

class DocumentPreview extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isLoading: false,
      data: null,
      documentId: this.props.documentId || ""
    };
    this._popoverRef = React.createRef();
  }
  onToggleAsync(isOpen) {
    return __awaiter(this, void 0, void 0, function* () {
      if (isOpen) {
        yield this.reloadAsync();
      } else {
        yield this.setState({
          data: null
        });
      }
    });
  }
  getEndpoint() {
    return this.props.endpoint || "";
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const endpoint = this.getEndpoint();
      const documentId = this.state.documentId;
      return yield this.postAsync(endpoint, documentId);
    });
  }
  toggleAsync(sender, documentId = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (documentId) {
        yield this.setState({
          documentId
        });
      }
      yield this._popoverRef.current.toggleAsync(sender.id);
    });
  }
  get isOpen() {
    return !!this._popoverRef.current && this._popoverRef.current.isOpen;
  }
  canReload() {
    return this.isOpen;
  }
  hasSpinner() {
    return true;
  }
  render() {
    return React.createElement(Popover, {
      ref: this._popoverRef,
      className: styles$O.documentPreview,
      onToggle: (sender, isOpen) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onToggleAsync(isOpen);
      }),
      justify: Justify.Right
    }, React.createElement("div", {
      className: styles$O.contentA4
    }, this.state.data && React.createElement("iframe", {
      src: this.state.data.src,
      width: "560",
      height: "832"
    }), this.isSpinning() && React.createElement(Spinner, {
      noShading: true
    })));
  }
}

//Autogenerated
class ModalLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.saveChangesLanguageItemName = `_3:0`;
    this.closeLanguageItemName = `_3:1`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_3:0`, {
      l: `en`,
      v: `Save changes`
    }, {
      l: `uk`,
      v: `Зберегти зміни`
    }, {
      l: `sv`,
      v: `Spara ändringar`
    }, {
      l: `ru`,
      v: `Сохранить изменения`
    }, {
      l: `pl`,
      v: `Zachowaj zmiany`
    }, {
      l: `nl`,
      v: `Wijzigingen opslaan`
    }, {
      l: `nb`,
      v: `Lagre endringer`
    }, {
      l: `it`,
      v: `Salvare le modifiche`
    }, {
      l: `fr`,
      v: `Sauvegarder les modifications`
    }, {
      l: `fi`,
      v: `Tallenna muutokset`
    }, {
      l: `es`,
      v: `Guardar cambios`
    }, {
      l: `de`,
      v: `Änderungen speichern`
    }, {
      l: `da`,
      v: `Gem ændringer`
    });
    this.set(`_3:1`, {
      l: `en`,
      v: `Close`
    }, {
      l: `uk`,
      v: `Закрити`
    }, {
      l: `sv`,
      v: `Stäng`
    }, {
      l: `ru`,
      v: `Закрыть`
    }, {
      l: `pl`,
      v: `Zamknij`
    }, {
      l: `nl`,
      v: `Dichtbij`
    }, {
      l: `nb`,
      v: `Lukke`
    }, {
      l: `it`,
      v: `Vicino`
    }, {
      l: `fr`,
      v: `Fermer`
    }, {
      l: `fi`,
      v: `Sulje`
    }, {
      l: `es`,
      v: `Cerca`
    }, {
      l: `de`,
      v: `Schließen`
    }, {
      l: `da`,
      v: `Luk`
    });
  }
  /**
  /* "SaveChanges" (Save changes)
  /* "Localizer.saveChanges"
  /* "Localizer.saveChangesLanguageItemName"
  */
  get saveChanges() {
    return this.get(`_3:0`);
  }
  /**
  /* "Close" (Close)
  /* "Localizer.close"
  /* "Localizer.closeLanguageItemName"
  */
  get close() {
    return this.get(`_3:1`);
  }
}
//Singleton
var ModalLocalizer$1 = new ModalLocalizer();

var css_248z$V = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.modal .modal-dialog {\n  margin: 1.75rem auto !important;\n}\n.modal .modal-dialog .modal-content .modal-header {\n  padding: 1rem;\n  border-bottom: none;\n  align-items: center;\n  cursor: default;\n}\n.modal .modal-dialog .modal-content .modal-header .modal-header-content {\n  min-height: 54px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.modal .modal-dialog .modal-content .modal-header .toolbar > i {\n  width: 52px;\n  padding: 0.5rem 0;\n  text-align: center;\n  color: white;\n  border-radius: 2px;\n  cursor: pointer;\n  background-color: #337ab7;\n}\n.modal .modal-dialog .modal-content .modal-header .toolbar > i:not(:first-child) {\n  margin-left: 8px;\n}\n.modal .modal-dialog .modal-content .modal-header .toolbar .dismiss {\n  background-color: rgb(254, 80, 0);\n}\n.modal .modal-dialog .modal-content .modal-header .mobile-toolbar > i:not(:first-child) {\n  margin-left: 8px;\n}\n.modal .modal-dialog .modal-content .modal-body {\n  padding-top: 0;\n}\n.modal .modal-dialog .modal-content .modal-body .textFormatting {\n  white-space: pre-wrap;\n  text-align: justify;\n}\n.modal .modal-dialog .default-maxWidth {\n  max-width: 475px;\n}\n.modal .modal-dialog.modal-auto {\n  margin: auto !important;\n  max-width: fit-content;\n}\n.modal .modal-dialog.modal-auto:before {\n  height: auto;\n}\n.modal .modal-dialog.mobile {\n  margin: 45px 0 0 0 !important;\n  max-width: 100%;\n  top: 100vh;\n  display: block !important;\n}\n.modal .modal-dialog.mobile:before {\n  height: auto;\n}\n.modal .modal-dialog.mobile .modal-content {\n  min-height: calc(100vh - 45px);\n  border-radius: 0;\n  border: 0;\n}\n.modal .modal-dialog.mobile.animation {\n  transition: top 0.15s ease-in-out;\n}\n\n.modal-open.mobile {\n  padding-right: 0 !important;\n}\n.modal-open.mobile .modal-backdrop.show {\n  opacity: 0;\n}\n.modal-open.mobile .modal.show .modal-dialog {\n  top: 0;\n}\n\n.modal-dialog-centered.modal-auto {\n  min-height: 100%;\n}\n.modal-dialog-centered.modal-auto:before {\n  height: auto;\n}";
styleInject(css_248z$V);

var ModalSize;
(function (ModalSize) {
  ModalSize[ModalSize["Default"] = 0] = "Default";
  ModalSize[ModalSize["Small"] = 1] = "Small";
  ModalSize[ModalSize["Large"] = 2] = "Large";
  ModalSize[ModalSize["ExtraLarge"] = 3] = "ExtraLarge";
  /*
   * Modal will resize according to content size
   */
  ModalSize[ModalSize["Auto"] = 4] = "Auto";
})(ModalSize || (ModalSize = {}));
class Modal extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false,
      data: null,
      isLoading: false,
      openInstance: null
    };
    this._closeConfirmDialogRef = React.createRef();
    this._animation = true;
    this._modalRef = React.createRef();
    this._modalBodyRef = React.createRef();
    this._data = null;
    this._scrollY = 0;
    this._confirmed = false;
  }
  resolveCloseConfirm() {
    return this.props.closeConfirm ? typeof this.props.closeConfirm === "function" ? this.props.closeConfirm() : typeof this.props.closeConfirm === "boolean" ? "" : this.props.closeConfirm : null;
  }
  //  Getters
  get title() {
    return this.props.title || "...";
  }
  get subtitle() {
    return this.props.subtitle || "";
  }
  get content() {
    return this.props.content || "";
  }
  get modal() {
    return this._modalRef.current;
  }
  get scrollY() {
    return this._scrollY;
  }
  get sizeStyle() {
    if (this.fullWindow) {
      return this._animation ? "mobile" : "mobile animation";
    }
    switch (this.props.size) {
      case ModalSize.Small:
        return "modal-sm";
      case ModalSize.Large:
        return "modal-lg";
      case ModalSize.ExtraLarge:
        return "modal-xl";
      case ModalSize.Auto:
        return "modal-auto";
      default:
        return "default-maxWidth";
    }
  }
  get data() {
    return this._data;
  }
  get isOpen() {
    return this.state.isOpen;
  }
  get isInfo() {
    return this.props.info || false;
  }
  get notResponsive() {
    return this.props.notResponsive == true;
  }
  /**
   * The modal takes the full size of the window (if mobile is true and responsive is true)
   */
  get fullWindow() {
    return !this.notResponsive && this.mobile;
  }
  get noHeader() {
    return this.props.noHeader === true;
  }
  get preventEsc() {
    return this.props.preventEsc === true;
  }
  getBodyNode() {
    return this.JQuery(`#${this.id}_body`);
  }
  get body() {
    return this._modalBodyRef.current;
  }
  //  ViewMethodCalls
  onModalBodyClick(e) {
    if (!this.isInfo) {
      return;
    }
    e.stopPropagation();
    this.closeModal();
  }
  //  Logics
  togglePageScroll(toggle) {
    if (this.fullWindow) {
      return;
    }
    if (toggle) {
      this.JQuery("html").addClass("prevent-scroll");
      return;
    }
    this.JQuery("html").removeClass("prevent-scroll");
  }
  setData(data = null) {
    if (data) {
      this._data = data;
    }
  }
  confirmNeededAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const confirmNeeded = !this._confirmed && this.resolveCloseConfirm() != null;
      if (confirmNeeded && this._closeConfirmDialogRef.current) {
        yield this._closeConfirmDialogRef.current.openAsync();
        return true;
      }
      return false;
    });
  }
  onOpenHandlerAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      this.togglePageScroll(true);
      const data = this.JQuery(event.relatedTarget).data("modal");
      if (data !== null && data !== undefined) {
        this.setData(this.transformData(data));
      }
      if (this.fullWindow) {
        this.JQuery("body").addClass("mobile");
      }
      yield this.setModalToOpenAsync();
    });
  }
  onCloseHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (yield this.confirmNeededAsync()) {
        this.openModal(false);
        return;
      }
      this.togglePageScroll(false);
      if (this.fullWindow) {
        this.JQuery("body").removeClass("mobile");
      }
      yield this.setModalToCloseAsync();
      this.scrollBack();
    });
  }
  onCloseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (yield this.confirmNeededAsync()) {
        return;
      }
      yield this.setModalToCloseAsync();
    });
  }
  scrollBack() {
    window.scrollTo(0, this.scrollY);
  }
  getEndpoint() {
    return "";
  }
  transformData(data) {
    if (!this.props.transform) {
      return data;
    }
    return this.props.transform(data);
  }
  hasSpinner() {
    return true;
  }
  setModalToOpenAsync(animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpen) {
        return;
      }
      this._confirmed = false;
      yield this.onPropBeforeOpen();
      const openInstance = this.state.openInstance || Modal._openInstance;
      yield this.setState({
        isOpen: true,
        openInstance
      });
      this.openModal(animation);
      yield this.onPropOpen();
      if (openInstance) {
        yield openInstance.closeAsync();
      }
      yield this.onPropToggle(true);
    });
  }
  setModalToCloseAsync(data = "") {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.isOpen) {
        return;
      }
      this._confirmed = true;
      yield this.onPropBeforeClose();
      const openInstance = this.state.openInstance;
      yield this.setState({
        isOpen: false,
        openInstance
      });
      this.closeModal();
      yield this.onPropCloseAsync(data);
      if (openInstance && Modal._openInstance == null) {
        yield openInstance.openAsync();
        yield this.setState({
          openInstance: null
        });
      }
      yield this.onPropToggle(false);
    });
  }
  openModal(animation = true) {
    if (!this.modal) {
      return;
    }
    this._animation = animation;
    this.showBootstrapModal();
    Modal._openInstance = this;
  }
  closeModal() {
    if (!this.modal) {
      return;
    }
    this.hideBootstrapModal();
    if (Modal._openInstance === this) {
      Modal._openInstance = null;
    }
  }
  //  LifeCycleHooks
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      this.enableBootstrapEventHandlers();
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this.closeModal();
      yield _super.componentWillUnmount.call(this);
      this.disableBootstrapEventHandlers();
    });
  }
  //  Bootstrap Methods
  enableBootstrapEventHandlers() {
    if (!this.modal) {
      return;
    }
    const node = this.JQuery(this.modal);
    node.on("shown.bs.modal", event => __awaiter(this, void 0, void 0, function* () {
      return yield this.onOpenHandlerAsync(event);
    }));
    node.on("hide.bs.modal", () => __awaiter(this, void 0, void 0, function* () {
      return yield this.onCloseHandlerAsync();
    }));
  }
  disableBootstrapEventHandlers() {
    if (!this.modal) {
      return;
    }
    const node = this.JQuery(this.modal);
    node.off("shown.bs.modal");
    node.off("hide.bs.modal");
  }
  showBootstrapModal() {
    if (!this.modal) {
      return;
    }
    const modal = this.JQuery(this.modal);
    if (modal && typeof modal.modal === "function") {
      modal.modal("show");
    }
  }
  hideBootstrapModal() {
    if (!this.modal) {
      return;
    }
    const modal = this.JQuery(this.modal);
    if (modal && typeof modal.modal === "function") {
      modal.modal("hide");
    }
  }
  //  PropsMethodCallHelpers
  onPropBeforeOpen() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onBeforeOpen) {
        yield this.props.onBeforeOpen(this);
      }
    });
  }
  onPropBeforeClose() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onBeforeClose) {
        yield this.props.onBeforeClose(this);
      }
    });
  }
  onPropOpen() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onOpen) {
        yield this.props.onOpen(this);
      }
    });
  }
  onPropCloseAsync(data = "") {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClose) {
        yield this.props.onClose(this, data);
      }
    });
  }
  onPropToggle(isOpen) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onToggle) {
        yield this.props.onToggle(this, isOpen);
      }
    });
  }
  //  Interface
  openAsync(data = null, animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      this._scrollY = window.scrollY;
      this.setData(data);
      yield this.setModalToOpenAsync(animation);
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (yield this.confirmNeededAsync()) {
        return;
      }
      yield this.setModalToCloseAsync();
    });
  }
  toggleAsync(data = null, animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpen) {
        yield this.closeAsync();
        return;
      }
      yield this.openAsync(data, animation);
    });
  }
  //  Renders
  renderToolbar() {
    return this.props.toolbar ? this.props.toolbar(this) : null;
  }
  renderModal() {
    const modalContentStyle = this.props.size === ModalSize.Auto && "w-auto";
    const infoContentStyle = this.props.keepTextFormatting && "textFormatting";
    const centeredStyle = !this.fullWindow && "modal-dialog-centered";
    const toolbarStyle = this.fullWindow ? "mobile-toolbar" : "toolbar";
    const closeConfirm = this.resolveCloseConfirm();
    return React.createElement("div", {
      id: this.id,
      ref: this._modalRef,
      tabIndex: !this.preventEsc ? -1 : undefined,
      role: "dialog",
      className: this.css("modal", this.props.className)
    }, React.createElement("div", {
      className: this.css("modal-dialog", centeredStyle, this.sizeStyle),
      role: "document"
    }, React.createElement("div", {
      className: this.css("modal-content", modalContentStyle, this.props.contentClassName)
    }, !this.noHeader && React.createElement("div", {
      className: "modal-header"
    }, React.createElement("div", {
      className: "modal-header-content"
    }, React.createElement("h5", {
      className: "modal-title"
    }, this.toMultiLines(this.title)), React.createElement("h6", {
      className: "modal-title"
    }, this.toMultiLines(this.subtitle))), React.createElement("div", {
      className: toolbarStyle
    }, this.renderToolbar(), React.createElement(Icon, {
      name: this.fullWindow ? this.props.mobileIcon || "chevron-down" : "times",
      style: !this.props.mobileIcon ? IconStyle.Regular : null,
      className: this.fullWindow ? "" : "dismiss",
      size: IconSize.X2,
      onClick: () => this.onCloseAsync()
    }))), React.createElement("div", {
      id: `${this.id}_body`,
      ref: this._modalBodyRef,
      className: this.css("modal-body", this.props.bodyClassName),
      onClick: e => this.onModalBodyClick(e)
    }, !this.props.children && React.createElement("p", {
      className: infoContentStyle
    }, this.toMultiLines(this.content)), this.props.children),
    // If the Modal will receive children (most likely Form) instead of text content(this.props.content)
    // Modal footer does not need to be displayed therefore Form will contain it's own control buttons
    !this.isInfo && !this.props.children && React.createElement("div", {
      className: "modal-footer"
    }, React.createElement(Button, {
      submit: true,
      label: ModalLocalizer$1.saveChanges,
      type: ButtonType.Orange
    }), React.createElement(Button, {
      label: ModalLocalizer$1.close,
      type: ButtonType.Default,
      onClick: () => this.onCloseAsync()
    })), this.isSpinning() && React.createElement(Spinner, null), closeConfirm != null && React.createElement(ConfirmationDialog, {
      ref: this._closeConfirmDialogRef,
      title: closeConfirm,
      callback: (caller, data) => this.setModalToCloseAsync(data)
    }))));
  }
  // This needs improvement in next version
  // Needed for correctly applying blur effect without moving modals outside of Layout manually
  render() {
    return ReactDOM.createPortal(this.renderModal(), document.body);
  }
}
Modal._openInstance = null;

//Autogenerated
class DocumentPreviewModalLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.previewLanguageItemName = `_A:0`;
    this.downloadLanguageItemName = `_A:1`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_A:0`, {
      l: `en`,
      v: `Preview`
    }, {
      l: `uk`,
      v: `Переглянути`
    }, {
      l: `sv`,
      v: `Förhandsvisning`
    }, {
      l: `ru`,
      v: `Предпросмотр`
    }, {
      l: `pl`,
      v: `Podgląd`
    }, {
      l: `nl`,
      v: `Voorbeeld`
    }, {
      l: `nb`,
      v: `Forhåndsvisning`
    }, {
      l: `it`,
      v: `Anteprima`
    }, {
      l: `fr`,
      v: `Aperçu`
    }, {
      l: `fi`,
      v: `Esikatselu`
    }, {
      l: `es`,
      v: `Avance`
    }, {
      l: `de`,
      v: `Vorschau`
    }, {
      l: `da`,
      v: `Eksempel`
    });
    this.set(`_A:1`, {
      l: `en`,
      v: `Download`
    }, {
      l: `uk`,
      v: `Завантажити`
    }, {
      l: `sv`,
      v: `Ladda ner`
    }, {
      l: `ru`,
      v: `Загрузить`
    }, {
      l: `pl`,
      v: `Pobierz`
    }, {
      l: `nl`,
      v: `Downloaden`
    }, {
      l: `nb`,
      v: `Last ned`
    }, {
      l: `it`,
      v: `Scaricamento`
    }, {
      l: `fr`,
      v: `Télécharger`
    }, {
      l: `fi`,
      v: `Lataa`
    }, {
      l: `es`,
      v: `Descargar`
    }, {
      l: `de`,
      v: `Herunterladen`
    }, {
      l: `da`,
      v: `Download`
    });
  }
  /**
  /* "Preview" (Preview)
  /* "Localizer.preview"
  /* "Localizer.previewLanguageItemName"
  */
  get preview() {
    return this.get(`_A:0`);
  }
  /**
  /* "Download" (Download)
  /* "Localizer.download"
  /* "Localizer.downloadLanguageItemName"
  */
  get download() {
    return this.get(`_A:1`);
  }
}
//Singleton
var DocumentPreviewModalLocalizer$1 = new DocumentPreviewModalLocalizer();

var css_248z$U = ".athenaeum-document-preview-modal-documentPreviewModal > div .athenaeum-document-preview-modal-body {\n  display: flex;\n}\n.athenaeum-document-preview-modal-documentPreviewModal > div .athenaeum-document-preview-modal-body .athenaeum-document-preview-modal-contentA4 {\n  background-color: #525659;\n  margin: auto;\n}\n.athenaeum-document-preview-modal-documentPreviewModal > div .athenaeum-document-preview-modal-body iframe {\n  border: none;\n  overflow: hidden;\n}";
var styles$N = {"documentPreviewModal":"athenaeum-document-preview-modal-documentPreviewModal","body":"athenaeum-document-preview-modal-body","contentA4":"athenaeum-document-preview-modal-contentA4"};
styleInject(css_248z$U);

const A4 = {
  width: 595,
  height: 842
};
class DocumentSize {
  constructor(width = A4.width, height = A4.height, zoom = 100) {
    this.width = width;
    this.height = height;
    this.zoom = zoom;
  }
  getSrc(data) {
    return data && data.src ? this.zoom > 0 ? `${Utility.toObjectUrl(data)}#zoom=${this.zoom}` : Utility.toObjectUrl(data) : "";
  }
  static getDocumentSize(width, height, size) {
    const toolbarHeight = 43;
    const deltaX = 32;
    const deltaY = ch.desktop ? 86 + 16 + toolbarHeight : 45 + 86 + 16 + toolbarHeight;
    width = width > deltaX ? width - deltaX : 0;
    height = height > deltaY ? height - deltaY : 0;
    const k1 = width / A4.width;
    const k2 = height / A4.height;
    const scaleHeight = k1 >= k2;
    const zoomK = ch.desktop ? 0.72 : scaleHeight ? 0.71 : 0.72;
    const modalK = size == DocumentPreviewSize.Medium ? 0.82 : 0.99;
    let zoom;
    if (scaleHeight) {
      const k = modalK * k2;
      width = k * A4.width;
      height = modalK * height + toolbarHeight;
      zoom = zoomK * k * 100;
    } else {
      const k = modalK * k1;
      height = k * A4.height + toolbarHeight;
      width = modalK * width;
      zoom = zoomK * k * 100;
    }
    return new DocumentSize(width, height, zoom);
  }
}
class DocumentPreviewModal extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isLoading: false,
      data: null,
      model: new DocumentPreviewModel()
    };
    this._modalRef = React.createRef();
  }
  onToggleAsync(isOpen) {
    return __awaiter(this, void 0, void 0, function* () {
      if (isOpen) {
        yield this.reloadAsync();
      } else {
        yield this.setState({
          data: null
        });
      }
    });
  }
  geDocumentSize() {
    const node = this.getNode();
    const width = node.width() || 0;
    const height = node.height() || 0;
    return DocumentSize.getDocumentSize(width, height, this.model.size);
  }
  download() {
    const document = this.state.data;
    if (document) {
      return ch.download(document);
    }
  }
  renderToolbar() {
    return React.createElement(Icon, {
      name: "far download",
      className: "blue",
      size: IconSize.X2,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.download();
      }),
      tooltip: DocumentPreviewModalLocalizer$1.download
    });
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (typeof this.model.document === "function") {
        const callback = this.model.document;
        return yield callback(this);
      }
      return this.model.document;
    });
  }
  getEndpoint() {
    return "";
  }
  isAsync() {
    return true;
  }
  openAsync(model) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        model
      });
      if (this._modalRef.current) {
        yield this._modalRef.current.toggleAsync();
      }
    });
  }
  get isOpen() {
    return !!this._modalRef.current && this._modalRef.current.isOpen;
  }
  get model() {
    return this.state.model;
  }
  get modal() {
    return this._modalRef.current;
  }
  get title() {
    return this.model.title || "Document preview";
  }
  get subtitle() {
    return this.model.subtitle ? this.model.subtitle : this.state.data ? this.state.data.name : null;
  }
  canReload() {
    return this.isOpen;
  }
  hasSpinner() {
    return true;
  }
  render() {
    const documentSize = this.geDocumentSize();
    return React.createElement(Modal, {
      info: true,
      id: this.id,
      ref: this._modalRef,
      className: styles$N.documentPreviewModal,
      bodyClassName: styles$N.body,
      title: this.title || DocumentPreviewModalLocalizer$1.preview,
      subtitle: this.subtitle || "...",
      size: ModalSize.Auto,
      toolbar: () => this.renderToolbar(),
      onToggle: (sender, isOpen) => this.onToggleAsync(isOpen)
    }, React.createElement("div", {
      className: styles$N.contentA4
    }, React.createElement("iframe", {
      allowFullScreen: true,
      src: documentSize.getSrc(this.state.data),
      width: documentSize.width,
      height: documentSize.height
    }), this.isSpinning() && React.createElement(Spinner, {
      noShading: true
    })));
  }
}

//Autogenerated
class FooterLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.frontpageLanguageItemName = `_E:0`;
    this.contactLanguageItemName = `_E:1`;
    this.authorsLanguageItemName = `_E:2`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_E:0`, {
      l: `en`,
      v: `Frontpage`
    }, {
      l: `uk`,
      v: `Головна сторінка`
    }, {
      l: `sv`,
      v: `Framsida`
    }, {
      l: `ru`,
      v: `Главная страница`
    }, {
      l: `pl`,
      v: `Strona główna`
    }, {
      l: `nl`,
      v: `Voorpagina`
    }, {
      l: `nb`,
      v: `Hjemmeside`
    }, {
      l: `it`,
      v: `Prima pagina`
    }, {
      l: `fr`,
      v: `Page de garde`
    }, {
      l: `fi`,
      v: `Etusivu`
    }, {
      l: `es`,
      v: `Portada`
    }, {
      l: `de`,
      v: `Titelseite`
    }, {
      l: `da`,
      v: `Forside`
    });
    this.set(`_E:1`, {
      l: `en`,
      v: `Contact information`
    }, {
      l: `uk`,
      v: `Контактна інформація`
    }, {
      l: `sv`,
      v: `Kontakt information`
    }, {
      l: `ru`,
      v: `Контактная информация`
    }, {
      l: `pl`,
      v: `Informacje kontaktowe`
    }, {
      l: `nl`,
      v: `Contactgegevens`
    }, {
      l: `nb`,
      v: `Kontakt informasjon`
    }, {
      l: `it`,
      v: `Informazioni sui contatti`
    }, {
      l: `fr`,
      v: `Coordonnées`
    }, {
      l: `fi`,
      v: `Yhteystiedot`
    }, {
      l: `es`,
      v: `Información del contacto`
    }, {
      l: `de`,
      v: `Kontaktinformationen`
    }, {
      l: `da`,
      v: `Kontaktinformation`
    });
    this.set(`_E:2`, {
      l: `en`,
      v: `Powered by ReApptor`
    }, {
      l: `uk`,
      v: `На основі ReApptor`
    }, {
      l: `sv`,
      v: `Drivs av ReApptor`
    }, {
      l: `ru`,
      v: `Работает на ReApptor`
    }, {
      l: `pl`,
      v: `Obsługiwane przez ReApptor`
    }, {
      l: `nl`,
      v: `Mogelijk gemaakt door ReApptor`
    }, {
      l: `nb`,
      v: `Drevet av ReApptor`
    }, {
      l: `it`,
      v: `Alimentato da ReApptor`
    }, {
      l: `fr`,
      v: `Propulsé par ReApptor`
    }, {
      l: `fi`,
      v: `Powered by ReApptor`
    }, {
      l: `es`,
      v: `Desarrollado por ReApptor`
    }, {
      l: `de`,
      v: `Unterstützt von ReApptor`
    }, {
      l: `da`,
      v: `Drevet af ReApptor`
    });
  }
  /**
  /* "Frontpage" (Frontpage)
  /* "Localizer.frontpage"
  /* "Localizer.frontpageLanguageItemName"
  */
  get frontpage() {
    return this.get(`_E:0`);
  }
  /**
  /* "Contact" (Contact information)
  /* "Localizer.contact"
  /* "Localizer.contactLanguageItemName"
  */
  get contact() {
    return this.get(`_E:1`);
  }
  /**
  /* "Authors" (Powered by ReApptor)
  /* "Localizer.authors"
  /* "Localizer.authorsLanguageItemName"
  */
  get authors() {
    return this.get(`_E:2`);
  }
}
//Singleton
var FooterLocalizer$1 = new FooterLocalizer();

var css_248z$T = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-footer-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-footer-footer {\n  margin-top: auto;\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter {\n  display: flex;\n  height: 120px;\n  align-items: center;\n  justify-content: space-around;\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter img {\n  height: 42px;\n  margin: 0 12px;\n  position: absolute;\n  left: 0;\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter .athenaeum-footer-footerLinks a {\n  color: white;\n  font-family: \"DINProBold\", Arial, sans-serif;\n  margin: 0 3px;\n  transition: all 0.3s;\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter .athenaeum-footer-footerLinks a:hover {\n  color: black;\n  text-decoration: none;\n}\n.athenaeum-footer-footer .athenaeum-footer-lowerFooter {\n  position: relative;\n  background-color: black;\n  color: white;\n  width: 100%;\n  text-align: center;\n}\n.athenaeum-footer-footer .athenaeum-footer-version {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  color: rgb(65, 64, 66);\n  font-size: 10px;\n  padding-left: 4px;\n  padding-right: 4px;\n}\n.athenaeum-footer-footer .athenaeum-footer-authors {\n  right: 0;\n  bottom: 0;\n  position: absolute;\n}\n.athenaeum-footer-footer .athenaeum-footer-authors > a {\n  color: rgb(65, 64, 66);\n  font-size: 10px;\n}\n@media screen and (max-width: 1024px) {\n  .athenaeum-footer-footer {\n    display: none;\n  }\n}";
var styles$M = {"font-renta":"athenaeum-footer-font-renta","footer":"athenaeum-footer-footer","upperFooter":"athenaeum-footer-upperFooter","footerLinks":"athenaeum-footer-footerLinks","lowerFooter":"athenaeum-footer-lowerFooter","version":"athenaeum-footer-version","authors":"athenaeum-footer-authors"};
styleInject(css_248z$T);

/**
 * A footer containing copyright-information, and optionally logo and links.
 */
class Footer extends BaseComponent {
  get links() {
    return this.props.links != null ? this.props.links(this) : [{
      href: "https://reapptor.com/",
      label: FooterLocalizer$1.frontpage
    }, {
      href: "https://www.reapptor.com/",
      label: FooterLocalizer$1.contact
    }];
  }
  get name() {
    const name = this.props.name;
    return (typeof name === "function" ? name() : name) || Footer.defaultName;
  }
  renderCopyright() {
    const currentYear = new Date().getFullYear();
    return React.createElement("span", null, "\u00A9 ", this.name, " ", currentYear);
  }
  get visible() {
    return window.innerWidth > LayoutBreak.Lg;
  }
  /**
   * Create a {@link React} {@link HTMLAnchorElement} from an {@link IFooterLink}.
   *
   * @param link The {@link IFooterLink} to create the element from.
   * @param key Used as the {@link React.Attributes.key} of the returned {@link React.ReactNode}.
   * @return A {@link React} {@link HTMLAnchorElement} created from the input {@link IFooterLink}.
   */
  renderLink(link, key) {
    return React.createElement("a", {
      key: key,
      href: link.href,
      rel: "noreferrer",
      target: "_blank"
    }, FooterLocalizer$1.get(link.label).toUpperCase());
  }
  render() {
    return React.createElement("footer", {
      className: styles$M.footer
    }, React.createElement("div", {
      className: styles$M.upperFooter
    }, this.props.logo && React.createElement("img", {
      src: this.props.logo,
      alt: this.name
    }), React.createElement("div", {
      className: styles$M.footerLinks
    }, this.links.map((link, index) => this.renderLink(link, index)))), React.createElement("div", {
      className: styles$M.lowerFooter
    }, this.renderCopyright(), this.props.version && React.createElement("span", {
      className: styles$M.version
    }, this.props.version), React.createElement("div", {
      className: styles$M.authors
    }, React.createElement("a", {
      href: "/authors"
    }, FooterLocalizer$1.authors))));
  }
}
/**
 * Default value of {@link IFooterProps.name}.
 */
Footer.defaultName = "ReApptor";

var JustifyContent;
(function (JustifyContent) {
  JustifyContent[JustifyContent["Start"] = 0] = "Start";
  JustifyContent[JustifyContent["Center"] = 1] = "Center";
  JustifyContent[JustifyContent["End"] = 2] = "End";
  JustifyContent[JustifyContent["SpaceBetween"] = 3] = "SpaceBetween";
})(JustifyContent || (JustifyContent = {}));
class Inline extends BaseComponent {
  getPaddingStyle(index, length) {
    return length > 0 ? length === 1 ? "p-1-except-left p-1-except-right" : index === 0 ? "p-1-except-left" : index === this.children.length - 1 ? "p-1-except-right" : "p-1" : "";
  }
  renderItem(item, index, length) {
    const paddingStyle = this.getPaddingStyle(index, length);
    return React.createElement("div", {
      key: index,
      className: this.css(paddingStyle)
    }, item);
  }
  get justify() {
    return this.props.justify || JustifyContent.Start;
  }
  get justifyContentStyles() {
    switch (this.justify) {
      case JustifyContent.Center:
        return "justify-content-center";
      case JustifyContent.End:
        return "justify-content-end";
      case JustifyContent.SpaceBetween:
        return "justify-content-between";
      default:
        return "justify-content-start";
    }
  }
  render() {
    return React.createElement("div", {
      className: this.css("d-flex flex-row align-items-center", this.justifyContentStyles, this.props.className)
    }, this.props.children && this.children.length > 0 && this.children.map((item, index) => this.renderItem(item, index, this.children.length)));
  }
}

//Autogenerated
class FormLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var FormLocalizer$1 = new FormLocalizer();

class Form extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      validationErrors: []
    };
    this._onSubmitInvoking = false;
  }
  handleKeydownAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = event.target;
      const preventSubmit = event.keyCode === 13 && !this.props.submitOnEnter && target.tagName != 'TEXTAREA';
      if (preventSubmit) {
        event.preventDefault();
      }
    });
  }
  invokeOnSubmitAsync(data) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onSubmit && !this._onSubmitInvoking) {
        try {
          this._onSubmitInvoking = true;
          yield this.props.onSubmit(this, data);
        } finally {
          this._onSubmitInvoking = false;
        }
      }
    });
  }
  handleSubmitAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      const inputs = this.inputs;
      let isValid = true;
      const data = new Dictionary();
      yield Utility.forEachAsync(inputs, input => __awaiter(this, void 0, void 0, function* () {
        yield input.validateAsync();
        isValid = isValid && input.isValid();
        data.setValue(input.getName(), input.getValue());
      }));
      isValid = isValid || this.props.noValidate;
      if (isValid) {
        yield this.invokeOnSubmitAsync(data);
      }
      return isValid;
    });
  }
  setReadonlyAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      const inputs = this.inputs;
      inputs.forEach(input => input.setReadonlyAsync(value));
    });
  }
  getInputs(component) {
    let inputs = [];
    let input = component;
    if (input.isInput && input.isInput()) {
      inputs.push(input);
    }
    const childComponents = component.childComponents;
    const length = childComponents.length;
    for (let i = 0; i < length; i++) {
      const childComponent = childComponents[i];
      const childInputs = this.getInputs(childComponent);
      inputs.push(...childInputs);
    }
    return inputs;
  }
  get inputs() {
    return this.getInputs(this);
  }
  validateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let isValid = true;
      yield Utility.forEachAsync(this.inputs, input => __awaiter(this, void 0, void 0, function* () {
        yield input.validateAsync();
        isValid = isValid && input.isValid();
      }));
      return isValid;
    });
  }
  setValidationErrorsAsync(...validationErrors) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        validationErrors: validationErrors
      });
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      if (this.props.readonly) {
        yield this.setReadonlyAsync(true);
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newReadonly = nextProps.readonly != null && nextProps.readonly !== this.props.readonly;
      if (newReadonly) {
        const readonly = nextProps.readonly || false;
        yield this.setReadonlyAsync(readonly);
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  render() {
    var _a;
    const inlineStyle = this.props.inline && styles$Z.inline;
    return React.createElement("form", {
      id: this.id,
      name: (_a = this.props.name) !== null && _a !== void 0 ? _a : undefined,
      className: this.css(styles$Z.form, inlineStyle, this.props.className),
      onKeyDown: e => this.handleKeydownAsync(e),
      onSubmit: e => this.handleSubmitAsync(e)
    }, this.state.validationErrors.length > 0 && React.createElement("ul", {
      className: styles$Z.errorList
    }, this.state.validationErrors.map((error, index) => React.createElement("li", {
      key: index
    }, React.createElement("span", null, FormLocalizer$1.get(error))))), this.props.inline ? React.createElement(Inline, null, this.children) : React.createElement(React.Fragment, null, this.children));
  }
}
Form.defaultProps = {
  submitOnEnter: true
};

class AddressHelper {
  static toDegreesMinutesAndSeconds(coordinate) {
    const absolute = Math.abs(coordinate);
    const degrees = Math.floor(absolute);
    const minutesNotTruncated = (absolute - degrees) * 60;
    const minutes = Math.floor(minutesNotTruncated);
    const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
    return `${degrees}°${minutes}'${seconds}"`;
  }
  static improveGoogleFormattedAddress(formattedAddress, address, streetNumber) {
    if (formattedAddress && address && streetNumber) {
      const parts = formattedAddress.split(",").map(item => item.trim());
      if (parts.length == 4) {
        const fullAddress = `${address} ${streetNumber}`;
        if (parts[0] !== fullAddress && parts[1] == fullAddress) {
          // for example: "Koronakatu 1 C, Koronakatu 1, 02210 Espoo, Finland" to "Koronakatu 1, 02210 Espoo, Finland"
          const index = formattedAddress.indexOf(",") + 1;
          formattedAddress = formattedAddress.substr(index).trim();
        }
      }
    }
    return formattedAddress;
  }
  static getFormattedAddress(googleFormattedAddress, lat, lon) {
    return googleFormattedAddress && lat > 0 && lon > 0 ? `${googleFormattedAddress}, #${lat}, ${lon}` : googleFormattedAddress;
  }
  static get googleApiUrl() {
    const context = ch.getContext();
    const settings = context.settings;
    if (!settings.googleMapApiKey || !settings.googleMapApiUrl) throw new Error("Application context doesn't provide Google API settings: \"googleMapApiKey\" or \"googleMapApiUrl\" are empty.");
    //return `${settings.googleMapApiUrl}api/js?key=${settings.googleMapApiKey}&libraries=places&loading=async&callback=Function.prototype`;
    return `${settings.googleMapApiUrl}api/js?key=${settings.googleMapApiKey}&libraries=places`;
  }
  static toGoogleLatLon(center) {
    if (center instanceof GeoLocation || center.isGeoLocation || center instanceof GeoCoordinate || center.isGeoCoordinate) {
      const coordinate = AddressHelper.getCoordinate(center) || AthenaeumComponentsConstants.defaultLocation;
      return {
        lat: coordinate.lat,
        lng: coordinate.lon
      };
    }
    return center;
  }
  static googleStaticApiUrl(center, zoom, markers) {
    const context = ch.getContext();
    const settings = context.settings;
    if (!settings.googleMapApiKey || !settings.googleMapApiUrl) throw new Error("Application context doesn't provide Google API settings: \"googleMapApiKey\" or \"googleMapApiUrl\" are empty.");
    const googleCenter = this.toGoogleLatLon(center);
    let src = `${settings.googleMapApiUrl}api/staticmap?key=${settings.googleMapApiKey}`;
    src = src + "&scale=1&size=640x480&format=PNG&maptype=roadmap";
    src = src + "&center=" + encodeURIComponent("{0},{1}".format(googleCenter.lat, googleCenter.lng));
    src = src + "&zoom=" + encodeURIComponent("{0}".format(zoom));
    const localizer = ServiceProvider.findLocalizer();
    src = src + "&language=" + encodeURIComponent("{0}".format((localizer === null || localizer === void 0 ? void 0 : localizer.language) || "en"));
    if (markers) {
      let markersSrc = "";
      for (let i = 0; i < markers.length; i++) {
        const marker = markers[i];
        if (marker.position) {
          markersSrc += "{0}/{1}".format(marker.position.lat, marker.position.lng);
        }
        if (i < markers.length - 1) {
          markersSrc += "|";
        }
      }
      src = src + "&markers=" + encodeURIComponent(markersSrc);
    }
    return src;
  }
  static loadGoogleLibrary() {
    setTimeout(() => this.loadGoogleLibraryAsync(), 0);
  }
  static loadGoogleLibraryAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isGoogleApiRegistered) {
        return Promise.resolve();
      }
      const googleMapScript = document.createElement("script");
      googleMapScript.src = this.googleApiUrl;
      googleMapScript.async = true;
      googleMapScript.defer = true;
      googleMapScript.id = "googleScript";
      return new Promise((resolve, reject) => {
        googleMapScript.addEventListener("load", () => {
          this._google = window.google;
          resolve();
        });
        googleMapScript.addEventListener("error", () => {
          reject();
          throw new Error("Google API script is not initialized, probably script is not loaded.");
        });
        window.document.body.appendChild(googleMapScript);
      });
    });
  }
  static get isGoogleApiRegistered() {
    return this._google != null;
  }
  static get google() {
    if (this._google == null) throw new Error("Google API script is not initialized, probably script is not loaded.");
    return this._google;
  }
  static get geocoder() {
    return new this.google.maps.Geocoder();
  }
  static toGoogleCoordinate(coordinate) {
    return new this.google.maps.LatLng(coordinate.lat, coordinate.lon);
  }
  static hasCoordinates(location) {
    return location.lat != 0 && location.lon != 0;
  }
  static createMapAsync(element, center, zoom, options) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!options) {
        options = {};
      }
      if (!options.zoom) {
        options.zoom = zoom || 16;
      }
      if (!options.center) {
        center = center && this.hasCoordinates(center) && center || (yield Utility.getLocationAsync()) || AthenaeumComponentsConstants.defaultLocation;
        options.center = new this.google.maps.LatLng(center.lat, center.lon);
      }
      // if (!options.gestureHandling) {
      //     options.gestureHandling = "cooperative";
      // }
      return new this.google.maps.Map(element, options);
    });
  }
  static toMarker(coordinate, title, iconUrl, size, offsetY, onClick, onDoubleClick) {
    const position = {
      lat: coordinate.lat,
      lng: coordinate.lon
    };
    size = size || 40;
    let infoWindow = null;
    if (title) {
      const content = `<b>${title}</b>`;
      offsetY = offsetY || -(4 / 5 * size);
      infoWindow = {
        content,
        position,
        pixelOffset: new google.maps.Size(0, offsetY)
      };
    }
    const icon = iconUrl ? {
      url: iconUrl,
      scaledSize: new google.maps.Size(size, size)
    } : undefined;
    return {
      title: title || undefined,
      infoWindow: infoWindow || undefined,
      position,
      icon,
      onClick,
      onDoubleClick
    };
  }
  static addMarkerAsync(position, map) {
    return __awaiter(this, void 0, void 0, function* () {
      if (position instanceof GeoCoordinate) {
        position = this.toGoogleCoordinate(position);
      }
      return new this.google.maps.Marker({
        position: position,
        map: map
      });
    });
  }
  static addInfoWindow(content) {
    return __awaiter(this, void 0, void 0, function* () {
      return new this.google.maps.InfoWindow({
        content
      });
    });
  }
  static setMapCenterAsync(position, map) {
    return __awaiter(this, void 0, void 0, function* () {
      if (position instanceof GeoCoordinate) {
        position = this.toGoogleCoordinate(position);
      }
      map.setCenter(position);
    });
  }
  static findLat(place) {
    if (place.geometry && place.geometry.location && place.geometry.location.lat) {
      return place.geometry.location.lat();
    }
    return null;
  }
  static findLon(place) {
    if (place.geometry && place.geometry.location && place.geometry.location.lng) {
      return place.geometry.location.lng();
    }
    return null;
  }
  static findAddressComponent(place, componentType) {
    if (place.address_components) {
      const component = place.address_components.find(component => component.types != null && component.types.some(type => type === componentType));
      if (component) {
        return component.long_name || component.short_name;
      }
    }
    return "";
  }
  static removeLatLon(addressValue) {
    const index = addressValue.indexOf("#");
    if (index > 0) {
      addressValue = addressValue.substr(0, index - 1).trim();
      if (addressValue.endsWith(",")) {
        addressValue = addressValue.substr(0, addressValue.length - 1).trim();
      }
    }
    return addressValue;
  }
  static getCountryName(countryCodeOrName) {
    if (countryCodeOrName) {
      countryCodeOrName = countryCodeOrName.trim().toLowerCase();
      switch (countryCodeOrName) {
        //"fi", "fi-fi", "Finland", "Suomi"
        case "fi":
        case "fi-fi":
        case "finland":
        case "suomi":
          return "Suomi";
        //"se", "sv", "sv-se", "Sweden", "Svenska", "Ruotsi"
        case "se":
        case "sv":
        case "sv-se":
        case "sweden":
        case "svenska":
        case "ruotsi":
          return "Svenska";
        //"no", "nb", "nor", "nb-no", "Norway", "Norge"
        case "no":
        case "nb":
        case "nor":
        case "nb-no":
        case "norway":
        case "norge":
          return "Norge";
        //"dk", "da", "da-dk", "Denmark", "Danmark"
        case "dk":
        case "da":
        case "da-dk":
        case "denmark":
        case "danmark":
          return "Danmark";
        //"pl", "pl-pl", "Poland", "Polska"
        case "pl":
        case "pl-pl":
        case "poland":
        case "polska":
          return "Polska";
        //"ru", "ru-ru", "Russia", "Россия"
        case "ru":
        case "ru-ru":
        case "russia":
        case "россия":
          return "Россия";
        //"ua", "uk", "uk-ua", "Ukraine", "Україна", "Украина"
        case "ua":
        case "uk":
        case "uk-ua":
        case "ukraine":
        case "україна":
        case "украина":
          return "Україна";
        //"de", "de-de", "Deutschland", "Germany"
        case "de":
        case "de-de":
        case "deutschland":
        case "germany":
          return "Deutschland";
        //"fr", "fr-fr", "France"
        case "fr":
        case "fr-fr":
        case "france":
          return "France";
        //"it", "it-it", "Italia", "Italy"
        case "it":
        case "it-it":
        case "italy":
        case "italia":
          return "Italia";
        //"en", "gb", "en-gb", "United Kingdom"
        case "en":
        case "gb":
        case "en-gb":
        case "united kingdom":
          return "United Kingdom";
        //"us", "en-us", "United States"
        case "us":
        case "en-us":
        case "united states":
          return "United States";
        //"es", "es-es", "Spain", "España"
        case "es":
        case "es-es":
        case "spain":
        case "españa":
          return "Spain";
        //"nl", "nl-nl", "Netherlands", "Nederland", "Dutch", "Holland"
        case "nl":
        case "nl-nl":
        case "netherlands":
        case "nederland":
        case "dutch":
        case "holland":
          return "Netherlands";
      }
    }
    return countryCodeOrName;
  }
  static extractCoordinate(formattedAddress) {
    if (formattedAddress) {
      const index = formattedAddress.indexOf("#");
      if (index > 0) {
        let items = formattedAddress.split("#");
        if (items.length > 1 && items[1]) {
          items = items[1].split(",");
          if (items.length > 1 && items[0] && items[1]) {
            const lat = Number(items[0]);
            const lon = Number(items[1]);
            if (!isNaN(lat) && isFinite(lat) && lat > 0 && !isNaN(lon) && isFinite(lon) && lon > 0) {
              return new GeoCoordinate(lat, lon);
            }
          }
        }
      }
    }
    return null;
  }
  static toLocation(formattedAddress) {
    if (!formattedAddress) {
      return null;
    }
    if (typeof formattedAddress !== "string") {
      return formattedAddress;
    }
    const geoLocation = new GeoLocation();
    geoLocation.formattedAddress = formattedAddress;
    //Formatted address comes in formats:
    //  "Äyritie 12, 01510 Vantaa, Finland, #60.21083359999999, 24.951597"
    //  "Skeppsbron 30, 111 30 Stockholm, Sweden, #59.3239062, 18.0748655"
    //  "Äyritie 12, Vantaa, Finland, #60.21083359999999, 24.951597"
    //  "Äyritie 12, Vantaa, 01510, Finland, #60.21083359999999, 24.951597"
    //  "Äyritie 12, Vantaa, Finland, #60.21083359999999, 24.951597"
    const includesLocation = formattedAddress.includes("#");
    if (includesLocation) {
      const parts = formattedAddress.replace(/([#])/gm, "").split(",").map(item => item.trim()).filter(item => !!item);
      const length = parts.length;
      if (length > 4) {
        const lat = Number(parts[length - 2]);
        const lon = Number(parts[length - 1]);
        const cityPostalCodeParts = parts[length - 4].trim().split(" ");
        if (cityPostalCodeParts.length == 3) {
          //111 30
          geoLocation.postalCode = cityPostalCodeParts[0] + " " + cityPostalCodeParts[1];
          geoLocation.city = cityPostalCodeParts[2];
        } else if (cityPostalCodeParts.length == 2) {
          geoLocation.postalCode = cityPostalCodeParts[0];
          geoLocation.city = cityPostalCodeParts[1];
        } else if (cityPostalCodeParts.length == 1) {
          if (parts.length > 5) {
            geoLocation.postalCode = parts[length - 4];
            geoLocation.city = parts[length - 5];
          } else {
            geoLocation.city = cityPostalCodeParts[0];
          }
        }
        if (!isNaN(lat) && isFinite(lat) && lat > 0) {
          geoLocation.lat = lat;
        }
        if (!isNaN(lon) && isFinite(lon) && lon > 0) {
          geoLocation.lon = lon;
        }
        geoLocation.address = parts[0];
        geoLocation.country = this.getCountryName(parts[length - 3]);
      }
    }
    return geoLocation;
  }
  static getCoordinate(location) {
    var _a, _b;
    if (location) {
      if (typeof location === "string") {
        return AddressHelper.extractCoordinate(location);
      }
      const position = location;
      if (((_a = position.coords) === null || _a === void 0 ? void 0 : _a.latitude) != null && ((_b = position.coords) === null || _b === void 0 ? void 0 : _b.longitude) != null) {
        return new GeoCoordinate(position.coords.latitude, position.coords.longitude);
      }
      const coordinate = location;
      return this.hasCoordinates(coordinate) ? coordinate : this.extractCoordinate(coordinate.formattedAddress);
    }
    return null;
  }
  static findLocationByLatLngAsync(latLng) {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise((resolve, reject) => {
        const request = {
          location: latLng,
          region: "fi"
        };
        this.geocoder.geocode(request, (results, status) => {
          if (status === this.google.maps.GeocoderStatus.OK) {
            resolve(this.getLocationFromGeocodeResult(results[0]));
          } else if (status === this.google.maps.GeocoderStatus.ZERO_RESULTS) {
            resolve(null);
          } else {
            reject(status);
          }
        });
      });
    });
  }
  static findAddressAsync(map, address) {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise((resolve, reject) => {
        const placesService = new this.google.maps.places.PlacesService(map);
        const request = {
          fields: ["formatted_address", "geometry"],
          query: address
        };
        placesService.findPlaceFromQuery(request, (results, status) => {
          if (status === this.google.maps.places.PlacesServiceStatus.OK) {
            resolve(this.getCoordinateFromGeocodeResult(results[0]));
          } else if (status === this.google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            resolve(null);
          } else {
            reject(status);
          }
        });
      });
    });
  }
  static getCoordinateFromGeocodeResult(result) {
    const lat = this.findLat(result);
    const lon = this.findLon(result);
    return new GeoCoordinate(lat !== null && lat !== void 0 ? lat : 0, lon !== null && lon !== void 0 ? lon : 0);
  }
  static getLocationFromGeocodeResult(result) {
    const lat = this.findLat(result);
    const lon = this.findLon(result);
    let country = this.findAddressComponent(result, "country");
    let address = this.findAddressComponent(result, "route") || this.findAddressComponent(result, "establishment");
    const town = this.findAddressComponent(result, "locality") || this.findAddressComponent(result, "postal_town") || this.findAddressComponent(result, "political");
    const postalCode = this.findAddressComponent(result, "postal_code");
    const streetNumber = this.findAddressComponent(result, "street_number");
    if (!address) {
      const plusCode = this.findAddressComponent(result, "plus_code");
      if (plusCode) {
        address = plusCode;
        if (!country) {
          country = "XZ"; // Internation waters county code: ISO 3166-1 alpha-2.
        }
      }
    }
    const googleFormattedAddress = this.improveGoogleFormattedAddress(result.formatted_address || "", address, streetNumber);
    const formattedAddress = this.getFormattedAddress(googleFormattedAddress, lat !== null && lat !== void 0 ? lat : 0, lon !== null && lon !== void 0 ? lon : 0);
    const isValidLocation = (address.length > 0 || formattedAddress.length > 0) && lat != null && lon != null;
    const geoLocation = new GeoLocation();
    if (isValidLocation) {
      geoLocation.formattedAddress = formattedAddress;
      geoLocation.address = (address + " " + streetNumber).trim();
      geoLocation.city = town;
      geoLocation.country = country;
      geoLocation.postalCode = postalCode;
      geoLocation.lat = lat;
      geoLocation.lon = lon;
    }
    return geoLocation;
  }
  static toDMS(coordinate) {
    const {
      lat: lat,
      lon: lon
    } = coordinate;
    const latitude = this.toDegreesMinutesAndSeconds(lat);
    const latitudeCardinal = lat >= 0 ? "N" : "S";
    const longitude = this.toDegreesMinutesAndSeconds(lon);
    const longitudeCardinal = lon >= 0 ? "E" : "W";
    return `${latitude}${latitudeCardinal} ${longitude}${longitudeCardinal}`;
  }
  /**
   * Finds the distance between the locations.
   * @returns The distance between the locations.
   * If any location is null - error is thrown.
   */
  static distance(x, y) {
    const xCoordinate = this.getCoordinate(x);
    const yCoordinate = this.getCoordinate(y);
    if (!xCoordinate) throw Error(`AddressHelper.distance(x, y): GEO coordinate cannot be extracted from argument "x": "${x}".`);
    if (!yCoordinate) throw Error(`AddressHelper.distance(x, y): GEO coordinate cannot be extracted from argument "y": "${y}".`);
    // The math module contains a function
    // named toRadians which converts from
    // degrees to radians.
    const toRadiansK = Math.PI / 180;
    const lon1 = xCoordinate.lon * toRadiansK;
    const lon2 = yCoordinate.lon * toRadiansK;
    const lat1 = xCoordinate.lat * toRadiansK;
    const lat2 = yCoordinate.lat * toRadiansK;
    // Haversine formula
    const dLon = lon2 - lon1;
    const dLat = lat2 - lat1;
    const a = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dLon / 2), 2);
    const c = 2 * Math.asin(Math.sqrt(a));
    // Radius of Earth in kilometers. Use 3956 for miles
    const r = 6371;
    // calculate the result
    return c * r;
  }
  /**
   * Finds the bottom-left and top-right coordinates of a rectangle that bounds the given route.
   * @param route - An array of locations that form the route.
   * @returns An array containing the bottom-left and top-right coordinates of the route's bounding rectangle.
   * Coordinates in array are in the order as they are mentioned.
   * If the route is empty (has no locations) - null is returned.
   */
  static findRouteRectangle(route) {
    const geoCoordinates = route.map(item => AddressHelper.getCoordinate(item)).where(item => item != null).select(item => item);
    if (geoCoordinates.length == 0) {
      return null;
    }
    const minLat = geoCoordinates.minValue(x => x.lat);
    const minLon = geoCoordinates.minValue(x => x.lon);
    const maxLat = geoCoordinates.maxValue(x => x.lat);
    const maxLon = geoCoordinates.maxValue(x => x.lon);
    const bottomLeft = new GeoCoordinate(minLat, minLon);
    const topRight = new GeoCoordinate(maxLat, maxLon);
    return [bottomLeft, topRight];
  }
  /**
   * Finds the bottom-left and top-right coordinates of a rectangle that bounds the given route.
   * @param route - An array of locations that form the route.
   * @returns An array containing the bottom-left and top-right coordinates of the route's bounding rectangle.
   * Coordinates in array are in the order as they are mentioned.
   * If the route is empty (has no locations) - null is returned.
   */
  static getRouteRectangle(route) {
    const rectangle = this.findRouteRectangle(route);
    if (rectangle == null) throw Error(`AddressHelper.getRouteRectangle(coordinates): No coordinates can be extracted, at least one point is expected, but specified argument "route": "${route}".`);
    return rectangle;
  }
  /**
   * Finds the center of the rectangle that bounds the given route.
   * @param route - An array of locations that form the route.
   * @returns The center of the rectangle that bounds the given route.
   * If the route is empty (has no locations) - error is thrown.
   */
  static findCenter(route) {
    const rectangle = AddressHelper.findRouteRectangle(route);
    if (rectangle == null) {
      return null;
    }
    const x = rectangle[0];
    const y = rectangle[1];
    const lat = (x.lat + y.lat) / 2;
    const lon = (x.lon + y.lon) / 2;
    return new GeoCoordinate(lat, lon);
  }
  /**
   * Gets the center of the rectangle that bounds the given route.
   * @param route - An array of locations that form the route.
   * @returns The center of the rectangle that bounds the given route.
   * If the route is empty (has no locations) - error is thrown.
   */
  static getCenter(route) {
    const center = this.findCenter(route);
    if (center == null) throw Error(`AddressHelper.getCenter(route): No coordinates can be extracted, at least one point is expected, but specified argument "route": "${route}".`);
    return center;
  }
  /**
   * Finds the appropriate zoom level for displaying a route on a map. Zoom is found based on the rectangle that bounds the route.
   * Zoom level range: from 0 included - to 17 included.
   * 0 zoom level means: the smallest zoom - the biggest possible area is visible - the whole map.
   * 17 zoom level means: the biggest zoom - the smallest possible area is visible.
   * @param route - An array of locations that form the route.
   * @param gap
   * @param aspectRate
   * @returns The zoom level which allows to see the route on the map in the optimal way.
   */
  static findZoom(route, gap = 2, aspectRate) {
    const rectangle = AddressHelper.findRouteRectangle(route);
    if (rectangle != null) {
      const minLat = rectangle.minValue(item => item.lat);
      const minLon = rectangle.minValue(item => item.lon);
      const maxLat = rectangle.maxValue(item => item.lat);
      const maxLon = rectangle.maxValue(item => item.lon);
      aspectRate = aspectRate != null && aspectRate > 0 ? aspectRate : 1;
      const topLeft = new GeoCoordinate(maxLat, minLon);
      const bottomLeft = new GeoCoordinate(minLat, minLon);
      const topRight = new GeoCoordinate(maxLat, maxLon);
      const width = AddressHelper.distance(topLeft, topRight);
      const height = AddressHelper.distance(topLeft, bottomLeft);
      const maxDistanceKm = Utility.max([width, aspectRate * height]);
      const adjustedMaxDistanceKm = gap * maxDistanceKm;
      const zoomDistancesKm = [40000, 20000, 10000, 5000, 2500, 1250, 625, 312.5, 156.25, 78.125, 39.0625, 19.53125, 9.765625, 4.8828125, 2.44140625, 1.220703125, 0.6103515625, 0.3051757813, 0.1525878906];
      for (let zoom = 0; zoom < zoomDistancesKm.length - 1; zoom++) {
        if (adjustedMaxDistanceKm > zoomDistancesKm[zoom + 1]) {
          return zoom;
        }
      }
    }
    return 0;
  }
}
AddressHelper._google = null;

class Comparator {
  static isEqualGeoCoordinate(x, y) {
    return x.lat === y.lat && x.lon === y.lon;
  }
  static isEqualGeoLocation(x, y) {
    if (x.formattedAddress && y.formattedAddress && x.formattedAddress === y.formattedAddress) {
      return true;
    }
    const xCoordinate = AddressHelper.getCoordinate(x);
    const yCoordinate = AddressHelper.getCoordinate(y);
    if (xCoordinate && yCoordinate) {
      return this.isEqualGeoCoordinate(xCoordinate, yCoordinate);
    }
    const xAddress = AddressHelper.removeLatLon(x.formattedAddress);
    const yAddress = AddressHelper.removeLatLon(y.formattedAddress);
    return xAddress === yAddress;
  }
  static isEqualStatusListItem(x, y) {
    return x.completed === y.completed && x.lineThrough === y.lineThrough && x.value === y.value;
  }
  static isEqualPageRoute(x, y) {
    if (x === y) {
      return true;
    }
    if (x == null && y == null) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    if (x.name !== y.name) {
      return false;
    }
    if (x.index !== y.index) {
      return false;
    }
    if (x.id !== y.id) {
      return false;
    }
    // TODO: compare parameters
    return true;
  }
  static isEqual(x, y, compareHashCode = false) {
    if (x === y) {
      return true;
    }
    if (x == null && y == null) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    if (typeof x === "object") {
      if (x instanceof StatusListItem || x.isStatusListItem) {
        return (y instanceof StatusListItem || y.isStatusListItem) && this.isEqualStatusListItem(x, y);
      }
      if (x instanceof SelectListItem || x.isSelectListItem) {
        return (y instanceof SelectListItem || y.isSelectListItem) && x.value === y.value;
      }
      if (x instanceof PageRoute || x.isPageRoute) {
        return (y instanceof PageRoute || y.isPageRoute) && this.isEqualPageRoute(x, y);
      }
      if (x instanceof GeoLocation || x.isGeoLocation) {
        return (y instanceof GeoLocation || y.isGeoLocation) && this.isEqualGeoLocation(x, y);
      }
      if (x instanceof GeoCoordinate || x.isGeoCoordinate) {
        return (y instanceof GeoCoordinate || y.isGeoCoordinate) && this.isEqualGeoCoordinate(x, y);
      }
      if (Utility.isDateType(x) || Utility.isDateType(y)) {
        const xDate = new Date(x);
        const yDate = new Date(y);
        return xDate.valueOf() === yDate.valueOf();
      }
      // if (typeof y === "object") {
      //     const xType: ServiceType = TypeResolver.resolve(x);
      //     const yType: ServiceType = TypeResolver.resolve(y);
      //    
      //     if (xType === yType) {
      //         const xHashCode: number = HashCodeUtility.getHashCode(x);
      //         const yHashCode: number = HashCodeUtility.getHashCode(y);
      //
      //         return (xHashCode === yHashCode);
      //     }
      // }
    }
    if (typeof x === "string" && typeof y === "object") {
      return Comparator.isEqual(y, x);
    }
    if (Array.isArray(x) && Array.isArray(y)) {
      if (x.length !== y.length) {
        return false;
      }
      for (let i = 0; i < x.length; i++) {
        if (!Comparator.isEqual(x[i], y[i])) {
          return false;
        }
      }
      return true;
    }
    if (this._comparator) {
      return this._comparator(x, y);
    }
    return compareHashCode ? HashCodeUtility.isEqual(x, y) : x == y;
  }
  static register(comparator) {
    this._comparator = comparator;
  }
}
Comparator._comparator = null;

/**
 /* Represents the optgroup HTML element and its attributes.
 /* In a select list, multiple groups with the same name are supported.
 /* They are compared with reference equality.
 */
class SelectListGroup {
  constructor() {
    this.__lowerName = null;
    /**
     * Gets or sets a value that indicates whether this is disabled.
     */
    this.disabled = false;
    /**
     /* Represents the value of the optgroup's label.
     */
    this.name = "";
    this.order = 0;
    this.isSelectListGroup = true;
  }
  get lowerName() {
    if (this.__lowerName == null) {
      return this.__lowerName = (this.name || "").toLowerCase();
    }
    return this.__lowerName;
  }
  static compare(x, y) {
    if (x === y) {
      return 0;
    }
    if (x == null && y == null) {
      return 0;
    }
    if (y == null) {
      return 1;
    }
    if (x == null) {
      return -1;
    }
    return StringUtility.compare(x.lowerName, y.lowerName);
  }
  static isEqual(x, y) {
    return this.compare(x, y) === 0;
  }
  static create(name, disabled = false) {
    const item = new SelectListGroup();
    item.name = name || "";
    item.disabled = disabled;
    return item;
  }
}
/**
 * Represent an item in a <see cref="T:Microsoft.AspNetCore.Mvc.Rendering.SelectList" /> or <see cref="T:Microsoft.AspNetCore.Mvc.Rendering.MultiSelectList" />.
 * This class is typically rendered as an HTML <code>&lt;option&gt;</code> element with the specified
 * attribute values.
 */
class SelectListItem {
  constructor(value = null, text = null, subtext = null, ref = null) {
    this.__lowerText = null;
    this.__lowerSubtext = null;
    /**
     * Gets or sets a value that indicates whether this SelectListItem is disabled.
     * This property is typically rendered as a <code>disabled="disabled"</code> attribute in the HTML
     */
    this.disabled = false;
    /**
     * Gets or sets a value that indicates whether this SelectListItem is selected.
     * This property is typically rendered as a <code>disabled="disabled"</code> attribute in the HTML
     */
    this.selected = false;
    /**
     * Gets or sets a value that indicates the display text of this <see cref="T:Microsoft.AspNetCore.Mvc.Rendering.SelectListItem" />.
     * This property is typically rendered as the inner HTML in the HTML <code>&lt;option&gt;</code> element.
     */
    this.text = "";
    this.subtext = "";
    /**
     * Gets or sets a value that indicates the value of this <see cref="T:Microsoft.AspNetCore.Mvc.Rendering.SelectListItem" />.
     * This property is typically rendered as a <code>value="..."</code> attribute in the HTML
     */
    this.value = "";
    this.favorite = false;
    /**
     * Represents the optgroup HTML element this item is wrapped into.
     * In a select list, multiple groups with the same name are supported.
     * They are compared with reference equality.
     */
    this.group = null;
    this.ref = this;
    this.isSelectListItem = true;
    this.value = value || "";
    this.text = text || "";
    this.subtext = subtext || "";
    this.ref = ref != null ? ref : this;
  }
  get lowerText() {
    if (this.__lowerText == null) {
      return this.__lowerText = (this.text || "").toLowerCase();
    }
    return this.__lowerText;
  }
  get lowerSubtext() {
    if (this.__lowerSubtext == null) {
      return this.__lowerSubtext = (this.subtext || "").toLowerCase();
    }
    return this.__lowerSubtext;
  }
  static isEqual(x, y) {
    if (x === y) {
      return true;
    }
    if (x == null && y == null) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    return this.CompareByValue(x, y) === 0;
  }
  static is(item) {
    return item != null ? Array.isArray(item) ? item.length > 0 && item[0] != null && SelectListItem.is(item[0]) : item instanceof SelectListItem || item.isSelectListItem === true : false;
  }
}
SelectListItem.Group = (x, y, groupSelected = false) => {
  let result = 0;
  if (groupSelected) {
    const xSelected = x.selected;
    const ySelected = y.selected;
    result = BoolUtility.compare(xSelected, ySelected, true);
  }
  if (result === 0) {
    const xFavorite = x.favorite;
    const yFavorite = y.favorite;
    result = BoolUtility.compare(xFavorite, yFavorite, true);
    if (result === 0) {
      const xGroupOrder = x.group != null ? x.group.order : -1;
      const yGroupOrder = y.group != null ? y.group.order : -1;
      result = NumberUtility.compare(xGroupOrder, yGroupOrder);
      if (result === 0) {
        const xGroupName = x.group != null ? x.group.lowerName : "";
        const yGroupName = y.group != null ? y.group.lowerName : "";
        result = StringUtility.compare(xGroupName, yGroupName);
      }
    }
  }
  return result;
};
SelectListItem.CompareByName = (x, y, groupSelected = false) => {
  let result = SelectListItem.Group(x, y, groupSelected);
  if (result === 0) {
    result = StringUtility.compare(x.lowerText, y.lowerText);
  }
  return result;
};
SelectListItem.CompareByValue = (x, y, groupSelected = false) => {
  let result = SelectListItem.Group(x, y, groupSelected);
  if (result === 0) {
    result = StringUtility.compare(x.value, y.value);
  }
  return result;
};
SelectListItem.CompareByGroup = (x, y, groupSelected = false) => {
  return SelectListItem.Group(x, y, groupSelected);
};
class StatusListItem extends SelectListItem {
  constructor(lineThrough = false, completed = false, value = null, text = null, subtext = null, ref = null) {
    super(value, text, subtext, ref);
    this.completed = false;
    this.lineThrough = false;
    this.className = null;
    this.isStatusListItem = true;
    this.lineThrough = lineThrough;
    this.completed = completed;
  }
}
class SelectListSeparator extends SelectListItem {
  constructor() {
    super();
    this.isSelectListSeparator = true;
    this.value = "";
    this.selected = false;
  }
}
SelectListSeparator.instance = new SelectListSeparator();

//Autogenerated
class DropdownLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.multipleSelectedLanguageItemName = `_0:0`;
    this.noItemsLanguageItemName = `_0:1`;
    this.noDataLanguageItemName = `_0:2`;
    this.filterResultsLanguageItemName = `_0:3`;
    this.getResultsLanguageItemName = `_0:4`;
    this.addLanguageItemName = `_0:5`;
    this.nothingSelectedLanguageItemName = `_0:6`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_0:0`, {
      l: `en`,
      v: `{0} selected`
    }, {
      l: `uk`,
      v: `{0} вибран(о)`
    }, {
      l: `sv`,
      v: `{0} valt`
    }, {
      l: `ru`,
      v: `{0} выбран(о)`
    }, {
      l: `pl`,
      v: `{0} wybrane`
    }, {
      l: `nl`,
      v: `{0} geselecteerd`
    }, {
      l: `nb`,
      v: `{0} valgt`
    }, {
      l: `it`,
      v: `{0} selezionato`
    }, {
      l: `fr`,
      v: `{0} sélectionné`
    }, {
      l: `fi`,
      v: `{0} valittu`
    }, {
      l: `es`,
      v: `{0} seleccionado`
    }, {
      l: `de`,
      v: `{0} ausgewählt`
    }, {
      l: `da`,
      v: `{0} valgt`
    });
    this.set(`_0:1`, {
      l: `en`,
      v: `No items found`
    }, {
      l: `uk`,
      v: `Нічого не знайдено`
    }, {
      l: `sv`,
      v: `Inga artiklar hittades`
    }, {
      l: `ru`,
      v: `Данные не найдены`
    }, {
      l: `pl`,
      v: `Nie znaleziono przedmiotów`
    }, {
      l: `nl`,
      v: `Geen items gevonden`
    }, {
      l: `nb`,
      v: `Ingen objekter funnet`
    }, {
      l: `it`,
      v: `Nessun articolo trovato`
    }, {
      l: `fr`,
      v: `Aucun élément trouvé`
    }, {
      l: `fi`,
      v: `Kohteita ei löytynyt`
    }, {
      l: `es`,
      v: `No se encontraron artículos`
    }, {
      l: `de`,
      v: `Keine Elemente gefunden`
    }, {
      l: `da`,
      v: `Ingen genstande fundet`
    });
    this.set(`_0:2`, {
      l: `en`,
      v: `No data`
    }, {
      l: `uk`,
      v: `Немає даних`
    }, {
      l: `sv`,
      v: `Ingen information`
    }, {
      l: `ru`,
      v: `Нет данных`
    }, {
      l: `pl`,
      v: `Brak danych`
    }, {
      l: `nl`,
      v: `Geen gegevens`
    }, {
      l: `nb`,
      v: `Ingen data`
    }, {
      l: `it`,
      v: `Nessun dato`
    }, {
      l: `fr`,
      v: `Pas de données`
    }, {
      l: `fi`,
      v: `Ei tietoja`
    }, {
      l: `es`,
      v: `Sin datos`
    }, {
      l: `de`,
      v: `Keine Daten`
    }, {
      l: `da`,
      v: `Ingen data`
    });
    this.set(`_0:3`, {
      l: `en`,
      v: `Filter results`
    }, {
      l: `uk`,
      v: `Відфільтрувати результати`
    }, {
      l: `sv`,
      v: `Filtrera resultat`
    }, {
      l: `ru`,
      v: `Отфильтровать результаты`
    }, {
      l: `pl`,
      v: `Filtruj wyniki`
    }, {
      l: `nl`,
      v: `Resultaten filteren`
    }, {
      l: `nb`,
      v: `Filtrer resultater`
    }, {
      l: `it`,
      v: `Filtra i risultati`
    }, {
      l: `fr`,
      v: `Filtrer les résultats`
    }, {
      l: `fi`,
      v: `Suodata tuloksia`
    }, {
      l: `es`,
      v: `Filtrar Resultados`
    }, {
      l: `de`,
      v: `Filter Ergebnisse`
    }, {
      l: `da`,
      v: `Filtrer resultaterne`
    });
    this.set(`_0:4`, {
      l: `en`,
      v: `Start typing to get results`
    }, {
      l: `uk`,
      v: `Почніть писати, щоб побачити дані`
    }, {
      l: `sv`,
      v: `Börja skriva för att få resultat`
    }, {
      l: `ru`,
      v: `Начните писать, чтобы увидеть данные`
    }, {
      l: `pl`,
      v: `Zacznij pisać, aby uzyskać wyniki`
    }, {
      l: `nl`,
      v: `Begin met typen om resultaten te krijgen`
    }, {
      l: `nb`,
      v: `Begynn å skrive for å få resultater`
    }, {
      l: `it`,
      v: `Inizia a digitare per ottenere risultati`
    }, {
      l: `fr`,
      v: `Commencez à taper pour obtenir des résultats`
    }, {
      l: `fi`,
      v: `Aloita kirjoittaminen saadaksesi tuloksia`
    }, {
      l: `es`,
      v: `Comience a escribir para obtener resultados`
    }, {
      l: `de`,
      v: `Beginnen Sie mit der Eingabe, um Ergebnisse zu erhalten`
    }, {
      l: `da`,
      v: `Begynd at skrive for at få resultater`
    });
    this.set(`_0:5`, {
      l: `en`,
      v: `Add`
    }, {
      l: `uk`,
      v: `Додати`
    }, {
      l: `sv`,
      v: `Lägg till`
    }, {
      l: `ru`,
      v: `Новый`
    }, {
      l: `pl`,
      v: `Dodaj`
    }, {
      l: `nl`,
      v: `Toevoegen`
    }, {
      l: `nb`,
      v: `Legg til`
    }, {
      l: `it`,
      v: `Aggiungere`
    }, {
      l: `fr`,
      v: `Ajouter`
    }, {
      l: `fi`,
      v: `Lisää`
    }, {
      l: `es`,
      v: `Agregar`
    }, {
      l: `de`,
      v: `Hinzufügen`
    }, {
      l: `da`,
      v: `Tilføj`
    });
    this.set(`_0:6`, {
      l: `en`,
      v: `Nothing is selected`
    }, {
      l: `uk`,
      v: `Нічого не вибрано`
    }, {
      l: `sv`,
      v: `Ingenting är valt`
    }, {
      l: `ru`,
      v: `Ничего не выбрано`
    }, {
      l: `pl`,
      v: `Wybierz`
    }, {
      l: `nl`,
      v: `Er is niets geselecteerd`
    }, {
      l: `nb`,
      v: `Ingenting er valgt`
    }, {
      l: `it`,
      v: `Non è selezionato nulla`
    }, {
      l: `fr`,
      v: `Rien n'est sélectionné`
    }, {
      l: `fi`,
      v: `Ei mitään valittu`
    }, {
      l: `es`,
      v: `No hay nada seleccionado`
    }, {
      l: `de`,
      v: `Es ist nichts ausgewählt`
    }, {
      l: `da`,
      v: `Intet er valgt`
    });
  }
  /**
  /* "MultipleSelected" ({0} selected)
  /* "Localizer.multipleSelected"
  /* "Localizer.multipleSelectedLanguageItemName"
  */
  get multipleSelected() {
    return this.get(`_0:0`);
  }
  /**
  /* "NoItems" (No items found)
  /* "Localizer.noItems"
  /* "Localizer.noItemsLanguageItemName"
  */
  get noItems() {
    return this.get(`_0:1`);
  }
  /**
  /* "NoData" (No data)
  /* "Localizer.noData"
  /* "Localizer.noDataLanguageItemName"
  */
  get noData() {
    return this.get(`_0:2`);
  }
  /**
  /* "FilterResults" (Filter results)
  /* "Localizer.filterResults"
  /* "Localizer.filterResultsLanguageItemName"
  */
  get filterResults() {
    return this.get(`_0:3`);
  }
  /**
  /* "GetResults" (Start typing to get results)
  /* "Localizer.getResults"
  /* "Localizer.getResultsLanguageItemName"
  */
  get getResults() {
    return this.get(`_0:4`);
  }
  /**
  /* "Add" (Add)
  /* "Localizer.add"
  /* "Localizer.addLanguageItemName"
  */
  get add() {
    return this.get(`_0:5`);
  }
  /**
  /* "NothingSelected" (Nothing is selected)
  /* "Localizer.nothingSelected"
  /* "Localizer.nothingSelectedLanguageItemName"
  */
  get nothingSelected() {
    return this.get(`_0:6`);
  }
}
//Singleton
var DropdownLocalizer$1 = new DropdownLocalizer();

var css_248z$S = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-dropdown-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-dropdown-list, .athenaeum-dropdown-dropdown {\n  text-align: left;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  height: 100%;\n}\n.athenaeum-dropdown-list.athenaeum-dropdown-disabled, .athenaeum-dropdown-disabled.athenaeum-dropdown-dropdown {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-selected, .athenaeum-dropdown-dropdown .athenaeum-dropdown-selected {\n  text-align: center;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer {\n  display: flex;\n  visibility: hidden;\n  height: inherit;\n  position: absolute;\n  flex-direction: column;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter {\n  padding: 4px 2px 0;\n  position: relative;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter > input, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter > input {\n  width: 100%;\n  padding-right: 18px !important;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter input::placeholder, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter input::placeholder {\n  font-style: italic;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean {\n  position: absolute;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  top: 0;\n  right: 12px;\n  opacity: 0.3;\n  margin-top: 2px;\n  color: black;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean:hover {\n  opacity: 1;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton {\n  padding: 0 2px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton > span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton > span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-scrollableContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-scrollableContainer {\n  overflow-y: auto;\n  height: inherit;\n  position: relative;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList {\n  height: auto;\n  position: absolute;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: unset;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList {\n    position: unset !important;\n  }\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noWrap, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noWrap {\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-lineThrough, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-lineThrough {\n  text-decoration: line-through;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults {\n  display: flex;\n  align-items: center;\n  padding: 2px 10px;\n  margin: 2px 0;\n  border-radius: 5px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults {\n  color: rgb(254, 80, 0);\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem:hover, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults:hover {\n  background-color: rgb(227, 227, 227);\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem.athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem.athenaeum-dropdown-noResults {\n  color: white;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem:hover, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem.athenaeum-dropdown-noResults:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem.athenaeum-dropdown-noResults:hover {\n  color: #337ab7;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem span, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults {\n  border-radius: 0;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div {\n  padding-top: 2px;\n  padding-bottom: 3px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > span, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > span {\n  display: inline;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > small, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > small {\n  margin-left: 0.5em;\n  font-size: 75%;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-iconContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-iconContainer, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-iconContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-iconContainer {\n  padding: 5px;\n  margin-right: 10px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item span, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults span {\n  display: block;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item small, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults small {\n  text-transform: capitalize;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-minus, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-minus, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-minus, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-minus {\n  font-size: 1.5em;\n  margin-right: 5px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle {\n  width: 100%;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle span, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle span {\n  display: inline;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle .athenaeum-dropdown-amountUnit, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle .athenaeum-dropdown-amountUnit, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle .athenaeum-dropdown-amountUnit, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle .athenaeum-dropdown-amountUnit {\n  padding-left: 5px;\n  color: lightgray;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountDisabled, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountDisabled, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountDisabled, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountDisabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amount, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amount, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amount, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amount {\n  font-size: 1.5em;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-plus, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-plus, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-plus, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-plus {\n  font-size: 1.5em;\n  margin-left: 5px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-notCompleted, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-notCompleted, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-notCompleted, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-notCompleted {\n  margin-right: 0;\n  margin-left: auto;\n  padding-left: 8px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-notCompleted > img, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-notCompleted > img, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-notCompleted > img, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-notCompleted > img {\n  height: 20px;\n  min-height: 16px;\n  min-width: 16px;\n  max-width: 24px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-group, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-group, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-group:hover, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-group:active {\n  cursor: default;\n  color: #e3e3e3 !important;\n  background-color: inherit !important;\n  font-size: 12px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-groupSeparator, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-groupSeparator {\n  margin: 6px 2px;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-selectedItem, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-selectedItem {\n  background-color: #337ab7;\n  color: white;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemGroupIdent, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemGroupIdent {\n  padding-left: 20px !important;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-opened, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-opened {\n  visibility: visible;\n  position: initial;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults {\n  padding: 0;\n  cursor: default;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults:hover {\n  background-color: transparent;\n}\n\n.athenaeum-dropdown-dropdown {\n  cursor: pointer;\n  position: relative;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-hovered, .athenaeum-dropdown-dropdown .athenaeum-dropdown-selected:hover {\n  background-color: rgb(227, 227, 227);\n  border-color: #adadad;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-focused {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  white-space: nowrap;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected.athenaeum-dropdown-toggleButtonVisible {\n  visibility: visible;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected.athenaeum-dropdown-clearButtonVisible {\n  visibility: visible;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer > div {\n  margin-left: 6px;\n  align-items: center;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer > div.athenaeum-dropdown-clearButton {\n  display: flex;\n  padding: 4px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer > div.athenaeum-dropdown-clearButton:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer > div.athenaeum-dropdown-toggleButton {\n  display: flex;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer {\n  height: auto;\n  position: absolute;\n  background-color: rgb(254, 80, 0);\n  width: auto;\n  min-width: 100%;\n  left: auto;\n  right: 0;\n  bottom: 0;\n  border-radius: 5px;\n  color: white;\n  margin: 2px 0;\n  padding: 3px 0;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 150;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-alignLeft {\n  left: 0;\n  right: auto;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-alignTop {\n  bottom: 35px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-alignBottom {\n  bottom: auto;\n  top: auto;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-opened {\n  visibility: visible;\n  position: absolute;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList {\n  position: unset !important;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults {\n  color: white;\n  padding: 0 12px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-iconContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-iconContainer {\n  padding: 2px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-checkbox, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-checkbox {\n  margin-left: auto;\n  padding-left: 10px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults {\n  border-radius: 0;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div {\n  padding-top: 2px;\n  padding-bottom: 3px;\n  width: auto;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > span {\n  display: inline;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > small {\n  margin-left: 0.5em;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 75%;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter {\n  padding: 4px 8px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean {\n  color: black !important;\n  right: 16px;\n  margin-top: 0;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton {\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton > span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults {\n  cursor: default;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults:hover {\n  background-color: transparent;\n}\n\n.athenaeum-dropdown-dropdownWidget {\n  width: calc(100% + 24px);\n  left: -12px;\n  bottom: -36px;\n}\n\n.athenaeum-dropdown-transparent {\n  background-color: transparent;\n  border: none;\n}\n.athenaeum-dropdown-transparent:hover i.athenaeum-dropdown-transparent {\n  visibility: visible;\n}\n.athenaeum-dropdown-transparent.athenaeum-dropdown-selected:hover {\n  background-color: rgba(227, 227, 226, 0.5);\n}\n.athenaeum-dropdown-transparent:not(.athenaeum-dropdown-selected) {\n  margin: -6px 0px -6px -12px;\n}\n\ni.athenaeum-dropdown-transparent {\n  visibility: hidden;\n}\n\n.athenaeum-dropdown-small {\n  min-width: 52px;\n}\n.athenaeum-dropdown-small > div:first-child {\n  padding: 0.375rem;\n  height: auto;\n}\n.athenaeum-dropdown-small > div:first-child span {\n  font-size: 0.8rem;\n}";
var styles$L = {"font-renta":"athenaeum-dropdown-font-renta","list":"athenaeum-dropdown-list","dropdown":"athenaeum-dropdown-dropdown","disabled":"athenaeum-dropdown-disabled","selected":"athenaeum-dropdown-selected","itemsContainer":"athenaeum-dropdown-itemsContainer","filter":"athenaeum-dropdown-filter","clean":"athenaeum-dropdown-clean","addButton":"athenaeum-dropdown-addButton","scrollableContainer":"athenaeum-dropdown-scrollableContainer","itemsList":"athenaeum-dropdown-itemsList","noWrap":"athenaeum-dropdown-noWrap","lineThrough":"athenaeum-dropdown-lineThrough","item":"athenaeum-dropdown-item","noResults":"athenaeum-dropdown-noResults","listItem":"athenaeum-dropdown-listItem","selectedItem":"athenaeum-dropdown-selectedItem","inlineSubtext":"athenaeum-dropdown-inlineSubtext","iconContainer":"athenaeum-dropdown-iconContainer","minus":"athenaeum-dropdown-minus","amountTitle":"athenaeum-dropdown-amountTitle","amountUnit":"athenaeum-dropdown-amountUnit","amountDisabled":"athenaeum-dropdown-amountDisabled","amount":"athenaeum-dropdown-amount","plus":"athenaeum-dropdown-plus","notCompleted":"athenaeum-dropdown-notCompleted","group":"athenaeum-dropdown-group","groupSeparator":"athenaeum-dropdown-groupSeparator","itemGroupIdent":"athenaeum-dropdown-itemGroupIdent","opened":"athenaeum-dropdown-opened","hovered":"athenaeum-dropdown-hovered","focused":"athenaeum-dropdown-focused","toggleButtonVisible":"athenaeum-dropdown-toggleButtonVisible","clearButtonVisible":"athenaeum-dropdown-clearButtonVisible","toggleButtonContainer":"athenaeum-dropdown-toggleButtonContainer","clearButton":"athenaeum-dropdown-clearButton","toggleButton":"athenaeum-dropdown-toggleButton","alignLeft":"athenaeum-dropdown-alignLeft","alignTop":"athenaeum-dropdown-alignTop","alignBottom":"athenaeum-dropdown-alignBottom","checkbox":"athenaeum-dropdown-checkbox","dropdownWidget":"athenaeum-dropdown-dropdownWidget","transparent":"athenaeum-dropdown-transparent","small":"athenaeum-dropdown-small"};
styleInject(css_248z$S);

class DropdownListItem extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  canDecrease(item) {
    return item.amount >= item.step;
  }
  lastBeforeZero(item) {
    return item.amount === item.step;
  }
  decreaseAsync(e, item) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      item.amount = Utility.roundE(item.amount - item.step);
      yield this.props.onChangeAmount(this, item);
      yield this.reRenderAsync();
    });
  }
  canIncrease(item) {
    return item.amount <= 1000 - item.step;
  }
  increaseAsync(e, item) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      item.amount = Utility.roundE(item.amount + item.step);
      yield this.props.onChangeAmount(this, item);
      yield this.reRenderAsync();
    });
  }
  renderAmountListItem(item) {
    const noWrapCss = this.props.noWrap && styles$L.noWrap;
    const icon = this.lastBeforeZero(item) ? "far times-circle" : "far minus-circle";
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: this.css(styles$L.minus, !this.canDecrease(item) && styles$L.amountDisabled),
      onClick: e => this.decreaseAsync(e, item)
    }, React.createElement(Icon, {
      name: icon
    })), React.createElement("div", {
      className: this.css(styles$L.amountTitle, noWrapCss)
    }, React.createElement("span", null, ReactUtility.toTags(DropdownLocalizer$1.get(item.text))), !this.props.subtextHidden && React.createElement("small", {
      className: styles$L.amountUnit
    }, ReactUtility.toTags(DropdownLocalizer$1.get(item.subtext)))), React.createElement("div", {
      className: styles$L.amount
    }, React.createElement("span", null, item.amountValue)), React.createElement("div", {
      className: this.css(styles$L.plus, !this.canIncrease(item) && styles$L.amountDisabled),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.increaseAsync(e, item);
      })
    }, React.createElement(Icon, {
      name: "far plus-circle"
    })));
  }
  renderStatusListItem(item) {
    const noWrapCss = this.props.noWrap && styles$L.noWrap;
    const lineThroughCss = item.lineThrough && styles$L.lineThrough;
    const icon = item.completed === true ? null : item.completed === false ? "fal exclamation-square" : item.completed;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: this.css(noWrapCss, lineThroughCss)
    }, React.createElement("span", null, ReactUtility.toTags(DropdownLocalizer$1.get(item.text))), !this.props.subtextHidden && !!item.subtext && React.createElement("small", null, ReactUtility.toTags(DropdownLocalizer$1.get(item.subtext)))), icon != null && React.createElement("div", {
      className: this.css(styles$L.notCompleted)
    }, Icon.renderIcon(icon, null, IconSize.Normal)));
  }
  renderListItem(item) {
    const noWrapCss = this.props.noWrap && styles$L.noWrap;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: this.css(noWrapCss)
    }, React.createElement("span", null, ReactUtility.toTags(DropdownLocalizer$1.get(item.text))), !this.props.subtextHidden && React.createElement("small", null, ReactUtility.toTags(DropdownLocalizer$1.get(item.subtext)))));
  }
  render() {
    const item = this.props.item;
    const isAmount = item.isAmountListItem;
    const isStatus = item.isStatusListItem;
    return React.createElement(React.Fragment, null, isAmount ? this.renderAmountListItem(item) : isStatus ? this.renderStatusListItem(item) : this.renderListItem(item));
  }
}

const FILTER_MIN_SYMBOLS = 0;
const FILTER_MIN_LENGTH = 6;
const FILTER_MAX_LENGTH = 1000;
const SELECTED_TEXT_FORMAT = 3;
const EXPAND_TOP_PADDING = 150;
class AmountListItem extends SelectListItem {
  constructor() {
    super(...arguments);
    this.step = 1.0;
    this.amount = 0.0;
    this.isAmountListItem = true;
  }
  get amountValue() {
    return this.step >= 1 ? Utility.format(`{0:0}`, this.amount) : Utility.format(`{0:0.0}`, this.amount);
  }
}
var DropdownSchema;
(function (DropdownSchema) {
  DropdownSchema[DropdownSchema["Default"] = 0] = "Default";
  DropdownSchema[DropdownSchema["Widget"] = 1] = "Widget";
  DropdownSchema[DropdownSchema["Transparent"] = 2] = "Transparent";
})(DropdownSchema || (DropdownSchema = {}));
var DropdownType;
(function (DropdownType) {
  DropdownType["Dropdown"] = "dropdown";
  DropdownType["List"] = "list";
})(DropdownType || (DropdownType = {}));
var DropdownOrderBy;
(function (DropdownOrderBy) {
  DropdownOrderBy[DropdownOrderBy["Name"] = 0] = "Name";
  DropdownOrderBy[DropdownOrderBy["Value"] = 1] = "Value";
  DropdownOrderBy[DropdownOrderBy["None"] = 2] = "None";
})(DropdownOrderBy || (DropdownOrderBy = {}));
var DropdownAlign;
(function (DropdownAlign) {
  DropdownAlign[DropdownAlign["Right"] = 0] = "Right";
  DropdownAlign[DropdownAlign["Left"] = 1] = "Left";
})(DropdownAlign || (DropdownAlign = {}));
var DropdownVerticalAlign;
(function (DropdownVerticalAlign) {
  DropdownVerticalAlign[DropdownVerticalAlign["Bottom"] = 0] = "Bottom";
  DropdownVerticalAlign[DropdownVerticalAlign["Top"] = 1] = "Top";
  DropdownVerticalAlign[DropdownVerticalAlign["Auto"] = 2] = "Auto";
})(DropdownVerticalAlign || (DropdownVerticalAlign = {}));
var DropdownSelectType;
(function (DropdownSelectType) {
  DropdownSelectType[DropdownSelectType["Background"] = 0] = "Background";
  DropdownSelectType[DropdownSelectType["Checkbox"] = 1] = "Checkbox";
})(DropdownSelectType || (DropdownSelectType = {}));
var DropdownSubtextType;
(function (DropdownSubtextType) {
  DropdownSubtextType[DropdownSubtextType["Row"] = 0] = "Row";
  DropdownSubtextType[DropdownSubtextType["Inline"] = 1] = "Inline";
  DropdownSubtextType[DropdownSubtextType["Hidden"] = 2] = "Hidden";
})(DropdownSubtextType || (DropdownSubtextType = {}));
var DropdownRequiredType;
(function (DropdownRequiredType) {
  /**
   * No auto selection. User can un-select required item.
   */
  DropdownRequiredType[DropdownRequiredType["Manual"] = 0] = "Manual";
  /**
   * No auto selection. User cannot un-select required item.
   */
  DropdownRequiredType[DropdownRequiredType["Restricted"] = 1] = "Restricted";
  /**
   * First item will be selected automatically. User cannot un-select required item.
   */
  DropdownRequiredType[DropdownRequiredType["AutoSelect"] = 2] = "AutoSelect";
})(DropdownRequiredType || (DropdownRequiredType = {}));
class Dropdown extends BaseInput {
  constructor() {
    super(...arguments);
    this._filterInputRef = React.createRef();
    this._scrollableContainerRef = React.createRef();
    this._listContainerRef = React.createRef();
    this._itemsListRef = React.createRef();
    this._language = DropdownLocalizer$1.language;
    this._maxHeight = null;
    this._isLongList = false;
    this._autoScroll = true;
    this._itemsHashCode = null;
    this.state = {
      items: [],
      filteredItems: [],
      validationError: null,
      readonly: this.props.disabled || false,
      model: {
        value: null
      },
      expanded: this.props.expanded || false,
      edit: true,
      availableHeight: 0
    };
  }
  onFilterInputClick() {
    const filterAutoFocus = this.desktop ? this.props.filterAutoFocus !== false : this.props.filterAutoFocus == true;
    if (filterAutoFocus && this._filterInputRef.current) {
      this._filterInputRef.current.focus();
    }
  }
  dynamicTransform(item) {
    var _a;
    if (typeof item === "string") {
      const selectListItem = new SelectListItem(item, item);
      selectListItem.ref = item;
      return selectListItem;
    }
    if (typeof item === "number") {
      const value = item.toString();
      const selectListItem = new SelectListItem(value, value);
      selectListItem.ref = item;
      return selectListItem;
    }
    const provider = ServiceProvider.getService("ITransformProvider");
    if (provider != null) {
      const selectListItem = provider.toSelectListItem(item);
      selectListItem.ref = item;
      return selectListItem;
    }
    const anyItem = item;
    const converter = (_a = TypeConverter.getConverter(anyItem, "ISelectListItem")) !== null && _a !== void 0 ? _a : TypeConverter.getConverter(anyItem, SelectListItem);
    if (converter != null) {
      const selectListItem = typeof converter === "function" ? converter(item) : converter.convert(item);
      selectListItem.ref = item;
      return selectListItem;
    }
    const id = Utility.findValueByAccessor(item, ["id", "code"]);
    const value = Utility.findStringValueByAccessor(item, ["value"]);
    const name = Utility.findStringValueByAccessor(item, ["name", "text", "label"]);
    const subtext = Utility.findStringValueByAccessor(item, ["subtext", "description"]);
    const favorite = Utility.findStringValueByAccessor(item, "favorite") === "true";
    const groupName = Utility.findStringValueByAccessor(item, ["group", "group.name"]);
    const deleted = Utility.findValueByAccessor(item, ["delete", "isDeleted"]);
    const completed = Utility.findValueByAccessor(item, ["completed", "isCompleted", "status"]);
    const isDeleted = deleted === true || deleted == "1";
    const hasCompleted = completed != null && (typeof completed === "boolean" || typeof completed === "string" || completed instanceof FileModel || completed.isFileModel || completed.name);
    const selectListItem = isDeleted || hasCompleted ? new StatusListItem(isDeleted, completed !== null && completed !== void 0 ? completed : true) : new SelectListItem();
    selectListItem.value = value ? value : id != null ? id.toString() : name ? name : Utility.getComponentId();
    selectListItem.text = name !== null && name !== void 0 ? name : "";
    selectListItem.subtext = subtext !== null && subtext !== void 0 ? subtext : "";
    selectListItem.favorite = favorite;
    selectListItem.group = groupName ? SelectListGroup.create(groupName) : null;
    selectListItem.ref = item;
    return selectListItem;
  }
  transform(item) {
    const anyItem = item;
    const listItem = anyItem.isSelectListSeparator ? anyItem : anyItem.isSelectListItem ? anyItem : this.props.transform ? this.props.transform(item) : this.dynamicTransform(item);
    if (listItem.ref == null) {
      listItem.ref = item;
    }
    return listItem;
  }
  noItemsFound() {
    return this.filterValue.length > 0 && !this._isLongList && (this.filteredItems.length == 0 || this.favorite && !this.filterFavorite && this.filteredItems.every(item => item.favorite));
  }
  isLongList(items = null, filterValue = null) {
    items = items || this.state.items;
    filterValue = filterValue || this.filterValue;
    return items.length > this.filterMaxLength || filterValue.length < this.filterMinSymbols;
  }
  filterComparator(filter, item) {
    return item.lowerText.includes(filter) || item.lowerSubtext.includes(filter) || item.group != null && item.group.lowerName.includes(filter);
  }
  filter(items) {
    let filter = this.filterValue;
    this._isLongList = this.isLongList(items, filter);
    if (filter) {
      const showFavorite = this.favorite && !this.filterFavorite;
      const customComparator = this.props.filter;
      const filterComparator = this.filterComparator;
      const comparator = customComparator ? (filter, item) => customComparator(filter, item, filterComparator) : filterComparator;
      filter = filter.toLowerCase();
      items = items.filter(item => showFavorite && item.favorite || comparator(filter, item));
      this._isLongList = this.isLongList(items, filter);
      if (this._isLongList) {
        items = [];
      }
    } else if (this._isLongList) {
      items = this.favorite ? items.filter(item => item.favorite) : [];
    }
    return items;
  }
  processMaxHeightProp() {
    this._maxHeight = null;
    if (this._itemsListRef.current && typeof this.props.maxHeight === "function") {
      const maxHeight = this.getMaxHeightValue();
      if (maxHeight != undefined) {
        this._maxHeight = maxHeight;
        const element = this.JQuery(this._itemsListRef.current);
        element.css("max-height", maxHeight);
      }
    }
  }
  getMaxHeightValue() {
    const filterHeight = 42;
    const defaultMaxHeight = 316;
    let maxHeight;
    const maxHeightProp = this.props.maxHeight;
    if (maxHeightProp) {
      const maxHeightType = typeof maxHeightProp;
      if (maxHeightType === "string") {
        maxHeight = maxHeightProp;
      } else if (maxHeightType === "number") {
        maxHeight = maxHeightProp;
      } else if (maxHeightType === "function") {
        maxHeight = maxHeightProp();
      }
    }
    if (this.hasFilter && maxHeight && typeof maxHeight === "number") {
      maxHeight = maxHeight - filterHeight;
    }
    return maxHeight || defaultMaxHeight;
  }
  order(items) {
    const groupSelected = !!this.props.groupSelected;
    switch (this.orderBy) {
      case DropdownOrderBy.Name:
        items = items.sort((x, y) => SelectListItem.CompareByName(x, y, groupSelected));
        break;
      case DropdownOrderBy.Value:
        items = items.sort((x, y) => SelectListItem.CompareByValue(x, y, groupSelected));
        break;
      case DropdownOrderBy.None:
        if (this.grouping) {
          items = items.sort((x, y) => SelectListItem.CompareByGroup(x, y, groupSelected));
        }
        break;
    }
    return items;
  }
  updateModelValue() {
    const value = this.multiple ? this.selectedListItems.filter(item => item.selected).map(item => item.value) : this.selectedListItem != null ? this.selectedListItem.value : null;
    if (value !== this.state.model.value) {
      this.state.model.value = value;
    }
  }
  getVerticalAlign() {
    var _a;
    let align = (_a = this.props.verticalAlign) !== null && _a !== void 0 ? _a : DropdownVerticalAlign.Auto;
    if (align !== DropdownVerticalAlign.Auto) {
      return align;
    }
    const dropdownNode = this.getNode();
    if (!dropdownNode.length) {
      align = DropdownVerticalAlign.Bottom;
      return align;
    }
    const viewPortHeight = window.innerHeight;
    const pageYOffset = window.pageYOffset;
    const dropdownNodeTop = dropdownNode.offset().top - pageYOffset + dropdownNode.height() * 2;
    const listContainer = this._listContainerRef.current;
    const listContainerHeight = listContainer ? listContainer.clientHeight : 0;
    const availableBottomHeight = viewPortHeight - dropdownNodeTop;
    const fitBottom = availableBottomHeight > listContainerHeight;
    const fitTop = dropdownNodeTop > listContainerHeight + EXPAND_TOP_PADDING;
    if (fitBottom) {
      align = DropdownVerticalAlign.Bottom;
    } else if (fitTop) {
      align = DropdownVerticalAlign.Top;
    } else {
      align = DropdownVerticalAlign.Bottom;
    }
    return align;
  }
  getFilteredItems() {
    return this.props.groupSelected ? this.order(this.state.filteredItems) : this.state.filteredItems;
  }
  getSelectedListItems(items) {
    if (SelectListItem.is(items)) {
      const selectedListItems = items.where(item => item.selected);
      return selectedListItems.length > 0 ? selectedListItems : null;
    }
    return null;
  }
  getSelectedListItem(items) {
    if (SelectListItem.is(items)) {
      return items.find(item => item.selected) || null;
    }
    return null;
  }
  hasVisibleGroup(item) {
    return this.grouping && !item.favorite && item.group != null && item.group.name.length > 0 && (!this.groupSelected || !item.selected);
  }
  firstInGroup(item, index, hasVisibleGroup) {
    if (hasVisibleGroup) {
      const firstGroup = index == 0;
      if (firstGroup) {
        return true;
      }
      const previousItem = this.filteredItems[index - 1];
      const newGroup = !SelectListGroup.isEqual(previousItem.group, item.group);
      if (newGroup) {
        return true;
      }
      if (this.favorite) {
        const firstNotFavorite = previousItem.favorite;
        if (firstNotFavorite) {
          return true;
        }
      }
      if (this.groupSelected) {
        const firstNotSelected = previousItem.selected;
        if (firstNotSelected) {
          return true;
        }
      }
    }
    return false;
  }
  invokeOnAddAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onAdd) {
        yield this.props.onAdd(this);
      }
      yield this.toggleAsync();
    });
  }
  invokeOnItemsChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemsChange) {
        yield this.props.onItemsChange(this);
      }
    });
  }
  getItem(item) {
    return item.selected ? item.ref != null ? item.ref : item : null;
  }
  invokeOnChangeAsync(item, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        const selectedItem = this.getItem(item);
        yield this.props.onChange(this, selectedItem, userInteraction);
      }
    });
  }
  invokeOnItemClickAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemClick) {
        const selectedItem = this.getItem(item);
        yield this.props.onItemClick(this, selectedItem);
      }
    });
  }
  onListContainerClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
    });
  }
  onChangeAmountAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChangeAmount) {
        yield this.props.onChangeAmount(this, item.ref, item.amount);
      }
    });
  }
  selectDefaultAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const autoSelect = this.requiredType == DropdownRequiredType.AutoSelect;
      if (autoSelect) {
        const items = this.state.items;
        if (items.length > 0) {
          const unselected = items.every(item => !item.selected);
          if (unselected) {
            const firstItem = items[0];
            yield this.invokeSelectListItemAsync(firstItem, false);
          }
        }
      }
    });
  }
  selectItemHandlerAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      const autoCollapse = this.autoCollapse;
      if (this.multiple) {
        const restricted = item.selected && this.requiredType != DropdownRequiredType.Manual && this.selectedItems.length === 1;
        let expanded = this.expanded;
        if (!restricted) {
          item.selected = !item.selected;
          this.updateModelValue();
        }
        if (expanded && autoCollapse) {
          expanded = false;
          if (this.props.onToggle) {
            yield this.props.onToggle(this, expanded);
          }
        }
        if (this.isMounted) {
          const filteredItems = this.getFilteredItems();
          yield this.setState({
            filteredItems,
            expanded
          });
          yield this.invokeOnChangeAsync(item, true);
        }
      } else {
        const unselectable = this.requiredType == DropdownRequiredType.Manual;
        if (!item.selected) {
          this.selectedListItems.map(item => item.selected = false);
          item.selected = true;
          this.updateModelValue();
          let expanded = this.expanded;
          if (autoCollapse) {
            expanded = false;
            if (this.props.onToggle) {
              yield this.props.onToggle(this, expanded);
            }
          }
          if (this.isMounted) {
            this.updateModelValue();
            const filteredItems = this.getFilteredItems();
            yield this.setState({
              filteredItems,
              expanded
            });
            yield this.invokeOnChangeAsync(item, true);
          }
        } else if (unselectable) {
          this.selectedListItems.map(item => item.selected = false);
          item.selected = false;
          let expanded = this.expanded;
          if (autoCollapse) {
            expanded = false;
            if (this.props.onToggle) {
              yield this.props.onToggle(this, expanded);
            }
          }
          if (this.isMounted) {
            this.updateModelValue();
            const filteredItems = this.getFilteredItems();
            yield this.setState({
              filteredItems,
              expanded
            });
            yield this.invokeOnChangeAsync(item, true);
          }
        } else {
          if (autoCollapse) {
            yield this.collapseAsync();
          }
        }
      }
      yield this.invokeOnItemClickAsync(item);
    });
  }
  clearSelectedAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.invokeUnselectAllAsync(true);
    });
  }
  cleanFilterAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._filterInputRef.current.value = "";
      yield this.filterHandlerAsync();
    });
  }
  initializeItemsAsync(items, selectedItem, selectedItems) {
    return __awaiter(this, void 0, void 0, function* () {
      const prevSelectedItem = this.selectedListItem;
      const selectItems = items.map(item => this.transform(item));
      let filteredItems = this.filter(selectItems);
      filteredItems = this.order(filteredItems);
      yield this.setState({
        items: selectItems,
        filteredItems: filteredItems
      });
      if (this.multiple && selectedItems != null) {
        yield this.invokeSelectAsync(selectedItems, false);
      } else if (selectedItem != null) {
        yield this.invokeSelectAsync(selectedItem, false);
      }
      yield this.selectDefaultAsync();
      this.updateModelValue();
      this.state.validationError = null;
      const newSelectedItem = this.selectedListItem;
      if (newSelectedItem != null) {
        const callback = prevSelectedItem == null || prevSelectedItem.value != newSelectedItem.value;
        if (callback) {
          yield this.invokeOnChangeAsync(newSelectedItem, false);
        }
      }
      yield this.invokeOnItemsChangeAsync();
    });
  }
  invokeSelectListItemsAsync(items, callback, userInteraction = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.multiple && items != null) {
        const itemValues = new Set();
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const value = typeof item === "string" ? item : typeof item === "number" ? item.toString() : item.value;
          if (!itemValues.has(value)) {
            itemValues.add(value);
          }
        }
        const listItems = this.listItems;
        const updated = [];
        for (let i = 0; i < listItems.length; i++) {
          const listItem = listItems[i];
          const selected = itemValues.has(listItem.value);
          if (listItem.selected !== selected) {
            updated.push(listItem);
            listItem.selected = selected;
          }
        }
        if (updated) {
          this.updateModelValue();
          if (callback) {
            for (let i = 0; i < updated.length; i++) {
              yield this.invokeOnChangeAsync(updated[i], userInteraction);
            }
          }
          if (this.isMounted) {
            const filteredItems = this.getFilteredItems();
            yield this.setState({
              filteredItems
            });
          }
        }
      }
    });
  }
  invokeSelectAsync(itemOrItems, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      if (itemOrItems != null) {
        if (Array.isArray(itemOrItems)) {
          const listItems = [];
          for (let i = 0; i < itemOrItems.length; i++) {
            const listItem = this.find(itemOrItems[i]);
            if (listItem != null) {
              listItems.push(listItem);
            }
          }
          yield this.invokeSelectListItemsAsync(listItems, callback);
        } else {
          const listItem = this.find(itemOrItems);
          yield this.invokeSelectListItemAsync(listItem, callback);
        }
      }
    });
  }
  invokeSelectListItemAsync(item, callback, userInteraction = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (item != null) {
        const itemValue = typeof item === "string" ? item : typeof item === "number" ? item.toString() : item.value;
        const listItem = this.find(itemValue);
        if (listItem != null && !listItem.selected) {
          if (!this.multiple) {
            this.selectedListItems.map(item => item.selected = false);
          }
          listItem.selected = true;
          this.updateModelValue();
          if (callback) {
            yield this.invokeOnChangeAsync(listItem, userInteraction);
          }
          if (this.isMounted) {
            const filteredItems = this.getFilteredItems();
            yield this.setState({
              filteredItems
            });
          }
        }
      } else if (!this.multiple && this.selectedListItem != null) {
        const listItem = this.selectedListItem;
        listItem.selected = false;
        this.updateModelValue();
        if (callback) {
          yield this.invokeOnChangeAsync(listItem, userInteraction);
        }
        if (this.isMounted) {
          const filteredItems = this.getFilteredItems();
          yield this.setState({
            filteredItems
          });
        }
      }
    });
  }
  favoriteItemHandlerAsync(e, item) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      if (this.favorite) {
        item.favorite = !item.favorite;
        if (this.props.onFavoriteChange) {
          yield this.props.onFavoriteChange(this, item.ref, item.favorite);
        }
        const filteredItems = this.order(this.state.filteredItems);
        yield this.setState({
          filteredItems
        });
      }
    });
  }
  invokeUnselectAllAsync(userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.multiple && this.selectedListItems.length > 0) {
        yield this.invokeSelectListItemsAsync([], true, userInteraction);
      } else if (this.selectedListItem) {
        yield this.invokeSelectListItemAsync(null, true, userInteraction);
      }
    });
  }
  filterHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let filteredItems = this.filter(this.listItems);
      filteredItems = this.order(filteredItems);
      yield this.setState({
        filteredItems
      });
    });
  }
  get filterValue() {
    return this._filterInputRef.current != null && this.hasFilter ? this._filterInputRef.current.value : "";
  }
  get filteredItems() {
    return this.state.filteredItems;
  }
  get isListType() {
    return this.props.type === DropdownType.List;
  }
  get isDropdownType() {
    return !this.isListType;
  }
  get styleSchema() {
    return this.props.styleSchema || DropdownSchema.Default;
  }
  getType() {
    return BaseInputType.Dropdown;
  }
  ignoreValueProps() {
    return true;
  }
  get autoCollapse() {
    return this.isListType ? false : this.props.autoCollapse != null ? this.props.autoCollapse : !this.multiple;
  }
  get multiple() {
    return this.props.multiple || false;
  }
  get required() {
    return this.props.required || false;
  }
  get requiredType() {
    return this.required ? this.props.requiredType != null ? this.props.requiredType : DropdownRequiredType.AutoSelect : DropdownRequiredType.Manual;
  }
  get clearButton() {
    return this.props.clearButton === true && this.requiredType == DropdownRequiredType.Manual;
  }
  get favorite() {
    var _a;
    return (_a = this.props.favorite) !== null && _a !== void 0 ? _a : false;
  }
  get filterFavorite() {
    var _a;
    return (_a = this.props.filterFavorite) !== null && _a !== void 0 ? _a : false;
  }
  get grouping() {
    return this.props.noGrouping != true;
  }
  get groupSelected() {
    return this.props.groupSelected || false;
  }
  get expanded() {
    return this.state.expanded;
  }
  get collapsed() {
    return !this.expanded;
  }
  get orderBy() {
    return this.props.orderBy || DropdownOrderBy.Name;
  }
  getValidators() {
    return [];
  }
  get listItems() {
    return this.state.items;
  }
  get selectedListItems() {
    const items = this.state.items.filter(item => item.selected);
    //If no items (data) yet, return props.selectedItems if it is specified
    if (this.multiple && items.length == 0 && this.listItems.length === 0) {
      const selectedItems = this.props.selectedItems || null;
      if (selectedItems && typeof selectedItems[0] === "object") {
        return selectedItems.map(item => this.transform(item));
      }
    }
    return items;
  }
  get selectedListItem() {
    if (this.multiple) {
      return null;
    }
    const items = this.selectedListItems;
    if (items.length >= 1) {
      return items[0];
    }
    //If no items (data) yet, return props.selectedItem if it is specified
    if (this.listItems.length === 0) {
      const selectedItem = this.props.selectedItem || null;
      if (selectedItem != null && typeof selectedItem === "object") {
        return this.transform(selectedItem);
      }
      return null;
    }
    return null;
  }
  get items() {
    return this.listItems.map(item => item.ref);
  }
  get selectedItems() {
    return this.selectedListItems.map(item => item.ref);
  }
  get selectedValues() {
    return this.selectedListItems.map(item => item.value);
  }
  get selectedItem() {
    const selectedListItem = this.selectedListItem;
    return selectedListItem ? selectedListItem.ref : null;
  }
  get selectedValue() {
    const selectedListItem = this.selectedListItem;
    return selectedListItem ? selectedListItem.value : null;
  }
  get align() {
    return this.props.align || DropdownAlign.Right;
  }
  get filterMinSymbols() {
    return this.props.filterMinSymbols != null && this.props.filterMinSymbols >= 0 ? this.props.filterMinSymbols : FILTER_MIN_SYMBOLS;
  }
  get filterMinLength() {
    return this.props.filterMinLength != null && this.props.filterMinLength >= 0 ? this.props.filterMinLength : FILTER_MIN_LENGTH;
  }
  get filterMaxLength() {
    return this.props.filterMaxLength != null && this.props.filterMaxLength >= 0 ? this.props.filterMaxLength : FILTER_MAX_LENGTH;
  }
  get hasFilter() {
    return !this.props.noFilter && this.listItems.length >= this.filterMinLength;
  }
  get hasAddButton() {
    return !!this.props.addButton;
  }
  get disabled() {
    return this.readonly;
  }
  get selectType() {
    return this.props.selectType || DropdownSelectType.Background;
  }
  get subtextType() {
    return this.props.subtextType || DropdownSubtextType.Row;
  }
  get selectedTextFormat() {
    return this.props.selectedTextFormat ? typeof this.props.selectedTextFormat === "number" ? this.props.selectedTextFormat : SELECTED_TEXT_FORMAT : null;
  }
  get noSubtext() {
    return this.props.noSubtext === true;
  }
  get hasSelected() {
    return this.multiple ? this.selectedListItems.length > 0 : this.selectedListItem != null;
  }
  get trackChanges() {
    return this.props.trackChanges === true;
  }
  unselectAllAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeUnselectAllAsync(false);
    });
  }
  selectItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      const listItem = item != null ? this.transform(item) : null;
      yield this.invokeSelectListItemAsync(listItem, true);
    });
  }
  selectAsync(itemOrItems) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSelectAsync(itemOrItems, true);
    });
  }
  selectListItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSelectListItemAsync(item, true);
    });
  }
  selectListItemsAsync(items) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSelectListItemsAsync(items, true);
    });
  }
  selectFirstAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.listItems.length > 0) {
        yield this.invokeSelectListItemAsync(this.listItems[0], true);
      }
    });
  }
  hideEditAsync() {
    const _super = Object.create(null, {
      hideEditAsync: {
        get: () => super.hideEditAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.hideEditAsync.call(this);
      yield this.collapseAsync();
    });
  }
  showEditAsync(select) {
    const _super = Object.create(null, {
      showEditAsync: {
        get: () => super.showEditAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.showEditAsync.call(this, select);
      yield this.expandAsync();
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializeItemsAsync(this.props.items, this.props.selectedItem, this.props.selectedItems);
    });
  }
  isItemsModified(prevItems, items) {
    const isModified = !Comparator.isEqual(prevItems, items);
    if (isModified) {
      return true;
    }
    if (this.trackChanges) {
      const hashCode = HashCodeUtility.getHashCode(items);
      if (this._itemsHashCode !== hashCode) {
        const isFirstCall = this._itemsHashCode == null;
        this._itemsHashCode = hashCode;
        if (!isFirstCall) {
          return true;
        }
      }
    }
    return false;
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const props = this.props;
      const newExpanded = props.expanded !== nextProps.expanded;
      const newDisabled = props.disabled !== nextProps.disabled;
      const newGroupSelected = props.groupSelected !== nextProps.groupSelected;
      const newFavorite = props.favorite !== nextProps.favorite;
      const newRequired = props.required !== nextProps.required;
      const newMinFilerSymbols = props.filterMinSymbols !== nextProps.filterMinSymbols;
      //const newItems: boolean = (!Comparator.isEqual(props.items, nextProps.items));
      const newItems = this.isItemsModified(props.items, nextProps.items);
      const newSelectedListItem = !Comparator.isEqual(props.selectedItem, nextProps.selectedItem);
      const newSelectedListItems = !Comparator.isEqual(props.selectedItems, nextProps.selectedItems);
      const newLanguage = this._language !== DropdownLocalizer$1.language;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newExpanded || newDisabled) {
        this.state.expanded = nextProps.expanded || false;
        this.state.readonly = nextProps.disabled || false;
        yield this.setState(this.state);
      }
      if (newItems || newSelectedListItem || newSelectedListItems || newGroupSelected || newFavorite || newRequired || newMinFilerSymbols || newLanguage) {
        this._language = DropdownLocalizer$1.language;
        const selectedItem = newSelectedListItem ? nextProps.selectedItem : nextProps.selectedItem || this.getSelectedListItem(nextProps.items) || this.selectedItem;
        const selectedItems = newSelectedListItems ? nextProps.selectedItems : nextProps.selectedItems || this.getSelectedListItems(nextProps.items) || this.selectedItems;
        yield this.initializeItemsAsync(nextProps.items, selectedItem, selectedItems);
      }
    });
  }
  componentDidUpdate() {
    return __awaiter(this, void 0, void 0, function* () {
      this.processMaxHeightProp();
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const expanded = !this.state.expanded;
      if (this.props.onToggle) {
        yield this.props.onToggle(this, expanded);
      }
      if (this.isMounted) {
        yield this.setState({
          expanded
        });
        if (expanded) {
          if (this._autoScroll) {
            this._autoScroll = false;
            yield this.scrollToSelected(false);
          }
          this.onFilterInputClick();
        }
      }
    });
  }
  collapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.expanded) {
        yield this.toggleAsync();
      }
    });
  }
  expandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.expanded) {
        yield this.toggleAsync();
      }
    });
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializeItemsAsync(this.props.items, this.props.selectedItem, this.props.selectedItems);
    });
  }
  reRender() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderAsync();
  }
  find(item) {
    if (item != null && this.listItems) {
      const itemValue = typeof item === "string" ? item : typeof item === "number" ? item.toString() : this.transform(item).value;
      if (itemValue) {
        return this.listItems.find(item => item.value === itemValue) || null;
      }
    }
    return null;
  }
  scrollToSelected(smooth = false) {
    if (this.expanded) {
      const maxHeightIsLimited = !!this._maxHeight;
      const scrollableContainerElement = maxHeightIsLimited ? this._itemsListRef.current : this._scrollableContainerRef.current;
      if (scrollableContainerElement) {
        const selectedListItem = this.selectedListItem;
        if (selectedListItem) {
          const selectedItemElement = scrollableContainerElement.querySelector(`.${styles$L.selectedItem}`);
          if (selectedItemElement) {
            const scrollableContainerHeight = this.JQuery(scrollableContainerElement).height() || 0;
            const top = selectedItemElement.offsetTop;
            if (top > scrollableContainerHeight) {
              const behavior = smooth ? "smooth" : "auto";
              scrollableContainerElement.scrollTo({
                top,
                behavior
              });
            }
          }
        }
      }
    }
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isDropdownType && this.expanded) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id, this.props.toggleButtonId);
        if (outside) {
          yield this.collapseAsync();
        }
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.type !== DropdownType.List) {
        if (e.keyCode === 27) {
          yield this.collapseAsync();
        }
      }
    });
  }
  renderToggleButton() {
    let iconProps = {
      name: "fa-caret-down",
      style: IconStyle.Solid
    };
    if (this.styleSchema === DropdownSchema.Widget) {
      iconProps.name = "fa-bars";
      iconProps.size = IconSize.ExtraSmall;
    } else if (this.props.toggleIcon) {
      if (typeof this.props.toggleIcon == "string") {
        iconProps.name = this.props.toggleIcon;
      } else {
        iconProps = this.props.toggleIcon;
      }
    }
    return React.createElement("div", {
      className: styles$L.toggleButton
    }, React.createElement(Icon, Object.assign({}, iconProps, {
      size: IconSize.Normal
    })));
  }
  renderClearIcon() {
    return React.createElement("div", {
      className: this.css(styles$L.clearButton)
    }, React.createElement(Icon, {
      stopPropagation: true,
      name: "fa fa-times",
      size: IconSize.Normal,
      onClick: () => this.clearSelectedAsync()
    }));
  }
  renderToggleContainer(toggleButtonVisible, clearButtonVisible, className) {
    return React.createElement("div", {
      className: this.css(styles$L.toggleButtonContainer, className)
    }, clearButtonVisible && this.renderClearIcon(), toggleButtonVisible && this.renderToggleButton());
  }
  renderAddButton() {
    const addButton = this.props.addButton;
    let text;
    if (typeof addButton === "function") {
      const render = addButton(this);
      // noinspection SuspiciousTypeOfGuard
      if (typeof render !== "string") {
        return render;
      }
      text = render;
    } else if (typeof addButton === "string") {
      text = DropdownLocalizer$1.get(addButton);
    } else {
      text = DropdownLocalizer$1.add;
    }
    return React.createElement("div", {
      className: styles$L.addButton,
      onClick: () => this.invokeOnAddAsync()
    }, React.createElement(Button, {
      type: ButtonType.Orange,
      icon: {
        name: "fas plus"
      }
    }), React.createElement("span", null, text));
  }
  renderSelectedItem() {
    if (this.props.selectedItemTransform) {
      return this.props.selectedItemTransform(this);
    }
    const toggleButtonVisible = this.props.toggleIcon !== false;
    const clearButtonVisible = this.clearButton && this.hasSelected;
    const expandedStyle = this.styleSchema === DropdownSchema.Widget && this.state.expanded && this.css(styles$L.hovered, styles$L.focused);
    const transparentStyle = this.styleSchema === DropdownSchema.Transparent && styles$L.transparent;
    const toggleButtonVisibleStyle = toggleButtonVisible && styles$L.toggleButtonVisible;
    const clearButtonVisibleStyle = clearButtonVisible && styles$L.clearButtonVisible;
    const inlineStyles = {};
    if (this.props.textAlign) {
      inlineStyles.textAlign = StylesUtility.textAlign(this.props.textAlign);
      inlineStyles.width = "100%";
    }
    const noSubtext = this.noSubtext;
    const selectedListItem = this.selectedListItem;
    const title = selectedListItem !== null && noSubtext ? DropdownLocalizer$1.get(selectedListItem.subtext) : "";
    let text = this.props.selectedTextTransform ? this.props.selectedTextTransform(this) : "";
    if (!text) {
      text = selectedListItem !== null ? noSubtext ? DropdownLocalizer$1.get(selectedListItem.text) : `${DropdownLocalizer$1.get(selectedListItem.text)} <small>${DropdownLocalizer$1.get(selectedListItem.subtext)}</small>` : this.selectedListItems.length !== 0 ? this.props.multipleSelectedText ? DropdownLocalizer$1.multipleSelected : this.selectedTextFormat && this.selectedListItems.length <= this.selectedTextFormat ? noSubtext ? this.selectedListItems.take(this.selectedTextFormat).map(item => DropdownLocalizer$1.get(item.text)).join(", ") : this.selectedListItems.take(this.selectedTextFormat).map(item => item.subtext ? `${DropdownLocalizer$1.get(item.text)} <small>${DropdownLocalizer$1.get(item.subtext)}</small>` : DropdownLocalizer$1.get(item.text)).join(", ") : DropdownLocalizer$1.get(DropdownLocalizer$1.multipleSelected, this.selectedListItems.length) : this.props.nothingSelectedText ? DropdownLocalizer$1.get(this.props.nothingSelectedText) : DropdownLocalizer$1.nothingSelected;
    }
    return React.createElement("div", {
      className: this.css(styles$L.selected, "form-control", expandedStyle, transparentStyle, toggleButtonVisibleStyle, clearButtonVisibleStyle, "selected-item"),
      title: title,
      onClick: () => this.toggleAsync()
    }, React.createElement("span", {
      style: inlineStyles
    }, ReactUtility.toTags(text)), this.renderToggleContainer(toggleButtonVisible, clearButtonVisible, transparentStyle));
  }
  renderSelectListItem(item, index) {
    const isSeparator = item.isSelectListSeparator;
    const isListItem = !isSeparator;
    const hasVisibleGroup = isListItem && this.hasVisibleGroup(item);
    const needGroupSeparator = isListItem && this.firstInGroup(item, index, hasVisibleGroup);
    const selected = isListItem && item.selected;
    const favorite = isListItem && this.props.favorite === true;
    const checkbox = isListItem && this.selectType == DropdownSelectType.Checkbox;
    const listItemStyle = this.isListType && this.props.styleSchema !== DropdownSchema.Widget && styles$L.listItem;
    const inlineSubtextStyle = this.subtextType == DropdownSubtextType.Inline && styles$L.inlineSubtext;
    const selectedStyle = selected && !checkbox && styles$L.selectedItem;
    const customClassName = isListItem && item.isStatusListItem ? item.className : null;
    return React.createElement(React.Fragment, {
      key: index
    }, needGroupSeparator && React.createElement(React.Fragment, null, React.createElement(React.Fragment, null, index > 0 && React.createElement("hr", {
      className: styles$L.groupSeparator
    })), React.createElement(React.Fragment, null, hasVisibleGroup && React.createElement("div", {
      className: this.css(styles$L.item, styles$L.group)
    }, React.createElement("div", null, React.createElement("span", null, DropdownLocalizer$1.get(item.group.name)))))), !isSeparator ? React.createElement("div", {
      className: this.css(styles$L.item, customClassName, listItemStyle, inlineSubtextStyle, selectedStyle, hasVisibleGroup && styles$L.itemGroupIdent),
      onClick: () => this.selectItemHandlerAsync(item)
    }, favorite && React.createElement("div", {
      className: styles$L.iconContainer,
      onClick: e => this.favoriteItemHandlerAsync(e, item)
    }, React.createElement(Icon, {
      name: "star",
      style: item.favorite ? IconStyle.Solid : IconStyle.Regular,
      size: IconSize.Large
    })), React.createElement(DropdownListItem, {
      item: item,
      subtextHidden: this.subtextType == DropdownSubtextType.Hidden,
      noWrap: this.props.noWrap,
      onChangeAmount: (sender, item) => this.onChangeAmountAsync(item)
    }), checkbox && React.createElement("div", {
      className: styles$L.checkbox
    }, React.createElement(Icon, {
      name: "fas check",
      size: IconSize.Large,
      customStyle: {
        visibility: !selected ? "hidden" : undefined
      }
    }))) : React.createElement("hr", {
      className: styles$L.groupSeparator
    }));
  }
  renderInput() {
    const hasItems = this.listItems.length > 0;
    const alignStyle = this.align === DropdownAlign.Left && styles$L.alignLeft;
    const verticalAlignStyle = this.getVerticalAlign() === DropdownVerticalAlign.Top ? `${styles$L.alignTop} alignTop` : styles$L.alignBottom;
    const toggleStyle = this.state.expanded ? this.css(styles$L.itemsContainer, styles$L.opened, alignStyle, verticalAlignStyle) : styles$L.itemsContainer;
    const dropdownStyle = this.isDropdownType ? styles$L.dropdown : styles$L.list;
    const dropdownWidgetStyle = this.styleSchema === DropdownSchema.Widget && this.isDropdownType && styles$L.dropdownWidget;
    const transparentStyle = this.styleSchema === DropdownSchema.Transparent && styles$L.transparent;
    const noWrapStyle = this.props.noWrap && styles$L.noWrap;
    const smallStyle = this.props.small && styles$L.small;
    const inlineStyles = {};
    if (this.props.width) {
      inlineStyles.width = this.props.width;
    } else {
      if (this.props.minWidth) {
        inlineStyles.minWidth = this.props.minWidth;
      }
      if (this.props.maxWidth) {
        inlineStyles.maxWidth = this.props.maxWidth;
      }
    }
    const longListPlaceholder = this.isLongList() ? DropdownLocalizer$1.getResults : DropdownLocalizer$1.filterResults;
    const noDataText = this.props.noDataText ? DropdownLocalizer$1.get(this.props.noDataText) : DropdownLocalizer$1.noData;
    const maxHeight = this.getMaxHeightValue();
    const scrollableContainerInlineStyles = {
      maxHeight: maxHeight
    };
    const itemsListInlineStyles = {
      position: this.props.absoluteListItems ? "absolute" : "unset"
    };
    return React.createElement("div", {
      className: this.css(dropdownStyle, dropdownWidgetStyle, transparentStyle, smallStyle, this.disabled && styles$L.disabled, "dropdown-container"),
      style: inlineStyles
    }, this.isDropdownType && this.styleSchema !== DropdownSchema.Widget && this.renderSelectedItem(), React.createElement("div", {
      className: toggleStyle,
      ref: this._listContainerRef,
      onClick: e => this.onListContainerClickAsync(e)
    }, this.hasAddButton && this.renderAddButton(), this.hasFilter && React.createElement("div", {
      className: styles$L.filter,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.onFilterInputClick();
      })
    }, React.createElement("input", {
      id: "filter_input_" + this.id,
      ref: this._filterInputRef,
      autoComplete: "off",
      role: "presentation",
      className: "form-control filter",
      type: "text",
      placeholder: longListPlaceholder,
      onKeyUp: () => this.filterHandlerAsync(),
      onPaste: () => this.filterHandlerAsync()
    }), this.filterValue && React.createElement("span", {
      className: this.css("fa fa-times", styles$L.clean),
      onClick: () => this.cleanFilterAsync()
    })), React.createElement("div", {
      className: styles$L.scrollableContainer,
      ref: this._scrollableContainerRef,
      style: scrollableContainerInlineStyles
    }, React.createElement("div", {
      ref: this._itemsListRef,
      className: styles$L.itemsList,
      style: itemsListInlineStyles
    }, hasItems ? React.createElement(React.Fragment, null, this.filteredItems.map((item, index) => this.renderSelectListItem(item, index)), this.noItemsFound() && React.createElement("div", {
      className: this.css(styles$L.noResults, noWrapStyle)
    }, React.createElement("span", null, DropdownLocalizer$1.noItems))) : React.createElement("div", {
      className: this.css(styles$L.noResults, noWrapStyle)
    }, React.createElement("span", null, noDataText))))));
  }
}

//Autogenerated
class GridLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.actionsDeleteLanguageItemName = `_14:0`;
    this.actionsRestoreLanguageItemName = `_14:1`;
    this.actionsCancelLanguageItemName = `_14:2`;
    this.actionsSaveLanguageItemName = `_14:3`;
    this.actionsPreviewLanguageItemName = `_14:4`;
    this.actionsDownloadLanguageItemName = `_14:5`;
    this.actionsDetailsLanguageItemName = `_14:6`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_14:0`, {
      l: `en`,
      v: `Delete`
    }, {
      l: `uk`,
      v: `Видалити`
    }, {
      l: `sv`,
      v: `Radera`
    }, {
      l: `ru`,
      v: `Удалить`
    }, {
      l: `pl`,
      v: `Usuwać`
    }, {
      l: `nl`,
      v: `Verwijderen`
    }, {
      l: `nb`,
      v: `Slett`
    }, {
      l: `it`,
      v: `Eliminare`
    }, {
      l: `fr`,
      v: `Supprimer`
    }, {
      l: `fi`,
      v: `Poista`
    }, {
      l: `es`,
      v: `Borrar`
    }, {
      l: `de`,
      v: `Löschen`
    }, {
      l: `da`,
      v: `Slet`
    });
    this.set(`_14:1`, {
      l: `en`,
      v: `Restore`
    }, {
      l: `uk`,
      v: `Відновити`
    }, {
      l: `sv`,
      v: `Återställ`
    }, {
      l: `ru`,
      v: `Восстановить`
    }, {
      l: `pl`,
      v: `Przywrócić`
    }, {
      l: `nl`,
      v: `Herstellen`
    }, {
      l: `nb`,
      v: `Restaurere`
    }, {
      l: `it`,
      v: `Ristabilire`
    }, {
      l: `fr`,
      v: `Restaurer`
    }, {
      l: `fi`,
      v: `Palauta`
    }, {
      l: `es`,
      v: `Restaurar`
    }, {
      l: `de`,
      v: `Wiederherstellen`
    }, {
      l: `da`,
      v: `Gendan`
    });
    this.set(`_14:2`, {
      l: `en`,
      v: `Cancel`
    }, {
      l: `uk`,
      v: `Скасувати`
    }, {
      l: `sv`,
      v: `Avbryt`
    }, {
      l: `ru`,
      v: `Отменить`
    }, {
      l: `pl`,
      v: `Anulować`
    }, {
      l: `nl`,
      v: `Annuleren`
    }, {
      l: `nb`,
      v: `Avbryt`
    }, {
      l: `it`,
      v: `Annulla`
    }, {
      l: `fr`,
      v: `Annuler`
    }, {
      l: `fi`,
      v: `Peruu`
    }, {
      l: `es`,
      v: `Cancelar`
    }, {
      l: `de`,
      v: `Stornieren`
    }, {
      l: `da`,
      v: `Afbestille`
    });
    this.set(`_14:3`, {
      l: `en`,
      v: `Save`
    }, {
      l: `uk`,
      v: `Зберегти`
    }, {
      l: `sv`,
      v: `Spara`
    }, {
      l: `ru`,
      v: `Сохранить`
    }, {
      l: `pl`,
      v: `Ratować`
    }, {
      l: `nl`,
      v: `Opslaan`
    }, {
      l: `nb`,
      v: `Lagre`
    }, {
      l: `it`,
      v: `Salva`
    }, {
      l: `fr`,
      v: `Sauvegarder`
    }, {
      l: `fi`,
      v: `Tallenna`
    }, {
      l: `es`,
      v: `Ahorrar`
    }, {
      l: `de`,
      v: `Speichern`
    }, {
      l: `da`,
      v: `Gemme`
    });
    this.set(`_14:4`, {
      l: `en`,
      v: `Preview`
    }, {
      l: `uk`,
      v: `Переглянути`
    }, {
      l: `sv`,
      v: `Förhandsvisning`
    }, {
      l: `ru`,
      v: `Предпросмотр`
    }, {
      l: `pl`,
      v: `Podgląd`
    }, {
      l: `nl`,
      v: `Voorbeeld`
    }, {
      l: `nb`,
      v: `Forhåndsvisning`
    }, {
      l: `it`,
      v: `Anteprima`
    }, {
      l: `fr`,
      v: `Aperçu`
    }, {
      l: `fi`,
      v: `Esikatsele`
    }, {
      l: `es`,
      v: `Avance`
    }, {
      l: `de`,
      v: `Vorschau`
    }, {
      l: `da`,
      v: `Eksempel`
    });
    this.set(`_14:5`, {
      l: `en`,
      v: `Download`
    }, {
      l: `uk`,
      v: `Завантажити`
    }, {
      l: `sv`,
      v: `Ladda ner`
    }, {
      l: `ru`,
      v: `Загрузить`
    }, {
      l: `pl`,
      v: `Pobierz`
    }, {
      l: `nl`,
      v: `Downloaden`
    }, {
      l: `nb`,
      v: `Last ned`
    }, {
      l: `it`,
      v: `Scaricamento`
    }, {
      l: `fr`,
      v: `Télécharger`
    }, {
      l: `fi`,
      v: `Lataa`
    }, {
      l: `es`,
      v: `Descargar`
    }, {
      l: `de`,
      v: `Herunterladen`
    }, {
      l: `da`,
      v: `Download`
    });
    this.set(`_14:6`, {
      l: `en`,
      v: `Details`
    }, {
      l: `uk`,
      v: `Подробиці`
    }, {
      l: `sv`,
      v: `Detaljer`
    }, {
      l: `ru`,
      v: `Подробности`
    }, {
      l: `pl`,
      v: `Detale`
    }, {
      l: `nl`,
      v: `Details`
    }, {
      l: `nb`,
      v: `Detaljer`
    }, {
      l: `it`,
      v: `Dettagli`
    }, {
      l: `fr`,
      v: `Détails`
    }, {
      l: `fi`,
      v: `Yksityiskohdat`
    }, {
      l: `es`,
      v: `Detalles`
    }, {
      l: `de`,
      v: `Einzelheiten`
    }, {
      l: `da`,
      v: `Detaljer`
    });
  }
  /**
  /* "Actions.Delete" (Delete)
  /* "Localizer.actionsDelete"
  /* "Localizer.actionsDeleteLanguageItemName"
  */
  get actionsDelete() {
    return this.get(`_14:0`);
  }
  /**
  /* "Actions.Restore" (Restore)
  /* "Localizer.actionsRestore"
  /* "Localizer.actionsRestoreLanguageItemName"
  */
  get actionsRestore() {
    return this.get(`_14:1`);
  }
  /**
  /* "Actions.Cancel" (Cancel)
  /* "Localizer.actionsCancel"
  /* "Localizer.actionsCancelLanguageItemName"
  */
  get actionsCancel() {
    return this.get(`_14:2`);
  }
  /**
  /* "Actions.Save" (Save)
  /* "Localizer.actionsSave"
  /* "Localizer.actionsSaveLanguageItemName"
  */
  get actionsSave() {
    return this.get(`_14:3`);
  }
  /**
  /* "Actions.Preview" (Preview)
  /* "Localizer.actionsPreview"
  /* "Localizer.actionsPreviewLanguageItemName"
  */
  get actionsPreview() {
    return this.get(`_14:4`);
  }
  /**
  /* "Actions.Download" (Download)
  /* "Localizer.actionsDownload"
  /* "Localizer.actionsDownloadLanguageItemName"
  */
  get actionsDownload() {
    return this.get(`_14:5`);
  }
  /**
  /* "Actions.Details" (Details)
  /* "Localizer.actionsDetails"
  /* "Localizer.actionsDetailsLanguageItemName"
  */
  get actionsDetails() {
    return this.get(`_14:6`);
  }
}
//Singleton
var GridLocalizer$1 = new GridLocalizer();

const DEFAULT_PAGE_SIZE = 100;
const MAX_PAGE_SIZE = 20;
//export type GridSortingCallback<TItem = {}> = (column: ColumnModel<TItem>, x: TItem, y: TItem) => number;
var ColumnType;
(function (ColumnType) {
  ColumnType[ColumnType["Custom"] = 0] = "Custom";
  ColumnType[ColumnType["Text"] = 1] = "Text";
  ColumnType[ColumnType["Number"] = 2] = "Number";
  ColumnType[ColumnType["Date"] = 3] = "Date";
  ColumnType[ColumnType["Enum"] = 4] = "Enum";
  ColumnType[ColumnType["Boolean"] = 5] = "Boolean";
  ColumnType[ColumnType["Dropdown"] = 6] = "Dropdown";
  ColumnType[ColumnType["Address"] = 7] = "Address";
  ColumnType[ColumnType["Icon"] = 8] = "Icon";
})(ColumnType || (ColumnType = {}));
var ColumnActionType;
(function (ColumnActionType) {
  ColumnActionType["Details"] = "details";
  ColumnActionType["Preview"] = "preview";
  ColumnActionType["Download"] = "download";
  ColumnActionType["Delete"] = "delete";
  ColumnActionType["Restore"] = "restore";
  ColumnActionType["Save"] = "save";
  ColumnActionType["Cancel"] = "cancel";
})(ColumnActionType || (ColumnActionType = {}));
var GridHoveringType;
(function (GridHoveringType) {
  GridHoveringType[GridHoveringType["Row"] = 0] = "Row";
  GridHoveringType[GridHoveringType["Cell"] = 1] = "Cell";
  GridHoveringType[GridHoveringType["EditableCell"] = 2] = "EditableCell";
  GridHoveringType[GridHoveringType["None"] = 3] = "None";
})(GridHoveringType || (GridHoveringType = {}));
var GridOddType;
(function (GridOddType) {
  GridOddType[GridOddType["Row"] = 0] = "Row";
  GridOddType[GridOddType["None"] = 1] = "None";
})(GridOddType || (GridOddType = {}));
var GridSelectableType;
(function (GridSelectableType) {
  GridSelectableType[GridSelectableType["Single"] = 0] = "Single";
  GridSelectableType[GridSelectableType["Multiple"] = 1] = "Multiple";
})(GridSelectableType || (GridSelectableType = {}));
var CellPaddingType;
(function (CellPaddingType) {
  CellPaddingType[CellPaddingType["Large"] = 0] = "Large";
  CellPaddingType[CellPaddingType["Medium"] = 1] = "Medium";
  CellPaddingType[CellPaddingType["Small"] = 2] = "Small";
})(CellPaddingType || (CellPaddingType = {}));
var BorderType;
(function (BorderType) {
  BorderType[BorderType["DarkSeparators"] = 0] = "DarkSeparators";
  BorderType[BorderType["NoSeparators"] = 1] = "NoSeparators";
})(BorderType || (BorderType = {}));
class ColumnModel {
  constructor() {
    this._lastOuterWidth = 0;
    this.name = null;
    this.index = 0;
    this.header = "";
    this.title = "";
    this.accessor = null;
    this.visible = true;
    this.responsivePriority = 0;
    this.group = null;
    this.textAlign = null;
    this.verticalAlign = null;
    this.type = ColumnType.Custom;
    this.editable = false;
    this.removable = true;
    this.reRenderRow = false;
    this.rotate = false;
    this.format = null;
    this.minWidth = null;
    this.maxWidth = null;
    this.maxHeight = null;
    this.noWrap = false;
    this.wordBreak = false;
    this.stretch = false;
    this.total = false;
    this.route = null;
    this.className = null;
    this.settings = new ColumnSettings();
    this.sorting = null;
    this.selectable = null;
    this.isDefaultSorting = false;
    this.actions = [];
    this.headerCellInstance = {};
    this.collapsed = false;
    this.tag = null;
    this.grid = new GridModel();
  }
  outerWidth(visible = true) {
    return this.isVisible && this.headerCellInstance.outerWidth ? this._lastOuterWidth = this.headerCellInstance.outerWidth() : visible ? 0 : this._lastOuterWidth;
  }
  get isFirst() {
    return this.index === 0;
  }
  get isLast() {
    return this.index === this.grid.columns.length - 1;
  }
  get cells() {
    return this.grid.rows.map(row => row.cells[this.index]);
  }
  get sortable() {
    return this.sorting != null && this.sorting != false;
  }
  get isVisible() {
    return !this.collapsed && (typeof this.visible === "boolean" ? this.visible : this.visible());
  }
  get nextColumn() {
    return this.index < this.grid.columns.length - 1 ? this.grid.columns[this.index + 1] : this.grid.columns[0];
  }
  get nextVisibleColumn() {
    if (this.index < this.grid.columns.length - 1) {
      const next = this.grid.columns[this.index + 1];
      return next.isVisible ? next : next.nextVisibleColumn;
    }
    return null;
  }
  get prevColumn() {
    return this.index > 0 ? this.grid.columns[this.index - 1] : this.grid.columns[this.grid.columns.length - 1];
  }
  get prevVisibleColumn() {
    if (this.index > 0) {
      const prev = this.grid.columns[this.index - 1];
      return prev.isVisible ? prev : prev.prevVisibleColumn;
    }
    return null;
  }
}
class GridModel {
  constructor() {
    this.id = "";
    this.className = null;
    this.responsiveRowClassName = null;
    this.rows = [];
    this.columns = [];
    this.headerMinHeight = null;
    this.noDataNoHeader = false;
    this.noHeader = false;
    this.stickyHeader = false;
    this.minWidth = null;
    this.cellPadding = CellPaddingType.Large;
    this.noDataText = null;
    this.detailsColStart = null;
    this.detailsColEnd = null;
    this.autoToggle = false;
    this.hovering = GridHoveringType.Row;
    this.odd = GridOddType.Row;
    this.responsive = false;
    this.pagination = false;
    this.checkable = false;
    this.selectableType = null;
    this.readonly = false;
    this.borderType = BorderType.DarkSeparators;
    this.optimization = true;
    this.checked = false;
    this.instance = {};
    this.checkHeaderInstance = {};
    this.data = [];
    this.pageNumber = 1;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.sortColumn = null;
    this.sortDirection = null;
    this.totalItemCount = 0;
    this.generation = 0;
    this.tag = null;
  }
  get canPrevPage() {
    return this.instance.canPrevPage;
  }
  get canNextPage() {
    return this.instance.canNextPage;
  }
  prevPageAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.instance.prevPageAsync();
    });
  }
  nextPageAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.instance.nextPageAsync();
    });
  }
  get key() {
    return `grid_${this.id}`;
  }
  get modified() {
    return this.rows.some(item => item.modified);
  }
  get total() {
    return this.columns.some(item => item.total);
  }
  get checkedRows() {
    return this.checkable ? this.rows.filter(row => row.checked) : [];
  }
  get selectedRows() {
    return this.selectable ? this.rows.filter(row => row.selected) : [];
  }
  get selectedRow() {
    const selectedRows = this.selectedRows;
    return selectedRows.length > 0 ? selectedRows[0] : null;
  }
  get items() {
    return this.rows.map(row => row.model);
  }
  get checkedItems() {
    return this.checkedRows.map(row => row.model);
  }
  get selectedItems() {
    return this.selectedRows.map(row => row.model);
  }
  get selectedItem() {
    const selectedItems = this.selectedItems;
    return selectedItems.length > 0 ? selectedItems[0] : null;
  }
  get firstRow() {
    return this.rows[0];
  }
  get lastRow() {
    return this.rows[this.rows.length - 1];
  }
  get mobile() {
    return this.responsive && ch.mobile;
  }
  get desktop() {
    return !this.mobile;
  }
  get selectable() {
    return this.selectableType != null;
  }
  fullWidth(visible = true) {
    return this.columns.sum(column => column.outerWidth(visible));
  }
  collapsedWidth() {
    return this.columns.where(column => column.collapsed).sum(column => column.outerWidth(false));
  }
  getDump() {
    const dump = new Dictionary();
    //const cells: CellModel<TItem>[] = [];
    this.rows.filter(row => row.modified).forEach(row => row.cells.filter(cell => cell.modified).forEach(cell => dump.setValue(cell.initialKey, cell.value)));
    return dump;
  }
  setDump(dump) {
    let modified = false;
    const length = dump.size();
    if (length) {
      this.rows.forEach(row => row.cells.forEach(cell => {
        const key = cell.initialKey;
        if (dump.containsKey(key)) {
          const value = dump.getValue(key);
          cell.setValue(value);
          modified = modified || cell.modified;
        }
      }));
    }
    return modified;
  }
  setDumpAsync(dump) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.setDump(dump);
      if (modified) {
        yield this.reRenderAsync();
      }
      return modified;
    });
  }
  reloadComponentsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const components = this.rows.selectMany(row => row.cells.where(cell => cell.asyncContentInstance != null).map(cell => cell.asyncContentInstance));
      if (components) {
        yield Utility.forEachAsync(components, component => component.reloadAsync());
      }
    });
  }
  reloadComponents() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reloadComponentsAsync();
  }
  reRenderInputsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const inputs = this.rows.selectMany(row => row.cells.where(cell => cell.inputContentInstance != null).map(cell => cell.inputContentInstance));
      if (inputs) {
        yield Utility.forEachAsync(inputs, input => input.reRenderAsync());
      }
    });
  }
  reRenderInputs() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderInputsAsync();
  }
  reloadAsync(keepState = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.instance && this.instance.reloadAsync) {
        if (keepState) {
          const dump = this.getDump();
          yield this.instance.reloadAsync();
          yield this.setDumpAsync(dump);
        } else {
          yield this.instance.reloadAsync();
        }
      }
    });
  }
  reload(keepState = false) {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reloadAsync(keepState);
  }
  clearAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.instance && this.instance.clearAsync) {
        yield this.instance.clearAsync();
      }
    });
  }
  clear() {
    // clear without await
    // noinspection JSIgnoredPromiseFromCall
    this.clearAsync();
  }
  find(model, equals) {
    equals = equals !== null && equals !== void 0 ? equals : (x, y) => Comparator.isEqual(x, y);
    return this.rows.find(row => equals(row.model, model)) || null;
  }
  get(model, equals) {
    const row = this.find(model, equals);
    if (row == null) throw Error("Row cannot be found, unknown model.");
    return row;
  }
  getAsync(endpoint) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.instance.getAsync(endpoint);
    });
  }
  postAsync(endpoint, request) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.instance.postAsync(endpoint, request);
    });
  }
  insertAsync(index, ...items) {
    return __awaiter(this, void 0, void 0, function* () {
      const rows = this.rows;
      if (index < 0 || index > rows.length) throw Error(`Row index "${index}" out of range, can be in [0..${rows.length}]`);
      const newRows = items.map((item, itemIndex) => GridTransformer.toRow(this, item, index + itemIndex));
      rows.splice(index, 0, ...newRows);
      for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        const row = rows[rowIndex];
        row.index = rowIndex;
        row.cells.forEach(cell => cell.clearRowSpan());
      }
      yield this.instance.reRenderAsync();
      return newRows;
    });
  }
  addAsync(model) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.insertAsync(this.rows.length, model);
    });
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.instance.reRenderAsync();
    });
  }
  bind() {
    return this.rows.map(row => row.bind()).some(modified => modified);
  }
  bindAsync(forceRender = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.bind();
      if (forceRender || modified) {
        yield this.reRenderAsync();
      }
    });
  }
  saveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.rows.forEach(row => row.saveAsync());
    });
  }
  delete(modelOrIndex) {
    const rows = this.rows;
    let index = 0;
    if (typeof modelOrIndex === "number") {
      index = modelOrIndex;
      if (index < 0 || index >= rows.length) throw Error(`Row index "${index}" out of range, can be in [0..${rows.length}].`);
    } else {
      const row = this.find(modelOrIndex);
      if (row == null) {
        return;
      }
      index = row.index;
    }
    rows.removeAt(index);
    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const row = rows[rowIndex];
      row.index = rowIndex;
      row.cells.forEach(cell => cell.clearRowSpan());
    }
  }
  deleteAsync(modelOrIndex) {
    return __awaiter(this, void 0, void 0, function* () {
      this.delete(modelOrIndex);
      //await this.instance.newGenerationAsync();
      yield this.instance.reRenderAsync();
    });
  }
}
class ColumnSettingsDefinition {}
class ColumnSettings {
  constructor() {
    this.min = null;
    this.max = null;
    this.step = null;
    this.maxLength = null;
    this.hideZero = false;
    /**
     * Show additional info line below main text.
     */
    this.infoAccessor = null;
    /**
     * If number is used for infoAccessor: Option to hide value if 0
     */
    this.infoHideZero = false;
    /**
     * If infoAccessor value equals to main text: Option to hide if equal
     */
    this.infoHideEqual = false;
    /**
     * Title for infoAccessor.
     */
    this.infoTitle = null;
    /**
     * Show infoAccessor value with bold style
     */
    this.infoBold = false;
    /**
     * Redirects to specified PageRoute.
     */
    this.infoRoute = null;
    /**
     * Show infoAccessor value with bold style if it doesn't match to main text
     */
    this.infoBoldNotEqual = false;
    this.infoFormat = null;
    this.descriptionAccessor = null;
    this.descriptionTitle = null;
    this.descriptionMaxLength = null;
    this.descriptionJustify = Justify.Left;
    this.descriptionIcon = null;
    this.descriptionAlight = Align.Bottom;
    this.required = false;
    this.requiredType = DropdownRequiredType.AutoSelect;
    this.addButton = false;
    this.nothingSelectedText = null;
    this.multiple = false;
    this.noFilter = false;
    this.autoCollapse = true;
    this.groupSelected = false;
    this.align = DropdownAlign.Right;
    this.verticalAlign = DropdownVerticalAlign.Auto;
    this.arrows = false;
    this.locationPicker = false;
  }
}
class ColumnSubActionDefinition {}
class ColumnActionDefinition {}
class ColumnSubAction {
  constructor() {
    this.action = new ColumnAction();
    this.name = null;
    this.label = null;
    this.title = null;
    this.icon = null;
    this.iconPosition = Justify.Left;
  }
}
class ColumnAction {
  constructor() {
    this.name = null;
    this.title = null;
    this.tooltip = null;
    this.className = null;
    this.icon = null;
    this.type = null;
    this.right = false;
    this.toggleModal = null;
    this.alwaysAvailable = false;
    this.actions = [];
    this.confirm = null;
    this.column = new ColumnModel();
  }
}
class CellAction {
  constructor() {
    this.action = new ColumnAction();
    this.visible = true;
    this.disabled = false;
    this.instance = {};
  }
}
class DescriptionCellAction extends CellAction {
  constructor() {
    super(...arguments);
    this.readonly = null;
    this.justify = Justify.Left;
    this.alight = Align.Bottom;
    this.maxLength = null;
    this.isDescription = true;
  }
}
class ColumnDefinition {
  constructor() {
    /**
     * @default 0
     */
    this.responsivePriority = 0;
  }
}
class RowModel {
  constructor() {
    this._initialKey = null;
    this._key = null;
    this._model = {};
    this.id = 0;
    this.index = 0;
    this.grid = new GridModel();
    this.cells = [];
    this.className = null;
    this.expanded = false;
    this.deleted = false;
    this.hasDetails = false;
    this.instance = {};
    this.checkable = false;
    this.selectable = false;
    this.readonly = false;
    this.checked = false;
    this.selected = false;
    this.responsiveContainerExpanded = false;
    this.tag = null;
  }
  initializeKeys() {
    if (this._key == null) {
      this._key = this.grid.optimization ? `${this.grid.key}_row_${HashCodeUtility.getHashCode(this.model)}` : `${this.grid.key}_row_${this.id}`;
      if (this._initialKey == null) {
        this._initialKey = this._key;
      }
    }
  }
  get model() {
    return this._model;
  }
  set model(value) {
    if (this._model !== value) {
      this._model = value;
      const rowIndex = this.index;
      const data = this.grid.data;
      if (data[rowIndex] !== value) {
        data[rowIndex] = value;
      }
    }
  }
  get initialKey() {
    this.initializeKeys();
    return this._initialKey;
  }
  get key() {
    this.initializeKeys();
    return this._key;
  }
  get isReadonly() {
    return this.readonly || this.grid.readonly;
  }
  get isFirst() {
    return this.index === 0;
  }
  get isLast() {
    return this.index === this.grid.rows.length - 1;
  }
  get modified() {
    return this.cells.some(item => item.modified);
  }
  get valid() {
    return this.cells.every(item => item.valid);
  }
  get hasDeleted() {
    return this.cells.some(item => item.deleted);
  }
  get spannedRows() {
    return this.cells.filter(cell => cell.spannedRow != null).map(cell => cell.spannedRow).distinct(row => row.index);
  }
  get position() {
    return (this.grid.pageNumber - 1) * this.grid.pageSize + this.index + 1;
  }
  get detailsColStart() {
    const detailsColStart = this.grid.detailsColStart || 0;
    return this.grid.checkable ? detailsColStart + 1 : detailsColStart;
  }
  get detailsColEnd() {
    if (this.grid.detailsColEnd != null) {
      const detailsColEnd = this.grid.detailsColEnd < 0 ? this.grid.columns.length + this.grid.detailsColEnd : this.grid.detailsColEnd;
      return this.grid.checkable ? detailsColEnd + 1 : detailsColEnd;
    }
    for (let columnIndex = this.cells.length - 1; columnIndex >= 0; columnIndex--) {
      const cell = this.cells[columnIndex];
      if (!cell.spanned && cell.rowSpan < 1) {
        return this.grid.checkable ? columnIndex + 1 : columnIndex;
      }
    }
    const detailsColEnd = this.cells.length - 1;
    return this.grid.checkable ? detailsColEnd + 1 : detailsColEnd;
  }
  get nextRow() {
    return this.index < this.grid.rows.length - 1 ? this.grid.rows[this.index + 1] : this.grid.rows[0];
  }
  get prevRow() {
    return this.index > 0 ? this.grid.rows[this.index - 1] : this.grid.rows[this.grid.rows.length - 1];
  }
  resetKey(resetInitialKey = false) {
    this._key = null;
    if (resetInitialKey) {
      this._initialKey = null;
    }
  }
  get(columnName) {
    const cell = this.cells.find(item => item.column.name === columnName) || this.cells.find(item => item.accessor === columnName);
    if (cell == null) throw Error(`Column with name or accessor '${columnName}' cannot be found in the grid.`);
    return cell;
  }
  getIndex(columnName) {
    let index = this.cells.findIndex(item => item.column.name === columnName);
    if (index === -1) {
      index = this.cells.findIndex(item => item.accessor === columnName);
    }
    return index;
  }
  loop(inScope) {
    const rows = this.grid.rows;
    const rowIndex = this.index;
    let firstIndex = rowIndex;
    let lastIndex = rowIndex;
    const lastRowIndex = rows.length - 1;
    for (let index = rowIndex - 1; index >= 0; index--) {
      const subRow = rows[index];
      if (!inScope(subRow)) {
        break;
      }
      firstIndex = index;
    }
    for (let index = rowIndex + 1; index <= lastRowIndex; index++) {
      const subRow = rows[index];
      if (!inScope(subRow)) {
        break;
      }
      lastIndex = index;
    }
    const scope = new ArrayScope();
    scope.firstIndex = firstIndex;
    scope.lastIndex = lastIndex;
    return scope;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.expanded = !this.expanded;
      if (this.expanded && this.grid.autoToggle) {
        const expandedRow = this.grid.rows.find(row => row !== this && row.expanded) || null;
        if (expandedRow) {
          yield expandedRow.toggleAsync();
        }
      }
      yield this.reRenderAsync();
      //await this.instance.updateStateAsync();
      yield Utility.forEachAsync(this.spannedRows, row => row.reRenderAsync());
    });
  }
  selectAsync() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.selectable) {
        const grid = this.grid;
        if (this.grid.selectableType == GridSelectableType.Single) {
          if (!this.selected) {
            const selectedRow = grid.selectedRow;
            this.selected = true;
            if (selectedRow != null) {
              selectedRow.selected = false;
              yield selectedRow.reRenderAsync();
            }
            yield this.reRenderAsync();
            yield (_a = grid.onSelect) === null || _a === void 0 ? void 0 : _a.call(grid, grid, this);
          }
        } else {
          this.selected = !this.selected;
          yield this.reRenderAsync();
          yield (_b = grid.onSelect) === null || _b === void 0 ? void 0 : _b.call(grid, grid, this);
        }
      }
    });
  }
  bind() {
    return this.cells.map(cell => cell.bind()).some(modified => modified);
  }
  bindAsync(forceRender = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.bind();
      if (forceRender || modified) {
        yield this.reRenderAsync();
      }
    });
  }
  setModel(model) {
    let modified = false;
    const cells = this.cells;
    const columns = this.grid.columns;
    const length = columns.length;
    for (let i = 0; i < length; i++) {
      const column = columns[i];
      const cell = cells[column.index];
      if (cell.accessor) {
        const value = typeof cell.accessor === "string" ? Utility.findValueByAccessor(model, cell.accessor) : cell.accessor(model);
        cell.setValue(value);
        modified = modified || cell.modified;
      }
    }
    return modified;
  }
  setModelAsync(model, forceRender = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.setModel(model);
      if (forceRender || modified) {
        yield this.reRenderAsync();
      }
      return modified;
    });
  }
  saveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        this.cells.forEach(cell => cell.save());
        yield this.reRenderAsync();
      }
    });
  }
  cancelAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        yield Utility.forEachAsync(this.cells, cell => cell.cancelAsync());
        yield this.reRenderAsync();
      }
    });
  }
  reRenderAsync(withSpannedRows = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (withSpannedRows) {
        yield Utility.forEachAsync(this.spannedRows, row => row.reRenderAsync());
      }
      yield this.instance.reRenderAsync();
    });
  }
  setDeletedAsync(deleted) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.deleted !== deleted) {
        this.deleted = deleted;
        yield this.reRenderAsync();
      }
    });
  }
}
class CellModel {
  constructor() {
    this._value = null;
    this._initialValue = null;
    this._valueInitialized = false;
    this._rowSpan = 0;
    this._columnSpan = 0;
    this._spannedRow = null;
    this._spannedColumn = null;
    this._descriptionAction = null;
    this._description = null;
    this.id = 0;
    this.actions = [];
    this.row = new RowModel();
    this.column = new ColumnModel();
    this.grid = new GridModel();
    this.className = null;
    this.visible = true;
    this.readonly = false;
    this.valid = true;
    this.deleted = false;
    this.title = "";
    this.type = ColumnType.Custom;
    this.editable = false;
    this.accessor = null;
    this.route = null;
    this.infoRoute = null;
    this.instance = {};
    this.asyncContentInstance = null;
    this.inputContentInstance = null;
    this.tag = null;
  }
  get key() {
    return `${this.row.key}_cell_${this.columnIndex}`;
  }
  get initialKey() {
    return `${this.row.initialKey}_cell_${this.columnIndex}`;
  }
  get isFirstColumn() {
    return this.column.isFirst;
  }
  get isLastColumn() {
    return this.column.isLast;
  }
  get isFirstRow() {
    return this.row.isFirst;
  }
  get isLastRow() {
    return this.row.isLast;
  }
  get isSpanned() {
    return this.spanned || this.rowSpan > 1;
  }
  get isDeleted() {
    return this.removable && (this.deleted || this.row.deleted);
  }
  get isReadonly() {
    return this.readonly || this.row.isReadonly;
  }
  get isVisible() {
    return this.visible && this.column.isVisible;
  }
  get isSelectable() {
    //return (this.isVisible) && (!this.isDeleted) && ((this.isReadonly) || (this.type == ColumnType.Custom) || (this.type == ColumnType.Icon)) && (this.actions.length == 0);
    return this.grid.selectable && this.isVisible && !this.isDeleted && this.column.selectable !== false;
  }
  /**
   * The cell input is in the editable mode (input is visible).
   */
  get edit() {
    return this.inputContentInstance != null && this.inputContentInstance.edit;
  }
  get rowSpan() {
    return this._rowSpan;
  }
  get columnSpan() {
    return this._columnSpan;
  }
  set rowSpan(value) {
    value = value === 1 ? 0 : value;
    if (this._rowSpan !== value) {
      if (!this.spanned && value >= 0) {
        const spanned = value > 0;
        const rows = this.grid.rows;
        const rowsLength = rows.length;
        const firstIndex = this.rowIndex + 1;
        const lastIndex = firstIndex + (spanned ? value : this._rowSpan) - 2;
        const columnIndex = this.columnIndex;
        for (let index = firstIndex; index <= lastIndex && index < rowsLength; index++) {
          const cell = rows[index].cells[columnIndex];
          cell._spannedRow = spanned ? this.row : null;
          if (spanned) {
            cell.rowSpan = 0;
          }
        }
      }
      this._rowSpan = value;
    }
  }
  set columnSpan(value) {
    value = value === 1 ? 0 : value;
    if (this._columnSpan !== value) {
      if (!this.spanned && value >= 0) {
        const spanned = value > 0;
        const columns = this.grid.columns;
        const columnsLength = columns.length;
        const firstIndex = this.columnIndex + 1;
        const lastIndex = firstIndex + (spanned ? value : this._columnSpan) - 2;
        //const rowIndex: number = this.rowIndex;
        const row = this.row;
        for (let index = firstIndex; index <= lastIndex && index < columnsLength; index++) {
          //const cell: CellModel<TItem> = columns[index].cells[rowIndex];
          const cell = row.cells[index];
          cell._spannedColumn = spanned ? this.column : null;
          if (spanned) {
            cell.columnSpan = 0;
          }
        }
      }
      this._columnSpan = value;
    }
  }
  get descriptionAction() {
    var _a;
    return (_a = this._descriptionAction) !== null && _a !== void 0 ? _a : this._descriptionAction = this.actions.firstOrDefault(action => action instanceof DescriptionCellAction);
  }
  get descriptionIcon() {
    return this.column.settings.descriptionIcon;
  }
  get description() {
    if (this._description === null) {
      const accessor = this.column.settings.descriptionAccessor;
      if (accessor) {
        this._description = typeof accessor === "string" ? Utility.findValueByAccessor(this.model, accessor) : accessor(this.model);
      }
    }
    return this._description || (this._description = "");
  }
  set description(value) {
    const accessor = this.column.settings.descriptionAccessor;
    if (accessor && typeof accessor === "string") {
      Utility.setValueByAccessor(this.model, accessor, value);
      this._description = null;
    }
  }
  get descriptionReadonly() {
    return this.descriptionAction && this.descriptionAction.readonly != null ? this.descriptionAction.readonly : this.isReadonly || this.isDeleted;
  }
  set descriptionReadonly(value) {
    if (this.descriptionAction) {
      this.descriptionAction.readonly = value;
    }
  }
  get spanned() {
    return this._spannedRow != null || this._spannedColumn != null;
  }
  get spannedRow() {
    return this._spannedRow;
  }
  get spannedColumn() {
    return this._spannedColumn;
  }
  get spannedRows() {
    const spannedRows = [];
    if (!this.spanned) {
      const row = this.row;
      const columnIndex = this.columnIndex;
      let spannedRow = row;
      while (spannedRow != null && (spannedRow === row || spannedRow.cells[columnIndex].spannedRow === row)) {
        spannedRows.push(spannedRow);
        spannedRow = !spannedRow.isLast ? spannedRow.nextRow : null;
      }
    }
    return spannedRows;
  }
  get spannedColumns() {
    const spannedColumns = [];
    if (!this.spanned) {
      const column = this.column;
      const rowIndex = this.rowIndex;
      let spannedColumn = column;
      while (spannedColumn != null && (spannedColumn === column || spannedColumn.cells[rowIndex].spannedColumn === column)) {
        spannedColumns.push(spannedColumn);
        spannedColumn = !spannedColumn.isLast ? spannedColumn.nextColumn : null;
      }
    }
    return spannedColumns;
  }
  get value() {
    return this._value;
  }
  get initialValue() {
    return this._initialValue;
  }
  set value(value) {
    if (this.accessor) {
      if (this._value !== value) {
        if (typeof this.accessor === "string") {
          Utility.setValueByAccessor(this.row.model, this.accessor, value);
          this._value = Utility.findValueByAccessor(this.row.model, this.accessor);
        } else {
          this._value = value;
        }
      }
      if (!this._valueInitialized) {
        this._initialValue = this._value;
        this._valueInitialized = true;
      }
    }
  }
  get modifiable() {
    return this._valueInitialized && this.type != ColumnType.Icon && (this.type != ColumnType.Custom || this.editable);
  }
  get modified() {
    if (this.modifiable) {
      const hideZero = this.column.settings.hideZero;
      const value = hideZero ? this._value || 0 : this._value;
      const initialValue = hideZero ? this._initialValue || 0 : this._initialValue;
      const isEqual = Comparator.isEqual(value, initialValue);
      if (!isEqual) {
        return true;
      }
    }
    return false;
  }
  get rowIndex() {
    return this.row.index;
  }
  get columnIndex() {
    return this.column.index;
  }
  get model() {
    return this.row.model;
  }
  get next() {
    return this.columnIndex < this.grid.columns.length - 1 ? this.row.cells[this.columnIndex + 1] : this.row.cells[0];
  }
  get prev() {
    return this.columnIndex > 0 ? this.row.cells[this.columnIndex - 1] : this.row.cells[this.grid.columns.length - 1];
  }
  get nextRow() {
    return this.row.nextRow;
  }
  get prevRow() {
    return this.row.prevRow;
  }
  get removable() {
    return this.column.removable;
  }
  clearRowSpan() {
    this._rowSpan = 0;
    this._spannedRow = null;
  }
  calcRowSpan() {
    let rowSpan = this._rowSpan;
    const columnIndex = this.grid.checkable ? this.columnIndex + 1 : this.columnIndex;
    if (rowSpan > 1) {
      const rows = this.grid.rows;
      const rowsLength = rows.length;
      const firstRowIndex = this.rowIndex;
      const lastRowIndex = firstRowIndex + rowSpan - 1;
      const detailsColStart = this.row.detailsColStart;
      const detailsColEnd = this.row.detailsColEnd;
      for (let index = firstRowIndex; index <= lastRowIndex && index < rowsLength; index++) {
        const row = rows[index];
        const rowExpanded = row.expanded && (columnIndex < detailsColStart || columnIndex > detailsColEnd);
        if (rowExpanded) {
          rowSpan++;
        }
      }
      return rowSpan;
    } else if (this.row.expanded) {
      const detailsColStart = this.row.detailsColStart;
      const detailsColEnd = this.row.detailsColEnd;
      const rowExpanded = columnIndex < detailsColStart || columnIndex > detailsColEnd;
      if (rowExpanded) {
        return 2;
      }
    }
    return null;
  }
  equalRowSpan(cell) {
    let equal = cell.rowIndex == this.rowIndex;
    equal = equal && cell.spanned === this.spanned && cell.rowSpan === this.rowSpan;
    return equal;
  }
  prevRows(callback) {
    const result = [];
    if (this.rowIndex > 0) {
      for (let index = this.rowIndex - 1; index >= 0; index--) {
        const row = this.grid.rows[index];
        const item = row.model;
        if (!callback(item)) {
          break;
        }
        result.push(row);
      }
    }
    return result;
  }
  nextRows(callback, start = 1) {
    const result = [];
    if (this.rowIndex <= this.grid.rows.length - 1) {
      const firstIndex = this.rowIndex + start;
      for (let index = firstIndex; index < this.grid.rows.length; index++) {
        const row = this.grid.rows[index];
        const item = row.model;
        if (!callback(item)) {
          break;
        }
        result.push(row);
      }
    }
    return result;
  }
  filterRows(callback, excludeSelf = true) {
    return this.grid.rows.filter(row => (!excludeSelf || row.index !== this.rowIndex) && callback(row.cells[this.columnIndex].model));
  }
  someRows(callback, excludeSelf = true, excludeDeleted = true) {
    const rowIndex = this.rowIndex;
    const columnIndex = this.columnIndex;
    return this.grid.rows.some(row => (!excludeDeleted || !row.deleted) && (!excludeSelf || row.index !== rowIndex) && callback(row.cells[columnIndex].model));
  }
  forEachRowsAsync(callback, excludeSelf = true, excludeDeleted = true) {
    return __awaiter(this, void 0, void 0, function* () {
      let items = this.grid.rows;
      items = excludeSelf ? items.filter(row => row.index !== this.rowIndex) : items;
      items = excludeDeleted ? items.filter(row => !row.deleted) : items;
      yield Utility.forEachAsync(items, row => callback(row.cells[this.columnIndex]));
    });
  }
  save() {
    if (this.modified) {
      this._initialValue = this.value;
      this.row.resetKey(true);
    }
  }
  saveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        this._initialValue = this.value;
        this.row.resetKey(true);
        if (this.column.callback) {
          yield this.column.callback(this, null);
        }
        yield this.reRenderAsync();
      }
    });
  }
  cancel() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        this.value = this._initialValue;
        this.row.resetKey();
      }
    });
  }
  cancelAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        this.value = this._initialValue;
        this.row.resetKey();
        if (this.column.callback) {
          yield this.column.callback(this, null);
        }
        yield this.reRenderAsync();
      }
    });
  }
  setValue(value) {
    if (this.accessor) {
      if (this.value !== value) {
        const modified = this.modified;
        this.value = value;
        this.row.resetKey();
        return this.modified !== modified;
      }
    }
    return false;
  }
  setValueAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.setValue(value);
      if (modified) {
        yield this.row.reRenderAsync();
      } else {
        yield this.reRenderAsync();
      }
      return modified;
    });
  }
  bindDescription() {
    // bind description
    const description = this.description;
    this._description = null;
    const newDescription = this.description;
    return description != newDescription;
  }
  bind() {
    if (this.accessor) {
      const value = typeof this.accessor === "string" ? Utility.findValueByAccessor(this.model, this.accessor) : this.accessor(this.model);
      this.setValue(value);
      if (this.modified) {
        this._description = null;
        this.save();
        return true;
      }
    }
    return this.bindDescription();
  }
  bindAsync(forceRender = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.bind();
      if (forceRender || modified) {
        yield this.reRenderAsync();
      }
    });
  }
  setValidAsync(valid) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.valid !== valid) {
        const rowValid = this.row.valid;
        this.valid = valid;
        const rowValidModified = rowValid !== this.row.valid;
        if (rowValidModified) {
          yield this.row.reRenderAsync();
        } else {
          yield this.reRenderAsync();
        }
      }
    });
  }
  setDeletedAsync(deleted) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.removable && this.deleted !== deleted) {
        this.deleted = deleted;
        yield this.reRenderAsync();
      }
    });
  }
  setRowDeleted(deleted) {
    this.row.cells.forEach(cell => {
      if (cell != this && !cell.isSpanned) {
        cell.deleted = deleted;
      }
    });
  }
  setRowDeletedAsync(deleted) {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.forEachAsync(this.row.cells, cell => __awaiter(this, void 0, void 0, function* () {
        if (cell != this && !cell.isSpanned) {
          yield cell.setDeletedAsync(deleted);
        }
      }));
      yield this.reRenderAsync();
    });
  }
  editAsync(select = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.editable && !this.isReadonly && this.inputContentInstance) {
        yield this.inputContentInstance.showEditAsync(select);
      }
    });
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isVisible) {
        yield this.instance.reRenderAsync();
      }
    });
  }
  reRender() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderAsync();
  }
  reloadAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.asyncContentInstance) {
        yield this.asyncContentInstance.reloadAsync();
      }
    });
  }
}
class GridTransformer {
  static toGrid(from, id, instance) {
    const to = new GridModel();
    to.id = id;
    to.className = from.className || null;
    to.responsiveRowClassName = from.responsiveRowClassName || null;
    to.headerMinHeight = from.headerMinHeight || null;
    to.noDataNoHeader = from.noDataNoHeader || false;
    to.noHeader = from.noHeader || false;
    to.stickyHeader = from.stickyHeader || false;
    to.minWidth = from.minWidth || null;
    to.cellPadding = from.cellPadding || CellPaddingType.Large;
    to.noDataText = from.noDataText || null;
    to.detailsColStart = from.detailsColStart || null;
    to.detailsColEnd = from.detailsColEnd || null;
    to.hovering = from.hovering || GridHoveringType.Row;
    to.odd = from.odd || GridOddType.Row;
    to.responsive = from.responsive || false;
    to.pagination = from.pagination || false;
    to.checkable = from.checkable || false;
    to.selectableType = from.selectable == null || from.selectable === false ? null : from.selectable === true ? GridSelectableType.Single : from.selectable;
    to.readonly = from.readonly || false;
    to.borderType = from.borderType || BorderType.DarkSeparators;
    to.optimization = from.optimization !== false;
    to.autoToggle = from.autoToggle || false;
    to.onCheck = from.onCheck;
    to.onSelect = from.onSelect;
    to.onBeforePagination = from.onBeforePagination;
    to.onPagination = from.onPagination;
    to.renderDetails = from.renderDetails;
    to.columns = (from.columns || []).map((item, index) => this.toColumn(to, item, index));
    to.rows = [];
    to.pageNumber = 1;
    to.totalItemCount = 0;
    to.pageSize = from.pagination ? typeof from.pagination === "number" ? from.pagination : typeof from.pagination === "object" ? from.pagination.pageSize || DEFAULT_PAGE_SIZE : DEFAULT_PAGE_SIZE : MAX_PAGE_SIZE;
    to.sortColumn = to.columns.find(item => item.sorting != null && item.sorting != false && item.isDefaultSorting) || to.columns.find(item => item.sorting != null && item.sorting != false) || null;
    to.sortDirection = to.sortColumn != null ? to.sortColumn.sorting === SortDirection.Desc ? SortDirection.Desc : SortDirection.Asc : null;
    if (instance) {
      to.instance = instance;
    }
    //add check for multiple isSortColumn
    return to;
  }
  static toColumn(grid, from, columnIndex) {
    var _a, _b, _c, _d;
    const to = new ColumnModel();
    to.name = from.name || null;
    to.title = from.title || "";
    to.index = columnIndex;
    to.accessor = from.accessor || null;
    to.grid = grid;
    to.group = from.group || null;
    to.textAlign = from.textAlign || null;
    to.verticalAlign = from.verticalAlign || null;
    to.type = from.type || ColumnType.Custom;
    to.editable = from.editable || false;
    to.removable = from.removable != false;
    to.reRenderRow = from.reRenderRow || false;
    to.rotate = from.rotate || false;
    to.format = from.format || null;
    to.minWidth = from.minWidth || null;
    to.maxWidth = from.maxWidth || null;
    to.maxHeight = from.maxHeight || null;
    to.noWrap = from.noWrap || false;
    to.wordBreak = from.wordBreak || false;
    to.stretch = from.stretch || false;
    to.total = from.total || false;
    to.route = from.route || null;
    to.className = from.className || null;
    to.header = from.header || "";
    to.visible = (_a = from.visible) !== null && _a !== void 0 ? _a : true;
    to.responsivePriority = from.responsivePriority || 0;
    to.init = from.init;
    to.transform = from.transform;
    to.render = from.render;
    to.callback = from.callback;
    to.sorting = (_b = from.sorting) !== null && _b !== void 0 ? _b : null;
    to.selectable = (_c = from.selectable) !== null && _c !== void 0 ? _c : null;
    to.isDefaultSorting = from.isDefaultSorting || false;
    to.settings = this.toSettings(from.settings || new ColumnSettingsDefinition());
    to.actions = ((_d = from.actions) !== null && _d !== void 0 ? _d : []).map(action => this.toAction(to, action));
    return to;
  }
  static toRows(grid, items) {
    return items.map((item, rowIndex) => this.toRow(grid, item, rowIndex));
  }
  static toRow(grid, model, rowIndex) {
    const to = new RowModel();
    to.id = ch.getId();
    to.grid = grid;
    to.index = rowIndex;
    to.model = model;
    to.checkable = grid.checkable;
    to.selectable = grid.selectable;
    to.cells = grid.columns.map(column => this.toCell(grid, to, column));
    return to;
  }
  static toCell(grid, row, column) {
    const to = new CellModel();
    to.id = ch.getId();
    to.grid = grid;
    to.row = row;
    to.column = column;
    to.type = column.type;
    to.editable = column.editable;
    to.accessor = column.accessor;
    to.title = column.title;
    to.actions = column.actions.map(columnAction => this.toCellAction(columnAction));
    if (column.settings.descriptionAccessor) {
      const descriptionAction = this.toDescriptionCellAction(column);
      to.actions.insert(descriptionAction);
    }
    return to;
  }
  static toSettings(from) {
    var _a, _b;
    const to = new ColumnSettings();
    to.min = from.min || null;
    to.max = from.max || null;
    to.step = from.step || null;
    to.maxLength = from.maxLength || null;
    to.hideZero = from.hideZero || false;
    to.infoHideZero = from.infoHideZero || false;
    to.infoHideEqual = from.infoHideEqual || false;
    to.infoAccessor = from.infoAccessor || null;
    to.infoTitle = from.infoTitle || null;
    to.infoBold = from.infoBold || false;
    to.infoBoldNotEqual = from.infoBoldNotEqual || false;
    to.infoFormat = from.infoFormat || null;
    to.infoRoute = from.infoRoute || null;
    to.descriptionAccessor = from.descriptionAccessor || null;
    to.descriptionJustify = from.descriptionJustify || Justify.Left;
    to.descriptionIcon = from.descriptionIcon || null;
    to.descriptionMaxLength = from.descriptionMaxLength || null;
    to.descriptionAlight = from.descriptionAlight || Align.Bottom;
    to.descriptionCallback = from.descriptionCallback;
    to.required = (_a = from.required) !== null && _a !== void 0 ? _a : false;
    to.requiredType = (_b = from.requiredType) !== null && _b !== void 0 ? _b : DropdownRequiredType.AutoSelect;
    to.addButton = from.addButton || false;
    to.addCallback = from.addCallback;
    to.nothingSelectedText = from.nothingSelectedText || null;
    to.autoCollapse = from.autoCollapse || true;
    to.groupSelected = from.groupSelected || false;
    to.multiple = from.multiple || false;
    to.noFilter = from.noFilter || false;
    to.align = from.align || DropdownAlign.Right;
    to.verticalAlign = from.verticalAlign || DropdownVerticalAlign.Auto;
    to.arrows = from.arrows || false;
    to.locationPicker = from.locationPicker || false;
    to.fetchItems = from.fetchItems;
    to.selectedTextTransform = from.selectedTextTransform;
    to.infoTransform = from.infoTransform;
    return to;
  }
  static toSubAction(action, from) {
    var _a;
    const to = new ColumnSubAction();
    to.action = action;
    if (typeof from === "string") {
      to.name = from;
      to.label = from;
    } else {
      to.name = from.name || null;
      to.label = from.label || null;
      to.title = from.title || null;
      to.iconPosition = (_a = from.iconPosition) !== null && _a !== void 0 ? _a : Justify.Left;
      to.icon = this.toIcon(from.icon);
    }
    return to;
  }
  static toAction(column, from) {
    var _a, _b, _c, _d, _e, _f;
    const to = new ColumnAction();
    to.column = column;
    to.title = from.title || null;
    to.tooltip = from.tooltip || null;
    to.className = from.className || null;
    to.toggleModal = from.toggleModal || null;
    to.confirm = from.confirm || null;
    to.right = (_a = from.right) !== null && _a !== void 0 ? _a : false;
    to.actions = ((_b = from.actions) !== null && _b !== void 0 ? _b : []).map(action => this.toSubAction(to, action));
    to.callback = from.callback;
    to.render = from.render;
    to.alwaysAvailable = (_c = from.alwaysAvailable) !== null && _c !== void 0 ? _c : false;
    to.name = from.name || null;
    to.icon = this.toIcon(from.icon);
    if (from.type != null) {
      const alwaysAvailable = from.alwaysAvailable !== false;
      switch (from.type) {
        case ColumnActionType.Details:
          to.alwaysAvailable = alwaysAvailable;
          to.name = from.name || "details";
          to.type = ActionType.Secondary;
          to.icon = this.toIcon(from.icon || "far info-square");
          to.title = from.title || GridLocalizer$1.actionsDetails;
          break;
        case ColumnActionType.Download:
          to.alwaysAvailable = alwaysAvailable;
          to.name = from.name || "download";
          to.type = ActionType.Create;
          to.icon = this.toIcon(from.icon || "far download");
          to.title = from.title || GridLocalizer$1.actionsDownload;
          break;
        case ColumnActionType.Preview:
          to.alwaysAvailable = alwaysAvailable;
          to.name = from.name || "preview";
          to.type = ActionType.Blue;
          to.icon = this.toIcon(from.icon || "far search");
          to.title = from.title || GridLocalizer$1.actionsPreview;
          break;
        case ColumnActionType.Save:
          to.alwaysAvailable = alwaysAvailable;
          to.name = from.name || "save";
          to.type = ActionType.Create;
          to.icon = this.toIcon(from.icon || "far save");
          to.title = from.title || GridLocalizer$1.actionsSave;
          break;
        case ColumnActionType.Cancel:
          to.alwaysAvailable = alwaysAvailable;
          to.name = from.name || "cancel";
          to.type = ActionType.Grey;
          to.icon = this.toIcon(from.icon || "far ban");
          to.title = from.title || GridLocalizer$1.actionsCancel;
          to.right = (_d = from.right) !== null && _d !== void 0 ? _d : true;
          break;
        case ColumnActionType.Restore:
          to.alwaysAvailable = alwaysAvailable;
          to.name = from.name || "restore";
          to.type = ActionType.Create;
          to.icon = this.toIcon(from.icon || "far undo-alt");
          to.title = from.title || GridLocalizer$1.actionsRestore;
          to.right = (_e = from.right) !== null && _e !== void 0 ? _e : true;
          break;
        case ColumnActionType.Delete:
        case ActionType.Delete:
          to.alwaysAvailable = alwaysAvailable;
          to.name = from.name || "delete";
          to.type = ActionType.Delete;
          to.icon = this.toIcon(from.icon || "far trash-alt");
          to.title = from.title || GridLocalizer$1.actionsDelete;
          to.right = (_f = from.right) !== null && _f !== void 0 ? _f : true;
          break;
        default:
          to.type = from.type || null;
      }
    }
    return to;
  }
  static toCellAction(columnAction) {
    const to = new CellAction();
    to.action = columnAction;
    return to;
  }
  static toDescriptionCellAction(column) {
    const to = new DescriptionCellAction();
    to.action.name = "description";
    to.action.type = ActionType.Grey;
    to.action.title = column.settings.descriptionTitle;
    to.action.callback = column.settings.descriptionCallback;
    to.justify = column.settings.descriptionJustify;
    to.maxLength = column.settings.descriptionMaxLength;
    to.alight = column.settings.descriptionAlight;
    return to;
  }
  static toIcon(icon, checkIconName = false) {
    if (icon != null) {
      if (typeof icon === "string") {
        if (!checkIconName || Icon.isIconName(icon)) {
          return {
            name: icon
          };
        }
        return null;
      }
      return icon;
    }
    return null;
  }
}

var css_248z$R = "@charset \"UTF-8\";\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-grid-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-grid-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-grid-list, .athenaeum-grid-dropdown {\n  text-align: left;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  height: 100%;\n}\n.athenaeum-grid-list.athenaeum-grid-disabled, .athenaeum-grid-disabled.athenaeum-grid-dropdown {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-grid-list .athenaeum-grid-selected, .athenaeum-grid-dropdown .athenaeum-grid-selected {\n  text-align: center;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer {\n  display: flex;\n  visibility: hidden;\n  height: inherit;\n  position: absolute;\n  flex-direction: column;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter {\n  padding: 4px 2px 0;\n  position: relative;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter > input, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter > input {\n  width: 100%;\n  padding-right: 18px !important;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter input::placeholder, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter input::placeholder {\n  font-style: italic;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean {\n  position: absolute;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  top: 0;\n  right: 12px;\n  opacity: 0.3;\n  margin-top: 2px;\n  color: black;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean:hover {\n  opacity: 1;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-addButton, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-addButton {\n  padding: 0 2px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-addButton > span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-addButton > span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-scrollableContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-scrollableContainer {\n  overflow-y: auto;\n  height: inherit;\n  position: relative;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList {\n  height: auto;\n  position: absolute;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: unset;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList {\n    position: unset !important;\n  }\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noWrap, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noWrap {\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-lineThrough, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-lineThrough {\n  text-decoration: line-through;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults {\n  display: flex;\n  align-items: center;\n  padding: 2px 10px;\n  margin: 2px 0;\n  border-radius: 5px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults {\n  color: rgb(254, 80, 0);\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem:hover, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults:hover {\n  background-color: rgb(227, 227, 227);\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem.athenaeum-grid-selectedItem, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem.athenaeum-grid-selectedItem, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-selectedItem.athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-selectedItem.athenaeum-grid-noResults {\n  color: white;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem.athenaeum-grid-selectedItem:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem.athenaeum-grid-selectedItem:hover, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-selectedItem.athenaeum-grid-noResults:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-selectedItem.athenaeum-grid-noResults:hover {\n  color: #337ab7;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem span, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults {\n  border-radius: 0;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div {\n  padding-top: 2px;\n  padding-bottom: 3px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > span, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > span {\n  display: inline;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > small, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > small {\n  margin-left: 0.5em;\n  font-size: 75%;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-iconContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-iconContainer, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-iconContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-iconContainer {\n  padding: 5px;\n  margin-right: 10px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item span, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults span {\n  display: block;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item small, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults small {\n  text-transform: capitalize;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-minus, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-minus, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-minus, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-minus {\n  font-size: 1.5em;\n  margin-right: 5px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle {\n  width: 100%;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle span, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle span {\n  display: inline;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle .athenaeum-grid-amountUnit, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle .athenaeum-grid-amountUnit, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle .athenaeum-grid-amountUnit, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle .athenaeum-grid-amountUnit {\n  padding-left: 5px;\n  color: lightgray;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountDisabled, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountDisabled, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountDisabled, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountDisabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amount, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amount, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amount, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amount {\n  font-size: 1.5em;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-plus, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-plus, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-plus, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-plus {\n  font-size: 1.5em;\n  margin-left: 5px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-notCompleted, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-notCompleted, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-notCompleted, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-notCompleted {\n  margin-right: 0;\n  margin-left: auto;\n  padding-left: 8px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-notCompleted > img, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-notCompleted > img, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-notCompleted > img, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-notCompleted > img {\n  height: 20px;\n  min-height: 16px;\n  min-width: 16px;\n  max-width: 24px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-group, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-group, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-group:hover, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-group:active {\n  cursor: default;\n  color: #e3e3e3 !important;\n  background-color: inherit !important;\n  font-size: 12px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-groupSeparator, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-groupSeparator {\n  margin: 6px 2px;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-selectedItem, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-selectedItem {\n  background-color: #337ab7;\n  color: white;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-itemGroupIdent, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-itemGroupIdent {\n  padding-left: 20px !important;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer.athenaeum-grid-opened, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-opened {\n  visibility: visible;\n  position: initial;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults {\n  padding: 0;\n  cursor: default;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults:hover {\n  background-color: transparent;\n}\n\n.athenaeum-grid-dropdown {\n  cursor: pointer;\n  position: relative;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-hovered, .athenaeum-grid-dropdown .athenaeum-grid-selected:hover {\n  background-color: rgb(227, 227, 227);\n  border-color: #adadad;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-focused {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  white-space: nowrap;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected.athenaeum-grid-toggleButtonVisible {\n  visibility: visible;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected.athenaeum-grid-clearButtonVisible {\n  visibility: visible;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer > div {\n  margin-left: 6px;\n  align-items: center;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer > div.athenaeum-grid-clearButton {\n  display: flex;\n  padding: 4px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer > div.athenaeum-grid-clearButton:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer > div.athenaeum-grid-toggleButton {\n  display: flex;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer {\n  height: auto;\n  position: absolute;\n  background-color: rgb(254, 80, 0);\n  width: auto;\n  min-width: 100%;\n  left: auto;\n  right: 0;\n  bottom: 0;\n  border-radius: 5px;\n  color: white;\n  margin: 2px 0;\n  padding: 3px 0;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 150;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-alignLeft {\n  left: 0;\n  right: auto;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-alignTop {\n  bottom: 35px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-alignBottom {\n  bottom: auto;\n  top: auto;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-opened {\n  visibility: visible;\n  position: absolute;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList {\n  position: unset !important;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults {\n  color: white;\n  padding: 0 12px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-iconContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-iconContainer {\n  padding: 2px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-checkbox, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-checkbox {\n  margin-left: auto;\n  padding-left: 10px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults {\n  border-radius: 0;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div {\n  padding-top: 2px;\n  padding-bottom: 3px;\n  width: auto;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > span {\n  display: inline;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > small {\n  margin-left: 0.5em;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 75%;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter {\n  padding: 4px 8px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean {\n  color: black !important;\n  right: 16px;\n  margin-top: 0;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-addButton {\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-addButton > span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults {\n  cursor: default;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults:hover {\n  background-color: transparent;\n}\n\n.athenaeum-grid-dropdownWidget {\n  width: calc(100% + 24px);\n  left: -12px;\n  bottom: -36px;\n}\n\n.athenaeum-grid-transparent {\n  background-color: transparent;\n  border: none;\n}\n.athenaeum-grid-transparent:hover i.athenaeum-grid-transparent {\n  visibility: visible;\n}\n.athenaeum-grid-transparent.athenaeum-grid-selected:hover {\n  background-color: rgba(227, 227, 226, 0.5);\n}\n.athenaeum-grid-transparent:not(.athenaeum-grid-selected) {\n  margin: -6px 0px -6px -12px;\n}\n\ni.athenaeum-grid-transparent {\n  visibility: hidden;\n}\n\n.athenaeum-grid-small {\n  min-width: 52px;\n}\n.athenaeum-grid-small > div:first-child {\n  padding: 0.375rem;\n  height: auto;\n}\n.athenaeum-grid-small > div:first-child span {\n  font-size: 0.8rem;\n}\n\n.athenaeum-grid-grid {\n  font-size: 0.7rem !important;\n  background-color: rgba(255, 255, 255, 0.95);\n  width: auto !important;\n  min-width: 100%;\n  margin-bottom: 0;\n  position: relative;\n}\n.athenaeum-grid-grid.athenaeum-grid-noRowHovering tr:hover {\n  background-color: transparent;\n}\n.athenaeum-grid-grid thead.athenaeum-grid-noHeader {\n  visibility: collapse;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th {\n  cursor: default;\n  min-width: 66px;\n  white-space: nowrap;\n  padding: 0.5rem 0.75rem;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th .athenaeum-grid-rotateHeader {\n  transform: translate(0px, 0px) rotate(315deg);\n  width: 30px;\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-stickyHeader {\n  position: sticky;\n  background: white;\n  z-index: 999;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-sortable {\n  cursor: pointer;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-sortable:hover {\n  border-bottom-width: 2px;\n  border-bottom-color: black;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-sortable.athenaeum-grid-asc > div > span, .athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-sortable.athenaeum-grid-desc > div > span {\n  text-decoration: underline;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-check {\n  min-width: 40px;\n  max-width: 40px;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-check input {\n  cursor: pointer;\n  user-select: none;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-check.athenaeum-grid-partially input {\n  opacity: 0.6;\n}\n.athenaeum-grid-grid thead tr:hover {\n  background-color: transparent !important;\n}\n.athenaeum-grid-grid tbody > tr {\n  height: 0;\n}\n.athenaeum-grid-grid tbody.athenaeum-grid-spinner {\n  width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  border: 1px transparent;\n}\n.athenaeum-grid-grid tbody.athenaeum-grid-spinner tr {\n  width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n.athenaeum-grid-grid tbody.athenaeum-grid-spinner tr td {\n  width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  border: none;\n  font-size: 0;\n  line-height: 0;\n}\n.athenaeum-grid-grid td {\n  vertical-align: middle !important;\n}\n.athenaeum-grid-grid td:first-of-type {\n  min-width: 40px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-rowSpan {\n  background-color: inherit;\n}\n.athenaeum-grid-grid td.athenaeum-grid-square {\n  min-width: 135px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-dropdown {\n  min-width: 190px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-cellHovering:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted {\n  position: relative;\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted:before {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  border-bottom: 1px solid rgba(234, 60, 0, 0.9);\n  height: 0;\n  content: \"·\";\n  font-size: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted.athenaeum-grid-firstColumn:before {\n  left: 0.5rem;\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted.athenaeum-grid-lastColumn:before {\n  right: 0.5rem;\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted .athenaeum-grid-defaultCell span {\n  opacity: 0.25;\n}\n.athenaeum-grid-grid td.athenaeum-grid-check {\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n}\n.athenaeum-grid-grid td.athenaeum-grid-check input {\n  cursor: pointer;\n}\n.athenaeum-grid-grid td.athenaeum-grid-check.athenaeum-grid-disabled {\n  cursor: not-allowed;\n}\n.athenaeum-grid-grid td.athenaeum-grid-check.athenaeum-grid-disabled input {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.athenaeum-grid-grid td.athenaeum-grid-noWrap {\n  white-space: nowrap;\n}\n.athenaeum-grid-grid td.athenaeum-grid-noWrap .athenaeum-grid-textCell span {\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  display: block;\n}\n.athenaeum-grid-grid td.athenaeum-grid-wordBreak {\n  word-break: break-word;\n}\n.athenaeum-grid-grid td.athenaeum-grid-wordBreak .athenaeum-grid-textCell span {\n  word-break: break-word;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge {\n  padding: 8px 12px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div div.alignTop {\n  bottom: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell {\n  min-height: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell .athenaeum-grid-twoLines {\n  position: relative;\n  height: 23px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span {\n  position: absolute;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:first-child {\n  top: -3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:nth-child(2) {\n  top: 11px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > div > div span {\n  height: 12px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div span {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium {\n  padding: 3px 6px;\n  /* Default cell */\n  /* Text cell */\n  /* Date cell */\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-enumCell .athenaeum-grid-dropdown {\n  min-width: 100%;\n  width: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div {\n  padding: 0 3px !important;\n  margin: 0 -6px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child {\n  padding: 3px 2px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div div.alignTop {\n  bottom: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > div > div span {\n  height: 12px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div span {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div {\n  padding: 0 6px !important;\n  margin: 0 -9px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div input {\n  padding: 3px 2px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell {\n  min-height: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-twoLines {\n  position: relative;\n  height: 24px;\n  top: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span {\n  position: absolute;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:first-child {\n  top: -3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:nth-child(2) {\n  top: 11px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-actions {\n  margin-right: 0;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div {\n  padding: 0;\n  margin-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div span {\n  padding: 0;\n  line-height: 22px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div input {\n  padding: 3px 2px;\n  width: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput.athenaeum-grid-noWrap > div > div span {\n  max-height: 1px;\n  white-space: initial;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div {\n  padding: 0;\n  margin-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div span {\n  padding-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div input {\n  padding: 3px 2px;\n  width: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-actions {\n  margin-right: 0;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell.athenaeum-grid-noActions input {\n  width: calc(100% + 6px) !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-dateCell .athenaeum-grid-actions {\n  margin-right: -1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall {\n  padding: 1px 3px;\n  /* Enum cell (DropDown) */\n  /* Number cell */\n  /* Default cell */\n  /* Text cell */\n  /* Date cell */\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-enumCell .athenaeum-grid-dropdown {\n  min-width: 100%;\n  width: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div {\n  padding: 3px !important;\n  margin: 0 -3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child {\n  padding: 0 2px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div div.alignTop {\n  bottom: 25px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer {\n  padding-left: 3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer > span {\n  left: 3px;\n  top: 11px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > div > div span {\n  height: 12px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div {\n  padding: 0;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div span {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div {\n  padding: 3px !important;\n  margin: 0 -3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div input {\n  padding: 0 3px !important;\n  height: 22px;\n  margin-top: -2px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput.athenaeum-grid-withArrows > div > div > div > div {\n  padding-right: 3px;\n  height: 22px;\n  top: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell {\n  min-height: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell span {\n  padding: 0 3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-twoLines {\n  position: relative;\n  height: 24px;\n  top: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span {\n  position: absolute;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:first-child {\n  top: -3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:nth-child(2) {\n  top: 10px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-actions {\n  margin-right: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div {\n  padding: 0 3px;\n  margin-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div span {\n  padding: 0;\n  line-height: 22px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div input {\n  height: 22px;\n  padding: 0 2px;\n  width: calc(100% + 3px);\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div {\n  padding: 0 3px;\n  margin-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div span {\n  padding-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div input {\n  height: 22px;\n  padding: 0 2px;\n  width: calc(100% + 3px);\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput.athenaeum-grid-noWrap > div > div span {\n  max-height: 1px;\n  white-space: initial;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-actions {\n  margin-right: 1px;\n  padding: 0 0 0 4px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell.athenaeum-grid-noActions input {\n  width: calc(100% + 6px) !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-dateCell .athenaeum-grid-twoLines span {\n  padding: 0 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-dateCell input {\n  padding: 0 3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-dateCell .athenaeum-grid-actions {\n  margin-right: 5px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-cell .athenaeum-grid-actions > i {\n  padding: 2px 4px;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell.athenaeum-grid-fixedLineHeight {\n  line-height: 12px;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell.athenaeum-grid-noActions {\n  min-width: 100%;\n  width: auto;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell > span {\n  width: inherit;\n  cursor: default;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-center {\n  margin-left: auto;\n  margin-right: auto;\n  justify-content: center;\n  text-align: center;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions {\n  padding: 0 0 0 8px;\n  white-space: nowrap;\n  display: block;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions:first-child {\n  padding-left: 0;\n  width: 100%;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i {\n  padding: 4px;\n  font-size: 1rem;\n  margin: 0 1px;\n  cursor: pointer;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i.athenaeum-grid-actionDisabled {\n  cursor: default;\n  opacity: 0.5;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i:first-child {\n  margin-left: 0;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i:last-child {\n  margin-right: 0;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i:hover:not(.athenaeum-grid-actionDisabled) {\n  box-shadow: 0 0 0 1px #adadad;\n  border-radius: 3px;\n  background-color: rgb(254, 80, 0);\n  color: white !important;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions .athenaeum-grid-actionRight {\n  float: right;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions .athenaeum-grid-actionDisabled {\n  visibility: visible;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell input:not(.filter) {\n  padding: 0;\n  line-height: 1;\n  height: auto;\n  min-width: 46px;\n  color: #212529;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown {\n  min-width: 100%;\n  width: 100%;\n  margin: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div {\n  padding: 0 0.375rem;\n  margin: 0 -0.75rem;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child {\n  width: 100%;\n  height: auto;\n  padding: 3px 5px;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child span {\n  font-size: 0.8em !important;\n  text-align: left;\n  min-height: 16px;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child:not(:hover) {\n  background-color: transparent;\n  border-color: transparent;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child:not(:hover) i {\n  display: none;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell.athenaeum-grid-notValid .athenaeum-grid-dropdown > div > div > div > div:first-child span {\n  color: #a94442;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell {\n  position: relative;\n  margin-bottom: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer {\n  width: 100%;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > span {\n  position: absolute;\n  left: 0;\n  top: 0.75rem;\n  color: #adadad;\n  cursor: default;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > span.athenaeum-grid-hideZero {\n  display: none;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo .athenaeum-grid-numberInput span {\n  margin-top: -0.5rem;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo .athenaeum-grid-numberInput.athenaeum-grid-bold span {\n  font-weight: bold;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput {\n  width: 100%;\n  margin: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput span {\n  padding-bottom: 0.5rem;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput.athenaeum-grid-hideZero span {\n  color: transparent;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div {\n  height: 24px;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  padding: 0 0.375rem;\n  margin: 0 -0.75rem;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div > div {\n  padding-right: 6px;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput input {\n  width: 100%;\n  font-size: 0.8rem !important;\n  height: 24px;\n  padding: 3px 5px;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput input:focus {\n  outline: none;\n  box-shadow: none;\n  border-color: #ced4da;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput.athenaeum-grid-withArrows input {\n  padding-right: 20px;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell.athenaeum-grid-notValid span {\n  color: #a94442;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell > div {\n  margin: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell .athenaeum-grid-twoLines {\n  height: 24px;\n  position: relative;\n  top: -2px;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell .athenaeum-grid-twoLines span {\n  color: #adadad;\n  position: relative;\n  top: -2px;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell .athenaeum-grid-shortDate input {\n  width: 42px;\n  min-width: 42px !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell input {\n  border: 0;\n  background-color: transparent !important;\n  width: 54px;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell input:focus, .athenaeum-grid-grid .athenaeum-grid-dateCell input:active {\n  box-shadow: none;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell.athenaeum-grid-notValid div input {\n  color: #a94442;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell .athenaeum-grid-actions {\n  margin-right: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell {\n  position: relative;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer {\n  width: 100%;\n  overflow-x: hidden;\n  margin-left: -6px;\n  margin-right: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput {\n  width: 100%;\n  margin: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div input {\n  padding: 3px 5px;\n  width: 100%;\n  font-size: 0.8rem !important;\n  box-sizing: border-box;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div input:focus {\n  outline: none;\n  box-shadow: none;\n  border-color: #ced4da;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div span {\n  padding: 0;\n  height: auto;\n  min-height: 16px;\n  line-height: 22px;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput {\n  width: 100%;\n  margin: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div input {\n  padding: 3px 5px;\n  width: 100%;\n  font-size: 0.8rem !important;\n  box-sizing: border-box;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div input:focus {\n  outline: none;\n  box-shadow: none;\n  border-color: #ced4da;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div span {\n  height: auto;\n  min-height: 16px;\n  padding-left: 6px;\n  padding-right: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell.athenaeum-grid-noActions .athenaeum-grid-textContainer {\n  width: calc(100% + 12px);\n  margin-left: -6px;\n  margin-right: -6px;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell.athenaeum-grid-noActions input {\n  width: 100% !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell.athenaeum-grid-noActions span {\n  padding-left: 6px !important;\n  padding-right: 6px !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-actions {\n  margin-right: -6px;\n}\n.athenaeum-grid-grid .athenaeum-grid-booleanCell {\n  position: relative;\n}\n.athenaeum-grid-grid .athenaeum-grid-booleanCell label {\n  width: 100% !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  text-align: center;\n  cursor: pointer;\n}\n.athenaeum-grid-grid .athenaeum-grid-booleanCell label input {\n  cursor: pointer;\n  width: auto !important;\n  min-width: auto !important;\n  padding: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell span {\n  width: 100% !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-twoLines {\n  width: 100%;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span {\n  display: block;\n  width: 100% !important;\n  cursor: default;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:last-child {\n  color: #adadad;\n  font-weight: normal;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span.athenaeum-grid-bold {\n  font-weight: bold;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-link {\n  cursor: pointer !important;\n  width: auto !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-link:hover {\n  text-decoration: underline;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-actions {\n  margin-right: -6px;\n}\n.athenaeum-grid-grid .athenaeum-grid-emptyRow {\n  height: 34px;\n}\n.athenaeum-grid-grid .athenaeum-grid-emptyRow td {\n  font-weight: 600;\n  text-align: center;\n  cursor: default;\n  color: #adadad;\n}\n.athenaeum-grid-grid .athenaeum-grid-emptyRow:hover {\n  background-color: white !important;\n}\n\n.athenaeum-grid-pagination {\n  margin-top: 8px;\n  margin-bottom: 1rem;\n  filter: none !important;\n}";
var styles$K = {"font-renta":"athenaeum-grid-font-renta","list":"athenaeum-grid-list","dropdown":"athenaeum-grid-dropdown","disabled":"athenaeum-grid-disabled","selected":"athenaeum-grid-selected","itemsContainer":"athenaeum-grid-itemsContainer","filter":"athenaeum-grid-filter","clean":"athenaeum-grid-clean","addButton":"athenaeum-grid-addButton","scrollableContainer":"athenaeum-grid-scrollableContainer","itemsList":"athenaeum-grid-itemsList","noWrap":"athenaeum-grid-noWrap","lineThrough":"athenaeum-grid-lineThrough","item":"athenaeum-grid-item","noResults":"athenaeum-grid-noResults","listItem":"athenaeum-grid-listItem","selectedItem":"athenaeum-grid-selectedItem","inlineSubtext":"athenaeum-grid-inlineSubtext","iconContainer":"athenaeum-grid-iconContainer","minus":"athenaeum-grid-minus","amountTitle":"athenaeum-grid-amountTitle","amountUnit":"athenaeum-grid-amountUnit","amountDisabled":"athenaeum-grid-amountDisabled","amount":"athenaeum-grid-amount","plus":"athenaeum-grid-plus","notCompleted":"athenaeum-grid-notCompleted","group":"athenaeum-grid-group","groupSeparator":"athenaeum-grid-groupSeparator","itemGroupIdent":"athenaeum-grid-itemGroupIdent","opened":"athenaeum-grid-opened","hovered":"athenaeum-grid-hovered","focused":"athenaeum-grid-focused","toggleButtonVisible":"athenaeum-grid-toggleButtonVisible","clearButtonVisible":"athenaeum-grid-clearButtonVisible","toggleButtonContainer":"athenaeum-grid-toggleButtonContainer","clearButton":"athenaeum-grid-clearButton","toggleButton":"athenaeum-grid-toggleButton","alignLeft":"athenaeum-grid-alignLeft","alignTop":"athenaeum-grid-alignTop","alignBottom":"athenaeum-grid-alignBottom","checkbox":"athenaeum-grid-checkbox","dropdownWidget":"athenaeum-grid-dropdownWidget","transparent":"athenaeum-grid-transparent","small":"athenaeum-grid-small","grid":"athenaeum-grid-grid","noRowHovering":"athenaeum-grid-noRowHovering","noHeader":"athenaeum-grid-noHeader","th":"athenaeum-grid-th","rotateHeader":"athenaeum-grid-rotateHeader","stickyHeader":"athenaeum-grid-stickyHeader","sortable":"athenaeum-grid-sortable","asc":"athenaeum-grid-asc","desc":"athenaeum-grid-desc","check":"athenaeum-grid-check","partially":"athenaeum-grid-partially","spinner":"athenaeum-grid-spinner","rowSpan":"athenaeum-grid-rowSpan","square":"athenaeum-grid-square","cellHovering":"athenaeum-grid-cellHovering","deleted":"athenaeum-grid-deleted","firstColumn":"athenaeum-grid-firstColumn","lastColumn":"athenaeum-grid-lastColumn","defaultCell":"athenaeum-grid-defaultCell","textCell":"athenaeum-grid-textCell","wordBreak":"athenaeum-grid-wordBreak","paddingLarge":"athenaeum-grid-paddingLarge","enumCell":"athenaeum-grid-enumCell","twoLines":"athenaeum-grid-twoLines","numberCell":"athenaeum-grid-numberCell","numberContainer":"athenaeum-grid-numberContainer","numberInfo":"athenaeum-grid-numberInfo","numberInput":"athenaeum-grid-numberInput","paddingMedium":"athenaeum-grid-paddingMedium","actions":"athenaeum-grid-actions","textContainer":"athenaeum-grid-textContainer","addressInput":"athenaeum-grid-addressInput","textInput":"athenaeum-grid-textInput","noActions":"athenaeum-grid-noActions","dateCell":"athenaeum-grid-dateCell","paddingSmall":"athenaeum-grid-paddingSmall","withArrows":"athenaeum-grid-withArrows","cell":"athenaeum-grid-cell","fixedLineHeight":"athenaeum-grid-fixedLineHeight","center":"athenaeum-grid-center","actionDisabled":"athenaeum-grid-actionDisabled","actionRight":"athenaeum-grid-actionRight","notValid":"athenaeum-grid-notValid","hideZero":"athenaeum-grid-hideZero","bold":"athenaeum-grid-bold","shortDate":"athenaeum-grid-shortDate","booleanCell":"athenaeum-grid-booleanCell","link":"athenaeum-grid-link","emptyRow":"athenaeum-grid-emptyRow","pagination":"athenaeum-grid-pagination"};
styleInject(css_248z$R);

class CellActionComponent extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  invokeActionCallbackAsync(cell, action, selectedAction, data) {
    return __awaiter(this, void 0, void 0, function* () {
      const descriptionCellAction = this.getDescriptionCellAction();
      if (descriptionCellAction) {
        yield this.toggleDescriptionAsync(cell, descriptionCellAction);
      } else if (action.action.callback && !action.disabled) {
        yield action.action.callback(cell, action, selectedAction, data);
      }
    });
  }
  getActionColor(actionType) {
    switch (actionType) {
      case ActionType.Default:
        return "text-dark";
      case ActionType.Create:
        return "text-success";
      case ActionType.Edit:
        return "text-warning";
      case ActionType.Delete:
        return "text-danger";
      case ActionType.Muted:
        return "text-muted";
      case ActionType.Secondary:
        return "text-secondary";
      case ActionType.Light:
        return "text-light";
      case ActionType.Grey:
        return "grey";
      case ActionType.Info:
        return "text-info";
      case ActionType.Blue:
        return "text-primary";
      default:
        return "text-primary";
    }
  }
  toggleDescriptionAsync(cell, action) {
    return __awaiter(this, void 0, void 0, function* () {
      const model = new DescriptionModel();
      model.description = cell.description;
      model.align = action.alight;
      model.justify = action.justify;
      model.maxLength = action.maxLength;
      model.readonly = cell.descriptionReadonly;
      model.onChange = value => __awaiter(this, void 0, void 0, function* () {
        return this.updateDescriptionAsync(cell, action, value);
      });
      yield ch.descriptionAsync(cell.instance.id, model);
    });
  }
  updateDescriptionAsync(cell, action, value) {
    return __awaiter(this, void 0, void 0, function* () {
      const hadDescription = !!cell.description;
      cell.description = value;
      if (action.action.callback) {
        yield action.action.callback(cell, action);
      }
      if (hadDescription && !cell.description) {
        yield cell.reRenderAsync();
      }
    });
  }
  get cell() {
    return this.props.cell;
  }
  get cellAction() {
    return this.props.cellAction;
  }
  getDescriptionCellAction() {
    const cellAction = this.cellAction;
    return cellAction instanceof DescriptionCellAction ? cellAction : null;
  }
  get columnAction() {
    return this.cellAction.action;
  }
  render() {
    const cellAction = this.cellAction;
    const action = this.columnAction;
    const actions = action.actions;
    const cell = this.cell;
    cellAction.instance = this;
    const hasActions = actions.length > 0;
    const isDescription = cellAction instanceof DescriptionCellAction;
    const alwaysAvailable = isDescription || action.alwaysAvailable;
    const visible = cellAction.visible && (alwaysAvailable || !cell.grid.readonly);
    const disabled = cellAction.disabled;
    const actionColorClassName = this.getActionColor(action.type);
    const rightStyle = action.right && styles$K.actionRight;
    const disabledStyle = disabled && styles$K.actionDisabled;
    const hasToggleModal = action.toggleModal != null;
    let dataModal = undefined;
    if (hasToggleModal) {
      try {
        dataModal = JSON.stringify(cell.model);
      } catch (_a) {
        // Just to solve cyclic object parsing problem
      }
    }
    let confirm = null;
    if (action.confirm) {
      if (typeof action.confirm === "function") {
        const routeCallback = action.confirm;
        confirm = routeCallback(cell, cellAction);
      } else {
        confirm = action.confirm;
      }
    }
    let icon = action.icon;
    if (isDescription) {
      icon = {
        name: cell.descriptionIcon ? cell.descriptionIcon : cell.description ? "far comment-alt-dots" : "far comment-alt"
      };
    }
    if (!action.title && !icon) {
      icon = {
        name: "fas circle"
      };
    }
    if (action.right) ;
    return React.createElement(React.Fragment, null, visible && React.createElement(React.Fragment, null, icon ? hasActions ? React.createElement(Icon, Object.assign({
      id: this.id
    }, icon, {
      tooltip: action.tooltip || action.title,
      className: this.css(actionColorClassName, rightStyle, disabledStyle, action.className),
      dataTarget: action.toggleModal,
      dataModal: dataModal,
      toggleModal: !!action.toggleModal,
      confirm: confirm,
      onClick: (sender, data) => this.invokeActionCallbackAsync(cell, cellAction, null, data)
    }), actions.map((action, index) => {
      return React.createElement(Icon.Action, {
        key: index,
        title: action.label,
        tooltip: action.title,
        icon: action.icon,
        iconPosition: action.iconPosition,
        onClick: () => this.invokeActionCallbackAsync(cell, cellAction, action.name)
      });
    })) : React.createElement(Icon, Object.assign({
      id: this.id
    }, icon, {
      tooltip: action.tooltip || action.title,
      className: this.css(actionColorClassName, rightStyle, disabledStyle, action.className),
      dataTarget: action.toggleModal,
      dataModal: dataModal,
      toggleModal: !!action.toggleModal,
      confirm: confirm,
      onClick: (sender, data) => this.invokeActionCallbackAsync(cell, cellAction, null, data)
    })) : hasActions ? React.createElement(Button, {
      id: this.id,
      label: action.title,
      title: action.tooltip,
      className: this.css(actionColorClassName, rightStyle, disabledStyle, action.className),
      dataTarget: action.toggleModal,
      dataModal: dataModal,
      toggleModal: !!action.toggleModal,
      disabled: disabled,
      confirm: confirm,
      onClick: (sender, data) => this.invokeActionCallbackAsync(cell, cellAction, null, data)
    }, actions.map((action, index) => {
      return React.createElement(Button.Action, {
        key: index,
        title: action.label,
        tooltip: action.title,
        icon: action.icon,
        iconPosition: action.iconPosition,
        onClick: () => this.invokeActionCallbackAsync(cell, cellAction, action.name)
      });
    })) : React.createElement(Button, {
      id: this.id,
      label: action.title,
      title: action.tooltip,
      className: this.css(actionColorClassName, rightStyle, disabledStyle, action.className),
      dataTarget: action.toggleModal,
      dataModal: dataModal,
      toggleModal: !!action.toggleModal,
      disabled: disabled,
      confirm: confirm,
      onClick: (sender, data) => this.invokeActionCallbackAsync(cell, cellAction, null, data)
    })));
  }
}

class DropdownCell extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false
    };
    this._inputRef = React.createRef();
  }
  onChangeAsync(sender, value, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      const cell = this.model;
      let modelValue = value;
      if (modelValue != null && (modelValue instanceof SelectListItem || modelValue.isSelectListItem)) {
        modelValue = parseInt(modelValue.value);
      }
      if (this.settings.multiple && this.items) {
        const selectedItems = sender.selectedItems;
        modelValue = this.items.filter(item => selectedItems.some(selectedItem => Comparator.isEqual(selectedItem, item)));
      }
      const cellState = cell.modified;
      cell.setValue(modelValue);
      if (userInteraction && cell.column.callback) {
        yield cell.column.callback(cell, null);
      }
      const modified = cellState !== cell.modified;
      if (modified) {
        yield cell.row.reRenderAsync();
      } else {
        yield this.reRenderAsync();
      }
    });
  }
  selectedTextTransform(sender) {
    return !this.hasData || this.isLoading ? "" : this.settings.selectedTextTransform(sender);
  }
  get selectedTextTransformLambda() {
    return this.settings.selectedTextTransform ? sender => this.selectedTextTransform(sender) : undefined;
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.settings.fetchItems) {
        return yield this.settings.fetchItems(this.model);
      }
      return [];
    });
  }
  onAddAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.settings.addCallback) {
        yield this.settings.addCallback(this.model);
      }
    });
  }
  getEndpoint() {
    return "";
  }
  isAsync() {
    return this.settings.fetchItems != null;
  }
  get model() {
    return this.props.cell;
  }
  get settings() {
    return this.model.column.settings;
  }
  get items() {
    return this.state.data || [];
  }
  get value() {
    return this.model.value;
  }
  get selectedItem() {
    return !this.settings.multiple ? this.value : null;
  }
  get values() {
    return this.model.value;
  }
  get selectedItems() {
    return this.settings.multiple ? this.values : null;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      this.props.cell.inputContentInstance = this._inputRef.current;
    });
  }
  render() {
    this.model.asyncContentInstance = this;
    return React.createElement(React.Fragment, null, React.createElement(Dropdown, {
      ref: this._inputRef,
      noSubtext: true,
      noWrap: true,
      nothingSelectedText: this.settings.nothingSelectedText || undefined,
      autoCollapse: this.settings.autoCollapse,
      multiple: this.settings.multiple,
      align: this.settings.align,
      verticalAlign: this.settings.verticalAlign,
      required: this.settings.required,
      groupSelected: this.settings.groupSelected,
      noFilter: this.settings.noFilter,
      requiredType: this.settings.requiredType,
      className: styles$K.dropdown,
      orderBy: DropdownOrderBy.None,
      addButton: this.settings.addButton,
      items: this.items,
      selectedItem: this.selectedItem || undefined,
      selectedItems: this.selectedItems || undefined,
      selectedTextTransform: this.selectedTextTransformLambda,
      onAdd: () => this.onAddAsync(),
      onChange: (sender, item, userInteraction) => this.onChangeAsync(sender, item, userInteraction)
    }));
  }
}

var css_248z$Q = ".athenaeum-location-picker-locationPicker {\n  width: 640px;\n  height: 480px;\n}\n.athenaeum-location-picker-locationPicker.athenaeum-location-picker-fullWidth {\n  width: 100%;\n}\n.athenaeum-location-picker-locationPicker > div {\n  margin-bottom: 4px;\n}\n.athenaeum-location-picker-locationPicker .athenaeum-location-picker-map {\n  width: 100%;\n  height: calc(100% - 39px);\n}";
var styles$J = {"locationPicker":"athenaeum-location-picker-locationPicker","fullWidth":"athenaeum-location-picker-fullWidth","map":"athenaeum-location-picker-map"};
styleInject(css_248z$Q);

class LocationPicker extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      location: this.props.location || null,
      searchLocation: this.props.location != null ? this.props.location.formattedAddress : ""
    };
    this._addressInputRef = React.createRef();
    this._locationPickerRef = React.createRef();
    this._googleMap = null;
    this._marker = null;
    this._infoWindow = null;
  }
  get locationPicker() {
    return this._locationPickerRef.current;
  }
  get addressInput() {
    return this._addressInputRef.current;
  }
  get googleMap() {
    return this._googleMap;
  }
  get isValidLocation() {
    return this.location != null && AddressHelper.hasCoordinates(this.location);
  }
  get infoWindowContent() {
    return this.location ? `<div class="infoContent">
                    <span class="address">${AddressHelper.removeLatLon(this.location.formattedAddress)}</span>
                    <span class="dms">${AddressHelper.toDMS(this.location)}</span>
               </div>
               ` : "";
  }
  initAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._googleMap = yield AddressHelper.createMapAsync(this.locationPicker, this.state.location, this.props.zoomLevel);
      if (!this.readonly) {
        AddressHelper.google.maps.event.addListener(this._googleMap, "click", event => __awaiter(this, void 0, void 0, function* () {
          yield this.onMapClickAsync(event.latLng);
        }));
      }
      if (this.location) {
        yield this.coordinateLocationAsync(this.location);
        yield this.setMarkerAsync(true);
      }
    });
  }
  coordinateLocationAsync(location) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!AddressHelper.hasCoordinates(location)) {
        const coordinate = yield AddressHelper.findAddressAsync(this.googleMap, location.formattedAddress);
        if (coordinate != null) {
          location.lat = coordinate.lat;
          location.lon = coordinate.lon;
          yield this.invokeOnChangeAsync();
        }
      }
    });
  }
  invokeOnChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange && this.location) {
        yield this.props.onChange(this, this.location);
      }
    });
  }
  setLocationAsync(location, setCenter = false) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        location
      });
      yield this.setMarkerAsync(setCenter);
    });
  }
  onMapClickAsync(latLng) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly) {
        const location = yield AddressHelper.findLocationByLatLngAsync(latLng);
        if (location) {
          location.lat = latLng.lat();
          location.lon = latLng.lng();
          this.state.searchLocation = "";
          yield this.setLocationAsync(location);
          yield this.invokeOnChangeAsync();
        }
      }
    });
  }
  setMarkerAsync(setCenter = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.location && this.isValidLocation) {
        const latLng = new AddressHelper.google.maps.LatLng(this.location.lat, this.location.lon);
        if (this._marker) {
          this._marker.setPosition(latLng);
        } else {
          this._marker = yield AddressHelper.addMarkerAsync(latLng, this.googleMap);
        }
        if (this.props.infoWindow) {
          if (this._infoWindow) {
            this._infoWindow.close();
            this._infoWindow.setContent(this.infoWindowContent);
          } else {
            this._infoWindow = yield AddressHelper.addInfoWindow(this.infoWindowContent);
          }
          this._marker.addListener("click", () => this._infoWindow.open(this._googleMap, this._marker));
        }
        if (setCenter) {
          this.googleMap.setCenter(latLng);
        }
      }
    });
  }
  onInputChange(location) {
    return __awaiter(this, void 0, void 0, function* () {
      this.state.searchLocation = location.formattedAddress;
      yield this.setLocationAsync(location, true);
      yield this.invokeOnChangeAsync();
    });
  }
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      const nextLocation = nextProps.location || null;
      const newLocation = !Comparator.isEqual(this.state.location, nextLocation);
      if (newLocation && nextLocation) {
        this.state.searchLocation = nextLocation.formattedAddress;
        yield this.setLocationAsync(nextLocation, true);
        yield this.coordinateLocationAsync(nextLocation);
      }
    });
  }
  componentDidMount() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initAsync();
    });
  }
  focus() {
    this.addressInput.focus();
  }
  get readonly() {
    return this.props.readonly == true;
  }
  get location() {
    return this.state.location;
  }
  get formattedAddress() {
    return this.location ? this.location.formattedAddress : "";
  }
  render() {
    return React.createElement("div", {
      className: this.css(styles$J.locationPicker, this.props.fullWidth && styles$J.fullWidth)
    }, !this.readonly && React.createElement(AddressInput, {
      id: `AddressInput_within_location_${this.id}`,
      readonly: this.readonly,
      ref: this._addressInputRef,
      value: this.state.searchLocation,
      country: this.props.country,
      onChange: location => this.onInputChange(location)
    }), React.createElement("div", {
      id: this.props.id || this.id,
      ref: this._locationPickerRef,
      className: styles$J.map
    }));
  }
}

//Autogenerated
class LocationPickerModalLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.titleLanguageItemName = `_12:0`;
    this.subtitleLanguageItemName = `_12:1`;
    this.setLocationLanguageItemName = `_12:2`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_12:0`, {
      l: `en`,
      v: `Location picker`
    }, {
      l: `uk`,
      v: `Вибір розташування`
    }, {
      l: `sv`,
      v: `Platsväljare`
    }, {
      l: `ru`,
      v: `Выбор местоположения`
    }, {
      l: `pl`,
      v: `Wybierz lokalizację`
    }, {
      l: `nl`,
      v: `Locatiekiezer`
    }, {
      l: `nb`,
      v: `Stedsvelger`
    }, {
      l: `it`,
      v: `Selettore di posizione`
    }, {
      l: `fr`,
      v: `Sélecteur d'emplacement`
    }, {
      l: `fi`,
      v: `Sijaintivalitsin`
    }, {
      l: `es`,
      v: `Selector de ubicación`
    }, {
      l: `de`,
      v: `Standortauswahl`
    }, {
      l: `da`,
      v: `Placeringsvælger`
    });
    this.set(`_12:1`, {
      l: `en`,
      v: `Choose location on map`
    }, {
      l: `uk`,
      v: `Оберіть місце на мапі`
    }, {
      l: `sv`,
      v: `Välj plats på kartan`
    }, {
      l: `ru`,
      v: `Выбрать местоположение на карте`
    }, {
      l: `pl`,
      v: `Wybierz lokalizację na mapie`
    }, {
      l: `nl`,
      v: `Kies locatie op de kaart`
    }, {
      l: `nb`,
      v: `Velg plassering på kartet`
    }, {
      l: `it`,
      v: `Scegli la posizione sulla mappa`
    }, {
      l: `fr`,
      v: `Choisissez un emplacement sur la carte`
    }, {
      l: `fi`,
      v: `Valitse sijainti kartalla`
    }, {
      l: `es`,
      v: `Elige ubicación en el mapa`
    }, {
      l: `de`,
      v: `Wählen Sie den Standort auf der Karte`
    }, {
      l: `da`,
      v: `Vælg placering på kortet`
    });
    this.set(`_12:2`, {
      l: `en`,
      v: `Set location`
    }, {
      l: `uk`,
      v: `Оберіть адресу`
    }, {
      l: `sv`,
      v: `Ställ in plats`
    }, {
      l: `ru`,
      v: `Установить местоположение`
    }, {
      l: `pl`,
      v: `Ustaw lokalizację`
    }, {
      l: `nl`,
      v: `Locatie instellen`
    }, {
      l: `nb`,
      v: `Angi sted`
    }, {
      l: `it`,
      v: `Imposta la posizione`
    }, {
      l: `fr`,
      v: `Définir l'emplacement`
    }, {
      l: `fi`,
      v: `Aseta sijainti`
    }, {
      l: `es`,
      v: `Escoger localización`
    }, {
      l: `de`,
      v: `Ort festlegen`
    }, {
      l: `da`,
      v: `Indstil placering`
    });
  }
  /**
  /* "Title" (Location picker)
  /* "Localizer.title"
  /* "Localizer.titleLanguageItemName"
  */
  get title() {
    return this.get(`_12:0`);
  }
  /**
  /* "Subtitle" (Choose location on map)
  /* "Localizer.subtitle"
  /* "Localizer.subtitleLanguageItemName"
  */
  get subtitle() {
    return this.get(`_12:1`);
  }
  /**
  /* "SetLocation" (Set location)
  /* "Localizer.setLocation"
  /* "Localizer.setLocationLanguageItemName"
  */
  get setLocation() {
    return this.get(`_12:2`);
  }
}
//Singleton
var LocationPickerModalLocalizer$1 = new LocationPickerModalLocalizer();

var css_248z$P = ".athenaeum-location-picker-modal-locationPickerModal .modal-dialog {\n  max-width: 674px !important;\n}\n.athenaeum-location-picker-modal-locationPickerModal .infoContent {\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-location-picker-modal-locationPickerModal .infoContent .address {\n  font-weight: 600;\n}\n.athenaeum-location-picker-modal-locationPickerModal .infoContent .dms {\n  font-size: 12px;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-map {\n  padding-bottom: 1rem;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address {\n  height: 100%;\n  width: 500px;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address .athenaeum-location-picker-modal-coordinate {\n  display: flex;\n  align-items: center;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address .athenaeum-location-picker-modal-coordinate span {\n  font-size: 12px;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address .athenaeum-location-picker-modal-coordinate span.athenaeum-location-picker-modal-separator {\n  margin: 0 8px;\n  display: block;\n  width: 1px;\n  height: 70%;\n  background-color: black;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address .athenaeum-location-picker-modal-dms {\n  font-size: 12px;\n}";
var styles$I = {"locationPickerModal":"athenaeum-location-picker-modal-locationPickerModal","map":"athenaeum-location-picker-modal-map","address":"athenaeum-location-picker-modal-address","coordinate":"athenaeum-location-picker-modal-coordinate","separator":"athenaeum-location-picker-modal-separator","dms":"athenaeum-location-picker-modal-dms"};
styleInject(css_248z$P);

class LocationPickerModal extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      location: this.props.location || null
    };
    this._locationPickerRef = React.createRef();
    this._modalRef = React.createRef();
  }
  onSubmitAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly && this.props.onSubmit && this.locationPicker && this.location) {
        yield this.props.onSubmit(this, this.location);
      }
      if (this.modal) {
        yield this.modal.closeAsync();
      }
    });
  }
  onOpenAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.locationPicker) {
        this.locationPicker.focus();
      }
      if (this.props.onOpen) {
        yield this.props.onOpen(this);
      }
    });
  }
  onCloseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClose) {
        yield this.props.onClose(this);
      }
    });
  }
  onChangeAsync(location) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.locationPicker) {
        yield this.setState({
          location
        });
      }
    });
  }
  get locationPicker() {
    return this._locationPickerRef.current;
  }
  get modal() {
    return this._modalRef.current;
  }
  get location() {
    return this.state.location;
  }
  get formattedAddress() {
    if (this.locationPicker) {
      return this.locationPicker.formattedAddress;
    }
    return "";
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modal) {
        yield this.modal.openAsync();
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (nextProps.location && nextProps.location !== this.state.location) {
        yield this.setState({
          location: nextProps.location
        });
      }
    });
  }
  get readonly() {
    return !!this.props.readonly;
  }
  get required() {
    return this.props.required === true;
  }
  get hasLocation() {
    return this.location != null && !!this.location.formattedAddress;
  }
  get isOpen() {
    return !!this.modal && this.modal.isOpen;
  }
  render() {
    return React.createElement(Modal, {
      id: this.id,
      ref: this._modalRef,
      title: this.props.title || LocationPickerModalLocalizer$1.title,
      subtitle: this.props.subtitle || LocationPickerModalLocalizer$1.subtitle,
      className: styles$I.locationPickerModal,
      notResponsive: this.props.notResponsive,
      noHeader: this.props.noHeader,
      onOpen: () => this.onOpenAsync(),
      onClose: () => this.onCloseAsync()
    }, React.createElement("div", {
      className: styles$I.map
    }, React.createElement(LocationPicker, {
      ref: this._locationPickerRef,
      location: this.location || undefined,
      country: this.props.country,
      infoWindow: this.props.infoWindow,
      readonly: this.readonly,
      onChange: (sender, location) => this.onChangeAsync(location)
    })), React.createElement(ButtonContainer, null, React.createElement("div", {
      className: styles$I.address
    }, React.createElement("span", null, AddressHelper.removeLatLon(this.formattedAddress)), this.location && AddressHelper.hasCoordinates(this.location) && React.createElement("span", {
      className: styles$I.dms
    }, AddressHelper.toDMS(this.location))), !this.readonly ? React.createElement(Button, {
      type: ButtonType.Orange,
      label: LocationPickerModalLocalizer$1.setLocation,
      disabled: this.required && !this.hasLocation,
      onClick: () => this.onSubmitAsync()
    }) : React.createElement("div", null)));
  }
}

const isBrowser = typeof window != null && window.document != null;
const GOOGLE_MAP_SCRIPT_BASE_URL = "https://maps.googleapis.com/maps/api/js";
const loadGoogleMapScript = (googleMapsScriptBaseUrl, googleMapsScriptUrl) => {
  if (!isBrowser) {
    return Promise.resolve();
  }
  if (typeof google !== "undefined") {
    if (google.maps && google.maps.api) {
      return Promise.resolve();
    }
  }
  const scriptElements = document.querySelectorAll(`script[src*="${googleMapsScriptBaseUrl}"]`);
  if (scriptElements && scriptElements.length) {
    return new Promise(resolve => {
      // in case we already have a script on the page and it's loaded we resolve
      if (typeof google !== "undefined") return resolve();
      // otherwise we wait until it's loaded and resolve
      scriptElements[0].addEventListener("load", () => resolve());
    });
  }
  const el = document.createElement("script");
  el.src = googleMapsScriptUrl;
  document.body.appendChild(el);
  return new Promise(resolve => {
    el.addEventListener("load", () => resolve());
  });
};

const UsePlacesWidget = props => {
  const {
      ref = undefined,
      onPlaceSelected,
      apiKey,
      libraries = "places",
      inputAutocompleteValue = "new-password"
    } = props,
    _a = props.options,
    _b = _a === void 0 ? {} : _a,
    {
      types = ["(cities)"],
      componentRestrictions = undefined,
      fields = ["address_components", "geometry.location", "place_id", "formatted_address"],
      bounds = undefined
    } = _b,
    options = __rest(_b, ["types", "componentRestrictions", "fields", "bounds"]),
    {
      googleMapsScriptBaseUrl = GOOGLE_MAP_SCRIPT_BASE_URL,
      language
    } = props;
  const inputRef = useRef(null);
  const event = useRef(null);
  const autocompleteRef = useRef(null);
  const observerHack = useRef(null);
  const languageQueryParam = language ? `&language=${language}` : "";
  const googleMapsScriptUrl = `${googleMapsScriptBaseUrl}?libraries=${libraries}&key=${apiKey}${languageQueryParam}`;
  const handleLoadScript = useCallback(() => Utility.reTryAsync(() => loadGoogleMapScript(googleMapsScriptBaseUrl, googleMapsScriptUrl)), [googleMapsScriptBaseUrl, googleMapsScriptUrl]);
  useEffect(() => {
    const config = Object.assign(Object.assign({}, options), {
      fields,
      types,
      bounds
    });
    if (componentRestrictions) {
      config.componentRestrictions = componentRestrictions;
    }
    if (autocompleteRef.current || !inputRef.current || !isBrowser) return;
    if (ref && !ref.current) ref.current = inputRef.current;
    const handleAutoComplete = () => {
      var _a;
      if (typeof google === "undefined") return console.error("Google has not been found. Make sure your provide apiKey prop.");
      if (!((_a = google.maps) === null || _a === void 0 ? void 0 : _a.places)) return console.error("Google maps places API must be loaded.");
      if (!(inputRef.current instanceof HTMLInputElement)) return console.error("Input ref must be HTMLInputElement.");
      autocompleteRef.current = new google.maps.places.Autocomplete(inputRef.current, config);
      if (autocompleteRef.current) {
        event.current = autocompleteRef.current.addListener("place_changed", () => {
          if (onPlaceSelected && autocompleteRef && autocompleteRef.current) {
            onPlaceSelected(autocompleteRef.current.getPlace(), inputRef.current, autocompleteRef.current);
          }
        });
      }
    };
    if (apiKey) {
      handleLoadScript().then(() => handleAutoComplete());
    } else {
      handleAutoComplete();
    }
    return () => event.current ? event.current.remove() : undefined;
  }, []);
  // Autofill workaround adapted from https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3/49161445#49161445
  useEffect(() => {
    var _a;
    if (!((_a = React === null || React === void 0 ? void 0 : React.version) === null || _a === void 0 ? void 0 : _a.startsWith("18")) && isBrowser && window.MutationObserver && inputRef.current && inputRef.current instanceof HTMLInputElement) {
      observerHack.current = new MutationObserver(() => {
        observerHack.current.disconnect();
        if (inputRef.current) {
          inputRef.current.autocomplete = inputAutocompleteValue;
        }
      });
      observerHack.current.observe(inputRef.current, {
        attributes: true,
        attributeFilter: ["autocomplete"]
      });
    }
  }, [inputAutocompleteValue]);
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setFields(fields);
    }
  }, [fields]);
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setBounds(bounds);
    }
  }, [bounds]);
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setComponentRestrictions(componentRestrictions);
    }
  }, [componentRestrictions]);
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setOptions(options);
    }
  }, [options]);
  return {
    ref: inputRef,
    autocompleteRef
  };
};

const ReactGoogleAutocomplete = props => {
  const rest = __rest(props, ["onPlaceSelected", "apiKey", "libraries", "inputAutocompleteValue", "options", "googleMapsScriptBaseUrl", "language"]);
  const response = UsePlacesWidget({
    ref: props.ref,
    googleMapsScriptBaseUrl: props.googleMapsScriptBaseUrl,
    onPlaceSelected: props.onPlaceSelected,
    apiKey: props.apiKey,
    libraries: props.libraries,
    inputAutocompleteValue: props.inputAutocompleteValue,
    options: props.options,
    language: props.language
  });
  return React.createElement("input", Object.assign({
    ref: response.ref
  }, rest));
};

//Autogenerated
class AddressInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.validatorsCustomRequiredLanguageItemName = `_15:0`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_15:0`, {
      l: `en`,
      v: `Type and select an address from the list`
    }, {
      l: `sv`,
      v: `Skriv och välj en adress i listan`
    }, {
      l: `pl`,
      v: `Wpisz i wybierz adres z listy`
    }, {
      l: `nl`,
      v: `Typ en selecteer een adres uit de lijst`
    }, {
      l: `nb`,
      v: `Skriv inn og velg en adresse fra listen`
    }, {
      l: `it`,
      v: `Digitare e selezionare un indirizzo dall'elenco`
    }, {
      l: `fr`,
      v: `Tapez et sélectionnez une adresse dans la liste`
    }, {
      l: `fi`,
      v: `Kirjoita ja valitse osoite listasta`
    }, {
      l: `es`,
      v: `Escriba y seleccione una dirección de la lista`
    }, {
      l: `de`,
      v: `Geben Sie eine Adresse ein und wählen Sie sie aus der Liste aus`
    }, {
      l: `da`,
      v: `Skriv og vælg en adresse på listen`
    });
  }
  /**
  /* "Validators.Custom.Required" (Type and select an address from the list)
  /* "Localizer.validatorsCustomRequired"
  /* "Localizer.validatorsCustomRequiredLanguageItemName"
  */
  get validatorsCustomRequired() {
    return this.get(`_15:0`);
  }
}
//Singleton
var AddressInputLocalizer$1 = new AddressInputLocalizer();

var css_248z$O = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-text-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-text-input-textInputContainer {\n  position: relative;\n}\n.athenaeum-text-input-textInputContainer input.athenaeum-text-input-textInput.athenaeum-text-input-small {\n  font-size: 0.8rem;\n  padding: 0.375rem;\n  height: auto;\n  width: 5rem;\n  background-color: white;\n}\n.athenaeum-text-input-textInputContainer input.athenaeum-text-input-textInput.athenaeum-text-input-autoSuggest {\n  padding-right: 1.5rem;\n}\n.athenaeum-text-input-textInputContainer input.athenaeum-text-input-textInput.athenaeum-text-input-clearButton {\n  padding-right: 1.5rem;\n}\n.athenaeum-text-input-textInputContainer input.athenaeum-text-input-textInput.athenaeum-text-input-autoSuggest.athenaeum-text-input-clearButton {\n  padding-right: 2.5rem;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-autoSuggestIcon {\n  position: absolute;\n  top: 5px;\n  bottom: 4px;\n  right: 5px;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-autoSuggestIcon > i {\n  padding: 4px;\n  cursor: pointer;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-autoSuggestIcon:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-clearButtonIcon {\n  position: absolute;\n  top: 5px;\n  bottom: 4px;\n  right: 5px;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-clearButtonIcon:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-clearButtonIcon > i {\n  padding: 4px;\n  cursor: pointer;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-clearButtonIcon.athenaeum-text-input-autoSuggest {\n  right: 20px;\n}";
var styles$H = {"font-renta":"athenaeum-text-input-font-renta","textInputContainer":"athenaeum-text-input-textInputContainer","textInput":"athenaeum-text-input-textInput","small":"athenaeum-text-input-small","autoSuggest":"athenaeum-text-input-autoSuggest","clearButton":"athenaeum-text-input-clearButton","autoSuggestIcon":"athenaeum-text-input-autoSuggestIcon","clearButtonIcon":"athenaeum-text-input-clearButtonIcon"};
styleInject(css_248z$O);

class AddressInput extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      model: {
        value: this.props.value || ""
      },
      edit: !this.props.clickToEdit,
      readonly: this.props.readonly || false,
      validationError: "",
      generation: 0,
      location: AddressHelper.toLocation(this.props.value),
      inputValue: false
    };
    this._locationPickerModalRef = React.createRef();
  }
  get locationPickerModal() {
    return this._locationPickerModalRef.current;
  }
  get locationPickerIsOpen() {
    return !!this.locationPickerModal && this.locationPickerModal.isOpen;
  }
  openLocationPickerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.locationPickerModal) {
        yield this.locationPickerModal.openAsync();
        yield this.reRenderAsync();
      }
    });
  }
  onInputKeyDownHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e.key === "Enter") {
        e.preventDefault();
      } else if (e.key === "Escape") {
        yield this.setEditAsync(false);
      }
    });
  }
  invokeOnChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.location) {
        yield this.setEditAsync(false);
        if (this.props.onChange) {
          yield this.props.onChange(this.state.location);
        }
      }
    });
  }
  onPlaceSelectedAsync(place) {
    return __awaiter(this, void 0, void 0, function* () {
      if (place.formatted_address !== AddressHelper.removeLatLon(this.value)) {
        const geoLocation = AddressHelper.getLocationFromGeocodeResult(place);
        this.state.location = geoLocation;
        this.state.inputValue = true;
        yield this.updateValueAsync(geoLocation.formattedAddress);
        yield this.invokeOnChangeAsync();
        if (this.props.clickToEdit) {
          yield this.setState({
            edit: false
          });
        }
      }
    });
  }
  onLocationCloseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.reRenderAsync();
    });
  }
  onLocationSetAsync(location) {
    return __awaiter(this, void 0, void 0, function* () {
      const isEqual = Comparator.isEqual(this.state.location, location);
      if (!isEqual) {
        this.state.location = location;
        this.state.inputValue = false;
        this.onValuePropsChanged();
        yield this.updateValueAsync(location.formattedAddress);
        yield this.invokeOnChangeAsync();
      }
    });
  }
  get locationPickerId() {
    return `locationPicker_${this.id}`;
  }
  get defaultValue() {
    return this.state.inputValue ? null : this.getFormattedStr();
  }
  getType() {
    return BaseInputType.Text;
  }
  onValuePropsChanged() {
    const state = this.state;
    state.generation = state.generation + 1;
  }
  getFormattedStr() {
    return AddressHelper.removeLatLon(this.value);
  }
  getCustomRequiredValidationError() {
    return AddressInputLocalizer$1.validatorsCustomRequired;
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.clickToEdit) {
        const targetNode = e.target;
        let outside = Utility.clickedOutside(targetNode, this.id);
        if (this.props.locationPicker) {
          outside = outside && Utility.clickedOutside(targetNode, this.locationPickerId);
        }
        outside = outside && !this.JQuery(targetNode).parents(".pac-container").length;
        if (outside) {
          yield this.hideEditAsync();
        }
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const nextLocation = AddressHelper.toLocation(nextProps.value);
      const newLocation = !Comparator.isEqual(this.state.location, nextLocation);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newLocation || nextLocation) {
        this.state.inputValue = false;
        this.onValuePropsChanged();
        yield this.setState({
          location: nextLocation
        });
      }
    });
  }
  get countries() {
    return this.props.country != null ? typeof this.props.country === "string" ? this.props.country ? [this.props.country] : null : this.props.country.length > 0 ? this.props.country : null : [ch.country];
  }
  get options() {
    const options = {
      types: ["address"],
      fields: ["address_components", "formatted_address", "geometry"]
    };
    const countries = this.countries;
    if (countries) {
      options.componentRestrictions = {
        country: countries
      };
    }
    return options;
  }
  renderLocationPicker() {
    if (this.props.locationPicker) {
      return React.createElement(LocationPickerModal, {
        ref: this._locationPickerModalRef,
        infoWindow: true,
        id: this.locationPickerId,
        location: this.state.location || undefined,
        required: this.props.required,
        readonly: this.readonly,
        onClose: () => this.onLocationCloseAsync(),
        onSubmit: (sender, location) => this.onLocationSetAsync(location)
      });
    }
    return null;
  }
  renderAppend() {
    if (this.props.locationPicker && this.state.edit) {
      return React.createElement("div", {
        className: "input-group-append cursor-pointer",
        onClick: () => this.openLocationPickerAsync()
      }, React.createElement("span", {
        className: this.css("input-group-text", styles$Z.append, this.state.validationError && styles$Z.validationError)
      }, React.createElement(Icon, {
        name: "fas map-marker-alt"
      })));
    }
    if (this.state.edit) {
      return super.renderAppend();
    }
    return;
  }
  renderInput() {
    const smallStyle = this.props.small && styles$H.small;
    return React.createElement(React.Fragment, null, React.createElement(ReactGoogleAutocomplete, {
      key: `${this.getInputId()}_${this.state.generation}`,
      id: this.getInputId(),
      className: this.css(styles$H.textInput, "form-control", smallStyle),
      options: this.options,
      defaultValue: this.defaultValue || undefined,
      disabled: this.locationPickerIsOpen,
      readOnly: this.readonly,
      autoComplete: "off",
      role: "presentation",
      onKeyDown: e => this.onInputKeyDownHandlerAsync(e),
      onPlaceSelected: place => this.onPlaceSelectedAsync(place)
    }), this.renderLocationPicker());
  }
}

var css_248z$N = ".athenaeum-auto-suggest-autoSuggest {\n  display: none;\n  margin: 2px 0;\n  padding: 3px 0;\n  background-color: #fe5000;\n  border-radius: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  position: absolute;\n  right: 0;\n  z-index: 150;\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container {\n  color: white;\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container .athenaeum-auto-suggest-group {\n  cursor: default;\n  color: #e3e3e3 !important;\n  background-color: inherit !important;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding: 0 12px;\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container .athenaeum-auto-suggest-groupItem {\n  cursor: pointer;\n  padding-left: 20px;\n  text-transform: uppercase;\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container .athenaeum-auto-suggest-groupItem:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container .athenaeum-auto-suggest-groupSeparator {\n  margin: 6px 2px;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.athenaeum-auto-suggest-autoSuggest.athenaeum-auto-suggest-open {\n  display: block;\n}";
var styles$G = {"autoSuggest":"athenaeum-auto-suggest-autoSuggest","container":"athenaeum-auto-suggest-container","group":"athenaeum-auto-suggest-group","groupItem":"athenaeum-auto-suggest-groupItem","groupSeparator":"athenaeum-auto-suggest-groupSeparator","open":"athenaeum-auto-suggest-open"};
styleInject(css_248z$N);

class AutoSuggestItem {
  constructor(value = null, group = null) {
    this.value = value || "";
    this.group = group || "";
    this.isAutoSuggestItem = true;
  }
}
class AutoSuggestItemGroup {
  constructor(name) {
    this.name = name;
    this.items = [];
  }
}
class AutoSuggest extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: this.props.isOpen || false
    };
  }
  get items() {
    const items = this.props.items;
    if (items.length == 0) {
      return [];
    }
    if (items[0] instanceof AutoSuggestItem) {
      return items;
    }
    return items.map(item => new AutoSuggestItem(item));
  }
  get toggleButtonId() {
    return this.props.toggleButtonId;
  }
  onSelectAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.props.onSelect(this, item.value);
        yield this.closeAsync();
      }
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        if (this.state.isOpen) {
          yield this.setState({
            isOpen: false
          });
        }
      }
    });
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.isOpen) {
        yield this.setState({
          isOpen: true
        });
      }
    });
  }
  groupBy(data) {
    const dictionary = new Dictionary();
    data.forEach(item => {
      let group = dictionary.getValue(item.group);
      if (!group) {
        group = new AutoSuggestItemGroup(item.group);
        dictionary.setValue(item.group, group);
      }
      group.items.push(item);
    });
    return dictionary.values();
  }
  get isOpen() {
    return this.state.isOpen;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpen) {
        yield this.closeAsync();
      } else {
        yield this.openAsync();
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const targetNode = e.target;
      const outside = Utility.clickedOutside(targetNode, this.id, this.toggleButtonId);
      if (outside) {
        yield this.closeAsync();
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e.keyCode === 27) {
        yield this.closeAsync();
      }
    });
  }
  render() {
    const groups = this.groupBy(this.items);
    return React.createElement("div", {
      id: this.id,
      className: this.css(this.props.className, styles$G.autoSuggest, this.isOpen && styles$G.open)
    }, this.items.length > 0 && groups.map((group, index) => React.createElement("div", {
      key: index,
      className: styles$G.container
    }, group.name && React.createElement("span", {
      className: styles$G.group
    }, group.name), group.items.map((item, index) => React.createElement("div", {
      key: index,
      className: styles$G.groupItem,
      onClick: () => this.onSelectAsync(item)
    }, item.value)), groups.length > 1 && index !== groups.length - 1 && React.createElement("hr", {
      className: styles$G.groupSeparator
    }))));
  }
}

//Autogenerated
class TextInputLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var TextInputLocalizer$1 = new TextInputLocalizer();

class TextInput extends BaseInput {
  constructor() {
    super(...arguments);
    this._autoSuggestRef = React.createRef();
    this._keyDownKey = null;
  }
  invokeOnChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, this.value, true, false);
      }
    });
  }
  onChangeAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.valueChangeHandlerAsync(event);
      yield this.invokeOnChangeAsync();
    });
  }
  onKeyDownAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        this._keyDownKey = e.key;
        const enter = e.key === "Enter";
        const esc = e.key === "Escape";
        if (this.props.clickToEdit) {
          if (enter || esc) {
            e.preventDefault();
            yield this.hideEditAsync();
          }
        } else if (enter && this.props.onChange) {
          yield this.props.onChange(this, this.value, true, true);
        }
      } finally {
        this._keyDownKey = null;
      }
    });
  }
  toggleAutoSuggest() {
    return __awaiter(this, void 0, void 0, function* () {
      const autoSuggest = this._autoSuggestRef.current;
      if (autoSuggest) {
        yield autoSuggest.toggleAsync();
      }
    });
  }
  setValueFromAutoSuggest(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value != this.str) {
        yield this.updateValueAsync(value);
        this.focus();
        yield this.invokeOnChangeAsync();
      }
    });
  }
  clearAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.str) {
        yield this.updateValueAsync("");
        this.focus();
        yield this.invokeOnChangeAsync();
      }
    });
  }
  get autoSuggestItems() {
    var _a;
    return (_a = this.props.autoSuggestItems) !== null && _a !== void 0 ? _a : [];
  }
  get toggleButtonId() {
    return `auto-suggest-toggler-${this.id}`;
  }
  getType() {
    return BaseInputType.Text;
  }
  getContainerClassName() {
    return styles$H.textInputContainer;
  }
  onShowEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onEdit) {
        yield this.props.onEdit(this, true);
      }
    });
  }
  onHideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onEdit) {
        yield this.props.onEdit(this, false);
      }
      if (this.props.onChange) {
        const enter = this._keyDownKey === "Enter";
        const done = enter || !this.cancelOnHide;
        yield this.props.onChange(this, this.value, true, done);
      }
    });
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      valueBlurHandlerAsync: {
        get: () => super.valueBlurHandlerAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.valueBlurHandlerAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  valueFocusHandler() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onFocus) {
        yield this.props.onFocus(this);
      }
    });
  }
  clickHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClick) {
        yield this.props.onClick(this);
      }
    });
  }
  getValidators() {
    return [];
  }
  focus(select = false) {
    const inputElement = this.inputElement;
    if (inputElement) {
      inputElement.focus();
      if (select) {
        inputElement.select();
      }
    }
  }
  get value() {
    const value = this.state.model.value || "";
    return this.props.trim ? value.trim() : value;
  }
  get str() {
    return this.state.model.value || "";
  }
  get noAutoComplete() {
    return this.props.noAutoComplete == true || this.props.autoComplete === false;
  }
  get clearButton() {
    return this.props.clearButton === true;
  }
  get cancelOnHide() {
    return this.props.cancelOnHide === true;
  }
  renderInput() {
    const value = this.str;
    const autoSuggestItems = this.autoSuggestItems;
    const hasAutoSuggestItems = autoSuggestItems.length > 0;
    const noAutoComplete = this.noAutoComplete;
    const clearButton = this.clearButton && !!value;
    const smallStyle = this.props.small && styles$H.small;
    const autoSuggestStyle = hasAutoSuggestItems && styles$H.autoSuggest;
    const clearButtonStyle = clearButton && styles$H.clearButton;
    const clearButtonWitchAutoSuggestStyle = clearButton && hasAutoSuggestItems && styles$H.autoSuggest;
    const inlineStyles = {};
    if (this.props.width) {
      inlineStyles.width = this.props.width;
    }
    return React.createElement(React.Fragment, null, React.createElement("input", {
      id: this.getInputId(),
      type: this.getType(),
      className: this.css(styles$H.textInput, "form-control", smallStyle, autoSuggestStyle, clearButtonStyle),
      style: inlineStyles,
      title: TextInputLocalizer$1.get(this.props.title),
      placeholder: TextInputLocalizer$1.get(this.props.placeholder),
      value: value,
      readOnly: this.readonly,
      size: this.props.size || 10,
      minLength: this.props.minLength || 0,
      maxLength: this.props.maxLength || 255,
      autoFocus: this.props.autoFocus,
      autoComplete: noAutoComplete ? "off" : "on",
      role: noAutoComplete ? "presentation" : "",
      onChange: e => this.onChangeAsync(e),
      onBlur: () => this.valueBlurHandlerAsync(),
      onClick: () => this.clickHandlerAsync(),
      onFocus: () => this.valueFocusHandler(),
      onKeyDown: e => this.onKeyDownAsync(e)
    }), clearButton && React.createElement("div", {
      className: this.css(styles$H.clearButtonIcon, clearButtonWitchAutoSuggestStyle)
    }, React.createElement(Icon, {
      stopPropagation: true,
      name: "fa fa-times",
      size: IconSize.Normal,
      onClick: () => this.clearAsync()
    })), hasAutoSuggestItems && React.createElement(React.Fragment, null, React.createElement("div", {
      className: this.css(styles$H.autoSuggestIcon)
    }, React.createElement(Icon, {
      id: this.toggleButtonId,
      stopPropagation: true,
      name: "fa fa-caret-down",
      size: IconSize.Normal,
      onClick: () => this.toggleAutoSuggest()
    })), React.createElement(AutoSuggest, {
      ref: this._autoSuggestRef,
      items: autoSuggestItems,
      toggleButtonId: this.toggleButtonId,
      onSelect: (_, value) => this.setValueFromAutoSuggest(value)
    })));
  }
}

var css_248z$M = ".athenaeum-number-input-numberInput {\n  position: relative;\n}\n.athenaeum-number-input-numberInput input[type=number]::-webkit-inner-spin-button, .athenaeum-number-input-numberInput input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.athenaeum-number-input-numberInput .athenaeum-number-input-numberInputArrow {\n  position: absolute;\n  width: 20px;\n  border-left: 1px solid #d4d4d4;\n  border-right: 1px solid transparent;\n  color: #d4d4d4;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-number-input-numberInput .athenaeum-number-input-increaseArrow {\n  right: 0;\n  top: 0;\n  bottom: unset;\n  height: 50%;\n}\n.athenaeum-number-input-numberInput .athenaeum-number-input-decreaseArrow {\n  top: unset;\n  right: 0;\n  bottom: 0;\n  height: 50%;\n}";
var styles$F = {"numberInput":"athenaeum-number-input-numberInput","numberInputArrow":"athenaeum-number-input-numberInputArrow","increaseArrow":"athenaeum-number-input-increaseArrow","decreaseArrow":"athenaeum-number-input-decreaseArrow"};
styleInject(css_248z$M);

var NumberInputBehaviour;
(function (NumberInputBehaviour) {
  /*
  * Validate on input change,
  */
  NumberInputBehaviour[NumberInputBehaviour["ValidationOnChange"] = 0] = "ValidationOnChange";
  NumberInputBehaviour[NumberInputBehaviour["ValidationOnSave"] = 1] = "ValidationOnSave";
  NumberInputBehaviour[NumberInputBehaviour["Restricted"] = 2] = "Restricted";
})(NumberInputBehaviour || (NumberInputBehaviour = {}));
class NumberInput extends BaseInput {
  constructor() {
    super(...arguments);
    this._ref = null;
    this._acceptableStr = null;
    this._focused = false;
    this._empty = false;
  }
  onChangeAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const str = e.currentTarget.value;
      const caretPosition = e.currentTarget.selectionEnd !== null ? e.currentTarget.selectionEnd : -1;
      const parsingResult = NumberUtility.parse(str, this.allowFloat);
      const acceptableStr = parsingResult.acceptableStr !== null ? parsingResult.acceptableStr : this._acceptableStr;
      const needToRender = acceptableStr !== this._acceptableStr;
      const isNewStr = parsingResult.parsed && acceptableStr !== this.getStr();
      const empty = !acceptableStr;
      const setOrClearValue = this._empty != empty;
      this._acceptableStr = acceptableStr;
      this._empty = empty;
      if (this.behaviour === NumberInputBehaviour.ValidationOnChange) {
        yield this.saveChangesAsync(false, setOrClearValue);
      } else if (needToRender) {
        yield this.reRenderAsync();
      }
      if (this.ref.current) {
        const newStr = this.getStr();
        let index;
        if (isNewStr) {
          const prefix = str.substr(0, caretPosition);
          index = newStr.indexOf(prefix);
          if (index !== -1) {
            index += caretPosition;
          } else {
            index = caretPosition;
          }
        } else {
          const isReplace = parsingResult.parsed && str !== acceptableStr;
          index = isReplace ? caretPosition : caretPosition - 1;
        }
        if (index !== -1) {
          this.ref.current.selectionStart = index;
          this.ref.current.selectionEnd = index;
        }
      }
    });
  }
  onKeyDownAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const enter = e.keyCode === 13;
      const esc = e.keyCode === 27;
      if (this.props.clickToEdit) {
        if (enter || esc) {
          e.preventDefault();
          yield this.hideEditAsync();
        }
      } else {
        if (enter) {
          yield this.saveChangesAsync();
        }
      }
    });
  }
  invokeOnChange(value, userInteraction, done) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, value, userInteraction, done);
      }
    });
  }
  saveChangesAsync(clearAcceptableStr = true, forced = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._acceptableStr !== null) {
        const parsingResult = NumberUtility.parse(this._acceptableStr, this.allowFloat);
        if (clearAcceptableStr) {
          this._acceptableStr = null;
        }
        let updated = false;
        if (parsingResult.parsed) {
          updated = yield this.invokeSetAsync(parsingResult.value, true, forced);
        }
        if (!updated) {
          yield this.reRenderAsync();
        }
      }
    });
  }
  invokeSetAsync(value, userInteraction, forced = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly) {
        value = Utility.roundE(value);
        const acceptInvalidNumbers = this.behaviour !== NumberInputBehaviour.Restricted && userInteraction;
        if ((forced || value !== this.value) && (acceptInvalidNumbers || this.canSet(value))) {
          yield this.invokeOnChange(value, userInteraction, true);
          yield this.updateValueAsync(value);
          return true;
        }
      }
      return false;
    });
  }
  invokeIncreaseAsync(userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSetAsync(this.value + this.step, userInteraction);
    });
  }
  invokeDecreaseAsync(userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSetAsync(this.value - this.step, userInteraction);
    });
  }
  getStr() {
    const hideZero = this.hideZero && !this.focused && this.value == 0 || this.focused && this._empty;
    return hideZero ? "" : this._acceptableStr !== null ? this._acceptableStr : this.str;
  }
  get ref() {
    return this._ref || (this._ref = this.props.forwardedRef || React.createRef());
  }
  get format() {
    const numberFormat = NumberUtility.resolveFormat(this.props.step, this.props.format);
    return numberFormat.format;
  }
  valueFocusHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const str = this.getStr();
      this._focused = true;
      this._empty = !str;
      if (this.props.onFocus) {
        yield this.props.onFocus(this);
      }
    });
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      valueBlurHandlerAsync: {
        get: () => super.valueBlurHandlerAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._focused = false;
      yield this.saveChangesAsync();
      yield _super.valueBlurHandlerAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  onShowEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      if (this.ref.current) {
        this.ref.current.focus();
        this.ref.current.select();
      }
    });
  }
  onHideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.saveChangesAsync();
    });
  }
  parse(str) {
    return str ? Math.abs(Number(str)) : 0;
  }
  getValidators() {
    return this.behaviour !== NumberInputBehaviour.Restricted ? [NumberRangeValidator.validator(this.min, this.max)] : [];
  }
  get behaviour() {
    var _a;
    return this.props.clickToEdit ? NumberInputBehaviour.Restricted : (_a = this.props.behaviour) !== null && _a !== void 0 ? _a : NumberInputBehaviour.ValidationOnChange;
  }
  get focused() {
    return this._focused;
  }
  get value() {
    return this.state.model.value;
  }
  get min() {
    return this.props.min || 0;
  }
  get max() {
    return this.props.max || Number.POSITIVE_INFINITY;
  }
  get step() {
    const numberFormat = NumberUtility.resolveFormat(this.props.step, this.props.format);
    return numberFormat.step;
  }
  get canDecrease() {
    return this.canSet(this.value - this.step);
  }
  get canIncrease() {
    return this.canSet(this.value + this.step);
  }
  get increaseIconProps() {
    const increaseIconProp = this.props.increaseIcon || "arrow-up";
    if (typeof increaseIconProp === "string") {
      return {
        name: increaseIconProp,
        size: IconSize.ExtraSmall
      };
    }
    return increaseIconProp;
  }
  get decreaseIconProps() {
    const decreaseIconProp = this.props.decreaseIcon || "arrow-down";
    if (typeof decreaseIconProp === "string") {
      return {
        name: decreaseIconProp,
        size: IconSize.ExtraSmall
      };
    }
    return decreaseIconProp;
  }
  get hideZero() {
    return this.props.hideZero === true;
  }
  get allowFloat() {
    return this.step < 1.0;
  }
  get noAutoComplete() {
    return this.props.noAutoComplete == true;
  }
  get empty() {
    const str = this.getStr();
    return !str;
  }
  canSet(value) {
    value = Utility.roundE(value);
    return this.min <= value && value <= this.max;
  }
  setAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSetAsync(value, false);
    });
  }
  increaseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeIncreaseAsync(false);
    });
  }
  decreaseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeDecreaseAsync(false);
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      yield _super.initializeAsync.call(this);
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      const newHideZero = this.props.hideZero !== nextProps.hideZero;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newHideZero) {
        yield this.reRenderAsync();
      }
    });
  }
  renderInput() {
    const noAutoComplete = this.noAutoComplete;
    return React.createElement("div", {
      className: styles$F.numberInput
    }, React.createElement("input", {
      id: this.getInputId(),
      ref: this.ref,
      type: this.getType(),
      value: this.getStr(),
      readOnly: this.readonly,
      className: "form-control",
      title: this.props.title,
      placeholder: this.props.placeholder,
      autoComplete: noAutoComplete ? "off" : "on",
      role: noAutoComplete ? "presentation" : "",
      autoFocus: this.props.autoFocus,
      onChange: e => this.onChangeAsync(e),
      onFocus: () => this.valueFocusHandlerAsync(),
      onBlur: () => this.valueBlurHandlerAsync(),
      onKeyDown: e => this.onKeyDownAsync(e)
    }), !this.props.hideArrows && React.createElement("div", {
      className: this.css(styles$F.numberInputArrow, styles$F.increaseArrow),
      onClick: () => this.invokeIncreaseAsync(true)
    }, React.createElement(Icon, Object.assign({}, this.increaseIconProps))), !this.props.hideArrows && React.createElement("div", {
      className: this.css(styles$F.numberInputArrow, styles$F.decreaseArrow),
      onClick: () => this.invokeDecreaseAsync(true)
    }, React.createElement(Icon, Object.assign({}, this.decreaseIconProps))));
  }
}

//Autogenerated
class DateInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.timeLanguageItemName = `_3A:0`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_3A:0`, {
      l: `en`,
      v: `Time`
    }, {
      l: `uk`,
      v: `Час`
    }, {
      l: `sv`,
      v: `Tid`
    }, {
      l: `ru`,
      v: `Время`
    }, {
      l: `pl`,
      v: `Czas`
    }, {
      l: `nl`,
      v: `Tijd`
    }, {
      l: `nb`,
      v: `Tid`
    }, {
      l: `it`,
      v: `Tempo`
    }, {
      l: `fr`,
      v: `Temps`
    }, {
      l: `fi`,
      v: `Aika`
    }, {
      l: `es`,
      v: `Tiempo`
    }, {
      l: `de`,
      v: `Zeit`
    }, {
      l: `da`,
      v: `Tid`
    });
  }
  /**
  /* "Time" (Time)
  /* "Localizer.time"
  /* "Localizer.timeLanguageItemName"
  */
  get time() {
    return this.get(`_3A:0`);
  }
}
//Singleton
var DateInputLocalizer$1 = new DateInputLocalizer();

var css_248z$L = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-date-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-date-input-dateInput {\n  position: relative;\n}\n.athenaeum-date-input-dateInput .react-datepicker-popper {\n  z-index: 10;\n}\n.athenaeum-date-input-dateInput .react-datepicker-popper .react-datepicker__triangle {\n  z-index: 10;\n}\n.athenaeum-date-input-dateInput input:read-only {\n  background-color: white;\n}\n.athenaeum-date-input-dateInput.athenaeum-date-input-clearButton input {\n  padding-right: 1.5rem;\n}\n.athenaeum-date-input-dateInput.athenaeum-date-input-readonly input:read-only {\n  background-color: #e9ecef;\n}\n.athenaeum-date-input-dateInput.athenaeum-date-input-small input {\n  font-size: 0.8rem;\n  padding: 0.375rem;\n  height: auto;\n  width: 5rem;\n  background-color: white !important;\n}\n\n.athenaeum-date-input-clearButtonIcon {\n  position: absolute;\n  top: 5px;\n  bottom: 4px;\n  right: 5px;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-date-input-clearButtonIcon:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-date-input-clearButtonIcon > i {\n  padding: 4px;\n  cursor: pointer;\n}\n.athenaeum-date-input-clearButtonIcon.athenaeum-date-input-autoSuggest {\n  right: 20px;\n}";
var styles$E = {"font-renta":"athenaeum-date-input-font-renta","dateInput":"athenaeum-date-input-dateInput","clearButton":"athenaeum-date-input-clearButton","readonly":"athenaeum-date-input-readonly","small":"athenaeum-date-input-small","clearButtonIcon":"athenaeum-date-input-clearButtonIcon","autoSuggest":"athenaeum-date-input-autoSuggest"};
styleInject(css_248z$L);

class LocaleLib {
  static buildFormatLongFn(args) {
    return function () {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // TODO: Remove String()
      let width = options.width ? String(options.width) : args.defaultWidth;
      return args.formats[width] || args.formats[args.defaultWidth];
    };
  }
  static buildLocalizeFn(args) {
    return function (dirtyIndex, options) {
      let context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
      let valuesArray;
      if (context === 'formatting' && args.formattingValues) {
        let defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
        let width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
        valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
      } else {
        let _defaultWidth = args.defaultWidth;
        let _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
        valuesArray = args.values[_width] || args.values[_defaultWidth];
      }
      let index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
      return valuesArray[index];
    };
  }
  static buildMatchFn(args) {
    return function (string) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let width = options.width;
      let matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
      let matchResult = string.match(matchPattern);
      if (!matchResult) {
        return null;
      }
      let matchedString = matchResult[0];
      let parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
      let key = Array.isArray(parsePatterns) ? LocaleLib.findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      }) : LocaleLib.findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
      let value;
      value = args.valueCallback ? args.valueCallback(key) : key;
      value = options.valueCallback ? options.valueCallback(value) : value;
      let rest = string.slice(matchedString.length);
      return {
        value: value,
        rest: rest
      };
    };
  }
  static findKey(object, predicate) {
    for (let key in object) {
      if (object.hasOwnProperty(key) && predicate(object[key])) {
        return key;
      }
    }
    return undefined;
  }
  static findIndex(array, predicate) {
    for (let key = 0; key < array.length; key++) {
      if (predicate(array[key])) {
        return key;
      }
    }
    return undefined;
  }
  static buildMatchPatternFn(args) {
    return function (string) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var matchResult = string.match(args.matchPattern);
      if (!matchResult) return null;
      var matchedString = matchResult[0];
      var parseResult = string.match(args.parsePattern);
      if (!parseResult) return null;
      var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
      value = options.valueCallback ? options.valueCallback(value) : value;
      var rest = string.slice(matchedString.length);
      return {
        value: value,
        rest: rest
      };
    };
  }
}

class FiLib {
  static futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
  }
  static futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
  }
  static futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
  }
  static futureDays(text) {
    return text.replace(/päivää?/, 'päivän');
  }
  static futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
  }
  static futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
  }
  static futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
  }
  static formatDistance(token, count, options) {
    let tokenValue = FiLib.formatDistanceLocale[token];
    let result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return tokenValue.futureTense(result) + ' kuluttua';
      } else {
        return result + ' sitten';
      }
    }
    return result;
  }
  static formatRelative(token, _date, _baseDate, _options) {
    return FiLib.formatRelativeLocale[token];
  }
  static ordinalNumber(dirtyNumber, _options) {
    let number = Number(dirtyNumber);
    return number + '.';
  }
}
FiLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'alle sekunti',
    other: 'alle {{count}} sekuntia',
    futureTense: FiLib.futureSeconds
  },
  xSeconds: {
    one: 'sekunti',
    other: '{{count}} sekuntia',
    futureTense: FiLib.futureSeconds
  },
  halfAMinute: {
    one: 'puoli minuuttia',
    other: 'puoli minuuttia',
    futureTense: function futureTense(_text) {
      return 'puolen minuutin';
    }
  },
  lessThanXMinutes: {
    one: 'alle minuutti',
    other: 'alle {{count}} minuuttia',
    futureTense: FiLib.futureMinutes
  },
  xMinutes: {
    one: 'minuutti',
    other: '{{count}} minuuttia',
    futureTense: FiLib.futureMinutes
  },
  aboutXHours: {
    one: 'noin tunti',
    other: 'noin {{count}} tuntia',
    futureTense: FiLib.futureHours
  },
  xHours: {
    one: 'tunti',
    other: '{{count}} tuntia',
    futureTense: FiLib.futureHours
  },
  xDays: {
    one: 'päivä',
    other: '{{count}} päivää',
    futureTense: FiLib.futureDays
  },
  aboutXWeeks: {
    one: 'noin viikko',
    other: 'noin {{count}} viikkoa',
    futureTense: FiLib.futureWeeks
  },
  xWeeks: {
    one: 'viikko',
    other: '{{count}} viikkoa',
    futureTense: FiLib.futureWeeks
  },
  aboutXMonths: {
    one: 'noin kuukausi',
    other: 'noin {{count}} kuukautta',
    futureTense: FiLib.futureMonths
  },
  xMonths: {
    one: 'kuukausi',
    other: '{{count}} kuukautta',
    futureTense: FiLib.futureMonths
  },
  aboutXYears: {
    one: 'noin vuosi',
    other: 'noin {{count}} vuotta',
    futureTense: FiLib.futureYears
  },
  xYears: {
    one: 'vuosi',
    other: '{{count}} vuotta',
    futureTense: FiLib.futureYears
  },
  overXYears: {
    one: 'yli vuosi',
    other: 'yli {{count}} vuotta',
    futureTense: FiLib.futureYears
  },
  almostXYears: {
    one: 'lähes vuosi',
    other: 'lähes {{count}} vuotta',
    futureTense: FiLib.futureYears
  }
};
FiLib.dateFormats = {
  full: 'eeee d. MMMM y',
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'd.M.y'
};
FiLib.timeFormats = {
  full: 'HH.mm.ss zzzz',
  long: 'HH.mm.ss z',
  medium: 'HH.mm.ss',
  short: 'HH.mm'
};
FiLib.dateTimeFormats = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{' + 'date}} {{time}}'
};
FiLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: FiLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: FiLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: FiLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
FiLib.formatRelativeLocale = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: 'P'
};
FiLib.eraValues = {
  narrow: ['eaa.', 'jaa.'],
  abbreviated: ['eaa.', 'jaa.'],
  wide: ['ennen ajanlaskun alkua', 'jälkeen ajanlaskun alun']
};
FiLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. klettaali', '2. klettaali', '3. klettaali', '4. klettaali']
};
FiLib.monthValues = {
  narrow: ['T', 'H', 'M', 'H', 'T', 'K', 'H', 'E', 'S', 'L', 'M', 'J'],
  abbreviated: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
  wide: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu']
};
FiLib.formattingMonthValues = {
  narrow: FiLib.monthValues.narrow,
  abbreviated: FiLib.monthValues.abbreviated,
  wide: ['tammikuuta', 'helmikuuta', 'maaliskuuta', 'huhtikuuta', 'toukokuuta', 'kesäkuuta', 'heinäkuuta', 'elokuuta', 'syyskuuta', 'lokakuuta', 'marraskuuta', 'joulukuuta']
};
FiLib.dayValues = {
  narrow: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
  short: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
  abbreviated: ['sunn.', 'maan.', 'tiis.', 'kesk.', 'torst.', 'perj.', 'la'],
  wide: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai']
};
FiLib.formattingDayValues = {
  narrow: FiLib.dayValues.narrow,
  short: FiLib.dayValues.short,
  abbreviated: FiLib.dayValues.abbreviated,
  wide: ['sunnuntaina', 'maanantaina', 'tiistaina', 'keskiviikkona', 'torstaina', 'perjantaina', 'lauantaina']
};
FiLib.dayPeriodValues = {
  narrow: {
    am: 'ap',
    pm: 'ip',
    midnight: 'keskiyö',
    noon: 'keskipäivä',
    morning: 'ap',
    afternoon: 'ip',
    evening: 'illalla',
    night: 'yöllä'
  },
  abbreviated: {
    am: 'ap',
    pm: 'ip',
    midnight: 'keskiyö',
    noon: 'keskipäivä',
    morning: 'ap',
    afternoon: 'ip',
    evening: 'illalla',
    night: 'yöllä'
  },
  wide: {
    am: 'ap',
    pm: 'ip',
    midnight: 'keskiyöllä',
    noon: 'keskipäivällä',
    morning: 'aamupäivällä',
    afternoon: 'iltapäivällä',
    evening: 'illalla',
    night: 'yöllä'
  }
};
FiLib.localize = {
  ordinalNumber: FiLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: FiLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: FiLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: FiLib.monthValues,
    defaultWidth: 'wide',
    formattingValues: FiLib.formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: FiLib.dayValues,
    defaultWidth: 'wide',
    formattingValues: FiLib.formattingDayValues,
    defaultFormattingWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: FiLib.dayPeriodValues,
    defaultWidth: 'wide'
  })
};
FiLib.matchOrdinalNumberPattern = /^(\d+)(\.)/i;
FiLib.parseOrdinalNumberPattern = /\d+/i;
FiLib.matchEraPatterns = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
FiLib.parseEraPatterns = {
  any: [/^e/i, /^j/i]
};
FiLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? klettaali/i
};
FiLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
FiLib.matchMonthPatterns = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
FiLib.parseMonthPatterns = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
};
FiLib.matchDayPatterns = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
FiLib.parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
};
FiLib.matchDayPeriodPatterns = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
FiLib.parseDayPeriodPatterns = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
};
FiLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: FiLib.matchOrdinalNumberPattern,
    parsePattern: FiLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: FiLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FiLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: FiLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FiLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: FiLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FiLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: FiLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FiLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: FiLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: FiLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */
const fiLocale = {
  code: 'fi',
  formatDistance: FiLib.formatDistance,
  formatLong: FiLib.formatLong,
  formatRelative: FiLib.formatRelative,
  localize: FiLib.localize,
  match: FiLib.match,
  options: {
    weekStartsOn: 1
    /* Monday */,

    firstWeekContainsDate: 4
  }
};

class DateFnsLib {
  static requiredArgs(required, args) {
    if (args.length < required) {
      throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
    }
  }
  static _typeof(obj) {
    //"@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      DateFnsLib._typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      DateFnsLib._typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return DateFnsLib._typeof(obj);
  }
  static toDate(argument) {
    DateFnsLib.requiredArgs(1, arguments);
    let argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || DateFnsLib._typeof(argument) === 'object' && argStr === '[object Date]') {
      // Prevent the date to lose the milliseconds when passed to new Date() in IE10
      return new Date(argument.getTime());
    } else if (typeof argument === 'number' || argStr === '[object Number]') {
      return new Date(argument);
    } else {
      if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
        console.warn(new Error().stack);
      }
      return new Date(NaN);
    }
  }
  static getDefaultOptions() {
    return DateFnsLib.defaultOptions;
  }
  static setDefaultOptions(newOptions) {
    DateFnsLib.defaultOptions = newOptions;
  }
  static toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
      return NaN;
    }
    let number = Number(dirtyNumber);
    if (isNaN(number)) {
      return number;
    }
    return number < 0 ? Math.ceil(number) : Math.floor(number);
  }
  static startOfUTCWeek(dirtyDate, options) {
    let _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    DateFnsLib.requiredArgs(1, arguments);
    let defaultOptions = DateFnsLib.getDefaultOptions();
    let weekStartsOn = DateFnsLib.toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    let date = DateFnsLib.toDate(dirtyDate);
    let day = date.getUTCDay();
    let diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }
  static isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
    DateFnsLib.requiredArgs(2, arguments);
    let dateLeftStartOfWeek = DateFnsLib.startOfUTCWeek(dirtyDateLeft, options);
    let dateRightStartOfWeek = DateFnsLib.startOfUTCWeek(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
  }
}
DateFnsLib.defaultOptions = {};

class RuLib {
  static declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) {
      return scheme.one;
    }
    let rem10 = count % 10;
    let rem100 = count % 100; // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) {
      return scheme.singularNominative.replace('{{count}}', String(count)); // 2, 3, 4, 22, 23, 24, 32 ...
    } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
      return scheme.singularGenitive.replace('{{count}}', String(count)); // 5, 6, 7, 8, 9, 10, 11, ...
    } else {
      return scheme.pluralGenitive.replace('{{count}}', String(count));
    }
  }
  static buildLocalizeTokenFn(scheme) {
    return function (count, options) {
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          if (scheme.future) {
            return RuLib.declension(scheme.future, count);
          } else {
            return 'через ' + RuLib.declension(scheme.regular, count);
          }
        } else {
          if (scheme.past) {
            return RuLib.declension(scheme.past, count);
          } else {
            return RuLib.declension(scheme.regular, count) + ' назад';
          }
        }
      } else {
        return RuLib.declension(scheme.regular, count);
      }
    };
  }
  static _lastWeek(day) {
    let weekday = RuLib.accusativeWeekdays[day];
    switch (day) {
      case 0:
        return "'в прошлое " + weekday + " в' p";
      case 1:
      case 2:
      case 4:
        return "'в прошлый " + weekday + " в' p";
      case 3:
      case 5:
      case 6:
        return "'в прошлую " + weekday + " в' p";
    }
    return 0;
  }
  static thisWeek(day) {
    let weekday = RuLib.accusativeWeekdays[day];
    if (day === 2
    /* Tue */) {
      return "'во " + weekday + " в' p";
    } else {
      return "'в " + weekday + " в' p";
    }
  }
  static _nextWeek(day) {
    let weekday = RuLib.accusativeWeekdays[day];
    switch (day) {
      case 0:
        return "'в следующее " + weekday + " в' p";
      case 1:
      case 2:
      case 4:
        return "'в следующий " + weekday + " в' p";
      case 3:
      case 5:
      case 6:
        return "'в следующую " + weekday + " в' p";
    }
    return 0;
  }
  static formatRelative(token, date, baseDate, options) {
    let format = RuLib.formatRelativeLocale[token];
    if (typeof format === 'function') {
      return format(date, baseDate, options);
    }
    return format;
  }
  static ordinalNumber(dirtyNumber, options) {
    let number = Number(dirtyNumber);
    let unit = options === null || options === void 0 ? void 0 : options.unit;
    let suffix;
    if (unit === 'date') {
      suffix = '-е';
    } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
      suffix = '-я';
    } else {
      suffix = '-й';
    }
    return number + suffix;
  }
}
RuLib.formatDistanceLocale = {
  lessThanXSeconds: RuLib.buildLocalizeTokenFn({
    regular: {
      one: 'меньше секунды',
      singularNominative: 'меньше {{count}} секунды',
      singularGenitive: 'меньше {{count}} секунд',
      pluralGenitive: 'меньше {{count}} секунд'
    },
    future: {
      one: 'меньше, чем через секунду',
      singularNominative: 'меньше, чем через {{count}} секунду',
      singularGenitive: 'меньше, чем через {{count}} секунды',
      pluralGenitive: 'меньше, чем через {{count}} секунд'
    }
  }),
  xSeconds: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} секунда',
      singularGenitive: '{{count}} секунды',
      pluralGenitive: '{{count}} секунд'
    },
    past: {
      singularNominative: '{{count}} секунду назад',
      singularGenitive: '{{count}} секунды назад',
      pluralGenitive: '{{count}} секунд назад'
    },
    future: {
      singularNominative: 'через {{count}} секунду',
      singularGenitive: 'через {{count}} секунды',
      pluralGenitive: 'через {{count}} секунд'
    }
  }),
  halfAMinute: function halfAMinute(_count, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'через полминуты';
      } else {
        return 'полминуты назад';
      }
    }
    return 'полминуты';
  },
  lessThanXMinutes: RuLib.buildLocalizeTokenFn({
    regular: {
      one: 'меньше минуты',
      singularNominative: 'меньше {{count}} минуты',
      singularGenitive: 'меньше {{count}} минут',
      pluralGenitive: 'меньше {{count}} минут'
    },
    future: {
      one: 'меньше, чем через минуту',
      singularNominative: 'меньше, чем через {{count}} минуту',
      singularGenitive: 'меньше, чем через {{count}} минуты',
      pluralGenitive: 'меньше, чем через {{count}} минут'
    }
  }),
  xMinutes: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} минута',
      singularGenitive: '{{count}} минуты',
      pluralGenitive: '{{count}} минут'
    },
    past: {
      singularNominative: '{{count}} минуту назад',
      singularGenitive: '{{count}} минуты назад',
      pluralGenitive: '{{count}} минут назад'
    },
    future: {
      singularNominative: 'через {{count}} минуту',
      singularGenitive: 'через {{count}} минуты',
      pluralGenitive: 'через {{count}} минут'
    }
  }),
  aboutXHours: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} часа',
      singularGenitive: 'около {{count}} часов',
      pluralGenitive: 'около {{count}} часов'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} час',
      singularGenitive: 'приблизительно через {{count}} часа',
      pluralGenitive: 'приблизительно через {{count}} часов'
    }
  }),
  xHours: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} час',
      singularGenitive: '{{count}} часа',
      pluralGenitive: '{{count}} часов'
    }
  }),
  xDays: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} день',
      singularGenitive: '{{count}} дня',
      pluralGenitive: '{{count}} дней'
    }
  }),
  aboutXWeeks: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} недели',
      singularGenitive: 'около {{count}} недель',
      pluralGenitive: 'около {{count}} недель'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} неделю',
      singularGenitive: 'приблизительно через {{count}} недели',
      pluralGenitive: 'приблизительно через {{count}} недель'
    }
  }),
  xWeeks: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} неделя',
      singularGenitive: '{{count}} недели',
      pluralGenitive: '{{count}} недель'
    }
  }),
  aboutXMonths: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} месяца',
      singularGenitive: 'около {{count}} месяцев',
      pluralGenitive: 'около {{count}} месяцев'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} месяц',
      singularGenitive: 'приблизительно через {{count}} месяца',
      pluralGenitive: 'приблизительно через {{count}} месяцев'
    }
  }),
  xMonths: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} месяц',
      singularGenitive: '{{count}} месяца',
      pluralGenitive: '{{count}} месяцев'
    }
  }),
  aboutXYears: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: 'около {{count}} года',
      singularGenitive: 'около {{count}} лет',
      pluralGenitive: 'около {{count}} лет'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} год',
      singularGenitive: 'приблизительно через {{count}} года',
      pluralGenitive: 'приблизительно через {{count}} лет'
    }
  }),
  xYears: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} год',
      singularGenitive: '{{count}} года',
      pluralGenitive: '{{count}} лет'
    }
  }),
  overXYears: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: 'больше {{count}} года',
      singularGenitive: 'больше {{count}} лет',
      pluralGenitive: 'больше {{count}} лет'
    },
    future: {
      singularNominative: 'больше, чем через {{count}} год',
      singularGenitive: 'больше, чем через {{count}} года',
      pluralGenitive: 'больше, чем через {{count}} лет'
    }
  }),
  almostXYears: RuLib.buildLocalizeTokenFn({
    regular: {
      singularNominative: 'почти {{count}} год',
      singularGenitive: 'почти {{count}} года',
      pluralGenitive: 'почти {{count}} лет'
    },
    future: {
      singularNominative: 'почти через {{count}} год',
      singularGenitive: 'почти через {{count}} года',
      pluralGenitive: 'почти через {{count}} лет'
    }
  })
};
RuLib.formatDistance = function formatDistance(token, count, options) {
  return RuLib.formatDistanceLocale[token](count, options);
};
RuLib.dateFormats = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: 'dd.MM.y'
};
RuLib.timeFormats = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
RuLib.dateTimeFormats = {
  any: '{{date}}, {{time}}'
};
RuLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: RuLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: RuLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: RuLib.dateTimeFormats,
    defaultWidth: 'any'
  })
};
RuLib.accusativeWeekdays = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];
RuLib.formatRelativeLocale = {
  lastWeek: function lastWeek(date, baseDate, options) {
    let day = date.getUTCDay();
    if (DateFnsLib.isSameUTCWeek(date, baseDate, options)) {
      return RuLib.thisWeek(day);
    } else {
      return RuLib._lastWeek(day);
    }
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function nextWeek(date, baseDate, options) {
    let day = date.getUTCDay();
    if (DateFnsLib.isSameUTCWeek(date, baseDate, options)) {
      return RuLib.thisWeek(day);
    } else {
      return RuLib._nextWeek(day);
    }
  },
  other: 'P'
};
RuLib.eraValues = {
  narrow: ['до н.э.', 'н.э.'],
  abbreviated: ['до н. э.', 'н. э.'],
  wide: ['до нашей эры', 'нашей эры']
};
RuLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
};
RuLib.monthValues = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
};
RuLib.formattingMonthValues = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
};
RuLib.dayValues = {
  narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
  wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
};
RuLib.dayPeriodValues = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утро',
    afternoon: 'день',
    evening: 'вечер',
    night: 'ночь'
  }
};
RuLib.formattingDayPeriodValues = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'вечера',
    night: 'ночи'
  }
};
RuLib.localize = {
  ordinalNumber: RuLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: RuLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: RuLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: RuLib.monthValues,
    defaultWidth: 'wide',
    formattingValues: RuLib.formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: RuLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: RuLib.dayPeriodValues,
    defaultWidth: 'any',
    formattingValues: RuLib.formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
RuLib.matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
RuLib.parseOrdinalNumberPattern = /\d+/i;
RuLib.matchEraPatterns = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
};
RuLib.parseEraPatterns = {
  any: [/^д/i, /^н/i]
};
RuLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
};
RuLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
RuLib.matchMonthPatterns = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
RuLib.parseMonthPatterns = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
};
RuLib.matchDayPatterns = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
RuLib.parseDayPatterns = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
};
RuLib.matchDayPeriodPatterns = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
RuLib.parseDayPeriodPatterns = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
};
RuLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: RuLib.matchOrdinalNumberPattern,
    parsePattern: RuLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: RuLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: RuLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: RuLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: RuLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: RuLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: RuLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: RuLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: RuLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: RuLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: RuLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
const ruLocale = {
  code: 'ru',
  formatDistance: RuLib.formatDistance,
  formatLong: RuLib.formatLong,
  formatRelative: RuLib.formatRelative,
  localize: RuLib.localize,
  match: RuLib.match,
  options: {
    weekStartsOn: 1
    /* Monday */,

    firstWeekContainsDate: 1
  }
};

class DaLib {
  static formatDistance(token, count, options) {
    let result;
    let tokenValue = DaLib.formatDistanceLocale[token];
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', String(count));
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'om ' + result;
      } else {
        return result + ' siden';
      }
    }
    return result;
  }
  static formatRelative(token, _date, _baseDate, _options) {
    return DaLib.formatRelativeLocale[token];
  }
  static ordinalNumber(dirtyNumber, _options) {
    let number = Number(dirtyNumber);
    return number + '.';
  }
}
DaLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'mindre end ét sekund',
    other: 'mindre end {{count}} sekunder'
  },
  xSeconds: {
    one: '1 sekund',
    other: '{{count}} sekunder'
  },
  halfAMinute: 'ét halvt minut',
  lessThanXMinutes: {
    one: 'mindre end ét minut',
    other: 'mindre end {{count}} minutter'
  },
  xMinutes: {
    one: '1 minut',
    other: '{{count}} minutter'
  },
  aboutXHours: {
    one: 'cirka 1 time',
    other: 'cirka {{count}} timer'
  },
  xHours: {
    one: '1 time',
    other: '{{count}} timer'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dage'
  },
  aboutXWeeks: {
    one: 'cirka 1 uge',
    other: 'cirka {{count}} uger'
  },
  xWeeks: {
    one: '1 uge',
    other: '{{count}} uger'
  },
  aboutXMonths: {
    one: 'cirka 1 måned',
    other: 'cirka {{count}} måneder'
  },
  xMonths: {
    one: '1 måned',
    other: '{{count}} måneder'
  },
  aboutXYears: {
    one: 'cirka 1 år',
    other: 'cirka {{count}} år'
  },
  xYears: {
    one: '1 år',
    other: '{{count}} år'
  },
  overXYears: {
    one: 'over 1 år',
    other: 'over {{count}} år'
  },
  almostXYears: {
    one: 'næsten 1 år',
    other: 'næsten {{count}} år'
  }
};
DaLib.dateFormats = {
  full: "EEEE 'den' d. MMMM y",
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'dd/MM/y'
};
DaLib.timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
DaLib.dateTimeFormats = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
DaLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: DaLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: DaLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: DaLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
DaLib.formatRelativeLocale = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: 'P'
};
DaLib.eraValues = {
  narrow: ['fvt', 'vt'],
  abbreviated: ['f.v.t.', 'v.t.'],
  wide: ['før vesterlandsk tidsregning', 'vesterlandsk tidsregning']
};
DaLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1. kvt.', '2. kvt.', '3. kvt.', '4. kvt.'],
  wide: ['1. klettal', '2. klettal', '3. klettal', '4. klettal']
};
DaLib.monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
DaLib.dayValues = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
  abbreviated: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
};
DaLib.dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'morgen',
    afternoon: 'eftermiddag',
    evening: 'aften',
    night: 'nat'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'morgen',
    afternoon: 'eftermiddag',
    evening: 'aften',
    night: 'nat'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'morgen',
    afternoon: 'eftermiddag',
    evening: 'aften',
    night: 'nat'
  }
};
DaLib.formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'om morgenen',
    afternoon: 'om eftermiddagen',
    evening: 'om aftenen',
    night: 'om natten'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'om morgenen',
    afternoon: 'om eftermiddagen',
    evening: 'om aftenen',
    night: 'om natten'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'om morgenen',
    afternoon: 'om eftermiddagen',
    evening: 'om aftenen',
    night: 'om natten'
  }
};
DaLib.localize = {
  ordinalNumber: DaLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: DaLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: DaLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: DaLib.monthValues,
    defaultWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: DaLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: DaLib.dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: DaLib.formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
DaLib.matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
DaLib.parseOrdinalNumberPattern = /\d+/i;
DaLib.matchEraPatterns = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
DaLib.parseEraPatterns = {
  any: [/^f/i, /^(v|e)/i]
};
DaLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? klettal/i
};
DaLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
DaLib.matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
DaLib.parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
DaLib.matchDayPatterns = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
DaLib.parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
DaLib.matchDayPeriodPatterns = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
DaLib.parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
};
DaLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: DaLib.matchOrdinalNumberPattern,
    parsePattern: DaLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchPatternFn({
    matchPatterns: DaLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: DaLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchPatternFn({
    matchPatterns: DaLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: DaLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchPatternFn({
    matchPatterns: DaLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: DaLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchPatternFn({
    matchPatterns: DaLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: DaLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchPatternFn({
    matchPatterns: DaLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: DaLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */
const daLocale = {
  code: 'da',
  formatDistance: DaLib.formatDistance,
  formatLong: DaLib.formatLong,
  formatRelative: DaLib.formatRelative,
  localize: DaLib.localize,
  match: DaLib.match,
  options: {
    weekStartsOn: 1
    /* Monday */,

    firstWeekContainsDate: 4
  }
};

class EnGbLib {}
EnGbLib.dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
EnGbLib.timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
EnGbLib.dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
EnGbLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: EnGbLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: EnGbLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: EnGbLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};

class EnUsLib {
  static formatDistance(token, count, options) {
    let result;
    let tokenValue = EnUsLib.formatDistanceLocale[token];
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', count.toString());
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'in ' + result;
      } else {
        return result + ' ago';
      }
    }
    return result;
  }
  static formatRelative(token, _date, _baseDate, _options) {
    return EnUsLib.formatRelativeLocale[token];
  }
  static ordinalNumber(dirtyNumber, _options) {
    let number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    let rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) {
      switch (rem100 % 10) {
        case 1:
          return number + 'st';
        case 2:
          return number + 'nd';
        case 3:
          return number + 'rd';
      }
    }
    return number + 'th';
  }
}
EnUsLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
EnUsLib.dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
EnUsLib.timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
EnUsLib.dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
EnUsLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: EnUsLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: EnUsLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: EnUsLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
EnUsLib.formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
EnUsLib.eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
EnUsLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
EnUsLib.monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
EnUsLib.dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
EnUsLib.dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
EnUsLib.formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
EnUsLib.localize = {
  ordinalNumber: EnUsLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: EnUsLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: EnUsLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: EnUsLib.monthValues,
    defaultWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: EnUsLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: EnUsLib.dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: EnUsLib.formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
EnUsLib.matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
EnUsLib.parseOrdinalNumberPattern = /\d+/i;
EnUsLib.matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
EnUsLib.parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
EnUsLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
EnUsLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
EnUsLib.matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
EnUsLib.parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
EnUsLib.matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
EnUsLib.parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
EnUsLib.matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
EnUsLib.parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
EnUsLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: EnUsLib.matchOrdinalNumberPattern,
    parsePattern: EnUsLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: EnUsLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: EnUsLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: EnUsLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: EnUsLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: EnUsLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: EnUsLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: EnUsLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: EnUsLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: EnUsLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: EnUsLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */
const enGbLocale = {
  code: 'en-GB',
  formatDistance: EnUsLib.formatDistance,
  formatLong: EnGbLib.formatLong,
  formatRelative: EnUsLib.formatRelative,
  localize: EnUsLib.localize.default,
  match: EnUsLib.match,
  options: {
    weekStartsOn: 1
    /* Monday */,

    firstWeekContainsDate: 4
  }
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
const enUsLocale = {
  code: 'en-US',
  formatDistance: EnUsLib.formatDistance,
  formatLong: EnUsLib.formatLong.default,
  formatRelative: EnUsLib.formatRelative,
  localize: EnUsLib.localize,
  match: EnUsLib.match,
  options: {
    weekStartsOn: 0
    /* Sunday */,

    firstWeekContainsDate: 1
  }
};

class SvLib {
  static formatDistance(token, count, options) {
    let result;
    let tokenValue = SvLib.formatDistanceLocale[token];
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      if (options && options.onlyNumeric) {
        result = tokenValue.other.replace('{{count}}', String(count));
      } else {
        result = tokenValue.other.replace('{{count}}', count < 13 ? SvLib.wordMapping[count] : String(count));
      }
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'om ' + result;
      } else {
        return result + ' sedan';
      }
    }
    return result;
  }
  static formatRelative(token, _date, _baseDate, _options) {
    return SvLib.formatRelativeLocale[token];
  }
  static ordinalNumber(dirtyNumber, _options) {
    let number = Number(dirtyNumber);
    let rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) {
      switch (rem100 % 10) {
        case 1:
        case 2:
          return number + ':a';
      }
    }
    return number + ':e';
  }
}
SvLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'mindre än en sekund',
    other: 'mindre än {{count}} sekunder'
  },
  xSeconds: {
    one: 'en sekund',
    other: '{{count}} sekunder'
  },
  halfAMinute: 'en halv minut',
  lessThanXMinutes: {
    one: 'mindre än en minut',
    other: 'mindre än {{count}} minuter'
  },
  xMinutes: {
    one: 'en minut',
    other: '{{count}} minuter'
  },
  aboutXHours: {
    one: 'ungefär en timme',
    other: 'ungefär {{count}} timmar'
  },
  xHours: {
    one: 'en timme',
    other: '{{count}} timmar'
  },
  xDays: {
    one: 'en dag',
    other: '{{count}} dagar'
  },
  aboutXWeeks: {
    one: 'ungefär en vecka',
    other: 'ungefär {{count}} vecka'
  },
  xWeeks: {
    one: 'en vecka',
    other: '{{count}} vecka'
  },
  aboutXMonths: {
    one: 'ungefär en månad',
    other: 'ungefär {{count}} månader'
  },
  xMonths: {
    one: 'en månad',
    other: '{{count}} månader'
  },
  aboutXYears: {
    one: 'ungefär ett år',
    other: 'ungefär {{count}} år'
  },
  xYears: {
    one: 'ett år',
    other: '{{count}} år'
  },
  overXYears: {
    one: 'över ett år',
    other: 'över {{count}} år'
  },
  almostXYears: {
    one: 'nästan ett år',
    other: 'nästan {{count}} år'
  }
};
SvLib.wordMapping = ['noll', 'en', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv'];
SvLib.dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'y-MM-dd'
};
SvLib.timeFormats = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
SvLib.dateTimeFormats = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
SvLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: SvLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: SvLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: SvLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
SvLib.formatRelativeLocale = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: 'P'
};
SvLib.eraValues = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['före Kristus', 'efter Kristus']
};
SvLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1:a klettalet', '2:a klettalet', '3:e klettalet', '4:e klettalet']
};
SvLib.monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
};
SvLib.dayValues = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
  abbreviated: ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'],
  wide: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
SvLib.dayPeriodValues = {
  narrow: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morg.',
    afternoon: 'efterm.',
    evening: 'kväll',
    night: 'natt'
  },
  abbreviated: {
    am: 'f.m.',
    pm: 'e.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morgon',
    afternoon: 'efterm.',
    evening: 'kväll',
    night: 'natt'
  },
  wide: {
    am: 'förmiddag',
    pm: 'eftermiddag',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morgon',
    afternoon: 'eftermiddag',
    evening: 'kväll',
    night: 'natt'
  }
};
SvLib.formattingDayPeriodValues = {
  narrow: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på efterm.',
    evening: 'på kvällen',
    night: 'på natten'
  },
  abbreviated: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på efterm.',
    evening: 'på kvällen',
    night: 'på natten'
  },
  wide: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morgonen',
    afternoon: 'på eftermiddagen',
    evening: 'på kvällen',
    night: 'på natten'
  }
};
SvLib.localize = {
  ordinalNumber: SvLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: SvLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: SvLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: SvLib.monthValues,
    defaultWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: SvLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: SvLib.dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: SvLib.formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
SvLib.matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
SvLib.parseOrdinalNumberPattern = /\d+/i;
SvLib.matchEraPatterns = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
SvLib.parseEraPatterns = {
  any: [/^f/i, /^[ev]/i]
};
SvLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? klettalet/i
};
SvLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
SvLib.matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
SvLib.parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
SvLib.matchDayPatterns = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
SvLib.parseDayPatterns = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
SvLib.matchDayPeriodPatterns = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
SvLib.parseDayPeriodPatterns = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
};
SvLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: SvLib.matchOrdinalNumberPattern,
    parsePattern: SvLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: SvLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: SvLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: SvLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: SvLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: SvLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: SvLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: SvLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: SvLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: SvLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: SvLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */
const svLocale = {
  code: 'sv',
  formatDistance: SvLib.formatDistance,
  formatLong: SvLib.formatLong,
  formatRelative: SvLib.formatRelative,
  localize: SvLib.localize,
  match: SvLib.match,
  options: {
    weekStartsOn: 1
    /* Monday */,

    firstWeekContainsDate: 4
  }
};

class NbLib {
  static formatDistance(token, count, options) {
    let result;
    let tokenValue = NbLib.formatDistanceLocale[token];
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', String(count));
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'om ' + result;
      } else {
        return result + ' siden';
      }
    }
    return result;
  }
  static formatRelative(token, _date, _baseDate, _options) {
    return NbLib.formatRelativeLocale[token];
  }
  static ordinalNumber(dirtyNumber, _options) {
    let number = Number(dirtyNumber);
    return number + '.';
  }
}
NbLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'mindre enn ett sekund',
    other: 'mindre enn {{count}} sekunder'
  },
  xSeconds: {
    one: 'ett sekund',
    other: '{{count}} sekunder'
  },
  halfAMinute: 'et halvt minutt',
  lessThanXMinutes: {
    one: 'mindre enn ett minutt',
    other: 'mindre enn {{count}} minutter'
  },
  xMinutes: {
    one: 'ett minutt',
    other: '{{count}} minutter'
  },
  aboutXHours: {
    one: 'omtrent en time',
    other: 'omtrent {{count}} timer'
  },
  xHours: {
    one: 'en time',
    other: '{{count}} timer'
  },
  xDays: {
    one: 'en dag',
    other: '{{count}} dager'
  },
  aboutXWeeks: {
    one: 'omtrent en uke',
    other: 'omtrent {{count}} uker'
  },
  xWeeks: {
    one: 'en uke',
    other: '{{count}} uker'
  },
  aboutXMonths: {
    one: 'omtrent en måned',
    other: 'omtrent {{count}} måneder'
  },
  xMonths: {
    one: 'en måned',
    other: '{{count}} måneder'
  },
  aboutXYears: {
    one: 'omtrent ett år',
    other: 'omtrent {{count}} år'
  },
  xYears: {
    one: 'ett år',
    other: '{{count}} år'
  },
  overXYears: {
    one: 'over ett år',
    other: 'over {{count}} år'
  },
  almostXYears: {
    one: 'nesten ett år',
    other: 'nesten {{count}} år'
  }
};
NbLib.dateFormats = {
  full: 'EEEE d. MMMM y',
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'dd.MM.y'
};
NbLib.timeFormats = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
NbLib.dateTimeFormats = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
NbLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: NbLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: NbLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: NbLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
NbLib.formatRelativeLocale = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: 'P'
};
NbLib.eraValues = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['før Kristus', 'etter Kristus']
};
NbLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. klettal', '2. klettal', '3. klettal', '4. klettal']
};
NbLib.monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
  wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
};
NbLib.dayValues = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
  abbreviated: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
};
NbLib.dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på etterm.',
    evening: 'på kvelden',
    night: 'på natten'
  },
  abbreviated: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på etterm.',
    evening: 'på kvelden',
    night: 'på natten'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morgenen',
    afternoon: 'på ettermiddagen',
    evening: 'på kvelden',
    night: 'på natten'
  }
};
NbLib.localize = {
  ordinalNumber: NbLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: NbLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: NbLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: NbLib.monthValues,
    defaultWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: NbLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: NbLib.dayPeriodValues,
    defaultWidth: 'wide'
  })
};
NbLib.matchOrdinalNumberPattern = /^(\d+)\.?/i;
NbLib.parseOrdinalNumberPattern = /\d+/i;
NbLib.matchEraPatterns = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
NbLib.parseEraPatterns = {
  any: [/^f/i, /^e/i]
};
NbLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? klettal/i
};
NbLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
NbLib.matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
NbLib.parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
NbLib.matchDayPatterns = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
NbLib.parseDayPatterns = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
NbLib.matchDayPeriodPatterns = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
NbLib.parseDayPeriodPatterns = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
};
NbLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: NbLib.matchOrdinalNumberPattern,
    parsePattern: NbLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: NbLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: NbLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: NbLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: NbLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: NbLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: NbLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: NbLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: NbLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: NbLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: NbLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */
const nbLocale = {
  code: 'nb',
  formatDistance: NbLib.formatDistance,
  formatLong: NbLib.formatLong,
  formatRelative: NbLib.formatRelative,
  localize: NbLib.localize,
  match: NbLib.match,
  options: {
    weekStartsOn: 1
    /* Monday */,

    firstWeekContainsDate: 4
  }
};

class PlLib {
  static declensionGroup(scheme, count) {
    if (count === 1) {
      return scheme.one;
    }
    let rem100 = count % 100; // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) {
      return scheme.other;
    }
    let rem10 = rem100 % 10; // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) {
      return scheme.twoFour;
    }
    return scheme.other;
  }
  static declension(scheme, count, time) {
    let group = PlLib.declensionGroup(scheme, count);
    let finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
  }
  static formatDistance(token, count, options) {
    let scheme = PlLib.formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) {
      return PlLib.declension(scheme, count, 'regular');
    }
    if (options.comparison && options.comparison > 0) {
      return 'za ' + PlLib.declension(scheme, count, 'future');
    } else {
      return PlLib.declension(scheme, count, 'past') + ' temu';
    }
  }
  static dayAndTimeWithAdjective(token, date, baseDate, options) {
    let adjectives;
    if (DateFnsLib.isSameUTCWeek(date, baseDate, options)) {
      adjectives = PlLib.adjectivesThisWeek;
    } else if (token === 'lastWeek') {
      adjectives = PlLib.adjectivesLastWeek;
    } else if (token === 'nextWeek') {
      adjectives = PlLib.adjectivesNextWeek;
    } else {
      throw new Error("Cannot determine adjectives for token ".concat(token));
    }
    let day = date.getUTCDay();
    let grammaticalGender = PlLib.dayGrammaticalGender[day];
    let adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
  }
  static formatRelative(token, date, baseDate, options) {
    let format = PlLib.formatRelativeLocale[token];
    if (typeof format === 'function') {
      return format(token, date, baseDate, options);
    }
    return format;
  }
}
PlLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: {
      regular: 'mniej niż sekunda',
      past: 'mniej niż sekundę',
      future: 'mniej niż sekundę'
    },
    twoFour: 'mniej niż {{count}} sekundy',
    other: 'mniej niż {{count}} sekund'
  },
  xSeconds: {
    one: {
      regular: 'sekunda',
      past: 'sekundę',
      future: 'sekundę'
    },
    twoFour: '{{count}} sekundy',
    other: '{{count}} sekund'
  },
  halfAMinute: {
    one: 'pół minuty',
    twoFour: 'pół minuty',
    other: 'pół minuty'
  },
  lessThanXMinutes: {
    one: {
      regular: 'mniej niż minuta',
      past: 'mniej niż minutę',
      future: 'mniej niż minutę'
    },
    twoFour: 'mniej niż {{count}} minuty',
    other: 'mniej niż {{count}} minut'
  },
  xMinutes: {
    one: {
      regular: 'minuta',
      past: 'minutę',
      future: 'minutę'
    },
    twoFour: '{{count}} minuty',
    other: '{{count}} minut'
  },
  aboutXHours: {
    one: {
      regular: 'około godziny',
      past: 'około godziny',
      future: 'około godzinę'
    },
    twoFour: 'około {{count}} godziny',
    other: 'około {{count}} godzin'
  },
  xHours: {
    one: {
      regular: 'godzina',
      past: 'godzinę',
      future: 'godzinę'
    },
    twoFour: '{{count}} godziny',
    other: '{{count}} godzin'
  },
  xDays: {
    one: {
      regular: 'dzień',
      past: 'dzień',
      future: '1 dzień'
    },
    twoFour: '{{count}} dni',
    other: '{{count}} dni'
  },
  aboutXWeeks: {
    one: 'około tygodnia',
    twoFour: 'około {{count}} tygodni',
    other: 'około {{count}} tygodni'
  },
  xWeeks: {
    one: 'tydzień',
    twoFour: '{{count}} tygodnie',
    other: '{{count}} tygodni'
  },
  aboutXMonths: {
    one: 'około miesiąc',
    twoFour: 'około {{count}} miesiące',
    other: 'około {{count}} miesięcy'
  },
  xMonths: {
    one: 'miesiąc',
    twoFour: '{{count}} miesiące',
    other: '{{count}} miesięcy'
  },
  aboutXYears: {
    one: 'około rok',
    twoFour: 'około {{count}} lata',
    other: 'około {{count}} lat'
  },
  xYears: {
    one: 'rok',
    twoFour: '{{count}} lata',
    other: '{{count}} lat'
  },
  overXYears: {
    one: 'ponad rok',
    twoFour: 'ponad {{count}} lata',
    other: 'ponad {{count}} lat'
  },
  almostXYears: {
    one: 'prawie rok',
    twoFour: 'prawie {{count}} lata',
    other: 'prawie {{count}} lat'
  }
};
PlLib.dateFormats = {
  full: 'EEEE, do MMMM y',
  long: 'do MMMM y',
  medium: 'do MMM y',
  short: 'dd.MM.y'
};
PlLib.timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
PlLib.dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
PlLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: PlLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: PlLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: PlLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
PlLib.adjectivesLastWeek = {
  masculine: 'ostatni',
  feminine: 'ostatnia'
};
PlLib.adjectivesThisWeek = {
  masculine: 'ten',
  feminine: 'ta'
};
PlLib.adjectivesNextWeek = {
  masculine: 'następny',
  feminine: 'następna'
};
PlLib.dayGrammaticalGender = {
  0: 'feminine',
  1: 'masculine',
  2: 'masculine',
  3: 'feminine',
  4: 'masculine',
  5: 'masculine',
  6: 'feminine'
};
PlLib.formatRelativeLocale = {
  lastWeek: PlLib.dayAndTimeWithAdjective,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: PlLib.dayAndTimeWithAdjective,
  other: 'P'
};
PlLib.eraValues = {
  narrow: ['p.n.e.', 'n.e.'],
  abbreviated: ['p.n.e.', 'n.e.'],
  wide: ['przed naszą erą', 'naszej ery']
};
PlLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['I kw.', 'II kw.', 'III kw.', 'IV kw.'],
  wide: ['I kwartał', 'II kwartał', 'III kwartał', 'IV kwartał']
};
PlLib.monthValues = {
  narrow: ['S', 'L', 'M', 'K', 'M', 'C', 'L', 'S', 'W', 'P', 'L', 'G'],
  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  wide: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień']
};
PlLib.monthFormattingValues = {
  narrow: ['s', 'l', 'm', 'k', 'm', 'c', 'l', 's', 'w', 'p', 'l', 'g'],
  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  wide: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
};
PlLib.dayValues = {
  narrow: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
};
PlLib.dayFormattingValues = {
  narrow: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
};
PlLib.dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'półn.',
    noon: 'poł',
    morning: 'rano',
    afternoon: 'popoł.',
    evening: 'wiecz.',
    night: 'noc'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'północ',
    noon: 'południe',
    morning: 'rano',
    afternoon: 'popołudnie',
    evening: 'wieczór',
    night: 'noc'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'północ',
    noon: 'południe',
    morning: 'rano',
    afternoon: 'popołudnie',
    evening: 'wieczór',
    night: 'noc'
  }
};
PlLib.dayPeriodFormattingValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'o półn.',
    noon: 'w poł.',
    morning: 'rano',
    afternoon: 'po poł.',
    evening: 'wiecz.',
    night: 'w nocy'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o północy',
    noon: 'w południe',
    morning: 'rano',
    afternoon: 'po południu',
    evening: 'wieczorem',
    night: 'w nocy'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o północy',
    noon: 'w południe',
    morning: 'rano',
    afternoon: 'po południu',
    evening: 'wieczorem',
    night: 'w nocy'
  }
};
PlLib.ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  return String(dirtyNumber);
};
PlLib.localize = {
  ordinalNumber: PlLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: PlLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: PlLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: PlLib.monthValues,
    defaultWidth: 'wide',
    formattingValues: PlLib.monthFormattingValues,
    defaultFormattingWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: PlLib.dayValues,
    defaultWidth: 'wide',
    formattingValues: PlLib.dayFormattingValues,
    defaultFormattingWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: PlLib.dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: PlLib.dayPeriodFormattingValues,
    defaultFormattingWidth: 'wide'
  })
};
PlLib.matchOrdinalNumberPattern = /^(\d+)?/i;
PlLib.parseOrdinalNumberPattern = /\d+/i;
PlLib.matchEraPatterns = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
PlLib.parseEraPatterns = {
  any: [/^p/i, /^n/i]
};
PlLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
PlLib.parseQuarterPatterns = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
};
PlLib.matchMonthPatterns = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
PlLib.parseMonthPatterns = {
  narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
  any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
};
PlLib.matchDayPatterns = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
PlLib.parseDayPatterns = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
};
PlLib.matchDayPeriodPatterns = {
  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
PlLib.parseDayPeriodPatterns = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  }
};
PlLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: PlLib.matchOrdinalNumberPattern,
    parsePattern: PlLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: PlLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: PlLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: PlLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: PlLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: PlLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: PlLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: PlLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: PlLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: PlLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: PlLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */
const plLocale = {
  code: 'pl',
  formatDistance: PlLib.formatDistance,
  formatLong: PlLib.formatLong,
  formatRelative: PlLib.formatRelative,
  localize: PlLib.localize,
  match: PlLib.match,
  options: {
    weekStartsOn: 1
    /* Monday */,

    firstWeekContainsDate: 4
  }
};

class FrLib {
  static formatRelative(token, date, baseDate, options) {
    return FrLib.formatRelativeLocale[token];
  }
  static ordinalNumber(dirtyNumber, options) {
    let number = Number(dirtyNumber);
    let unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    let feminineUnits = ['year', 'week', 'hour', 'minute', 'second'];
    let suffix;
    if (number === 1) {
      suffix = unit && feminineUnits.includes(unit) ? 'ère' : 'er';
    } else {
      suffix = 'ème';
    }
    return number + suffix;
  }
}
FrLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'moins d’une seconde',
    other: 'moins de {{count}} secondes'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} secondes'
  },
  halfAMinute: '30 secondes',
  lessThanXMinutes: {
    one: 'moins d’une minute',
    other: 'moins de {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'environ 1 heure',
    other: 'environ {{count}} heures'
  },
  xHours: {
    one: '1 heure',
    other: '{{count}} heures'
  },
  xDays: {
    one: '1 jour',
    other: '{{count}} jours'
  },
  aboutXWeeks: {
    one: 'environ 1 semaine',
    other: 'environ {{count}} semaines'
  },
  xWeeks: {
    one: '1 semaine',
    other: '{{count}} semaines'
  },
  aboutXMonths: {
    one: 'environ 1 mois',
    other: 'environ {{count}} mois'
  },
  xMonths: {
    one: '1 mois',
    other: '{{count}} mois'
  },
  aboutXYears: {
    one: 'environ 1 an',
    other: 'environ {{count}} ans'
  },
  xYears: {
    one: '1 an',
    other: '{{count}} ans'
  },
  overXYears: {
    one: 'plus d’un an',
    other: 'plus de {{count}} ans'
  },
  almostXYears: {
    one: 'presqu’un an',
    other: 'presque {{count}} ans'
  }
};
FrLib.formatDistance = function formatDistance(token, count, options) {
  var result;
  var form = FrLib.formatDistanceLocale[token];
  if (typeof form === 'string') {
    result = form;
  } else if (count === 1) {
    result = form.one;
  } else {
    result = form.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'dans ' + result;
    } else {
      return 'il y a ' + result;
    }
  }
  return result;
};
FrLib.dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
FrLib.timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
FrLib.dateTimeFormats = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
FrLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: FrLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: FrLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: FrLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
FrLib.formatRelativeLocale = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: 'P'
};
FrLib.eraValues = {
  narrow: ['av. J.-C', 'ap. J.-C'],
  abbreviated: ['av. J.-C', 'ap. J.-C'],
  wide: ['avant Jésus-Christ', 'après Jésus-Christ']
};
FrLib.quarterValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
};
FrLib.monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
};
FrLib.dayValues = {
  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
  abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
};
FrLib.dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'mat.',
    afternoon: 'ap.m.',
    evening: 'soir',
    night: 'mat.'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'matin',
    afternoon: 'après-midi',
    evening: 'soir',
    night: 'matin'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'du matin',
    afternoon: 'de l’après-midi',
    evening: 'du soir',
    night: 'du matin'
  }
};
FrLib.localize = {
  ordinalNumber: FrLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: FrLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: FrLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: FrLib.monthValues,
    defaultWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: FrLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: FrLib.dayPeriodValues,
    defaultWidth: 'wide'
  })
};
FrLib.matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
FrLib.parseOrdinalNumberPattern = /\d+/i;
FrLib.matchEraPatterns = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
FrLib.parseEraPatterns = {
  any: [/^av/i, /^ap/i]
};
FrLib.matchQuarterPatterns = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
};
FrLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
FrLib.matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
FrLib.parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
FrLib.matchDayPatterns = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
FrLib.parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
};
FrLib.matchDayPeriodPatterns = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
FrLib.parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
};
FrLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: FrLib.matchOrdinalNumberPattern,
    parsePattern: FrLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: FrLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FrLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: FrLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FrLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: FrLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FrLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: FrLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FrLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: FrLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: FrLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */
const frLocale = {
  code: 'fr',
  formatDistance: FrLib.formatDistance,
  formatLong: FrLib.formatLong,
  formatRelative: FrLib.formatRelative,
  localize: FrLib.localize,
  match: FrLib.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};

var _a$3;
class DeLib {
  static formatDistance(token, count, options) {
    let result;
    let tokenValue = options !== null && options !== void 0 && options.addSuffix ? this.formatDistanceLocale[token].withPreposition : this.formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', String(count));
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'in ' + result;
      } else {
        return 'vor ' + result;
      }
    }
    return result;
  }
  static formatRelative(token, _date, _baseDate, _options) {
    return DeLib.formatRelativeLocale[token];
  }
  static ordinalNumber(dirtyNumber, _options) {
    let number = Number(dirtyNumber);
    return number + '.';
  }
}
_a$3 = DeLib;
DeLib.formatDistanceLocale = {
  lessThanXSeconds: {
    standalone: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    },
    withPreposition: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    }
  },
  xSeconds: {
    standalone: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    },
    withPreposition: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    }
  },
  halfAMinute: {
    standalone: 'halbe Minute',
    withPreposition: 'halben Minute'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    },
    withPreposition: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    }
  },
  xMinutes: {
    standalone: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    },
    withPreposition: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    },
    withPreposition: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    }
  },
  xHours: {
    standalone: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    },
    withPreposition: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    }
  },
  xDays: {
    standalone: {
      one: '1 Tag',
      other: '{{count}} Tage'
    },
    withPreposition: {
      one: '1 Tag',
      other: '{{count}} Tagen'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    },
    withPreposition: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    }
  },
  xWeeks: {
    standalone: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    },
    withPreposition: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monate'
    },
    withPreposition: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monaten'
    }
  },
  xMonths: {
    standalone: {
      one: '1 Monat',
      other: '{{count}} Monate'
    },
    withPreposition: {
      one: '1 Monat',
      other: '{{count}} Monaten'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahre'
    },
    withPreposition: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahren'
    }
  },
  xYears: {
    standalone: {
      one: '1 Jahr',
      other: '{{count}} Jahre'
    },
    withPreposition: {
      one: '1 Jahr',
      other: '{{count}} Jahren'
    }
  },
  overXYears: {
    standalone: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahre'
    },
    withPreposition: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahren'
    }
  },
  almostXYears: {
    standalone: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahre'
    },
    withPreposition: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahren'
    }
  }
};
DeLib.dateFormats = {
  full: 'EEEE, do MMMM y',
  // Montag, 7. Januar 2018
  long: 'do MMMM y',
  // 7. Januar 2018
  medium: 'do MMM y',
  // 7. Jan. 2018
  short: 'dd.MM.y' // 07.01.2018
};
DeLib.timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
DeLib.dateTimeFormats = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
DeLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: DeLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: DeLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: DeLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
DeLib.formatRelativeLocale = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: 'P'
};
DeLib.eraValues = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['vor Christus', 'nach Christus']
};
DeLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
};
DeLib.monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
};
DeLib.formattingMonthValues = {
  narrow: _a$3.monthValues.narrow,
  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
  wide: _a$3.monthValues.wide
};
DeLib.dayValues = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
};
DeLib.dayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachm.',
    evening: 'Abend',
    night: 'Nacht'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  }
};
DeLib.formattingDayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachm.',
    evening: 'abends',
    night: 'nachts'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  }
};
DeLib.localize = {
  ordinalNumber: DeLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: DeLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: DeLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: DeLib.monthValues,
    defaultWidth: 'wide',
    formattingValues: DeLib.formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: DeLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: DeLib.dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: DeLib.formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
DeLib.matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
DeLib.parseOrdinalNumberPattern = /\d+/i;
DeLib.matchEraPatterns = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
DeLib.parseEraPatterns = {
  any: [/^v/i, /^n/i]
};
DeLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
DeLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
DeLib.matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
DeLib.parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
DeLib.matchDayPatterns = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
DeLib.parseDayPatterns = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
DeLib.matchDayPeriodPatterns = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
DeLib.parseDayPeriodPatterns = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i // will never be matched. Night is matched by `pm`
  }
};
DeLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: DeLib.matchOrdinalNumberPattern,
    parsePattern: DeLib.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: DeLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: DeLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: DeLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: DeLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: DeLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: DeLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: DeLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: DeLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: DeLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: DeLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */
const deLocale = {
  code: 'de',
  formatDistance: DeLib.formatDistance,
  formatLong: DeLib.formatLong,
  formatRelative: DeLib.formatRelative,
  localize: DeLib.localize,
  match: DeLib.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};

var _a$2;
class ItLib {
  static formatDistance(token, count, options) {
    let result;
    let tokenValue = this.formatDistanceLocale[token];
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', count.toString());
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'tra ' + result;
      } else {
        return result + ' fa';
      }
    }
    return result;
  }
  static lastWeek(day) {
    switch (day) {
      case 0:
        return "'domenica scorsa alle' p";
      default:
        return "'" + this.weekdays[day] + " scorso alle' p";
    }
  }
  static thisWeek(day) {
    return "'" + this.weekdays[day] + " alle' p";
  }
  static nextWeek(day) {
    switch (day) {
      case 0:
        return "'domenica prossima alle' p";
      default:
        return "'" + this.weekdays[day] + " prossimo alle' p";
    }
  }
  static formatRelative(token, date, baseDate, options) {
    let format = ItLib.formatRelativeLocale[token];
    if (typeof format === 'function') {
      return format(date, baseDate, options);
    }
    return format;
  }
  static ordinalNumber(dirtyNumber, _options) {
    const number = Number(dirtyNumber);
    return number + '.';
  }
}
_a$2 = ItLib;
ItLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'meno di un secondo',
    other: 'meno di {{count}} secondi'
  },
  xSeconds: {
    one: 'un secondo',
    other: '{{count}} secondi'
  },
  halfAMinute: 'alcuni secondi',
  lessThanXMinutes: {
    one: 'meno di un minuto',
    other: 'meno di {{count}} minuti'
  },
  xMinutes: {
    one: 'un minuto',
    other: '{{count}} minuti'
  },
  aboutXHours: {
    one: "circa un'ora",
    other: 'circa {{count}} ore'
  },
  xHours: {
    one: "un'ora",
    other: '{{count}} ore'
  },
  xDays: {
    one: 'un giorno',
    other: '{{count}} giorni'
  },
  aboutXWeeks: {
    one: 'circa una settimana',
    other: 'circa {{count}} settimane'
  },
  xWeeks: {
    one: 'una settimana',
    other: '{{count}} settimane'
  },
  aboutXMonths: {
    one: 'circa un mese',
    other: 'circa {{count}} mesi'
  },
  xMonths: {
    one: 'un mese',
    other: '{{count}} mesi'
  },
  aboutXYears: {
    one: 'circa un anno',
    other: 'circa {{count}} anni'
  },
  xYears: {
    one: 'un anno',
    other: '{{count}} anni'
  },
  overXYears: {
    one: 'più di un anno',
    other: 'più di {{count}} anni'
  },
  almostXYears: {
    one: 'quasi un anno',
    other: 'quasi {{count}} anni'
  }
};
ItLib.dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
ItLib.timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
ItLib.dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
ItLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: ItLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: ItLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: ItLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
ItLib.weekdays = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
ItLib.formatRelativeLocale = {
  lastWeek: function lastWeek(date, baseDate, options) {
    const day = date.getUTCDay();
    if (DateFnsLib.isSameUTCWeek(date, baseDate, options)) {
      return ItLib.thisWeek(day);
    } else {
      return ItLib.lastWeek(day);
    }
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function nextWeek(date, baseDate, options) {
    const day = date.getUTCDay();
    if (DateFnsLib.isSameUTCWeek(date, baseDate, options)) {
      return ItLib.thisWeek(day);
    } else {
      return ItLib.nextWeek(day);
    }
  },
  other: 'P'
};
ItLib.eraValues = {
  narrow: ['aC', 'dC'],
  abbreviated: ['a.C.', 'd.C.'],
  wide: ['avanti Cristo', 'dopo Cristo']
};
ItLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
ItLib.monthValues = {
  narrow: ['G', 'F', 'M', 'A', 'M', 'G', 'L', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
  wide: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']
};
ItLib.dayValues = {
  narrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
  short: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
  abbreviated: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
  wide: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato']
};
ItLib.dayPeriodValues = {
  narrow: {
    am: 'm.',
    pm: 'p.',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  }
};
ItLib.formattingDayPeriodValues = {
  narrow: {
    am: 'm.',
    pm: 'p.',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  }
};
ItLib.localize = {
  ordinalNumber: ItLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: ItLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: ItLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: ItLib.monthValues,
    defaultWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: ItLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: ItLib.dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: ItLib.formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
ItLib.matchOrdinalNumberPattern = /^(\d+)(º)?/i;
ItLib.parseOrdinalNumberPattern = /\d+/i;
ItLib.matchEraPatterns = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
ItLib.parseEraPatterns = {
  any: [/^a/i, /^(d|e)/i]
};
ItLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
ItLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
ItLib.matchMonthPatterns = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
ItLib.parseMonthPatterns = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
ItLib.matchDayPatterns = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
ItLib.parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
};
ItLib.matchDayPeriodPatterns = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
ItLib.parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
};
ItLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: _a$2.matchOrdinalNumberPattern,
    parsePattern: _a$2.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: ItLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ItLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: ItLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ItLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: ItLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ItLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: ItLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: ItLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: ItLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: ItLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */
const itLocale = {
  code: 'it',
  formatDistance: ItLib.formatDistance,
  formatLong: ItLib.formatLong,
  formatRelative: ItLib.formatRelative,
  localize: ItLib.localize,
  match: ItLib.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};

var _a$1;
class EsLib {
  static formatDistance(token, count, options) {
    let result;
    let tokenValue = this.formatDistanceLocale[token];
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', count.toString());
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'en ' + result;
      } else {
        return 'hace ' + result;
      }
    }
    return result;
  }
  static formatRelative(token, date, baseDate, options) {
    if (date.getUTCHours() !== 1) {
      return this.formatRelativeLocalePlural[token];
    } else {
      return this.formatRelativeLocale[token];
    }
  }
  static ordinalNumber(dirtyNumber, _options) {
    const number = Number(dirtyNumber);
    return number + 'º';
  }
}
_a$1 = EsLib;
EsLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de un segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'medio minuto',
  lessThanXMinutes: {
    one: 'menos de un minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'alrededor de 1 hora',
    other: 'alrededor de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 día',
    other: '{{count}} días'
  },
  aboutXWeeks: {
    one: 'alrededor de 1 semana',
    other: 'alrededor de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'alrededor de 1 mes',
    other: 'alrededor de {{count}} meses'
  },
  xMonths: {
    one: '1 mes',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'alrededor de 1 año',
    other: 'alrededor de {{count}} años'
  },
  xYears: {
    one: '1 año',
    other: '{{count}} años'
  },
  overXYears: {
    one: 'más de 1 año',
    other: 'más de {{count}} años'
  },
  almostXYears: {
    one: 'casi 1 año',
    other: 'casi {{count}} años'
  }
};
EsLib.dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
EsLib.timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
EsLib.dateTimeFormats = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
EsLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: EsLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: EsLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: EsLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
EsLib.formatRelativeLocale = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: 'P'
};
EsLib.formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: 'P'
};
EsLib.eraValues = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'después de cristo']
};
EsLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
EsLib.monthValues = {
  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
};
EsLib.dayValues = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
};
EsLib.dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  }
};
EsLib.formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  }
};
EsLib.localize = {
  ordinalNumber: EsLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: EsLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: EsLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: EsLib.monthValues,
    defaultWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: EsLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: EsLib.dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: EsLib.formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
EsLib.matchOrdinalNumberPattern = /^(\d+)(º)?/i;
EsLib.parseOrdinalNumberPattern = /\d+/i;
EsLib.matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
EsLib.parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
};
EsLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
EsLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
EsLib.matchMonthPatterns = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
EsLib.parseMonthPatterns = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
};
EsLib.matchDayPatterns = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
EsLib.parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
};
EsLib.matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
EsLib.parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
};
EsLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: _a$1.matchOrdinalNumberPattern,
    parsePattern: _a$1.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: EsLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: EsLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: EsLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: EsLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: EsLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: EsLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: EsLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: EsLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: EsLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: EsLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */
const esLocale = {
  code: 'es',
  formatDistance: EsLib.formatDistance,
  formatLong: EsLib.formatLong,
  formatRelative: EsLib.formatRelative,
  localize: EsLib.localize,
  match: EsLib.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1
  }
};

var _a;
class NlLib {
  static formatDistance(token, count, options) {
    let result;
    let tokenValue = this.formatDistanceLocale[token];
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', String(count));
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'over ' + result;
      } else {
        return result + ' geleden';
      }
    }
    return result;
  }
  static formatRelative(token, date, baseDate, options) {
    return this.formatRelativeLocale[token];
  }
  static ordinalNumber(dirtyNumber, _options) {
    const number = Number(dirtyNumber);
    return number + 'e';
  }
}
_a = NlLib;
NlLib.formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'minder dan een seconde',
    other: 'minder dan {{count}} seconden'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  halfAMinute: 'een halve minuut',
  lessThanXMinutes: {
    one: 'minder dan een minuut',
    other: 'minder dan {{count}} minuten'
  },
  xMinutes: {
    one: 'een minuut',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} uur'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} uur'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weken'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weken'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maanden'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer dan 1 jaar',
    other: 'meer dan {{count}} jaar'
  },
  almostXYears: {
    one: 'bijna 1 jaar',
    other: 'bijna {{count}} jaar'
  }
};
NlLib.dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd-MM-y'
};
NlLib.timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
NlLib.dateTimeFormats = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
NlLib.formatLong = {
  date: LocaleLib.buildFormatLongFn({
    formats: NlLib.dateFormats,
    defaultWidth: 'full'
  }),
  time: LocaleLib.buildFormatLongFn({
    formats: NlLib.timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: LocaleLib.buildFormatLongFn({
    formats: NlLib.dateTimeFormats,
    defaultWidth: 'full'
  })
};
NlLib.formatRelativeLocale = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};
NlLib.eraValues = {
  narrow: ['v.C.', 'n.C.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['voor Christus', 'na Christus']
};
NlLib.quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
};
NlLib.monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};
NlLib.dayValues = {
  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};
NlLib.dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};
NlLib.localize = {
  ordinalNumber: NlLib.ordinalNumber,
  era: LocaleLib.buildLocalizeFn({
    values: NlLib.eraValues,
    defaultWidth: 'wide'
  }),
  quarter: LocaleLib.buildLocalizeFn({
    values: NlLib.quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: LocaleLib.buildLocalizeFn({
    values: NlLib.monthValues,
    defaultWidth: 'wide'
  }),
  day: LocaleLib.buildLocalizeFn({
    values: NlLib.dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: LocaleLib.buildLocalizeFn({
    values: NlLib.dayPeriodValues,
    defaultWidth: 'wide'
  })
};
NlLib.matchOrdinalNumberPattern = /^(\d+)e?/i;
NlLib.parseOrdinalNumberPattern = /\d+/i;
NlLib.matchEraPatterns = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
NlLib.parseEraPatterns = {
  any: [/^a/i, /^(d|e)/i]
};
NlLib.matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
NlLib.parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
NlLib.matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
NlLib.parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
NlLib.matchDayPatterns = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
NlLib.parseDayPatterns = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
NlLib.matchDayPeriodPatterns = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
NlLib.parseDayPeriodPatterns = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
NlLib.match = {
  ordinalNumber: LocaleLib.buildMatchPatternFn({
    matchPattern: _a.matchOrdinalNumberPattern,
    parsePattern: _a.parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: LocaleLib.buildMatchFn({
    matchPatterns: NlLib.matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: NlLib.parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: LocaleLib.buildMatchFn({
    matchPatterns: NlLib.matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: NlLib.parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: LocaleLib.buildMatchFn({
    matchPatterns: NlLib.matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: NlLib.parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: LocaleLib.buildMatchFn({
    matchPatterns: NlLib.matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: NlLib.parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: LocaleLib.buildMatchFn({
    matchPatterns: NlLib.matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: NlLib.parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */
const nlLocale = {
  code: 'nl',
  formatDistance: NlLib.formatDistance,
  formatLong: NlLib.formatLong,
  formatRelative: NlLib.formatRelative,
  localize: NlLib.localize,
  match: NlLib.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};

const DatePicker = DatePickerLibrary.default.default || DatePickerLibrary.default || DatePickerLibrary;
// TODO: ua (uk-ua, Ukraine)
// United States
registerLocale("en-US", enUsLocale);
registerLocale("us", enUsLocale);
// United Kingdom
registerLocale("en-GB", enGbLocale);
registerLocale("en", enGbLocale);
registerLocale("gb", enGbLocale);
// Finland
registerLocale("fi-fi", fiLocale);
registerLocale("fi", fiLocale);
// Russia
registerLocale("ru-ru", ruLocale);
registerLocale("ru", ruLocale);
// Denmark
registerLocale("da-dk", daLocale);
registerLocale("da", daLocale);
registerLocale("dk", daLocale);
// Sweden
registerLocale("sv-se", svLocale);
registerLocale("sv", svLocale);
registerLocale("se", svLocale);
// Norway
registerLocale("nb-no", nbLocale);
registerLocale("nb", nbLocale);
registerLocale("no", nbLocale);
registerLocale("nor", nbLocale);
// Poland
registerLocale("pl-pl", plLocale);
registerLocale("pl", plLocale);
// France
registerLocale("fr-fr", frLocale);
registerLocale("fr", frLocale);
// Germany
registerLocale("de-de", deLocale);
registerLocale("de", deLocale);
// Italy
registerLocale("it-it", itLocale);
registerLocale("it", itLocale);
// Spain
registerLocale("es-es", esLocale);
registerLocale("es", esLocale);
// Netherlands
registerLocale("nl-nl", nlLocale);
registerLocale("nl", nlLocale);
setDefaultLocale("fi");
class DateInput extends BaseInput {
  get todayButton() {
    return this.props.todayButton || "";
  }
  get calendarClassName() {
    const calendarStyle = this.props.rentaStyle ? "renta" : "";
    return this.props.calendarClassName || calendarStyle;
  }
  handleChangeAsync(date) {
    const _super = Object.create(null, {
      hideEditAsync: {
        get: () => super.hideEditAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield this.updateValueAsync(date);
      if (this.props.clickToEdit) {
        yield _super.hideEditAsync.call(this);
      }
      if (this.props.onChange) {
        yield this.props.onChange(this.state.model.value);
      }
    });
  }
  handleSelectAsync(date) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemClick) {
        yield this.props.onItemClick(this, date);
      }
    });
  }
  handleRawChangeAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
    });
  }
  handleCalendarOpenAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onExpand) {
        yield this.props.onExpand(this);
      }
    });
  }
  handleMonthChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onMonthChange) {
        yield this.props.onMonthChange(this);
      }
    });
  }
  get selected() {
    return this.state.model.value != null ? new Date(this.state.model.value) : null;
  }
  renderCustomInput() {
    return this.props.customInput ? this.props.customInput(this) : null;
  }
  get format() {
    let format = this.props.showMonthYearPicker ? this.props.shortDate ? "MM.yy" : "MM.yyyy" : this.props.shortDate ? "dd.MM.yy" : "dd.MM.yyyy";
    if (this.props.showTime) {
      format = "dd.MM.yyyy H:mm";
    }
    if (this.props.showOnlyTime) {
      format = "H:mm";
    }
    return this.props.format || format;
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      valueBlurHandlerAsync: {
        get: () => super.valueBlurHandlerAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.valueBlurHandlerAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  onLabelClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
    });
  }
  get clearButton() {
    return this.props.clearButton === true;
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.click();
    });
  }
  clearAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const model = this.state.model;
      model.value = null;
      yield this.setState({
        model
      });
      if (this.props.onChange) {
        yield this.props.onChange(this.state.model.value);
      }
    });
  }
  clear() {
    // no await needed
    // noinspection JSIgnoredPromiseFromCall
    this.clearAsync();
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      //super
      yield _super.componentDidMount.call(this);
      //set input as readonly to avoid auto complete
      this.JQuery(`#${this.getInputId()}`).prop("readonly", true);
    });
  }
  renderValue() {
    const strValue = this.state.model.value != null ? Utility.toDateString(this.state.model.value) : "";
    return React.createElement("span", {
      className: styles$Z.value
    }, strValue);
  }
  renderInput() {
    const clearButton = this.clearButton && !!this.state.model.value;
    const smallStyle = this.props.small && styles$E.small;
    const readonlyStyle = this.readonly && styles$E.readonly;
    const clearButtonStyle = clearButton && styles$E.clearButton;
    return React.createElement("div", {
      className: this.css(styles$E.dateInput, smallStyle, readonlyStyle, clearButtonStyle, this.props.className)
    }, React.createElement(DatePicker, {
      id: this.getInputId(),
      ref: this.props.forwardedRef,
      className: "form-control",
      timeFormat: this.props.timeFormat || "HH:mm",
      excludeDates: this.props.excludeDates,
      title: DateInputLocalizer$1.get(this.props.title),
      dateFormat: this.format,
      minDate: this.props.minDate,
      maxDate: this.props.maxDate,
      minTime: this.props.minTime || undefined,
      maxTime: this.props.maxTime || undefined,
      selected: this.selected,
      calendarClassName: this.css("datepicker", this.calendarClassName),
      todayButton: this.todayButton,
      inline: this.props.expanded,
      withPortal: this.props.popup,
      showMonthDropdown: this.props.showMonthDropdown,
      showMonthYearPicker: this.props.showMonthYearPicker,
      showYearDropdown: this.props.showYearDropdown,
      showMonthYearDropdown: this.props.showMonthYearDropdown,
      locale: DateInputLocalizer$1.language,
      readOnly: this.readonly,
      customInput: this.renderCustomInput(),
      showTimeSelect: this.props.showTime,
      showTimeSelectOnly: this.props.showOnlyTime,
      timeIntervals: this.props.timeIntervals,
      timeCaption: this.props.timeCaption || DateInputLocalizer$1.time,
      placeholderText: this.props.placeholder || undefined,
      onChange: date => this.handleChangeAsync(date),
      onSelect: date => this.handleSelectAsync(date),
      onChangeRaw: e => this.handleRawChangeAsync(e),
      onBlur: () => this.valueBlurHandlerAsync(),
      onCalendarOpen: () => this.handleCalendarOpenAsync(),
      onMonthChange: () => this.handleMonthChangeAsync()
    }), clearButton && React.createElement("div", {
      className: this.css(styles$E.clearButtonIcon)
    }, React.createElement(Icon, {
      stopPropagation: true,
      name: "fa fa-times",
      size: IconSize.Normal,
      onClick: () => this.clearAsync()
    })));
  }
}

class Cell extends BaseComponent {
  constructor() {
    super(...arguments);
    this._inputRef = React.createRef();
  }
  toTitle(value) {
    let title = GridLocalizer$1.get(value);
    //remove: tags:
    title = title.replace("<mark>", "");
    title = title.replace("</mark>", "");
    return title;
  }
  findNextInputCell(cell) {
    do {
      cell = cell.isLastColumn ? cell.nextRow.cells[0] : cell.next;
      if (cell.isVisible && !cell.isReadonly && cell.inputContentInstance) {
        return cell;
      }
    } while (!cell.isLastColumn || !cell.isLastRow);
    return null;
  }
  onKeyDownAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const tab = e.keyCode == 9;
      if (tab) {
        const cell = this.cell;
        if (cell.inputContentInstance && cell.inputContentInstance.edit) {
          e.preventDefault();
          yield cell.inputContentInstance.hideEditAsync();
          const nextCell = this.findNextInputCell(cell);
          if (nextCell && nextCell.inputContentInstance) {
            yield nextCell.inputContentInstance.showEditAsync();
          }
        }
      }
    });
  }
  findValueByGridAccessor(model, accessor = null) {
    return accessor ? typeof accessor === "function" ? accessor(model) : Utility.findValueByAccessor(model, accessor) : null;
  }
  invokeCallback(cell, info = false) {
    return __awaiter(this, void 0, void 0, function* () {
      const column = cell.column;
      if (!cell.isReadonly && column.callback) {
        yield column.callback(cell, null);
      }
      if (cell.route) {
        yield PageRouteProvider.redirectAsync(cell.route);
      }
      if (info && cell.infoRoute) {
        yield PageRouteProvider.redirectAsync(cell.infoRoute);
      }
    });
  }
  processNewValueAsync(cell, value, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = cell.setValue(value);
      if (userInteraction) {
        yield this.invokeCallback(cell);
      }
      if (modified || cell.column.reRenderRow) {
        yield cell.row.reRenderAsync();
      } else {
        yield this.reRenderAsync();
      }
    });
  }
  onPlaceSelectedAsync(cell, location) {
    return __awaiter(this, void 0, void 0, function* () {
      const value = location.formattedAddress;
      yield this.processNewValueAsync(cell, value, true);
    });
  }
  onTextCellChangeAsync(cell, value, userInteraction, done) {
    return __awaiter(this, void 0, void 0, function* () {
      if (done) {
        yield this.processNewValueAsync(cell, value, userInteraction);
      }
    });
  }
  onEnumCellChangeAsync(cell, item, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      const value = parseInt(item.value);
      yield this.processNewValueAsync(cell, value, userInteraction);
    });
  }
  onNumberCellChangeAsync(cell, value, userInteraction, done) {
    return __awaiter(this, void 0, void 0, function* () {
      if (done) {
        yield this.processNewValueAsync(cell, value, userInteraction);
      }
    });
  }
  onBooleanCellChangeAsync(cell, value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.processNewValueAsync(cell, value, true);
    });
  }
  onDateCellChangeAsync(cell, value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.processNewValueAsync(cell, value, true);
    });
  }
  renderDefaultCellContent(cell, settings, cellValue) {
    const hasInfo = !!settings.infoAccessor;
    let infoValue = "";
    if (hasInfo) {
      infoValue = this.findValueByGridAccessor(cell.model, settings.infoAccessor);
      const infoFormat = cell.column.settings.infoFormat != null ? cell.column.settings.infoFormat : cell.column.format;
      infoValue = settings.hideZero && !infoValue ? "" : cell.column.settings && cell.column.settings.infoTransform ? cell.column.settings.infoTransform(cell, infoValue, infoFormat) : Utility.formatValue(infoValue, infoFormat);
      const hideInfo = hasInfo && (settings.infoHideZero && !infoValue || settings.infoHideEqual && infoValue == cellValue);
      if (hideInfo) {
        infoValue = "";
      }
    }
    let hasValue = !!cellValue;
    // noinspection SuspiciousTypeOfGuard
    let hasInfoValue = !!infoValue && typeof infoValue === "string";
    if (!hasValue && hasInfoValue) {
      cellValue = infoValue;
      infoValue = "";
      //hasValue = true;
      hasInfoValue = false;
    }
    const overflowX = !!cell.column.maxWidth;
    const overflowY = !!cell.column.maxHeight;
    const overflow = overflowX || overflowY;
    const inlineStyles = {
      textAlign: StylesUtility.textAlign(cell.column.textAlign)
    };
    let title = cell.title;
    if (overflow) {
      inlineStyles.textOverflow = "ellipsis";
      if (overflowX) {
        inlineStyles.overflowX = "hidden";
      }
      if (overflowY) {
        inlineStyles.overflowY = "hidden";
      }
      if (!title) {
        title = cellValue;
      }
    }
    let infoTitle = "";
    if (hasInfoValue) {
      infoTitle = settings.infoTitle || "";
      if (overflow) {
        if (!infoTitle) {
          infoTitle = infoValue;
        }
      }
    }
    const linkStyle = cell.route && styles$K.link || "";
    const infoLinkStyle = (cell.route || cell.infoRoute) && styles$K.link || "";
    const valueBoldStyle = hasInfoValue && settings.infoBoldNotEqual && infoValue != cellValue && styles$K.bold || "";
    const infoValueBold = hasInfoValue && settings.infoBold && styles$K.bold || "";
    return React.createElement(React.Fragment, null, hasInfoValue ? React.createElement("div", {
      className: styles$K.twoLines
    }, React.createElement("span", {
      className: this.css(linkStyle, valueBoldStyle),
      style: inlineStyles,
      title: this.toTitle(title),
      onClick: () => this.invokeCallback(cell)
    }, ReactUtility.toMultiLines(cellValue)), React.createElement("span", {
      style: inlineStyles,
      className: this.css(infoLinkStyle, infoValueBold),
      title: this.toTitle(infoTitle)
    }, ReactUtility.toMultiLines(infoValue))) : React.createElement("span", {
      className: this.css(infoLinkStyle),
      style: inlineStyles,
      title: this.toTitle(title),
      onClick: () => this.invokeCallback(cell)
    }, ReactUtility.toMultiLines(cellValue)));
  }
  renderTextCellContent(cell, settings, cellValue) {
    const noWrapStyle = cell.column.noWrap && styles$K.noWrap;
    return React.createElement("div", {
      className: this.css(styles$K.textContainer)
    }, React.createElement(TextInput, {
      clickToEdit: true,
      ref: this._inputRef,
      className: this.css(styles$K.textInput, noWrapStyle),
      value: cellValue || "",
      title: this.toTitle(cell.title),
      maxLength: settings.maxLength || undefined,
      onChange: (sender, value, userInteraction, done) => this.onTextCellChangeAsync(cell, value, userInteraction, done)
    }));
  }
  renderNumberCellContent(cell, settings, cellValue) {
    let hasInfo = !!settings.infoAccessor;
    let infoValue = hasInfo ? this.findValueByGridAccessor(cell.model, settings.infoAccessor) : null;
    const hideInfo = hasInfo && (settings.infoHideZero && !infoValue || settings.infoHideEqual && infoValue == cellValue);
    if (hideInfo) {
      hasInfo = false;
    }
    cellValue = settings.hideZero ? cellValue || 0 : cellValue;
    infoValue = settings.infoHideZero ? infoValue || 0 : infoValue;
    const hasInfoValue = infoValue != null;
    const hideZeroStyle = settings.hideZero && infoValue == 0 && cellValue == 0 && styles$K.hideZero || "";
    const numberInfoStyle = hasInfo && styles$K.numberInfo || "";
    const valueBoldStyle = hasInfoValue && settings.infoBoldNotEqual && infoValue != cellValue && styles$K.bold || "";
    const withArrowsStyle = settings.arrows && styles$K.withArrows || "";
    const min = typeof settings.min === "number" ? settings.min : null;
    const max = typeof settings.max === "number" ? settings.max : null;
    return React.createElement("div", {
      className: this.css(styles$K.numberContainer, numberInfoStyle)
    }, hasInfo && React.createElement("span", {
      className: this.css(hideZeroStyle),
      title: this.toTitle(settings.infoTitle)
    }, Utility.formatValue(infoValue || 0, cell.column.format)), React.createElement(NumberInput, {
      clickToEdit: true,
      ref: this._inputRef,
      title: this.toTitle(cell.title),
      hideArrows: !settings.arrows,
      className: this.css(styles$K.numberInput, hideZeroStyle, valueBoldStyle, withArrowsStyle),
      format: cell.column.format || undefined,
      min: min || undefined,
      max: max || undefined,
      step: settings.step || undefined,
      value: cellValue || 0,
      onChange: (sender, value, userInteraction, done) => this.onNumberCellChangeAsync(cell, value, userInteraction, done)
    }));
  }
  renderAddressCellContent(cell, settings, cellValue) {
    return React.createElement("div", {
      className: this.css(styles$K.textContainer)
    }, React.createElement(AddressInput, {
      clickToEdit: true,
      ref: this._inputRef,
      className: this.css(styles$K.addressInput),
      value: cellValue || "",
      locationPicker: settings.locationPicker,
      append: settings.locationPicker,
      onChange: location => this.onPlaceSelectedAsync(cell, location)
    }));
  }
  renderIconCellContent(cell, cellValue) {
    const icon = GridTransformer.toIcon(cellValue);
    const size = icon != null ? icon.size || IconSize.Large : undefined;
    const alignCenterStyle = cell.column.textAlign == TextAlign.Center && styles$K.center;
    return React.createElement("div", {
      className: this.css(alignCenterStyle),
      title: this.toTitle(cell.title),
      onClick: () => this.invokeCallback(cell)
    }, icon && React.createElement(Icon, Object.assign({}, icon, {
      size: size
    })));
  }
  renderBooleanCellContent(cell, cellValue) {
    const id = `grid_${cell.grid.id}_${cell.rowIndex}_${cell.columnIndex}_input`;
    return React.createElement("label", {
      htmlFor: id,
      title: GridLocalizer$1.get(cell.title)
    }, React.createElement("input", {
      type: "checkbox",
      id: id,
      checked: cellValue,
      onChange: e => this.onBooleanCellChangeAsync(cell, e.target.checked)
    }));
  }
  renderDateCellContent(cell, settings, cellValue) {
    let hasInfo = !!settings.infoAccessor;
    let infoValue = hasInfo ? this.findValueByGridAccessor(cell.model, settings.infoAccessor) : null;
    const hideInfo = hasInfo && (settings.infoHideZero && !infoValue || settings.infoHideEqual && Comparator.isEqual(infoValue, cellValue));
    if (hideInfo) {
      hasInfo = false;
    }
    if (Utility.isDateType(infoValue)) {
      infoValue = Utility.formatValue(infoValue, cell.column.format);
    }
    const minDate = typeof settings.min !== "number" ? settings.min : null;
    const maxDate = typeof settings.max !== "number" ? settings.max : null;
    const shortDate = cell.column.format === "d" || cell.column.format === "MM.yy" || cell.column.format === "dd.MM.yy";
    const shortDateStyle = shortDate && styles$K.shortDate || "";
    return React.createElement(React.Fragment, null, hasInfo && infoValue ? React.createElement("div", {
      className: styles$K.twoLines
    }, React.createElement(DateInput, {
      className: this.css(shortDateStyle),
      title: this.toTitle(cell.title),
      shortDate: shortDate,
      minDate: minDate,
      maxDate: maxDate,
      value: cellValue,
      onChange: date => this.onDateCellChangeAsync(cell, date)
    }), React.createElement("span", {
      title: this.toTitle(settings.infoTitle)
    }, infoValue)) : React.createElement(DateInput, {
      className: this.css(shortDateStyle),
      title: GridLocalizer$1.get(cell.title),
      shortDate: shortDate,
      minDate: minDate,
      maxDate: maxDate,
      value: cellValue,
      onChange: date => this.onDateCellChangeAsync(cell, date)
    }));
  }
  renderEnumCellContent(cell, cellValue, enumName) {
    const enumProvider = ServiceProvider.getRequiredService("IEnumProvider");
    return React.createElement(Dropdown, {
      required: true,
      noSubtext: true,
      noWrap: true,
      className: styles$K.dropdown,
      orderBy: DropdownOrderBy.None,
      verticalAlign: DropdownVerticalAlign.Auto,
      align: DropdownAlign.Left,
      noFilter: cell.column.settings.noFilter,
      items: enumProvider.getEnumItems(enumName),
      selectedItem: enumProvider.getEnumItem(enumName, cellValue),
      onChange: (sender, item, userInteraction) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onEnumCellChangeAsync(cell, item, userInteraction);
      })
    });
  }
  renderDropdownCellContent(cell) {
    return React.createElement(DropdownCell, {
      cell: cell
    });
  }
  renderAction(cell, action, cellAction, index) {
    if (action.render) {
      return action.render(cell, cellAction);
    }
    return React.createElement(CellActionComponent, {
      key: index,
      cell: cell,
      cellAction: cellAction
    });
  }
  renderActions(cell) {
    const cellActions = cell.actions;
    return React.createElement(React.Fragment, null, cellActions.length > 0 && React.createElement("div", {
      className: this.css(styles$K.actions)
    }, cellActions.map((cellAction, index) => this.renderAction(cell, cellAction.action, cellAction, index))));
  }
  get cellPaddingClassName() {
    const cellPadding = this.grid.cellPadding;
    switch (cellPadding) {
      case CellPaddingType.Small:
        return styles$K.paddingSmall;
      case CellPaddingType.Medium:
        return styles$K.paddingMedium;
      default:
        return styles$K.paddingLarge;
    }
  }
  get cell() {
    return this.props.cell;
  }
  get column() {
    return this.cell.column;
  }
  get grid() {
    return this.column.grid;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      this.props.cell.inputContentInstance = this._inputRef.current;
    });
  }
  render() {
    var _a;
    const cell = this.props.cell;
    const row = cell.row;
    const column = cell.column;
    const settings = column.settings;
    cell.instance = this;
    let cellContent = null;
    let cellValue = null;
    let cellStyle = "";
    let editable = cell.editable;
    const accessor = cell.accessor;
    if (accessor) {
      cellValue = typeof accessor === "string" ? accessor === "#" ? cell.row.position : Utility.findValueByAccessor(cell.model, accessor) : accessor(cell.model);
      cell.value = cellValue;
    }
    cell.route = null;
    if (column.route) {
      if (typeof column.route === "function") {
        const routeCallback = column.route;
        cell.route = routeCallback(cell);
      } else {
        cell.route = column.route;
      }
    }
    cell.infoRoute = null;
    if (column.settings.infoRoute) {
      if (typeof column.settings.infoRoute === "function") {
        const infoRouteCallback = column.settings.infoRoute;
        cell.infoRoute = infoRouteCallback(cell);
      } else {
        cell.infoRoute = column.settings.infoRoute;
      }
    }
    if (column.init) {
      column.init(cell);
    }
    const format = column.format;
    const readonly = cell.isReadonly;
    const deleted = cell.isDeleted;
    const visible = cell.visible;
    const type = cell.type;
    if (column.render) {
      cellContent = column.render(cell);
    } else if (accessor) {
      let rendered = false;
      if (type == ColumnType.Icon) {
        cellStyle = styles$K.defaultCell;
        cellContent = this.renderIconCellContent(cell, cellValue);
        rendered = true;
        editable = true;
      }
      if (!readonly && !deleted) {
        switch (type) {
          case ColumnType.Enum:
            if (!format) throw Error("Wrong grid declaration. Format property in column definition should contain enum type name for enum cell!");
            cellStyle = styles$K.enumCell;
            const enumName = format;
            cellContent = this.renderEnumCellContent(cell, cellValue, enumName);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Dropdown:
            cellStyle = styles$K.enumCell;
            cellContent = this.renderDropdownCellContent(cell);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Text:
            cellStyle = styles$K.textCell;
            cellContent = this.renderTextCellContent(cell, settings, cellValue);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Number:
            cellStyle = styles$K.numberCell;
            cellContent = this.renderNumberCellContent(cell, settings, cellValue);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Date:
            cellStyle = styles$K.dateCell;
            cellContent = this.renderDateCellContent(cell, settings, cellValue);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Boolean:
            cellStyle = styles$K.booleanCell;
            cellContent = this.renderBooleanCellContent(cell, cellValue);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Address:
            cellStyle = styles$K.textCell;
            cellContent = this.renderAddressCellContent(cell, settings, cellValue);
            rendered = true;
            editable = true;
            break;
        }
      }
      if (!rendered) {
        cellValue = settings.hideZero && !cellValue ? "" : column.transform ? column.transform(cell, cellValue, format) : Utility.formatValue(cellValue, format);
        cellContent = this.renderDefaultCellContent(cell, settings, cellValue);
        cellStyle = styles$K.defaultCell;
      }
    }
    const inlineStyles = {
      maxWidth: column.maxWidth || undefined,
      maxHeight: column.maxHeight || undefined
    };
    let noWrapClass = null;
    let wordBreakClass = null;
    if (column.noWrap) {
      inlineStyles.whiteSpace = "nowrap";
      noWrapClass = styles$K.noWrap;
    }
    if (column.wordBreak) {
      inlineStyles.wordBreak = "break-word";
      wordBreakClass = styles$K.wordBreak;
    }
    const rowSpan = cell.calcRowSpan();
    const colSpan = (_a = this.props.colSpan) !== null && _a !== void 0 ? _a : cell.columnSpan;
    const rowSpanStyle = rowSpan && styles$K.rowSpan;
    const noActionsStyle = !deleted && cell.actions.filter(action => action.visible).length === 0 && styles$K.noActions;
    const notValidStyle = editable && !readonly && !cell.valid && styles$K.notValid;
    const cellHoveringStyle = (cell.grid.hovering === GridHoveringType.Cell || cell.grid.hovering === GridHoveringType.EditableCell && editable && visible && !readonly && !deleted) && styles$K.cellHovering;
    const checkedStyle = row.checked && styles$K.checked;
    const selectedStyle = row.selected && styles$K.selected;
    const deletedStyle = deleted && styles$K.deleted;
    const deletedFirstCellStyle = deleted && (cell.isFirstColumn || !cell.prev.isDeleted || !cell.prev.equalRowSpan(cell)) && styles$K.firstColumn || "";
    const deletedLastCellStyle = deleted && (cell.isLastColumn || !cell.next.isDeleted || !cell.next.equalRowSpan(cell)) && styles$K.lastColumn || "";
    return !cell.spanned && React.createElement("td", {
      id: this.id,
      className: this.css(rowSpanStyle, column.className, cell.className, cellHoveringStyle, notValidStyle, deletedStyle, deletedFirstCellStyle, deletedLastCellStyle, this.cellPaddingClassName, noWrapClass, wordBreakClass, checkedStyle, selectedStyle),
      style: inlineStyles,
      rowSpan: rowSpan || undefined,
      colSpan: colSpan,
      onClick: () => {
        var _a, _b;
        return (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, cell);
      },
      onKeyDown: e => this.onKeyDownAsync(e)
    }, visible && React.createElement("div", {
      className: this.css(styles$K.cell, cellStyle, noActionsStyle, notValidStyle)
    }, cellContent || this.props.children, this.renderActions(cell)));
  }
}

class CheckHeaderCell extends BaseComponent {
  get model() {
    return this.props.model;
  }
  onCheckAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const model = this.model;
      const newChecked = model.checked === false;
      model.rows.forEach(row => {
        if (row.checkable) {
          row.checked = newChecked;
        }
      });
      model.checked = newChecked;
      yield model.reRenderAsync();
      if (model.onCheck) {
        yield model.onCheck(model);
      }
    });
  }
  render() {
    const model = this.model;
    model.checkHeaderInstance = this;
    const checked = model.checked !== false;
    const partiallyStyle = model.checked === undefined && styles$K.partially;
    const rowSpan = this.props.hasHeaderGroups ? 2 : undefined;
    const colSpan = this.props.colSpanLeft ? 2 : undefined;
    return React.createElement("th", {
      rowSpan: rowSpan,
      colSpan: colSpan,
      className: this.css(styles$K.th, styles$K.check, partiallyStyle),
      onClick: () => this.onCheckAsync()
    }, React.createElement("input", {
      type: "checkbox",
      checked: checked
    }));
  }
}

class HeaderCell extends BaseComponent {
  sortAsync(column) {
    return __awaiter(this, void 0, void 0, function* () {
      const grid = column.grid;
      grid.sortColumn = column;
      grid.sortDirection = grid.sortColumn == column ? grid.sortDirection == SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc : column.sorting == SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
      yield grid.reloadAsync();
    });
  }
  render() {
    var _a, _b;
    const column = this.props.column;
    const top = this.props.top;
    const grid = column.grid;
    const columnIndex = column.index;
    let render = true;
    let header;
    let rowSpan = undefined;
    let colSpan = undefined;
    let textAlign = column.textAlign || TextAlign.Left;
    let verticalAlign = VerticalAlign.Middle;
    if (column.group) {
      header = top ? column.group : column.header;
      if (top) {
        textAlign = TextAlign.Center;
        const prevColumn = column.prevVisibleColumn;
        if (prevColumn != null && prevColumn.group === column.group) {
          render = false;
        } else {
          colSpan = 0;
          for (let i = columnIndex; i < grid.columns.length; i++) {
            const nextColumn = grid.columns[i];
            if (nextColumn.group === column.group) {
              if (nextColumn.isVisible) {
                colSpan++;
              }
            } else {
              break;
            }
          }
        }
      }
    } else {
      textAlign = column.textAlign || textAlign;
      verticalAlign = column.verticalAlign || verticalAlign;
      if (top) {
        header = column.header;
        rowSpan = this.props.hasHeaderGroups ? 2 : undefined;
      } else {
        render = false;
      }
    }
    const stickyHeader = grid.stickyHeader;
    const groupHeaderCell = top && colSpan != null && colSpan > 1;
    const sortable = !groupHeaderCell && column.sortable;
    const sortDirection = sortable && grid.sortColumn == column ? grid.sortDirection : null;
    // to prevent sticky Header from going under top navbar.
    const navbarDefaultHeight = '45px';
    const topCssProperty = `calc(var(--app-navbar-height, ${navbarDefaultHeight}) + ${(((_b = (_a = this.props.tableHeadFirstRowRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0) * (this.props.tableHeadRowIndex || 0)}px)`;
    const minHeight = !top && !column.group && grid.headerMinHeight ? `${grid.headerMinHeight}px` : undefined;
    const inlineStyles = Object.assign({
      textAlign: StylesUtility.textAlign(textAlign),
      verticalAlign: StylesUtility.verticalAlign(verticalAlign),
      height: minHeight,
      minWidth: column.minWidth || undefined
    }, stickyHeader ? {
      top: topCssProperty
    } : {});
    if (column.stretch) {
      inlineStyles.width = "100%";
    }
    const rotateClassName = column.rotate && (!top || !column.group) ? styles$K.rotateHeader : "";
    const stickyHeaderClassName = stickyHeader ? styles$K.stickyHeader : "";
    const sortableClassName = sortable && styles$K.sortable;
    const sortDirectionClassName = sortDirection == SortDirection.Asc ? styles$K.asc : sortDirection == SortDirection.Desc ? styles$K.desc : "";
    const icon = column.type == ColumnType.Icon ? GridTransformer.toIcon(header, true) : null;
    if (render) {
      column.headerCellInstance = this;
    }
    if (this.props.colSpanLeft) {
      colSpan = (colSpan || 1) + 1;
    }
    return render && React.createElement("th", {
      id: this.id,
      style: inlineStyles,
      title: GridLocalizer$1.get(column.title),
      rowSpan: rowSpan || undefined,
      colSpan: colSpan || undefined,
      className: this.css(styles$K.th, sortableClassName, sortDirectionClassName, stickyHeaderClassName),
      onClick: () => sortable && this.sortAsync(column)
    }, React.createElement("div", {
      className: this.css(rotateClassName)
    }, icon ? React.createElement(Icon, Object.assign({}, icon, {
      size: IconSize.Large
    })) : React.createElement("span", null, this.toMultiLines(GridLocalizer$1.get(header)) || this.props.children)));
  }
}

class GridSpinner extends BaseComponent {
  hasSpinner() {
    return true;
  }
  render() {
    return React.createElement(React.Fragment, null, this.isSpinning() && React.createElement(Spinner, null));
  }
}

var css_248z$K = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-collapsed-row-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-collapsed-row-collapsedRow:hover {\n  background-color: inherit !important;\n}\n.athenaeum-collapsed-row-collapsedRow > td {\n  border: none !important;\n  padding: 0 !important;\n}\n.athenaeum-collapsed-row-collapsedRow > td table {\n  width: 100%;\n}\n.athenaeum-collapsed-row-collapsedRow > td table tr td:first-child {\n  width: auto;\n  text-align: left;\n  border-left: none;\n}\n.athenaeum-collapsed-row-collapsedRow > td table tr td:first-child > span {\n  display: inline-block;\n  width: 100%;\n}\n.athenaeum-collapsed-row-collapsedRow > td table tr td:last-child {\n  width: 100%;\n  border-right: none;\n}";
var styles$D = {"font-renta":"athenaeum-collapsed-row-font-renta","collapsedRow":"athenaeum-collapsed-row-collapsedRow"};
styleInject(css_248z$K);

class CollapsedRow extends BaseComponent {
  get grid() {
    return this.props.grid;
  }
  get row() {
    return this.props.row;
  }
  get cells() {
    return this.props.cells;
  }
  renderCell(cell) {
    const column = cell.column;
    const hasHeader = !!column.group || !!column.header;
    return React.createElement("tr", {
      key: cell.key
    }, hasHeader && React.createElement("td", null, column.group && React.createElement("span", null, this.toMultiLines(GridLocalizer$1.get(column.group))), column.header && React.createElement("span", null, this.toMultiLines(GridLocalizer$1.get(column.header)))), React.createElement(Cell, {
      key: cell.key,
      cell: cell,
      colSpan: hasHeader ? 1 : 2
    }));
  }
  render() {
    const grid = this.grid;
    const row = this.row;
    const cells = this.cells;
    const className = grid.responsiveRowClassName;
    const collapsedCells = grid.responsive ? row.cells.where(item => item.column.collapsed) : [];
    if (collapsedCells.length == 0 || !row.responsiveContainerExpanded) {
      return React.createElement(React.Fragment, null);
    }
    return React.createElement("tr", {
      className: this.css(styles$D.collapsedRow, className)
    }, React.createElement("td", {
      colSpan: cells.length + 1
    }, React.createElement("table", null, collapsedCells.map(cell => this.renderCell(cell)))));
  }
}

var css_248z$J = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-row-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-row-gridRow.athenaeum-row-data.athenaeum-row-darkSeparators td {\n  border-bottom-color: #7f8484;\n}\n.athenaeum-row-gridRow.athenaeum-row-data.athenaeum-row-darkSeparators:nth-last-child(2) td {\n  border-bottom-color: inherit;\n}\n.athenaeum-row-gridRow.athenaeum-row-data.athenaeum-row-odd:not(.athenaeum-row-rowSelected).athenaeum-row-rowHovering:not(:hover), .athenaeum-row-gridRow.athenaeum-row-data.athenaeum-row-odd:not(.athenaeum-row-rowSelected):not(.athenaeum-row-rowHovering) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.athenaeum-row-gridRow.athenaeum-row-data.athenaeum-row-rowSelected {\n  background-color: #337ab7 !important;\n  color: white;\n}\n.athenaeum-row-gridRow.athenaeum-row-data.athenaeum-row-rowSelected:hover {\n  background-color: rgba(51, 122, 183, 0.9) !important;\n}\n.athenaeum-row-gridRow.athenaeum-row-details {\n  display: none;\n  background-color: rgba(0, 0, 0, 0.02) !important;\n}\n.athenaeum-row-gridRow.athenaeum-row-details > td {\n  vertical-align: top;\n  position: relative;\n}\n.athenaeum-row-gridRow.athenaeum-row-details:hover {\n  background-color: rgba(0, 0, 0, 0.02) !important;\n}\n.athenaeum-row-gridRow.athenaeum-row-details.athenaeum-row-visible {\n  display: table-row;\n}\n.athenaeum-row-gridRow .athenaeum-row-responsive {\n  min-width: 40px;\n  max-width: 40px;\n  cursor: pointer;\n  text-align: center;\n  vertical-align: middle;\n}\n.athenaeum-row-gridRow .athenaeum-row-responsive .athenaeum-row-responsiveIcon {\n  color: #337ab7;\n}\n.athenaeum-row-gridRow .athenaeum-row-responsive .athenaeum-row-responsiveIcon.athenaeum-row-expanded {\n  color: #a94442;\n}\n.athenaeum-row-gridRow.athenaeum-row-heightLarge {\n  height: 52px;\n}\n.athenaeum-row-gridRow.athenaeum-row-heightMedium {\n  height: 42px;\n}\n.athenaeum-row-gridRow.athenaeum-row-heightSmall {\n  height: 32px;\n}";
var styles$C = {"font-renta":"athenaeum-row-font-renta","gridRow":"athenaeum-row-gridRow","data":"athenaeum-row-data","darkSeparators":"athenaeum-row-darkSeparators","odd":"athenaeum-row-odd","rowSelected":"athenaeum-row-rowSelected","rowHovering":"athenaeum-row-rowHovering","details":"athenaeum-row-details","visible":"athenaeum-row-visible","responsive":"athenaeum-row-responsive","responsiveIcon":"athenaeum-row-responsiveIcon","expanded":"athenaeum-row-expanded","heightLarge":"athenaeum-row-heightLarge","heightMedium":"athenaeum-row-heightMedium","heightSmall":"athenaeum-row-heightSmall"};
styleInject(css_248z$J);

class Row extends BaseComponent {
  onSelectAsync(cell) {
    return __awaiter(this, void 0, void 0, function* () {
      if (cell.isSelectable) {
        yield cell.row.selectAsync();
      }
    });
  }
  onCheckAsync() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.model.checkable) {
        this.model.checked = !this.model.checked;
        yield this.reRenderAsync();
        yield (_b = (_a = this.props).onCheck) === null || _b === void 0 ? void 0 : _b.call(_a, this.model);
      }
    });
  }
  onToggleAsync(row) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      row.responsiveContainerExpanded = !row.responsiveContainerExpanded;
      yield this.reRenderAsync();
      yield (_b = (_a = this.props).onToggle) === null || _b === void 0 ? void 0 : _b.call(_a, this.model);
    });
  }
  get grid() {
    return this.model.grid;
  }
  get model() {
    return this.props.row;
  }
  get isLoading() {
    return this.grid.instance.isLoading;
  }
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return !this.isLoading && this.isMounted;
  }
  render() {
    const grid = this.grid;
    const row = this.model;
    row.instance = this;
    const renderDetails = row.grid.renderDetails != null && (row.hasDetails || row.expanded);
    row.hasDetails = renderDetails;
    if (this.props.init) {
      this.props.init(row);
    }
    const oddStyle = grid.odd === GridOddType.Row && row.index % 2 === 0 && styles$C.odd;
    const rowHoveringStyle = grid.hovering === GridHoveringType.Row && styles$C.rowHovering;
    const rowSelectedStyle = row.selected && styles$C.rowSelected;
    const detailsVisibleStyle = row.expanded && styles$C.visible;
    const detailsColSpan = row.detailsColEnd - row.detailsColStart + 1;
    const checkRowSpan = row.expanded ? 2 : 1;
    const checkDisabledStyle = grid.checkable && !row.checkable && styles$K.disabled;
    const borderStyle = this.grid.borderType === BorderType.DarkSeparators && styles$C.darkSeparators;
    const cells = row.cells.where(item => item.column.isVisible);
    const collapsedCells = grid.responsive ? row.cells.where(item => item.column.collapsed && item.column.responsivePriority >= 0) : [];
    const responsive = collapsedCells.length > 0;
    const responsiveContainerExpanded = responsive && row.responsiveContainerExpanded;
    const responsiveIconName = responsiveContainerExpanded ? "fas minus-circle" : "fas plus-circle";
    const responsiveExpandedStyle = responsiveContainerExpanded && styles$C.expanded;
    return React.createElement(React.Fragment, null, React.createElement("tr", {
      className: this.css(styles$C.gridRow, rowHoveringStyle, rowSelectedStyle, styles$C.data, row.className, oddStyle, borderStyle)
    }, responsive && React.createElement("td", {
      className: this.css(styles$C.responsive),
      onClick: () => this.onToggleAsync(row)
    }, React.createElement(Icon, {
      className: this.css(styles$C.responsiveIcon, responsiveExpandedStyle),
      name: responsiveIconName,
      size: IconSize.Large
    })), grid.checkable && React.createElement("td", {
      className: this.css(styles$K.check, checkDisabledStyle),
      rowSpan: checkRowSpan,
      onClick: () => this.onCheckAsync()
    }, React.createElement("input", {
      id: `${row.id}_checkbox`,
      type: "checkbox",
      checked: row.checked,
      disabled: !this.model.checkable
    })), cells.map(cell => React.createElement(Cell, {
      key: cell.key,
      cell: cell,
      onClick: cell => this.onSelectAsync(cell)
    }))), React.createElement("tr", {
      className: this.css(styles$C.gridRow, styles$C.details, detailsVisibleStyle, oddStyle)
    }, React.createElement("td", {
      colSpan: detailsColSpan
    }, renderDetails && React.createElement(React.Fragment, null, row.grid.renderDetails(row)))), React.createElement(CollapsedRow, {
      grid: grid,
      row: row,
      cells: cells
    }));
  }
}

var css_248z$I = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-total-row-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-total-row-totalRow {\n  background-color: rgba(222, 226, 230, 0.7725490196) !important;\n}\n.athenaeum-total-row-totalRow td {\n  text-align: center;\n  color: #337ab7;\n  cursor: default;\n}";
var styles$B = {"font-renta":"athenaeum-total-row-font-renta","totalRow":"athenaeum-total-row-totalRow"};
styleInject(css_248z$I);

class TotalRow extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  get grid() {
    return this.props.grid;
  }
  render() {
    const grid = this.grid;
    const totals = [];
    for (let i = 0; i < grid.columns.length; i++) {
      const column = grid.columns[i];
      const total = column.total;
      let totalValue = null;
      if (total) {
        if (typeof total === "function") {
          const value = total(column);
          totalValue = typeof value === "number" ? Utility.format("{0:0.00}", value) : value;
        } else {
          const value = column.cells.sum(cell => cell.value);
          totalValue = typeof total === "string" ? Utility.formatValue(value, total) : Utility.format("{0:0.00}", value);
        }
      }
      totals.push(totalValue);
    }
    return React.createElement(React.Fragment, null, React.createElement("tr", {
      className: this.css(styles$B.totalRow)
    }, totals.map((value, index) => React.createElement("td", {
      key: index
    }, value != null && React.createElement("span", null, this.toMultiLines(value))))));
  }
}

var css_248z$H = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.page-link {\n  color: #337ab7;\n}\n\n@media screen and (max-width: 768px) {\n  .page-link:hover {\n    background-color: #ffffff !important;\n  }\n}";
styleInject(css_248z$H);

var css_248z$G = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-pagination-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-pagination-pagination .athenaeum-pagination-pageDropdownWrap {\n  min-width: 116px;\n}\n.athenaeum-pagination-pagination .athenaeum-pagination-pageDropdownWrap > div {\n  width: auto;\n}\n.athenaeum-pagination-pagination .athenaeum-pagination-total {\n  margin-left: 1rem;\n  width: 86px;\n  color: rgb(227, 227, 227);\n  cursor: default;\n  white-space: nowrap;\n}";
var styles$A = {"font-renta":"athenaeum-pagination-font-renta","pagination":"athenaeum-pagination-pagination","pageDropdownWrap":"athenaeum-pagination-pageDropdownWrap","total":"athenaeum-pagination-total"};
styleInject(css_248z$G);

class Pagination extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      pageSize: this.props.pageSize,
      pageNumber: this.props.pageNumber
    };
    this._dataPerPageVariants = null;
  }
  processAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, this.pageNumber, this.pageSize);
      }
    });
  }
  invokeOnBeforeChangeAsync(pageNumber, pageSize) {
    return __awaiter(this, void 0, void 0, function* () {
      let canChange = true;
      if (this.props.onBeforeChange) {
        canChange = yield this.props.onBeforeChange(this, pageNumber, pageSize);
      }
      return canChange;
    });
  }
  changePageNumberAsync(button) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!button.disabled) {
        const pageNumber = button.pageNumber;
        if (this.pageNumber != pageNumber) {
          const canChange = yield this.invokeOnBeforeChangeAsync(pageNumber, this.pageSize);
          if (canChange) {
            yield this.setState({
              pageNumber
            });
            yield this.processAsync();
          }
        }
      }
    });
  }
  onChangePageNumber(event, button) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      yield this.changePageNumberAsync(button);
    });
  }
  onChangePageSizeAsync(pageSize, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (userInteraction && this.pageSize != pageSize) {
        const canChange = yield this.invokeOnBeforeChangeAsync(this.pageNumber, pageSize);
        if (canChange) {
          const currentFirstRowIndex = (this.pageNumber - 1) * this.pageSize;
          const pageNumber = Math.trunc(currentFirstRowIndex / pageSize) + 1;
          yield this.setState({
            pageSize,
            pageNumber
          });
          yield this.processAsync();
        }
      }
    });
  }
  get prevButton() {
    const currentPageNumber = this.pageNumber;
    const prevPageNumber = currentPageNumber - 1;
    return {
      pageNumber: prevPageNumber,
      current: false,
      visible: true,
      disabled: prevPageNumber < this.firstPageNumber,
      label: "‹"
    };
  }
  get nextButton() {
    const currentPageNumber = this.pageNumber;
    const totalItemCount = this.totalItemCount;
    const pageSize = this.pageSize;
    const nextPageNumber = currentPageNumber + 1;
    const lastPageNumber = totalItemCount > 0 ? Math.ceil(totalItemCount / pageSize) : 1;
    return {
      pageNumber: nextPageNumber,
      current: false,
      visible: true,
      disabled: nextPageNumber > lastPageNumber,
      label: "›"
    };
  }
  get paginationButtons() {
    const isMobile = this.mobile;
    const firstPageNumber = this.firstPageNumber;
    const currentPageNumber = this.pageNumber;
    const totalItemCount = this.totalItemCount;
    const pageSize = this.pageSize;
    const prevPrevPrevPageNumber = currentPageNumber - 3;
    const prevPrevPageNumber = currentPageNumber - 2;
    const prevPageNumber = currentPageNumber - 1;
    const nextPageNumber = currentPageNumber + 1;
    const nextNextPageNumber = currentPageNumber + 2;
    const nextNextNextPageNumber = currentPageNumber + 3;
    const lastPageNumber = totalItemCount > 0 ? Math.ceil(totalItemCount / pageSize) : 1;
    let pages;
    if (isMobile) {
      const firstPageVisible = firstPageNumber <= prevPrevPageNumber;
      const prevPrevPrevPageVisible = prevPrevPrevPageNumber > 0 && prevPrevPrevPageNumber + 3 === lastPageNumber && prevPrevPrevPageNumber !== firstPageNumber;
      const prevPrevPageVisible = prevPrevPageNumber > 0 && prevPrevPageNumber + 2 === lastPageNumber && prevPrevPageNumber !== firstPageNumber || prevPrevPageNumber > 0 && nextPageNumber >= lastPageNumber && prevPrevPageNumber !== firstPageNumber;
      const lastPageVisible = lastPageNumber >= nextNextPageNumber;
      const nextNextNextPageVisible = nextNextNextPageNumber - 3 === firstPageNumber && lastPageNumber > 4;
      const nextNextPageVisible = lastPageNumber > 4 && (nextNextPageNumber - 2 === firstPageNumber || prevPageNumber === firstPageNumber);
      pages = [
      //We always want to show 5 numbers on mobile view. 
      //Examples, where [] marks the selected number. 
      //A: < [1], 2, 3, 4, 10 >
      //B: < 1, [2], 3, 4, 10 >
      //C: < 1, 2, [3], 4, 10 > 
      //D: < 1, 3, [4], 5, 10 >
      //E: < 1, 4, [5], 6, 10 >
      //F: < 1, [7], 8, 9, 10 >
      //G: < 1, 7, [8], 9, 10 >
      //H: < 1, 7, 8, [9], 10 >
      //I: < 1, 7, 8, 9, [10] >
      //Always show prev arrow. Disable if no previous page
      this.prevButton,
      //First page. Hide when currentPage is 3, since then line below will render "1"
      {
        pageNumber: firstPageNumber,
        current: false,
        visible: firstPageVisible,
        disabled: firstPageNumber === currentPageNumber,
        label: firstPageNumber.toString()
      },
      //Case I
      {
        pageNumber: prevPrevPrevPageNumber,
        current: false,
        visible: prevPrevPrevPageVisible,
        disabled: false,
        label: prevPrevPrevPageNumber.toString()
      },
      //Case H
      {
        pageNumber: prevPrevPageNumber,
        current: false,
        visible: prevPrevPageVisible,
        disabled: false,
        label: prevPrevPageNumber.toString()
      },
      //Always show next prev page number unless prev is last
      {
        pageNumber: prevPageNumber,
        current: false,
        visible: prevPageNumber >= firstPageNumber,
        disabled: false,
        label: prevPageNumber.toString()
      },
      //Always show currentPage
      {
        pageNumber: currentPageNumber,
        current: true,
        visible: true,
        disabled: true,
        label: currentPageNumber.toString()
      },
      //Always show next page number unless next is last
      {
        pageNumber: nextPageNumber,
        current: false,
        visible: nextPageNumber <= lastPageNumber,
        disabled: false,
        label: nextPageNumber.toString()
      },
      //Case B
      {
        pageNumber: nextNextPageNumber,
        current: false,
        visible: nextNextPageVisible,
        disabled: false,
        label: nextNextPageNumber.toString()
      },
      //Case A
      {
        pageNumber: nextNextNextPageNumber,
        current: false,
        visible: nextNextNextPageVisible,
        disabled: false,
        label: nextNextNextPageNumber.toString()
      }, {
        pageNumber: lastPageNumber,
        current: false,
        visible: lastPageVisible,
        disabled: lastPageNumber === currentPageNumber,
        label: lastPageNumber.toString()
      }, this.nextButton];
    } else {
      pages = [this.prevButton, {
        pageNumber: firstPageNumber,
        current: false,
        visible: firstPageNumber < prevPrevPageNumber,
        disabled: firstPageNumber === currentPageNumber,
        label: firstPageNumber.toString()
      }, {
        pageNumber: prevPrevPageNumber,
        current: false,
        visible: prevPageNumber - firstPageNumber > 2,
        disabled: true,
        label: "..."
      }, {
        pageNumber: prevPrevPageNumber,
        current: false,
        visible: prevPrevPageNumber >= firstPageNumber,
        disabled: false,
        label: prevPrevPageNumber.toString()
      }, {
        pageNumber: prevPageNumber,
        current: false,
        visible: prevPageNumber >= firstPageNumber,
        disabled: false,
        label: prevPageNumber.toString()
      }, {
        pageNumber: currentPageNumber,
        current: true,
        visible: true,
        disabled: true,
        label: currentPageNumber.toString()
      }, {
        pageNumber: nextPageNumber,
        current: false,
        visible: nextPageNumber <= lastPageNumber,
        disabled: false,
        label: nextPageNumber.toString()
      }, {
        pageNumber: nextNextPageNumber,
        current: false,
        visible: nextNextPageNumber <= lastPageNumber,
        disabled: false,
        label: nextNextPageNumber.toString()
      }, {
        pageNumber: nextNextPageNumber,
        current: false,
        visible: lastPageNumber - nextPageNumber > 2,
        disabled: true,
        label: "..."
      }, {
        pageNumber: lastPageNumber,
        current: false,
        visible: lastPageNumber > nextNextPageNumber,
        disabled: lastPageNumber === currentPageNumber,
        label: lastPageNumber.toString()
      }, this.nextButton];
    }
    return pages;
  }
  get dataPerPageVariants() {
    if (this._dataPerPageVariants == null) {
      const variants = this.props.dataPerPageVariants || [10, 25, 50, 100];
      if (!variants.includes(this.pageSize)) {
        variants.push(this.pageSize);
        variants.sort((x, y) => x - y);
      }
      this._dataPerPageVariants = variants;
    }
    return this._dataPerPageVariants;
  }
  get classNames() {
    return this.props.classNames || {};
  }
  get firstPageNumber() {
    return 1;
  }
  get pageNumber() {
    return this.state.pageNumber;
  }
  get pageSize() {
    return this.state.pageSize;
  }
  get itemCount() {
    return this.props.itemCount;
  }
  get totalItemCount() {
    return this.props.totalItemCount;
  }
  get canPrev() {
    return !this.prevButton.disabled;
  }
  get canNext() {
    return !this.nextButton.disabled;
  }
  prevAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.changePageNumberAsync(this.prevButton);
    });
  }
  nextAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.changePageNumberAsync(this.nextButton);
    });
  }
  renderPaginationButton(button, index) {
    const activeStyle = button.current && this.css("active", this.classNames.buttonActive);
    const disabledStyle = button.disabled && this.css("disabled", this.classNames.buttonDisabled);
    return button.visible && React.createElement("li", {
      key: index,
      className: this.css("page-item", this.classNames.pageItem, activeStyle, disabledStyle)
    }, React.createElement("a", {
      href: "#",
      className: this.css("page-link shadow-none", this.classNames.pageLink),
      onClick: e => this.onChangePageNumber(e, button)
    }, button.label));
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      const newPageNumber = nextProps.pageNumber != this.pageNumber;
      const newPageSize = nextProps.pageSize != this.pageSize;
      const newDataPerPageVariants = nextProps.dataPerPageVariants != this.dataPerPageVariants;
      const newProps = newPageNumber || newPageSize || newDataPerPageVariants;
      if (newProps) {
        if (newDataPerPageVariants) {
          this._dataPerPageVariants = null;
        }
        yield this.setState({
          pageNumber: nextProps.pageNumber,
          pageSize: nextProps.pageSize
        });
      }
    });
  }
  render() {
    return React.createElement("nav", {
      id: this.id,
      className: this.css(styles$A.pagination, "d-flex align-items-center", this.props.className)
    }, React.createElement("ul", {
      className: this.css("pagination mb-0", this.classNames.pagination)
    }, this.paginationButtons.map((button, index) => this.renderPaginationButton(button, index))), React.createElement("div", {
      className: this.css(styles$A.pageDropdownWrap, "ml-3 d-flex align-items-center justify-content-between", this.classNames.pageDropdownWrap)
    }, React.createElement(Dropdown, {
      inline: true,
      small: true,
      required: true,
      noFilter: true,
      items: this.dataPerPageVariants,
      selectedItem: this.props.pageSize,
      orderBy: DropdownOrderBy.None,
      onChange: (sender, item, userInteraction) => this.onChangePageSizeAsync(item, userInteraction)
    }), this.totalItemCount > 0 && React.createElement("span", {
      className: this.css(styles$A.total, this.classNames.total)
    }, this.itemCount, " / ", this.totalItemCount)));
  }
}

class Grid extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isLoading: false,
      data: null
    };
    //  stickyHeader prop functionality related. (to get height of first row of tr in thead for setting "top" of second row of th in thead in stick mode)
    this._tableHeadFirstRowRef = React.createRef();
    this._spinnerRef = React.createRef();
    this._paginationRef = React.createRef();
    this._overflowData = null;
    this._language = GridLocalizer$1.language;
    this._columnsVisibilityHashCode = -1;
    this._delayedReload = false;
    this._grid = null;
    this._gridInstance = null;
    this._rows = null;
  }
  getColumnVisibilityHasCode(columns) {
    const data = columns.map((item, index) => ({
      visible: item.isVisible,
      index
    }));
    return Utility.getHashCode(data);
  }
  paginateAsync(pageNumber, pageSize) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.pageNumber != pageNumber || this.pageSize != pageSize) {
        this.model.pageNumber = pageNumber;
        this.model.pageSize = pageSize;
        yield this.reloadAsync();
        yield this.invokePaginationAsync(pageNumber, pageSize);
      }
    });
  }
  onBeforePaginationAsync(pageNumber, pageSize) {
    return __awaiter(this, void 0, void 0, function* () {
      let canChange = true;
      if (this.props.onBeforePagination) {
        canChange = yield this.props.onBeforePagination(this.model, pageNumber, pageSize);
      }
      return canChange;
    });
  }
  invokePaginationAsync(pageNumber, pageSize) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onPagination) {
        yield this.props.onPagination(this.model, pageNumber, pageSize);
      }
    });
  }
  invokeProcessDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onProcessData) {
        const model = this.model;
        const data = model.data;
        yield this.props.onProcessData(model, data);
      }
    });
  }
  setDataAsync(data) {
    return __awaiter(this, void 0, void 0, function* () {
      const state = this.state;
      yield this.processDataAsync(state, data);
      if (this.isMounted) {
        yield this.setState(state);
      }
    });
  }
  buildModelAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const data = this.model.data;
      this._language = GridLocalizer$1.language;
      this._grid = null;
      this._rows = null;
      yield this.setDataAsync(data);
    });
  }
  onCheckRowAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const count = this.rows.length;
      const selected = Utility.count(this.rows, row => row.checked);
      const newChecked = selected == 0 ? false : selected === count ? true : undefined;
      if (newChecked !== this.model.checked) {
        this.model.checked = newChecked;
        yield this.model.checkHeaderInstance.reRenderAsync();
      }
      if (this.model.onCheck) {
        yield this.model.onCheck(this.model);
      }
    });
  }
  width() {
    const gridNode = this.getNode();
    const width = gridNode.width();
    return width != null ? width + 1 : 0;
  }
  getOverflowData() {
    const gridContainerWidth = Math.round(this.containerWidth());
    const gridWidth = Math.round(this.model.fullWidth());
    const gridFullWidth = Math.round(this.model.fullWidth(false));
    return {
      containerWidth: gridContainerWidth,
      gridWidth: gridWidth,
      gridFullWidth: gridFullWidth
    };
  }
  invokeReloadAsync() {
    const _super = Object.create(null, {
      reloadAsync: {
        get: () => super.reloadAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.columnVisibilityChanged) {
        const data = this.props.data || [];
        yield this.setDataAsync(data);
      }
      yield _super.reloadAsync.call(this);
      yield this.processResponsiveAsync();
    });
  }
  processResponsiveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.model.responsive) {
        const overflowData = this.getOverflowData();
        let columns = this.model.columns;
        const needToHide = overflowData.containerWidth < overflowData.gridWidth;
        if (needToHide) {
          let widthToCompensate = overflowData.gridWidth - overflowData.containerWidth;
          const gridCollapsed = this.model.columns.some(row => row.collapsed);
          if (gridCollapsed) {
            // Expand/Collapse TD width (hardcoded in styles)
            widthToCompensate -= 40;
          }
          while (true) {
            columns = columns.where(column => column.isVisible);
            if (columns.length <= 1) {
              return;
            }
            columns.sortBy(column => column.responsivePriority);
            const lastColumn = columns[columns.length - 1];
            const columnWidth = lastColumn.outerWidth();
            widthToCompensate -= columnWidth;
            lastColumn.collapsed = true;
            if (widthToCompensate <= 0) {
              break;
            }
          }
          this._overflowData = overflowData;
          yield this.reRenderAsync();
          return;
        }
        const lastContainerWidth = this._overflowData ? this._overflowData.containerWidth : overflowData.containerWidth;
        const needToShow = lastContainerWidth < overflowData.containerWidth && columns.some(column => column.collapsed);
        if (needToShow) {
          columns.map(column => column.collapsed = false);
          yield this.reRenderAsync();
          this._overflowData = overflowData;
          yield this.processResponsiveAsync();
          return;
        }
      }
    });
  }
  sort(items, sortColumn, sortDirection) {
    if (sortColumn && sortColumn.accessor && items && sortDirection != null) {
      const accessor = sortColumn.accessor;
      const getter = model => typeof accessor === "string" ? Utility.findValueByAccessor(model, accessor) : accessor(model);
      items = items.sort((x, y) => {
        const xValue = getter(x);
        const yValue = getter(y);
        return xValue == yValue ? 0 : xValue > yValue ? sortDirection == SortDirection.Desc ? -1 : 1 : sortDirection == SortDirection.Desc ? 1 : -1;
      });
    }
    return items;
  }
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      const model = this.model;
      let items = [];
      let totalItemCount = 0;
      let pageNumber = model.pageNumber;
      const sortColumn = model.sortColumn;
      const sortDirection = model.sortDirection;
      if (data) {
        let pagedData = data;
        if (pagedData.items) {
          items = pagedData.items;
          totalItemCount = pagedData.totalItemCount;
          pageNumber = pagedData.pageNumber;
        } else {
          items = data;
          items = this.sort(items, sortColumn, sortDirection);
          if (model.pagination) {
            pagedData = Utility.toPagedList(items, model.pageNumber, model.pageSize);
            items = pagedData.items;
            totalItemCount = pagedData.totalItemCount;
            pageNumber = pagedData.pageNumber;
          } else {
            pageNumber = 1;
            totalItemCount = items.length;
          }
        }
      }
      model.data = items;
      model.checked = false;
      model.pageNumber = pageNumber;
      model.totalItemCount = totalItemCount;
      model.sortColumn = sortColumn;
      model.sortDirection = sortDirection;
      model.generation++;
      this._rows = null;
      yield this.invokeProcessDataAsync();
    });
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchData) {
        const model = this.model;
        const pageNumber = model.pageNumber;
        const pageSize = model.pageSize;
        const sortColumn = model.sortColumn;
        const sortColumnName = sortColumn != null ? sortColumn.name ? sortColumn.name : sortColumn.accessor && typeof sortColumn.accessor === "string" ? sortColumn.accessor : sortColumn.index.toString() : null;
        const sortDirection = sortColumnName ? model.sortDirection || SortDirection.Asc : null;
        return yield this.props.fetchData(this, pageNumber, pageSize, sortColumnName, sortDirection);
      }
      return [];
    });
  }
  getEndpoint() {
    return "";
  }
  isAsync() {
    return this.props.fetchData != null;
  }
  isEmpty() {
    return this._rows == null || this._rows.length == 0;
  }
  hasSpinner() {
    return true;
  }
  getNode() {
    return this.JQuery(`#table_${this.id}`);
  }
  containerWidth() {
    const gridNode = this.getNode();
    const parentNode = gridNode.parent();
    return parentNode.innerWidth() || gridNode.outerWidth() || 0;
  }
  setSpinnerAsync(isSpinning) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._spinnerRef.current) {
        yield this._spinnerRef.current.setSpinnerAsync(isSpinning);
      }
    });
  }
  reloadAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isLoading) {
        this._delayedReload = true;
        return;
      }
      yield this.invokeReloadAsync();
      if (this._delayedReload) {
        this._delayedReload = false;
        yield this.reloadAsync();
      }
    });
  }
  get columnVisibilityChanged() {
    const isEmpty = this._rows == null || this._rows.length == 0;
    const previousVisibilityHashCode = this._columnsVisibilityHashCode;
    this._columnsVisibilityHashCode = this.getColumnVisibilityHasCode(this.model.columns);
    return !isEmpty && previousVisibilityHashCode != -1 && previousVisibilityHashCode != this._columnsVisibilityHashCode;
  }
  get columns() {
    return this.model.columns;
  }
  get rows() {
    return this._rows || (this._rows = this.model.rows = GridTransformer.toRows(this.model, this.model.data || []));
  }
  get model() {
    return this._grid || (this._grid = GridTransformer.toGrid(this.props, this.id, this._gridInstance));
  }
  get pageNumber() {
    return this.model.pageNumber;
  }
  get pageSize() {
    return this.model.pageSize;
  }
  get itemCount() {
    return this.model.items.length;
  }
  get totalItemCount() {
    return this.model.totalItemCount;
  }
  get colSpan() {
    return this.model.checkable ? this.model.columns.length + 1 : this.model.columns.length;
  }
  prevPageAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      yield (_a = this._paginationRef.current) === null || _a === void 0 ? void 0 : _a.prevAsync();
    });
  }
  nextPageAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      yield (_a = this._paginationRef.current) === null || _a === void 0 ? void 0 : _a.nextAsync();
    });
  }
  get canPrevPage() {
    return this._paginationRef.current != null && this._paginationRef.current.canPrev;
  }
  get canNextPage() {
    return this._paginationRef.current != null && this._paginationRef.current.canNext;
  }
  get classNames() {
    return this.props.classNames || {};
  }
  clearAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setDataAsync([]);
    });
  }
  onGlobalResize(e) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.processResponsiveAsync();
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      if (this.props.data != null) {
        yield this.setDataAsync(this.props.data);
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newData = !Comparator.isEqual(this.props.data, nextProps.data);
      if (newData) {
        const data = nextProps.data || [];
        yield this.setDataAsync(data);
      }
      const newReadonly = this.props.readonly !== nextProps.readonly;
      const newResponsive = this.props.responsive !== nextProps.responsive;
      const newLanguage = this._language !== GridLocalizer$1.language;
      const newCheckable = this.props.checkable !== nextProps.checkable;
      const newSelectable = this.props.selectable !== nextProps.selectable;
      const newNoHeader = this.props.noHeader !== nextProps.noHeader;
      const newBorderType = this.props.borderType !== nextProps.borderType;
      const newPagination = !Comparator.isEqual(this.props.pagination, nextProps.pagination, true);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newReadonly || newLanguage || newResponsive || newCheckable || newSelectable || newNoHeader || newBorderType || newPagination) {
        yield this.buildModelAsync();
      }
      yield this.processResponsiveAsync();
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      yield this.processResponsiveAsync();
      //await this.processResponsiveAsync();
    });
  }
  renderHeader(column, hasHeaderGroups, top, colSpanLeft, tableHeadRowIndex) {
    return React.createElement(HeaderCell, {
      key: `grid_header_${column.index}_${top}`,
      column: column,
      hasHeaderGroups: hasHeaderGroups,
      top: top,
      colSpanLeft: colSpanLeft,
      tableHeadFirstRowRef: this._tableHeadFirstRowRef,
      tableHeadRowIndex: tableHeadRowIndex
    });
  }
  renderDataRow(row) {
    return React.createElement(Row, {
      key: row.key,
      row: row,
      init: this.props.initRow,
      onCheck: () => this.onCheckRowAsync(),
      onToggle: row => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        return yield (_b = (_a = this.props).onRowToggle) === null || _b === void 0 ? void 0 : _b.call(_a, row);
      })
    });
  }
  renderEmptyRow() {
    return React.createElement("tr", {
      className: styles$K.emptyRow
    }, React.createElement("td", {
      colSpan: this.colSpan
    }, GridLocalizer$1.get(this.model.noDataText)));
  }
  render() {
    this._gridInstance = this;
    this.model.instance = this;
    const model = this.model;
    const rows = this.rows;
    const visible = this.hasData || !model.noDataNoHeader;
    const outerSpinner = model.noDataNoHeader;
    const rowHoveringStyle = model.hovering === GridHoveringType.Row ? "table-hover" : styles$K.noRowHovering;
    const noHeaderStyleStyle = model.noHeader && styles$K.noHeader;
    const inlineStyles = {};
    if (model.minWidth) {
      inlineStyles.minWidth = model.minWidth;
    }
    const columns = model.columns.where(item => item.isVisible);
    const collapsedColumns = model.responsive ? model.columns.where(item => item.collapsed) : [];
    const responsive = collapsedColumns.length > 0;
    const hasHeaderGroups = visible && columns.some(column => !!column.group);
    const pagination = model.pagination && typeof model.pagination === "object" ? model.pagination : {};
    return React.createElement(React.Fragment, null, visible && React.createElement(React.Fragment, null, React.createElement("table", {
      id: "table_" + this.id,
      key: model.key,
      style: inlineStyles,
      className: this.css(styles$K.grid, "table table-bordered", rowHoveringStyle, this.props.className)
    }, columns.length > 0 && React.createElement(React.Fragment, null, React.createElement("thead", {
      className: this.css(noHeaderStyleStyle)
    }, React.createElement("tr", {
      ref: this._tableHeadFirstRowRef
    }, model.checkable && React.createElement(CheckHeaderCell, {
      model: model,
      hasHeaderGroups: hasHeaderGroups,
      colSpanLeft: responsive
    }), columns.map((column, index) => this.renderHeader(column, hasHeaderGroups, true, responsive && index == 0, 0))), hasHeaderGroups && React.createElement("tr", null, columns.map((column, index) => this.renderHeader(column, hasHeaderGroups, false, responsive && index == 0, 1)))), React.createElement("tbody", null, model.noDataText && rows.length === 0 ? this.renderEmptyRow() : rows.map((item, rowIndex) => this.renderDataRow(rows[rowIndex])), rows.length > 0 && model.total && React.createElement(TotalRow, {
      grid: model
    }))), !outerSpinner && React.createElement("tbody", {
      className: styles$K.spinner
    }, React.createElement("tr", null, React.createElement("td", {
      colSpan: this.colSpan
    }, React.createElement(GridSpinner, {
      ref: this._spinnerRef
    }))))), model.pagination && React.createElement(Pagination, {
      ref: this._paginationRef,
      className: this.css(styles$K.pagination, pagination.className),
      classNames: this.classNames.pagination,
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      itemCount: this.itemCount,
      totalItemCount: this.totalItemCount,
      dataPerPageVariants: pagination.dataPerPageVariants,
      onBeforeChange: (_, pageNumber, pageSize) => this.onBeforePaginationAsync(pageNumber, pageSize),
      onChange: (_, pageNumber, pageSize) => this.paginateAsync(pageNumber, pageSize)
    })), outerSpinner && React.createElement(GridSpinner, {
      ref: this._spinnerRef
    }));
  }
}

var css_248z$F = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-skeleton-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-skeleton-skeleton {\n  display: flex;\n}\n@keyframes athenaeum-skeleton-wave {\n  0% {\n    background-position: -400px 0;\n  }\n  100% {\n    background-position: 400px 0;\n  }\n}\n.athenaeum-skeleton-skeleton .athenaeum-skeleton-skeletonItem {\n  display: flex;\n  border-radius: 2px;\n  background: rgba(130, 130, 130, 0.2);\n  background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);\n  background-size: 100% 100%;\n  animation: athenaeum-skeleton-wave 10s infinite ease-out;\n}";
var styles$z = {"font-renta":"athenaeum-skeleton-font-renta","skeleton":"athenaeum-skeleton-skeleton","skeletonItem":"athenaeum-skeleton-skeletonItem","wave":"athenaeum-skeleton-wave"};
styleInject(css_248z$F);

var css_248z$E = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-skeleton-rectangle-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-skeleton-rectangle-skeletonRectangle {\n  height: 80px;\n  width: 160px;\n}";
var styles$y = {"font-renta":"athenaeum-skeleton-rectangle-font-renta","skeletonRectangle":"athenaeum-skeleton-rectangle-skeletonRectangle"};
styleInject(css_248z$E);

class SkeletonRectangle extends BaseComponent {
  render() {
    const inlineStyles = {
      width: this.props.width,
      height: this.props.height
    };
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$z.skeletonItem, styles$y.skeletonRectangle, this.props.className),
      style: inlineStyles
    });
  }
}

var css_248z$D = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-skeleton-square-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-skeleton-square-skeletonSquare {\n  height: 80px;\n  width: 80px;\n}";
var styles$x = {"font-renta":"athenaeum-skeleton-square-font-renta","skeletonSquare":"athenaeum-skeleton-square-skeletonSquare"};
styleInject(css_248z$D);

class SkeletonSquare extends BaseComponent {
  render() {
    const inlineStyles = {
      width: this.props.size,
      height: this.props.size
    };
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$z.skeletonItem, styles$x.skeletonSquare, this.props.className),
      style: inlineStyles
    });
  }
}

var css_248z$C = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-skeleton-circle-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-skeleton-circle-skeletonCircle {\n  border-radius: 50% !important;\n  height: 80px;\n  width: 80px;\n}";
var styles$w = {"font-renta":"athenaeum-skeleton-circle-font-renta","skeletonCircle":"athenaeum-skeleton-circle-skeletonCircle"};
styleInject(css_248z$C);

class SkeletonCircle extends BaseComponent {
  render() {
    const inlineStyles = {
      width: this.props.size,
      height: this.props.size
    };
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$z.skeletonItem, styles$w.skeletonCircle, this.props.className),
      style: inlineStyles
    });
  }
}

class Skeleton extends BaseComponent {
  static get Rectangle() {
    return SkeletonRectangle;
  }
  static get Square() {
    return SkeletonSquare;
  }
  static get Circle() {
    return SkeletonCircle;
  }
  render() {
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$z.skeleton, this.props.className)
    }, this.children);
  }
}

var css_248z$B = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-layout-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-layout-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-layout-page {\n  padding: 15px 8px;\n  height: 100%;\n}\n.athenaeum-layout-page[data-haswideheader=true] {\n  padding: 0 0 15px 0;\n}\n.athenaeum-layout-page .athenaeum-layout-container {\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 6px;\n}\n.athenaeum-layout-page .athenaeum-layout-container.athenaeum-layout-fullHeight {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-layout-page .athenaeum-layout-container.athenaeum-layout-fullWidth {\n  max-width: unset !important;\n  min-width: 100% !important;\n}\n.athenaeum-layout-page.athenaeum-layout-scale {\n  padding: 0;\n}\n.athenaeum-layout-page.athenaeum-layout-scale .athenaeum-layout-container {\n  max-width: unset !important;\n  min-width: 100% !important;\n  height: 100%;\n  border-radius: 0;\n  padding-bottom: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.athenaeum-layout-page.athenaeum-layout-scale .athenaeum-layout-container > div {\n  margin-top: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.athenaeum-layout-page .athenaeum-layout-row {\n  flex-grow: 2;\n  margin: 15px 15px 25px;\n}\n.athenaeum-layout-page .athenaeum-layout-row:last-of-type {\n  margin-bottom: 15px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-layout-page .athenaeum-layout-row {\n    margin: 0 -15px 15px !important;\n  }\n  .athenaeum-layout-page .athenaeum-layout-row:last-of-type {\n    margin-bottom: 0 !important;\n  }\n}\n.athenaeum-layout-page .athenaeum-layout-pageRow {\n  margin-bottom: 0;\n  flex-grow: 0;\n}\n.athenaeum-layout-page .athenaeum-layout-pageRow.athenaeum-layout-alertRow {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.athenaeum-layout-page .athenaeum-layout-header {\n  flex-grow: 0;\n  margin-bottom: 16px;\n  padding: 0 15px;\n  overflow: unset;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=false] {\n  padding: 0 15px;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=true] {\n  background-position: center;\n  background-size: cover;\n  color: white;\n  margin: 0;\n  max-height: 25vh;\n  min-height: 10vh;\n  height: 225px;\n  margin-bottom: 1rem;\n  display: flex;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=true] .athenaeum-layout-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=true] .athenaeum-layout-content h1 {\n  font-size: clamp(1.2rem, 5vw, 2rem);\n  font-weight: bold;\n  text-align: center;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=true] .athenaeum-layout-content h2 {\n  font-size: 24px;\n}\n.athenaeum-layout-page .athenaeum-layout-header .athenaeum-layout-content {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.athenaeum-layout-page .athenaeum-layout-header .athenaeum-layout-content h4 {\n  font-size: 18px;\n}\n.athenaeum-layout-page .athenaeum-layout-header .athenaeum-layout-content p {\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Arial, sans-serif;\n  margin-bottom: 8px;\n}\n.athenaeum-layout-page .athenaeum-layout-header .athenaeum-layout-content.athenaeum-layout-noMargin {\n  margin-bottom: 0;\n}\n.athenaeum-layout-page .athenaeum-layout-header hr {\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  margin: 8px 0 0 0;\n  width: 100%;\n}\n\n.athenaeum-layout-layout {\n  display: flex;\n  flex-direction: column;\n  height: inherit;\n}\n.athenaeum-layout-layout.athenaeum-layout-hasTopNav {\n  visibility: visible;\n}\n.athenaeum-layout-layout.athenaeum-layout-hasFooter {\n  visibility: visible;\n}\n.athenaeum-layout-layout.athenaeum-layout-hasLeftNav {\n  visibility: visible;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-layout-layout {\n    overflow-x: hidden;\n  }\n}\n.athenaeum-layout-layout .athenaeum-layout-main {\n  background-color: inherit;\n  flex-grow: 2;\n  flex-basis: 0;\n}\n.athenaeum-layout-layout .athenaeum-layout-main.athenaeum-layout-topNav {\n  margin-top: 45px;\n}\n.athenaeum-layout-layout .athenaeum-layout-main.athenaeum-layout-leftNav {\n  display: flex;\n  position: relative;\n}\n.athenaeum-layout-layout .athenaeum-layout-main.athenaeum-layout-leftNav > div {\n  flex-grow: 2;\n}\n.athenaeum-layout-layout .athenaeum-layout-main .athenaeum-layout-leftNav {\n  z-index: 1000;\n}\n.athenaeum-layout-layout .athenaeum-layout-swipeRight {\n  margin-left: 99%;\n  margin-right: -99%;\n  transition: all 0.2s ease-out;\n}\n.athenaeum-layout-layout .athenaeum-layout-swipeLeft {\n  margin-right: 99%;\n  margin-left: -99%;\n  transition: all 0.2s ease-out;\n}";
var styles$v = {"font-renta":"athenaeum-layout-font-renta","page":"athenaeum-layout-page","container":"athenaeum-layout-container","fullHeight":"athenaeum-layout-fullHeight","fullWidth":"athenaeum-layout-fullWidth","scale":"athenaeum-layout-scale","row":"athenaeum-layout-row","pageRow":"athenaeum-layout-pageRow","alertRow":"athenaeum-layout-alertRow","header":"athenaeum-layout-header","content":"athenaeum-layout-content","noMargin":"athenaeum-layout-noMargin","layout":"athenaeum-layout-layout","hasTopNav":"athenaeum-layout-hasTopNav","hasFooter":"athenaeum-layout-hasFooter","hasLeftNav":"athenaeum-layout-hasLeftNav","main":"athenaeum-layout-main","topNav":"athenaeum-layout-topNav","leftNav":"athenaeum-layout-leftNav","swipeRight":"athenaeum-layout-swipeRight","swipeLeft":"athenaeum-layout-swipeLeft"};
styleInject(css_248z$B);

class OneColumn extends BaseComponent {
  renderRow(index, item) {
    return React.createElement("div", {
      key: index,
      className: this.css(styles$v.row, "row")
    }, React.createElement("div", {
      className: "col-md-12"
    }, item));
  }
  render() {
    const children = this.props.children ? this.children : [];
    return React.createElement("div", {
      id: this.id,
      className: this.css(this.props.className)
    }, children.length > 0 && children.map((item, index) => this.renderRow(index, item)));
  }
}

class TwoColumns extends BaseComponent {
  get leftClassName() {
    return this.props.leftClassName || "col-md-6";
  }
  get rightClassName() {
    return this.props.rightClassName || "col-md-6";
  }
  renderRow(left, right) {
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$v.row, this.props.className, "row")
    }, React.createElement("div", {
      className: this.leftClassName
    }, left), React.createElement("div", {
      className: this.rightClassName
    }, right));
  }
  render() {
    const children = this.props.children ? this.children : [];
    return React.createElement(React.Fragment, null, children.length > 0 && this.renderRow(children[0], children[1]));
  }
}

//Autogenerated
class AddressDividerLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.addressLanguageItemName = `_7:0`;
    this.streetLanguageItemName = `_7:1`;
    this.cityLanguageItemName = `_7:2`;
    this.postalCodeLanguageItemName = `_7:3`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_7:0`, {
      l: `en`,
      v: `Address`
    }, {
      l: `uk`,
      v: `Адреса`
    }, {
      l: `sv`,
      v: `Adress`
    }, {
      l: `ru`,
      v: `Адрес`
    }, {
      l: `pl`,
      v: `Adres`
    }, {
      l: `nl`,
      v: `Adres`
    }, {
      l: `nb`,
      v: `Addresse`
    }, {
      l: `it`,
      v: `Indirizzo`
    }, {
      l: `fr`,
      v: `Adresse`
    }, {
      l: `fi`,
      v: `Osoite`
    }, {
      l: `es`,
      v: `Dirección`
    }, {
      l: `de`,
      v: `Adresse`
    }, {
      l: `da`,
      v: `Adresse`
    });
    this.set(`_7:1`, {
      l: `en`,
      v: `Street`
    }, {
      l: `uk`,
      v: `Вулиця`
    }, {
      l: `sv`,
      v: `Gata`
    }, {
      l: `ru`,
      v: `Улица`
    }, {
      l: `pl`,
      v: `Ulica`
    }, {
      l: `nl`,
      v: `Straat`
    }, {
      l: `nb`,
      v: `Gate`
    }, {
      l: `it`,
      v: `Strada`
    }, {
      l: `fr`,
      v: `Rue`
    }, {
      l: `fi`,
      v: `Katu`
    }, {
      l: `es`,
      v: `Calle`
    }, {
      l: `de`,
      v: `Straße`
    }, {
      l: `da`,
      v: `Gade`
    });
    this.set(`_7:2`, {
      l: `en`,
      v: `City`
    }, {
      l: `uk`,
      v: `Місто`
    }, {
      l: `sv`,
      v: `Stad`
    }, {
      l: `ru`,
      v: `Город`
    }, {
      l: `pl`,
      v: `Miasto`
    }, {
      l: `nl`,
      v: `Stad`
    }, {
      l: `nb`,
      v: `By`
    }, {
      l: `it`,
      v: `Città`
    }, {
      l: `fr`,
      v: `Ville`
    }, {
      l: `fi`,
      v: `Kaupunki`
    }, {
      l: `es`,
      v: `Ciudad`
    }, {
      l: `de`,
      v: `Stadt`
    }, {
      l: `da`,
      v: `By`
    });
    this.set(`_7:3`, {
      l: `en`,
      v: `Postal code`
    }, {
      l: `uk`,
      v: `Поштовий індекс`
    }, {
      l: `sv`,
      v: `Postnummer`
    }, {
      l: `ru`,
      v: `Почтовый индекс`
    }, {
      l: `pl`,
      v: `Kod pocztowy`
    }, {
      l: `nl`,
      v: `Postcode`
    }, {
      l: `nb`,
      v: `Postnummer`
    }, {
      l: `it`,
      v: `Codice Postale`
    }, {
      l: `fr`,
      v: `Code Postal`
    }, {
      l: `fi`,
      v: `Postinumero`
    }, {
      l: `es`,
      v: `Código Postal`
    }, {
      l: `de`,
      v: `Postleitzahl`
    }, {
      l: `da`,
      v: `Postnummer`
    });
  }
  /**
  /* "Address" (Address)
  /* "Localizer.address"
  /* "Localizer.addressLanguageItemName"
  */
  get address() {
    return this.get(`_7:0`);
  }
  /**
  /* "Street" (Street)
  /* "Localizer.street"
  /* "Localizer.streetLanguageItemName"
  */
  get street() {
    return this.get(`_7:1`);
  }
  /**
  /* "City" (City)
  /* "Localizer.city"
  /* "Localizer.cityLanguageItemName"
  */
  get city() {
    return this.get(`_7:2`);
  }
  /**
  /* "PostalCode" (Postal code)
  /* "Localizer.postalCode"
  /* "Localizer.postalCodeLanguageItemName"
  */
  get postalCode() {
    return this.get(`_7:3`);
  }
}
//Singleton
var AddressDividerLocalizer$1 = new AddressDividerLocalizer();

var AddressDividerColumns;
(function (AddressDividerColumns) {
  AddressDividerColumns[AddressDividerColumns["Two"] = 0] = "Two";
  AddressDividerColumns[AddressDividerColumns["One"] = 1] = "One";
})(AddressDividerColumns || (AddressDividerColumns = {}));
class AddressDivider extends BaseComponent {
  constructor() {
    var _a, _b;
    super(...arguments);
    this.state = {
      location: (_a = AddressHelper.toLocation(this.props.location)) !== null && _a !== void 0 ? _a : new GeoLocation(),
      readonly: (_b = this.props.readonly) !== null && _b !== void 0 ? _b : false
    };
    this._containerRef = React.createRef();
    this._addressInputRef = React.createRef();
  }
  get location() {
    return this.state.location;
  }
  get addressInput() {
    const container = this._containerRef.current;
    return container.findComponent(`${this.id}_formattedAddress`);
  }
  onPlaceSelectedAsync(location) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        location
      });
      if (this.props.onChange) {
        yield this.props.onChange(this, location);
      }
    });
  }
  isInput() {
    return true;
  }
  isValid() {
    return !this.addressInput.state.validationError;
  }
  getName() {
    return this.id;
  }
  getValue() {
    return this.addressInput.getValue();
  }
  get readonly() {
    return this.state.readonly;
  }
  get edit() {
    return true;
  }
  get columns() {
    var _a;
    return (_a = this.props.columns) !== null && _a !== void 0 ? _a : AddressDividerColumns.Two;
  }
  setReadonlyAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value !== this.state.readonly) {
        yield this.setState({
          readonly: value
        });
        yield this._addressInputRef.current.setReadonlyAsync(value);
      }
    });
  }
  validateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.addressInput.validateAsync();
    });
  }
  hideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.addressInput.hideEditAsync();
    });
  }
  showEditAsync(select) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.addressInput.showEditAsync(select);
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      const newReadonly = this.props.readonly != nextProps.readonly;
      const newLocation = !Comparator.isEqual(this.props.location, nextProps.location);
      const newState = newReadonly || newLocation;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newState) {
        if (newReadonly) {
          this.state.readonly = (_a = this.props.readonly) !== null && _a !== void 0 ? _a : false;
        }
        if (newLocation) {
          this.state.location = (_b = AddressHelper.toLocation(nextProps.location)) !== null && _b !== void 0 ? _b : new GeoLocation();
        }
        yield this.setState(this.state);
      }
    });
  }
  render() {
    return React.createElement(React.Fragment, null, this.columns == AddressDividerColumns.Two && React.createElement(React.Fragment, null, React.createElement(TwoColumns, {
      ref: this._containerRef,
      className: this.props.className
    }, React.createElement(AddressInput, {
      id: `${this.id}_formattedAddress`,
      ref: this._addressInputRef,
      label: AddressDividerLocalizer$1.address,
      required: this.props.required,
      readonly: this.readonly,
      value: this.location.formattedAddress,
      locationPicker: this.props.locationPicker,
      append: this.props.locationPicker,
      country: this.props.country,
      onChange: location => __awaiter(this, void 0, void 0, function* () {
        return yield this.onPlaceSelectedAsync(location);
      })
    }), React.createElement(TextInput, {
      id: `${this.id}_address`,
      label: AddressDividerLocalizer$1.street,
      value: this.location.address,
      readonly: true
    })), React.createElement(TwoColumns, null, React.createElement(TextInput, {
      id: `${this.id}_city`,
      label: AddressDividerLocalizer$1.city,
      value: this.location.city,
      readonly: true
    }), React.createElement(TextInput, {
      id: `${this.id}_postalCode`,
      label: AddressDividerLocalizer$1.postalCode,
      value: this.location.postalCode,
      readonly: true
    }))), this.columns == AddressDividerColumns.One && React.createElement(React.Fragment, null, React.createElement(OneColumn, {
      ref: this._containerRef,
      className: this.props.className
    }, React.createElement(AddressInput, {
      id: `${this.id}_formattedAddress`,
      ref: this._addressInputRef,
      label: AddressDividerLocalizer$1.address,
      required: this.props.required,
      readonly: this.readonly,
      value: this.location.formattedAddress,
      locationPicker: this.props.locationPicker,
      append: this.props.locationPicker,
      country: this.props.country,
      onChange: location => this.onPlaceSelectedAsync(location)
    })), React.createElement(OneColumn, null, React.createElement(TextInput, {
      readonly: true,
      id: `${this.id}_address`,
      label: AddressDividerLocalizer$1.street,
      value: this.location.address
    })), React.createElement(OneColumn, null, React.createElement(TextInput, {
      readonly: true,
      id: `${this.id}_city`,
      label: AddressDividerLocalizer$1.city,
      value: this.location.city
    })), React.createElement(OneColumn, null, React.createElement(TextInput, {
      readonly: true,
      id: `${this.id}_postalCode`,
      label: AddressDividerLocalizer$1.postalCode,
      value: this.location.postalCode
    }))));
  }
}

//Autogenerated
class VirtualAddressDividerLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.streetLanguageItemName = `_8:0`;
    this.cityLanguageItemName = `_8:1`;
    this.postalcodeLanguageItemName = `_8:2`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_8:0`, {
      l: `en`,
      v: `Street`
    }, {
      l: `uk`,
      v: `Вулиця`
    }, {
      l: `sv`,
      v: `Gata`
    }, {
      l: `ru`,
      v: `Улица`
    }, {
      l: `pl`,
      v: `Ulica`
    }, {
      l: `nl`,
      v: `Straat`
    }, {
      l: `nb`,
      v: `Gate`
    }, {
      l: `it`,
      v: `Strada`
    }, {
      l: `fr`,
      v: `Rue`
    }, {
      l: `fi`,
      v: `Katu`
    }, {
      l: `es`,
      v: `Calle`
    }, {
      l: `de`,
      v: `Straße`
    }, {
      l: `da`,
      v: `Gade`
    });
    this.set(`_8:1`, {
      l: `en`,
      v: `City`
    }, {
      l: `uk`,
      v: `Місто`
    }, {
      l: `sv`,
      v: `Stad`
    }, {
      l: `ru`,
      v: `Город`
    }, {
      l: `pl`,
      v: `Miasto`
    }, {
      l: `nl`,
      v: `Stad`
    }, {
      l: `nb`,
      v: `By`
    }, {
      l: `it`,
      v: `Città`
    }, {
      l: `fr`,
      v: `Ville`
    }, {
      l: `fi`,
      v: `Kaupunki`
    }, {
      l: `es`,
      v: `Ciudad`
    }, {
      l: `de`,
      v: `Stadt`
    }, {
      l: `da`,
      v: `By`
    });
    this.set(`_8:2`, {
      l: `en`,
      v: `Postal code`
    }, {
      l: `uk`,
      v: `Поштовий індекс`
    }, {
      l: `sv`,
      v: `Postnummer`
    }, {
      l: `ru`,
      v: `Почтовый индекс`
    }, {
      l: `pl`,
      v: `Kod pocztowy`
    }, {
      l: `nl`,
      v: `Postcode`
    }, {
      l: `nb`,
      v: `Postnummer`
    }, {
      l: `it`,
      v: `Codice Postale`
    }, {
      l: `fr`,
      v: `Code Postal`
    }, {
      l: `fi`,
      v: `Postinumero`
    }, {
      l: `es`,
      v: `Código Postal`
    }, {
      l: `de`,
      v: `Postleitzahl`
    }, {
      l: `da`,
      v: `Postnummer`
    });
  }
  /**
  /* "Street" (Street)
  /* "Localizer.street"
  /* "Localizer.streetLanguageItemName"
  */
  get street() {
    return this.get(`_8:0`);
  }
  /**
  /* "City" (City)
  /* "Localizer.city"
  /* "Localizer.cityLanguageItemName"
  */
  get city() {
    return this.get(`_8:1`);
  }
  /**
  /* "Postalcode" (Postal code)
  /* "Localizer.postalcode"
  /* "Localizer.postalcodeLanguageItemName"
  */
  get postalcode() {
    return this.get(`_8:2`);
  }
}
//Singleton
var VirtualAddressDividerLocalizer$1 = new VirtualAddressDividerLocalizer();

class VirtualAddressDivider extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      readonly: this.props.readonly || false,
      city: "",
      postalCode: "",
      address: ""
    };
    this._addressInputRef = React.createRef();
    this._cityInputRef = React.createRef();
    this._postalCodeInputRef = React.createRef();
  }
  get virtualAddress() {
    return `${this.state.city}, ${this.state.postalCode}, ${this.state.address}`;
  }
  setVirtualAddressAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      const items = value.split(",");
      if (items.length >= 3) {
        const city = value.split(",")[0].trim();
        const postalCode = value.split(",")[1].trim();
        const address = value.split(",")[2].trim();
        yield this.setState({
          city,
          postalCode,
          address
        });
      }
    });
  }
  onCityChangeAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        city: value
      });
    });
  }
  onPostalCodeChangeAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        postalCode: value
      });
    });
  }
  onAddressChangeAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        address: value
      });
    });
  }
  isInput() {
    return true;
  }
  isValid() {
    return !!(this.state.address && this.state.city && this.state.postalCode);
  }
  getName() {
    return this.id;
  }
  getValue() {
    return this.virtualAddress;
  }
  get readonly() {
    return this.state.readonly;
  }
  get edit() {
    return true;
  }
  setReadonlyAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value !== this.state.readonly) {
        yield this.setState({
          readonly: value
        });
        yield this._addressInputRef.current.setReadonlyAsync(value);
      }
    });
  }
  validateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this._addressInputRef.current.validateAsync();
      yield this._cityInputRef.current.validateAsync();
      yield this._postalCodeInputRef.current.validateAsync();
    });
  }
  hideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  showEditAsync(select) {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  componentDidMount() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.value) {
        yield this.setVirtualAddressAsync(this.props.value);
      }
    });
  }
  render() {
    return React.createElement(React.Fragment, null, React.createElement(OneColumn, null, React.createElement(TextInput, {
      ref: this._addressInputRef,
      id: `${this.id}_address`,
      required: true,
      label: VirtualAddressDividerLocalizer$1.street,
      value: this.state.address,
      onChange: (sender, value) => this.onAddressChangeAsync(value)
    })), React.createElement(TwoColumns, null, React.createElement(TextInput, {
      ref: this._cityInputRef,
      id: `${this.id}_city`,
      required: true,
      label: VirtualAddressDividerLocalizer$1.city,
      value: this.state.city,
      onChange: (sender, value) => this.onCityChangeAsync(value)
    }), React.createElement(TextInput, {
      ref: this._postalCodeInputRef,
      id: `${this.id}_postalCode`,
      required: true,
      label: VirtualAddressDividerLocalizer$1.postalcode,
      value: this.state.postalCode,
      onChange: (sender, value) => this.onPostalCodeChangeAsync(value)
    })));
  }
}

class ColorInput extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      readonly: this.props.disabled || false,
      model: {
        value: this.props.value || (this.props.model ? this.props.model.value : "#6d6d6d")
      },
      edit: true,
      validationError: null
    };
  }
  setColorAsync(changeEvent) {
    return __awaiter(this, void 0, void 0, function* () {
      this.state.model.value = changeEvent.target.value;
      if (this.props.onChange) {
        yield this.props.onChange(this, changeEvent.target.value);
      }
      yield this.reRenderAsync();
    });
  }
  renderInput() {
    return React.createElement("div", {
      className: this.props.className
    }, React.createElement("input", {
      type: "color",
      value: this.props.value,
      disabled: this.readonly,
      onChange: value => this.setColorAsync(value)
    }));
  }
}

var css_248z$A = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-checkbox-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-checkbox-checkbox {\n  cursor: pointer;\n  position: relative;\n  color: rgb(254, 80, 0);\n}\n.athenaeum-checkbox-checkbox.athenaeum-checkbox-readonly {\n  color: #adadad;\n}\n.athenaeum-checkbox-checkbox i {\n  vertical-align: middle;\n}\n.athenaeum-checkbox-checkbox .athenaeum-checkbox-square {\n  display: block;\n  position: absolute;\n  top: 6px;\n  left: 4px;\n  width: 16.4px;\n  height: 15.4px;\n  border-radius: 2px;\n  background-color: #fe5000;\n}\n\n.athenaeum-checkbox-checked {\n  cursor: pointer;\n}\n\n.athenaeum-checkbox-unchecked {\n  cursor: pointer;\n}\n\n.athenaeum-checkbox-inlineRight {\n  align-items: center;\n  height: 100%;\n}\n.athenaeum-checkbox-inlineRight .base-input-label {\n  order: 2;\n  margin-left: 0.5rem;\n}\n.athenaeum-checkbox-inlineRight label {\n  cursor: pointer;\n}\n.athenaeum-checkbox-inlineRight div:nth-child(2) {\n  align-items: center;\n  order: 1;\n}";
var styles$u = {"font-renta":"athenaeum-checkbox-font-renta","checkbox":"athenaeum-checkbox-checkbox","readonly":"athenaeum-checkbox-readonly","square":"athenaeum-checkbox-square","checked":"athenaeum-checkbox-checked","unchecked":"athenaeum-checkbox-unchecked","inlineRight":"athenaeum-checkbox-inlineRight"};
styleInject(css_248z$A);

var InlineType;
(function (InlineType) {
  InlineType[InlineType["Left"] = 0] = "Left";
  InlineType[InlineType["Right"] = 1] = "Right";
})(InlineType || (InlineType = {}));
class Checkbox extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      validationError: null,
      edit: true,
      readonly: !!this.props.readonly,
      model: {
        value: !!this.props.value
      }
    };
  }
  setAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.checked !== checked) {
        yield this.updateValueAsync(checked);
        if (this.props.onChange) {
          yield this.props.onChange(this, checked);
        }
      }
    });
  }
  onLabelClick() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.toggleAsync();
    });
  }
  getContainerClassName() {
    return this.props.inline && this.props.inlineType && this.props.inlineType === InlineType.Right ? styles$u.inlineRight : "";
  }
  get checked() {
    return this.value;
  }
  get radio() {
    return this.props.radio === true;
  }
  getValidators() {
    return [];
  }
  get value() {
    return this.state.model.value || false;
  }
  getType() {
    return BaseInputType.Checkbox;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly) {
        yield this.setAsync(!this.checked);
      }
    });
  }
  checkAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.checked) {
        yield this.toggleAsync();
      }
    });
  }
  uncheckAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.checked) {
        yield this.toggleAsync();
      }
    });
  }
  renderInput() {
    const readonlyStyle = this.readonly && styles$u.readonly;
    const checkedStyle = this.checked ? styles$u.checked : styles$u.unchecked;
    return React.createElement("div", {
      className: this.css(styles$u.checkbox, readonlyStyle, checkedStyle),
      title: this.props.title
    }, React.createElement("div", {
      onClick: () => this.toggleAsync()
    }, this.checked ? this.radio ? React.createElement(Icon, {
      name: "fas check-circle",
      size: IconSize.X2
    }) : React.createElement(Icon, {
      name: "fas check-square",
      size: IconSize.X2
    }) : this.radio ? React.createElement(Icon, {
      name: "far circle",
      size: IconSize.X2
    }) : React.createElement(Icon, {
      name: "far square",
      size: IconSize.X2
    })));
  }
}

class CheckboxNullable extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      validationError: null,
      edit: true,
      readonly: !!this.props.readonly,
      model: {
        value: this.props.value
      }
    };
  }
  setAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly && this.value !== value) {
        yield this.updateValueAsync(value);
        if (this.props.onChange) {
          yield this.props.onChange(this, value);
        }
      }
    });
  }
  onLabelClick() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.toggleAsync();
    });
  }
  getValidators() {
    return [];
  }
  get value() {
    return this.state.model.value;
  }
  get excludeNull() {
    return !!this.props.excludeNull;
  }
  getType() {
    return BaseInputType.Checkbox;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      switch (this.value) {
        case true:
          yield this.setAsync(false);
          break;
        case false:
          if (this.excludeNull) {
            yield this.setAsync(true);
          } else {
            yield this.setAsync(null);
          }
          break;
        case null:
          yield this.setAsync(true);
          break;
      }
    });
  }
  checkAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setAsync(true);
    });
  }
  uncheckAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setAsync(false);
    });
  }
  setNullAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.excludeNull) {
        yield this.toggleAsync();
      } else {
        yield this.setAsync(null);
      }
    });
  }
  renderCheckedIcon() {
    if (this.value === null || !this.value) {
      return React.createElement(Icon, {
        name: "far square",
        size: IconSize.X2
      });
    }
    return React.createElement(Icon, {
      name: "fas check-square",
      size: IconSize.X2
    });
  }
  renderInput() {
    return React.createElement("div", {
      className: this.css(styles$u.checkbox, this.readonly && styles$u.readonly)
    }, React.createElement("div", {
      className: "position-relative",
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }, this.renderCheckedIcon(), this.value === null && React.createElement("span", {
      className: styles$u.square
    })));
  }
}

class EmailInput extends TextInput {
  getType() {
    return BaseInputType.Email;
  }
  getValidators() {
    return [EmailValidator.validator];
  }
}

class UrlInput extends TextInput {
  getType() {
    return BaseInputType.Url;
  }
  getValidators() {
    return [UrlValidator.validator];
  }
}

//Autogenerated
class FileInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.dragAndDropLanguageItemName = `_9:0`;
    this.readonlyLanguageItemName = `_9:1`;
    this.chooseFileLanguageItemName = `_9:2`;
    this.previewLanguageItemName = `_9:3`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_9:0`, {
      l: `en`,
      v: `Drag'n'drop file here, or click to select`
    }, {
      l: `uk`,
      v: `Перетягніть файл, або оберіть його`
    }, {
      l: `sv`,
      v: `Släpp filen här eller välj genom att trycka`
    }, {
      l: `ru`,
      v: `Перетащите файл сюда или щелкните, чтобы выбрать`
    }, {
      l: `pl`,
      v: `Przeciągnij pliki tutaj i upuść albo kliknij aby wybrać`
    }, {
      l: `nl`,
      v: `Sleep het bestand hierheen, of klik om te selecteren`
    }, {
      l: `nb`,
      v: `Dra og drop filen hit, eller klikk for å velge`
    }, {
      l: `it`,
      v: `Trascina e rilascia il file qui o fai clic per selezionarlo`
    }, {
      l: `fr`,
      v: `Glissez et déposez le fichier ici, ou cliquez pour sélectionner`
    }, {
      l: `fi`,
      v: `Pudota tiedosto tähän tai valitse klikkaamalla`
    }, {
      l: `es`,
      v: `Arrastre y suelte el archivo aquí, o haga clic para seleccionar`
    }, {
      l: `de`,
      v: `Ziehen Sie die Datei hierher und legen Sie sie dort ab, oder klicken Sie, um sie auszuwählen`
    }, {
      l: `da`,
      v: `Placer filen her, eller vælg ved at klikke`
    });
    this.set(`_9:1`, {
      l: `en`,
      v: `File is readonly`
    }, {
      l: `uk`,
      v: `Файл доступний лише для читання`
    }, {
      l: `sv`,
      v: `Filen är bara läsbar`
    }, {
      l: `ru`,
      v: `Файл доступен только для чтения`
    }, {
      l: `pl`,
      v: `Plik tylko do odczytu`
    }, {
      l: `nl`,
      v: `Bestand is alleen-lezen`
    }, {
      l: `nb`,
      v: `Filen er skrivebeskyttet`
    }, {
      l: `it`,
      v: `Il file è di sola lettura`
    }, {
      l: `fr`,
      v: `Le fichier est en lecture seule`
    }, {
      l: `fi`,
      v: `Tämä tiedosto on vain luettavissa`
    }, {
      l: `es`,
      v: `El archivo es de solo lectura`
    }, {
      l: `de`,
      v: `Die Datei ist schreibgeschützt`
    }, {
      l: `da`,
      v: `Fil er readonly`
    });
    this.set(`_9:2`, {
      l: `en`,
      v: `Choose file`
    }, {
      l: `uk`,
      v: `Оберіть файл`
    }, {
      l: `sv`,
      v: `Välj fil`
    }, {
      l: `ru`,
      v: `Выберите файл`
    }, {
      l: `pl`,
      v: `Wybierz plik`
    }, {
      l: `nl`,
      v: `Kies bestand`
    }, {
      l: `nb`,
      v: `Velg fil`
    }, {
      l: `it`,
      v: `Scegli il file`
    }, {
      l: `fr`,
      v: `Choisir le fichier`
    }, {
      l: `fi`,
      v: `Valitse tiedosto`
    }, {
      l: `es`,
      v: `Elija el archivo`
    }, {
      l: `de`,
      v: `Datei wählen`
    }, {
      l: `da`,
      v: `Vælg fil`
    });
    this.set(`_9:3`, {
      l: `en`,
      v: `Preview`
    }, {
      l: `uk`,
      v: `Переглянути`
    }, {
      l: `sv`,
      v: `Förhandsvisning`
    }, {
      l: `ru`,
      v: `Предпросмотр`
    }, {
      l: `pl`,
      v: `Podgląd`
    }, {
      l: `nl`,
      v: `Voorbeeld`
    }, {
      l: `nb`,
      v: `Forhåndsvisning`
    }, {
      l: `it`,
      v: `Anteprima`
    }, {
      l: `fr`,
      v: `Aperçu`
    }, {
      l: `fi`,
      v: `Esikatselu`
    }, {
      l: `es`,
      v: `Avance`
    }, {
      l: `de`,
      v: `Vorschau`
    }, {
      l: `da`,
      v: `Eksempel`
    });
  }
  /**
  /* "DragAndDrop" (Drag'n'drop file here, or click to select)
  /* "Localizer.dragAndDrop"
  /* "Localizer.dragAndDropLanguageItemName"
  */
  get dragAndDrop() {
    return this.get(`_9:0`);
  }
  /**
  /* "Readonly" (File is readonly)
  /* "Localizer.readonly"
  /* "Localizer.readonlyLanguageItemName"
  */
  get readonly() {
    return this.get(`_9:1`);
  }
  /**
  /* "ChooseFile" (Choose file)
  /* "Localizer.chooseFile"
  /* "Localizer.chooseFileLanguageItemName"
  */
  get chooseFile() {
    return this.get(`_9:2`);
  }
  /**
  /* "Preview" (Preview)
  /* "Localizer.preview"
  /* "Localizer.previewLanguageItemName"
  */
  get preview() {
    return this.get(`_9:3`);
  }
}
//Singleton
var FileInputLocalizer$1 = new FileInputLocalizer();

var css_248z$z = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-file-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-file-input-file .athenaeum-file-input-dropZone {\n  height: 200px;\n  background-color: aliceblue;\n  border: 2px dashed #ccc;\n  border-radius: 5px;\n  margin-bottom: 10px;\n}\n.athenaeum-file-input-file .athenaeum-file-input-dropZone label {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: copy;\n}\n.athenaeum-file-input-file .athenaeum-file-input-dropZone label .athenaeum-file-input-preview {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n.athenaeum-file-input-file .athenaeum-file-input-dropZone label .athenaeum-file-input-preview .athenaeum-file-input-image {\n  height: 85%;\n  width: 85%;\n  margin: 0 auto;\n  background-position: center !important;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n}\n.athenaeum-file-input-file .athenaeum-file-input-selectedFile {\n  font-size: 1em;\n  margin-top: 5px;\n}\n.athenaeum-file-input-file .athenaeum-file-input-selectedFile i {\n  color: #a94442;\n  margin-left: 8px;\n  cursor: pointer;\n}\n.athenaeum-file-input-file .athenaeum-file-input-selectedFile .athenaeum-file-input-clickable {\n  cursor: pointer;\n}\n.athenaeum-file-input-file.athenaeum-file-input-readonly {\n  pointer-events: none;\n}\n.athenaeum-file-input-file.athenaeum-file-input-readonly label {\n  opacity: 0.65;\n}\n.athenaeum-file-input-file.athenaeum-file-input-readonly .athenaeum-file-input-selectedFile {\n  pointer-events: auto;\n}\n.athenaeum-file-input-file.athenaeum-file-input-readonly .athenaeum-file-input-selectedFile i {\n  display: none;\n}";
var styles$t = {"font-renta":"athenaeum-file-input-font-renta","file":"athenaeum-file-input-file","dropZone":"athenaeum-file-input-dropZone","preview":"athenaeum-file-input-preview","image":"athenaeum-file-input-image","selectedFile":"athenaeum-file-input-selectedFile","clickable":"athenaeum-file-input-clickable","readonly":"athenaeum-file-input-readonly"};
styleInject(css_248z$z);

class FileInput extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      readonly: this.props.disabled || false,
      model: {
        value: this.props.value || (this.props.model ? this.props.model.value : null)
      },
      edit: true,
      validationError: null
    };
  }
  get hidden() {
    return this.props.hidden === true;
  }
  getValidators() {
    return [FileSizeValidator.validator(this.props.maxSize), FileTypeValidator.validator(this.props.fileTypes), FilesSizeValidator.validator(this.props.maxTotalSize)];
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.click();
    });
  }
  getType() {
    return BaseInputType.File;
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      valueBlurHandlerAsync: {
        get: () => super.valueBlurHandlerAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.valueBlurHandlerAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  getFileReferences(fileList) {
    const fileReferences = [];
    if (fileList) {
      const length = fileList.length;
      for (let i = 0; i < length; i++) {
        fileReferences.push(fileList[i]);
      }
    }
    return fileReferences;
  }
  valueChangeHandlerAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      const changeEvent = event;
      const fileReferences = changeEvent.target.files;
      yield this.fileChangeAsync(fileReferences);
    });
  }
  onDropHandlerAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      this.preventEventDefaultBehavior(event);
      const fileReferences = event.nativeEvent.dataTransfer.files;
      yield this.fileChangeAsync(fileReferences);
    });
  }
  fileChangeAsync(fileList) {
    return __awaiter(this, void 0, void 0, function* () {
      const fileReferences = this.getFileReferences(fileList);
      if (this.props.multiple) {
        const files = [];
        for (let i = 0; i < fileReferences.length; i++) {
          const file = yield Utility.transformFileAsync(fileReferences[i]);
          if (file) {
            files.push(file);
          }
        }
        if (files.length) {
          const existingFiles = this.value || [];
          const newFiles = files.where(file => !existingFiles.some(item => item.name == file.name));
          if (newFiles.length > 0) {
            const newValue = existingFiles.concat(newFiles);
            yield this.updateValueAsync(newValue);
            if (this.props.onChange) {
              yield this.props.onChange(this, newFiles);
            }
          }
        }
      } else {
        const fileReference = fileReferences.firstOrDefault();
        const file = yield Utility.transformFileAsync(fileReference);
        yield this.updateValueAsync(file);
        if (this.props.onChange) {
          yield this.props.onChange(this, this.state.model.value || []);
        }
      }
    });
  }
  removeSelectedFileAsync(index = null) {
    return __awaiter(this, void 0, void 0, function* () {
      let value;
      let removedValue;
      if (index !== null && this.value instanceof Array && this.value.length > 0) {
        const copyValue = [...this.value];
        removedValue = copyValue.splice(index, 1)[0];
        value = copyValue;
      } else {
        removedValue = this.value;
        value = null;
      }
      yield this.updateValueAsync(value);
      if (this.props.onRemove && removedValue != null) {
        yield this.props.onRemove(removedValue);
      }
    });
  }
  onClickHandlerAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClick) {
        yield this.props.onClick(this, value);
      }
    });
  }
  preventEventDefaultBehavior(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  onDragOverHandler(e) {
    this.preventEventDefaultBehavior(e);
  }
  get acceptedTypes() {
    return this.props.fileTypes && this.props.fileTypes.length ? this.props.fileTypes.join(",") : "";
  }
  get placeholder() {
    return this.readonly ? FileInputLocalizer$1.readonly : this.props.placeholder || FileInputLocalizer$1.dragAndDrop;
  }
  renderPreview() {
    let imagePreviewStyle = {};
    if (!this.props.multiple) {
      imagePreviewStyle = this.state.model.value ? {
        background: `url(${this.state.model.value.src})`
      } : {};
    }
    return React.createElement("div", {
      className: styles$t.preview
    }, React.createElement("div", {
      className: styles$t.image,
      style: imagePreviewStyle
    }), FileInputLocalizer$1.preview);
  }
  renderFile() {
    if (this.value instanceof Array) {
      return this.value.length > 0 && this.value.map((file, index) => React.createElement("div", {
        key: index,
        className: styles$t.selectedFile
      }, React.createElement("span", {
        className: this.css(this.props.onClick && styles$t.clickable),
        onClick: () => this.onClickHandlerAsync(file)
      }, file.name), React.createElement(Icon, {
        name: "trash-alt",
        onClick: () => __awaiter(this, void 0, void 0, function* () {
          return yield this.removeSelectedFileAsync(index);
        }),
        confirm: file.id && this.props.removeConfirmation
      })));
    } else {
      return React.createElement("div", {
        className: styles$t.selectedFile
      }, React.createElement("span", {
        className: this.css(this.props.onClick && styles$t.clickable),
        onClick: () => this.onClickHandlerAsync(this.value)
      }, this.value.name), React.createElement(Icon, {
        name: "trash-alt",
        onClick: () => __awaiter(this, void 0, void 0, function* () {
          return yield this.removeSelectedFileAsync();
        }),
        confirm: this.value.id && this.props.removeConfirmation
      }));
    }
  }
  renderInput() {
    return React.createElement("div", {
      className: this.css(styles$t.file, this.readonly && styles$t.readonly)
    }, this.props.dropZone && !this.hidden && React.createElement("div", {
      className: styles$t.dropZone,
      onDrop: e => this.onDropHandlerAsync(e),
      onDragOver: e => this.onDragOverHandler(e)
    }, React.createElement("label", {
      htmlFor: this.getInputId()
    }, React.createElement("span", null, this.placeholder), this.state.model.value && this.props.dropZone && !this.props.multiple && this.state.model.value.src.startsWith("data:image") && this.renderPreview())), !this.props.dropZone && !this.hidden && React.createElement("div", {
      className: "d-flex align-items-center"
    }, React.createElement("label", {
      className: this.css("btn m-0", this.props.labelClassName ? this.props.labelClassName : "btn-info"),
      htmlFor: this.getInputId()
    }, FileInputLocalizer$1.chooseFile, " ", this.value && this.value.length > 0 && `(${this.value.length})`)), React.createElement("input", {
      id: this.getInputId(),
      hidden: true,
      value: "",
      type: this.getType(),
      multiple: this.props.multiple,
      className: "form-control-file",
      ref: this.props.forwardedRef,
      style: this.props.dropZone ? {
        display: "none"
      } : {},
      disabled: this.readonly,
      accept: this.acceptedTypes,
      onChange: e => this.valueChangeHandlerAsync(e),
      onBlur: () => this.valueBlurHandlerAsync()
    }), !this.hidden && this.value && this.renderFile());
  }
}

class PasswordInput extends TextInput {
  getType() {
    return BaseInputType.Password;
  }
}

class PhoneInput extends TextInput {
  getType() {
    return BaseInputType.Text;
  }
  getValidators() {
    return [PhoneValidator.validator];
  }
}

var css_248z$y = ".rc-slider-tooltip {\n  z-index: 10000;\n}";
styleInject(css_248z$y);

class Slider extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      defaultValue: this.props.defaultValue || 0,
      value: this.props.defaultValue || 0
    };
    this._sliderWithTooltip = createSliderWithTooltip(SliderComponent);
  }
  handleChangeAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        const newSliderValue = this.props.minimumAllowed <= value && value <= this.props.maximumAllowed ? value : this.state.defaultValue;
        yield this.setState({
          value: newSliderValue
        });
      }
      if (this.props.onChange) {
        yield this.props.onChange(this);
      }
    });
  }
  get sliderId() {
    return this.props.id || this.id;
  }
  callbackAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // if(this.props.onChange) {
      //     await this.props.onChange(this);
      // }
    });
  }
  get min() {
    return this.props.min || 0;
  }
  get max() {
    return this.props.max || 100;
  }
  get step() {
    return this.props.step || 1;
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (nextProps.defaultValue !== undefined && this.state.defaultValue !== nextProps.defaultValue) {
        this.setState({
          defaultValue: nextProps.defaultValue,
          value: nextProps.defaultValue
        });
      }
    });
  }
  render() {
    return React.createElement("div", {
      className: styles$Z.slider,
      id: this.sliderId
    }, React.createElement(this._sliderWithTooltip, {
      min: this.min,
      max: this.max,
      step: this.step,
      onChange: values => this.handleChangeAsync(values),
      trackStyle: [{
        backgroundColor: "#fe5000"
      }],
      handleStyle: {
        borderColor: "#fe5000"
      },
      onAfterChange: () => this.callbackAsync(),
      value: this.state.value,
      disabled: this.props.disabled
    }));
  }
}
Slider.defaultProps = {
  maximumAllowed: 100,
  minimumAllowed: 0
};

class Range extends BaseInput {
  constructor(props) {
    super(props);
    this._rangeWithTooltip = createSliderWithTooltip(Range$1);
  }
  handleChangeAsync(values) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        if (this.props.onChange) {
          yield this.props.onChange(this, this.state.model.value);
        }
        yield this.setState({
          model: {
            value: values
          }
        });
      }
    });
  }
  get min() {
    return this.props.min || 0;
  }
  get max() {
    return this.props.max || 100;
  }
  get step() {
    return this.props.step || 1;
  }
  get count() {
    return this.props.count || 2;
  }
  get defaultValue() {
    return this.props.defaultValue || [this.min, this.max];
  }
  renderInput() {
    return React.createElement("div", {
      className: styles$Z.slider
    }, React.createElement(this._rangeWithTooltip, {
      min: this.min,
      max: this.max,
      step: this.step,
      count: this.count,
      defaultValue: this.defaultValue,
      onChange: values => this.handleChangeAsync(values),
      allowCross: true,
      trackStyle: [{
        backgroundColor: "#fe5000"
      }],
      handleStyle: {
        borderColor: "#fe5000"
      }
    }));
  }
}

var css_248z$x = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-switch-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-switch-switch, .athenaeum-switch-container .athenaeum-switch-nullableSwitch, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked, .athenaeum-switch-checked {\n  width: 56px;\n  height: 32px;\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n  background-color: white;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.athenaeum-switch-switch .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-toggler, .athenaeum-switch-checked .athenaeum-switch-toggler {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  height: inherit;\n  width: 20px;\n  border: inherit;\n  border-radius: 5px;\n  background-color: white;\n  transition: all 0.3s ease;\n}\n.athenaeum-switch-switch.athenaeum-switch-readonly, .athenaeum-switch-container .athenaeum-switch-readonly.athenaeum-switch-nullableSwitch, .athenaeum-switch-container .athenaeum-switch-readonly.athenaeum-switch-nullableSwitchUnchecked, .athenaeum-switch-container .athenaeum-switch-readonly.athenaeum-switch-nullableSwitchChecked, .athenaeum-switch-readonly.athenaeum-switch-checked {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.athenaeum-switch-checked {\n  background-color: rgb(254, 80, 0);\n}\n.athenaeum-switch-checked .athenaeum-switch-toggler, .athenaeum-switch-checked .athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-toggler, .athenaeum-switch-checked .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-toggler, .athenaeum-switch-checked .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-checked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-checked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-checked .athenaeum-switch-toggler {\n  background-color: white;\n  left: 35px;\n}\n\n.athenaeum-switch-container {\n  display: flex;\n  align-items: center;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitch, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked {\n  background-color: lightgrey;\n  width: 84px;\n  display: flex;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-toggler {\n  left: calc(50% - 10px);\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-zone, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-zone, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-zone {\n  width: 100%;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked {\n  background-color: #28a745;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-toggler {\n  background-color: white;\n  left: calc(100% - 19px);\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked {\n  background-color: #dc3545;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-toggler {\n  background-color: white;\n  left: -1px;\n}\n.athenaeum-switch-container .athenaeum-switch-label:first-of-type {\n  margin-right: 4px;\n}\n.athenaeum-switch-container .athenaeum-switch-label:last-of-type {\n  margin-left: 4px;\n}";
var styles$s = {"font-renta":"athenaeum-switch-font-renta","switch":"athenaeum-switch-switch","container":"athenaeum-switch-container","nullableSwitch":"athenaeum-switch-nullableSwitch","nullableSwitchUnchecked":"athenaeum-switch-nullableSwitchUnchecked","nullableSwitchChecked":"athenaeum-switch-nullableSwitchChecked","checked":"athenaeum-switch-checked","toggler":"athenaeum-switch-toggler","readonly":"athenaeum-switch-readonly","zone":"athenaeum-switch-zone","label":"athenaeum-switch-label"};
styleInject(css_248z$x);

class Switch extends Checkbox {
  renderInput() {
    const toggleStyles = this.checked ? styles$s.checked : styles$s.switch;
    return React.createElement("div", {
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      }),
      className: this.css(toggleStyles, this.readonly && styles$s.readonly)
    }, React.createElement("span", {
      className: styles$s.toggler
    }));
  }
}

var TabRenderType;
(function (TabRenderType) {
  /**
   * Tab content will be always rendered
   */
  TabRenderType[TabRenderType["Always"] = 0] = "Always";
  /**
   * Only active tab content will be rendered
   */
  TabRenderType[TabRenderType["ActiveOnly"] = 1] = "ActiveOnly";
  /**
   * Tab content will be rendered once during tab activation
   */
  TabRenderType[TabRenderType["Once"] = 2] = "Once";
})(TabRenderType || (TabRenderType = {}));
class TabContainerModel {
  constructor() {
    this.id = "";
    this.className = null;
    this.scale = false;
    this.dataStorageType = DataStorageType.Page;
    this.renderType = TabRenderType.Always;
    this.tabs = [];
    this.instance = {};
  }
  restoreActiveTabIndex() {
    if (this.dataStorageType != false) {
      const lastActiveIndex = UserInteractionDataStorage.get(this.id, -1, this.dataStorageType);
      if (lastActiveIndex >= 0 && lastActiveIndex < this.tabs.length) {
        const tab = this.tabs[lastActiveIndex];
        if (!tab.closed && !tab.ignorable) {
          return lastActiveIndex;
        }
      }
    }
    return this.tabs.findIndex(tab => !tab.closed && !tab.ignorable);
  }
  saveActiveTabIndex() {
    if (this.dataStorageType != false) {
      UserInteractionDataStorage.set(this.id, this.activeIndex, this.dataStorageType);
    }
  }
  findTab(tabOrIndexOrId) {
    return typeof tabOrIndexOrId === "number" ? tabOrIndexOrId >= 0 && tabOrIndexOrId < this.tabs.length ? this.tabs[tabOrIndexOrId] : null : typeof tabOrIndexOrId === "string" ? this.tabs.find(tab => tab.id == tabOrIndexOrId) || null : tabOrIndexOrId;
  }
  get activeIndex() {
    return this.tabs.findIndex(item => item.active && !item.closed);
  }
  getActiveTab() {
    return this.tabs.find(tab => tab.active) || null;
  }
  getTabIds() {
    return this.tabs.map(tab => tab.id);
  }
  activateDefault(prevActiveIndex = null) {
    if (this.tabs.length > 0) {
      let newActiveIndex = this.tabs.findIndex(tab => !tab.closed && !tab.ignorable && tab.active);
      if (newActiveIndex === -1) {
        if (prevActiveIndex != null && prevActiveIndex >= 0 && prevActiveIndex < this.tabs.length && !this.tabs[prevActiveIndex].closed && !this.tabs[prevActiveIndex].ignorable) {
          newActiveIndex = prevActiveIndex;
        } else {
          newActiveIndex = this.restoreActiveTabIndex();
        }
      }
      const tab = this.tabs.firstOrDefault(item => item.index === newActiveIndex);
      if (tab) {
        tab.active = true;
        TabModel.setActiveTab(tab);
      }
      this.saveActiveTabIndex();
    }
  }
  activateTabAsync(tabOrIndexOrId) {
    return __awaiter(this, void 0, void 0, function* () {
      const tab = this.findTab(tabOrIndexOrId);
      if (tab && !tab.active && !tab.closed) {
        if (this.onBeforeSelect) {
          const canActivate = yield this.onBeforeSelect(tab);
          if (!canActivate) {
            return;
          }
        }
        if (!tab.ignorable) {
          const activeTab = this.getActiveTab();
          if (activeTab) {
            activeTab.active = false;
            yield activeTab.reRenderAsync();
          }
          tab.active = true;
          TabModel.setActiveTab(tab);
          this.saveActiveTabIndex();
          yield tab.reRenderAsync();
        }
        if (tab.onSelect) {
          yield tab.onSelect(tab);
        }
        if (this.onSelect) {
          yield this.onSelect(tab);
        }
      }
    });
  }
  closeTabAsync(tabOrIndexOrId, confirmed, data) {
    return __awaiter(this, void 0, void 0, function* () {
      const tab = this.findTab(tabOrIndexOrId);
      if (tab && !tab.closed) {
        const confirmNeeded = !!tab.closeConfirm && !confirmed;
        if (confirmNeeded && tab.closeConfirmDialogRef.current) {
          yield tab.closeConfirmDialogRef.current.openAsync();
          return;
        }
        // Close the tab:
        tab.closed = true;
        if (tab.active) {
          tab.active = false;
          if (tab.index > 0) {
            const prevTab = this.tabs[tab.index - 1];
            prevTab.active = true;
            TabModel.setActiveTab(prevTab);
            yield prevTab.reRenderAsync();
          }
        }
        this.saveActiveTabIndex();
        yield tab.reRenderAsync();
        if (tab.onClose) {
          yield tab.onClose(tab, data);
        }
        if (this.onClose) {
          yield this.onClose(tab);
        }
      }
    });
  }
}
class TabModel {
  constructor() {
    this.id = "";
    this.title = "";
    this.tooltip = "";
    this.className = null;
    this.activeClassName = null;
    this.icon = null;
    this.ignorable = false;
    this.active = false;
    this.closed = false;
    this.index = 0;
    this.container = new TabContainerModel();
    this.instance = {};
    this.headerInstance = {};
    this.closeConfirm = null;
    this.count = null;
    this.countClassName = null;
    this.closeConfirmDialogRef = React.createRef();
  }
  getCount() {
    const count = this.count;
    return count != null ? typeof count === "function" ? count() : count : null;
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.headerInstance.reRenderAsync) {
        yield this.headerInstance.reRenderAsync();
      }
      if (this.instance.reRenderAsync) {
        yield this.instance.reRenderAsync();
      }
    });
  }
  static setActiveTab(tab) {
    this._activeTab = tab;
  }
  static get activeTab() {
    return this._activeTab;
  }
}
TabModel._activeTab = null;
class TabTransformer {
  static toTab(from, id) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const to = new TabModel();
    to.id = id;
    to.active = (_a = from.active) !== null && _a !== void 0 ? _a : false;
    to.className = (_b = from.className) !== null && _b !== void 0 ? _b : null;
    to.activeClassName = (_c = from.activeClassName) !== null && _c !== void 0 ? _c : null;
    to.icon = (_d = from.icon) !== null && _d !== void 0 ? _d : null;
    to.ignorable = (_e = from.ignorable) !== null && _e !== void 0 ? _e : false;
    to.title = from.title || "";
    to.tooltip = from.tooltip || "";
    to.closeConfirm = (_f = from.closeConfirm) !== null && _f !== void 0 ? _f : null;
    to.count = (_g = from.count) !== null && _g !== void 0 ? _g : null;
    to.countClassName = (_h = from.countClassName) !== null && _h !== void 0 ? _h : null;
    to.onSelect = from.onSelect;
    to.onClose = from.onClose;
    return to;
  }
  static toTabContainer(from, id) {
    var _a;
    const to = new TabContainerModel();
    to.id = id;
    to.className = from.className || null;
    to.scale = from.scale || false;
    to.dataStorageType = (_a = from.dataStorageType) !== null && _a !== void 0 ? _a : DataStorageType.Page;
    to.renderType = from.renderType || TabRenderType.Always;
    to.tabs = [];
    to.onBeforeSelect = from.onBeforeSelect;
    to.onSelect = from.onSelect;
    to.onClose = from.onClose;
    return to;
  }
}

//Autogenerated
class TabContainerLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var TabContainerLocalizer$1 = new TabContainerLocalizer();

var css_248z$w = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-tab-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-tab-container-tabContainer {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  width: auto;\n  min-width: 100%;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-underlineTabStyle, .athenaeum-tab-container-tabContainer .athenaeum-tab-container-underlineTabStyleInactive, .athenaeum-tab-container-tabContainer .athenaeum-tab-container-underlineTabStyleActive {\n  font-size: 20px;\n  border: 0 !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n  text-decoration: underline;\n  text-decoration-thickness: 5px !important;\n  text-decoration-skip-ink: none;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-underlineTabStyleActive {\n  color: #333 !important;\n  text-decoration-color: rgb(254, 80, 0) !important;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-underlineTabStyleActive:hover {\n  text-decoration-color: rgb(254, 80, 0) !important;\n  text-decoration: underline;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-underlineTabStyleInactive {\n  color: #333 !important;\n  text-decoration-color: #adadad !important;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-underlineTabStyleInactive:hover {\n  text-decoration-color: #adadad !important;\n  text-decoration: underline;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer {\n  position: relative;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-navigationIcon {\n  padding: 10px 4px;\n  top: 0;\n  position: absolute;\n  cursor: pointer;\n  z-index: 1;\n  border-radius: 5px;\n  color: rgb(254, 80, 0);\n  display: none;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-navigationIcon.athenaeum-tab-container-left {\n  left: -16px;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-navigationIcon.athenaeum-tab-container-right {\n  right: -16px;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-scrollableContainer {\n  position: relative;\n  height: 52px;\n  overflow: hidden;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-scrollableContainer ul {\n  position: absolute;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab {\n  position: relative;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-closed {\n  display: none;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-icon.athenaeum-tab-container-hasText {\n  margin-left: -4px;\n  margin-right: 4px;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-close {\n  margin-left: 8px;\n  cursor: pointer;\n  opacity: 0.3;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-close:hover {\n  opacity: 1;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-count {\n  position: absolute;\n  right: -10px;\n  top: -7px;\n  padding-left: 9px;\n  padding-right: 9px;\n  font-size: 12px;\n  background: #000000;\n  color: #fff;\n  vertical-align: top;\n  border-radius: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n}";
var styles$r = {"font-renta":"athenaeum-tab-container-font-renta","tabContainer":"athenaeum-tab-container-tabContainer","underlineTabStyle":"athenaeum-tab-container-underlineTabStyle","underlineTabStyleInactive":"athenaeum-tab-container-underlineTabStyleInactive","underlineTabStyleActive":"athenaeum-tab-container-underlineTabStyleActive","navigationContainer":"athenaeum-tab-container-navigationContainer","navigationIcon":"athenaeum-tab-container-navigationIcon","left":"athenaeum-tab-container-left","right":"athenaeum-tab-container-right","scrollableContainer":"athenaeum-tab-container-scrollableContainer","tab":"athenaeum-tab-container-tab","closed":"athenaeum-tab-container-closed","icon":"athenaeum-tab-container-icon","hasText":"athenaeum-tab-container-hasText","close":"athenaeum-tab-container-close","count":"athenaeum-tab-container-count"};
styleInject(css_248z$w);

/**
 * Enum used to describe header style. Values:
 * > {@linkcode TabContainerHeaderStyleType.Default} <br />
 * > {@linkcode TabContainerHeaderStyleType.Underline}
 */
var TabContainerHeaderStyleType;
(function (TabContainerHeaderStyleType) {
  /**
   * Renders tab headers in default (button) appearance.
   */
  TabContainerHeaderStyleType[TabContainerHeaderStyleType["Default"] = 0] = "Default";
  /**
   * Renders tab headers as underlined text, where selected is highlighted with orange.
   */
  TabContainerHeaderStyleType[TabContainerHeaderStyleType["Underline"] = 1] = "Underline";
})(TabContainerHeaderStyleType || (TabContainerHeaderStyleType = {}));
class TabHeader extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  onClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.model.container.activateTabAsync(this.model);
    });
  }
  onCloseAsync(confirmed = false, data = "") {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.model.container.closeTabAsync(this.model, confirmed, data);
    });
  }
  get model() {
    return this.props.model;
  }
  get classNames() {
    var _a;
    const classNamesCopy = (_a = Object.assign({}, this.props.classNames)) !== null && _a !== void 0 ? _a : {};
    Object.keys(styles$r).forEach(key => !classNamesCopy[key] ? classNamesCopy[key] = styles$r[key] : classNamesCopy[key]);
    return classNamesCopy;
  }
  render() {
    const model = this.model;
    model.headerInstance = this;
    const count = model.getCount();
    const closedStyle = model.closed && styles$r.closed || "";
    const activeStyle = model.active && "active" || "";
    const activeCustomStyle = model.active && model.activeClassName || "";
    const iconStyle = !!model.title && styles$r.hasText || "";
    const typedHeaderStyle = this.props.headerStyleType == TabContainerHeaderStyleType.Underline ? model.active ? this.css(styles$r.underlineTabStyleActive) : styles$r.underlineTabStyleInactive : "";
    return React.createElement("li", {
      id: this.props.id,
      className: this.css("nav-item", styles$r.tab, closedStyle, model.className, activeCustomStyle, this.classNames.headerTab),
      title: TabContainerLocalizer$1.get(model.tooltip)
    }, React.createElement("a", {
      className: this.css("nav-link", activeStyle, this.classNames.headerLink, typedHeaderStyle),
      onClick: () => this.onClickAsync()
    }, model.icon && React.createElement(Icon, Object.assign({
      className: this.css(styles$r.icon, iconStyle, this.classNames.headerIcon)
    }, model.icon)), TabContainerLocalizer$1.get(model.title), model.onClose && React.createElement(Icon, {
      className: this.css(styles$r.close, this.classNames.headerClose),
      name: "fa fa-times",
      onClick: () => this.onCloseAsync()
    }), count != null && React.createElement("div", {
      className: this.css(styles$r.count, model.countClassName)
    }, React.createElement("span", null, count)), model.closeConfirm && React.createElement(ConfirmationDialog, {
      ref: model.closeConfirmDialogRef,
      title: typeof model.closeConfirm !== "boolean" ? model.closeConfirm : undefined,
      callback: (caller, data) => this.onCloseAsync(true, data)
    })));
  }
}

var css_248z$v = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.tabContainer .nav-tabs {\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: none;\n}\n.tabContainer .nav-tabs .nav-item {\n  margin-bottom: 8px;\n}\n.tabContainer .nav-tabs .nav-item:not(:last-child) {\n  margin-right: 8px;\n}\n.tabContainer .nav-tabs .nav-item .nav-link {\n  color: #495057;\n  cursor: pointer;\n  border-radius: 4px;\n  border-color: #ccc;\n  padding: 6px 12px;\n}\n.tabContainer .nav-tabs .nav-item .nav-link.active {\n  color: white;\n  cursor: default;\n  background-color: rgb(254, 80, 0);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);\n}\n.tabContainer .nav-tabs .nav-item .nav-link:hover:not(.active) {\n  background-color: rgba(227, 227, 226, 0.5);\n}\n.tabContainer .tab-content {\n  height: 100%;\n}\n.tabContainer .tab-content .tab-pane {\n  flex-direction: column;\n}\n.tabContainer .tab-content .tab-pane.active {\n  display: flex;\n}";
styleInject(css_248z$v);

class TabContainer extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      generation: 0
    };
    this._model = null;
  }
  getTabs() {
    return this.childComponents.filter(item => item.isTab).map(item => item);
  }
  forcedReRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        generation: this.state.generation + 1
      });
    });
  }
  initialized() {
    let initialized = false;
    if (this._model != null) {
      const modelTabIds = this._model.getTabIds();
      if (modelTabIds.length == this.children.length) {
        const tabIds = this.getTabs().map(tab => tab.id);
        initialized = tabIds.length === modelTabIds.length && tabIds.every((id, index) => id === modelTabIds[index]);
      }
    }
    return initialized;
  }
  componentDidMount() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.initialized()) {
        yield this.forcedReRenderAsync();
        if (this.model.onSelect) {
          const activeTab = this.model.getActiveTab();
          if (activeTab) {
            yield this.model.onSelect(activeTab);
          }
        }
      }
    });
  }
  get model() {
    const model = this._model || (this._model = TabTransformer.toTabContainer(this.props, this.id));
    if (!this.initialized()) {
      const activeIndex = model.activeIndex;
      const tabs = this.getTabs();
      model.tabs = [];
      tabs.forEach((tab, index) => {
        tab.initialize(model, index);
        const tabModel = tab.model;
        model.tabs.push(tabModel);
      });
      model.activateDefault(activeIndex);
    }
    return model;
  }
  activateTabAsync(tabOrIndexOrId) {
    return this.model.activateTabAsync(tabOrIndexOrId);
  }
  closeTabAsync(tabOrIndexOrId, confirmed, data) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.model.closeTabAsync(tabOrIndexOrId, confirmed, data);
    });
  }
  get tabContainerStyleType() {
    var _a;
    return (_a = this.props.headerStyleType) !== null && _a !== void 0 ? _a : TabContainerHeaderStyleType.Default;
  }
  get classNames() {
    var _a;
    const classNamesCopy = (_a = Object.assign({}, this.props.classNames)) !== null && _a !== void 0 ? _a : {};
    Object.keys(styles$r).forEach(key => !classNamesCopy[key] ? classNamesCopy[key] = styles$r[key] : classNamesCopy[key]);
    return classNamesCopy;
  }
  render() {
    const model = this.model;
    model.instance = this;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$r.tabContainer, "tabContainer", this.props.className, this.classNames.tabContainer)
    }, React.createElement("div", {
      className: this.css(styles$r.navigationContainer, this.classNames.navigationContainer)
    }, React.createElement("div", {
      className: this.css(styles$r.scrollableContainer, this.classNames.scrollableContainer)
    }, React.createElement("ul", {
      className: this.css("nav nav-tabs", styles$r.navTabs, this.classNames.navTabs)
    }, model.tabs.map(tab => React.createElement(TabHeader, {
      id: "tab_" + tab.id,
      model: tab,
      key: "tab_header_" + tab.id,
      classNames: this.classNames,
      headerStyleType: this.tabContainerStyleType
    }))))), React.createElement("div", {
      className: this.css("tab-content", this.classNames.tabContent)
    }, this.children));
  }
}

class Tab extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {};
    this._initialized = false;
    this._rendered = false;
    this._model = null;
    this.isTab = true;
  }
  get model() {
    return this._model || (this._model = TabTransformer.toTab(this.props, this.id));
  }
  get active() {
    return this.model.active;
  }
  reRenderAsync() {
    const _super = Object.create(null, {
      reRenderAsync: {
        get: () => super.reRenderAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.reRenderAsync.call(this);
    });
  }
  // public static getDerivedStateFromProps(nextProps: ITabProps, prevState: ITabState): ITabState | null {
  //
  //     const newClose: boolean = (nextProps.onClose !== prevState..onClose);
  //     const newIcon: boolean = (nextProps.icon !== this.model.icon);
  //     const newClassName: boolean = (nextProps.className !== this.model.className);
  //     const newTitle: boolean = (nextProps.title !== this.model.title);
  //     const newTooltip: boolean = (nextProps.tooltip !== this.model.tooltip);
  //     const newCount: boolean = (nextProps.count !== this.model.count);
  //
  //     return null;
  // }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      const newClose = nextProps.onClose !== this.model.onClose;
      const newIcon = nextProps.icon !== this.model.icon;
      const newClassName = nextProps.className !== this.model.className;
      const newTitle = nextProps.title !== this.model.title;
      const newTooltip = nextProps.tooltip !== this.model.tooltip;
      const newCount = nextProps.count !== this.model.count;
      if (newClose || newIcon || newClassName || newTitle || newTooltip || newCount) {
        this.model.onClose = nextProps.onClose;
        this.model.icon = (_a = nextProps.icon) !== null && _a !== void 0 ? _a : null;
        this.model.className = (_b = nextProps.className) !== null && _b !== void 0 ? _b : null;
        this.model.title = nextProps.title || "";
        this.model.tooltip = nextProps.tooltip || "";
        this.model.count = (_c = nextProps.count) !== null && _c !== void 0 ? _c : null;
        yield this.model.reRenderAsync();
      }
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.active) {
        TabModel.setActiveTab(null);
      }
      yield _super.componentWillUnmount.call(this);
    });
  }
  initialize(container, index) {
    this._model = null;
    this.model.container = container;
    this.model.index = index;
    this._initialized = true;
  }
  static get activeTab() {
    return TabModel.activeTab;
  }
  render() {
    const model = this.model;
    const container = model.container;
    model.instance = this;
    const activeStyle = model.active && "active";
    const scaleStyle = container.scale && "h-100";
    this._rendered = this._initialized && (model.active || container.renderType == TabRenderType.Always || container.renderType == TabRenderType.Once && this._rendered);
    return React.createElement("div", {
      id: this.id,
      className: this.css("tab-pane", styles$r.tab, activeStyle, scaleStyle)
    }, this._rendered && this.children);
  }
}

class FourColumns extends BaseComponent {
  renderRow(left, left2, right, right2) {
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$v.row, this.props.className, "row")
    }, React.createElement("div", {
      className: "col-md-3"
    }, left), React.createElement("div", {
      className: "col-md-3"
    }, left2), React.createElement("div", {
      className: "col-md-3"
    }, right), React.createElement("div", {
      className: "col-md-3"
    }, right2));
  }
  render() {
    const children = this.props.children ? this.children : [];
    return React.createElement(React.Fragment, null, children.length > 0 && this.renderRow(children[0], children[1], children[2], children[3]));
  }
}

class ThreeColumns extends BaseComponent {
  renderRow(rowClassName, left, middle, right) {
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: rowClassName
    }, left), React.createElement("div", {
      className: rowClassName
    }, middle), React.createElement("div", {
      className: rowClassName
    }, right));
  }
  get rowClassName() {
    return this.props.size ? this.props.size === "xs" ? `col-4` : `col-${this.props.size}-4` : `col-md-4`;
  }
  render() {
    const children = this.props.children ? this.children : [];
    return React.createElement("div", {
      id: this.id,
      className: this.css(this.props.className, styles$v.row, "row")
    }, children.length > 0 && this.renderRow(this.rowClassName, children[0], children[1], children[2]));
  }
}

class Scroller extends BaseComponent {
  constructor() {
    super(...arguments);
    this._layoutNode = null;
    this._mainNode = null;
  }
  getLayoutNode() {
    var _a;
    return (_a = this._layoutNode) !== null && _a !== void 0 ? _a : this._layoutNode = this.JQuery(`.${styles$v.layout}`);
  }
  getMainNode() {
    var _a;
    return (_a = this._mainNode) !== null && _a !== void 0 ? _a : this._mainNode = this.JQuery(`.${styles$v.main}`);
  }
  subscribeLayoutEvents() {
    const layoutNode = this.getLayoutNode();
    const windowNode = this.JQuery(window);
    layoutNode.on("scroll", () => this.onContainerScrollAsync());
    windowNode.on("scroll", () => this.onContainerScrollAsync());
  }
  unSubscribeLayoutEvents() {
    const layoutNode = this.getLayoutNode();
    const windowNode = this.JQuery(window);
    layoutNode.off("scroll", () => this.onContainerScrollAsync());
    windowNode.off("scroll", () => this.onContainerScrollAsync());
  }
  onContainerScrollAsync() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onScroll) {
        const layoutNode = this.getLayoutNode();
        if (layoutNode && layoutNode.scrollTop != null && typeof layoutNode.scrollTop === "function") {
          const container = this.getMainNode();
          const position = (_a = layoutNode.scrollTop()) !== null && _a !== void 0 ? _a : 0;
          const height = (_b = container.height()) !== null && _b !== void 0 ? _b : 0;
          if (position && height) {
            yield this.props.onScroll(this, position, height);
          }
        }
      }
    });
  }
  scrollTop() {
    const layoutNode = this.getLayoutNode();
    const layoutScrolled = JQueryUtility.scrollTop(layoutNode) > 0;
    if (layoutScrolled) {
      layoutNode.scrollTop(0);
      return;
    }
    const windowNode = this.JQuery(window);
    const windowScrolled = JQueryUtility.scrollTop(windowNode) > 0;
    if (windowScrolled) {
      windowNode.scrollTop(0);
    }
  }
  scrollBottom() {
    var _a;
    const layoutNode = this.getLayoutNode();
    const container = this.getMainNode();
    const height = (_a = container.height()) !== null && _a !== void 0 ? _a : 0;
    layoutNode.scrollTop(height);
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      this.subscribeLayoutEvents();
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillUnmount.call(this);
      this.unSubscribeLayoutEvents();
    });
  }
  render() {
    return React.createElement(React.Fragment, null);
  }
}

var css_248z$u = ".athenaeum-link-link {\n  color: white;\n  font-family: \"DINProBold\", Arial, sans-serif;\n}\n.athenaeum-link-link:hover {\n  color: white;\n  text-decoration: none;\n}";
var styles$q = {"link":"athenaeum-link-link"};
styleInject(css_248z$u);

class Link extends BaseComponent {
  handleClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
      if (this.route) {
        if (typeof this.route === "function") {
          yield this.route(this);
        } else {
          yield PageRouteProvider.redirectAsync(this.route);
        }
      }
      return false;
    });
  }
  get route() {
    var _a;
    return (_a = this.props.route) !== null && _a !== void 0 ? _a : null;
  }
  get href() {
    return this.route == null || typeof this.route === "function" ? "#" : this.useRouting ? PageRoute.toRelativePath(this.route) : `/${this.route.name}`;
  }
  static toRoute(menuItem) {
    if (menuItem.route) {
      const route = menuItem.route;
      return typeof route === "function" ? () => __awaiter(this, void 0, void 0, function* () {
        return route(menuItem);
      }) : route;
    }
    return null;
  }
  render() {
    return React.createElement("a", {
      id: this.id,
      className: this.css(styles$q.link, this.props.className),
      href: this.href,
      onClick: e => this.handleClickAsync(e)
    }, this.props.children);
  }
}

//Autogenerated
class TopNavLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.searchButtonLanguageItemName = `_D:0`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_D:0`, {
      l: `en`,
      v: `Search`
    }, {
      l: `uk`,
      v: `Search`
    }, {
      l: `sv`,
      v: `Sök`
    }, {
      l: `ru`,
      v: `Search`
    }, {
      l: `pl`,
      v: `Szukaj`
    }, {
      l: `nl`,
      v: `Zoekopdracht`
    }, {
      l: `nb`,
      v: `Søg`
    }, {
      l: `it`,
      v: `Ricerca`
    }, {
      l: `fr`,
      v: `Recherche`
    }, {
      l: `fi`,
      v: `Etsi`
    }, {
      l: `es`,
      v: `Buscar`
    }, {
      l: `de`,
      v: `Suchen`
    }, {
      l: `da`,
      v: `Søg`
    });
  }
  /**
  /* "Search.Button" (Search)
  /* "Localizer.searchButton"
  /* "Localizer.searchButtonLanguageItemName"
  */
  get searchButton() {
    return this.get(`_D:0`);
  }
}
//Singleton
var TopNavLocalizer$1 = new TopNavLocalizer();

var css_248z$t = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-hamburger-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-hamburger-hamburger {\n  background-color: #929292;\n  position: absolute;\n  top: 45px;\n  list-style: none;\n  margin: 0;\n  padding: 0 12px;\n  text-align: left;\n  width: 100%;\n  height: auto;\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease-in-out;\n  z-index: 10;\n}\n.athenaeum-hamburger-hamburger li {\n  border-bottom: 1px #bcbcbc solid;\n}\n.athenaeum-hamburger-hamburger li:last-of-type {\n  border-bottom: none;\n}\n.athenaeum-hamburger-hamburger .athenaeum-hamburger-link {\n  display: block;\n  padding: 8px;\n  transition: all 0.3s;\n}\n.athenaeum-hamburger-hamburger .athenaeum-hamburger-link:hover {\n  color: black;\n}\n.athenaeum-hamburger-hamburger .athenaeum-hamburger-link.athenaeum-hamburger-active {\n  visibility: visible;\n}\n.athenaeum-hamburger-hamburger_open {\n  max-height: 100vh;\n}\n.athenaeum-hamburger-hamburger_open li {\n  display: block;\n}";
var styles$p = {"font-renta":"athenaeum-hamburger-font-renta","hamburger":"athenaeum-hamburger-hamburger","link":"athenaeum-hamburger-link","active":"athenaeum-hamburger-active","hamburger_open":"athenaeum-hamburger-hamburger_open athenaeum-hamburger-hamburger"};
styleInject(css_248z$t);

class Hamburger extends BaseComponent {
  renderMenuItem(item, index) {
    const linkRoute = Link.toRoute(item);
    const pageRoute = typeof linkRoute === "object" ? linkRoute : null;
    const active = pageRoute != null && Comparator.isEqualPageRoute(pageRoute, ch.findPageRoute());
    const activeStyle = active && styles$p.active;
    return React.createElement("li", {
      key: index
    }, React.createElement(Link, {
      className: this.css(styles$p.link, activeStyle),
      route: linkRoute
    }, TopNavLocalizer$1.get(item.label)));
  }
  render() {
    const className = this.props.open ? styles$p.hamburger_open : styles$p.hamburger;
    return React.createElement("ul", {
      className: className
    }, this.props.menuItems.length && this.props.menuItems.map((item, index) => this.renderMenuItem(item, index)));
  }
}

var css_248z$s = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-language-dropdown-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-language-dropdown-dropdown {\n  position: relative;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flagsVisible {\n  display: flex;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-noFlagsVisible {\n  display: flex;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag {\n  display: flex;\n  align-items: center;\n  margin: 0 12px;\n  cursor: pointer;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag img {\n  height: 20px;\n  width: auto;\n  min-width: 100%;\n  object-fit: contain;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag {\n    margin-left: 6px;\n    margin-right: 6px;\n  }\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag.athenaeum-language-dropdown-selected > img {\n  min-width: auto;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag.athenaeum-language-dropdown-selected > span {\n  cursor: pointer;\n  font-family: \"DINProBold\", Arial, sans-serif;\n  margin: auto;\n  color: white;\n  padding: 4px 8px;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag.athenaeum-language-dropdown-selected > span > i {\n  margin-left: 8px;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag.athenaeum-language-dropdown-selected > span:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages {\n  list-style: none;\n  color: white;\n  font-weight: 600;\n  position: absolute;\n  right: 0;\n  top: 32px;\n  margin: 0;\n  padding: 5px 0;\n  background-color: #ee5300;\n  border-radius: 5px;\n  height: auto;\n  z-index: 11;\n  display: none;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages li {\n  display: flex;\n  padding: 4px 20px 4px 8px;\n  cursor: pointer;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages li:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages li img {\n  height: 16px;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages li span {\n  cursor: pointer;\n  font-family: \"DINProBold\", Arial, sans-serif;\n  margin-bottom: 0;\n  white-space: pre;\n}\n.athenaeum-language-dropdown-dropdown_open {\n  display: block !important;\n}";
var styles$o = {"font-renta":"athenaeum-language-dropdown-font-renta","dropdown":"athenaeum-language-dropdown-dropdown","flagsVisible":"athenaeum-language-dropdown-flagsVisible","noFlagsVisible":"athenaeum-language-dropdown-noFlagsVisible","flag":"athenaeum-language-dropdown-flag","selected":"athenaeum-language-dropdown-selected","languages":"athenaeum-language-dropdown-languages","dropdown_open":"athenaeum-language-dropdown-dropdown_open athenaeum-language-dropdown-languages"};
styleInject(css_248z$s);

var img$i = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWX////1FI+BAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1jESgkAQRNHvIgrqwiLQ3P+mJhqYqduBVcwPJ3jZVDVAO5RVr7Zn+qy1DC0Ah/7t/iUjSX0COtUy6qBRPaOGm4PJ3B1MQQ5m8TAKJphgzMxmKZi9MfFTwQTzl4xl+81kB5M9u/joWumkSy1zTQCcxul3ZhrPwAN1ahrILylPwQAAAABJRU5ErkJggg==";

var img$h = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAAXNSR0IArs4c6QAAAAlwSFlzAAAN1wAADdcBQiibeAAAADxQTFRF/0tVR3BM/+FaRkZVRkZV/+FaRkZV/+FaRkZV/+Fa/+FaREZV/7pZ/ztUY0dV//hb/+Fa/0tVRkZVMEVVbXZTjwAAAA90Uk5T8gAGEhkuWXetuPDx/f39An6h/gAAAG5JREFUeNrtz8kRwzAQxMABbfEQfVL556octPPQYxFAV0HAo4Z6AqLUFWt2EH2F66guQ1XdwXRNBzOTSeYacxia+liS/oaUTDLJ3JN5W9LLkr6WtP8M7ckkc4kZDmaoOZgmhuGpiLgzCgK2FmoDTqbHzP9iAuyNAAAAAElFTkSuQmCC";

var img$g = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAY1BMVEVHWKlHcEztVWXeyNjuVmattNmZos9QYa13g79HWKn////y4+r62t7k4e36y9DV1+r4usDCyOP2qLGwuNv0l6Dzh5KdptLxeIWLlsnwanh+isPvXm3tVWVyf71ndbhaabJPX60CUzFfAAAACnRSTlP/AAhIpq6vr7DpzIvbuQAAAaRJREFUeNrtl91ygyAQhaHYWCVqJMQYQ8T3f8oylIySE7aJzUVn2nPpz+eynDkrjHMu8oLdV1maoLJk91XkwiEYf8tUdVmPGRuVvTlMZsyp3k/rMFO3PRqTcSbOxknLYQ3mUil/V7CNPBinc93aZzHTfnsyTsftOytsu/MFHWT/HGaQ2t9yrfVb1IeCds34OMa2dSilm24vye4RTPrTQ6X9VTVfpTC2uTaiS7VrP32L6a6ltDaxeb5jNGYMpWjZp60UzIgYeApKwe8MiIlr1hX4FVbtP4WYuYOn0EEQ7kGPmKHS0D4QOMJGGDBcSmjGJaaXGgxHawhvqCWmXhgOVZKaMbRehTEv0T/mj2F+l4vpEFxiGjUnIykM2yhvOjmHMCUM2wgTJSMhDNsYEydjShC2gAnJCOlFTHfExP8RySyFsAVMWDeV7LaF6Q4YHNPUWCExYSOO96beiFuJmPgFdYYZDNOdwARNN2Ys/FLB5hQGV1CwHNZJYBL9bHMmoOsEBo32VZBgPEMP0Bgc05k/M4QfxzUYZp0Z/ZmBc7H5yQnmQ3DOPwG0K6zxTZL7ngAAAABJRU5ErkJggg==";

var img$f = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWX////1FI+BAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1jESgkAQRNHvIgrqwiLQ3P+mJhqYqduBVcwPJ3jZVDVAO5RVr7Zn+qy1DC0Ah/7t/iUjSX0COtUy6qBRPaOGm4PJ3B1MQQ5m8TAKJphgzMxmKZi9MfFTwQTzl4xl+81kB5M9u/joWumkSy1zTQCcxul3ZhrPwAN1ahrILylPwQAAAABJRU5ErkJggg==";

var img$e = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEX19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/pHWKn19/qK1Gr8AAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1rsSgkAQRNHrIgrqwiKP/v8/NdHATN0OrGJuOMHJpqoB2qGserU902etZWgBOPRv9y8ZSeoT0KmWUQeN6hk13BxM5u5gCnIwi4dRMMEEY2Y2S8HsjYmfCiaYv2Qs228mO5js2cVH10onXWqZawLgNE6/M9N4Bh6m8SCXu4eywgAAAABJRU5ErkJggg==";

var img$d = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAS1BMVEXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWVHWKntVWX////+jxOAAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAIxJREFUSMft1rEOgkAQRdHrIgoqsKjsm///UisLYyPsFMTMLbc4xSSbPIB2zIvemVkpZqbfWvLYAnDoP95XMpLUJ6BTLaMOGtUzarh5MAN3DyYjD+bpwyiYYIJxZuy7UmxtO2OKS17MX544/lQwweyScdl+DwYPZvDZxUevlU661DLXBMBpmrcz83QGXg+eJZulq75nAAAAAElFTkSuQmCC";

var img$c = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAS1BMVEXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWVHWKntVWX////+jxOAAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAIxJREFUSMft1rEOgkAQRdHrIgoqsKjsm///UisLYyPsFMTMLbc4xSSbPIB2zIvemVkpZqbfWvLYAnDoP95XMpLUJ6BTLaMOGtUzarh5MAN3DyYjD+bpwyiYYIJxZuy7UmxtO2OKS17MX544/lQwweyScdl+DwYPZvDZxUevlU661DLXBMBpmrcz83QGXg+eJZulq75nAAAAAElFTkSuQmCC";

var img$b = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAEVQTFRFAAAA9fX19fX19fX19fX19fX19fX19fX19fX19fX1/0tV/0tV/0tV/0tV/0tV/0tV/0tV/0tV/0tV/0tV/0tV/0tV/0tV5R8iRgAAABd0Uk5TABuv/f8P1H3Y9//3yXAPsPoOdtXv+/FE3A+uAAAAaklEQVR4nO3X2w2AIBBE0RFWQZG32n+pxhZkYmKyt4DzfwFSk7EylDUTMC9jyNMyw40rIg6ewXisDGYFQxFRRhlllPmM2Sgpo4wyyvyNCQwlYGcwOyKDiUi5jCIlJ6C2fpTzdeXqrbL+5QZvaVnljPuhEwAAAABJRU5ErkJggg==";

var img$a = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEVKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidz/zlSF6cyWAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1jESgkAQRNHvIgrqwiLQ3P+mJhqYqduBVcwPJ3jZVDVAO5RVr7Zn+qy1DC0Ah/7t/iUjSX0COtUy6qBRPaOGm4PJ3B1MQQ5m8TAKJphgzMxmKZi9MfFTwQTzl4xl+81kB5M9u/joWumkSy1zTQCcxul3ZhrPwAN1ahrILylPwQAAAABJRU5ErkJggg==";

var img$9 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEVKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidz/zlSF6cyWAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1jESgkAQRNHvIgrqwiLQ3P+mJhqYqduBVcwPJ3jZVDVAO5RVr7Zn+qy1DC0Ah/7t/iUjSX0COtUy6qBRPaOGm4PJ3B1MQQ5m8TAKJphgzMxmKZi9MfFTwQTzl4xl+81kB5M9u/joWumkSy1zTQCcxul3ZhrPwAN1ahrILylPwQAAAABJRU5ErkJggg==";

var img$8 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAYAAABe1bwWAAAAAXNSR0IArs4c6QAAAdVJREFUaEPtm79LAmEYx5+3JFRECDkiBBtaOhKEcBENqkXRudlGF0WE/gK3ApEmoSX/idBNKHFR4aA4KIISouKQQNJzsC408gd65bt635sO7pbnc5/nuZeH52E0dnk8HqfP5/ObzWaHpmls/Nmi3jPGtG6326xUKmVJkp5/4xwELwiCLZfLZUOhUJSITIsK4Z+4eoVCIR+LxZKKonz0waxUq9WiKIp7BgUyEbYsyyWv1xtk6XQ6nkqlzgBlRCCTySSYLMs1l8u1AzAjAo1Go87a7XaHiCwAM0FA7YPRAGWaAMDoWAEwAMNXMGAMjIExfARgDB8v1Bg9Y+7uX3t8LI3xNtsPnuPkO+NbA4xeKsGY2WRgDIzh+2nAGBgDY/gIwBg+XqgxMAbG8BGAMXy8UGNgDKcxjXAU/ZhZbQctcoh+DMDMn04Mxuj0YwAGYObPIyJCKumdY5BKSCWkEheBP1IJM3jTcFT2eBCpbVismNocg/OkdursZMsdP94UMec7Bub0QU4MJsNvdoPFbbsdk+FEdNtqldxXxeDPLgGR7cIbyIbX1g29S3D59pI/ql4nFaLBLsHw8lgczoCw6realh1fZIztkyViWqf32bxW3suS2hxun3wDqSDI7dQwlQgAAAAASUVORK5CYII=";

var img$7 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAYAAABe1bwWAAAAAXNSR0IArs4c6QAAAfJJREFUaEPtmz9IAlEcx3/vCEuRgk6HMooIXIyMoMFssCGCWqKhocWWaEqEaInGplykpjZdG5oqiIYcLIdQKnIRooysQS8oRCvkLk6yztTibWXfm+4vd+/D530P3vs9RppNL1otrR39TqFBJ5IgMO21ut2XZUUuvEoPt6dHeSmRKrXzvfFmY9/Uil/sHnYTUUPdQvi+YQXpKhw83171EqWzKhjdoHtr32jqcf1TIGXNzmYuQyfB6THWM+RZ6HS41wHlk8BNJOhhjrmdaFNz2wDAfBJ4frqPsZHFaI6I9ABTRiCvglEApZIAwNSwAmAAhi8wYAyMgTF8BGAMHy9kDIyBMXwEYAwfL2QMjIExfARgDB8vZEwtYwJbGwqRdqZEO2719bx6rF4vndfuq28oHVcb+/ppNqb0zO/4FqYkZzCCV8UagKnVlWBMdTIwBsZw/q7RldCVuJRBxiBjuIQhGANjYAwfARjDxwsZA2NgDB8BGMPHS80Y1OBVMsuz6+PJaJfFgKpNDZxkKhdja8v2haV5G+p8NWB8m3FPsTL84mBi32ZtQWU4EcUTj6He0d2x4pC82UzGgM/lHx9p/9drCfYO74KzSyFvOk3FtQQfm90qWoYdJqehURBlpWxOhS/S/9DdAiMl9yJL4Ujm6Cwhfaw+eQOsa9bCTNoW2AAAAABJRU5ErkJggg==";

var img$6 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAYAAABe1bwWAAAAAXNSR0IArs4c6QAAAfJJREFUaEPtmz9IAlEcx3/vCEuRgk6HMooIXIyMoMFssCGCWqKhocWWaEqEaInGplykpjZdG5oqiIYcLIdQKnIRooysQS8oRCvkLk6yztTibWXfm+4vd+/D530P3vs9RppNL1otrR39TqFBJ5IgMO21ut2XZUUuvEoPt6dHeSmRKrXzvfFmY9/Uil/sHnYTUUPdQvi+YQXpKhw83171EqWzKhjdoHtr32jqcf1TIGXNzmYuQyfB6THWM+RZ6HS41wHlk8BNJOhhjrmdaFNz2wDAfBJ4frqPsZHFaI6I9ABTRiCvglEApZIAwNSwAmAAhi8wYAyMgTF8BGAMHy9kDIyBMXwEYAwfL2QMjIExfARgDB8vZEwtYwJbGwqRdqZEO2719bx6rF4vndfuq28oHVcb+/ppNqb0zO/4FqYkZzCCV8UagKnVlWBMdTIwBsZw/q7RldCVuJRBxiBjuIQhGANjYAwfARjDxwsZA2NgDB8BGMPHS80Y1OBVMsuz6+PJaJfFgKpNDZxkKhdja8v2haV5G+p8NWB8m3FPsTL84mBi32ZtQWU4EcUTj6He0d2x4pC82UzGgM/lHx9p/9drCfYO74KzSyFvOk3FtQQfm90qWoYdJqehURBlpWxOhS/S/9DdAiMl9yJL4Ujm6Cwhfaw+eQOsa9bCTNoW2AAAAABJRU5ErkJggg==";

var img$5 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAIRQTFRFAAAAQUebQUebQUebQUebQUebvb/Z9fX1+Lu//0tV/0tV/0tV/0tV/0tVQUebQUebQUebQUebvb/Z9fX1+Lu//0tV/0tV/0tV/0tVQUebQUebQUeb/0tV/0tV/0tVQUeb/0tVQUeb/0tVQUeb/0tV/0tVQUebQUebQUeb/0tV/0tV/0tVz/IHvwAAACx0Uk5TAAIwX3Z3dHd0d3ZkMAIOkfv/+P/4//uRDg+w+vqwD31908n399Mbr/39rxvXC8N6AAAAhElEQVR4nO3XzR6BYBTE4YlCRJKD8lFUSPd/f9jW2bw/x27+F/CsZwB4o7Ef9JtM1WZhv/kiWuLTKl4nwzap2laG7fYHIMuPiuLCyOl8QaEhboxIiasFc0NlwdTQFUdGyJAhQ4YMGTJkyPyVMdp+Jku0sdrFRisd98fzN6Z9dd/vYfFg3mrd7rONIXzzAAAAAElFTkSuQmCC";

var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAY1BMVEVHWKlHcEztVWXeyNjuVmattNmZos9QYa13g79HWKn////y4+r62t7k4e36y9DV1+r4usDCyOP2qLGwuNv0l6Dzh5KdptLxeIWLlsnwanh+isPvXm3tVWVyf71ndbhaabJPX60CUzFfAAAACnRSTlP/AAhIpq6vr7DpzIvbuQAAAaRJREFUeNrtl91ygyAQhaHYWCVqJMQYQ8T3f8oylIySE7aJzUVn2nPpz+eynDkrjHMu8oLdV1maoLJk91XkwiEYf8tUdVmPGRuVvTlMZsyp3k/rMFO3PRqTcSbOxknLYQ3mUil/V7CNPBinc93aZzHTfnsyTsftOytsu/MFHWT/HGaQ2t9yrfVb1IeCds34OMa2dSilm24vye4RTPrTQ6X9VTVfpTC2uTaiS7VrP32L6a6ltDaxeb5jNGYMpWjZp60UzIgYeApKwe8MiIlr1hX4FVbtP4WYuYOn0EEQ7kGPmKHS0D4QOMJGGDBcSmjGJaaXGgxHawhvqCWmXhgOVZKaMbRehTEv0T/mj2F+l4vpEFxiGjUnIykM2yhvOjmHMCUM2wgTJSMhDNsYEydjShC2gAnJCOlFTHfExP8RySyFsAVMWDeV7LaF6Q4YHNPUWCExYSOO96beiFuJmPgFdYYZDNOdwARNN2Ys/FLB5hQGV1CwHNZJYBL9bHMmoOsEBo32VZBgPEMP0Bgc05k/M4QfxzUYZp0Z/ZmBc7H5yQnmQ3DOPwG0K6zxTZL7ngAAAABJRU5ErkJggg==";

var img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAAXNSR0IArs4c6QAAAAlwSFlzAAAXEgAAFxIBZ5/SUgAAAG9QTFRF/0tV5JSj8Jeh2omd+5GX+4uRoWyXnGiW/ImQ9fX19uXm5ufu9uDh99fY99LU2tvo+MXI+MDDx8nf+qWq+qCl06y/tLbVpKfNlZjF/mZuiIy+/lhifoG5c3azZWqtW2Coj0p/UVWiSU6fREmcQUebiaaergAAAAl0Uk5T/wEnYH+jusnR8xarSgAAAd5JREFUeNrd1NFu2zAMhWE5Sdem3upV2yxHkchQ/N//GTejAwoMWKoivij6+Uq8ODBEHIVhGPZf7v/v7k37PxFh2BvXXMKbToch7IxbY8JpF+6x3IBW1QGrBrjK3xmXc4eHoKSxAhZjA/K4AG2OCtQxUb49dXzByXNDnLRgSp0LAktqCDpn8rFHYFWnxaHFqQIyJaDlsQD0xwiaKmYsSVE8ZcyQ9dAo33sESFMBNEYDz9MC2BwVp0wLl9AFlmgYbZ69GSVmDE+zYch7YsxcYnGzlmZpZromWauxNrP+GAyJhdZIUTFaXNZDjYI5+bFHAElqapZLUzVJ4qqt5HWkqfZvKo2K02J0nDwu62GeDKceU3+MatMkLtJK0lWqqJrMairU5x4BwGXMAHEUwMYEeDkKQP+mslmRVsVrMSvmpbrUpkWtSH9MGuVKNbtjam6WlVJcikmWlpVammXTXN9zN9SXf4hjBddxfq2mv7ea+lJNwVPhtZp9Mf9Uk+W1mlCm9dnqEUASQFsKgCYFKIuzziqXc4/AFe70bqpxTXfM06/rnvtev+Mmtor5uonwKf3cxAdb+NMmwnkT4WP5sYmP1vDHLYSH0wYewu4Ubnbeh2F/ujnlMIRh2B3ubnLYDcNvSuW21lP3LU8AAAAASUVORK5CYII=";

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAFRQTFRFAAAAc68Ac68Ac68Ac68A/////0tV/0tV/0tV/0tVc68Ac68Ac68A/0tV/0tV/0tVc68A/0tVc68A/0tVc68A/0tVc68Ac68Ac68A/0tV/0tV/0tVaDJQ7QAAABx0Uk5TABuv/f////2vGw+w+vqwD31909P39w6R+/uRDhS9a0UAAABnSURBVHic7de3FYAwFENRkT45Z9h/TwawKXwQnd4At5YAUlGcpG7ZS+aWFyVQ1Y1HCWGs7XoMPiSMMRsxMZgZC4NZ4VcCGRMjRowYMWLEiBHzK0PafqQlStrFpJWObT++Med1s/7LA3oCPuTTuZByAAAAAElFTkSuQmCC";

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAA5FBMVEVHcEz/0lDIQEvIQUvIQUvHP0vIQUv4vU/CMUvxrU/wqk/IQUv/5VHENUvIQUvIQUvIQUv/0lDIQUv/6VHHPkvFOUv/4lH6/v7/0Eb/1VD/2k//4UPlg0b9y076s0H9+sQ2V7TplE2/JED/zTfNUlnYWzr5qD3soUL66rv/7Ff95ZX/1zfdcEb9+ub05fjIsm3VcnZjcKH+2XHcf37ZiJbqw73/6DPTt2f/ySe0DU7vslz53qHPMx+taWjlrKP+w+b9rdvy3dHCP2///D7/cb6qu9nRRSTaPULKPDXywX+uPl+XQGk56mZHAAAAEXRSTlMA8vCud/1Z/f7++cvy8RxAZ/U0M3sAAAIqSURBVHjaxdbZctowFIBhhZIYKJBYwpYsyzbejTdMWMKeQNskbd//fSo3N530psLq5Ls8M/5Hy3hGgBve3jQxBL+1YUNtwH2CjX0G4AZK0K4XI2M5LdjcdUtKBsrLjCRogUFHggHodSXogT762wQJ6oMr9T3ft3yfqCKu3mfIep0mdpL4a9IgQ0jqYEdJcZEScnnGT3C5CGE4L3FCyGUZahCCl8+eBzve/ogNwifiGapT1bzfhK631RjbfNcJnwhnUOy5yDDjnOUszHPmG6jXYUg0M3E3DFHVsiPbthRlQgmf5MgQyxj191SBGoTeAtdSn08soQzn7/BulWuRGz1XuHwqcbLeFYkluCkrc7DzxfVi0/bm+PHrE3ZWDi50Syyj29VizgItMu39W2YZVouqp4tlUBcGQdgJIhYdxt/wY4mXr0EwctElm4o72suP8Zh3yjLJElxQoU1x2e6ouRMG7QPP/HwZdZgFFydKBDfV84K5ZTKohIfZIY6i1xC5gedOxDLUPmLHJAzagctCklt5wG9q2aUXnE1m1BnmjhSmBOEqwYVORM8mLdIMMc/e58V5H4WeskqLhAhmqBLHsaIr1bZa4lNwPm+RtY3jrmqIZAxjxi9oZpmTBNdOKaJvEyr2az5Mp9MH1SCE3nM0qyec0Go4s6ZyxPd98sfknzJ9XYI+UKQArdF1Y/VTQJNg8B+eSR+fkfUSvYMStGW90nlHRoUb3rWbuAUA/AK71O4htK65EwAAAABJRU5ErkJggg==";

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAACXBIWXMAAA4mAAAOJgGi7yX8AAAAPFBMVEX29/dHcExBR5v/S1X/S1VBR5v/S1VBR5v/S1VBR5v/S1X9Zm5wdbP6/v73+fn19fX/S1X/N0JBR5slLI3RB13QAAAADXRSTlPyAAYSGS5Zd63o8f39XfUgEwAAAIFJREFUeNrt00sOwjAQBNFqQ/wDB2Puf1fukOlV5LfwstSyNEh65JCnJJTyjOlVQnWGVZGnQaZOg0qfBn1nduZS5mvBywJOA2CMc4zYM4CPwc7szA0yvtM0gLcFPwvaMmiuzLIwrfFlHFimNXf84rIMCmqGMQmpRCMtCSkdJeSQ9Afgg8Q7zRg6VwAAAABJRU5ErkJggg==";

const flags = {
  //Language codes:
  fi: img$e,
  sv: img$9,
  nb: img$d,
  da: img$i,
  pl: img$b,
  ru: img$8,
  uk: img$7,
  de: img$h,
  fr: img$5,
  en: img$g,
  it: img$2,
  es: img$1,
  nl: img,
  // Country codes
  dk: img$f,
  no: img$c,
  se: img$a,
  ua: img$6,
  gb: img$4,
  us: img$3
};
class LanguageDropdown extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      currentLanguage: this.getCurrentLanguage(),
      isOpen: false
    };
  }
  getCurrentLanguage() {
    return this.props.languages.find(language => language.code === this.props.currentLanguage);
  }
  dropdownToggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let isOpen = !this.state.isOpen;
      yield this.setState({
        isOpen
      });
    });
  }
  closeDropdownAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
    });
  }
  onLanguageChangeAsync(language) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.currentLanguage.code !== language.code) {
        yield this.setState({
          currentLanguage: language
        });
        if (this.props.onChange) {
          this.props.onChange(this, language.code);
        }
      }
      yield this.closeDropdownAsync();
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      let target = e.target;
      let container = document.querySelector(`.${styles$o.dropdown}`);
      let outside = container != null && !container.contains(target);
      if (outside) {
        yield this.closeDropdownAsync();
      }
    });
  }
  get flagsVisible() {
    const noFlags = this.props.noFlags != null ? typeof this.props.noFlags === "function" ? this.props.noFlags() : this.props.noFlags : null;
    return noFlags !== true;
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newLanguage = nextProps.currentLanguage != this.props.currentLanguage;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newLanguage) {
        const currentLanguage = this.getCurrentLanguage();
        yield this.setState({
          currentLanguage
        });
      }
    });
  }
  render() {
    const flagsVisible = this.flagsVisible;
    const isOpenStyle = this.state.isOpen ? styles$o.dropdown_open : styles$o.languages;
    const flagsVisibilityStyle = flagsVisible ? styles$o.flagsVisible : styles$o.noFlagsVisible;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$o.dropdown, this.props.className, flagsVisibilityStyle)
    }, React.createElement("div", {
      className: this.css(styles$o.flag, styles$o.selected),
      onClick: () => this.dropdownToggleAsync()
    }, flagsVisible ? React.createElement("img", {
      src: flags[this.state.currentLanguage.code],
      alt: this.state.currentLanguage.label
    }) : React.createElement("span", null, this.state.currentLanguage.label, React.createElement(Icon, {
      name: "fa-caret-down",
      size: IconSize.Normal
    }))), React.createElement("ul", {
      className: isOpenStyle
    }, this.props.languages.map((language, index) => React.createElement("li", {
      key: index,
      onClick: () => this.onLanguageChangeAsync(language)
    }, flagsVisible && React.createElement("div", {
      className: styles$o.flag
    }, React.createElement("img", {
      src: flags[language.code],
      alt: language.label
    })), React.createElement("span", null, language.label)))));
  }
}

var css_248z$r = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-search-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-search-dropdown {\n  position: relative;\n  margin-left: 6px;\n  margin-right: 6px;\n  color: #ffffff;\n  cursor: pointer;\n}\n.athenaeum-search-dropdown .athenaeum-search-searchInput {\n  margin-bottom: 0 !important;\n}\n.athenaeum-search-dropdown .athenaeum-search-searchContainer {\n  color: white;\n  font-weight: 600;\n  position: absolute;\n  right: 0;\n  top: 37px;\n  margin: 0;\n  padding: 5px 5px;\n  background-color: #ee5300;\n  border-radius: 5px;\n  height: auto;\n  z-index: 11;\n  display: none;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n}\n@media screen and (max-width: 640px) {\n  .athenaeum-search-dropdown .athenaeum-search-searchContainer {\n    right: -65px;\n  }\n}\n.athenaeum-search-dropdown_open {\n  display: block !important;\n}";
var styles$n = {"font-renta":"athenaeum-search-font-renta","dropdown":"athenaeum-search-dropdown","searchInput":"athenaeum-search-searchInput","searchContainer":"athenaeum-search-searchContainer","dropdown_open":"athenaeum-search-dropdown_open athenaeum-search-searchContainer"};
styleInject(css_248z$r);

class Search extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false
    };
    this._searchInputModel = {
      value: ""
    };
    this._searchInputRef = React.createRef();
  }
  dropdownToggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const isOpen = !this.state.isOpen;
      yield this.setState({
        isOpen
      });
      if (isOpen && this._searchInputRef.current) {
        this._searchInputRef.current.focus();
      }
    });
  }
  closeDropdownAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
    });
  }
  onSearchButtonCLickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._searchInputModel.value.length >= 3 && this.props.onSearch) {
        yield this.props.onSearch(this._searchInputModel.value);
      }
      this._searchInputModel.value = "";
      yield this.closeDropdownAsync();
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const container = document.querySelector(`.${styles$n.dropdown}`);
      const outside = container != null && !container.contains(target);
      if (outside) {
        yield this.closeDropdownAsync();
      }
    });
  }
  get isOpen() {
    return this.state.isOpen;
  }
  render() {
    const className = this.state.isOpen ? styles$n.dropdown_open : styles$n.searchContainer;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$n.dropdown, this.props.className)
    }, React.createElement(Icon, {
      name: "search",
      size: IconSize.X2,
      className: this.props.className,
      onClick: () => this.dropdownToggleAsync()
    }), React.createElement("div", {
      className: className
    }, React.createElement(Form, {
      inline: true,
      submitOnEnter: true,
      onSubmit: () => this.onSearchButtonCLickAsync()
    }, React.createElement(TextInput, {
      ref: this._searchInputRef,
      placeholder: this.props.searchPlaceHolder,
      className: styles$n.searchInput,
      width: this.isOpen ? "250px" : "50px",
      model: this._searchInputModel
    }), React.createElement(Button, {
      submit: true,
      label: TopNavLocalizer$1.searchButton
    }))));
  }
}

var css_248z$q = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-menu-item-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content {\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content.athenaeum-menu-item-separator {\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content:not(.athenaeum-menu-item-separator) {\n  cursor: pointer;\n  padding: 8px 16px;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content:hover:not(.athenaeum-menu-item-separator) {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content .athenaeum-menu-item-element:not(:last-child) {\n  padding-right: 12px;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content .athenaeum-menu-item-element.athenaeum-menu-item-count {\n  font-size: 12px;\n  background: #000000;\n  color: #fff;\n  vertical-align: top;\n  margin-left: -10px;\n  margin-top: -15px;\n  padding-left: 9px;\n  padding-right: 9px;\n  border-radius: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content .athenaeum-menu-item-element.athenaeum-menu-item-count.athenaeum-menu-item-inline {\n  margin: 0;\n}";
var styles$m = {"font-renta":"athenaeum-menu-item-font-renta","menuItem":"athenaeum-menu-item-menuItem","content":"athenaeum-menu-item-content","separator":"athenaeum-menu-item-separator","element":"athenaeum-menu-item-element","count":"athenaeum-menu-item-count","inline":"athenaeum-menu-item-inline"};
styleInject(css_248z$q);

class MenuItem extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
      if (this.route) {
        if (typeof this.route === "function") {
          yield this.route(this.props);
        } else {
          yield PageRouteProvider.redirectAsync(this.route);
        }
      }
      if (this.props.onClick) {
        yield this.props.onClick(this);
      }
      return false;
    });
  }
  getCount() {
    return this.props.count != null ? typeof this.props.count === "function" ? this.props.count() : this.props.count : null;
  }
  get route() {
    var _a;
    return (_a = this.props.route) !== null && _a !== void 0 ? _a : null;
  }
  get isSeparator() {
    return this.label === "-";
  }
  get label() {
    return this.props.label;
  }
  get icon() {
    var _a;
    return (_a = this.props.icon) !== null && _a !== void 0 ? _a : null;
  }
  get count() {
    return this.getCount();
  }
  render() {
    const count = this.getCount();
    const separatorStyle = this.isSeparator && styles$m.separator;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$m.menuItem, this.props.className, separatorStyle)
    }, this.isSeparator ? React.createElement("hr", {
      className: this.css(styles$m.content, separatorStyle)
    }) : React.createElement("div", {
      className: this.css(styles$m.content),
      onClick: e => this.onClickAsync(e)
    }, this.icon && Icon.renderIcon(this.icon, this.css(styles$m.element, styles$m.icon), IconSize.X2), this.label && React.createElement("span", {
      className: this.css(styles$m.element, styles$m.label)
    }, TopNavLocalizer$1.get(this.label)), count != null && React.createElement("div", {
      className: this.css(styles$m.element, styles$m.count, styles$m.inline, this.props.countClassName)
    }, React.createElement("span", null, count))));
  }
}

var css_248z$p = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-user-profile-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-user-profile-userProfile {\n  padding: 32px;\n  background-color: rgb(65, 64, 66);\n  display: flex;\n  align-items: center;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-avatar img {\n  border-radius: 50%;\n  border: 1px solid white;\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n  object-position: center;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info {\n  margin-left: 24px;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-label {\n  color: #adadad;\n  white-space: nowrap;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-label.athenaeum-user-profile-fullName {\n  font-size: 1.3em;\n  font-weight: bold;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-label.athenaeum-user-profile-roleName {\n  font-size: 0.9em;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-rating {\n  padding-top: 8px;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-rating .athenaeum-user-profile-star {\n  color: #adadad;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-rating .athenaeum-user-profile-star:not(:first-child) {\n  margin-left: 8px;\n}";
var styles$l = {"font-renta":"athenaeum-user-profile-font-renta","userProfile":"athenaeum-user-profile-userProfile","avatar":"athenaeum-user-profile-avatar","info":"athenaeum-user-profile-info","label":"athenaeum-user-profile-label","fullName":"athenaeum-user-profile-fullName","roleName":"athenaeum-user-profile-roleName","rating":"athenaeum-user-profile-rating","star":"athenaeum-user-profile-star"};
styleInject(css_248z$p);

class UserProfile extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  get profile() {
    return this.props;
  }
  get rating() {
    var _a;
    const rating = [];
    for (let i = 0; i < ((_a = this.profile.rating) !== null && _a !== void 0 ? _a : 0); i++) {
      rating[i] = i;
    }
    return rating;
  }
  render() {
    var _a;
    if (this.profile.render) {
      return this.profile.render(this.props);
    }
    return React.createElement("div", {
      id: this.id,
      className: this.css(this.props.className, styles$l.userProfile)
    }, React.createElement("div", {
      className: styles$l.avatar
    }, Icon.renderIcon((_a = this.profile.avatar) !== null && _a !== void 0 ? _a : "fa fa-user-circle", styles$l.avatar, IconSize.X5)), React.createElement("div", {
      className: styles$l.info
    }, React.createElement("span", {
      className: this.css(styles$l.label, styles$l.fullName)
    }, this.profile.userFullName), React.createElement("span", {
      className: this.css(styles$l.label, styles$l.roleName)
    }, TopNavLocalizer$1.get(this.profile.roleName)), React.createElement("div", {
      className: styles$l.rating
    }, this.rating.map(index => React.createElement(Icon, {
      key: index,
      className: styles$l.star,
      name: "fas fa-star",
      size: IconSize.Normal
    })))));
  }
}

var css_248z$o = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-profile-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-profile-profile {\n  position: relative;\n}\n.athenaeum-profile-profile .athenaeum-profile-icon {\n  cursor: pointer;\n  color: white;\n}\n.athenaeum-profile-profile .athenaeum-profile-container {\n  background-color: rgb(254, 80, 0);\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  color: white;\n  top: 37px;\n  right: 0;\n  margin-right: -35px;\n  min-width: 35px;\n  height: auto;\n  font-weight: 600;\n  position: absolute;\n  z-index: 11;\n  display: none;\n  user-select: none;\n  overflow: hidden;\n}\n.athenaeum-profile-profile .athenaeum-profile-container .athenaeum-profile-itemsContainer {\n  padding: 8px 0;\n}\n.athenaeum-profile-profile .athenaeum-profile-container.athenaeum-profile-expanded {\n  display: block !important;\n}";
var styles$k = {"font-renta":"athenaeum-profile-font-renta","profile":"athenaeum-profile-profile","icon":"athenaeum-profile-icon","container":"athenaeum-profile-container","itemsContainer":"athenaeum-profile-itemsContainer","expanded":"athenaeum-profile-expanded"};
styleInject(css_248z$o);

class Profile extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      expanded: false
    };
  }
  get containerId() {
    return `${this.id}_container`;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const expanded = !this.state.expanded;
      yield this.setState({
        expanded
      });
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded) {
        yield this.setState({
          expanded: false
        });
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.closeAsync();
        }
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && e.keyCode == 27) {
        yield this.closeAsync();
      }
    });
  }
  static findUserProfile() {
    const context = ch.findContext();
    const userContext = context;
    if (userContext) {
      const user = userContext.user;
      if (user) {
        const transformProvider = ServiceProvider.findTransformProvider();
        const userFullName = (transformProvider === null || transformProvider === void 0 ? void 0 : transformProvider.toString(user)) || Utility.findStringValueByAccessor(user, ["fullName", "username", "login"]);
        if (userFullName) {
          const roleNameAccessor = ["role.Name", "role.roleName", "roleName"];
          const role = Utility.findValueByAccessor(userContext, "role") || Utility.findValueByAccessor(user, "role");
          const roleName = (transformProvider === null || transformProvider === void 0 ? void 0 : transformProvider.toString(role)) || Utility.findStringValueByAccessor(userContext, roleNameAccessor) || Utility.findStringValueByAccessor(user, roleNameAccessor);
          const rating = Utility.findValueByAccessor(user, "rating");
          const avatar = Utility.findValueByAccessor(user, "avatar");
          return {
            userFullName,
            roleName,
            rating,
            avatar
          };
        }
      }
    }
    return null;
  }
  static resolveUserProfile(resolver, userProfile) {
    return userProfile != null ? typeof userProfile === "function" ? userProfile(resolver) : typeof userProfile === "boolean" ? userProfile ? Profile.findUserProfile() : null : userProfile : null;
  }
  getUserProfile() {
    return Profile.resolveUserProfile(this, this.props.userProfile);
  }
  get items() {
    var _a;
    return (_a = this.props.items) !== null && _a !== void 0 ? _a : [];
  }
  get expanded() {
    return this.state.expanded;
  }
  render() {
    const userProfile = this.getUserProfile();
    const expandedStyle = this.state.expanded && styles$k.expanded;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$k.profile, this.props.className, expandedStyle)
    }, React.createElement("div", {
      className: styles$k.icon,
      onClick: () => this.toggleAsync()
    }, Icon.renderIcon(this.props.icon || "far user-circle", null, IconSize.X2)), this.items && React.createElement("div", {
      id: this.containerId,
      className: this.css(styles$k.container, expandedStyle)
    }, React.createElement("div", {
      className: styles$k.userProfileContainer
    }, userProfile && React.createElement(UserProfile, Object.assign({}, userProfile))), React.createElement("div", {
      className: styles$k.itemsContainer
    }, this.items.map((item, index) => React.createElement(MenuItem, Object.assign({
      key: index
    }, item, {
      onClick: () => this.closeAsync()
    }))))));
  }
}

var css_248z$n = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-top-nav-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-top-nav-navigation {\n  background-color: rgb(254, 80, 0);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  height: 45px;\n  min-height: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1000;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-left {\n  display: flex;\n  height: inherit;\n  align-items: center;\n  position: absolute;\n  left: 0;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon {\n  color: white;\n  cursor: pointer;\n  padding: 0 12px;\n  margin-right: -8px;\n  height: inherit;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon.athenaeum-top-nav-noBackButton {\n  display: none;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon.athenaeum-top-nav-noBackButton {\n    display: flex;\n    visibility: collapse;\n    width: 0;\n    cursor: default;\n    pointer-events: none;\n  }\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon i {\n  font-size: 1.6em;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon:hover {\n  background-color: rgb(234, 60, 0);\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon {\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 6px;\n    padding-right: 6px;\n  }\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-left_leftNav {\n  color: white;\n  cursor: pointer;\n  text-align: center;\n  min-width: 25px;\n}\n@media screen and (min-width: 480px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-left_leftNav {\n    min-width: 32px;\n  }\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-left_leftNav:not(:first-child) {\n    padding-left: 6px;\n  }\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-left img {\n  height: 32px;\n  margin: 0 12px;\n  cursor: pointer;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-left img {\n    height: 24px;\n    margin-left: 6px;\n    margin-right: 6px;\n  }\n}\n@media screen and (max-width: 310px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-left img {\n    height: 16px;\n  }\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-left span {\n  font-size: 1.8em;\n  color: white;\n  opacity: 0.9;\n  margin-bottom: -4px;\n  white-space: nowrap;\n}\n@media screen and (max-width: 310px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-left span {\n    font-size: 1.4em;\n  }\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-middle {\n  display: flex;\n  height: inherit;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-middle .athenaeum-top-nav-link {\n  padding: 0 16px;\n  height: inherit;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-middle .athenaeum-top-nav-link:hover {\n  background-color: rgb(234, 60, 0);\n}\n@media screen and (max-width: 1460px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-middle .athenaeum-top-nav-link {\n    display: none;\n  }\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-middle .athenaeum-top-nav-link.athenaeum-top-nav-active {\n  visibility: visible;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-right {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 0;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-right_search {\n  margin-left: 6px;\n  margin-right: 6px;\n  color: #ffffff;\n  cursor: pointer;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-right_shoppingCart {\n  color: #ffffff;\n  cursor: pointer;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-right_shoppingCartCount {\n  font-size: 12px;\n  background: #000000;\n  color: #fff;\n  vertical-align: top;\n  margin-left: -10px;\n  margin-top: -15px;\n  padding-left: 9px;\n  padding-right: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n  border-radius: 9px;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-right_notifications {\n  color: #ffffff;\n  cursor: pointer;\n  margin-left: 6px;\n  margin-right: 6px;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-right_notificationsCount {\n  font-size: 12px;\n  background: #000000;\n  color: #fff;\n  vertical-align: top;\n  margin-left: -18px;\n  margin-top: -15px;\n  padding-left: 9px;\n  padding-right: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n  border-radius: 9px;\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-right_infoIcon {\n  color: white;\n  margin: 0 12px;\n  cursor: pointer;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-right_infoIcon {\n    margin-left: 6px;\n    margin-right: 6px;\n  }\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-right_hamburgerIcon {\n  display: none;\n  cursor: pointer;\n  color: white;\n  margin: 0 12px;\n  width: 25px;\n  z-index: 1;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-right_hamburgerIcon {\n    margin-left: 6px;\n    margin-right: 6px;\n  }\n}\n@media screen and (max-width: 1460px) {\n  .athenaeum-top-nav-navigation .athenaeum-top-nav-right_hamburgerIcon {\n    display: flex;\n  }\n}\n.athenaeum-top-nav-navigation .athenaeum-top-nav-hover:hover, .athenaeum-top-nav-navigation .athenaeum-top-nav-right_hamburgerIcon:hover {\n  color: black;\n}";
var styles$j = {"font-renta":"athenaeum-top-nav-font-renta","navigation":"athenaeum-top-nav-navigation","left":"athenaeum-top-nav-left","left_backIcon":"athenaeum-top-nav-left_backIcon","noBackButton":"athenaeum-top-nav-noBackButton","left_leftNav":"athenaeum-top-nav-left_leftNav","middle":"athenaeum-top-nav-middle","link":"athenaeum-top-nav-link","active":"athenaeum-top-nav-active","right":"athenaeum-top-nav-right","right_search":"athenaeum-top-nav-right_search","right_shoppingCart":"athenaeum-top-nav-right_shoppingCart","right_shoppingCartCount":"athenaeum-top-nav-right_shoppingCartCount","right_notifications":"athenaeum-top-nav-right_notifications","right_notificationsCount":"athenaeum-top-nav-right_notificationsCount","right_infoIcon":"athenaeum-top-nav-right_infoIcon","right_hamburgerIcon":"athenaeum-top-nav-right_hamburgerIcon","hover":"athenaeum-top-nav-hover"};
styleInject(css_248z$n);

var TopMenuContainer;
(function (TopMenuContainer) {
  TopMenuContainer[TopMenuContainer["Left"] = 0] = "Left";
  TopMenuContainer[TopMenuContainer["Middle"] = 1] = "Middle";
  TopMenuContainer[TopMenuContainer["Right"] = 2] = "Right";
})(TopMenuContainer || (TopMenuContainer = {}));
class TopNav extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isHamburgerOpen: false,
      data: null,
      isLoading: false,
      shoppingCart: null
    };
    this._profile = null;
  }
  backAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      PageRouteProvider.back();
    });
  }
  toggleLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const leftNav = this.leftNav;
      if (leftNav) {
        yield leftNav.toggleAsync();
        if (this.props.onLeftNavToggle) {
          yield this.props.onLeftNavToggle(this);
        }
      }
    });
  }
  onShoppingCartClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onShoppingCartClick) {
        yield this.props.onShoppingCartClick(this);
      }
    });
  }
  onNotificationsClickAsync(notifications) {
    return __awaiter(this, void 0, void 0, function* () {
      if (notifications.onClick) {
        yield notifications.onClick(this);
      }
      if (this.props.onNotificationsClick) {
        yield this.props.onNotificationsClick(this);
      }
    });
  }
  toggleHamburgerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const isHamburgerOpen = !this.state.isHamburgerOpen;
      yield this.setState({
        isHamburgerOpen
      });
    });
  }
  closeHamburgerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isHamburgerOpen: false
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const container = document.querySelector(`.${styles$j.right_hamburgerIcon}`);
      const outsideHamburgerIcon = container != null && !container.contains(target);
      if (outsideHamburgerIcon) {
        yield this.closeHamburgerAsync();
      }
    });
  }
  onLogoClick() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onLogoClick) {
        yield this.props.onLogoClick(this);
      }
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      TopNav.mountedInstance = this;
      yield _super.componentDidMount.call(this);
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      TopNav.mountedInstance = null;
      yield _super.componentWillUnmount.call(this);
    });
  }
  onLanguageChangeAsync(language) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.setLanguageAsync(language);
      if (this.props.onChangeLanguage) {
        yield this.props.onChangeLanguage(this, language);
      }
    });
  }
  fetchDataAsync() {
    const _super = Object.create(null, {
      fetchDataAsync: {
        get: () => super.fetchDataAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._profile = null;
      if (this.props.fetchShoppingCart) {
        const shoppingCart = yield this.props.fetchShoppingCart(this);
        yield this.setState({
          shoppingCart
        });
      }
      if (this.props.fetchItems) {
        return yield this.props.fetchItems(this);
      }
      return _super.fetchDataAsync.call(this);
    });
  }
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onFetchItems) {
        yield this.props.onFetchItems(this);
      }
    });
  }
  get searchPlaceHolder() {
    return this.props.searchPlaceHolder ? this.props.searchPlaceHolder() : "";
  }
  get languages() {
    const languages = this.props.languages != null ? typeof this.props.languages === "function" ? this.props.languages() : this.props.languages : null;
    return languages == null || languages === true ? TopNavLocalizer$1.supportedLanguages : languages !== false ? languages : null;
  }
  get languagesProps() {
    const languages = this.languages;
    return languages ? {
      languages: languages,
      noFlags: this.props.languagesNoFlags,
      currentLanguage: TopNavLocalizer$1.language
    } : null;
  }
  get leftNav() {
    var _a, _b;
    return (_b = (_a = this.props.leftNavRef) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null;
  }
  getEndpoint() {
    return "/api/Application/GetTopNavItems";
  }
  get items() {
    return this.state.data || [];
  }
  get shoppingCart() {
    return this.state.shoppingCart;
  }
  get hasBackButton() {
    var _a;
    const visibility = this.props.backButtonVisibility;
    const defaultValue = BackButtonVisibility.Mobile;
    const value = visibility != null ? typeof visibility === "function" ? (_a = visibility()) !== null && _a !== void 0 ? _a : defaultValue : visibility : defaultValue;
    return value == BackButtonVisibility.Visible || value == BackButtonVisibility.Desktop && this.desktop || value == BackButtonVisibility.Mobile && this.mobile;
  }
  static resolveProfile(profile) {
    return profile ? typeof profile === "function" ? profile() : profile : null;
  }
  static resolveNotifications(notifications) {
    if (notifications != null) {
      if (typeof notifications === "function") {
        const data = notifications();
        if (data != null) {
          if (typeof data === "number") {
            return {
              count: data
            };
          } else {
            return data;
          }
        }
      } else if (typeof notifications === "number") {
        return {
          count: notifications
        };
      } else {
        return notifications;
      }
    }
    return null;
  }
  static isNotificationsVisible(notifications) {
    return notifications.visible == null || notifications.visible == true || typeof notifications.visible === "function" && notifications.visible();
  }
  static getNotificationsCount(notifications) {
    var _a;
    return notifications.count != null ? typeof notifications.count === "function" ? (_a = notifications.count()) !== null && _a !== void 0 ? _a : 0 : notifications.count : 0;
  }
  get profile() {
    var _a;
    return (_a = this._profile) !== null && _a !== void 0 ? _a : this._profile = TopNav.resolveProfile(this.props.profile);
  }
  get manual() {
    const page = ch.findPage();
    return page ? page.getManualProps() : {};
  }
  get searchLocation() {
    var _a;
    return (_a = this.props.searchLocation) !== null && _a !== void 0 ? _a : TopMenuContainer.Right;
  }
  renderSearchRender(value) {
    return value != null ? typeof value === "function" ? this.renderSearchRender(value()) : value : null;
  }
  renderSearch() {
    return React.createElement(React.Fragment, null, this.props.searchRender ? this.renderSearchRender(this.props.searchRender) : this.props.onSearchClick && React.createElement(Search, {
      searchPlaceHolder: this.searchPlaceHolder,
      onSearch: searchTerm => this.props.onSearchClick(searchTerm)
    }));
  }
  renderMenuItem(item, index) {
    const linkRoute = Link.toRoute(item);
    const pageRoute = typeof linkRoute === "object" ? linkRoute : null;
    const active = pageRoute != null && Comparator.isEqualPageRoute(pageRoute, ch.findPageRoute());
    const activeStyle = active && styles$j.active;
    return React.createElement(Link, {
      key: index,
      className: this.css(styles$j.link, activeStyle),
      route: linkRoute
    }, TopNavLocalizer$1.get(item.label));
  }
  render() {
    var _a;
    const leftNav = this.leftNav;
    const hasLeftNav = leftNav != null;
    const languagesProps = this.languagesProps;
    const manual = this.manual;
    const hasManual = !!manual.manual || !!manual.render || !!manual.onClick;
    const notifications = TopNav.resolveNotifications(this.props.notifications);
    const notificationsVisible = notifications != null && TopNav.isNotificationsVisible(notifications);
    const notificationsCount = notifications != null && notificationsVisible != null ? TopNav.getNotificationsCount(notifications) : 0;
    const shoppingCart = this.shoppingCart;
    const noBackButtonStyle = !this.hasBackButton && styles$j.noBackButton;
    return React.createElement("nav", {
      id: this.id,
      className: this.css(styles$j.navigation, this.props.className)
    }, React.createElement("div", {
      className: styles$j.left
    }, React.createElement("div", {
      className: this.css(styles$j.left_backIcon, noBackButtonStyle),
      onClick: () => this.backAsync()
    }, React.createElement("i", {
      className: "fas fa-chevron-circle-left"
    })), leftNav && React.createElement(Icon, {
      id: leftNav.toggleButtonId,
      name: leftNav.expanded ? "fal fa-times" : "fal fa-bars",
      size: IconSize.X2,
      className: styles$j.left_leftNav,
      onClick: () => this.toggleLeftNavAsync()
    }), this.props.logo && React.createElement("img", {
      src: this.props.logo,
      alt: this.props.logoText || "Logo",
      onClick: () => this.onLogoClick()
    }), this.searchLocation == TopMenuContainer.Left && this.renderSearch()), React.createElement("div", {
      className: styles$j.middle
    }, this.searchLocation == TopMenuContainer.Middle && this.renderSearch(), !hasLeftNav && this.items.map((item, index) => this.renderMenuItem(item, index))), React.createElement("div", {
      className: styles$j.right
    }, hasManual && React.createElement(Icon, {
      name: manual.icon || "question-circle",
      className: this.css(styles$j.right_infoIcon, this.desktop && styles$j.hover),
      style: IconStyle.Regular,
      size: IconSize.X2,
      toggleModal: !manual.onClick,
      dataTarget: "page-help-info",
      onClick: manual.onClick
    }), this.searchLocation == TopMenuContainer.Right && this.renderSearch(), shoppingCart && React.createElement(React.Fragment, null, React.createElement(Icon, {
      name: "shopping-cart",
      size: IconSize.X2,
      className: this.css(this.props.shoppingCardClassName, (_a = this.props.className) !== null && _a !== void 0 ? _a : styles$j.right_shoppingCart),
      onClick: () => this.onShoppingCartClickAsync()
    }), shoppingCart.productsCount > 0 && React.createElement("span", {
      className: styles$j.right_shoppingCartCount
    }, shoppingCart.productsCount)), notifications != null && notificationsVisible && React.createElement(React.Fragment, null, React.createElement(Icon, {
      name: "fal fa-bell",
      size: IconSize.X2,
      className: this.css(styles$j.right_notifications, notifications.className),
      onClick: () => this.onNotificationsClickAsync(notifications)
    }), notificationsCount > 0 && React.createElement("span", {
      className: this.css(styles$j.right_notificationsCount, notifications.countClassName)
    }, notificationsCount)), this.profile && React.createElement(Profile, Object.assign({}, this.profile)), !hasLeftNav && this.items.length > 0 && React.createElement("div", {
      className: styles$j.right_hamburgerIcon,
      onClick: () => this.toggleHamburgerAsync()
    }, React.createElement("i", {
      className: "fas fa-2x fa-bars"
    })), languagesProps && (this.props.languagesRender ? this.props.languagesRender(this, languagesProps) : React.createElement(LanguageDropdown, Object.assign({}, languagesProps, {
      className: this.props.languageClassName,
      onChange: (_, language) => this.onLanguageChangeAsync(language)
    })))), React.createElement(Hamburger, {
      menuItems: this.items,
      open: this.state.isHamburgerOpen
    }));
  }
}
TopNav.mountedInstance = null;

var css_248z$m = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-expander-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-expander-expander {\n  margin: 0;\n  padding: 0;\n  display: flex;\n}\n.athenaeum-expander-expander .athenaeum-expander-content {\n  display: flex;\n  height: auto;\n  overflow: hidden;\n  transition-timing-function: ease-in-out;\n}\n.athenaeum-expander-expander .athenaeum-expander-content.athenaeum-expander-vertical {\n  transition-property: max-height;\n}\n.athenaeum-expander-expander .athenaeum-expander-content.athenaeum-expander-horizontal {\n  transition-property: max-width;\n}\n.athenaeum-expander-expander .athenaeum-expander-content.athenaeum-expander-processing {\n  display: block;\n  z-index: 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  margin-top: -100%;\n  margin-left: -100%;\n}\n.athenaeum-expander-expander .athenaeum-expander-content.athenaeum-expander-animation {\n  white-space: nowrap;\n}\n.athenaeum-expander-expander .athenaeum-expander-content.athenaeum-expander-collapsed:not(.athenaeum-expander-animation) {\n  display: none;\n}";
var styles$i = {"font-renta":"athenaeum-expander-font-renta","expander":"athenaeum-expander-expander","content":"athenaeum-expander-content","vertical":"athenaeum-expander-vertical","horizontal":"athenaeum-expander-horizontal","processing":"athenaeum-expander-processing","animation":"athenaeum-expander-animation","collapsed":"athenaeum-expander-collapsed"};
styleInject(css_248z$m);

var ExpanderType;
(function (ExpanderType) {
  ExpanderType[ExpanderType["Vertical"] = 0] = "Vertical";
  ExpanderType[ExpanderType["Horizontal"] = 1] = "Horizontal";
})(ExpanderType || (ExpanderType = {}));
class Expander extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      preprocessing: false,
      animation: false,
      expanded: this.props.expanded === true,
      maxHeight: this.props.expanded === true ? "none" : 0,
      maxWidth: this.props.expanded === true ? "none" : 0
    };
    this._contentRef = React.createRef();
  }
  transitionDelayAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // Wait 1 ms -> start new circle in new thread ("getBoundingClientRect" breaks transition)
      yield Utility.wait(1);
    });
  }
  invokeToggleAsync(expand, animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const vertical = this.type == ExpanderType.Vertical;
      const horizontal = !vertical;
      const transitionTime = 1000 * this.transitionTime;
      if (expand) {
        // Expand:
        // Step #1: Hidden rendering
        yield this.setState({
          preprocessing: true,
          maxHeight: "none",
          maxWidth: "none"
        });
        // Step #2: Recalculate
        const contentNode = this._contentRef.current;
        const rect = contentNode.getBoundingClientRect();
        let maxHeight = vertical ? 0 : "none";
        let maxWidth = horizontal ? 0 : "none";
        yield this.setState({
          expanded: true,
          preprocessing: false,
          maxHeight,
          maxWidth
        });
        yield this.transitionDelayAsync();
        // Step 3#: Transition (Animation):
        maxHeight = vertical ? rect.height : "none";
        maxWidth = horizontal ? rect.width : "none";
        yield this.setState({
          maxHeight,
          maxWidth,
          animation: true
        });
        yield Utility.wait(transitionTime);
        //await this.setState({animation: false});
        yield this.setState({
          maxHeight: "none",
          maxWidth: "none",
          animation: false
        });
        // Callback
        if (this.props.onToggle) {
          yield this.props.onToggle(this, true);
        }
      } else {
        const needToInitializeVertical = vertical && this.state.maxHeight == "none";
        const needToInitializeHorizontal = horizontal && this.state.maxWidth == "none";
        if (needToInitializeVertical || needToInitializeHorizontal) {
          const contentNode = this._contentRef.current;
          const rect = contentNode.getBoundingClientRect();
          if (needToInitializeVertical) {
            yield this.setState({
              maxHeight: rect.height
            });
          } else {
            yield this.setState({
              maxWidth: rect.width
            });
          }
          yield this.transitionDelayAsync();
        }
        //await Utility.wait(100);
        // Collapse:
        const maxHeight = vertical ? 0 : "none";
        const maxWidth = horizontal ? 0 : "none";
        if (animation) {
          yield this.setState({
            maxHeight,
            maxWidth,
            expanded: false,
            animation: true
          });
          yield Utility.wait(transitionTime);
          yield this.setState({
            animation: false
          });
        } else {
          yield this.setState({
            maxHeight,
            maxWidth,
            expanded: false,
            animation: false
          });
        }
        // Callback
        if (this.props.onToggle) {
          yield this.props.onToggle(this, false);
        }
      }
    });
  }
  // Getters
  get autoCollapse() {
    return this.props.autoCollapse === true;
  }
  get type() {
    var _a;
    return (_a = this.props.type) !== null && _a !== void 0 ? _a : ExpanderType.Vertical;
  }
  get transitionTime() {
    return this.props.transitionTime || 0.2;
  }
  get expanded() {
    return this.state.expanded;
  }
  get collapsed() {
    return !this.expanded;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.expanded) {
        yield this.expandAsync();
      }
    });
  }
  setExpanded(expanded, animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (expanded !== this.expanded) {
        yield this.invokeToggleAsync(expanded, animation);
      }
    });
  }
  expandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setExpanded(true);
    });
  }
  collapseAsync(animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setExpanded(false, animation);
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.expanded ? yield this.collapseAsync() : yield this.expandAsync();
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && this.autoCollapse) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.collapseAsync();
        }
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const nextExpanded = nextProps.expanded === true;
      const newExpanded = nextExpanded != this.expanded;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newExpanded) {
        yield this.setExpanded(nextExpanded);
      }
    });
  }
  render() {
    const preprocessing = this.state.preprocessing;
    const expanded = this.expanded;
    const processingStyles = preprocessing ? styles$i.processing : expanded ? styles$i.expanded : styles$i.collapsed;
    const typeStyle = this.type == ExpanderType.Vertical ? styles$i.vertical : styles$i.horizontal;
    const animationStyle = this.state.animation && styles$i.animation;
    const inlineStyles = {
      maxHeight: this.state.maxHeight,
      maxWidth: this.state.maxWidth,
      transitionDuration: `${this.transitionTime}s`
    };
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$i.expander, this.props.className, processingStyles)
    }, React.createElement("div", {
      id: `${this.id}_content`,
      ref: this._contentRef,
      className: this.css(styles$i.content, this.props.contentClassName, typeStyle, processingStyles, animationStyle),
      style: inlineStyles
    }, this.children));
  }
}

var css_248z$l = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-left-nav-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-left-nav-leftNav {\n  display: flex;\n  width: fit-content;\n  background-color: rgb(254, 80, 0);\n  color: white;\n}\n.athenaeum-left-nav-leftNav.athenaeum-left-nav-absolute {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: auto;\n}\n.athenaeum-left-nav-leftNav .athenaeum-left-nav-container {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.athenaeum-left-nav-leftNav .athenaeum-left-nav-container .athenaeum-left-nav-itemsContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.athenaeum-left-nav-leftNav .athenaeum-left-nav-container .athenaeum-left-nav-itemsContainer .athenaeum-left-nav-expander {\n  flex-grow: 1;\n}";
var styles$h = {"font-renta":"athenaeum-left-nav-font-renta","leftNav":"athenaeum-left-nav-leftNav","absolute":"athenaeum-left-nav-absolute","container":"athenaeum-left-nav-container","itemsContainer":"athenaeum-left-nav-itemsContainer","expander":"athenaeum-left-nav-expander"};
styleInject(css_248z$l);

class LeftNav extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false,
      expanded: this.fixed,
      maxWidth: null
    };
    this._expanderRef = React.createRef();
  }
  getUserProfile() {
    return this.props.userProfile != null ? typeof this.props.userProfile === "function" ? this.props.userProfile(this) : typeof this.props.userProfile === "boolean" ? this.props.userProfile ? Profile.findUserProfile() : null : this.props.userProfile : null;
  }
  onItemClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.autoCollapse && this.expandable) {
        yield this.collapseAsync(false);
      }
    });
  }
  onToggleAsync(expanded) {
    return __awaiter(this, void 0, void 0, function* () {
      this.state.expanded = expanded;
      if (this.props.onToggle) {
        yield this.props.onToggle(this, expanded);
      }
    });
  }
  getItems() {
    const items = this.state.data || [];
    return items.filter(item => item.visible == null || item.visible === true || typeof item.visible === "function" && item.visible());
  }
  getTopItems(items) {
    return items.where(item => !item.bottom);
  }
  getBottomItems(items) {
    return items.where(item => !!item.bottom);
  }
  getEndpoint() {
    return "";
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.props.items != null ? typeof this.props.items === "function" ? yield this.props.items(this) : this.props.items : [];
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && this.expandable && this.autoCollapse) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id, this.toggleButtonId);
        if (outside) {
          yield this.collapseAsync();
        }
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && this.expandable && this.autoCollapse && e.keyCode == 27) {
        yield this.collapseAsync();
      }
    });
  }
  isAsync() {
    return this.props.items != null && typeof this.props.items === "function";
  }
  get expandable() {
    return this.props.expandable !== false;
  }
  get fixed() {
    return this.props.fixed === true;
  }
  get absolute() {
    return !this.fixed;
  }
  get autoCollapse() {
    return this.props.autoCollapse === true || this.props.autoCollapse !== false && this.absolute;
  }
  get expanded() {
    return this.state.expanded;
  }
  get toggleButtonId() {
    var _a;
    return (_a = this.props.toggleButtonId) !== null && _a !== void 0 ? _a : `${this.id}_toggleButton`;
  }
  get collapsed() {
    return !this.expanded;
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.items != null && typeof this.props.items !== "function") {
        this.state.data = this.props.items;
      }
      yield _super.initializeAsync.call(this);
    });
  }
  collapseAsync(animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expandable && this._expanderRef.current) {
        yield this._expanderRef.current.collapseAsync(animation);
      }
      // if ((this.expandable) && (this.expanded)) {
      //     await this.toggleAsync(animation);
      // }
    });
  }
  expandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expandable && this._expanderRef.current) {
        yield this._expanderRef.current.expandAsync();
      }
      // if ((this.expandable) && (this.collapsed)) {
      //     await this.toggleAsync(animation);
      // }
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expandable && this._expanderRef.current) {
        yield this._expanderRef.current.toggleAsync();
      }
      // if ((this.expandable) && (!this.toggling)) {
      //
      //     if (animation) {
      //         const expanding: boolean = !this.expanded;
      //         const collapsing: boolean = !expanding;
      //
      //         const node: JQueryNode = this.getNode();
      //
      //         // check current state
      //         const originalMaxWidth: string = node.css("max-width");
      //         const originalWhiteSpace: string = node.css("white-space");
      //
      //         let maxWidth: number = 0;
      //         if (collapsing) {
      //             maxWidth = node.width()!;
      //         }
      //
      //         // override state
      //         node.css("max-width", maxWidth);
      //         node.css("white-space", "nowrap");
      //
      //         this.state.toggling = true;
      //
      //         if (expanding) {
      //             await this.setState({expanded: true});
      //         }
      //
      //         const step: number = 15;
      //         const delay: number = 5;
      //
      //         while (true) {
      //
      //             if (expanding) {
      //
      //                 maxWidth += step;
      //
      //                 node.css("max-width", maxWidth);
      //
      //                 const newWidth: number = node.width()!;
      //
      //                 if (newWidth < maxWidth) {
      //                     break;
      //                 }
      //             } else {
      //                 maxWidth -= step;
      //
      //                 if (maxWidth <= 0) {
      //                     break;
      //                 }
      //
      //                 node.css("max-width", maxWidth);
      //             }
      //
      //             await Utility.wait(delay);
      //         }
      //
      //         // restore state
      //         node.css("max-width", originalMaxWidth);
      //         node.css("white-space", originalWhiteSpace);
      //
      //         this.state.toggling = false;
      //
      //         if (collapsing) {
      //             await this.setState({expanded: false});
      //         }
      //     } else {
      //         await this.setState({expanded: !this.expanded});
      //     }
      //
      //     if (this.props.onToggle) {
      //         await this.props.onToggle(this, this.expanded);
      //     }
      // }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newItems = !Comparator.isEqual(this.props.items, nextProps.items);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newItems) {
        yield this.reloadAsync();
      } else {
        yield this.reRenderAsync();
      }
    });
  }
  renderItems(items) {
    const topItems = this.getTopItems(items);
    const bottomItems = this.getBottomItems(items);
    return React.createElement(React.Fragment, null, topItems.map((item, index) => React.createElement(MenuItem, Object.assign({
      key: index
    }, item, {
      onClick: () => this.onItemClickAsync()
    }))), React.createElement("div", {
      className: styles$h.expander
    }), bottomItems.map((item, index) => React.createElement(MenuItem, Object.assign({
      key: index
    }, item, {
      onClick: () => this.onItemClickAsync()
    }))));
  }
  render() {
    const userProfile = this.getUserProfile();
    //const items: IMenuItem[] = (this.expanded) ? this.getItems() : [];
    const items = this.getItems();
    const inlineStyles = {
      height: this.props.height || undefined,
      minHeight: this.props.minHeight || undefined,
      width: this.props.width || undefined,
      minWidth: this.props.minWidth || undefined
    };
    const fixedStyle = this.fixed && styles$h.fixed;
    const absoluteStyle = this.absolute && styles$h.absolute;
    return React.createElement("nav", {
      id: this.id,
      className: this.css(styles$h.leftNav, this.props.className, fixedStyle, absoluteStyle)
    }, React.createElement(Expander, {
      ref: this._expanderRef,
      type: ExpanderType.Horizontal,
      autoCollapse: false,
      expanded: this.expanded,
      onToggle: (_, expanded) => this.onToggleAsync(expanded)
    }, React.createElement("div", {
      className: this.css(styles$h.container),
      style: inlineStyles
    }, React.createElement("div", {
      className: styles$h.userProfileContainer
    }, userProfile && React.createElement(UserProfile, Object.assign({}, userProfile))), React.createElement("div", {
      className: styles$h.itemsContainer
    }, items.length > 0 && this.renderItems(items)))));
  }
}

class TakePicture extends BaseComponent {
  constructor() {
    super(...arguments);
    this._imageInputRef = React.createRef();
    this._cameraUserInputRef = React.createRef();
    this._cameraEnvironmentInputRef = React.createRef();
    this._imageInputResolver = null;
    this._bodyOnFocusCallback = null;
  }
  subscribeOnFocusEvent() {
    // store current callback
    this._bodyOnFocusCallback = document.body.onfocus;
    // subscribe to new callback
    document.body.onfocus = () => this.onFocusCallbackAsync();
  }
  unsubscribeOnFocusEvent() {
    // restore original callback
    document.body.onfocus = this._bodyOnFocusCallback;
    // clear current callback
    this._bodyOnFocusCallback = null;
  }
  onImageInputChangeAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (this._imageInputResolver) {
        const fileModel = event.target.files && event.target.files.length > 0 ? yield Utility.transformFileAsync(event.target.files[0]) : null;
        this._imageInputResolver(fileModel);
        this._imageInputResolver = null;
      }
    });
  }
  onFocusCallbackAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.unsubscribeOnFocusEvent();
      if (this._imageInputResolver) {
        // wait 5*100 mlsec for "onImageInputChange" event
        for (let i = 0; i < 5; i++) {
          yield Utility.wait(100);
          if (this._imageInputResolver == null) {
            return;
          }
        }
        // resolve promise with no file ("cancel");
        this._imageInputResolver(null);
        this._imageInputResolver = null;
      }
    });
  }
  takePictureAsync(camera = true) {
    this.subscribeOnFocusEvent();
    const cameraType = typeof camera === "boolean" ? camera ? CameraType.OutwardFacingCamera : null : camera;
    const input = cameraType != null ? cameraType == CameraType.OutwardFacingCamera ? this._cameraEnvironmentInputRef.current : this._cameraUserInputRef.current : this._imageInputRef.current;
    if (input) {
      input.value = "";
      input.click();
      return new Promise(resolve => {
        this._imageInputResolver = resolve;
      });
    }
    return new Promise(() => null);
  }
  render() {
    return React.createElement(React.Fragment, null, React.createElement("input", {
      ref: this._imageInputRef,
      id: `${this.id}_imageInput`,
      style: {
        display: "none"
      },
      type: "file",
      accept: "image/*",
      capture: false,
      multiple: false,
      onChange: event => this.onImageInputChangeAsync(event)
    }), React.createElement("input", {
      ref: this._cameraUserInputRef,
      id: `${this.id}_cameraUserInput`,
      style: {
        display: "none"
      },
      type: "file",
      accept: "image/*",
      capture: "user",
      multiple: false,
      onChange: event => this.onImageInputChangeAsync(event)
    }), React.createElement("input", {
      ref: this._cameraEnvironmentInputRef,
      id: `${this.id}_cameraEnvironmentInput`,
      style: {
        display: "none"
      },
      type: "file",
      accept: "image/*",
      capture: "environment",
      multiple: false,
      onChange: event => this.onImageInputChangeAsync(event)
    }));
  }
}

/**
 * A base layout containing an {@link IBasePage}.
 */
class Layout extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isLoading: false,
      isSpinning: false,
      data: null,
      page: null,
      error: false
    };
    this._pageRef = React.createRef();
    this._topNavRef = React.createRef();
    this._leftNavRef = React.createRef();
    this._footerRef = React.createRef();
    this._downloadLink = React.createRef();
    this._takePictureRef = React.createRef();
    this._callToAnchorRef = React.createRef();
    this._emailToAnchorRef = React.createRef();
    this._mobile = this.mobile;
    this._tokenProcessing = false;
    this._verticalLayoutType = ch.verticalLayoutType;
    this._horizontalLayoutType = ch.horizontalLayoutType;
    this._touch = null;
    this._startTouch = null;
    this._swiping = false;
    this._alert = null;
    this._pageUrl = null;
  }
  onTouchStartHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this._touch = e.touches[0];
      this._startTouch = e.touches[0];
    });
  }
  // noinspection JSUnusedLocalSymbols
  onTouchEndHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._startTouch != null && this._touch) {
        const x = this._startTouch.clientX;
        const y = this._startTouch.clientY;
        const xDiff = this._touch.clientX - x;
        const yDiff = this._touch.clientY - y;
        const minSwipe = window.innerWidth / 3.0;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          /*most significant*/
          if (xDiff > minSwipe) {
            // right swipe
            yield this.onSwipeHandlerAsync(SwipeDirection.Right);
          } else if (xDiff < -minSwipe) {
            // left swipe
            yield this.onSwipeHandlerAsync(SwipeDirection.Left);
          }
        } else {
          if (yDiff > minSwipe) {
            //down swipe
            yield this.onSwipeHandlerAsync(SwipeDirection.Down);
          } else if (yDiff < -minSwipe) {
            //up swipe
            yield this.onSwipeHandlerAsync(SwipeDirection.Up);
          }
        }
        this._startTouch = null;
        this._touch = null;
      }
    });
  }
  onTouchMoveHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this._touch = e.touches[0];
    });
  }
  onSwipeHandlerAsync(direction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.isSpinning && !this.state.isLoading) {
        const page = this._pageRef.current || this.state.page;
        let defaultHandling = true;
        if (page) {
          defaultHandling = yield page.onSwipeHandlerAsync(direction);
        }
        if (defaultHandling) {
          if (direction === SwipeDirection.Right) {
            yield this.swipeRightAsync();
            yield PageRouteProvider.back();
          }
        }
      }
    });
  }
  swipe(styleName) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._swiping) {
        try {
          this._swiping = true;
          let main = document.querySelector(`.${styles$v.main}`);
          main.classList.add(styleName);
          yield Utility.wait(500);
          main.classList.remove(styleName);
        } finally {
          this._swiping = false;
        }
      }
    });
  }
  onTopNavFetchItemsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.reloadLeftNavAsync();
    });
  }
  static isDefaultRoute(names) {
    const length = names.length;
    if (length > 0) {
      let hash = window.location.hash;
      let pathname = window.location.pathname;
      if (pathname.endsWith("/")) {
        pathname = pathname.substring(0, pathname.length - 1);
      }
      if (!!hash || !!pathname) {
        hash = hash.toLowerCase();
        pathname = pathname.toLowerCase();
        for (let i = 0; i < length; i++) {
          const name = names[i].toLowerCase();
          const nameHash = `#${name}`;
          const namePathname = `/${name}`;
          if (nameHash == hash || namePathname == pathname || namePathname.endsWith(pathname)) {
            return true;
          }
        }
      }
    }
    return false;
  }
  static processDefaultRoutesAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const defaultRoutes = [{
        names: ["login"],
        route: BasePageDefinitions.loginRoute
      }, {
        names: ["contactsupport", "contact", "support"],
        route: BasePageDefinitions.contactSupportRoute
      }, {
        names: ["privacypolicy", "privacy", "policy"],
        route: BasePageDefinitions.privacyPolicyRoute
      }, {
        names: ["authors"],
        route: BasePageDefinitions.authorsRoute
      }, {
        names: ["offline"],
        route: BasePageDefinitions.offlineRoute
      }];
      const length = defaultRoutes.length;
      for (let i = 0; i < length; i++) {
        const defaultRoute = defaultRoutes[i];
        const match = Layout.isDefaultRoute(defaultRoute.names);
        if (match) {
          yield PageRouteProvider.redirectAsync(defaultRoute.route, true, true);
          return;
        }
      }
    });
  }
  static processRouteResolverAsync(useRouting) {
    return __awaiter(this, void 0, void 0, function* () {
      const pathname = window.location.pathname;
      if (!!pathname && pathname !== "/") {
        const pageRoute = PageRouteProvider.resolveRoute(pathname, useRouting);
        if (pageRoute) {
          const currentRoute = ch.findPageRoute();
          if (currentRoute == null || !PageRoute.isEqual(currentRoute, pageRoute)) {
            yield PageRouteProvider.redirectAsync(pageRoute);
          }
        }
      }
    });
  }
  processTokenAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const parsed = queryString.parse(window.location.search);
      let token = parsed.token;
      if (!token) {
        const pathname = window.location.pathname.substring(1);
        if (pathname && pathname.length == 32 && /^[0-9a-fA-F]+$/.test(pathname)) {
          token = pathname;
        }
      }
      if (token) {
        try {
          this._tokenProcessing = true;
          if (this.props.tokenLogin) {
            yield this.props.tokenLogin(this, token);
          } else {
            yield this.postAsync("/api/application/tokenLogin", token);
          }
          yield PageRouteProvider.changeUrlWithoutReload();
        } finally {
          if (this._tokenProcessing) {
            this._tokenProcessing = false;
            yield this.reRenderAsync();
          }
        }
      }
    });
  }
  isMobileApp() {
    const href = document.location.href.toLowerCase();
    return href.endsWith("/mobile") || href.endsWith("/mobile/") || href.endsWith("/mobilehome") || href.endsWith("/mobilehome/");
  }
  isPwaApp() {
    // TODO:
    // "device-detector-js" can be used to analyze UserAgent to define device type properly!
    // https://www.npmjs.com/package/device-detector-js
    // For example:
    // const deviceDetector = new DeviceDetector();
    // const device: DeviceDetectorResult = deviceDetector.parse(window.navigator.userAgent);
    // const deviceType: DeviceType = device.device?.type ?? "";
    // const isMobileApp: boolean = (deviceType === "smartphone") || (deviceType === "tablet");
    return (
      // 1) Main check: is device is in standalone mode ("display": "standalone" in manifest.json);
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone ||
      // 2) Android app with PWA application can fill referrer
      document.referrer.includes("android-app://") ||
      // 3) Exception: samsung devices (some tablets don't process "(display-mode: standalone)" right):
      !!navigator.userAgent.match(/SAMSUNG|Samsung|SGH-[I|N|T]|GT-[I|N]|SM-[A|N|P|T|Z]|SHV-E|SCH-[I|J|R|S]|SPH-L/i)
    );
  }
  getApplicationType() {
    return this.isMobileApp() ? WebApplicationType.MobileApp : this.isPwaApp() ? WebApplicationType.PwaApp : this.mobile ? WebApplicationType.MobileBrowser : WebApplicationType.DesktopBrowser;
  }
  getLanguageQuery() {
    const parsed = queryString.parse(window.location.search);
    return parsed.lang || parsed.language || parsed.culture || "";
  }
  removeTooltip() {
    this.JQuery(".tooltip").remove();
  }
  /**
   * Do not delete - needed for REACT error handling
   * @return \{error: true}
   */
  // noinspection JSUnusedGlobalSymbols
  static getDerivedStateFromError() {
    return {
      error: true
    };
  }
  static get Scroller() {
    return Scroller;
  }
  /**
   * @return {@link ApplicationContext.applicationName}
   */
  get applicationName() {
    return this.state.data != null ? this.state.data.applicationName : "";
  }
  // React.Component
  componentDidCatch(error, errorInfo) {
    return __awaiter(this, void 0, void 0, function* () {
      // noinspection JSVoidFunctionReturnValueUsed,TypeScriptValidateJSTypes
      const processed = yield PageRouteProvider.exception(error, errorInfo);
      if (processed && this.state.error) {
        yield this.setState({
          error: false
        });
      }
    });
  }
  componentDidUpdate() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._alert) {
        yield this.alertAsync(this._alert);
      }
    });
  }
  // ISpinner
  /**
   * @inheritDoc
   *
   * NOTE: only works if the {@link Layout} is mounted.
   */
  setSpinnerAsync(isSpinning) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isSpinning !== isSpinning && this.isMounted) {
        yield this.setState({
          isSpinning
        });
      }
    });
  }
  isSpinning() {
    return this.state.isSpinning;
  }
  // BaseAsyncComponent
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onCreate) {
        yield this.props.onCreate(this);
      }
      yield _super.componentDidMount.call(this);
      if (this.mobile) {
        this.initializeTooltips();
      }
      this._pageUrl = window.location.href;
      yield this.processTokenAsync();
      yield Layout.processDefaultRoutesAsync();
      yield Layout.processRouteResolverAsync(this.useRouting);
    });
  }
  fetchDataAsync() {
    const _super = Object.create(null, {
      fetchDataAsync: {
        get: () => super.fetchDataAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchContext) {
        const timezoneOffset = Utility.timezoneOffset;
        const applicationType = this.getApplicationType();
        const context = yield this.props.fetchContext(this, timezoneOffset, applicationType);
        yield ch.setContextAsync(context);
        if (context.currentPage) {
          yield PageRouteProvider.redirectAsync(context.currentPage, true);
        }
        return context;
      }
      return _super.fetchDataAsync.call(this);
    });
  }
  getEndpoint() {
    const timezoneOffset = Utility.timezoneOffset;
    const applicationType = this.getApplicationType();
    const language = this.getLanguageQuery();
    const pathname = encodeURIComponent(window.location.pathname);
    return `/api/Application/GetContext?timezoneOffset=${timezoneOffset}&applicationType=${applicationType}&language=${language}&pathname=${pathname}`;
  }
  // IGlobalResize
  onGlobalResize(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const mobile = this.mobile;
      const verticalLayoutType = ch.verticalLayoutType;
      const horizontalLayoutType = ch.horizontalLayoutType;
      const modified = mobile !== this._mobile || verticalLayoutType !== this._verticalLayoutType || horizontalLayoutType !== this._horizontalLayoutType;
      if (modified) {
        this._mobile = mobile;
        this._verticalLayoutType = verticalLayoutType;
        this._horizontalLayoutType = horizontalLayoutType;
        yield this.reRenderAsync();
      }
    });
  }
  // ILayoutPage
  setPageAsync(page) {
    return __awaiter(this, void 0, void 0, function* () {
      this._tokenProcessing = false;
      yield this.setState({
        page: page
      });
      if (this.mobile) {
        this.removeTooltip();
        this.initializeTooltips();
      }
    });
  }
  reloadTopNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const topNav = TopNav.mountedInstance;
      if (topNav != null) {
        yield topNav.reloadAsync();
        yield this.reRenderLeftNavAsync();
      }
    });
  }
  reRenderTopNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const topNav = TopNav.mountedInstance;
      if (topNav != null) {
        yield topNav.reRenderAsync();
      }
    });
  }
  reloadLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasLeftNav) {
        if (this._leftNavRef.current != null) {
          yield this._leftNavRef.current.reloadAsync();
        }
        yield this.reRenderAsync();
        yield this.reRenderTopNavAsync();
      }
    });
  }
  reRenderLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._leftNavRef.current != null) {
        yield this._leftNavRef.current.reRenderAsync();
      }
    });
  }
  /**
   * @inheritDoc
   *
   * Only works if {@link mobile} is true.
   */
  swipeLeftAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.mobile) {
        this.removeTooltip();
        yield this.swipe(styles$v.swipeLeft);
      }
    });
  }
  /**
   * @inheritDoc
   *
   * Only works if {@link mobile} is true.
   */
  swipeRightAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.mobile) {
        this.removeTooltip();
        yield this.swipe(styles$v.swipeRight);
      }
    });
  }
  alertAsync(alert) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      if (pageContainer != null) {
        this._alert = null;
        yield pageContainer.alertAsync(alert);
      } else {
        this._alert = alert;
      }
    });
  }
  hideAlertAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._alert = null;
      const pageContainer = ServiceProvider.getService("IPageContainer");
      if (pageContainer != null) {
        yield pageContainer.hideAlertAsync();
      }
    });
  }
  /**
   * @inheritDoc
   * @return true
   */
  isLayout() {
    return true;
  }
  get tooltips() {
    return this.JQuery('[data-toggle="tooltip"]');
  }
  /**
   * @inheritDoc
   *
   * NOTE: handles only Bootstrap tooltips.
   */
  initializeTooltips() {
    const tooltip = this.tooltips;
    if (tooltip.length > 0 && typeof tooltip.tooltip === "function") {
      tooltip.tooltip({
        trigger: "click",
        placement: "top"
      });
      tooltip.on("show.bs.tooltip", () => {
        this.JQuery(".tooltip").not(tooltip).remove();
      });
    }
  }
  /**
   * @inheritDoc
   *
   * NOTE: handles only Bootstrap tooltips.
   */
  reinitializeTooltips() {
    const tooltip = this.tooltips;
    if (tooltip.length > 0 && typeof tooltip.tooltip === "function") {
      tooltip.tooltip("dispose");
    }
    this.initializeTooltips();
  }
  takePictureAsync(camera = true) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._takePictureRef.current ? this._takePictureRef.current.takePictureAsync(camera) : null;
    });
  }
  download(file) {
    const link = this._downloadLink.current;
    if (link) {
      link.href = Utility.isBase64(file.src) ? Utility.toObjectUrl(file) : file.src;
      link.download = file.name;
      link.target = "_self";
      link.type = file.type;
      link.click();
    }
  }
  callTo(phone) {
    const anchor = this._callToAnchorRef.current;
    if (anchor) {
      anchor.href = `tel:${phone}`;
      anchor.text = phone;
      anchor.click();
    }
  }
  smsTo(phone, message) {
    const anchor = this._callToAnchorRef.current;
    if (anchor) {
      anchor.href = `sms:${phone};?&body=${message}`;
      anchor.text = phone;
      anchor.click();
    }
  }
  mailTo(email) {
    const anchor = this._callToAnchorRef.current;
    if (anchor) {
      anchor.href = `mailto:${email}`;
      anchor.text = email;
      anchor.click();
    }
  }
  get leftNav() {
    const leftNav = this.props.leftNav ? typeof this.props.leftNav === "function" ? this.props.leftNav() : this.props.leftNav : null;
    if (leftNav != null) {
      // initialize items:
      if (leftNav.items == null) {
        const fetchTopNavItems = this.props.fetchTopNavItems;
        if (fetchTopNavItems != null) {
          leftNav.items = () => fetchTopNavItems(this);
        } else {
          leftNav.items = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            return ((_a = this._topNavRef.current) === null || _a === void 0 ? void 0 : _a.items) || [];
          });
        }
      }
      // initialize userProfile
      if (leftNav.userProfile == null) {
        //return Profile.resolveUserProfile(this, this.props.userProfile);
        const profile = TopNav.resolveProfile(this.props.profile);
        leftNav.userProfile = profile === null || profile === void 0 ? void 0 : profile.userProfile;
      }
    }
    return leftNav;
  }
  get hasTopNav() {
    return this.props.noTopNav !== true && this.hasData && this.state.page != null && this.state.page.hasTopNav;
  }
  get hasLeftNav() {
    return this.leftNav !== null && this.hasData && this.state.page != null && this.state.page.hasLeftNav;
  }
  get hasBackButton() {
    return this.state.page != null ? this.state.page.hasBackButton : null;
  }
  get hasFooter() {
    return this.props.noFooter !== true && this.hasData && this.state.page != null && this.state.page.hasFooter;
  }
  get hasLanguageSelector() {
    return this.props.noLanguageSelector !== true && this.hasData && this.state.page != null && this.state.page.hasLanguageSelector;
  }
  /**
   * @inheritDoc
   * @see IPageContainer.alert
   */
  get alert() {
    var _a;
    const pageContainer = ServiceProvider.getService("IPageContainer");
    return (_a = pageContainer === null || pageContainer === void 0 ? void 0 : pageContainer.alert) !== null && _a !== void 0 ? _a : this._alert;
  }
  get useRouting() {
    return this.props.useRouting === true;
  }
  get pageUrl() {
    var _a;
    return (_a = this._pageUrl) !== null && _a !== void 0 ? _a : this._pageUrl = window.location.href;
  }
  // IReactComponent
  render() {
    const contentVisible = !this._tokenProcessing && this.hasData;
    const hasTopNav = contentVisible && this.hasTopNav;
    const hasLeftNav = contentVisible && this.hasLeftNav;
    const hasFooter = contentVisible && this.hasFooter && !this.state.error && !this.isLoading;
    const footerVisible = hasFooter && this._footerRef.current != null && this._footerRef.current.visible;
    const leftNav = hasLeftNav ? this.leftNav : null;
    const hasTopNavStyle = hasTopNav && styles$v.hasTopNav;
    const hasFooterStyle = footerVisible && styles$v.hasFooter;
    const hasLeftNavStyle = hasLeftNav && styles$v.hasLeftNav;
    return React.createElement("div", {
      className: this.css(styles$v.layout, this.props.className, hasTopNavStyle, hasFooterStyle, hasLeftNavStyle),
      onTouchStart: e => this.onTouchStartHandlerAsync(e),
      onTouchEnd: e => this.onTouchEndHandlerAsync(e),
      onTouchMove: e => this.onTouchMoveHandlerAsync(e)
    }, hasTopNav && React.createElement(TopNav, {
      ref: this._topNavRef,
      className: this.props.topNavClassName,
      applicationName: this.applicationName,
      leftNavRef: hasLeftNav ? this._leftNavRef : undefined,
      fetchItems: this.props.fetchTopNavItems,
      languages: this.hasLanguageSelector ? this.props.languages : false,
      languagesNoFlags: this.props.languagesNoFlags,
      languagesRender: this.props.languagesRender,
      logo: this.props.topNavLogo,
      notifications: this.props.notifications,
      backButtonVisibility: () => this.hasBackButton,
      fetchShoppingCart: this.props.fetchShoppingCartAsync,
      onShoppingCartClick: this.props.onShoppingCartClick,
      onSearchClick: this.props.onSearchClick,
      searchLocation: this.props.searchLocation,
      searchPlaceHolder: this.props.searchPlaceHolder,
      searchRender: this.props.searchRender,
      logoText: this.props.topNavLogoText,
      profile: this.props.profile,
      onLogoClick: this.props.onLogoClick,
      onFetchItems: () => this.onTopNavFetchItemsAsync(),
      onChangeLanguage: this.props.onChangeLanguage
    }), contentVisible && React.createElement("main", {
      className: this.css(styles$v.main, hasLeftNav && styles$v.leftNav, hasTopNav && styles$v.topNav)
    }, leftNav && React.createElement(LeftNav, Object.assign({
      ref: this._leftNavRef
    }, leftNav, {
      className: this.css(styles$v.leftNav, leftNav.className),
      onToggle: () => this.reRenderTopNavAsync()
    })), !this.state.error && !this.isLoading && this.state.page != null && PageRouteProvider.render(this.state.page, this._pageRef)), hasFooter && (this.props.footerRender ? this.props.footerRender(this) : React.createElement(Footer, {
      ref: this._footerRef,
      version: ch.version,
      links: this.props.footerLinks,
      logo: this.props.footerLogo,
      name: this.props.footerName
    })), (this.state.error || this.state.isSpinning || this._tokenProcessing) && React.createElement(Spinner, {
      global: true
    }), contentVisible && !this.isLoading && this.props.cookieConsent && React.createElement(CookieConsent, {
      description: this.props.cookieConsent().description,
      title: this.props.cookieConsent().title,
      acceptButtonText: this.props.cookieConsent().acceptButtonText,
      cookieName: this.props.cookieConsent().cookieName,
      position: this.props.cookieConsent().position,
      cookieExpirationInDays: this.props.cookieConsent().cookieExpirationInDays
    }), contentVisible && React.createElement(React.Fragment, null, React.createElement(TakePicture, {
      ref: this._takePictureRef
    }), React.createElement("a", {
      ref: this._downloadLink,
      id: `${this.id}_downloadAnchor`,
      style: {
        display: "none"
      }
    }), React.createElement("a", {
      ref: this._callToAnchorRef,
      id: `${this.id}_callToAnchor`,
      style: {
        display: "none"
      },
      href: ""
    }), React.createElement("a", {
      ref: this._emailToAnchorRef,
      id: `${this.id}_emailToAnchor`,
      style: {
        display: "none"
      },
      href: ""
    })));
  }
}

//Autogenerated
class ListLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.loadingLanguageItemName = `_1:0`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_1:0`, {
      l: `en`,
      v: `Loading...`
    }, {
      l: `uk`,
      v: `Завантаження...`
    }, {
      l: `sv`,
      v: `Laddar...`
    }, {
      l: `ru`,
      v: `Загрузка...`
    }, {
      l: `pl`,
      v: `Ładowanie...`
    }, {
      l: `nl`,
      v: `Bezig met laden...`
    }, {
      l: `nb`,
      v: `Loading...`
    }, {
      l: `it`,
      v: `Caricamento...`
    }, {
      l: `fr`,
      v: `Chargement...`
    }, {
      l: `fi`,
      v: `Ladataan...`
    }, {
      l: `es`,
      v: `Cargando...`
    }, {
      l: `de`,
      v: `Wird geladen...`
    }, {
      l: `da`,
      v: `Indlæser...`
    });
  }
  /**
  /* "Loading" (Loading...)
  /* "Localizer.loading"
  /* "Localizer.loadingLanguageItemName"
  */
  get loading() {
    return this.get(`_1:0`);
  }
}
//Singleton
var ListLocalizer$1 = new ListLocalizer();

var css_248z$k = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-list-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-list-listWrapper {\n  height: 100%;\n}\n.athenaeum-list-listWrapper .athenaeum-list-list {\n  height: 100%;\n}\n.athenaeum-list-listWrapper .athenaeum-list-list > div > label {\n  margin-bottom: 0;\n}\n.athenaeum-list-listWrapper .athenaeum-list-list div span {\n  text-transform: initial !important;\n}\n.athenaeum-list-listWrapper .athenaeum-list-list div input {\n  font-size: 0.8rem !important;\n  padding: 0.35rem !important;\n}";
var styles$g = {"font-renta":"athenaeum-list-font-renta","listWrapper":"athenaeum-list-listWrapper","list":"athenaeum-list-list"};
styleInject(css_248z$k);

class List extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false
    };
    this._dropdownRef = React.createRef();
  }
  onChangeAsync(value, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, value, userInteraction);
      }
    });
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchItems) {
        return yield this.props.fetchItems(this);
      }
      return [];
    });
  }
  getEndpoint() {
    return "";
  }
  get dropdown() {
    return this._dropdownRef.current;
  }
  get maxWidth() {
    return this.props.maxWidth || "none";
  }
  get noDataOrLoadingText() {
    return this.isLoading ? ListLocalizer$1.loading : this.props.noDataText || null;
  }
  get listItems() {
    return this.dropdown.listItems;
  }
  get selectedListItems() {
    return this.dropdown.selectedListItems;
  }
  get selectedListItem() {
    return this.dropdown.selectedListItem;
  }
  get selectedItems() {
    return this.dropdown.selectedItems;
  }
  get selectedValues() {
    return this.dropdown.selectedValues;
  }
  get selectedItem() {
    return this.dropdown.selectedItem;
  }
  get selectedValue() {
    return this.dropdown.selectedValue;
  }
  find(item) {
    return this.dropdown.find(item);
  }
  unselectAllAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.unselectAllAsync();
    });
  }
  selectItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.selectItemAsync(item);
    });
  }
  selectAsync(itemOrItems) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.selectAsync(itemOrItems);
    });
  }
  selectListItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.selectListItemAsync(item);
    });
  }
  selectListItemsAsync(items) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.selectListItemsAsync(items);
    });
  }
  hasSpinner() {
    return true;
  }
  isAsync() {
    return this.props.fetchItems != null;
  }
  scrollToSelected(smooth = false) {
    this.dropdown.scrollToSelected(smooth);
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.reRenderAsync();
    });
  }
  get items() {
    var _a;
    return (_a = this.props.items) !== null && _a !== void 0 ? _a : this.state.data || [];
  }
  render() {
    return React.createElement("div", {
      className: styles$g.listWrapper,
      style: {
        maxWidth: this.maxWidth
      }
    }, React.createElement(Dropdown, {
      id: `${this.id}_dropdown`,
      noSubtext: true,
      noWrap: true,
      ref: this._dropdownRef,
      absoluteListItems: this.props.absoluteListItems,
      noDataText: this.noDataOrLoadingText,
      noGrouping: this.props.noGrouping,
      maxHeight: this.props.maxHeight,
      multiple: this.props.multiple,
      filterMinLength: this.props.filterMinLength,
      filterMaxLength: this.props.filterMaxLength,
      label: this.props.label,
      expanded: true,
      disabled: this.props.disabled || this.isLoading,
      type: DropdownType.List,
      required: this.props.required,
      requiredType: this.props.requiredType,
      className: this.css(styles$g.list, this.props.className),
      orderBy: this.props.orderBy,
      subtextType: this.props.subtextType,
      selectType: this.props.selectType,
      trackChanges: this.props.trackChanges,
      items: this.items,
      selectedItem: this.props.selectedItem,
      selectedItems: this.props.selectedItems,
      transform: this.props.transform,
      groupSelected: this.props.groupSelected,
      filterFavorite: this.props.filterFavorite,
      onChange: (sender, item, userInteraction) => this.onChangeAsync(item, userInteraction)
    }));
  }
}

var css_248z$j = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-page-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-page-container-page {\n  padding: 15px 8px;\n  height: 100%;\n}\n.athenaeum-page-container-page[data-haswideheader=true] {\n  padding: 0 0 15px 0;\n}\n.athenaeum-page-container-page .athenaeum-page-container-container {\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 6px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-container.athenaeum-page-container-fullHeight {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-page-container-page .athenaeum-page-container-container.athenaeum-page-container-fullWidth {\n  max-width: unset !important;\n  min-width: 100% !important;\n}\n.athenaeum-page-container-page.athenaeum-page-container-scale {\n  padding: 0;\n}\n.athenaeum-page-container-page.athenaeum-page-container-scale .athenaeum-page-container-container {\n  max-width: unset !important;\n  min-width: 100% !important;\n  height: 100%;\n  border-radius: 0;\n  padding-bottom: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.athenaeum-page-container-page.athenaeum-page-container-scale .athenaeum-page-container-container > div {\n  margin-top: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.athenaeum-page-container-page .athenaeum-page-container-row {\n  flex-grow: 2;\n  margin: 15px 15px 25px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-row:last-of-type {\n  margin-bottom: 15px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-page-container-page .athenaeum-page-container-row {\n    margin: 0 -15px 15px !important;\n  }\n  .athenaeum-page-container-page .athenaeum-page-container-row:last-of-type {\n    margin-bottom: 0 !important;\n  }\n}\n.athenaeum-page-container-page .athenaeum-page-container-pageRow {\n  margin-bottom: 0;\n  flex-grow: 0;\n}\n.athenaeum-page-container-page .athenaeum-page-container-pageRow.athenaeum-page-container-alertRow {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header {\n  flex-grow: 0;\n  margin-bottom: 16px;\n  padding: 0 15px;\n  overflow: unset;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=false] {\n  padding: 0 15px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=true] {\n  background-position: center;\n  background-size: cover;\n  color: white;\n  margin: 0;\n  max-height: 25vh;\n  min-height: 10vh;\n  height: 225px;\n  margin-bottom: 1rem;\n  display: flex;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=true] .athenaeum-page-container-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=true] .athenaeum-page-container-content h1 {\n  font-size: clamp(1.2rem, 5vw, 2rem);\n  font-weight: bold;\n  text-align: center;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=true] .athenaeum-page-container-content h2 {\n  font-size: 24px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header .athenaeum-page-container-content {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header .athenaeum-page-container-content h4 {\n  font-size: 18px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header .athenaeum-page-container-content p {\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Arial, sans-serif;\n  margin-bottom: 8px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header .athenaeum-page-container-content.athenaeum-page-container-noMargin {\n  margin-bottom: 0;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header hr {\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  margin: 8px 0 0 0;\n  width: 100%;\n}";
var styles$f = {"font-renta":"athenaeum-page-container-font-renta","page":"athenaeum-page-container-page","container":"athenaeum-page-container-container","fullHeight":"athenaeum-page-container-fullHeight","fullWidth":"athenaeum-page-container-fullWidth","scale":"athenaeum-page-container-scale","row":"athenaeum-page-container-row","pageRow":"athenaeum-page-container-pageRow","alertRow":"athenaeum-page-container-alertRow","header":"athenaeum-page-container-header","content":"athenaeum-page-container-content","noMargin":"athenaeum-page-container-noMargin"};
styleInject(css_248z$j);

class PageRow extends BaseComponent {
  minimize(duration = undefined) {
    const node = this.getNode();
    const properties = {
      opacity: 0,
      height: 0,
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0
    };
    if (duration) {
      node.animate(properties, duration);
    } else {
      node.animate(properties);
    }
  }
  render() {
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$f.row, "row", this.props.className)
    }, this.props.children);
  }
}

var css_248z$i = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-description-font-renta {\n  font-family: \"DINProMedium\";\n}";
var styles$e = {"font-renta":"athenaeum-description-font-renta"};
styleInject(css_248z$i);

class Description extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      model: this.props.model || new DescriptionModel()
    };
    this._popoverRef = React.createRef();
  }
  onChangeAsync(data) {
    return __awaiter(this, void 0, void 0, function* () {
      const description = data.getValue("description") || "";
      yield this.closeAsync();
      if (description != this.model.description) {
        this.model.description = description;
        yield this.setState({
          model: this.model
        });
        if (this.model.onChange) {
          yield this.model.onChange(description);
        }
      }
    });
  }
  get popover() {
    return this._popoverRef.current;
  }
  toggleAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        model
      });
      yield this.popover.toggleAsync(containerId);
    });
  }
  openAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.toggleAsync(containerId, model);
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.popover.closeAsync();
    });
  }
  get model() {
    return this.state.model;
  }
  render() {
    var _a;
    return React.createElement(Popover, {
      id: this.id,
      ref: this._popoverRef,
      className: this.css(styles$e.description, this.model.className, this.props.className),
      justify: this.model.justify,
      align: this.model.align
    }, React.createElement(Form, {
      onSubmit: (sender, data) => this.onChangeAsync(data)
    }, React.createElement(TextAreaInput, {
      autoFocus: true,
      id: "description",
      className: "mb-2",
      cols: 50,
      rows: 4,
      maxLength: (_a = this.model.maxLength) !== null && _a !== void 0 ? _a : 255,
      readonly: this.model.readonly,
      value: this.model.description
    }), !this.model.readonly && React.createElement(ButtonContainer, null, React.createElement(Button, {
      submit: true,
      icon: {
        name: "fa fa-check",
        size: IconSize.Large
      },
      type: ButtonType.Success
    }))));
  }
}

//Autogenerated
class PageContainerLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.pageHelpLanguageItemName = `_4:0`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_4:0`, {
      l: `en`,
      v: `Page help`
    }, {
      l: `uk`,
      v: `Довідка`
    }, {
      l: `sv`,
      v: `Sidhjälp`
    }, {
      l: `ru`,
      v: `Справка`
    }, {
      l: `pl`,
      v: `Pomoc strony`
    }, {
      l: `nl`,
      v: `Hulp pagina`
    }, {
      l: `nb`,
      v: `Sidehjelp`
    }, {
      l: `it`,
      v: `Aiuto della pagina`
    }, {
      l: `fr`,
      v: `Page d'aide`
    }, {
      l: `fi`,
      v: `Sivun ohje`
    }, {
      l: `es`,
      v: `Ayuda de página`
    }, {
      l: `de`,
      v: `Seitenhilfe`
    }, {
      l: `da`,
      v: `Hjælp til sider`
    });
  }
  /**
  /* "PageHelp" (Page help)
  /* "Localizer.pageHelp"
  /* "Localizer.pageHelpLanguageItemName"
  */
  get pageHelp() {
    return this.get(`_4:0`);
  }
}
//Singleton
var PageContainerLocalizer$1 = new PageContainerLocalizer();

class PageContainer extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false,
      alert: null,
      alertClassName: this.props.alertClassName || null
    };
    this._alertContainerRef = React.createRef();
    this._documentPreviewModalRef = React.createRef();
    this._descriptionRef = React.createRef();
    this._confirmationDialogRef = React.createRef();
    this._messageBoxRef = React.createRef();
    this._qrScrollerRef = React.createRef();
    this._height = 0;
  }
  get manual() {
    const page = ch.findPage();
    return page ? page.getManualProps() : {};
  }
  toggleVerticalScroll() {
    if (this.scrollY) {
      this.JQuery("html").addClass("vertical-scroll");
    } else {
      this.JQuery("html").removeClass("vertical-scroll");
    }
  }
  toggleHorizontalScroll() {
    if (this.scrollX) {
      this.JQuery("html").addClass("horizontal-scroll");
    } else {
      this.JQuery("html").removeClass("horizontal-scroll");
    }
  }
  onAlertCloseAsync(sender, userInteraction = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const animation = sender.model.autoClose && !userInteraction;
      yield this.invokeHideAlertAsync(animation);
    });
  }
  invokeHideAlertAsync(animation) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.alert) {
        if (animation && this._alertContainerRef.current) {
          this._alertContainerRef.current.minimize(AthenaeumComponentsConstants.alertAnimationDelay);
          yield Utility.wait(AthenaeumComponentsConstants.alertAnimationDelay);
        }
        if (this.isMounted) {
          yield this.setState({
            alert: null
          });
        } else {
          this.state.alert = null;
        }
      }
    });
  }
  getEndpoint() {
    return this.props.endpoint || "";
  }
  isAsync() {
    return this.getEndpoint().length > 0;
  }
  height() {
    if (this._height === 0) {
      const node = this.getNode();
      this._height = node.children().first().height() || 0;
    }
    const alertHeight = this._alertContainerRef.current ? this._alertContainerRef.current.outerHeight(true) : 0;
    return this._height - alertHeight;
  }
  onGlobalResize(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this._height = 0;
    });
  }
  get alert() {
    return this.state.alert;
  }
  get scale() {
    return this.props.scale == true;
  }
  get scrollY() {
    return !this.mobile && (this.props.scrollY == true || this.props.scrollY != false && this.scale);
  }
  get scrollX() {
    return !this.mobile && this.props.scrollX == true;
  }
  alertAsync(alert) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        alert: alert
      });
      const needToScrollToTop = !alert.flyout && alert.autoScroll && this._qrScrollerRef.current != null && this._alertContainerRef.current != null && !this._alertContainerRef.current.isInView();
      if (needToScrollToTop) {
        this._qrScrollerRef.current.scrollTop();
      }
    });
  }
  hideAlertAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeHideAlertAsync(false);
    });
  }
  /**
   * @inheritDoc
   * @see ConfirmationDialog.confirmAsync
   */
  confirmAsync(title) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._confirmationDialogRef.current.confirmAsync(title);
    });
  }
  messageBoxAsync(titleOrModel, caption, buttons, icon) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._messageBoxRef.current.showAsync(titleOrModel, caption, buttons, icon);
    });
  }
  documentPreviewAsync(model) {
    return __awaiter(this, void 0, void 0, function* () {
      const documentPreviewModal = this._documentPreviewModalRef.current;
      yield documentPreviewModal.openAsync(model);
    });
  }
  descriptionAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      const description = this._descriptionRef.current;
      yield description.toggleAsync(containerId, model);
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this.toggleVerticalScroll();
      this.toggleHorizontalScroll();
      PageContainer.instance = this;
      yield _super.componentDidMount.call(this);
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      PageContainer.instance = null;
      yield _super.componentWillUnmount.call(this);
    });
  }
  render() {
    const pageHeaderChildren = [];
    const nonPageHeaderChildren = [];
    const manual = this.manual;
    const hasManual = !!manual.manual || !!manual.render || !!manual.onClick;
    const transparentStyle = this.props.transparent ? {
      backgroundColor: "transparent"
    } : {};
    this.childrenWithType.forEach(child => {
      if (typeof child.type !== "string" && child.type.typeName === PageHeader.typeName) {
        pageHeaderChildren.push(child);
      } else {
        nonPageHeaderChildren.push(child);
      }
    });
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$f.page, this.props.className, this.props.scale && styles$f.scale),
      "data-haswideheader": String(this.props.hasWideHeader)
    }, this.props.hasWideHeader && React.createElement("div", null, pageHeaderChildren), React.createElement("div", {
      className: this.css("container", styles$f.container, this.props.fullHeight && styles$f.fullHeight, this.props.fullWidth && styles$f.fullWidth),
      style: transparentStyle
    }, this.alert && this.alert.message && React.createElement(PageRow, {
      ref: this._alertContainerRef,
      className: this.css(styles$f.pageRow, styles$f.alertRow)
    }, React.createElement("div", {
      className: "col d-flex justify-content-center"
    }, React.createElement(Alert, {
      className: this.props.alertClassName,
      model: this.alert,
      onClose: (sender, userInteraction) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onAlertCloseAsync(sender, userInteraction);
      })
    }))), this.props.hasWideHeader ? nonPageHeaderChildren : this.props.children), hasManual && React.createElement(Modal, {
      info: true,
      id: "page-help-info",
      className: this.props.className,
      title: manual.title || PageContainerLocalizer$1.pageHelp,
      content: manual.manual
    }, manual.render && manual.render(manual)), React.createElement(DocumentPreviewModal, {
      ref: this._documentPreviewModalRef
    }), React.createElement(Description, {
      ref: this._descriptionRef
    }), React.createElement(ConfirmationDialog, {
      ref: this._confirmationDialogRef
    }), React.createElement(MessageBox, {
      ref: this._messageBoxRef
    }), React.createElement(Layout.Scroller, {
      ref: this._qrScrollerRef
    }));
  }
}
// noinspection JSVoidFunctionReturnValueUsed, JSUnusedLocalSymbols
PageContainer.initialize = (() => ServiceProvider.addSingleton("IPageContainer", () => PageContainer.instance))();
PageContainer.instance = null;

class PageHeader extends BaseComponent {
  constructor() {
    super(...arguments);
    this.typeName = "PageHeader";
  }
  onClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClick) {
        yield this.props.onClick(this);
      }
    });
  }
  renderTitle() {
    const title = this.props.title;
    if (typeof title === "function") {
      return title(this);
    }
    return React.createElement(React.Fragment, null, this.toMultiLines(title));
  }
  render() {
    const style = this.props.wideHeader && this.props.wideHeaderBackgroundImage ? {
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${this.props.wideHeaderBackgroundImage})`
    } : {};
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$f.header, styles$f.row, !this.props.wideHeader && "row", this.props.className),
      "data-wideheader": String(this.props.wideHeader),
      style: style
    }, React.createElement("div", {
      className: styles$f.content
    }, React.createElement("div", null, React.createElement("h4", {
      onClick: () => this.onClickAsync()
    }, this.renderTitle()), this.props.subtitle && React.createElement("p", {
      className: this.props.withTabs ? styles$f.noMargin : ""
    }, this.toMultiLines(this.props.subtitle))), this.props.children), !this.props.wideHeader && !this.props.withTabs && React.createElement("hr", null));
  }
}
PageHeader.typeName = "PageHeader";

var css_248z$h = "@charset \"UTF-8\";\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-widget-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-widget-container-widgetContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n  max-width: 640px;\n  width: 100%;\n  margin: 0 auto;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget {\n  padding: 4px 6px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-readonly {\n  opacity: 0.8;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-approved {\n  opacity: 1;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-approved a {\n  background-color: #28a745;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-approved a:hover {\n  background-color: #28a745;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content {\n  text-decoration: none;\n  color: white;\n  background: rgb(254, 80, 0);\n  border-radius: 5px;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 12px;\n  width: 100%;\n  cursor: pointer;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-icon, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-icon,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-icon,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-icon {\n  padding: 10px 10px 14px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-icon_hidden,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-icon_hidden {\n  visibility: hidden;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-date {\n  padding: 10px 10px 14px;\n  font-size: 4em;\n  line-height: 42px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-number span:empty:before, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-date span:empty:before,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-number span:empty:before,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-date span:empty:before {\n  content: \"​\";\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-date,\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-number,\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number,\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date,\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-date {\n    font-size: 3em;\n  }\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-smallNumbers span > small,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-smallNumbers span > small {\n  font-size: 50%;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-date {\n  font-size: 2rem;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-description, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description {\n  border-top: 1px solid;\n  font-size: 0.85em;\n  padding-top: 0.5em;\n  display: flex;\n  flex-grow: 0;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-description span:empty:before, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description span:empty:before,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-description span:empty:before {\n  content: \"​\";\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  flex-grow: 1;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 10px 0 14px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-edit input,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-edit input {\n  width: 100px;\n  margin-bottom: 3px;\n  margin-top: 4px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-readonly,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-readonly {\n  opacity: 0.5;\n  cursor: default;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-disabled,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-date {\n  width: 100px;\n  padding: 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-qr,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-qr {\n  display: flex;\n  justify-content: center;\n  padding: 10px 0 14px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature {\n  padding: 8px 0 12px 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-signaturePad,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-signaturePad {\n  background-color: #ff7e51;\n  border-radius: 5px;\n  width: 100%;\n  height: 200px;\n  cursor: pointer;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 8px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer button,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer button {\n  display: block;\n  width: 100%;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer button:first-child,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer button:first-child {\n  margin-right: 8px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer {\n  display: none;\n  align-items: center;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-status,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-status {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-dropdownWidget,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-dropdownWidget {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-edit input,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-edit input {\n  width: 74px;\n  margin-right: 10px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-readonly,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-readonly {\n  opacity: 0.5;\n  cursor: default;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-date {\n  padding: 0 10px 0 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-disabled,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget i,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget i {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-icon,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-icon {\n  padding: 0 10px 0 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date {\n  padding: 0 10px 0 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription {\n  width: 100%;\n  word-break: break-word;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description {\n  display: block;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-label,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-label {\n  display: block;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a:hover,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-contentContainer {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-description, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-compact .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-compact .athenaeum-widget-container-description {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-label, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-label, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-compact .athenaeum-widget-container-label,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-label,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-compact .athenaeum-widget-container-label {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-compactContainer {\n  display: flex;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-transparent {\n  background: rgba(234, 60, 0, 0.5);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-transparent:hover {\n  background: rgba(234, 60, 0, 0.6);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 10px 10px 14px;\n  line-height: 42px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-status {\n  width: 76px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-switch, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-checked {\n  width: 56px;\n  height: 32px;\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n  background-color: white;\n  position: relative;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-switch .athenaeum-widget-container-toggler, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-checked .athenaeum-widget-container-toggler {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  height: inherit;\n  width: 20px;\n  border: inherit;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-checked {\n  background-color: rgb(254, 80, 0);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-checked .athenaeum-widget-container-toggler {\n  background-color: white;\n  left: 35px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer {\n  padding: 10px 10px 14px;\n  margin: 2px 0;\n  text-align: left;\n  position: relative;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer > input {\n  margin-top: 1px;\n  margin-bottom: 2px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer .athenaeum-widget-container-autoCompleteToggler {\n  position: absolute;\n  color: black;\n  right: 1.3rem;\n  top: 1.3rem;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer .athenaeum-widget-container-autoCompleteContainer {\n  padding: 0 10px;\n  position: relative;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer .athenaeum-widget-container-autoCompleteContainer.athenaeum-widget-container-mobile {\n  padding: 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer .athenaeum-widget-container-autoCompleteContainer.athenaeum-widget-container-mobile .athenaeum-widget-container-autoComplete {\n  position: unset;\n  border: none;\n  box-shadow: none;\n  background-color: inherit;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-valueContainer {\n  height: 66px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  word-break: break-word;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-products {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-products .athenaeum-widget-container-category {\n  width: 100px;\n  height: 100px;\n  margin: auto;\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-checkStepContainer {\n  background: rgb(254, 80, 0);\n  padding: 15px;\n  border-radius: 10px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-checkStepContainer > a {\n  background: transparent;\n  box-shadow: none;\n  border-radius: 0;\n  padding: 0;\n  text-align: left;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-checkStepContainer .athenaeum-widget-container-checkStep i {\n  color: white;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar {\n  height: 143px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: flex;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-labels {\n  text-align: left;\n  width: auto;\n  min-width: 180px;\n  left: 0;\n  align-self: flex-start;\n  float: left;\n  padding: 8px;\n  border-radius: 5px;\n  background-color: #ea3c00;\n  opacity: 0.7;\n  margin-left: -6px;\n  margin-top: -6px;\n  font-size: 0.8em;\n  position: absolute;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-labels .athenaeum-widget-container-labelsContainer {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-labels span {\n  display: block;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets {\n  width: 100%;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer {\n  display: flex;\n  height: calc(100% - 18px);\n  border-right: 1px dashed #ffd1bb;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer span {\n  min-width: 4px;\n  width: 100%;\n  align-self: flex-end;\n  margin: 0 2px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer span.athenaeum-widget-container-color1 {\n  background-color: #dd3162;\n  border: 1px solid #ff6384;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer span.athenaeum-widget-container-color2 {\n  background-color: rgba(49, 175, 212, 0.5);\n  border: 1px solid #31afd4;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer.athenaeum-widget-container-borderLeft {\n  border-left: 1px dashed #ffd1bb;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer.athenaeum-widget-container-hideLabels .athenaeum-widget-container-labels {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer:hover .athenaeum-widget-container-labels {\n  opacity: 1;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer:hover .athenaeum-widget-container-labelsContainer {\n  display: block;\n}\n.athenaeum-widget-container-widgetContainer > button {\n  margin: 4px 6px;\n  height: 80px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-dropdownWidget .athenaeum-widget-container-noDescription .dropdown-container {\n  bottom: -12px;\n}";
var widgetStyles = {"font-renta":"athenaeum-widget-container-font-renta","widgetContainer":"athenaeum-widget-container-widgetContainer","widget":"athenaeum-widget-container-widget","readonly":"athenaeum-widget-container-readonly","approved":"athenaeum-widget-container-approved","content":"athenaeum-widget-container-content","icon":"athenaeum-widget-container-icon","compactContainer":"athenaeum-widget-container-compactContainer","icon_hidden":"athenaeum-widget-container-icon_hidden","number":"athenaeum-widget-container-number","date":"athenaeum-widget-container-date","smallNumbers":"athenaeum-widget-container-smallNumbers","description":"athenaeum-widget-container-description","labelAndDescription":"athenaeum-widget-container-labelAndDescription","contentContainer":"athenaeum-widget-container-contentContainer","numberWidget":"athenaeum-widget-container-numberWidget","edit":"athenaeum-widget-container-edit","disabled":"athenaeum-widget-container-disabled","qr":"athenaeum-widget-container-qr","signature":"athenaeum-widget-container-signature","signaturePad":"athenaeum-widget-container-signaturePad","buttonContainer":"athenaeum-widget-container-buttonContainer","status":"athenaeum-widget-container-status","dropdownWidget":"athenaeum-widget-container-dropdownWidget","label":"athenaeum-widget-container-label","compact":"athenaeum-widget-container-compact","transparent":"athenaeum-widget-container-transparent","switchContent":"athenaeum-widget-container-switchContent","switch":"athenaeum-widget-container-switch","checked":"athenaeum-widget-container-checked","toggler":"athenaeum-widget-container-toggler","textInput":"athenaeum-widget-container-textInput","inputContainer":"athenaeum-widget-container-inputContainer","autoCompleteToggler":"athenaeum-widget-container-autoCompleteToggler","autoCompleteContainer":"athenaeum-widget-container-autoCompleteContainer","mobile":"athenaeum-widget-container-mobile","autoComplete":"athenaeum-widget-container-autoComplete","valueContainer":"athenaeum-widget-container-valueContainer","products":"athenaeum-widget-container-products","category":"athenaeum-widget-container-category","checkStepContainer":"athenaeum-widget-container-checkStepContainer","checkStep":"athenaeum-widget-container-checkStep","bar":"athenaeum-widget-container-bar","barContainer":"athenaeum-widget-container-barContainer","labels":"athenaeum-widget-container-labels","labelsContainer":"athenaeum-widget-container-labelsContainer","sets":"athenaeum-widget-container-sets","setsContainer":"athenaeum-widget-container-setsContainer","color1":"athenaeum-widget-container-color1","color2":"athenaeum-widget-container-color2","borderLeft":"athenaeum-widget-container-borderLeft","hideLabels":"athenaeum-widget-container-hideLabels","noDescription":"athenaeum-widget-container-noDescription"};
styleInject(css_248z$h);

class BaseWidgetContainer extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false
    };
    this._widgetToggleStates = new Dictionary();
    this._pageId = null;
  }
  onDropdownWidgetToggleHandlerAsync(sender, expanded) {
    return __awaiter(this, void 0, void 0, function* () {
      const toggle = expanded;
      if (toggle) {
        this._widgetToggleStates.clear();
      }
      if (this.mobile) {
        const widgets = this.childComponents.filter(component => component !== sender && component.isWidget).map(component => component);
        yield Utility.forEachAsync(widgets, widget => __awaiter(this, void 0, void 0, function* () {
          const widgetId = widget.id;
          if (toggle) {
            const maximized = !widget.minimized;
            this._widgetToggleStates.setValue(widgetId, maximized);
            yield widget.minimizeAsync();
          } else {
            const maximized = this._widgetToggleStates.getValue(widgetId) || null;
            if (maximized) {
              yield widget.maximizeAsync();
            }
          }
        }));
      }
    });
  }
  extendChildProps(element) {
    if (!this.noToggle && element.props.onToggle == null) {
      return {
        onToggle: (sender, expanded) => __awaiter(this, void 0, void 0, function* () {
          return sender.siblingsAutoToggle && (yield this.onDropdownWidgetToggleHandlerAsync(sender, expanded));
        })
      };
    }
    return null;
  }
  get widgetIds() {
    return this.state.data;
  }
  get widgets() {
    let widgets = this.children;
    if (this.isAsync()) {
      widgets = widgets.filter(item => !item.props.id || item.props.id.startsWith("_") || this.widgetIds != null && this.widgetIds.includes(item.props.id));
    }
    return widgets;
  }
  get noToggle() {
    return this.props.noToggle === true;
  }
  get controller() {
    return this.props.controller;
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      BaseWidgetContainer.mountedInstance = this;
      yield _super.initializeAsync.call(this);
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillUnmount.call(this);
      if (BaseWidgetContainer.mountedInstance === this) {
        BaseWidgetContainer.mountedInstance = null;
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      //update props
      this.props = nextProps;
      //check page state
      let pageId = ch.findPageId();
      let reload = this._pageId !== pageId;
      this._pageId = pageId;
      //reload data async if needed
      yield this.invokeReloadDataAsync(reload);
      //call base class
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  getEndpoint() {
    return `/api/${this.props.controller}/getWidgets`;
  }
  isAsync() {
    return !!this.props.controller && this.props.async === true;
  }
  renderContent(renderHidden = false) {
    return React.createElement(React.Fragment, null, this.widgets);
  }
  render() {
    return React.createElement("div", {
      id: this.id,
      className: this.css(this.props.className, widgetStyles.widgetContainer)
    }, this.renderContent());
  }
}
BaseWidgetContainer.mountedInstance = null;

class WidgetContainer extends BaseWidgetContainer {}

//Autogenerated
class WidgetContainerLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var WidgetContainerLocalizer$1 = new WidgetContainerLocalizer();

class BaseWidget extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      text: this.props.text,
      number: null,
      date: null,
      label: this.props.label,
      description: this.props.description,
      icon: this.props.icon,
      isLoading: false,
      data: null,
      spinnerVisible: false,
      minimized: this.props.minimized === true,
      transparent: this.props.transparent === true
    };
  }
  onSpinnerDelayHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isSpinning()) {
        yield this.setState({
          spinnerVisible: true
        });
      }
    });
  }
  get numberFormat() {
    return "0";
  }
  get dateFormat() {
    return "D";
  }
  getDescription() {
    return this.state.description;
  }
  getLabel() {
    return this.state.label;
  }
  getNumber() {
    return this.state.date != null ? Utility.formatValue(this.state.date, this.dateFormat) : this.state.number != null ? Utility.formatValue(this.state.number, this.numberFormat) : this.state.text || "";
  }
  isAsync() {
    return !!this.props.id && this.props.async === true;
  }
  get transparent() {
    return this.state.transparent;
  }
  toggleTransparentAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const transparent = !this.transparent;
      yield this.setState({
        transparent
      });
    });
  }
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      const date = Utility.isDateType(data) ? new Date(data) : null;
      const number = data != null && typeof data === "number" ? data : null;
      state.text = data;
      state.number = number != null ? number : null;
      state.date = date;
      state.spinnerVisible = false;
    });
  }
  get number() {
    return !this.isSpinning() ? this.getNumber() : "\u00A0";
  }
  get label() {
    return WidgetContainerLocalizer$1.get(this.getLabel());
  }
  get description() {
    const description = this.getDescription();
    return WidgetContainerLocalizer$1.get(description, this.state.number);
  }
  get icon() {
    const icon = this.state.icon;
    if (icon != null) {
      icon.size = this.state.minimized ? IconSize.X2 : IconSize.X3;
    }
    return icon;
  }
  get wide() {
    return this.props.wide === true;
  }
  get contentFlexStyle() {
    return {
      flexGrow: `${this.props.stretchContent ? 1 : 0}`
    };
  }
  get descriptionFlexStyle() {
    return {
      flexGrow: `${!this.props.stretchContent ? 1 : 0}`
    };
  }
  hasDescription() {
    return !!this.description;
  }
  getActionEndpoint(action) {
    const controller = BaseWidgetContainer.mountedInstance && BaseWidgetContainer.mountedInstance.controller ? BaseWidgetContainer.mountedInstance.controller : "Dashboard";
    return `/api/${controller}/${action}`;
  }
  getEndpoint() {
    const action = `get${this.props.id}Data`;
    return this.getActionEndpoint(action);
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  onMouseDownAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  getTarget() {
    return LinkTarget.Self;
  }
  getHref() {
    return "javascript:void(0)";
  }
  getInnerClassName() {
    return "";
  }
  get classNames() {
    var _a;
    const classNamesCopy = (_a = Object.assign({}, this.props.classNames)) !== null && _a !== void 0 ? _a : {};
    Object.keys(widgetStyles).forEach(key => !classNamesCopy[key] ? classNamesCopy[key] = widgetStyles[key] : classNamesCopy[key]);
    return classNamesCopy;
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
  isSpinning() {
    return this.isAsync() && this.state.data == null;
  }
  get minimized() {
    return this.state.minimized;
  }
  get containsTagSmall() {
    return this.number.includes("<small>");
  }
  toggleMinimized() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.minimized) {
        yield this.maximizeAsync();
      } else {
        yield this.minimizeAsync();
      }
    });
  }
  minimizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.minimized) {
        yield this.setState({
          minimized: true
        });
      }
    });
  }
  maximizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.minimized) {
        yield this.setState({
          minimized: false
        });
      }
    });
  }
  renderLabel() {
    return React.createElement("div", {
      className: this.css(widgetStyles.label, this.classNames.label)
    }, React.createElement("span", null, this.toMultiLines(this.label)));
  }
  renderContent(renderHidden = false) {
    return React.createElement(React.Fragment, null, this.icon && React.createElement("div", {
      className: this.css(widgetStyles.icon, this.state.spinnerVisible && widgetStyles.icon_hidden, renderHidden && widgetStyles.icon_hidden)
    }, React.createElement(Icon, Object.assign({}, this.icon))), !this.icon && this.number && React.createElement("div", {
      className: this.css(widgetStyles.number, this.containsTagSmall && widgetStyles.smallNumbers)
    }, React.createElement("span", null, ReactUtility.toSmalls(this.number))));
  }
  renderDescription() {
    return React.createElement("div", {
      className: this.css(widgetStyles.description, this.classNames.description),
      style: this.descriptionFlexStyle
    }, React.createElement("span", null, this.toMultiLines(this.description)));
  }
  renderExtendedContent() {
    return React.createElement(React.Fragment, null);
  }
  renderMinimized() {
    const minimized = this.minimized;
    return React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, this.classNames.compactContainer)
    }, minimized && this.renderContent(), React.createElement("div", {
      className: this.css(widgetStyles.labelAndDescription, this.classNames.labelAndDescription)
    }, this.label && React.createElement("div", {
      className: this.css(widgetStyles.label, this.classNames.label)
    }, React.createElement("span", null, this.label)), this.description && React.createElement("div", {
      className: this.css(widgetStyles.description, this.classNames.description)
    }, React.createElement("span", null, ReactUtility.toTags(this.description)))), minimized && this.renderContent(true));
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      let newState = null;
      if (this.props.description !== nextProps.description) {
        newState = newState || {};
        newState.description = nextProps.description;
      }
      if (this.props.label !== nextProps.label) {
        newState = newState || {};
        newState.label = nextProps.label;
      }
      if (this.props.icon !== nextProps.icon) {
        newState = newState || {};
        newState.icon = nextProps.icon;
      }
      if (this.props.text !== nextProps.text) {
        newState = newState || {};
        newState.text = nextProps.text;
      }
      if (this.props.minimized !== nextProps.minimized) {
        newState = newState || {};
        newState.minimized = nextProps.minimized;
      }
      if (newState != null) {
        yield this.setState(newState);
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  render() {
    const minimized = this.minimized;
    return React.createElement("div", {
      id: this.id,
      className: this.css(widgetStyles.widget, this.props.className, this.getInnerClassName(), this.wide ? "col-md-12" : "col-md-6", this.classNames.widget)
    }, React.createElement("a", {
      href: this.getHref(),
      rel: "noreferrer",
      title: this.toSingleLine(this.description || this.label),
      target: this.getTarget(),
      className: this.css(minimized && widgetStyles.compact, this.transparent && widgetStyles.transparent),
      draggable: false,
      onMouseDown: e => this.onMouseDownAsync(e),
      onClick: e => this.onClickAsync(e)
    }, !minimized && this.renderLabel(), React.createElement("div", {
      className: this.css(widgetStyles.contentContainer, this.classNames.contentContainer),
      style: this.contentFlexStyle
    }, !minimized && this.renderContent(), this.renderExtendedContent()), !minimized && this.hasDescription() && this.renderDescription(), this.renderMinimized()), this.isSpinning() && React.createElement(Spinner, {
      noShading: true,
      onDelay: () => this.onSpinnerDelayHandlerAsync()
    }));
  }
}

//Autogenerated
class DropdownWidgetLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var DropdownWidgetLocalizer$1 = new DropdownWidgetLocalizer();

class DropdownWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this._dropdownRef = React.createRef();
  }
  get dropdown() {
    return this._dropdownRef.current;
  }
  calcDropdownAvailableHeight() {
    let availableHeight = 0;
    if (this.mobile) {
      const widgetContainer = WidgetContainer.mountedInstance;
      const pageContainer = PageContainer.instance;
      if (widgetContainer && pageContainer) {
        const pageContainerHeight = pageContainer.height();
        const widgetContainerOuterHeight = widgetContainer.outerHeight(true);
        const dropdownOuterHeight = this.dropdown ? this.dropdown.outerHeight() : 0;
        availableHeight = pageContainerHeight - widgetContainerOuterHeight + dropdownOuterHeight;
      }
    }
    if (this.props.minHeight && availableHeight < this.props.minHeight) {
      return this.props.minHeight;
    }
    return availableHeight > 0 ? availableHeight : undefined;
  }
  updateDescriptionAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        const description = yield this.getDescription();
        if (this.state.description !== description) {
          yield this.setState({
            description: description
          });
        }
      }
    });
  }
  getDescription() {
    const showSubtext = !this.props.noSubtext;
    if (this.props.noDescription) {
      return "";
    }
    if (!this.selectedListItem) {
      return this.props.description ? DropdownWidgetLocalizer$1.get(this.props.description) : "";
    }
    if (showSubtext && this.selectedListItem.subtext) {
      return `${DropdownWidgetLocalizer$1.get(this.selectedListItem.text)}, ${DropdownWidgetLocalizer$1.get(this.selectedListItem.subtext)}`;
    }
    return DropdownWidgetLocalizer$1.get(this.selectedListItem.text);
  }
  getStyleSchema() {
    return DropdownSchema.Widget;
  }
  processDataAsync(state, data) {
    const _super = Object.create(null, {
      processDataAsync: {
        get: () => super.processDataAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.processDataAsync.call(this, state, data);
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      if (this.isMounted && this.dropdown) {
        if (this.dropdown.collapsed && this.state.minimized) {
          yield this.setState({
            minimized: false
          });
        } else if (this.props.minimized) {
          yield this.setState({
            minimized: true
          });
        }
        yield this.dropdown.toggleAsync();
      }
    });
  }
  onFavoriteChangeAsync(sender, item, favorite) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onFavoriteChange) {
        yield this.props.onFavoriteChange(this, item, favorite);
      }
    });
  }
  onChangeHandlerAsync(sender, item, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.updateDescriptionAsync();
      if (userInteraction && this.props.autoCollapse) {
        yield this.collapseAsync();
      }
      if (this.props.onChange) {
        yield this.props.onChange(this, item, userInteraction);
      }
    });
  }
  onChangeAmountHandlerAsync(sender, item, amount) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChangeAmount) {
        yield this.props.onChangeAmount(this, item, amount);
      }
    });
  }
  onToggleHandlerAsync(sender, expanded) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onToggle) {
        yield this.props.onToggle(this, expanded);
      }
    });
  }
  onItemsChangeHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.updateDescriptionAsync();
    });
  }
  onItemClickHandlerAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemClick) {
        yield this.props.onItemClick(this, item);
      }
    });
  }
  onAddHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onAdd) {
        yield this.props.onAdd(this);
      }
    });
  }
  fetchDataAsync() {
    const _super = Object.create(null, {
      fetchDataAsync: {
        get: () => super.fetchDataAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchDataAsync) {
        return yield this.props.fetchDataAsync(this, this.getEndpoint());
      }
      return yield _super.fetchDataAsync.call(this);
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const outside = Utility.clickedOutside(target, this.id);
      if (outside) {
        yield this.collapseAsync();
      }
    });
  }
  collapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.dropdown && this.dropdown.expanded) {
        if (this.props.minimized) {
          yield this.setState({
            minimized: true
          });
        }
        yield this.dropdown.collapseAsync();
      }
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      if (this.props.items) {
        this.state.data = this.props.items;
        yield this.reRenderAsync();
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.isAsync()) {
        const newItems = !Comparator.isEqual(this.props.items, nextProps.items);
        if (newItems) {
          this.state.data = nextProps.items || [];
        }
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  isAsync() {
    return this.props.fetchDataAsync != null || super.isAsync();
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
  get favorite() {
    return this.props.favorite || false;
  }
  get items() {
    return this.dropdown ? this.dropdown.items : [];
  }
  get selectedItems() {
    return this.dropdown ? this.dropdown.selectedItems : [];
  }
  get selectedItem() {
    return this.dropdown ? this.dropdown.selectedItem : null;
  }
  get selectedValue() {
    return this.dropdown ? this.dropdown.selectedValue : null;
  }
  get listItems() {
    return this.dropdown ? this.dropdown.listItems : [];
  }
  get selectedListItems() {
    return this.dropdown ? this.dropdown.selectedListItems : [];
  }
  get selectedListItem() {
    return this.dropdown ? this.dropdown.selectedListItem : null;
  }
  get selectedValues() {
    return this.dropdown ? this.dropdown.selectedValues : [];
  }
  get siblingsAutoToggle() {
    return this.props.siblingsAutoToggle !== false;
  }
  find(item) {
    return this.dropdown ? this.dropdown.find(item) : null;
  }
  unselectAllAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.unselectAllAsync();
      }
    });
  }
  selectItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.selectItemAsync(item);
      }
    });
  }
  selectAsync(itemOrItems) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.selectAsync(itemOrItems);
      }
    });
  }
  selectListItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.selectListItemAsync(item);
      }
    });
  }
  selectListItemsAsync(items) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.selectListItemsAsync(items);
      }
    });
  }
  renderExtendedContent() {
    const dropdownType = this.mobile ? DropdownType.List : DropdownType.Dropdown;
    const dropdownStyles = !this.description && widgetStyles.noDescription;
    return React.createElement("div", {
      className: widgetStyles.dropdownWidget
    }, this.state.data && React.createElement(Dropdown, {
      id: `dropdown_${this.id}`,
      type: dropdownType,
      ref: this._dropdownRef,
      className: this.css(widgetStyles.dropdown, dropdownStyles),
      filter: this.props.filter,
      styleSchema: this.getStyleSchema(),
      maxHeight: () => this.calcDropdownAvailableHeight(),
      favorite: this.favorite,
      autoCollapse: this.props.autoCollapse,
      expanded: this.props.expanded && this.mobile,
      required: this.props.required,
      requiredType: this.props.requiredType,
      multiple: this.props.multiple,
      orderBy: this.props.orderBy,
      subtextType: this.props.subtextType,
      groupSelected: this.props.groupSelected,
      selectedItem: this.props.selectedItem,
      selectedItems: this.props.selectedItems,
      addButton: this.props.addButton,
      items: this.state.data || [],
      toggleButtonId: this.id,
      transform: this.props.transform,
      onAdd: () => this.onAddHandlerAsync(),
      onChange: (sender, item, userInteraction) => this.onChangeHandlerAsync(sender, item, userInteraction),
      onChangeAmount: (sender, item, amount) => this.onChangeAmountHandlerAsync(sender, item, amount),
      onFavoriteChange: (sender, item, favorite) => this.onFavoriteChangeAsync(sender, item, favorite),
      onToggle: (sender, expanded) => this.onToggleHandlerAsync(sender, expanded),
      onItemsChange: () => this.onItemsChangeHandlerAsync(),
      onItemClick: (sender, item) => this.onItemClickHandlerAsync(item)
    }));
  }
}

class SwitchNullable extends CheckboxNullable {
  renderInput() {
    const toggleStyles = this.value === false ? styles$s.nullableSwitchUnchecked : this.value === true ? styles$s.nullableSwitchChecked : styles$s.nullableSwitch;
    return React.createElement("div", {
      className: styles$s.container
    }, this.props.leftLabel && React.createElement("span", {
      className: styles$s.label
    }, this.props.leftLabel), React.createElement("div", {
      className: this.css(toggleStyles, this.readonly && styles$s.readonly)
    }, React.createElement("div", {
      className: styles$s.zone,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.uncheckAsync();
      })
    }), React.createElement("div", {
      className: styles$s.zone,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.setNullAsync();
      })
    }), React.createElement("div", {
      className: styles$s.zone,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.checkAsync();
      })
    }), React.createElement("span", {
      className: styles$s.toggler
    })), this.props.rightLabel && React.createElement("span", {
      className: styles$s.label
    }, this.props.rightLabel));
  }
}

class BaseRouteWidget extends BaseWidget {
  getRoute() {
    const propsRoute = this.props.route;
    return typeof propsRoute === "function" ? propsRoute() : propsRoute ? propsRoute : null;
  }
  getHref() {
    const route = this.getRoute();
    return this.useRouting && route ? PageRoute.toRelativePath(route) : super.getHref();
  }
  onNavigateAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        e.stopPropagation();
        if (this.useRouting) {
          // e.stopPropagation does not stop the browser from navigating to the page the widget URL points to, this does.
          // If routing is not enabled, then the URL is javascript, which does not lead to navigation anyway.
          e.preventDefault();
        }
        yield this.onNavigateAsync();
        const route = this.getRoute();
        if (route) {
          yield PageRouteProvider.redirectAsync(route);
        }
      }
    });
  }
}

class TimeWidget extends BaseRouteWidget {
  onNavigateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClick) {
        yield this.props.onClick();
      }
    });
  }
  setTimer() {
    setTimeout(() => __awaiter(this, void 0, void 0, function* () {
      return yield this.refreshDescriptionAsync();
    }), 1000);
  }
  refreshDescriptionAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.reRenderAsync();
      }
      this.setTimer();
    });
  }
  get description() {
    let description = "";
    const now = Utility.now();
    if (this.props.checkout) {
      if (this.state.data != null) {
        const beginAt = new Date(this.state.data);
        const diff = Utility.diff(now, beginAt);
        description = diff.toTimeString();
      }
    } else {
      description = Utility.format("{0:dd.MM.yyyy} {0:dddd} {0:HH:mm:ss}", now);
    }
    return description;
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.date != null) {
        this.state.data = this.props.date;
      }
      this.setTimer();
    });
  }
}

class BaseCheckboxWidget extends BaseWidget {
  onChangeAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.enabled) {
        let checked = !this.checked;
        let state = this.state;
        state.data = checked;
        if (this.isMounted) {
          e.stopPropagation();
          yield this.onChangeAsync(checked);
          yield this.setState(state);
        }
      }
    });
  }
  get icon() {
    const icon = this.checked ? {
      name: "check-circle",
      style: IconStyle.Solid
    } : {
      name: "circle",
      style: IconStyle.Regular
    };
    icon.size = this.minimized ? IconSize.X2 : IconSize.X3;
    return icon;
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (nextProps.checked !== this.props.checked) {
        this.state.data = nextProps.checked === true;
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let state = this.state;
      state.data = this.props.checked ? this.props.checked : false;
    });
  }
  get checked() {
    return this.state.data === true;
  }
  get disabled() {
    return this.props.disabled === true;
  }
  get enabled() {
    return !this.disabled;
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
}

class CheckboxWidget extends BaseCheckboxWidget {
  get minimized() {
    return this.mobile || this.state.minimized;
  }
  onChangeAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, checked);
      }
    });
  }
}

class CheckStepWidget extends BaseCheckboxWidget {
  get minimized() {
    return false;
  }
  onChangeAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, checked);
      }
    });
  }
  get icon() {
    return null;
  }
  renderLabel() {
    return null;
  }
  renderDescription() {
    return null;
  }
  renderMinimized() {
    return null;
  }
  get wide() {
    return true;
  }
  getInnerClassName() {
    return widgetStyles.checkStepContainer;
  }
  renderContent(renderHidden = false) {
    return React.createElement("div", {
      className: widgetStyles.checkStep
    }, React.createElement("div", {
      className: "d-flex justify-content-between"
    }, this.label && React.createElement("span", null, this.label), React.createElement(Checkbox, {
      className: widgetStyles.checkbox,
      value: this.checked,
      onChange: (sender, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangeAsync(value);
      })
    })), this.description && React.createElement("span", null, this.description));
  }
}

class BaseExpandableWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this._contentVisible = false;
  }
  onExpandAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  onCollapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  setContentAsync(visible) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._contentVisible !== visible) {
        this._contentVisible = visible;
        const minimized = this.props.minimized == true ? !visible : false;
        const expanding = !minimized && visible;
        yield this.setState({
          minimized: minimized
        });
        if (expanding) {
          yield this.onExpandAsync();
        } else {
          yield this.onCollapseAsync();
        }
      }
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.isSpinning()) {
        yield this.toggleContentAsync();
      }
    });
  }
  toggleContentAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setContentAsync(!this.contentVisible);
    });
  }
  showContentAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setContentAsync(true);
    });
  }
  hideContentAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setContentAsync(false);
    });
  }
  get contentVisible() {
    return this._contentVisible;
  }
  get noAutoCollapse() {
    return this.props.noAutoCollapse == true;
  }
  isAsync() {
    return false;
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.isSpinning()) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside && !this.noAutoCollapse) {
          yield this.hideContentAsync();
        }
      }
    });
  }
  renderContent(renderHidden = false) {
    return React.createElement(React.Fragment, null, this.contentVisible ? React.createElement("div", {
      className: widgetStyles.expandableContent
    }, this.renderExpanded()) : super.renderContent(renderHidden));
  }
}

var css_248z$g = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.dateInputContainer {\n  padding: 10px 0 12px 0;\n}\n\n.dateInputWidget {\n  background-color: rgb(254, 80, 0);\n  border-color: white;\n}\n.dateInputWidget .react-datepicker__triangle {\n  border-bottom-color: #e04716;\n}\n.dateInputWidget .react-datepicker__navigation.react-datepicker__navigation--previous {\n  border-right-color: white;\n}\n.dateInputWidget .react-datepicker__navigation.react-datepicker__navigation--next {\n  border-left-color: white;\n}\n.dateInputWidget .react-datepicker__header {\n  background-color: #e04716;\n  border-color: white;\n}\n.dateInputWidget .react-datepicker__header .react-datepicker__current-month {\n  color: white;\n}\n.dateInputWidget .react-datepicker__header .react-datepicker__day-name {\n  color: white;\n}\n.dateInputWidget .react-datepicker__day {\n  color: white;\n}\n.dateInputWidget .react-datepicker__day:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.dateInputWidget .react-datepicker__day--today {\n  border: 1px solid white;\n  border-radius: 50%;\n  height: 1.7rem;\n}\n.dateInputWidget .react-datepicker__day--selected {\n  background-color: #337ab7;\n}\n.dateInputWidget .react-datepicker__today-button {\n  background-color: #e04716;\n  color: white;\n  border-top-color: white;\n}";
styleInject(css_248z$g);

class DateInputWidget extends BaseExpandableWidget {
  handleChange(date) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(date);
      }
      yield this.hideContentAsync();
    });
  }
  onClickAsync(e) {
    const _super = Object.create(null, {
      toggleContentAsync: {
        get: () => super.toggleContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      if (target.parentElement) {
        if (target.parentElement.className.startsWith("react-datepicker")) {
          return;
        }
      }
      yield _super.toggleContentAsync.call(this);
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this.state.icon = {
        name: "far calendar-day"
      };
      yield _super.initializeAsync.call(this);
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this.state.icon = {
        name: "far calendar-day"
      };
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  renderExpanded() {
    return React.createElement("div", {
      className: "dateInputContainer"
    }, React.createElement(DatePickerLibrary__default, {
      selected: this.props.value || new Date(),
      minDate: this.props.minDate,
      onChange: date => this.handleChange(date),
      className: "form-control",
      calendarClassName: "datepicker dateInputWidget",
      inline: true,
      todayButton: this.props.todayButton
    }));
  }
  renderContent(renderHidden = false) {
    return React.createElement(React.Fragment, null, this.contentVisible ? React.createElement("div", {
      className: widgetStyles.expandableContent
    }, this.renderExpanded()) : this.props.value ? this.renderDate(this.props.value) : this.renderContent());
  }
  renderDate(date) {
    return React.createElement("span", {
      className: widgetStyles.date
    }, Utility.toDateString(date));
  }
}

class LinkWidget extends BaseWidget {
  getHref() {
    return this.props.url;
  }
  getTarget() {
    var _a;
    return (_a = this.props.target) !== null && _a !== void 0 ? _a : LinkTarget.Blank;
  }
}

var css_248z$f = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-navigation-widget-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content.athenaeum-navigation-widget-disabled i {\n  opacity: 0.5;\n}\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer {\n  padding: 0 !important;\n}\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-left i {\n  padding-right: 10px;\n}\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-right i {\n  padding-left: 10px;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle > div {\n  margin: 0;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle > div div:first-child {\n  text-align: left;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle > div div:last-child {\n  text-align: right;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content {\n  background-color: transparent;\n  box-shadow: none;\n  padding: 0;\n  display: inline-block;\n  width: auto;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer {\n  display: inline !important;\n  color: rgb(254, 80, 0);\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer i {\n  padding: 1px;\n  border-radius: 50%;\n  background-color: white;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-left {\n  display: inline-block !important;\n  text-align: left;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-right {\n  display: inline-block !important;\n  text-align: right;\n}";
var styles$d = {"font-renta":"athenaeum-navigation-widget-font-renta","navigation":"athenaeum-navigation-widget-navigation","widget":"athenaeum-navigation-widget-widget","content":"athenaeum-navigation-widget-content","disabled":"athenaeum-navigation-widget-disabled","compactContainer":"athenaeum-navigation-widget-compactContainer","left":"athenaeum-navigation-widget-left","right":"athenaeum-navigation-widget-right","mobileStyle":"athenaeum-navigation-widget-mobileStyle"};
styleInject(css_248z$f);

//Autogenerated
class NavigationWidgetLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.previousLanguageItemName = `_5:0`;
    this.returnToPreviousLanguageItemName = `_5:1`;
    this.nextLanguageItemName = `_5:2`;
    this.goToNextLanguageItemName = `_5:3`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_5:0`, {
      l: `en`,
      v: `Previous`
    }, {
      l: `uk`,
      v: `Назад`
    }, {
      l: `sv`,
      v: `Föregående`
    }, {
      l: `ru`,
      v: `Предыдущий`
    }, {
      l: `pl`,
      v: `Poprzedni`
    }, {
      l: `nl`,
      v: `Vorig`
    }, {
      l: `nb`,
      v: `Forrige`
    }, {
      l: `it`,
      v: `Precedente`
    }, {
      l: `fr`,
      v: `Précédent`
    }, {
      l: `fi`,
      v: `Edellinen`
    }, {
      l: `es`,
      v: `Previo`
    }, {
      l: `de`,
      v: `Vorherige`
    }, {
      l: `da`,
      v: `Forrige`
    });
    this.set(`_5:1`, {
      l: `en`,
      v: `Return to previous step`
    }, {
      l: `uk`,
      v: `Повернутися до попереднього кроку`
    }, {
      l: `sv`,
      v: `Återgå till föregående steg`
    }, {
      l: `ru`,
      v: `Вернуться на предыдущий шаг`
    }, {
      l: `pl`,
      v: `Powrót do poprzedniego kroku`
    }, {
      l: `nl`,
      v: `Keer terug naar de vorige stap`
    }, {
      l: `nb`,
      v: `Gå tilbake til forrige trinn`
    }, {
      l: `it`,
      v: `Ritorna al passaggio precedente`
    }, {
      l: `fr`,
      v: `Revenir à l'étape précédente`
    }, {
      l: `fi`,
      v: `Palaa edelliseen vaiheeseen`
    }, {
      l: `es`,
      v: `Volver al paso anterior`
    }, {
      l: `de`,
      v: `Kehren Sie zum vorherigen Schritt zurück`
    }, {
      l: `da`,
      v: `Vend tilbage til forrige trin`
    });
    this.set(`_5:2`, {
      l: `en`,
      v: `Next`
    }, {
      l: `uk`,
      v: `Далі`
    }, {
      l: `sv`,
      v: `Nästa`
    }, {
      l: `ru`,
      v: `Далее`
    }, {
      l: `pl`,
      v: `Następny`
    }, {
      l: `nl`,
      v: `Volgende`
    }, {
      l: `nb`,
      v: `Neste`
    }, {
      l: `it`,
      v: `Prossimo`
    }, {
      l: `fr`,
      v: `Suivant`
    }, {
      l: `fi`,
      v: `Seuraava`
    }, {
      l: `es`,
      v: `Próximo`
    }, {
      l: `de`,
      v: `Nächste`
    }, {
      l: `da`,
      v: `Næste`
    });
    this.set(`_5:3`, {
      l: `en`,
      v: `Go to next step`
    }, {
      l: `uk`,
      v: `Перейти до наступного кроку`
    }, {
      l: `sv`,
      v: `Gå till nästa steg`
    }, {
      l: `ru`,
      v: `Перейти к следующему шагу`
    }, {
      l: `pl`,
      v: `Następny krok`
    }, {
      l: `nl`,
      v: `Ga naar de volgende stap`
    }, {
      l: `nb`,
      v: `Gå til neste trinn`
    }, {
      l: `it`,
      v: `Vai al passaggio successivo`
    }, {
      l: `fr`,
      v: `Passer à l'étape suivante`
    }, {
      l: `fi`,
      v: `Siirry seuraavaan vaiheeseen`
    }, {
      l: `es`,
      v: `Ir al siguiente paso`
    }, {
      l: `de`,
      v: `Gehen Sie zum nächsten Schritt`
    }, {
      l: `da`,
      v: `Gå til næste trin`
    });
  }
  /**
  /* "Previous" (Previous)
  /* "Localizer.previous"
  /* "Localizer.previousLanguageItemName"
  */
  get previous() {
    return this.get(`_5:0`);
  }
  /**
  /* "ReturnToPrevious" (Return to previous step)
  /* "Localizer.returnToPrevious"
  /* "Localizer.returnToPreviousLanguageItemName"
  */
  get returnToPrevious() {
    return this.get(`_5:1`);
  }
  /**
  /* "Next" (Next)
  /* "Localizer.next"
  /* "Localizer.nextLanguageItemName"
  */
  get next() {
    return this.get(`_5:2`);
  }
  /**
  /* "GoToNext" (Go to next step)
  /* "Localizer.goToNext"
  /* "Localizer.goToNextLanguageItemName"
  */
  get goToNext() {
    return this.get(`_5:3`);
  }
}
//Singleton
var NavigationWidgetLocalizer$1 = new NavigationWidgetLocalizer();

class NavigationWidget extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      transparent: this.props.transparent || false
    };
  }
  onPrevClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.canPrev) {
        e.stopPropagation();
        if (this.props.onPrevClick) {
          yield this.props.onPrevClick();
        } else if (this.props.prevRoute) {
          yield ch.swipeRightAsync();
          yield PageRouteProvider.redirectAsync(this.props.prevRoute);
        } else {
          yield ch.swipeRightAsync();
          yield PageRouteProvider.back();
        }
      }
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.canNext) {
        e.stopPropagation();
        if (this.props.onClick) {
          yield this.props.onClick();
        } else if (this.props.route) {
          yield ch.swipeLeftAsync();
          yield PageRouteProvider.redirectAsync(this.props.route);
        }
      }
    });
  }
  get canPrev() {
    return this.props.canPrev !== false;
  }
  get canNext() {
    return this.props.can !== false;
  }
  get prevIcon() {
    return this.mobileStyle ? this.props.prevIcon || {
      name: "chevron-circle-left",
      style: IconStyle.Solid,
      size: IconSize.X3
    } : this.props.prevIcon || {
      name: "arrow-alt-circle-left",
      style: IconStyle.Regular,
      size: IconSize.X2
    };
  }
  get nextIcon() {
    return this.mobileStyle ? this.props.prevIcon || {
      name: "chevron-circle-right",
      style: IconStyle.Solid,
      size: IconSize.X3
    } : this.props.prevIcon || {
      name: "arrow-alt-circle-right",
      style: IconStyle.Regular,
      size: IconSize.X2
    };
  }
  get prevLabel() {
    return this.props.prevLabel || NavigationWidgetLocalizer$1.previous;
  }
  get prevDescription() {
    return this.props.prevDescription || NavigationWidgetLocalizer$1.returnToPrevious;
  }
  get label() {
    return this.props.label || NavigationWidgetLocalizer$1.next;
  }
  get description() {
    return this.props.description || NavigationWidgetLocalizer$1.goToNext;
  }
  get wide() {
    return true;
  }
  get mobileStyle() {
    return this.responsive && this.mobile;
  }
  get desktopStyle() {
    return !this.mobileStyle;
  }
  minimizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  maximizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  get minimized() {
    return false;
  }
  get responsive() {
    return this.props.responsive == true;
  }
  isWidget() {
    return true;
  }
  get transparent() {
    return this.state.transparent;
  }
  render() {
    const mobileStyle = this.mobileStyle && styles$d.mobileStyle;
    const disabledPrevStyle = !this.canPrev && styles$d.disabled;
    const disabledNextStyle = !this.canNext && styles$d.disabled;
    return React.createElement("div", {
      className: this.css(this.props.className, styles$d.navigation, mobileStyle, "col-md-12")
    }, React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      id: this.id,
      className: this.css(styles$d.widget, widgetStyles.widget, this.props.className, "col-6")
    }, React.createElement("div", {
      title: this.toSingleLine(this.prevDescription || this.props.label),
      className: this.css(styles$d.content, widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content, disabledPrevStyle),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onPrevClickAsync(e);
      })
    }, React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, styles$d.compactContainer, styles$d.left)
    }, React.createElement(Icon, Object.assign({}, this.prevIcon)), this.desktopStyle && React.createElement("div", {
      className: widgetStyles.labelAndDescription
    }, React.createElement("div", null, React.createElement("span", null, this.prevLabel)), React.createElement("div", {
      className: widgetStyles.description
    }, React.createElement("span", null, this.toSingleLine(this.prevDescription))))))), React.createElement("div", {
      id: this.id,
      className: this.css(styles$d.widget, widgetStyles.widget, this.props.className, "col-6")
    }, React.createElement("div", {
      title: this.toSingleLine(this.description || this.props.label),
      className: this.css(styles$d.content, widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content, disabledNextStyle),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onClickAsync(e);
      })
    }, React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, styles$d.compactContainer, styles$d.right)
    }, this.desktopStyle && React.createElement("div", {
      className: widgetStyles.labelAndDescription
    }, React.createElement("div", null, React.createElement("span", null, this.label)), React.createElement("div", {
      className: widgetStyles.description
    }, React.createElement("span", null, this.toSingleLine(this.description)))), React.createElement(Icon, Object.assign({}, this.nextIcon)))))));
  }
}

class NumberWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this._inputRef = React.createRef();
    this._acceptableStr = null;
  }
  onInputChangeHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const str = e.currentTarget.value;
      const parsingResult = NumberUtility.parse(str, this.allowFloat);
      const acceptableStr = parsingResult.acceptableStr !== null ? parsingResult.acceptableStr : this._acceptableStr;
      const needToRender = acceptableStr !== this._acceptableStr;
      this._acceptableStr = acceptableStr;
      if (needToRender) {
        yield this.reRenderAsync();
      }
    });
  }
  onInputKeyUpHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const enter = e.keyCode === 13;
      const esc = e.keyCode === 27;
      if (enter || esc) {
        yield this.stopEditAsync(enter);
      }
    });
  }
  onWheelHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const step = e.deltaY < 0 ? this.step : -this.step;
      yield this.setAsync(this.value + step);
    });
  }
  saveChangesAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._acceptableStr != null) {
        const parsingResult = NumberUtility.parse(this._acceptableStr, this.allowFloat);
        this._acceptableStr = null;
        if (parsingResult.parsed) {
          yield this.setAsync(parsingResult.value);
        }
      }
    });
  }
  getStr() {
    return this._acceptableStr != null ? this._acceptableStr : this.state.number != null ? this.state.number.toString() : "";
  }
  getInnerClassName() {
    if (this.readonly) {
      return widgetStyles.readonly;
    }
    return super.getInnerClassName();
  }
  setAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      value = Utility.roundE(value);
      if (value !== this.value && this.canSet(value)) {
        if (this.props.onChange) {
          yield this.props.onChange(this, value);
        }
        yield this.setState({
          number: value
        });
        return true;
      }
      return false;
    });
  }
  increaseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let nextValue = this.value + this.step;
      if (nextValue > this.max) {
        nextValue = this.max;
      }
      yield this.setAsync(nextValue);
    });
  }
  decreaseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let nextValue = this.value - this.step;
      if (nextValue < this.min) {
        nextValue = this.min;
      }
      yield this.setAsync(nextValue);
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      if (nextProps.value !== this.props.value) {
        this.state.number = nextProps.value != null ? nextProps.value : this.min;
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      const state = this.state;
      state.number = this.props.value || this.min;
      state.data = {
        edit: false
      };
    });
  }
  get edit() {
    return !this.readonly && this.props.strict !== true && this.state.data != null && this.state.data.edit;
  }
  setEditAsync(edit) {
    return __awaiter(this, void 0, void 0, function* () {
      edit = edit && !this.readonly;
      if (this.edit != edit) {
        this._acceptableStr = null;
        const data = {
          edit: edit
        };
        yield this.setState({
          data
        });
        if (edit && this._inputRef.current != null) {
          this._inputRef.current.focus();
          this._inputRef.current.select();
        }
      }
    });
  }
  startEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setEditAsync(true);
    });
  }
  stopEditAsync(save = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (save) {
        yield this.saveChangesAsync();
      }
      this._acceptableStr = null;
      yield this.setEditAsync(false);
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const outsideInput = Utility.clickedOutside(target, this.inputId);
      if (outsideInput) {
        yield this.stopEditAsync();
      }
      if (this.canMinimize) {
        const outsideWidget = Utility.clickedOutside(target, this.id);
        if (outsideWidget && !this.minimized) {
          yield this.minimizeAsync();
        }
      }
    });
  }
  get reverse() {
    return !!this.props.reverse;
  }
  get readonly() {
    return !!this.props.readonly;
  }
  get value() {
    return this.state.number || 0;
  }
  get min() {
    return this.props.min || 0;
  }
  get max() {
    return this.props.max || Number.POSITIVE_INFINITY;
  }
  get step() {
    const numberFormat = NumberUtility.resolveFormat(this.props.step, this.props.format);
    return numberFormat.step;
  }
  get canDecrease() {
    return this.value > this.min;
  }
  get canIncrease() {
    return this.value < this.max;
  }
  canSet(value) {
    value = Utility.roundE(value);
    return !this.readonly && this.min <= value && value <= this.max;
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
  getIconStyle(iconPosition) {
    return this.reverse ? iconPosition == 1 ? this.css(!this.canIncrease && widgetStyles.disabled) : this.css(!this.canDecrease && widgetStyles.disabled) : iconPosition == 1 ? this.css(!this.canDecrease && widgetStyles.disabled) : this.css(!this.canIncrease && widgetStyles.disabled);
  }
  getIconOnClick(iconPosition) {
    if (this.reverse) {
      return iconPosition == 1 ? () => __awaiter(this, void 0, void 0, function* () {
        return yield this.increaseAsync();
      }) : () => __awaiter(this, void 0, void 0, function* () {
        return yield this.decreaseAsync();
      });
    } else {
      return iconPosition == 1 ? () => __awaiter(this, void 0, void 0, function* () {
        return yield this.decreaseAsync();
      }) : () => __awaiter(this, void 0, void 0, function* () {
        return yield this.increaseAsync();
      });
    }
  }
  get inputId() {
    return `input${this.id}`;
  }
  get numberFormat() {
    const numberFormat = NumberUtility.resolveFormat(this.props.step, this.props.format);
    return numberFormat.format;
  }
  get allowFloat() {
    return this.step < 1.0;
  }
  get canMinimize() {
    return !!this.props.canMinimize;
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.canMinimize) {
        if (this.minimized) {
          yield this.maximizeAsync();
        } else {
          const target = e.target;
          const outsideWidgetBody = Utility.clickedOutside(target, `number-widget-body_${this.id}`);
          if (outsideWidgetBody) {
            yield this.toggleMinimized();
          }
        }
      }
    });
  }
  getIconProps(iconPosition) {
    const minusIconProps = this.props.minusIcon || {
      name: "minus-circle",
      style: IconStyle.Regular
    };
    const plusIconProps = this.props.plusIcon || {
      name: "plus-circle",
      style: IconStyle.Regular
    };
    return this.reverse ? iconPosition == 1 ? plusIconProps : minusIconProps : iconPosition == 1 ? minusIconProps : plusIconProps;
  }
  renderIcon(iconPosition) {
    const iconProps = this.getIconProps(iconPosition);
    return React.createElement("div", {
      onClick: this.getIconOnClick(iconPosition),
      className: this.getIconStyle(iconPosition)
    }, React.createElement(Icon, Object.assign({}, iconProps, {
      size: IconSize.X2
    })));
  }
  renderContent(renderHidden = false) {
    return React.createElement("div", {
      id: `number-widget-body_${this.id}`,
      className: this.css(widgetStyles.numberWidget, this.edit && widgetStyles.edit, this.readonly && widgetStyles.readonly)
    }, this.renderIcon(1), this.edit ? React.createElement("input", {
      id: this.inputId,
      ref: this._inputRef,
      type: "text",
      className: "form-control",
      readOnly: this.readonly,
      value: this.getStr(),
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputChangeHandlerAsync(e);
      }),
      onKeyUp: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputKeyUpHandlerAsync(e);
      }),
      onWheel: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onWheelHandlerAsync(e);
      })
    }) : React.createElement("div", {
      onClick: () => this.startEditAsync()
    }, super.renderContent(renderHidden)), this.renderIcon(2));
  }
}

class OcrOptions {
  constructor(scale = 1, filter = null) {
    this.filter = null;
    this.scale = scale;
    this.filter = filter;
  }
  get code() {
    return `scale:${this.scale} filter:${this.filter}`;
  }
}
class RenderContainer {
  constructor(videoWidth, videoHeight, viewFinderDeltaX, viewFinderDeltaY) {
    this.videoWidth = 0;
    this.videoHeight = 0;
    this.viewFinderDeltaX = 1;
    this.viewFinderDeltaY = 1;
    this.scale = 1;
    this.sx = 0;
    this.sy = 0;
    this.sw = 0;
    this.sh = 0;
    this.dw = 0;
    this.dh = 0;
    this.debugWidth = 0;
    this.debugHeight = 0;
    this.ocrCircles = [];
    this.ocrCircle = 0;
    this.videoWidth = videoWidth;
    this.videoHeight = videoHeight;
    this.viewFinderDeltaX = viewFinderDeltaX;
    this.viewFinderDeltaY = viewFinderDeltaY;
  }
  calculate(scale) {
    this.scale = scale;
    const crop = scale > 1 || this.viewFinderDeltaX > 0 || this.viewFinderDeltaY > 0;
    if (crop) {
      const finderDx = this.viewFinderDeltaX > 0 ? Math.round(this.videoWidth * this.viewFinderDeltaX) : 0;
      const finderDy = this.viewFinderDeltaY > 0 ? Math.round(this.videoHeight * this.viewFinderDeltaY) : 0;
      const finder2Dx = 2 * finderDx;
      const finder2Dy = 2 * finderDy;
      let dw = this.videoWidth - finder2Dx;
      let dh = this.videoHeight - finder2Dy;
      if (scale > 1) {
        dw = Math.trunc(scale * dw);
        dh = Math.trunc(scale * dh);
      }
      const croppedWidth = this.videoWidth - finder2Dx;
      const croppedHeight = this.videoHeight - finder2Dy;
      this.sx = finderDx;
      this.sy = finderDy;
      this.sw = croppedWidth;
      this.sh = croppedHeight;
      this.dw = dw;
      this.dh = dh;
    } else {
      this.sx = 0;
      this.sy = 0;
      this.sw = this.videoWidth;
      this.sh = this.videoHeight;
      this.dw = this.videoWidth;
      this.dh = this.videoHeight;
    }
    this.debugWidth = this.dw / 3;
    this.debugHeight = this.dh / 3;
  }
  static create(videoWidth, videoHeight, viewFinderDeltaX, viewFinderDeltaY, scale) {
    const container = new RenderContainer(videoWidth, videoHeight, viewFinderDeltaX, viewFinderDeltaY);
    container.calculate(scale);
    container.generateCircles();
    return container;
  }
  generateCircles() {
    const scale0 = this.scale;
    //const scale1: number = (scale0 > 2) ? 0.5 * scale0 : 1;
    //const scale2: number = 1.5 * scale0;
    this.ocrCircles = [new OcrOptions(scale0, null)
    //new OcrOptions(scale0, ImageFilterType.Brightness30),
    //new OcrOptions(scale0, ImageFilterType.Contrast70),
    //new OcrOptions(scale0, ImageFilterType.Contrast70),
    // new OcrOptions(scale1, ImageFilterType.Contrast30),
    // new OcrOptions(scale1, ImageFilterType.Contrast70),
    // new OcrOptions(scale1, null),
    // new OcrOptions(scale2, ImageFilterType.Contrast30),
    // new OcrOptions(scale2, ImageFilterType.Contrast70),
    // new OcrOptions(scale2, null),
    ];
  }
  getCircle() {
    const length = this.ocrCircles.length;
    if (length == 0) {
      return new OcrOptions(this.scale);
    }
    const index = this.ocrCircle;
    this.ocrCircle = index >= length - 1 ? 0 : index + 1;
    const circle = this.ocrCircles[index];
    if (circle.scale != this.scale) {
      this.calculate(circle.scale);
    }
    return circle;
  }
}

var ImageFilterType;
(function (ImageFilterType) {
  ImageFilterType[ImageFilterType["None"] = 0] = "None";
  ImageFilterType[ImageFilterType["Contrast30"] = 1] = "Contrast30";
  ImageFilterType[ImageFilterType["Contrast70"] = 2] = "Contrast70";
  ImageFilterType[ImageFilterType["Brightness30"] = 3] = "Brightness30";
  ImageFilterType[ImageFilterType["GaussianBlur"] = 4] = "GaussianBlur";
  ImageFilterType[ImageFilterType["Sharpen"] = 5] = "Sharpen";
  ImageFilterType[ImageFilterType["EdgeDetect"] = 6] = "EdgeDetect";
})(ImageFilterType || (ImageFilterType = {}));
class ImageFilters {
  constructor() {
    this.sobel_v = [-1.0, 0.0, +1.0, -2.0, 0.0, +2.0, -1.0, 0.0, +1.0];
    this.sobel_h = [-1.0, -2.0, -1.0, 0.0, 0.0, 0.0, +1.0, +2.0, +1.0];
  }
  contrast(imageData, contrast) {
    const data = imageData.data; // Note: original dataset modified directly!
    const length = data.length;
    const factor = 259 * (contrast + 255) / (255 * (259 - contrast));
    for (let i = 0; i < length; i += 4) {
      data[i] = factor * (data[i] - 128) + 128;
      data[i + 1] = factor * (data[i + 1] - 128) + 128;
      data[i + 2] = factor * (data[i + 2] - 128) + 128;
    }
  }
  brightness(imageData, brightness) {
    const data = imageData.data; // Note: original dataset modified directly!
    const length = data.length;
    for (let i = 0; i < length; i++) {
      if (i % 4 !== 3) {
        let value = data[i] + brightness;
        if (value < 0) {
          value = 0;
        } else if (value > 255) {
          value = 255;
        }
        data[i] = value;
      }
    }
  }
  gaussianBlur(imageData, radius = 3, destination = null) {
    let source = imageData.data; // Note: original dataset modified directly!
    const length = source.length;
    const width = imageData.width;
    if (destination == null) {
      destination = source;
      source = new Uint8ClampedArray(length);
      source.set(destination);
    }
    const blurRange = radius * 3;
    const gaussParam = [];
    const dRadius = 2 * radius * radius;
    for (let i = 0; i <= blurRange; i++) {
      gaussParam[i] = Math.exp(-i * i / dRadius);
    }
    for (let i = 0; i < length; i++) {
      let r = 0;
      let g = 0;
      let b = 0;
      let a = 0;
      let count = 0;
      const ox = i % width;
      for (let x = -1 * blurRange; x <= blurRange; x++) {
        const tx = ox + x;
        if (0 <= tx && tx < width) {
          const gauss = gaussParam[x < 0 ? -x : x]; // = [Math.abs(x)]
          const delta = 4 * (i + x);
          r += source[delta] * gauss;
          g += source[delta + 1] * gauss;
          b += source[delta + 2] * gauss;
          a += source[delta + 3] * gauss;
          count += gauss;
        }
      }
      const delta = 4 * i;
      destination[delta] = r / count | 0;
      destination[delta + 1] = g / count | 0;
      destination[delta + 2] = b / count | 0;
      destination[delta + 3] = a / count | 0;
    }
    // const tmp = new Uint8ClampedArray(length);
    // tmp.set(data);
    //
    // for (let i: number = 0; i < length; i++) {
    //     if (i % 4 !== 3) {
    //         const source: number = tmp[i];
    //         const delta: number = 4 * width;
    //         data[i] = (tmp[i]
    //             + (tmp[i - 4] || source)
    //             + (tmp[i + 4] || source)
    //             + (tmp[i - delta] || source)
    //             + (tmp[i + delta] || source)
    //             + (tmp[i - delta - 4] || source)
    //             + (tmp[i + delta + 4] || source)
    //             + (tmp[i + delta - 4] || source)
    //             + (tmp[i - delta + 4] || source)
    //         ) / 9;
    //     }
    // }
  }
  sharpen(imageData, mix = 0.7) {
    const w = imageData.width;
    const h = imageData.height;
    const weights = [0, -1, 0, -1, 5, -1, 0, -1, 0];
    const k = Math.round(Math.sqrt(weights.length));
    const half = k * 0.5 | 0;
    const dstBuff = imageData.data;
    const srcBuff = new Uint8ClampedArray(dstBuff.length);
    srcBuff.set(dstBuff);
    let x, sx, sy, r, g, b, a, dstOff, srcOff, wt, cx, cy, scy, scx;
    let y = h;
    while (y--) {
      x = w;
      while (x--) {
        sy = y;
        sx = x;
        dstOff = (y * w + x) * 4;
        r = 0;
        g = 0;
        b = 0;
        a = 0;
        if (x > 0 && y > 0 && x < w - 1 && y < h - 1) {
          for (cy = 0; cy < k; cy++) {
            for (cx = 0; cx < k; cx++) {
              scy = sy + cy - half;
              scx = sx + cx - half;
              if (scy >= 0 && scy < h && scx >= 0 && scx < w) {
                srcOff = (scy * w + scx) * 4;
                wt = weights[cy * k + cx];
                r += srcBuff[srcOff] * wt;
                g += srcBuff[srcOff + 1] * wt;
                b += srcBuff[srcOff + 2] * wt;
                a += srcBuff[srcOff + 3] * wt;
              }
            }
          }
          dstBuff[dstOff] = r * mix + srcBuff[dstOff] * (1 - mix);
          dstBuff[dstOff + 1] = g * mix + srcBuff[dstOff + 1] * (1 - mix);
          dstBuff[dstOff + 2] = b * mix + srcBuff[dstOff + 2] * (1 - mix);
          dstBuff[dstOff + 3] = srcBuff[dstOff + 3];
        } else {
          dstBuff[dstOff] = srcBuff[dstOff];
          dstBuff[dstOff + 1] = srcBuff[dstOff + 1];
          dstBuff[dstOff + 2] = srcBuff[dstOff + 2];
          dstBuff[dstOff + 3] = srcBuff[dstOff + 3];
        }
      }
    }
  }
  // input: imageData object with RGBA data
  // output: 2D array with edge detection data. Note, 1 channel per pixel.
  edgeDetect(imageData) {
    const width = imageData.width;
    const data = imageData.data;
    const dataLength = data.length;
    const pixels = new Uint8ClampedArray(dataLength * 0.25);
    const pixelsLength = pixels.length;
    //create greyscale first
    let i = dataLength;
    while (i) {
      // let a = data[i-1];
      const b = data[i - 2];
      const g = data[i - 3];
      const r = data[i - 4];
      pixels[i * 0.25] = 0.3 * r + 0.59 * g + 0.11 * b; // Luminocity weighted average.
      // pixels[i*0.25] = (r+b+g)/3; // average
      i -= 4;
    }
    // now edge detect
    let dataIndex = 0;
    for (let i = 0; i < pixelsLength; i++) {
      // loop our 3x3 kernels, build our kernel values
      let hSum = 0;
      let vSum = 0;
      for (let y = 0; y < 3; y++) {
        const delta = width * y;
        for (let x = 0; x < 3; x++) {
          let pixel = pixels[i + delta + x];
          let kernelAccessor = x * 3 + y;
          hSum += pixel * this.sobel_h[kernelAccessor];
          vSum += pixel * this.sobel_v[kernelAccessor];
        }
        // apply kernel evaluation to current pixel
        pixels[i] = Math.sqrt(hSum * hSum + vSum * vSum);
        // pixels[i] = Math.abs((hSum + vSum) * 0.5);
      }
      let pixel = 255 - pixels[i];
      data[dataIndex] = pixel;
      data[dataIndex + 1] = pixel;
      data[dataIndex + 2] = pixel;
      data[dataIndex + 3] = 255;
      dataIndex += 4;
    }
  }
  applyFilter(filter, canvasElementContext, width, height) {
    if (filter) {
      const imageData = canvasElementContext.getImageData(0, 0, width, height);
      switch (filter) {
        case ImageFilterType.Contrast30:
          this.contrast(imageData, 30);
          break;
        case ImageFilterType.Contrast70:
          this.contrast(imageData, 70);
          break;
        case ImageFilterType.Brightness30:
          this.brightness(imageData, 30);
          break;
        case ImageFilterType.Sharpen:
          this.sharpen(imageData);
          break;
        case ImageFilterType.GaussianBlur:
          this.gaussianBlur(imageData);
          break;
        case ImageFilterType.EdgeDetect:
          this.edgeDetect(imageData);
          break;
      }
      canvasElementContext.putImageData(imageData, 0, 0);
    }
  }
}
var ImageFilters$1 = new ImageFilters();

//Autogenerated
class QrWidgetLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.scanErrorLanguageItemName = `_33:0`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_33:0`, {
      l: `en`,
      v: `QR code scanner is not available, probably no permissions to camera on your mobile device.`
    }, {
      l: `uk`,
      v: `Сканер QR-коду недоступний, можливо, на вашому мобільному пристрої не отримано дозволу на використання камери.`
    }, {
      l: `sv`,
      v: `QR-kodskanner inte tillgänglig, förmodligen inga behörigheter för kameran på din mobila enhet.`
    }, {
      l: `ru`,
      v: `Сканер QR-кода недоступен, возможно, на вашем мобильном устройстве не получено разрешение на использование камеры.`
    }, {
      l: `pl`,
      v: `Skaner kodów QR niedostępny, prawdopodobnie brak uprawnień do kamery na Twoim urządzeniu mobilnym.`
    }, {
      l: `nl`,
      v: `QR-codescanner is niet beschikbaar, waarschijnlijk geen toestemming voor camera op uw mobiele apparaat.`
    }, {
      l: `nb`,
      v: `QR-kodeskanner er ikke tilgjengelig, det er sannsynligvis ingen tillatelser til bruk av kamera på mobilenheten din.`
    }, {
      l: `it`,
      v: `Lo scanner del codice QR non è disponibile, probabilmente non è disponibile l'autorizzazione per la fotocamera del tuo dispositivo mobile.`
    }, {
      l: `fr`,
      v: `Le scanner de code QR n'est pas disponible, probablement aucune autorisation sur l'appareil photo sur votre appareil mobile.`
    }, {
      l: `fi`,
      v: `QR koodi skanneri ei käytössä. Mahdollisesti kameran käyttöoikeudet puuttuvat laitteeltasi.`
    }, {
      l: `es`,
      v: `El escáner de códigos QR no está disponible, probablemente no tenga permisos para la cámara de su dispositivo móvil.`
    }, {
      l: `de`,
      v: `Der QR-Code-Scanner ist nicht verfügbar, wahrscheinlich keine Berechtigungen für die Kamera auf Ihrem Mobilgerät.`
    }, {
      l: `da`,
      v: `QR-kodescanner er ikke tilgængelig, sandsynligvis ingen tilladelser til kameraet på din mobile enhed.`
    });
  }
  /**
  /* "Scan.Error" (QR code scanner is not available, probably no permissions to camera on your mobile device.)
  /* "Localizer.scanError"
  /* "Localizer.scanErrorLanguageItemName"
  */
  get scanError() {
    return this.get(`_33:0`);
  }
}
//Singleton
var QrWidgetLocalizer$1 = new QrWidgetLocalizer();

var css_248z$e = ".athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport {\n  min-width: 300px;\n  min-height: 280px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport .athenaeum-qr-widget-container {\n  position: absolute;\n  display: flex;\n  height: 100%;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport .athenaeum-qr-widget-container > video {\n  position: relative;\n  margin: auto;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  pointer-events: none;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport .athenaeum-qr-widget-container .athenaeum-qr-widget-videoPlaceholder {\n  position: absolute;\n  border: solid 3px green;\n  display: flex;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport .athenaeum-qr-widget-container .athenaeum-qr-widget-finderPlaceholderRef {\n  position: absolute;\n  border: solid 3px yellow;\n  display: flex;\n  inset: auto;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport .athenaeum-qr-widget-container .athenaeum-qr-widget-viewFinder {\n  display: flex;\n  position: absolute;\n  width: auto;\n  height: auto;\n  left: auto;\n  right: auto;\n  top: auto;\n  bottom: auto;\n  border: solid 60px rgba(0, 0, 0, 0.6);\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport .athenaeum-qr-widget-container .athenaeum-qr-widget-viewFinder > div {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  border: solid 4px #6692FF;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport .athenaeum-qr-widget-container.athenaeum-qr-widget-initializing > video, .athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-viewportContainer .athenaeum-qr-widget-viewport .athenaeum-qr-widget-container.athenaeum-qr-widget-initializing .athenaeum-qr-widget-viewFinder {\n  visibility: hidden;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-logs {\n  position: fixed;\n  top: 60px;\n  right: 10px;\n  width: 100%;\n  height: 100%;\n  font-weight: bold;\n  font-size: 0.8rem;\n  pointer-events: none;\n  color: white !important;\n  background-color: rgba(51, 170, 51, 0.4) !important;\n  max-width: 400px;\n  max-height: 600px;\n}\n.athenaeum-qr-widget-qrWidget .athenaeum-qr-widget-expanded .athenaeum-qr-widget-debugImage {\n  position: fixed;\n  top: 60px;\n  right: 10px;\n}";
var styles$c = {"qrWidget":"athenaeum-qr-widget-qrWidget","expanded":"athenaeum-qr-widget-expanded","viewportContainer":"athenaeum-qr-widget-viewportContainer","viewport":"athenaeum-qr-widget-viewport","container":"athenaeum-qr-widget-container","videoPlaceholder":"athenaeum-qr-widget-videoPlaceholder","finderPlaceholderRef":"athenaeum-qr-widget-finderPlaceholderRef","viewFinder":"athenaeum-qr-widget-viewFinder","initializing":"athenaeum-qr-widget-initializing","logs":"athenaeum-qr-widget-logs","debugImage":"athenaeum-qr-widget-debugImage"};
styleInject(css_248z$e);

var QrFormat;
(function (QrFormat) {
  /** QrCode (2D): Aztec 2D barcode format. */
  QrFormat[QrFormat["Aztec"] = 0] = "Aztec";
  /** BarCode (1D): CODABAR 1D format. */
  QrFormat[QrFormat["Codabar"] = 1] = "Codabar";
  /** BarCode (1D): Code 39 1D format. */
  QrFormat[QrFormat["Code39"] = 2] = "Code39";
  /** BarCode (1D): Code 93 1D format. */
  QrFormat[QrFormat["Code93"] = 3] = "Code93";
  /** BarCode (1D): Code 128 1D format. */
  QrFormat[QrFormat["Code128"] = 4] = "Code128";
  /** QrCode (2D): Data Matrix 2D barcode format. */
  QrFormat[QrFormat["DataMatrix"] = 5] = "DataMatrix";
  /** BarCode (1D): EAN-8 1D format. */
  QrFormat[QrFormat["Ean8"] = 6] = "Ean8";
  /** BarCode (1D): EAN-13 1D format. */
  QrFormat[QrFormat["Ean13"] = 7] = "Ean13";
  /** BarCode (1D): ITF (Interleaved Two of Five) 1D format. */
  QrFormat[QrFormat["Itf"] = 8] = "Itf";
  /** QrCode (2D): MaxiCode 2D barcode format. */
  QrFormat[QrFormat["MaxiCode"] = 9] = "MaxiCode";
  /** QrCode (2D): PDF417 format. */
  QrFormat[QrFormat["Pdf417"] = 10] = "Pdf417";
  /** QrCode (2D): QR Code 2D barcode format. */
  QrFormat[QrFormat["QrCode"] = 11] = "QrCode";
  /** BarCode (1D): RSS 14 */
  QrFormat[QrFormat["Rss14"] = 12] = "Rss14";
  /** BarCode (1D): RSS EXPANDED */
  QrFormat[QrFormat["RssExpanded"] = 13] = "RssExpanded";
  /** BarCode (1D): UPC-A 1D format. */
  QrFormat[QrFormat["UpcA"] = 14] = "UpcA";
  /** BarCode (1D): UPC-E 1D format. */
  QrFormat[QrFormat["UpcE"] = 15] = "UpcE";
  /** BarCode (1D): UPC/EAN extension format. Not a stand-alone format. */
  QrFormat[QrFormat["UpcEanExtension"] = 16] = "UpcEanExtension";
  QrFormat[QrFormat["All"] = 99] = "All";
})(QrFormat || (QrFormat = {}));
var QrWidgetType;
(function (QrWidgetType) {
  /** BarCode: 1D (Default formats: QrFormat.Aztec, QrFormat.QrCode). */
  QrWidgetType[QrWidgetType["QrCode"] = 0] = "QrCode";
  /** BarCode: 2D (Default formats: QrFormat.UpcA, QrFormat.UpcE, QrFormat.Ean8, QrFormat.Ean13). */
  QrWidgetType[QrWidgetType["BarCode"] = 1] = "BarCode";
  /** BarCode: 1D & 2D (Default formats: QrFormat.Aztec, QrFormat.QrCode, QrFormat.UpcA, QrFormat.UpcE, QrFormat.Ean8, QrFormat.Ean13). */
  QrWidgetType[QrWidgetType["Any"] = 2] = "Any";
})(QrWidgetType || (QrWidgetType = {}));
var QrWidgetHighResolutionType;
(function (QrWidgetHighResolutionType) {
  /**
   * HD: 1280x720
   */
  QrWidgetHighResolutionType[QrWidgetHighResolutionType["HD"] = 0] = "HD";
  /**
   * FullDH: 1920x1080
   */
  QrWidgetHighResolutionType[QrWidgetHighResolutionType["FullHD"] = 1] = "FullHD";
  /**
   * UltraHD (4K): 3840x2160
   */
  QrWidgetHighResolutionType[QrWidgetHighResolutionType["UltraHD"] = 2] = "UltraHD";
})(QrWidgetHighResolutionType || (QrWidgetHighResolutionType = {}));
class QrWidgetConstraints {
  constructor() {
    this.supportsHardwareZoom = false;
    this.maxHardwareZoom = 0;
    this.supportsHighResolution = false;
    this.supportsTorch = false;
    this.width = 0;
    this.height = 0;
    this.maxWidth = 0;
    this.maxHeight = 0;
    this.zoom = 1;
    this.softwareZoom = 1;
    this.hardwareZoom = 1;
    this.landscape = false;
    this.torch = false;
    this.supportsFrameRate = false;
    this.maxFrameRate = 0;
    this.frameRate = 0;
    this.viewFinderDeltaX = 0;
    this.viewFinderDeltaY = 0;
    this.viewFinderBorder = 0;
    this.focusMode = null;
    this.supportedFocusModes = [];
    this.cycleInterval = null;
    this.processInterval = null;
  }
}
var FocusMode;
(function (FocusMode) {
  FocusMode["None"] = "none";
  FocusMode["Manual"] = "manual";
  FocusMode["SingleShort"] = "single-shot";
  FocusMode["Continuous"] = "continuous";
})(FocusMode || (FocusMode = {}));
const CameraDefaultWidth = 640;
const CameraDefaultHeight = 480;
const ViewFinderDefaultBorder = 10;
class QrWidget extends BaseExpandableWidget {
  constructor() {
    super(...arguments);
    this._ref = React.createRef();
    this._viewportContainerRef = React.createRef();
    this._videoRef = React.createRef();
    this._viewFinderRef = React.createRef();
    this._initializing = false;
    this._logsRef = React.createRef();
    this._logs = "";
    this._qrCodeReader = null;
    this._qrCodeReaderControls = null;
    this._softwareZoom = 1;
    this._hardwareZoom = 1;
    this._maxHardwareZoom = 1;
    this._videoTrack = null;
    this._qrConstraints = null;
    this._viewFinderDeltaX = 0;
    this._viewFinderDeltaY = 0;
    this._renderContainer = null;
    this._lastCallAt = null;
  }
  invokeOnInitializationAsync(qrConstraints) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.logAsync("qrConstraints: ", qrConstraints);
      if (this.props.onInitialize) {
        yield this.props.onInitialize(this, qrConstraints);
      }
    });
  }
  switchTorchAsync(onOff) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.torch && ((_a = this._qrCodeReaderControls) === null || _a === void 0 ? void 0 : _a.switchTorch)) {
        yield this._qrCodeReaderControls.switchTorch(onOff);
      }
    });
  }
  //private static readonly _circleData: Dictionary<string, { code: string, count: number }> = new Dictionary<string, { code: string, count: number }>();
  // private static consoleData(): void {
  //    
  //     console.log("--- STATISTICS ---");
  //     const values: { code: string, count: number }[] = this._circleData.values();
  //     values.sortByDescending(item => item.count);
  //     const length: number = values.length;
  //     for (let i: number = 0; i < length; i++) {
  //         const value: { code: string, count: number } = values[i];
  //         console.log(`${value.code}: ${value.count}`);
  //     }
  //     console.log("------------------");
  //    
  //     setTimeout(() => this.consoleData(), 1000);
  // }
  //static init: void = this.consoleData();
  onScanAsync(code, error) {
    const _super = Object.create(null, {
      hideContentAsync: {
        get: () => super.hideContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (code) {
        // console.log("RECOGNIZED!");
        //
        // const code: string = QrWidget._circle!.code;
        //
        // const item: { code: string, count: number } = QrWidget._circleData.getValue(code) ?? { code: code, count: 0}
        //
        // item.count++;
        //
        // QrWidget._circleData.setValue(code, item);
        yield this.switchTorchAsync(false);
        if (!this.noAutoCollapse) {
          yield this.stopReaderAsync();
          yield _super.hideContentAsync.call(this);
        }
        if (this.props.onQr) {
          try {
            yield this.props.onQr(this, code);
          } catch (error) {
            yield PageRouteProvider.exception(error, null, false);
          }
        }
      } else if (error) {
        yield this.onScanErrorAsync(error);
      }
    });
  }
  onScanErrorAsync(error) {
    const _super = Object.create(null, {
      hideContentAsync: {
        get: () => super.hideContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (error) {
        if (this.debug) {
          yield this.logAsync("scanError: ", error);
        }
        if (typeof error === "object") {
          yield PageRouteProvider.exception(error, null, false);
        }
      }
      yield this.switchTorchAsync(false);
      if (!this.debug && !this.noAutoCollapse) {
        yield _super.hideContentAsync.call(this);
      }
      yield ch.alertErrorAsync(QrWidgetLocalizer$1.scanError, true);
    });
  }
  logAsync(message, param) {
    return __awaiter(this, void 0, void 0, function* () {
      if (param != null) {
        const paramMessage = typeof param === "object" ? JSON.stringify(param, Object.getOwnPropertyNames(param), 1) : JSON.stringify(param, null, 1);
        message = message + " " + paramMessage;
      }
      this._logs = message + "\n" + this._logs;
      if (this._logsRef.current) {
        this._logsRef.current.value = this._logs;
      }
    });
  }
  setInitializingAsync(initializing) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._initializing != initializing) {
        this._initializing = initializing;
        yield this.reRenderAsync();
      }
    });
  }
  transformFormat(from) {
    return from;
  }
  defineZooming(zoom, maxHardwareZoom) {
    this._softwareZoom = 1;
    this._hardwareZoom = 1;
    this._maxHardwareZoom = maxHardwareZoom;
    if (zoom > 1) {
      const canHardwareZoom = !this.noHardwareZoom && maxHardwareZoom > 1;
      if (canHardwareZoom) {
        if (maxHardwareZoom >= zoom) {
          this._hardwareZoom = zoom;
        } else {
          this._hardwareZoom = maxHardwareZoom;
          this._softwareZoom = zoom / maxHardwareZoom;
        }
      } else {
        this._softwareZoom = zoom;
      }
    }
  }
  positionViewFinder() {
    this._viewFinderDeltaX = 0;
    this._viewFinderDeltaY = 0;
    this._renderContainer = null;
    let borderWidth = 0;
    if (this._viewFinderRef.current && this._videoRef.current) {
      borderWidth = this.viewFinderBorder;
      if (borderWidth > 0) {
        const softwareZoom = this.softwareZoom;
        const videoNode = this.JQuery(this._videoRef.current);
        const viewFinderNode = this.JQuery(this._viewFinderRef.current);
        const viewFinderContainerNode = viewFinderNode.parent();
        const containerWidth = viewFinderContainerNode.outerWidth() || 0;
        const containerHeight = viewFinderContainerNode.outerHeight() || 0;
        const videoElementWidth = videoNode.outerWidth() || 0;
        const videoElementHeight = videoNode.outerHeight() || 0;
        const fullVideoElementWidth = softwareZoom * videoElementWidth;
        const fullVideoElementHeight = softwareZoom * videoElementHeight;
        let scaledVideoElementWidth = fullVideoElementWidth;
        let scaledVideoElementHeight = fullVideoElementHeight;
        const videoPlaceholderX = Utility.round((containerWidth - scaledVideoElementWidth) / 2, 2);
        const videoPlaceholderY = Utility.round((containerHeight - scaledVideoElementHeight) / 2, 2);
        if (scaledVideoElementWidth > containerWidth) {
          scaledVideoElementWidth = containerWidth;
        } else if (scaledVideoElementHeight > containerHeight) {
          scaledVideoElementHeight = containerHeight;
        }
        const dx = (containerWidth - scaledVideoElementWidth) / 2;
        const dy = (containerHeight - scaledVideoElementHeight) / 2;
        viewFinderNode.css("left", dx);
        viewFinderNode.css("right", dx);
        viewFinderNode.css("top", dy);
        viewFinderNode.css("bottom", dy);
        if (borderWidth >= scaledVideoElementWidth / 4) {
          borderWidth = scaledVideoElementWidth / 4;
        }
        if (borderWidth >= scaledVideoElementHeight / 4) {
          borderWidth = scaledVideoElementHeight / 4;
        }
        viewFinderNode.css("border-width", `${borderWidth}px`);
        const deltaX = videoPlaceholderX < 0 ? -videoPlaceholderX : 0;
        const deltaY = videoPlaceholderY < 0 ? -videoPlaceholderY : 0;
        this._viewFinderDeltaX = Utility.round((borderWidth + deltaX) / fullVideoElementWidth, 2);
        this._viewFinderDeltaY = Utility.round((borderWidth + deltaY) / fullVideoElementHeight, 2);
        if (scaledVideoElementWidth != scaledVideoElementHeight) {
          if (scaledVideoElementHeight > scaledVideoElementWidth) {
            const delta = Math.trunc((scaledVideoElementHeight - scaledVideoElementWidth) / 2);
            const borderWidthY = borderWidth + delta;
            viewFinderNode.css("border-top-width", `${borderWidthY}px`);
            viewFinderNode.css("border-bottom-width", `${borderWidthY}px`);
            this._viewFinderDeltaY = fullVideoElementHeight <= containerHeight ? Utility.round((deltaY + borderWidthY) / fullVideoElementHeight, 2) : Utility.round((deltaY + borderWidth) / fullVideoElementHeight, 2);
          } else {
            const delta = Math.trunc((scaledVideoElementWidth - scaledVideoElementHeight) / 2);
            const borderWidthX = borderWidth + delta;
            viewFinderNode.css("border-left-width", `${borderWidthX}px`);
            viewFinderNode.css("border-right-width", `${borderWidthX}px`);
            this._viewFinderDeltaX = scaledVideoElementWidth <= containerWidth ? Utility.round((deltaX + borderWidthX) / fullVideoElementWidth, 2) : Utility.round((deltaX + borderWidth) / fullVideoElementWidth, 2);
          }
        }
      }
    }
    if (this._qrConstraints) {
      this._qrConstraints.viewFinderDeltaX = this._viewFinderDeltaX;
      this._qrConstraints.viewFinderDeltaY = this._viewFinderDeltaY;
      this._qrConstraints.viewFinderBorder = borderWidth;
    }
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      yield this.setState({
        icon: {
          name: "far camera"
        }
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newType = this.props.type !== nextProps.type;
      const newCamera = this.props.camera !== nextProps.camera;
      const newHighResolution = this.props.highResolution !== nextProps.highResolution;
      const newTorch = this.props.torch !== nextProps.torch;
      const newDelay = this.props.delay !== nextProps.delay;
      const newDebug = this.props.debug !== nextProps.debug;
      const newZoom = this.props.zoom !== nextProps.zoom;
      const newNoHardwareZoom = this.props.noHardwareZoom !== nextProps.noHardwareZoom;
      const newViewFinder = this.props.viewFinder !== nextProps.viewFinder;
      const newProps = newType || newCamera || newHighResolution || newTorch || newDelay || newDebug || newZoom || newViewFinder || newNoHardwareZoom;
      const newStopReader = newType || newCamera || newHighResolution || newTorch;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newProps) {
        if (newStopReader) {
          yield this.initializeReaderAsync();
        } else if (newZoom) {
          yield this.applyZoomAsync();
        } else {
          yield this.reRenderAsync();
          this.positionViewFinder();
        }
      }
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield this.stopReaderAsync();
      yield _super.componentWillUnmount.call(this);
    });
  }
  get type() {
    var _a;
    return (_a = this.props.type) !== null && _a !== void 0 ? _a : QrWidgetType.QrCode;
  }
  get formats() {
    const formats = this.props.formats != null ? Array.isArray(this.props.formats) ? this.props.formats : [this.props.formats] : [];
    return formats.includes(QrFormat.All) ? [QrFormat.Aztec, QrFormat.Codabar, QrFormat.Code39, QrFormat.Code93, QrFormat.Code128, QrFormat.DataMatrix, QrFormat.Ean8, QrFormat.Ean13, QrFormat.Itf, QrFormat.MaxiCode, QrFormat.Pdf417, QrFormat.QrCode, QrFormat.Rss14, QrFormat.RssExpanded, QrFormat.UpcA, QrFormat.UpcE, QrFormat.UpcEanExtension] : formats.length > 0 ? formats : this.type == QrWidgetType.QrCode ? [QrFormat.Aztec, QrFormat.QrCode] : this.type == QrWidgetType.BarCode ? [QrFormat.UpcA, QrFormat.UpcE, QrFormat.Ean8, QrFormat.Ean13] : [QrFormat.Aztec, QrFormat.QrCode, QrFormat.UpcA, QrFormat.UpcE, QrFormat.Ean8, QrFormat.Ean13];
  }
  get camera() {
    var _a;
    return (_a = this.props.camera) !== null && _a !== void 0 ? _a : CameraType.OutwardFacingCamera;
  }
  get facingMode() {
    return this.camera == CameraType.UserFacingCamera ? "user" : "environment";
  }
  get zoom() {
    return this.props.zoom && this.props.zoom > 1 ? this.props.zoom : 1;
  }
  get noHardwareZoom() {
    return this.props.noHardwareZoom === true;
  }
  get hardwareZoom() {
    return this._hardwareZoom;
  }
  get softwareZoom() {
    return this._softwareZoom;
  }
  get viewFinderBorder() {
    return typeof this.props.viewFinder === "number" ? this.props.viewFinder : this.props.viewFinder ? ViewFinderDefaultBorder : 0;
  }
  get delay() {
    return this.props.delay || 150;
  }
  get debug() {
    return this.props.debug === true;
  }
  get highResolution() {
    return this.props.highResolution !== false;
  }
  get torch() {
    return this.props.torch === true;
  }
  static testAsync(image, filter = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const createImageAsync = objectUrl => new Promise(resolve => {
        const image = document.createElement("img");
        image.onload = () => resolve(image);
        image.onerror = () => resolve(null);
        image.src = objectUrl;
      });
      const imageObjectUrl = Utility.toObjectUrl(image);
      const imageElement = yield createImageAsync(imageObjectUrl);
      const width = imageElement.width;
      const height = imageElement.height;
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const options = {
        willReadFrequently: true
      };
      const context = canvas.getContext("2d", options);
      context.drawImage(imageElement, 0, 0);
      if (filter) {
        ImageFilters$1.applyFilter(filter, context, width, height);
      }
      const possibleFormats = [QrFormat.Aztec, QrFormat.QrCode];
      const hints = new Map();
      hints.set(DecodeHintType.POSSIBLE_FORMATS, possibleFormats);
      hints.set(DecodeHintType.TRY_HARDER, true);
      const qrCodeReader = new BrowserQRCodeReader(hints);
      try {
        const result = yield qrCodeReader.decodeFromCanvas(canvas);
        const text = result.getText();
        return !!text ? text : false;
      } catch (e) {
        return false;
      }
    });
  }
  static test(canvas) {
    const possibleFormats = [QrFormat.Aztec, QrFormat.QrCode];
    const hints = new Map();
    hints.set(DecodeHintType.POSSIBLE_FORMATS, possibleFormats);
    hints.set(DecodeHintType.TRY_HARDER, true);
    const qrCodeReader = new BrowserQRCodeReader(hints);
    try {
      const result = qrCodeReader.decodeFromCanvas(canvas);
      const text = result.getText();
      return !!text ? text : false;
    } catch (e) {
      return false;
    }
  }
  onReaderDecodeAsync(result) {
    return __awaiter(this, void 0, void 0, function* () {
      const now = new Date();
      if (this._lastCallAt != null && this._qrConstraints != null) {
        const cycleInterval = Utility.diff(now, this._lastCallAt).totalMilliseconds;
        const processInterval = cycleInterval - this.delay;
        this._qrConstraints.cycleInterval = cycleInterval;
        this._qrConstraints.processInterval = processInterval;
      }
      this._lastCallAt = now;
      if (result) {
        const text = result.getText();
        yield this.onScanAsync(text);
      }
    });
  }
  stopReaderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._initializing = false;
      this._videoTrack = null;
      this._qrConstraints = null;
      this._qrCodeReader = null;
      this._viewFinderDeltaX = 0;
      this._viewFinderDeltaY = 0;
      //this._lastCallAt = null;
      if (this._qrCodeReaderControls) {
        this._qrCodeReaderControls.stop();
        this._qrCodeReaderControls = null;
      }
    });
  }
  static setCanvasSize(canvasElement, width, height) {
    if (canvasElement.width != width) {
      canvasElement.width = width;
      canvasElement.style.width = width + "px";
    }
    if (canvasElement.height != height) {
      canvasElement.height = height;
      canvasElement.style.height = height + "px";
    }
  }
  /**
   * 🖌 Prepares the canvas for capture and scan frames.
   */
  static createCaptureCanvas(mediaElement, renderContainerAction) {
    if (!mediaElement) {
      throw new ArgumentException("Cannot create a capture canvas without a media element.");
    }
    if (typeof document === "undefined") {
      throw new Error("The page \"Document\" is undefined, make sure you're running in a browser.");
    }
    const canvasElement = document.createElement("canvas");
    mediaElement.canvas = canvasElement;
    //const { width, height } = BrowserCodeReader.getMediaElementDimensions(mediaElement);
    const renderContainer = renderContainerAction();
    this.setCanvasSize(canvasElement, renderContainer.dw, renderContainer.dh);
    /**
     * The HTML canvas element context.
     */
    // const options: CanvasRenderingContext2DSettings = {
    //     willReadFrequently: true
    // };
    //
    // const context: CanvasRenderingContext2D | null = canvasElement.getContext("2d", options);
    //
    // if (context) {
    //     context.imageSmoothingEnabled = true;
    //
    //     if (context.imageSmoothingQuality != "high") {
    //         context.imageSmoothingQuality = "medium";
    //     }
    // }
    //
    // (canvasElement as any).getContext = () => context;
    canvasElement.sourceGetContext = canvasElement.getContext;
    //const getContextAction = (): CanvasRenderingContext2D | null => canvasElement.sourceGetContext("2d", options);
    canvasElement.getContext = () => {
      const options = {
        willReadFrequently: true
      };
      const context = canvasElement.sourceGetContext("2d", options);
      if (context) {
        context.imageSmoothingEnabled = true;
        if (context.imageSmoothingQuality != "high") {
          context.imageSmoothingQuality = "medium";
        }
      }
      return context;
    };
    return canvasElement;
  }
  static drawImageOnCanvas(canvasElementContext, mediaElement, renderContainerAction) {
    const renderContainer = renderContainerAction();
    const circle = renderContainer.getCircle();
    const canvasElement = canvasElementContext.canvas;
    this.setCanvasSize(canvasElement, renderContainer.dw, renderContainer.dh);
    canvasElementContext.drawImage(mediaElement, renderContainer.sx, renderContainer.sy, renderContainer.sw, renderContainer.sh, 0, 0, renderContainer.dw, renderContainer.dh);
    if (circle.filter) {
      ImageFilters$1.applyFilter(circle.filter, canvasElementContext, renderContainer.dw, renderContainer.dh);
    }
    // SOURCE:
    // const code: string | false = QrWidget.test(canvasElement);
    //
    // if (code) {
    //     console.log("RECOGNIZED (SOURCE): ", code);
    //     alert("code-SOURCE = " + code);
    // }
    //DEBUG:
    const debugCanvas = this._debugCanvasRef.current;
    if (debugCanvas) {
      debugCanvas.width = renderContainer.debugWidth;
      debugCanvas.height = renderContainer.debugHeight;
      const options = {
        willReadFrequently: true
      };
      const debugContext = debugCanvas.getContext("2d", options);
      if (debugContext) {
        debugContext.drawImage(mediaElement, renderContainer.sx, renderContainer.sy, renderContainer.sw, renderContainer.sh, 0, 0, renderContainer.debugWidth, renderContainer.debugHeight);
        if (circle.filter) {
          ImageFilters$1.applyFilter(circle.filter, debugContext, renderContainer.debugWidth, renderContainer.debugHeight);
        }
        // const code: string | false = QrWidget.test(debugCanvas);
        //
        // if (code) {
        //     console.log("RECOGNIZED (DEBUG): ", code);
        //     alert("code-DEBUG = " + code);
        // }
      }
    }
  }
  getHighResolutionDimension() {
    switch (this.props.highResolution) {
      case true:
      case QrWidgetHighResolutionType.HD:
        return {
          width: 1280,
          height: 720
        };
      case QrWidgetHighResolutionType.FullHD:
        return {
          width: 1920,
          height: 1080
        };
      case QrWidgetHighResolutionType.UltraHD:
        return {
          width: 3840,
          height: 2160
        };
      default:
        return {
          width: 640,
          height: 480
        };
    }
  }
  getDefaultStreamConstraints() {
    const video = {
      facingMode: this.facingMode,
      width: {
        min: CameraDefaultWidth,
        ideal: 1280
      },
      height: {
        min: CameraDefaultHeight,
        ideal: 720
      }
    };
    return {
      video
    };
  }
  applyZoomAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        if (!this._initializing && this._videoTrack && this._qrConstraints) {
          const lastHardwareZoom = this._hardwareZoom;
          const lastSoftwareZoom = this._softwareZoom;
          const zoom = this.zoom;
          this.defineZooming(zoom, this._maxHardwareZoom);
          const newHardwareZoom = lastHardwareZoom != this._hardwareZoom;
          const newSoftwareZoom = lastSoftwareZoom != this._softwareZoom;
          if (newHardwareZoom || newSoftwareZoom) {
            if (newHardwareZoom) {
              const constraints = {
                advanced: [{
                  zoom: this._hardwareZoom
                }]
              };
              yield this._videoTrack.applyConstraints(constraints);
            } else if (newSoftwareZoom) {
              yield this.reRenderAsync();
            }
            this.positionViewFinder();
            this._qrConstraints.hardwareZoom = this._hardwareZoom;
            this._qrConstraints.softwareZoom = this._softwareZoom;
            this._qrConstraints.zoom = zoom;
            yield this.invokeOnInitializationAsync(this._qrConstraints);
          }
        }
      } catch (ex) {
        // @ts-ignore
        yield this.onScanErrorAsync(ex);
      }
    });
  }
  initializeExtendedReaderAsync() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return __awaiter(this, void 0, void 0, function* () {
      if (this._qrCodeReaderControls == null && !this._initializing) {
        const video = this._videoRef.current;
        if (video) {
          yield this.setInitializingAsync(true);
          this.positionViewFinder();
          const renderContainer = () => {
            var _a;
            return (_a = this._renderContainer) !== null && _a !== void 0 ? _a : this._renderContainer = RenderContainer.create(video.videoWidth, video.videoHeight, this._viewFinderDeltaX, this._viewFinderDeltaY, this.softwareZoom);
          };
          BrowserCodeReader.createCaptureCanvas = mediaElement => QrWidget.createCaptureCanvas(mediaElement, renderContainer);
          BrowserCodeReader.drawImageOnCanvas = (canvasElementContext, mediaElement) => QrWidget.drawImageOnCanvas(canvasElementContext, mediaElement, renderContainer);
          try {
            // Initialize camera
            const defaultConstraints = this.getDefaultStreamConstraints();
            const mediaStream = yield navigator.mediaDevices.getUserMedia(defaultConstraints);
            video.srcObject = mediaStream;
            const videoTracks = mediaStream.getVideoTracks();
            this._videoTrack = videoTracks[0];
            let deviceSettings = yield this._videoTrack.getSettings();
            const zoom = this.zoom;
            const highResolution = this.highResolution;
            let maxHardwareZoom = 1;
            let supportsTorch = false;
            let supportsFocusMode = false;
            let torch = false;
            let supportsHighResolution = false;
            let maxWidth = CameraDefaultWidth;
            let maxHeight = CameraDefaultHeight;
            let supportsFrameRate = false;
            let maxFrameRate = 0;
            let supportedFocusModes = [];
            this.defineZooming(zoom, maxHardwareZoom);
            if (this._videoTrack.getCapabilities && this._videoTrack.applyConstraints) {
              const capabilities = this._videoTrack.getCapabilities();
              const constraints = {};
              maxHardwareZoom = (_b = (_a = capabilities.zoom) === null || _a === void 0 ? void 0 : _a.max) !== null && _b !== void 0 ? _b : 1;
              let applyConstraints = false;
              this.defineZooming(zoom, maxHardwareZoom);
              // Hardware Zoom
              if (this._hardwareZoom > 1) {
                const set = {
                  zoom: this._hardwareZoom
                };
                constraints.advanced = (_c = constraints.advanced) !== null && _c !== void 0 ? _c : [];
                constraints.advanced.push(set);
                applyConstraints = true;
              }
              // High Resolution
              maxWidth = (_e = (_d = capabilities.width) === null || _d === void 0 ? void 0 : _d.max) !== null && _e !== void 0 ? _e : CameraDefaultWidth;
              maxHeight = (_g = (_f = capabilities.height) === null || _f === void 0 ? void 0 : _f.max) !== null && _g !== void 0 ? _g : CameraDefaultHeight;
              supportsHighResolution = maxWidth > CameraDefaultWidth && maxHeight > CameraDefaultHeight;
              if (highResolution) {
                const dimension = this.getHighResolutionDimension();
                let newWidth = dimension.width;
                let newHeight = dimension.height;
                if (newWidth > maxWidth) {
                  newWidth = maxWidth;
                }
                if (newHeight > maxHeight) {
                  newHeight = maxHeight;
                }
                const deviceWidth = (_h = deviceSettings.width) !== null && _h !== void 0 ? _h : video.videoWidth;
                const deviceHeight = (_j = deviceSettings.width) !== null && _j !== void 0 ? _j : video.videoHeight;
                if (newWidth > deviceWidth && newHeight > deviceHeight) {
                  constraints.width = {
                    exact: newWidth
                  };
                  constraints.height = {
                    exact: newHeight
                  };
                  applyConstraints = true;
                }
              }
              // High frame rate
              maxFrameRate = (_l = (_k = capabilities.frameRate) === null || _k === void 0 ? void 0 : _k.max) !== null && _l !== void 0 ? _l : 0;
              supportsFrameRate = maxFrameRate > 0;
              const deviceFrameRate = (_m = deviceSettings.frameRate) !== null && _m !== void 0 ? _m : 0;
              if (supportsFrameRate && maxFrameRate > deviceFrameRate) {
                const set = {
                  frameRate: maxFrameRate
                };
                constraints.advanced = (_o = constraints.advanced) !== null && _o !== void 0 ? _o : [];
                constraints.advanced.push(set);
                applyConstraints = true;
              }
              // Focus mode
              supportedFocusModes = capabilities.focusMode;
              supportedFocusModes = supportedFocusModes != null && Array.isArray(supportedFocusModes) && supportedFocusModes.length > 0 ? supportedFocusModes.where(item => !!item) : [];
              supportsFocusMode = supportedFocusModes.contains(FocusMode.Continuous);
              if (supportsFocusMode) {
                const set = {
                  focusMode: FocusMode.Continuous
                };
                constraints.advanced = (_p = constraints.advanced) !== null && _p !== void 0 ? _p : [];
                constraints.advanced.push(set);
                applyConstraints = true;
              }
              // Apply constrains
              if (applyConstraints) {
                yield this._videoTrack.applyConstraints(constraints);
                deviceSettings = yield this._videoTrack.getSettings();
              }
            }
            // Initialize QR reader
            const possibleFormats = this.formats.map(item => this.transformFormat(item));
            const hints = new Map();
            hints.set(DecodeHintType.POSSIBLE_FORMATS, possibleFormats);
            hints.set(DecodeHintType.TRY_HARDER, true);
            const qrCodeReaderOptions = {
              delayBetweenScanAttempts: this.delay,
              delayBetweenScanSuccess: this.delay
            };
            this._qrCodeReader = new BrowserQRCodeReader(hints, qrCodeReaderOptions);
            //this._lastCallAt = null;
            this._qrCodeReaderControls = yield this._qrCodeReader.decodeFromStream(mediaStream, video, result => this.onReaderDecodeAsync(result));
            // Torch
            yield this.switchTorchAsync(true);
            // Position ViewFinder
            this.positionViewFinder();
            // Call onInitialize callback
            this._qrConstraints = new QrWidgetConstraints();
            this._qrConstraints.landscape = ch.landscape;
            this._qrConstraints.width = deviceSettings.width || video.videoWidth;
            this._qrConstraints.height = deviceSettings.height || video.videoHeight;
            this._qrConstraints.supportsHardwareZoom = maxHardwareZoom > 1;
            this._qrConstraints.maxHardwareZoom = maxHardwareZoom;
            this._qrConstraints.hardwareZoom = this._hardwareZoom;
            this._qrConstraints.softwareZoom = this._softwareZoom;
            this._qrConstraints.zoom = zoom;
            this._qrConstraints.supportsTorch = supportsTorch;
            this._qrConstraints.torch = torch;
            this._qrConstraints.supportsHighResolution = supportsHighResolution;
            this._qrConstraints.maxWidth = maxWidth;
            this._qrConstraints.maxHeight = maxHeight;
            this._qrConstraints.supportsFrameRate = supportsFrameRate;
            this._qrConstraints.maxFrameRate = maxFrameRate;
            this._qrConstraints.frameRate = deviceSettings.frameRate || maxFrameRate;
            this._qrConstraints.supportedFocusModes = supportedFocusModes;
            this._qrConstraints.focusMode = supportsFocusMode ? FocusMode.Continuous : null;
            yield this.invokeOnInitializationAsync(this._qrConstraints);
          } catch (ex) {
            // @ts-ignore
            yield this.onScanErrorAsync(ex);
          } finally {
            yield this.setInitializingAsync(false);
          }
        }
      }
    });
  }
  get loading() {
    return this._initializing || this._qrCodeReaderControls == null;
  }
  initializeReaderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.stopReaderAsync();
      yield this.initializeExtendedReaderAsync();
    });
  }
  getInnerClassName() {
    return styles$c.qrWidget;
  }
  onExpandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializeReaderAsync();
    });
  }
  onCollapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.stopReaderAsync();
    });
  }
  renderExpanded() {
    const qrStyle = {};
    if (this.softwareZoom > 1) {
      qrStyle.transform = `scale(${this.softwareZoom.toFixed(2)})`;
    }
    return React.createElement("div", {
      ref: this._ref,
      className: this.css(widgetStyles.qr, styles$c.expanded)
    }, React.createElement("div", {
      id: `${this.id}_viewportContainer`,
      ref: this._viewportContainerRef,
      className: styles$c.viewportContainer
    }, React.createElement("div", {
      className: styles$c.viewport
    }, React.createElement("div", {
      className: this.css(styles$c.container, this.loading && styles$c.initializing)
    }, React.createElement("video", {
      playsInline: true,
      autoPlay: true,
      muted: true,
      id: `${this.id}_video`,
      ref: this._videoRef,
      style: qrStyle
    }), this.viewFinderBorder > 0 && React.createElement("div", {
      ref: this._viewFinderRef,
      className: styles$c.viewFinder
    }, React.createElement("div", null)))), this.loading && React.createElement(Spinner, {
      noDelay: true
    })), this.debug && React.createElement(React.Fragment, null, React.createElement("textarea", {
      readOnly: true,
      ref: this._logsRef,
      className: styles$c.logs,
      value: this._logs
    }), React.createElement("canvas", {
      ref: QrWidget._debugCanvasRef,
      className: styles$c.debugImage,
      id: "debugCanvas",
      width: "400",
      height: "600"
    })));
  }
}
QrWidget._debugCanvasRef = React.createRef();

class RouteWidget extends BaseRouteWidget {
  onNavigateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClick) {
        yield this.props.onClick();
      }
    });
  }
}

//Autogenerated
class SignatureWidgetLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.clearLanguageItemName = `_2:0`;
    this.doneLanguageItemName = `_2:1`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_2:0`, {
      l: `en`,
      v: `Clear`
    }, {
      l: `uk`,
      v: `Очистити`
    }, {
      l: `sv`,
      v: `Töm`
    }, {
      l: `ru`,
      v: `Очистить`
    }, {
      l: `pl`,
      v: `Wyczyść`
    }, {
      l: `nl`,
      v: `Duidelijk`
    }, {
      l: `nb`,
      v: `Tøm`
    }, {
      l: `it`,
      v: `Chiaro`
    }, {
      l: `fr`,
      v: `Clair`
    }, {
      l: `fi`,
      v: `Tyhjennä`
    }, {
      l: `es`,
      v: `Claro`
    }, {
      l: `de`,
      v: `Klar`
    }, {
      l: `da`,
      v: `Klar`
    });
    this.set(`_2:1`, {
      l: `en`,
      v: `Done`
    }, {
      l: `uk`,
      v: `Завершити`
    }, {
      l: `sv`,
      v: `Färdig`
    }, {
      l: `ru`,
      v: `Завершить`
    }, {
      l: `pl`,
      v: `Gotowe`
    }, {
      l: `nl`,
      v: `Klaar`
    }, {
      l: `nb`,
      v: `Ferdig`
    }, {
      l: `it`,
      v: `Fatto`
    }, {
      l: `fr`,
      v: `Fait`
    }, {
      l: `fi`,
      v: `Valmis`
    }, {
      l: `es`,
      v: `Hecho`
    }, {
      l: `de`,
      v: `Erledigt`
    }, {
      l: `da`,
      v: `Udført`
    });
  }
  /**
  /* "Clear" (Clear)
  /* "Localizer.clear"
  /* "Localizer.clearLanguageItemName"
  */
  get clear() {
    return this.get(`_2:0`);
  }
  /**
  /* "Done" (Done)
  /* "Localizer.done"
  /* "Localizer.doneLanguageItemName"
  */
  get done() {
    return this.get(`_2:1`);
  }
}
//Singleton
var SignatureWidgetLocalizer$1 = new SignatureWidgetLocalizer();

class SignatureWidget extends BaseExpandableWidget {
  constructor() {
    super(...arguments);
    this._canvasRef = React.createRef();
  }
  initializeCanvas() {
    const signatureCanvas = this._canvasRef.current;
    if (signatureCanvas) {
      const canvas = signatureCanvas.getCanvas();
      const ctx = canvas.getContext("2d");
      const width = canvas.scrollWidth;
      const height = canvas.scrollHeight;
      const bottom = height - 0.20 * height;
      ctx.beginPath();
      ctx.moveTo(10, bottom);
      ctx.lineTo(width - 11, bottom);
      ctx.strokeStyle = "white";
      ctx.stroke();
    }
  }
  clearCanvas() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._canvasRef.current) {
        this._canvasRef.current.clear();
        this.initializeCanvas();
      }
    });
  }
  saveSignature() {
    const _super = Object.create(null, {
      hideContentAsync: {
        get: () => super.hideContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this._canvasRef.current) {
        if (this.props.onSign) {
          yield this.props.onSign(this.canvasData);
        }
      }
      yield _super.hideContentAsync.call(this);
    });
  }
  onClickAsync(e) {
    const _super = Object.create(null, {
      toggleContentAsync: {
        get: () => super.toggleContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      let target = e.target;
      if (target.parentElement !== null) {
        if (target.parentElement.className === widgetStyles.signature && target.className !== widgetStyles.icon || target.parentElement.className === widgetStyles.buttonContainer) {
          return;
        }
      }
      yield _super.toggleContentAsync.call(this);
      if (this.contentVisible) {
        this.initializeCanvas();
      }
    });
  }
  onMouseDownAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
    });
  }
  preventSwipe(e) {
    e.stopPropagation();
  }
  get canvasData() {
    const canvas = this._canvasRef.current || null;
    if (canvas) {
      const rawData = canvas.toData().flat();
      if (rawData.length > 5) {
        return canvas.toDataURL();
      }
    }
    return null;
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      yield this.setState({
        icon: {
          name: "far file-contract"
        }
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      yield this.setState({
        icon: {
          name: "far file-contract"
        }
      });
    });
  }
  renderExpanded() {
    return React.createElement("div", {
      className: widgetStyles.signature,
      onTouchStart: e => this.preventSwipe(e)
    }, React.createElement(SignatureCanvas, {
      penColor: "#007bff",
      canvasProps: {
        className: widgetStyles.signaturePad
      },
      ref: this._canvasRef
    }), React.createElement("div", {
      className: widgetStyles.buttonContainer
    }, React.createElement(Button, {
      type: ButtonType.Orange,
      onClick: () => this.clearCanvas(),
      label: SignatureWidgetLocalizer$1.clear
    }), React.createElement(Button, {
      type: ButtonType.Blue,
      onClick: () => this.saveSignature(),
      label: SignatureWidgetLocalizer$1.done
    })));
  }
}

var css_248z$d = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-steps-widget-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-content {\n  cursor: default !important;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-content:hover {\n  background-color: rgb(254, 80, 0) !important;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 12px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-steps-widget-steps .athenaeum-steps-widget-container {\n    margin-top: 0;\n  }\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-iconContainer {\n  display: flex;\n  position: relative;\n  color: white;\n  opacity: 0.5;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-iconContainer .athenaeum-steps-widget-icon {\n  font-size: 1.5em;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-iconContainer .athenaeum-steps-widget-number {\n  font-size: 0.8em;\n  position: absolute;\n  padding-bottom: 1px;\n  width: 100%;\n  display: inline;\n  align-self: center;\n  text-align: center;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-iconContainer.athenaeum-steps-widget-completed {\n  opacity: 1;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-separator {\n  height: 2px;\n  flex-grow: 1;\n  background-color: white;\n  opacity: 0.5;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-separator.athenaeum-steps-widget-completed {\n  opacity: 1;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-title {\n  position: absolute;\n  font-size: 11px;\n  width: 80px;\n  left: -28px;\n  top: -21px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-title.athenaeum-steps-widget-first {\n  left: -3px;\n  text-align: left;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-title.athenaeum-steps-widget-last {\n  left: -58px;\n  text-align: right;\n}";
var styles$b = {"font-renta":"athenaeum-steps-widget-font-renta","steps":"athenaeum-steps-widget-steps","content":"athenaeum-steps-widget-content","container":"athenaeum-steps-widget-container","iconContainer":"athenaeum-steps-widget-iconContainer","icon":"athenaeum-steps-widget-icon","number":"athenaeum-steps-widget-number","completed":"athenaeum-steps-widget-completed","separator":"athenaeum-steps-widget-separator","title":"athenaeum-steps-widget-title","first":"athenaeum-steps-widget-first","last":"athenaeum-steps-widget-last"};
styleInject(css_248z$d);

class Step extends BaseComponent {
  render() {
    const firstStyle = this.props.first && this.desktop && styles$b.first;
    const lastStyle = this.props.last && this.desktop && styles$b.last;
    return React.createElement("div", {
      id: `tooltip_${this.id}`,
      className: this.css(styles$b.iconContainer, this.props.completed && styles$b.completed),
      title: this.props.title || "",
      "data-toggle": this.mobile ? "tooltip" : ""
    }, React.createElement(Icon, Object.assign({}, {
      name: "far circle"
    }, {
      className: styles$b.icon
    })), React.createElement("span", {
      className: styles$b.number
    }, this.props.index), !this.mobile && React.createElement("span", {
      className: this.css(styles$b.title, firstStyle, lastStyle)
    }, this.props.title));
  }
}

class StepsWidget extends BaseWidget {
  getCurrentIndex() {
    const page = this.getPage();
    const route = page.route;
    return this.props.steps.findIndex(step => Comparator.isEqual(step.route, route));
  }
  get steps() {
    return this.props.steps.filter(step => !step.hidden);
  }
  componentDidUpdate() {
    ch.getLayout().reinitializeTooltips();
  }
  render() {
    const currentIndex = this.getCurrentIndex();
    return React.createElement("div", {
      id: this.id,
      className: this.css(widgetStyles.widget, this.props.className, "col-md-12", styles$b.steps)
    }, React.createElement("div", {
      title: this.toSingleLine(this.description || this.props.label),
      className: this.css(widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content, styles$b.content)
    }, React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, styles$b.container)
    }, this.steps.map((step, stepIndex) => React.createElement(React.Fragment, {
      key: stepIndex
    }, stepIndex > 0 && React.createElement("div", {
      className: this.css(styles$b.separator, stepIndex <= currentIndex && styles$b.completed)
    }), React.createElement(Step, {
      index: stepIndex + 1,
      title: step.title,
      completed: stepIndex <= currentIndex,
      first: stepIndex === 0,
      last: stepIndex === this.steps.length - 1
    }))))));
  }
}

class SwitchWidget extends BaseCheckboxWidget {
  onChangeAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, checked);
      }
    });
  }
  renderContent(renderHidden = false) {
    const toggleStyles = this.checked ? widgetStyles.checked : widgetStyles.switch;
    const toggleExternalStyles = this.checked ? this.props.checkedClassName : "";
    return React.createElement("div", {
      className: this.css(widgetStyles.switchContent, toggleExternalStyles)
    }, React.createElement("div", {
      className: widgetStyles.status
    }, React.createElement("span", null, this.props.leftLabel)), React.createElement("div", {
      className: toggleStyles
    }, React.createElement("span", {
      className: widgetStyles.toggler
    })), React.createElement("div", {
      className: widgetStyles.status
    }, React.createElement("span", null, this.props.rightLabel)));
  }
}

class BaseInputWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this.refObject = {
      _inputRef: React.createRef()
    };
  }
  onInputChangeHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      let value = e.currentTarget.value;
      const caretPosition = Number(e.currentTarget.selectionEnd);
      yield this.setAsync(value);
      let input = this.refObject._inputRef.current;
      if (input) {
        const prefix = value.substr(0, caretPosition);
        const index = value.indexOf(prefix) + caretPosition;
        input.selectionStart = index;
        input.selectionEnd = index;
      }
    });
  }
  onInputKeyUpHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e.keyCode === 13 || e.keyCode === 27) {
        yield this.setInputVisibleAsync(false);
      }
    });
  }
  setAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value !== this.value) {
        if (this.props.onChange) {
          yield this.props.onChange(this, value);
        }
        yield this.setState({
          text: value
        });
      }
    });
  }
  setInputVisibleAsync(visible) {
    return __awaiter(this, void 0, void 0, function* () {
      if (visible !== this.inputVisible) {
        let data = {
          visible: visible
        };
        yield this.setState({
          data
        });
        if (this.inputVisible && this.refObject._inputRef.current != null) {
          this.refObject._inputRef.current.focus();
        }
      }
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const value = this.props.value;
      const state = this.state;
      state.text = value || "";
      state.data = {
        visible: false
      };
    });
  }
  get value() {
    return this.state.text || "";
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
  get inputId() {
    return `input${this.id}`;
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      let target = e.target;
      if (target.parentElement !== null) {
        if (target.parentElement.className === widgetStyles.inputContainer) {
          if (this.refObject._inputRef.current) {
            this.refObject._inputRef.current.focus();
          }
          return;
        }
      }
      yield this.toggleInputAsync();
    });
  }
  toggleInputAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setInputVisibleAsync(!this.inputVisible);
    });
  }
  showInputAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setInputVisibleAsync(true);
    });
  }
  hideInputAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setInputVisibleAsync(false);
    });
  }
  get inputVisible() {
    return this.state.data != null && this.state.data.visible;
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      let target = e.target;
      const outside = Utility.clickedOutside(target, this.id);
      if (outside) {
        yield this.hideInputAsync();
      }
    });
  }
  get icon() {
    const icon = {
      name: "keyboard",
      style: IconStyle.Regular
    };
    icon.size = this.state.minimized ? IconSize.X2 : IconSize.X3;
    return icon;
  }
}

class TextAreaWidget extends BaseInputWidget {
  constructor() {
    super(...arguments);
    this.refObject = {
      _inputRef: React.createRef()
    };
  }
  // public get minimized(): boolean {
  //     return this.mobile || this.state.minimized;
  // }
  renderContent(renderHidden = false) {
    let fontSize = {
      fontSize: "2em"
    };
    if (this.value.length > 17) {
      fontSize = {
        fontSize: "1.5em"
      };
    }
    if (this.value.length > 44) {
      fontSize = {
        fontSize: "1em"
      };
    }
    return React.createElement("div", {
      className: widgetStyles.textInput
    }, this.inputVisible ? React.createElement("div", {
      className: widgetStyles.inputContainer
    }, React.createElement("textarea", {
      id: this.inputId,
      ref: this.refObject._inputRef,
      value: this.value,
      maxLength: this.props.maxLength,
      onChange: e => this.onInputChangeHandlerAsync(e),
      onKeyUp: e => this.onInputKeyUpHandlerAsync(e),
      className: "form-control",
      rows: this.props.rows || 3
    })) : React.createElement("div", {
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.showInputAsync();
      })
    }, this.value ? React.createElement("div", {
      className: widgetStyles.valueContainer
    }, React.createElement("span", {
      style: fontSize
    }, this.value)) : super.renderContent(renderHidden)));
  }
}

class TextInputWidget extends BaseInputWidget {
  constructor() {
    super(...arguments);
    this._autoSuggestRef = React.createRef();
    this.refObject = {
      _inputRef: React.createRef()
    };
  }
  setValueFromAutoSuggest(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setAsync(value);
    });
  }
  get autoSuggestItems() {
    return this.props.autoSuggestItems ? this.props.autoSuggestItems : [];
  }
  get toggleButtonId() {
    return `auto-suggest-toggler-${this.id}`;
  }
  get input() {
    return this.refObject._inputRef.current;
  }
  renderContent(renderHidden = false) {
    let fontSize = {
      fontSize: "2em"
    };
    if (this.value.length > 17) {
      fontSize = {
        fontSize: "1.5em"
      };
    }
    if (this.value.length > 44) {
      fontSize = {
        fontSize: "1em"
      };
    }
    return React.createElement("div", {
      className: widgetStyles.textInput
    }, this.inputVisible ? React.createElement(React.Fragment, null, React.createElement("div", {
      className: widgetStyles.inputContainer
    }, React.createElement("input", {
      id: this.inputId,
      type: "text",
      ref: this.refObject._inputRef,
      value: this.value,
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputChangeHandlerAsync(e);
      }),
      onKeyUp: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputKeyUpHandlerAsync(e);
      }),
      className: "form-control",
      autoComplete: this.props.autoComplete === false ? "off" : "on"
    }), this.autoSuggestItems.length > 0 && React.createElement("div", {
      className: this.css(widgetStyles.autoCompleteContainer, this.mobile && widgetStyles.mobile)
    }, React.createElement(AutoSuggest, {
      ref: this._autoSuggestRef,
      className: widgetStyles.autoComplete,
      items: this.autoSuggestItems,
      isOpen: this.inputVisible,
      toggleButtonId: this.toggleButtonId,
      onSelect: (_, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.setValueFromAutoSuggest(value);
      })
    })))) : React.createElement("div", {
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.showInputAsync();
      })
    }, this.value ? React.createElement("div", {
      className: widgetStyles.valueContainer
    }, React.createElement("span", {
      style: fontSize
    }, this.value)) : super.renderContent(renderHidden)));
  }
}

//Autogenerated
class TitleWidgetLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var TitleWidgetLocalizer$1 = new TitleWidgetLocalizer();

var css_248z$c = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-title-widget-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-title-widget-title .athenaeum-title-widget-shrink {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 100%;\n  width: calc(100vw - 120px);\n  display: inline-block;\n  white-space: nowrap;\n}";
var styles$a = {"font-renta":"athenaeum-title-widget-font-renta","title":"athenaeum-title-widget-title","shrink":"athenaeum-title-widget-shrink"};
styleInject(css_248z$c);

class TitleWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this._containerRef = React.createRef();
  }
  get icon() {
    const icon = this.state.icon;
    if (icon != null) {
      icon.size = this.expanded ? IconSize.X3 : IconSize.X2;
    }
    return icon;
  }
  getLabelWidthStyle() {
    const container = this._containerRef.current;
    if (container && !this.expanded) {
      return {
        maxWidth: container.offsetWidth - 80
      };
    }
    return {};
  }
  windowResizeHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.mobile) {
        yield this.reRenderAsync();
      }
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.minimized) {
        yield this.maximizeAsync();
      } else {
        yield this.minimizeAsync();
      }
    });
  }
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      if (data != null) {
        const title = TypeConverter.convert(data, "ITitleModel");
        if (title != null) {
          state.description = title.description;
          state.label = title.label;
          state.icon = title.icon || state.icon;
        }
      }
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.state.minimized = true;
      if (this.props.model != null) {
        this.state.label = this.props.model.label;
        this.state.description = this.props.model.description;
        this.state.icon = this.props.model.icon || this.props.icon;
      }
    });
  }
  get expanded() {
    return !!this.description && (this.desktop || !this.minimized);
  }
  render() {
    return React.createElement("div", {
      id: this.id,
      ref: this._containerRef,
      className: this.css(styles$a.title, widgetStyles.widget, this.props.className, this.getInnerClassName(), this.props.wide ? "col-md-12" : "col-md-6")
    }, React.createElement("div", {
      className: this.css(widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content),
      title: this.toSingleLine(TitleWidgetLocalizer$1.get(this.description || this.label)),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onClickAsync(e);
      })
    }, React.createElement("div", {
      className: widgetStyles.compactContainer
    }, this.renderContent(), React.createElement("div", {
      className: widgetStyles.labelAndDescription
    }, this.label && React.createElement("div", null, React.createElement("span", {
      className: this.css(!this.expanded && styles$a.shrink),
      style: this.getLabelWidthStyle()
    }, this.label)), this.expanded && React.createElement("div", {
      className: widgetStyles.description
    }, React.createElement("span", null, this.toMultiLines(this.description)))))));
  }
}

class WizardContainer extends BaseWidgetContainer {
  prevAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const page = this.getPage();
      yield page.prevAsync();
    });
  }
  nextAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const page = this.getPage();
      yield page.nextAsync();
    });
  }
  get responsive() {
    return this.props.responsive == true;
  }
  getPage() {
    return super.getPage();
  }
  renderContent(renderHidden = false) {
    return React.createElement(React.Fragment, null, this.props.steps && this.props.steps.steps.length > 1 && React.createElement(StepsWidget, {
      steps: this.props.steps.steps
    }), this.widgets, (this.responsive || this.desktop) && React.createElement(NavigationWidget, {
      responsive: this.responsive,
      className: this.props.navigationClassName,
      canPrev: this.props.canPrev,
      prevIcon: this.props.prevIcon,
      prevLabel: this.props.prevLabel,
      prevDescription: this.props.prevDescription,
      can: this.props.canNext,
      icon: this.props.nextIcon,
      label: this.props.nextLabel,
      description: this.props.nextDescription,
      onPrevClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.prevAsync();
      }),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.nextAsync();
      })
    }));
  }
}

//Autogenerated
class PasswordFormLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.helpTextUpperCaseLanguageItemName = `_3F:0`;
    this.helpTextLowerCaseLanguageItemName = `_3F:1`;
    this.helpTextNumberLanguageItemName = `_3F:2`;
    this.helpTextSpecialCharacterLanguageItemName = `_3F:3`;
    this.resetPasswordPasswordsDontMatchMessageLanguageItemName = `_3F:4`;
    this.changePasswordCurrentPasswordLanguageItemName = `_3F:5`;
    this.loginPagePasswordInputLanguageItemName = `_3F:6`;
    this.resetPasswordConfirmPasswordInputLanguageItemName = `_3F:7`;
    this.saveLanguageItemName = `_3F:8`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_3F:0`, {
      l: `en`,
      v: `one uppercase ('A'-'Z') character`
    }, {
      l: `uk`,
      v: `одна велика літера ('A'-'Z')`
    }, {
      l: `sv`,
      v: `en stor bokstav ('A'-'Z')`
    }, {
      l: `ru`,
      v: `одна прописная буква ('A'-'Z')`
    }, {
      l: `pl`,
      v: `jedną dużą literę (A-Z)`
    }, {
      l: `nl`,
      v: `één hoofdletter ('A'-'Z').`
    }, {
      l: `nb`,
      v: `En stor bokstav ('A' - 'Z')`
    }, {
      l: `it`,
      v: `un carattere maiuscolo ('A'-'Z').`
    }, {
      l: `fr`,
      v: `un caractère majuscule (« A » - « Z »)`
    }, {
      l: `fi`,
      v: `yksi iso kirjain ('A'-'Z')`
    }, {
      l: `es`,
      v: `un carácter en mayúscula ('A'-'Z')`
    }, {
      l: `de`,
      v: `ein Großbuchstabe ('A'-'Z').`
    }, {
      l: `da`,
      v: `Et stort ('A' - 'Z') tegn`
    });
    this.set(`_3F:1`, {
      l: `en`,
      v: `one lowercase ('a'-'z') character`
    }, {
      l: `uk`,
      v: `одна мала буква ('a'-'z')`
    }, {
      l: `sv`,
      v: `en liten bokstav ('a'-'z')`
    }, {
      l: `ru`,
      v: `одна строчная буква ('a'-'z')`
    }, {
      l: `pl`,
      v: `jedną małą literę (a-z)`
    }, {
      l: `nl`,
      v: `één teken in kleine letters ('a'-'z').`
    }, {
      l: `nb`,
      v: `En liten bokstav ('a' - 'z')`
    }, {
      l: `it`,
      v: `un carattere minuscolo ('a'-'z').`
    }, {
      l: `fr`,
      v: `un caractère minuscule (« a » - « z »)`
    }, {
      l: `fi`,
      v: `yksi pieni kirjain ('a'-'z')`
    }, {
      l: `es`,
      v: `un carácter en minúscula ('a'-'z')`
    }, {
      l: `de`,
      v: `ein Kleinbuchstabe ('a'-'z').`
    }, {
      l: `da`,
      v: `En lille bogstav ('a' - 'z')`
    });
    this.set(`_3F:2`, {
      l: `en`,
      v: `one number`
    }, {
      l: `uk`,
      v: `одна цифра`
    }, {
      l: `sv`,
      v: `en nummer`
    }, {
      l: `ru`,
      v: `одна цифра`
    }, {
      l: `pl`,
      v: `jedną cyfrę`
    }, {
      l: `nl`,
      v: `een nummer`
    }, {
      l: `nb`,
      v: `Ett nummer`
    }, {
      l: `it`,
      v: `un numero`
    }, {
      l: `fr`,
      v: `un nombre`
    }, {
      l: `fi`,
      v: `yksi numero`
    }, {
      l: `es`,
      v: `un número`
    }, {
      l: `de`,
      v: `eine Nummer`
    }, {
      l: `da`,
      v: `Et nummer`
    });
    this.set(`_3F:3`, {
      l: `en`,
      v: `one special character`
    }, {
      l: `uk`,
      v: `один буквено-цифровий символ`
    }, {
      l: `sv`,
      v: `ett special tecken`
    }, {
      l: `ru`,
      v: `один  буквенно-цифровой символ`
    }, {
      l: `pl`,
      v: `jeden znak specjalny`
    }, {
      l: `nl`,
      v: `één speciaal karakter`
    }, {
      l: `nb`,
      v: `En spesiell karakter`
    }, {
      l: `it`,
      v: `un carattere speciale`
    }, {
      l: `fr`,
      v: `un caractère spécial`
    }, {
      l: `fi`,
      v: `yksi erikoismerkki`
    }, {
      l: `es`,
      v: `un personaje especial`
    }, {
      l: `de`,
      v: `ein besonderer Charakter`
    }, {
      l: `da`,
      v: `En speciel karakter`
    });
    this.set(`_3F:4`, {
      l: `en`,
      v: `Passwords don't match`
    }, {
      l: `uk`,
      v: `Паролі не співпадають`
    }, {
      l: `sv`,
      v: `Lösenorden matchar inte`
    }, {
      l: `ru`,
      v: `Пароли не совпадают`
    }, {
      l: `pl`,
      v: `Hasła niejednakowe`
    }, {
      l: `nl`,
      v: `Wachtwoorden komen niet overeen`
    }, {
      l: `nb`,
      v: `Passord er ulike`
    }, {
      l: `it`,
      v: `Le password non corrispondono`
    }, {
      l: `fr`,
      v: `Les mots de passe ne correspondent pas`
    }, {
      l: `fi`,
      v: `Salasanat eivät täsmää`
    }, {
      l: `es`,
      v: `Las contraseñas no coinciden`
    }, {
      l: `de`,
      v: `Passwörter stimmen nicht überein`
    }, {
      l: `da`,
      v: `Adgangskoderne matcher ikke`
    });
    this.set(`_3F:5`, {
      l: `en`,
      v: `Current password`
    }, {
      l: `uk`,
      v: `Поточний пароль`
    }, {
      l: `sv`,
      v: `Nuvarande lösenord`
    }, {
      l: `ru`,
      v: `Текущий пароль`
    }, {
      l: `pl`,
      v: `Aktualne hasło`
    }, {
      l: `nl`,
      v: `Huidig ​​wachtwoord`
    }, {
      l: `nb`,
      v: `Nåverende passord`
    }, {
      l: `it`,
      v: `Password attuale`
    }, {
      l: `fr`,
      v: `Mot de passe actuel`
    }, {
      l: `fi`,
      v: `Nykyinen salasana`
    }, {
      l: `es`,
      v: `Contraseña actual`
    }, {
      l: `de`,
      v: `Aktuelles Passwort`
    }, {
      l: `da`,
      v: `Nuværende adgangskode`
    });
    this.set(`_3F:6`, {
      l: `en`,
      v: `Password`
    }, {
      l: `uk`,
      v: `Пароль`
    }, {
      l: `sv`,
      v: `Lösenord`
    }, {
      l: `ru`,
      v: `Пароль`
    }, {
      l: `pl`,
      v: `Hasło`
    }, {
      l: `nl`,
      v: `Wachtwoord`
    }, {
      l: `nb`,
      v: `Passord`
    }, {
      l: `it`,
      v: `Parola d'ordine`
    }, {
      l: `fr`,
      v: `Mot de passe`
    }, {
      l: `fi`,
      v: `Salasana`
    }, {
      l: `es`,
      v: `Contraseña`
    }, {
      l: `de`,
      v: `Passwort`
    }, {
      l: `da`,
      v: `Adgangskode`
    });
    this.set(`_3F:7`, {
      l: `en`,
      v: `Confirm password`
    }, {
      l: `uk`,
      v: `Підтвердити пароль`
    }, {
      l: `sv`,
      v: `Bekräfta lösenord`
    }, {
      l: `ru`,
      v: `Подтвердить пароль`
    }, {
      l: `pl`,
      v: `Potwiedż hasło`
    }, {
      l: `nl`,
      v: `Bevestig wachtwoord`
    }, {
      l: `nb`,
      v: `Bekreft passord`
    }, {
      l: `it`,
      v: `Conferma password`
    }, {
      l: `fr`,
      v: `Confirmez le mot de passe`
    }, {
      l: `fi`,
      v: `Vahvista salasana`
    }, {
      l: `es`,
      v: `Confirmar Contraseña`
    }, {
      l: `de`,
      v: `Bestätige das Passwort`
    }, {
      l: `da`,
      v: `Bekræft adgangskode`
    });
    this.set(`_3F:8`, {
      l: `en`,
      v: `Save`
    }, {
      l: `uk`,
      v: `Зберегти`
    }, {
      l: `sv`,
      v: `Spara`
    }, {
      l: `ru`,
      v: `Сохранить`
    }, {
      l: `pl`,
      v: `Zapisz`
    }, {
      l: `nl`,
      v: `Opslaan`
    }, {
      l: `nb`,
      v: `Lagre`
    }, {
      l: `it`,
      v: `Salva`
    }, {
      l: `fr`,
      v: `Sauvegarder`
    }, {
      l: `fi`,
      v: `Tallenna`
    }, {
      l: `es`,
      v: `Ahorrar`
    }, {
      l: `de`,
      v: `Speichern`
    }, {
      l: `da`,
      v: `Gem`
    });
  }
  /**
  /* "HelpText.UpperCase" (one uppercase ('A'-'Z') character)
  /* "Localizer.helpTextUpperCase"
  /* "Localizer.helpTextUpperCaseLanguageItemName"
  */
  get helpTextUpperCase() {
    return this.get(`_3F:0`);
  }
  /**
  /* "HelpText.LowerCase" (one lowercase ('a'-'z') character)
  /* "Localizer.helpTextLowerCase"
  /* "Localizer.helpTextLowerCaseLanguageItemName"
  */
  get helpTextLowerCase() {
    return this.get(`_3F:1`);
  }
  /**
  /* "HelpText.Number" (one number)
  /* "Localizer.helpTextNumber"
  /* "Localizer.helpTextNumberLanguageItemName"
  */
  get helpTextNumber() {
    return this.get(`_3F:2`);
  }
  /**
  /* "HelpText.SpecialCharacter" (one special character)
  /* "Localizer.helpTextSpecialCharacter"
  /* "Localizer.helpTextSpecialCharacterLanguageItemName"
  */
  get helpTextSpecialCharacter() {
    return this.get(`_3F:3`);
  }
  /**
  /* "ResetPassword.PasswordsDontMatchMessage" (Passwords don't match)
  /* "Localizer.resetPasswordPasswordsDontMatchMessage"
  /* "Localizer.resetPasswordPasswordsDontMatchMessageLanguageItemName"
  */
  get resetPasswordPasswordsDontMatchMessage() {
    return this.get(`_3F:4`);
  }
  /**
  /* "ChangePassword.CurrentPassword" (Current password)
  /* "Localizer.changePasswordCurrentPassword"
  /* "Localizer.changePasswordCurrentPasswordLanguageItemName"
  */
  get changePasswordCurrentPassword() {
    return this.get(`_3F:5`);
  }
  /**
  /* "LoginPage.PasswordInput" (Password)
  /* "Localizer.loginPagePasswordInput"
  /* "Localizer.loginPagePasswordInputLanguageItemName"
  */
  get loginPagePasswordInput() {
    return this.get(`_3F:6`);
  }
  /**
  /* "ResetPassword.ConfirmPasswordInput" (Confirm password)
  /* "Localizer.resetPasswordConfirmPasswordInput"
  /* "Localizer.resetPasswordConfirmPasswordInputLanguageItemName"
  */
  get resetPasswordConfirmPasswordInput() {
    return this.get(`_3F:7`);
  }
  /**
  /* "Save" (Save)
  /* "Localizer.save"
  /* "Localizer.saveLanguageItemName"
  */
  get save() {
    return this.get(`_3F:8`);
  }
}
//Singleton
var PasswordFormLocalizer$1 = new PasswordFormLocalizer();

var PasswordFormType;
(function (PasswordFormType) {
  PasswordFormType[PasswordFormType["SetPassword"] = 0] = "SetPassword";
  PasswordFormType[PasswordFormType["ChangePassword"] = 1] = "ChangePassword";
})(PasswordFormType || (PasswordFormType = {}));
class PasswordForm extends BaseComponent {
  constructor() {
    super(...arguments);
    this.currentPassword = {
      value: ""
    };
    this.password = {
      value: ""
    };
    this.passwordConfirmation = {
      value: ""
    };
    this._formRef = React.createRef();
    this.validationRows = [new ValidationRow(PasswordValidationRule.UpperCaseCharacter, PasswordFormLocalizer$1.helpTextUpperCase), new ValidationRow(PasswordValidationRule.LowerCaseCharacter, PasswordFormLocalizer$1.helpTextLowerCase), new ValidationRow(PasswordValidationRule.NumberCharacter, PasswordFormLocalizer$1.helpTextNumber), new ValidationRow(PasswordValidationRule.SpecialCharacter, PasswordFormLocalizer$1.helpTextSpecialCharacter)];
  }
  handleSubmitAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.password.value != this.passwordConfirmation.value) {
        const form = this._formRef.current;
        const validationError = PasswordFormLocalizer$1.resetPasswordPasswordsDontMatchMessage;
        yield form.setValidationErrorsAsync(validationError);
      } else {
        if (this.props.type == PasswordFormType.SetPassword) {
          yield this.props.onSubmit(this.password.value, "");
        }
        if (this.props.type == PasswordFormType.ChangePassword) {
          yield this.props.onSubmit(this.passwordConfirmation.value, this.currentPassword.value);
        }
      }
    });
  }
  render() {
    const changePassword = this.props.type == PasswordFormType.ChangePassword;
    return React.createElement(React.Fragment, null, React.createElement(Form, {
      id: "form",
      ref: this._formRef,
      onSubmit: () => this.handleSubmitAsync()
    }, changePassword && React.createElement(PasswordInput, {
      required: true,
      autoFocus: true,
      label: PasswordFormLocalizer$1.changePasswordCurrentPassword,
      model: this.currentPassword
    }), React.createElement(PasswordInput, {
      required: true,
      autoFocus: !changePassword,
      validLength: 8,
      label: PasswordFormLocalizer$1.loginPagePasswordInput,
      model: this.password,
      liveValidator: this.validationRows
    }), React.createElement(PasswordInput, {
      required: true,
      label: PasswordFormLocalizer$1.resetPasswordConfirmPasswordInput,
      model: this.passwordConfirmation
    }), React.createElement(ButtonContainer, null, React.createElement(Button, {
      submit: true,
      type: ButtonType.Orange,
      icon: {
        name: "far save"
      },
      label: PasswordFormLocalizer$1.save
    }))));
  }
}

var css_248z$b = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-toolbar-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-toolbar-container-toolbarContainer {\n  flex-direction: column;\n  justify-content: flex-end !important;\n  position: relative;\n  margin-bottom: 4px;\n}\n.athenaeum-toolbar-container-toolbarContainer .athenaeum-toolbar-container-toggleButton:focus {\n  box-shadow: none !important;\n  outline: none !important;\n}\n.athenaeum-toolbar-container-toolbarContainer .athenaeum-toolbar-container-toggleButton:hover {\n  background-color: unset !important;\n}";
var styles$9 = {"font-renta":"athenaeum-toolbar-container-font-renta","toolbarContainer":"athenaeum-toolbar-container-toolbarContainer","toggleButton":"athenaeum-toolbar-container-toggleButton"};
styleInject(css_248z$b);

class ToolbarContainer extends BaseComponent {
  render() {
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$9.toolbarContainer, "d-flex justify-content-between", this.props.className)
    }, this.children);
  }
}

var css_248z$a = ".athenaeum-toolbar-row-toolbarRow {\n  height: 41px;\n}";
var styles$8 = {"toolbarRow":"athenaeum-toolbar-row-toolbarRow"};
styleInject(css_248z$a);

class ToolbarRow extends BaseComponent {
  render() {
    return React.createElement(Inline, {
      id: this.id,
      className: this.css(styles$8.toolbarRow, this.props.className),
      justify: this.props.justify
    }, this.props.children);
  }
}

//Autogenerated
class ToolbarContainerLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var ToolbarContainerLocalizer$1 = new ToolbarContainerLocalizer();

var css_248z$9 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-toolbar-button-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-toolbar-button-toolbarButton span {\n  cursor: default;\n}";
var styles$7 = {"font-renta":"athenaeum-toolbar-button-font-renta","toolbarButton":"athenaeum-toolbar-button-toolbarButton"};
styleInject(css_248z$9);

class ToolbarButton extends BaseComponent {
  render() {
    return React.createElement("div", {
      className: this.css("d-flex", styles$7.toolbarButton, this.props.className)
    }, React.createElement(Inline, null, React.createElement("span", null, ToolbarContainerLocalizer$1.get(this.props.label)), React.createElement(Button, Object.assign({}, this.props, {
      small: true,
      label: undefined
    }))));
  }
}

var css_248z$8 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-panel-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-panel-panel {\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n  padding: 16px 0;\n  margin: 0 16px 16px 16px;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  transition: max-width 0.2s ease, height 0.2s ease;\n}\n.athenaeum-panel-panel .athenaeum-panel-heading {\n  margin-bottom: 16px;\n}\n.athenaeum-panel-panel .athenaeum-panel-title {\n  margin-bottom: 0;\n  align-self: center;\n}\n.athenaeum-panel-panel .athenaeum-panel-content {\n  display: block;\n}\n.athenaeum-panel-panel .athenaeum-panel-collapsedContent {\n  cursor: pointer;\n  height: 100%;\n  display: flex;\n  align-content: center;\n}\n.athenaeum-panel-panel:hover .athenaeum-panel-minimize {\n  display: block;\n}\n.athenaeum-panel-panel .athenaeum-panel-minimize {\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n  color: #337ab7;\n  opacity: 0.3;\n  padding: 6px 3px;\n}\n.athenaeum-panel-panel .athenaeum-panel-minimize:hover {\n  opacity: 1;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally {\n  max-width: 24px;\n  overflow: hidden;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally .athenaeum-panel-minimize {\n  display: block;\n  opacity: 1;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally .athenaeum-panel-heading {\n  display: none;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally .athenaeum-panel-content {\n  visibility: hidden;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally .athenaeum-panel-collapsedContent {\n  display: none;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseVertically {\n  height: 48px !important;\n  overflow: hidden;\n  padding: 0;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseVertically .athenaeum-panel-heading {\n  display: none;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseVertically .athenaeum-panel-minimize {\n  display: block;\n  opacity: 1;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseVertically .athenaeum-panel-content {\n  display: none;\n}";
var styles$6 = {"font-renta":"athenaeum-panel-font-renta","panel":"athenaeum-panel-panel","heading":"athenaeum-panel-heading","title":"athenaeum-panel-title","content":"athenaeum-panel-content","collapsedContent":"athenaeum-panel-collapsedContent","minimize":"athenaeum-panel-minimize","collapseHorizontally":"athenaeum-panel-collapseHorizontally","collapseVertically":"athenaeum-panel-collapseVertically"};
styleInject(css_248z$8);

var PanelCollapseType;
(function (PanelCollapseType) {
  PanelCollapseType[PanelCollapseType["Vertical"] = 0] = "Vertical";
  PanelCollapseType[PanelCollapseType["Horizontal"] = 1] = "Horizontal";
})(PanelCollapseType || (PanelCollapseType = {}));
class Panel extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      collapsed: this.props.collapsed || UserInteractionDataStorage.get(this.id, false, this.dataStorageType)
    };
  }
  saveCollapsed() {
    if (this.props.id) {
      UserInteractionDataStorage.set(this.id, this.collapsed, this.dataStorageType);
    }
  }
  get collapsed() {
    return this.state.collapsed;
  }
  get collapseType() {
    return this.props.collapsible !== undefined ? this.props.collapsible : null;
  }
  get collapseClass() {
    if (this.collapseType !== null) {
      if (this.collapseType === PanelCollapseType.Horizontal) {
        return styles$6.collapseHorizontally;
      } else {
        return styles$6.collapseVertically;
      }
    }
    return "";
  }
  get dataStorageType() {
    return this.props.dataStorageType || DataStorageType.Page;
  }
  get customHeading() {
    return this.props.customHeading;
  }
  get title() {
    return this.props.title || "";
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.collapsed) {
        yield this.expandAsync();
      } else {
        yield this.collapseAsync();
      }
    });
  }
  expandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.collapsed) {
        yield this.setState({
          collapsed: false
        });
        this.saveCollapsed();
      }
    });
  }
  collapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.collapsed) {
        yield this.setState({
          collapsed: true
        });
        this.saveCollapsed();
      }
    });
  }
  render() {
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$6.panel, this.collapsed && this.collapseClass, this.props.className)
    }, (this.customHeading || this.title) && React.createElement("div", {
      className: styles$6.heading
    }, !this.customHeading && React.createElement("h3", {
      className: this.css(styles$6.title, "col"),
      title: this.title
    }, this.title), this.customHeading), this.collapsed && React.createElement("div", {
      className: styles$6.collapsedContent,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }, React.createElement("h3", {
      className: this.css(styles$6.title, "col")
    }, this.title)), this.collapseType !== null && (this.collapseType === PanelCollapseType.Horizontal ? React.createElement("i", {
      className: this.css(styles$6.minimize, `${this.collapsed ? "fa fa-lg fa-caret-square-right" : "fa fa-lg fa-caret-square-left"}`),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }) : this.collapseType === PanelCollapseType.Vertical ? React.createElement("i", {
      className: this.css(styles$6.minimize, `${this.collapsed ? "fa fa-lg fa-caret-square-down" : "fa fa-lg fa-caret-square-up"}`),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }) : null), React.createElement("div", {
      className: this.css(styles$6.content)
    }, this.props.children));
  }
}

//Autogenerated
class ImageModalLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.previewNotSupportedLanguageItemName = `_43:0`;
    this.downloadLanguageItemName = `_43:1`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_43:0`, {
      l: `en`,
      v: `Preview is not supported for this type of file, but you can download it instead`
    }, {
      l: `uk`,
      v: `Попередній перегляд не підтримується для файлів цього типу, але ви можете завантажити його замість цього.`
    }, {
      l: `sv`,
      v: `Förhandsgranskning stöds inte för denna typ av fil, men du kan ladda ner den istället`
    }, {
      l: `ru`,
      v: `Предварительный просмотр не поддерживается для файлов этого типа, но вы можете скачать его вместо этого.`
    }, {
      l: `pl`,
      v: `Podgląd dokumentu niemożliwy`
    }, {
      l: `nl`,
      v: `Voorbeeld wordt niet ondersteund voor dit type bestand, maar u kunt het in plaats daarvan downloaden`
    }, {
      l: `nb`,
      v: `Forhåndsvisning støttes ikke for denne typen filer, men du kan laste den ned i stedet`
    }, {
      l: `it`,
      v: `L'anteprima non è supportata per questo tipo di file, ma puoi comunque scaricarla`
    }, {
      l: `fr`,
      v: `L'aperçu n'est pas pris en charge pour ce type de fichier, mais vous pouvez le télécharger à la place`
    }, {
      l: `fi`,
      v: `Tiedosto ei tue esikatselua. Voit ladata tiedoston katselua varten`
    }, {
      l: `es`,
      v: `La vista previa no es compatible con este tipo de archivo, pero puedes descargarla en su lugar.`
    }, {
      l: `de`,
      v: `Die Vorschau wird für diesen Dateityp nicht unterstützt, Sie können sie jedoch stattdessen herunterladen`
    }, {
      l: `da`,
      v: `Preview understøttes ikke for denne type fil, men du kan downloade den i stedet`
    });
    this.set(`_43:1`, {
      l: `en`,
      v: `Download`
    }, {
      l: `uk`,
      v: `Завантажити`
    }, {
      l: `sv`,
      v: `Ladda ner`
    }, {
      l: `ru`,
      v: `Загрузить`
    }, {
      l: `pl`,
      v: `Pobierz`
    }, {
      l: `nl`,
      v: `Downloaden`
    }, {
      l: `nb`,
      v: `Last ned`
    }, {
      l: `it`,
      v: `Scaricamento`
    }, {
      l: `fr`,
      v: `Télécharger`
    }, {
      l: `fi`,
      v: `Lataa`
    }, {
      l: `es`,
      v: `Descargar`
    }, {
      l: `de`,
      v: `Herunterladen`
    }, {
      l: `da`,
      v: `Download`
    });
  }
  /**
  /* "PreviewNotSupported" (Preview is not supported for this type of file, but you can download it instead)
  /* "Localizer.previewNotSupported"
  /* "Localizer.previewNotSupportedLanguageItemName"
  */
  get previewNotSupported() {
    return this.get(`_43:0`);
  }
  /**
  /* "Download" (Download)
  /* "Localizer.download"
  /* "Localizer.downloadLanguageItemName"
  */
  get download() {
    return this.get(`_43:1`);
  }
}
//Singleton
var ImageModalLocalizer$1 = new ImageModalLocalizer();

var css_248z$7 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-image-modal-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-image-modal-imageModal > div {\n  width: 100%;\n  height: 100%;\n  margin-bottom: 16px;\n}\n.athenaeum-image-modal-imageModal > div > div {\n  width: 100%;\n  height: 100%;\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  background-color: white !important;\n}\n.athenaeum-image-modal-imageModal .athenaeum-image-modal-image {\n  height: 50vh;\n}\n.athenaeum-image-modal-imageModal .athenaeum-image-modal-image.athenaeum-image-modal-mobile {\n  padding: 50% 50% 50% 50%;\n  height: 100%;\n}\n.athenaeum-image-modal-imageModal .athenaeum-image-modal-image.athenaeum-image-modal-bigger {\n  height: 70vh;\n}";
var styles$5 = {"font-renta":"athenaeum-image-modal-font-renta","imageModal":"athenaeum-image-modal-imageModal","image":"athenaeum-image-modal-image","mobile":"athenaeum-image-modal-mobile","bigger":"athenaeum-image-modal-bigger"};
styleInject(css_248z$7);

class ImageProvider {
  static getImageUrl(image) {
    return image.src ? image.src : `/files/images/${image.id}`;
  }
  static getImageStyle(image) {
    const url = typeof image === "string" ? image : ImageProvider.getImageUrl(image);
    return {
      background: `url(${url})`
    };
  }
}
class ImageModal extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      picture: this.props.picture || null,
      title: this.props.title || null,
      subtitle: this.props.subtitle || null
    };
    this._modalRef = React.createRef();
  }
  getImageUrl(image) {
    return this.props.imageUrl ? this.props.imageUrl(image) : ImageProvider.getImageUrl(image);
  }
  getImageStyle(image) {
    const url = this.getImageUrl(image);
    return ImageProvider.getImageStyle(url);
  }
  get picture() {
    return this.state.picture;
  }
  get previewSupported() {
    return this.picture ? AthenaeumComponentsConstants.imageFileTypes.includes(this.picture.type) : false;
  }
  download() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.picture) {
        if (!this.picture.src) {
          this.picture.src = `/files/images/${this.picture.id}`;
        }
        ch.download(this.picture);
      }
    });
  }
  openAsync(picture = null, title = null, subtitle = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const newState = picture != null || title != null || subtitle != null;
      if (newState) {
        picture = picture !== null && picture !== void 0 ? picture : this.state.picture;
        title = title !== null && title !== void 0 ? title : this.state.title;
        subtitle = subtitle !== null && subtitle !== void 0 ? subtitle : this.state.subtitle;
        yield this.setState({
          picture,
          title: title,
          subtitle
        });
      }
      yield this._modalRef.current.openAsync();
    });
  }
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (nextProps.picture && nextProps.picture !== this.props.picture) {
        yield this.setState({
          picture: nextProps.picture
        });
      }
    });
  }
  get title() {
    var _a, _b;
    return (_b = (_a = this.state.title) !== null && _a !== void 0 ? _a : this.props.title) !== null && _b !== void 0 ? _b : "";
  }
  get subtitle() {
    var _a, _b, _c, _d;
    return (_d = (_b = (_a = this.state.subtitle) !== null && _a !== void 0 ? _a : this.props.subtitle) !== null && _b !== void 0 ? _b : (_c = this.picture) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "";
  }
  render() {
    const mobileStyle = this.mobile && styles$5.mobile;
    const biggerStyle = this.props.size !== undefined && this.props.size !== ModalSize.Default && this.props.size !== ModalSize.Small && styles$5.bigger;
    return React.createElement(Modal, {
      id: this.id,
      ref: this._modalRef,
      className: this.props.className,
      bodyClassName: this.css(this.props.bodyClassName, styles$5.imageModal),
      title: this.title,
      subtitle: this.subtitle,
      size: this.props.size,
      notResponsive: this.props.notResponsive,
      noHeader: this.props.noHeader,
      closeConfirm: this.props.closeConfirm
    }, React.createElement("div", null, this.picture && this.previewSupported && React.createElement("div", {
      className: this.css(styles$5.image, mobileStyle, biggerStyle),
      style: this.getImageStyle(this.picture)
    }), this.picture && !this.previewSupported && React.createElement("span", null, ImageModalLocalizer$1.previewNotSupported)), this.props.download && this.picture && React.createElement(Button, {
      type: ButtonType.Orange,
      onClick: () => this.download(),
      label: ImageModalLocalizer$1.download
    }));
  }
}

var css_248z$6 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-accordion-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-accordion-accordion {\n  overflow: hidden;\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-headerContainer {\n  display: flex;\n  justify-content: space-between;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-headerContainer .athenaeum-accordion-header {\n  flex: 1;\n  align-self: center;\n  padding: 16px 12px;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-headerContainer .athenaeum-accordion-header h3 {\n  margin: 0;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-contentContainer {\n  height: auto;\n  transition: max-height 0.2s ease-in-out;\n  overflow: hidden;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-contentContainer .athenaeum-accordion-separator {\n  margin: 0 !important;\n  border-color: grey;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-contentContainer.athenaeum-accordion-collapsed {\n  max-height: 0 !important;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-contentContainer .athenaeum-accordion-content {\n  padding: 16px 12px;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-expansionInfo {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 48px;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-expansionInfo .athenaeum-accordion-expansionInfoIcon {\n  transition: transform 0.2s ease-in-out;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-expansionInfo .athenaeum-accordion-expansionInfoIcon.athenaeum-accordion-expanded {\n  transform: rotate(180deg);\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-toggler {\n  width: 48px;\n  background-color: rgb(254, 80, 0);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  cursor: pointer;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-toggler .athenaeum-accordion-icon {\n  transition: transform 0.2s ease-in-out;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-toggler .athenaeum-accordion-icon.athenaeum-accordion-expanded {\n  transform: rotate(180deg);\n}";
var styles$4 = {"font-renta":"athenaeum-accordion-font-renta","accordion":"athenaeum-accordion-accordion","headerContainer":"athenaeum-accordion-headerContainer","header":"athenaeum-accordion-header","contentContainer":"athenaeum-accordion-contentContainer","separator":"athenaeum-accordion-separator","collapsed":"athenaeum-accordion-collapsed","content":"athenaeum-accordion-content","expansionInfo":"athenaeum-accordion-expansionInfo","expansionInfoIcon":"athenaeum-accordion-expansionInfoIcon","expanded":"athenaeum-accordion-expanded","toggler":"athenaeum-accordion-toggler","icon":"athenaeum-accordion-icon"};
styleInject(css_248z$6);

var TogglerPosition;
(function (TogglerPosition) {
  TogglerPosition[TogglerPosition["Header"] = 0] = "Header";
  TogglerPosition[TogglerPosition["Bottom"] = 1] = "Bottom";
})(TogglerPosition || (TogglerPosition = {}));
class Accordion extends BaseComponent {
  constructor() {
    // Inherited
    super(...arguments);
    this.state = {
      expanded: !!this.props.expanded,
      maxHeight: 0
    };
    // Fields
    this._contentRef = React.createRef();
  }
  // Getters
  get autoCollapse() {
    switch (this.props.autoCollapse) {
      case false:
        return false;
      default:
        return true;
    }
  }
  get classNames() {
    const classNamesCopy = Object.assign({}, this.props.classNames);
    Object.keys(styles$4).forEach(key => !classNamesCopy[key] ? classNamesCopy[key] = styles$4[key] : classNamesCopy[key]);
    return classNamesCopy;
  }
  get contentNode() {
    return this._contentRef.current;
  }
  get collapsed() {
    return !this.expanded;
  }
  get expanded() {
    return this.state.expanded;
  }
  get hasToggle() {
    return !!this.props.toggler;
  }
  get maxHeightOffset() {
    var _a;
    return (_a = this.props.maxHeightOffset) !== null && _a !== void 0 ? _a : 0;
  }
  // Async-methods
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.expanded) {
        yield this.recalculateContentHeight();
      }
    });
  }
  setExpanded(expanded) {
    return __awaiter(this, void 0, void 0, function* () {
      if (expanded !== this.expanded) {
        yield this.recalculateContentHeight();
        yield this.setState({
          expanded
        });
        if (this.props.onToggle) {
          yield this.props.onToggle(this, expanded);
        }
      }
    });
  }
  getHeader() {
    const headerIsComponent = React.isValidElement(this.props.header);
    if (headerIsComponent) {
      return this.props.header;
    }
    return React.createElement("h3", null, this.props.header);
  }
  getToggler() {
    var _a, _b;
    if (this.hasToggle) {
      const togglerIsComponent = React.isValidElement(this.props.toggler);
      if (togglerIsComponent) {
        return this.props.toggler;
      }
      return React.createElement(Icon, {
        className: this.css(styles$4.icon, this.expanded && styles$4.expanded),
        name: (_a = this.props.togglerIcon) !== null && _a !== void 0 ? _a : "caret-down",
        size: (_b = this.props.togglerSize) !== null && _b !== void 0 ? _b : IconSize.X2
      });
    }
    return null;
  }
  get togglerPosition() {
    return this.props.togglerPosition !== undefined && this.props.togglerPosition !== null ? this.props.togglerPosition : TogglerPosition.Header;
  }
  expandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setExpanded(true);
    });
  }
  collapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setExpanded(false);
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.expanded ? yield this.collapseAsync() : yield this.expandAsync();
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && this.autoCollapse) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.collapseAsync();
        }
      }
    });
  }
  /**
   * If content is added dynamically to the {@link Accordion} while it is open, it will not resize itself automatically, causing the content to overflow and clip.
   * Calling this method will make the {@link Accordion} readjust itself, so all content is visible.
   */
  recalculateContentHeight() {
    return __awaiter(this, void 0, void 0, function* () {
      const contentNode = this.contentNode;
      if (contentNode) {
        const maxHeight = contentNode.getBoundingClientRect().height;
        yield this.setState({
          maxHeight
        });
      }
    });
  }
  render() {
    const expandedStyles = this.expanded && styles$4.expanded;
    return React.createElement("div", {
      id: this.id,
      className: this.css(this.classNames.accordion, this.props.className, styles$4.accordion, expandedStyles)
    }, React.createElement("div", {
      className: this.css(this.classNames.headerContainer, styles$4.headerContainer, !this.hasToggle && "cursor-pointer"),
      onClick: !this.hasToggle ? () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      }) : undefined
    }, React.createElement("div", {
      className: this.css(this.classNames.header, styles$4.header)
    }, this.getHeader()), !this.hasToggle && React.createElement("div", {
      className: this.css(styles$4.expansionInfo)
    }, React.createElement(Icon, {
      className: this.css(styles$4.expansionInfoIcon, this.expanded && styles$4.expanded),
      name: "angle-down",
      size: IconSize.X2
    })), this.hasToggle && this.togglerPosition === TogglerPosition.Header && React.createElement("div", {
      className: this.css(this.classNames.toggler, styles$4.toggler),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.toggleAsync();
      })
    }, this.getToggler())), React.createElement("div", {
      className: this.css(this.classNames.contentContainer, styles$4.contentContainer, this.collapsed && this.css(this.classNames.collapsed, styles$4.collapsed)),
      style: {
        maxHeight: this.state.maxHeight + this.maxHeightOffset
      }
    }, React.createElement("hr", {
      className: this.css(this.classNames.separator, styles$4.separator)
    }), React.createElement("div", {
      ref: this._contentRef,
      className: this.css(this.classNames.content, styles$4.content)
    }, this.props.children)), this.togglerPosition === TogglerPosition.Bottom && this.hasToggle && React.createElement("div", {
      className: this.css(this.classNames.toggler, styles$4.toggler),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.toggleAsync();
      })
    }, this.getToggler()));
  }
}

var css_248z$5 = ".athenaeum-google-map-googleMap a:focus {\n  outline: none;\n  text-decoration: none;\n}";
var styles$3 = {"googleMap":"athenaeum-google-map-googleMap"};
styleInject(css_248z$5);

/**
 * A generic Google Maps component.
 */
class GoogleMap extends BaseComponent {
  constructor() {
    // Fields
    super(...arguments);
    this._googleMapDiv = React.createRef();
    this._markerClusterer = null;
    this._googleMap = null;
    this._mapClickEventListener = null;
    this._markers = [];
    this._infoWindows = [];
    this._polyline = null;
    this.state = {};
  }
  // Properties
  get autoCloseInfoWindows() {
    return !!this.props.autoCloseInfoWindows;
  }
  get clusterMarkers() {
    return !!this.props.clusterMarkers;
  }
  get googleMap() {
    return this._googleMap;
  }
  get markerClusterer() {
    var _a;
    return (_a = this._markerClusterer) !== null && _a !== void 0 ? _a : this._markerClusterer = new MarkerClusterer({});
  }
  get center() {
    return AddressHelper.toGoogleLatLon(this.props.center);
  }
  // Methods
  handlePropsAsync(newEvent = true, newMarkers = true, newPolyLine = true, newZoom = false, newCenter = false) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
      const googleMap = this.googleMap;
      if (googleMap) {
        if (newMarkers) {
          this._markers.forEach(internalMarker => internalMarker.setMap(null));
          this.markerClusterer.clearMarkers();
          this._infoWindows.forEach(internalInfoWindow => internalInfoWindow.close());
          this._infoWindows = [];
          const markers = this.props.markers != null ? typeof this.props.markers === "function" ? (_a = this.props.markers()) !== null && _a !== void 0 ? _a : [] : (_b = this.props.markers) !== null && _b !== void 0 ? _b : [] : [];
          this._markers = markers.map(newMarker => {
            const internalMarker = new google.maps.Marker(newMarker);
            let internalInfoWindow = null;
            if (newMarker.infoWindow) {
              internalInfoWindow = new google.maps.InfoWindow(newMarker.infoWindow);
              this._infoWindows.push(internalInfoWindow);
            }
            internalMarker.addListener("click", event => {
              if (internalInfoWindow) {
                internalInfoWindow._isOpen = !internalInfoWindow._isOpen;
                if (internalInfoWindow._isOpen) {
                  internalInfoWindow.open(googleMap);
                  if (this.autoCloseInfoWindows) {
                    this.closeInfoWindows(internalInfoWindow);
                  }
                } else {
                  internalInfoWindow.close();
                }
              }
              if (newMarker.onClick) {
                const lon = event.latLng.lng();
                const lat = event.latLng.lat();
                const coordinate = new GeoCoordinate(lat, lon);
                newMarker.onClick(this, newMarker, coordinate);
              }
            });
            internalMarker.addListener("dblclick", event => {
              if (newMarker.onDoubleClick) {
                const lon = event.latLng.lng();
                const lat = event.latLng.lat();
                const coordinate = new GeoCoordinate(lat, lon);
                newMarker.onDoubleClick(this, newMarker, coordinate);
              }
            });
            return internalMarker;
          });
          if (this.clusterMarkers) {
            this.markerClusterer.setMap(this.googleMap);
            this.markerClusterer.addMarkers(this._markers);
          } else {
            this.markerClusterer.setMap(null);
            this._markers.forEach(internalMarker => internalMarker.setMap(this.googleMap));
          }
        }
        if (newPolyLine) {
          (_c = this._polyline) === null || _c === void 0 ? void 0 : _c.setMap(null);
          this.setPolyline();
        }
        if (newEvent) {
          (_d = this._mapClickEventListener) === null || _d === void 0 ? void 0 : _d.remove();
          this._mapClickEventListener = googleMap.addListener("click", event => this.onMapClickAsync(event));
        }
        if (newZoom) {
          googleMap.setZoom(this.props.zoom);
        }
        if (newCenter) {
          googleMap.setCenter(this.center);
        }
      }
    });
  }
  onMapClickAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.autoCloseInfoWindows) {
        this.closeInfoWindows();
      }
      if (this.props.onClick) {
        const lon = event.latLng.lng();
        const lat = event.latLng.lat();
        const coordinate = new GeoCoordinate(lat, lon);
        yield this.props.onClick(this, coordinate);
      }
    });
  }
  /**
   * Close all {@link IGoogleMapInternalInfoWindow}'s, except one if specified.
   *
   * @param except {@link IGoogleMapInternalInfoWindow} to keep open.
   */
  closeInfoWindows(except) {
    this._infoWindows.forEach(internalInfoWindow => {
      if (internalInfoWindow && except !== internalInfoWindow) {
        internalInfoWindow._isOpen = false;
        internalInfoWindow.close();
      }
    });
  }
  setPolyline() {
    if (this._googleMap) {
      const polylinePath = this.props.polyLinePath != null ? typeof this.props.polyLinePath === "function" ? this.props.polyLinePath() : this.props.polyLinePath : null;
      if (polylinePath != null && polylinePath.length > 0) {
        const lineSymbol = {
          path: google.maps.SymbolPath.CIRCLE,
          fillOpacity: 1,
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: "#173443",
          strokeColor: "#98c8e5",
          scale: 5
        };
        this._polyline = new google.maps.Polyline({
          path: polylinePath,
          map: this._googleMap,
          clickable: false,
          geodesic: true,
          strokeColor: "black",
          strokeOpacity: 0.1,
          strokeWeight: 5,
          icons: [{
            icon: lineSymbol,
            offset: "0",
            repeat: "20px"
          }]
        });
      }
    }
  }
  initializeMapContainerAsync() {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
      yield AddressHelper.loadGoogleLibraryAsync();
      const options = {
        streetViewControl: (_a = this.props.streetViewControl) !== null && _a !== void 0 ? _a : true,
        fullscreenControl: (_b = this.props.fullscreenControl) !== null && _b !== void 0 ? _b : true,
        mapTypeControl: (_c = this.props.mapTypeControl) !== null && _c !== void 0 ? _c : true,
        center: this.center,
        zoom: this.props.zoom,
        draggable: this.props.draggable,
        scrollwheel: this.props.scrollWheel
      };
      this._googleMap = yield AddressHelper.createMapAsync(this._googleMapDiv.current, null, null, options);
      yield this.handlePropsAsync();
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      if (AddressHelper.isGoogleApiRegistered) {
        yield this.initializeMapContainerAsync();
      } else {
        Utility.background(() => this.initializeMapContainerAsync());
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newMarkers = !Comparator.isEqual(nextProps.markers, this.props.markers);
      const newCenter = !Comparator.isEqual(nextProps.center, this.props.center);
      const newZoom = nextProps.zoom != this.props.zoom;
      const newPolyLinePath = !Comparator.isEqual(nextProps.polyLinePath, this.props.polyLinePath);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      yield this.handlePropsAsync(false, newMarkers, newPolyLinePath, newZoom, newCenter);
    });
  }
  /**
   * Center the map on the given coordinates.
   * @param center New center coordinates of the map.
   */
  setCenterAsync(center) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      (_a = this.googleMap) === null || _a === void 0 ? void 0 : _a.setCenter(center);
    });
  }
  render() {
    return React.createElement("div", {
      id: this.id,
      ref: this._googleMapDiv,
      className: this.css(styles$3.googleMap, this.props.className),
      style: {
        height: this.props.height
      }
    });
  }
}

//Autogenerated
class QrInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.buttonCloseLanguageItemName = `_47:0`;
    this.buttonLabelLanguageItemName = `_47:1`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_47:0`, {
      l: `en`,
      v: `Close`
    }, {
      l: `uk`,
      v: `\nЗакрити`
    }, {
      l: `sv`,
      v: `Stänga`
    }, {
      l: `ru`,
      v: `Закрывать`
    }, {
      l: `pl`,
      v: `\nBlisko`
    }, {
      l: `nl`,
      v: `Dichtbij`
    }, {
      l: `nb`,
      v: `Lukk`
    }, {
      l: `it`,
      v: `Vicino`
    }, {
      l: `fr`,
      v: `Fermer`
    }, {
      l: `fi`,
      v: `Sulje`
    }, {
      l: `es`,
      v: `Cerca`
    }, {
      l: `de`,
      v: `Schließen`
    }, {
      l: `da`,
      v: `Tæt`
    });
    this.set(`_47:1`, {
      l: `en`,
      v: `Qr code`
    }, {
      l: `sv`,
      v: `Qr-kod`
    }, {
      l: `pl`,
      v: `Kod Qr`
    }, {
      l: `nl`,
      v: `QR code`
    }, {
      l: `nb`,
      v: `QR kode`
    }, {
      l: `it`,
      v: `QR Code`
    }, {
      l: `fr`,
      v: `QR Code`
    }, {
      l: `fi`,
      v: `Qr-koodi`
    }, {
      l: `es`,
      v: `Código QR`
    }, {
      l: `de`,
      v: `QR-Code`
    }, {
      l: `da`,
      v: `Qr-kode`
    });
  }
  /**
  /* "Button.Close" (Close)
  /* "Localizer.buttonClose"
  /* "Localizer.buttonCloseLanguageItemName"
  */
  get buttonClose() {
    return this.get(`_47:0`);
  }
  /**
  /* "Button.Label" (Qr code)
  /* "Localizer.buttonLabel"
  /* "Localizer.buttonLabelLanguageItemName"
  */
  get buttonLabel() {
    return this.get(`_47:1`);
  }
}
//Singleton
var QrInputLocalizer$1 = new QrInputLocalizer();

var css_248z$4 = ".athenaeum-qr-input-qrInputContainer {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.athenaeum-qr-input-qrInputContainer .athenaeum-qr-input-qrInputButton {\n  height: 60px;\n  white-space: normal !important;\n  outline: none !important;\n  box-shadow: none !important;\n  text-transform: uppercase;\n}";
var styles$2 = {"qrInputContainer":"athenaeum-qr-input-qrInputContainer","qrInputButton":"athenaeum-qr-input-qrInputButton"};
styleInject(css_248z$4);

/**
 * Qr input that can be used without {@link WidgetContainer}.
 */
class QrInput extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      showQrReader: false
    };
  }
  get IsQrReaderVisible() {
    return this.state.showQrReader;
  }
  onScanAsync(code, error) {
    return __awaiter(this, void 0, void 0, function* () {
      if (code && this.props.onQr) {
        if (this.props.closeOnQr) {
          yield this.setState({
            showQrReader: false
          });
        }
        yield this.props.onQr(code);
      } else if (error) {
        yield this.onScanErrorAsync();
      }
    });
  }
  onScanErrorAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.alertErrorAsync("EN: Scan error!", true, true);
    });
  }
  toggleQrReaderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        showQrReader: !this.state.showQrReader
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.IsQrReaderVisible && this.props.autoClose) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.setState({
            showQrReader: false
          });
        }
      }
    });
  }
  render() {
    var _a, _b, _c;
    return React.createElement("div", {
      id: this.id,
      className: this.css(styles$2.qrInputContainer, this.props.className)
    }, React.createElement(Button, {
      block: true,
      icon: (_a = this.props.icon) !== null && _a !== void 0 ? _a : {
        name: "fa-qrcode"
      },
      className: (_b = this.props.buttonClassName) !== null && _b !== void 0 ? _b : styles$2.qrInputButton,
      type: this.props.buttonType,
      label: !this.IsQrReaderVisible ? (_c = this.props.label) !== null && _c !== void 0 ? _c : QrInputLocalizer$1.buttonLabel : QrInputLocalizer$1.buttonClose,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleQrReaderAsync();
      })
    }), this.IsQrReaderVisible && React.createElement(React.Fragment, null, React.createElement("span", null, "NOT IMPLEMENTED")));
  }
}

//Autogenerated
class LdDataHeaderLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var LdDataHeaderLocalizer$1 = new LdDataHeaderLocalizer();

class LdDataHeader extends BaseComponent {
  static trimUrl(url) {
    while (url.endsWith("/")) {
      url = url.substring(0, url.length - 1);
    }
    return url;
  }
  static combineUrl(applicationUrl, url) {
    const theUrl = new URL(url, applicationUrl);
    return url == "/" ? theUrl.toString() : this.trimUrl(theUrl.toString());
  }
  // private static removeUrlQuery(url: string): string {
  //     return url.split('?')[0];
  // }
  static equalsUrl(applicationUrl, x, y) {
    const xUrl = new URL(x, applicationUrl);
    const yUrl = new URL(y, applicationUrl);
    return xUrl.toString().toLowerCase() == yUrl.toString().toLowerCase();
  }
  static isRootPage() {
    const applicationUrl = ch.applicationUrl;
    return LdDataHeader.equalsUrl(applicationUrl, applicationUrl, ch.pageUrl);
  }
  getNeutralCanonicalUrl() {
    var _a;
    let canonical = this.props.canonical || ((_a = this.data) === null || _a === void 0 ? void 0 : _a.canonical) || null;
    if (canonical) {
      const showCanonical = canonical == "/" || !LdDataHeader.isRootPage();
      if (showCanonical) {
        return LdDataHeader.combineUrl(ch.applicationUrl, canonical);
      }
    }
    return null;
  }
  static getLanguageUrl(url, language) {
    url = this.trimUrl(url);
    return language ? `${url}/?lang=${language}` : url;
  }
  getCanonical() {
    //return `${neutralCanonicalUrl}?lang=${Localizer.language}`;
    const neutralCanonicalUrl = this.getNeutralCanonicalUrl();
    return neutralCanonicalUrl ? this.defaultLanguage != this.language ? LdDataHeader.getLanguageUrl(neutralCanonicalUrl, this.language) : neutralCanonicalUrl : null;
  }
  getAlternativeUrls() {
    // https://developers.google.com/search/blog/2010/09/unifying-content-under-multilingual
    const neutralCanonicalUrl = this.getNeutralCanonicalUrl();
    if (neutralCanonicalUrl) {
      const alternativeUrls = [];
      const supportedLanguages = LdDataHeaderLocalizer$1.supportedLanguageCodes;
      for (let i = 0; i < supportedLanguages.length; i++) {
        const language = supportedLanguages[i];
        const alternativeUrl = LdDataHeader.getLanguageUrl(neutralCanonicalUrl, language);
        alternativeUrls.push({
          url: alternativeUrl,
          lang: language
        });
      }
      alternativeUrls.push({
        url: neutralCanonicalUrl,
        lang: "x-default"
      });
      return alternativeUrls;
    }
    return null;
  }
  get data() {
    var _a;
    return (_a = this.props.data) !== null && _a !== void 0 ? _a : null;
  }
  get language() {
    return this.props.language || LdDataHeaderLocalizer$1.language;
  }
  get defaultLanguage() {
    var _a;
    return this.props.defaultLanguage || ((_a = this.data) === null || _a === void 0 ? void 0 : _a.defaultLanguage) || LdDataHeaderLocalizer$1.defaultLanguage;
  }
  get canonical() {
    return this.getCanonical();
  }
  get alternativeUrls() {
    return this.getAlternativeUrls();
  }
  render() {
    const data = this.data;
    const canonical = this.canonical;
    const alternativeUrls = this.alternativeUrls;
    return React.createElement(React.Fragment, null, (data || canonical || alternativeUrls) && React.createElement(Helmet, null, canonical && React.createElement("link", {
      rel: "canonical",
      href: canonical
    }), alternativeUrls && alternativeUrls.map((item, index) => React.createElement("link", Object.assign({
      key: index,
      rel: "alternate"
    }, {
      hreflang: item.lang
    }, {
      href: item.url
    }))), (data === null || data === void 0 ? void 0 : data.json) && React.createElement("script", {
      className: "structured-data-list",
      type: "application/ld+json"
    }, data.json), (data === null || data === void 0 ? void 0 : data.description) && React.createElement("meta", {
      name: "description",
      content: data.description
    }), (data === null || data === void 0 ? void 0 : data.keywords) && React.createElement("meta", {
      name: "keywords",
      content: data.keywords
    })));
  }
}

//Autogenerated
class DateRangeInputLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
  }
  initialize() {
    super.initialize(true);
  }
}
//Singleton
var DateRangeInputLocalizer$1 = new DateRangeInputLocalizer();

var css_248z$3 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Border */\n.athenaeum-date-range-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-date-range-input-dateRangeInputExpanded {\n  position: absolute;\n}\n\n.athenaeum-date-range-input-dateRangeInput {\n  max-width: calc(30px * 7 + 0px * 6 + 0px * 2 + 0.5rem * 2);\n  display: grid;\n  grid-gap: 5px 0px;\n  background: white;\n  padding: 0.5rem 0.5rem;\n  grid-template-columns: repeat(7, 1fr);\n  border: 1px solid #ffffff;\n  border-radius: 0.25rem;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  z-index: 100;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthName {\n  grid-column: 1/6;\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthAction {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ffffff;\n  cursor: pointer;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-weekDayName {\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ffffff;\n  width: 30px;\n  height: 30px;\n  overflow: hidden;\n  font-size: 0.7rem;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isToday span {\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 100%;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthViewGridDay {\n  width: 30px;\n  height: 30px;\n  font-size: 0.8rem;\n  background: #ffffff;\n  display: flex;\n  transition: 50ms all;\n  cursor: pointer;\n  padding: 3px;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthViewGridDay span {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthViewGridDay:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n  color: white;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isInRange {\n  background-color: rgba(234, 60, 0, 0.5);\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isOutOfRange {\n  color: rgba(0, 0, 0, 0.1);\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isInRangeAndNotSelected {\n  background-color: rgba(234, 60, 0, 0.1);\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isInRangeAndSelected {\n  background-color: #FBA587;\n  color: white;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isSelected {\n  background-color: rgb(254, 80, 0);\n  color: white;\n}\n\n.athenaeum-date-range-input-input {\n  cursor: pointer;\n}\n.athenaeum-date-range-input-input .athenaeum-date-range-input-dateSeparator {\n  padding: 0 0.5rem;\n}";
var styles$1 = {"font-renta":"athenaeum-date-range-input-font-renta","dateRangeInputExpanded":"athenaeum-date-range-input-dateRangeInputExpanded","dateRangeInput":"athenaeum-date-range-input-dateRangeInput","monthName":"athenaeum-date-range-input-monthName","monthAction":"athenaeum-date-range-input-monthAction","weekDayName":"athenaeum-date-range-input-weekDayName","isToday":"athenaeum-date-range-input-isToday","monthViewGridDay":"athenaeum-date-range-input-monthViewGridDay","isInRange":"athenaeum-date-range-input-isInRange","isOutOfRange":"athenaeum-date-range-input-isOutOfRange","isInRangeAndNotSelected":"athenaeum-date-range-input-isInRangeAndNotSelected","isInRangeAndSelected":"athenaeum-date-range-input-isInRangeAndSelected","isSelected":"athenaeum-date-range-input-isSelected","input":"athenaeum-date-range-input-input","dateSeparator":"athenaeum-date-range-input-dateSeparator"};
styleInject(css_248z$3);

var WeekDaysEnum;
(function (WeekDaysEnum) {
  WeekDaysEnum[WeekDaysEnum["Sunday"] = 0] = "Sunday";
  WeekDaysEnum[WeekDaysEnum["Monday"] = 1] = "Monday";
  WeekDaysEnum[WeekDaysEnum["TuesDay"] = 2] = "TuesDay";
  WeekDaysEnum[WeekDaysEnum["Wednesday"] = 3] = "Wednesday";
  WeekDaysEnum[WeekDaysEnum["Thursday"] = 4] = "Thursday";
  WeekDaysEnum[WeekDaysEnum["Friday"] = 5] = "Friday";
  WeekDaysEnum[WeekDaysEnum["Saturday"] = 6] = "Saturday";
})(WeekDaysEnum || (WeekDaysEnum = {}));
class DateRangeInput extends BaseInput {
  constructor() {
    super(...arguments);
    this._absolutePositionPaddingPx = 20;
    this._monthGridLongCount = 42;
    this._monthGridCount = 35;
    this._weekDaysCount = 7;
    this._inputRef = React.createRef();
    this._datePickerRef = React.createRef();
    this.state = {
      readonly: false,
      model: {
        value: [null, null]
      },
      edit: true,
      validationError: null,
      //...super.state,
      absolutePositionTop: 0,
      activeMonthView: this.defaultActiveMonthView(),
      lastHoveredDayGrid: null,
      showDatePicker: false
    };
  }
  get startDate() {
    const value = this.state.model.value;
    if (value === null || value === undefined) return null;
    if (!Array.isArray(value)) return null;
    if (value.length !== 2) return null;
    if (value[0] === null) return null;
    return DateRangeInput.getStartOfDay(value[0]);
  }
  get endDate() {
    const value = this.state.model.value;
    if (value === null || value === undefined) return null;
    if (!Array.isArray(value)) return null;
    if (value.length !== 2) return null;
    if (value[1] === null) return null;
    return DateRangeInput.getStartOfDay(value[1]);
  }
  get sameDayAllowed() {
    var _a;
    return (_a = this.props.sameDay) !== null && _a !== void 0 ? _a : false;
  }
  defaultActiveMonthView() {
    var _a;
    if (DateRangeInput.isValidDateRangeInputValue(this.props.value)) {
      return (_a = this.startDate) !== null && _a !== void 0 ? _a : DateRangeInput.getStartOfDay(new Date());
    }
    return new Date();
  }
  get gridDays() {
    const year = this.state.activeMonthView.getFullYear();
    const month = this.state.activeMonthView.getMonth();
    const firstDayOfNextMonth = 1;
    const previousMonth = month - 1;
    const nextMonth = month + 1;
    const currentMonthDayCount = DateRangeInput.daysInMonth(year, month);
    const firstDay = new Date(this.state.activeMonthView.setDate(1));
    const firstDayWeekDay = firstDay.getDay();
    const introDaysCount = firstDayWeekDay === WeekDaysEnum.Sunday ? this._weekDaysCount - 1 : firstDayWeekDay - 1;
    const isLongMonth = introDaysCount + currentMonthDayCount > this._monthGridCount;
    const gridCount = isLongMonth ? this._monthGridLongCount : this._monthGridCount;
    const outroDaysCount = gridCount - introDaysCount - currentMonthDayCount;
    const lastDayOfPreviousMonth = DateRangeInput.lastDayInMonth(year, previousMonth);
    const currentMonthGridDays = new Array(currentMonthDayCount).fill(0).map((val, index) => {
      const day = index + 1;
      return DateRangeInput.getStartOfDay(new Date(year, month, day));
    });
    const introMonthGridDays = new Array(introDaysCount).fill(0).map((val, index) => {
      const day = lastDayOfPreviousMonth - index;
      return DateRangeInput.getStartOfDay(new Date(year, previousMonth, day));
    }).reverse();
    const outroMonthGridDays = new Array(outroDaysCount).fill(0).map((val, index) => {
      const day = firstDayOfNextMonth + index;
      return DateRangeInput.getStartOfDay(new Date(year, nextMonth, day));
    });
    return [...introMonthGridDays, ...currentMonthGridDays, ...outroMonthGridDays];
  }
  get minDate() {
    if (!this.props.minDate) return null;
    return DateRangeInput.getStartOfDay(this.props.minDate);
  }
  get maxDate() {
    if (!this.props.maxDate) return null;
    return DateRangeInput.getStartOfDay(this.props.maxDate);
  }
  setValueAsync(dateRangeInputValue) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!DateRangeInput.isValidDateRangeInputValue(dateRangeInputValue)) {
        return;
      }
      const sortedValue = DateRangeInput.sortDates(dateRangeInputValue);
      yield this.updateValueAsync(sortedValue, false);
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      if (!this._inputRef.current || !this._datePickerRef.current) {
        return;
      }
      const isInsideOfDatePicker = this._inputRef.current.contains(target);
      const isInsideOfInput = this._datePickerRef.current.contains(target);
      if (isInsideOfDatePicker || isInsideOfInput) {
        return;
      }
      this.setState({
        showDatePicker: false
      });
    });
  }
  onDayGridClickAsync(clickedDate) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isOutOfRange(clickedDate)) {
        return;
      }
      //  No date is selected. set it to start
      if (!this.startDate && !this.endDate) {
        yield this.setValueAsync([clickedDate, null]);
        yield this.emitOnChange();
        return;
      }
      //  both are selected. reset end and set to start
      if (this.startDate && this.endDate) {
        yield this.setValueAsync([clickedDate, null]);
        yield this.emitOnChange();
        return;
      }
      //  only start is selected.
      if (this.startDate && !this.endDate) {
        //  sameDayAllowed is enabled and selected is same as start then do It!.
        if (this.sameDayAllowed && DateRangeInput.isSameDate(this.startDate, clickedDate)) {
          yield this.setValueAsync([this.startDate, clickedDate]);
          yield this.setState(() => ({
            showDatePicker: false
          }));
          yield this.emitOnChange();
          return;
        }
        //  sameDayAllowed is disabled and selected is same as start then reset both.
        if (DateRangeInput.isSameDate(this.startDate, clickedDate)) {
          yield this.setValueAsync([null, null]);
          return;
        }
        //  sameDayAllowed is disabled. clicked date is different than start then set to end
        yield this.setValueAsync([this.startDate, clickedDate]);
        yield this.emitOnChange();
        yield this.setState(() => ({
          showDatePicker: false
        }));
        return;
      }
      //  end is selected. set to start. this path should not happen usually.
      yield this.setValueAsync([clickedDate, this.endDate]);
      yield this.emitOnChange();
    });
  }
  onDayGridMouseEnterAsync(dayGridValue) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        lastHoveredDayGrid: dayGridValue
      });
    });
  }
  onNextMonthClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const nextMonth = this.state.activeMonthView.addMonths(1);
      yield this.setState({
        activeMonthView: nextMonth
      });
    });
  }
  onPreviousMonthClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const prevMonth = this.state.activeMonthView.addMonths(-1);
      yield this.setState({
        activeMonthView: prevMonth
      });
    });
  }
  emitOnChange() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.props.onChange) {
        return;
      }
      yield this.props.onChange(this.value);
    });
  }
  isDayGridSelected(dayGridValue) {
    return DateRangeInput.isSameDate(dayGridValue, this.startDate) || DateRangeInput.isSameDate(dayGridValue, this.endDate);
  }
  isDayGridInRange(dayGridValue) {
    if (this.isOutOfRange(dayGridValue)) {
      return false;
    }
    const isSmallerThanHoveredGrid = this.state.lastHoveredDayGrid ? dayGridValue.getTime() < this.state.lastHoveredDayGrid.getTime() : false;
    const isBiggerThanLastHoveredGrid = this.state.lastHoveredDayGrid ? dayGridValue.getTime() > this.state.lastHoveredDayGrid.getTime() : false;
    const isBiggerThanFirstClickedGrid = this.startDate ? dayGridValue.getTime() > this.startDate.getTime() : false;
    const isBiggerThanLastClickedGrid = this.endDate ? dayGridValue.getTime() > this.endDate.getTime() : false;
    const isSmallerThanFirstClickedGrid = this.startDate ? dayGridValue.getTime() < this.startDate.getTime() : false;
    const isSmallerThanLastClickedGrid = this.endDate ? dayGridValue.getTime() < this.endDate.getTime() : false;
    if (this.startDate && this.endDate) {
      return isBiggerThanFirstClickedGrid && isSmallerThanLastClickedGrid || isSmallerThanFirstClickedGrid && isBiggerThanLastClickedGrid;
    }
    if (this.startDate && !this.endDate) {
      return isSmallerThanHoveredGrid && isBiggerThanFirstClickedGrid || isSmallerThanFirstClickedGrid && isBiggerThanLastHoveredGrid;
    }
    return false;
  }
  isOutOfRange(dayGridValue) {
    if (!this.minDate && !this.maxDate) {
      return false;
    }
    if (this.minDate && this.maxDate) {
      const minDateUnixTime = this.minDate.getTime();
      const maxDateUnixTime = this.maxDate.getTime();
      const gridValueUnixTime = dayGridValue.getTime();
      return minDateUnixTime > gridValueUnixTime || maxDateUnixTime < gridValueUnixTime;
    }
    if (this.minDate) {
      const minDateUnixTime = this.minDate.getTime();
      const gridValueUnixTime = dayGridValue.getTime();
      return minDateUnixTime > gridValueUnixTime;
    }
    if (this.maxDate) {
      const maxDateUnixTime = this.maxDate.getTime();
      const gridValueUnixTime = dayGridValue.getTime();
      return maxDateUnixTime > gridValueUnixTime;
    }
    return false;
  }
  toggleDatePickerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._inputRef.current) {
        return;
      }
      const showDatePicker = !this.state.showDatePicker;
      const absolutePositionTop = this._inputRef.current.getBoundingClientRect().height + this._absolutePositionPaddingPx;
      yield this.setState({
        showDatePicker,
        absolutePositionTop
      });
    });
  }
  renderWeekDays() {
    const weekDays = [WeekDaysEnum.Monday, WeekDaysEnum.TuesDay, WeekDaysEnum.Wednesday, WeekDaysEnum.Thursday, WeekDaysEnum.Friday, WeekDaysEnum.Saturday, WeekDaysEnum.Sunday];
    return weekDays.map(weekDay => React.createElement("div", {
      key: weekDay,
      className: styles$1.weekDayName
    }, Utility.getShortDayOfWeek(weekDay)));
  }
  renderDayGrid(gridDay) {
    const isOutOfRangeStyle = this.isOutOfRange(gridDay) ? styles$1.isOutOfRange : "";
    const isSelectedStyle = this.isDayGridSelected(gridDay) && styles$1.isSelected || "";
    const isTodayStyle = DateRangeInput.todayInUnixTime() === gridDay.getTime() ? styles$1.isToday : "";
    const isInRangeAndSelectedStyle = this.startDate && this.endDate && this.isDayGridInRange(gridDay) ? styles$1.isInRangeAndSelected : "";
    const isInRangeAndNotSelectedStyle = this.startDate && !this.endDate && this.isDayGridInRange(gridDay) ? styles$1.isInRangeAndNotSelected : "";
    const className = this.css(styles$1.monthViewGridDay, isInRangeAndSelectedStyle, isInRangeAndNotSelectedStyle, isSelectedStyle, isTodayStyle, isOutOfRangeStyle);
    const onClick = () => __awaiter(this, void 0, void 0, function* () {
      return yield this.onDayGridClickAsync(gridDay);
    });
    const onMouseEnter = () => __awaiter(this, void 0, void 0, function* () {
      return yield this.onDayGridMouseEnterAsync(gridDay);
    });
    return React.createElement("div", {
      key: String(gridDay.getTime()),
      className: className,
      onMouseEnter: onMouseEnter,
      onClick: onClick
    }, React.createElement("span", null, DateRangeInput.getDayOfMonth(gridDay.getTime())));
  }
  renderDateRangePicker() {
    const style = this.props.expanded ? {
      top: `${this.state.absolutePositionTop}px`
    } : {};
    const monthName = new Intl.DateTimeFormat(DateRangeInputLocalizer$1.language, {
      month: "long"
    }).format(this.state.activeMonthView);
    const year = this.state.activeMonthView.getFullYear();
    const expandedStyle = this.props.expanded ? "" : styles$1.dateRangeInputExpanded;
    return React.createElement("div", {
      ref: this._datePickerRef,
      className: this.css(styles$1.dateRangeInput, this.props.className, expandedStyle),
      style: style
    }, React.createElement("span", {
      className: styles$1.monthName
    }, monthName, " ", year), React.createElement("div", {
      className: styles$1.monthAction,
      onClick: () => this.onPreviousMonthClickAsync()
    }, React.createElement(Icon, {
      name: "chevron-up",
      size: IconSize.Normal
    })), React.createElement("div", {
      className: styles$1.monthAction,
      onClick: () => this.onNextMonthClickAsync()
    }, React.createElement(Icon, {
      name: "chevron-down",
      size: IconSize.Normal
    })), this.renderWeekDays(), this.gridDays.map(gridDay => this.renderDayGrid(gridDay)));
  }
  renderInput() {
    var _a, _b;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      ref: this._inputRef,
      className: this.css("form-control", styles$1.input),
      onClick: () => this.toggleDatePickerAsync()
    }, React.createElement("span", null, ((_a = this.startDate) === null || _a === void 0 ? void 0 : _a.toISODateString()) || "-"), React.createElement("span", {
      className: styles$1.dateSeparator
    }, "-"), React.createElement("span", null, ((_b = this.endDate) === null || _b === void 0 ? void 0 : _b.toISODateString()) || "-")), this.state.showDatePicker && this.renderDateRangePicker());
  }
  static daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }
  static lastDayInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }
  static getStartOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
  }
  static getDayOfMonth(unixTime) {
    return new Date(unixTime).getDate();
  }
  static isValidDateRangeInputValue(dateRangeInputValue) {
    return !!dateRangeInputValue && Array.isArray(dateRangeInputValue) && dateRangeInputValue.length === 2;
  }
  static todayInUnixTime() {
    const now = new Date();
    return DateRangeInput.getStartOfDay(now).getTime();
  }
  static sortDates(value) {
    if (!value) {
      return [null, null];
    }
    const [date1, date2] = value;
    if (date1 && date2) {
      const sorter = (a, b) => a.getTime() - b.getTime();
      return [date1, date2].sort(sorter).map(date => DateRangeInput.getStartOfDay(date));
    }
    if (date1) {
      return [DateRangeInput.getStartOfDay(date1), null];
    }
    if (date2) {
      return [DateRangeInput.getStartOfDay(date2), null];
    }
    return [null, null];
  }
  static isSameDate(d1, d2) {
    if (!d1 || !d2) {
      return false;
    }
    return DateRangeInput.getStartOfDay(d1).getTime() === DateRangeInput.getStartOfDay(d2).getTime();
  }
}

/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var WINDOW = IS_BROWSER ? window : {};
var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
var NAMESPACE = 'cropper';

// Actions
var ACTION_ALL = 'all';
var ACTION_CROP = 'crop';
var ACTION_MOVE = 'move';
var ACTION_ZOOM = 'zoom';
var ACTION_EAST = 'e';
var ACTION_WEST = 'w';
var ACTION_SOUTH = 's';
var ACTION_NORTH = 'n';
var ACTION_NORTH_EAST = 'ne';
var ACTION_NORTH_WEST = 'nw';
var ACTION_SOUTH_EAST = 'se';
var ACTION_SOUTH_WEST = 'sw';

// Classes
var CLASS_CROP = "".concat(NAMESPACE, "-crop");
var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
var CLASS_MOVE = "".concat(NAMESPACE, "-move");

// Data keys
var DATA_ACTION = "".concat(NAMESPACE, "Action");
var DATA_PREVIEW = "".concat(NAMESPACE, "Preview");

// Drag modes
var DRAG_MODE_CROP = 'crop';
var DRAG_MODE_MOVE = 'move';
var DRAG_MODE_NONE = 'none';

// Events
var EVENT_CROP = 'crop';
var EVENT_CROP_END = 'cropend';
var EVENT_CROP_MOVE = 'cropmove';
var EVENT_CROP_START = 'cropstart';
var EVENT_DBLCLICK = 'dblclick';
var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
var EVENT_READY = 'ready';
var EVENT_RESIZE = 'resize';
var EVENT_WHEEL = 'wheel';
var EVENT_ZOOM = 'zoom';

// Mime types
var MIME_TYPE_JPEG = 'image/jpeg';

// RegExps
var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
var REGEXP_DATA_URL = /^data:/;
var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
var REGEXP_TAG_NAME = /^img|canvas$/i;

// Misc
// Inspired by the default width and height of a canvas element.
var MIN_CONTAINER_WIDTH = 200;
var MIN_CONTAINER_HEIGHT = 100;

var DEFAULTS = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3

  // Define the dragging mode of the cropper
  dragMode: DRAG_MODE_CROP,
  // 'crop', 'move' or 'none'

  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: '',
  // Re-render the cropper when resize the window
  responsive: true,
  // Restore the cropped area after resize the window
  restore: true,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: true,
  // Check the current image's Exif Orientation information
  checkOrientation: true,
  // Show the black modal
  modal: true,
  // Show the dashed lines for guiding
  guides: true,
  // Show the center indicator for guiding
  center: true,
  // Show the white modal to highlight the crop box
  highlight: true,
  // Show the grid background
  background: true,
  // Enable to crop the image automatically when initialize
  autoCrop: true,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: true,
  // Enable to rotate the image
  rotatable: true,
  // Enable to scale the image
  scalable: true,
  // Enable to zoom the image
  zoomable: true,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: true,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: true,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: true,
  // Enable to resize the crop box
  cropBoxResizable: true,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: true,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: MIN_CONTAINER_WIDTH,
  minContainerHeight: MIN_CONTAINER_HEIGHT,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
};

var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';

/**
 * Check if the given value is not a number.
 */
var isNaN$1 = Number.isNaN || WINDOW.isNaN;

/**
 * Check if the given value is a number.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a number, else `false`.
 */
function isNumber(value) {
  return typeof value === 'number' && !isNaN$1(value);
}

/**
 * Check if the given value is a positive number.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
 */
var isPositiveNumber = function isPositiveNumber(value) {
  return value > 0 && value < Infinity;
};

/**
 * Check if the given value is undefined.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
 */
function isUndefined(value) {
  return typeof value === 'undefined';
}

/**
 * Check if the given value is an object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is an object, else `false`.
 */
function isObject(value) {
  return _typeof(value) === 'object' && value !== null;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Check if the given value is a plain object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
 */
function isPlainObject(value) {
  if (!isObject(value)) {
    return false;
  }
  try {
    var _constructor = value.constructor;
    var prototype = _constructor.prototype;
    return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
  } catch (error) {
    return false;
  }
}

/**
 * Check if the given value is a function.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a function, else `false`.
 */
function isFunction(value) {
  return typeof value === 'function';
}
var slice = Array.prototype.slice;

/**
 * Convert array-like or iterable object to an array.
 * @param {*} value - The value to convert.
 * @returns {Array} Returns a new array.
 */
function toArray(value) {
  return Array.from ? Array.from(value) : slice.call(value);
}

/**
 * Iterate the given data.
 * @param {*} data - The data to iterate.
 * @param {Function} callback - The process function for each element.
 * @returns {*} The original data.
 */
function forEach(data, callback) {
  if (data && isFunction(callback)) {
    if (Array.isArray(data) || isNumber(data.length) /* array-like */) {
      toArray(data).forEach(function (value, key) {
        callback.call(data, value, key, data);
      });
    } else if (isObject(data)) {
      Object.keys(data).forEach(function (key) {
        callback.call(data, data[key], key, data);
      });
    }
  }
  return data;
}

/**
 * Extend the given object.
 * @param {*} target - The target object to extend.
 * @param {*} args - The rest objects for merging to the target object.
 * @returns {Object} The extended object.
 */
var assign = Object.assign || function assign(target) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (isObject(target) && args.length > 0) {
    args.forEach(function (arg) {
      if (isObject(arg)) {
        Object.keys(arg).forEach(function (key) {
          target[key] = arg[key];
        });
      }
    });
  }
  return target;
};
var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;

/**
 * Normalize decimal number.
 * Check out {@link https://0.30000000000000004.com/}
 * @param {number} value - The value to normalize.
 * @param {number} [times=100000000000] - The times for normalizing.
 * @returns {number} Returns the normalized number.
 */
function normalizeDecimalNumber(value) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
  return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
}
var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;

/**
 * Apply styles to the given element.
 * @param {Element} element - The target element.
 * @param {Object} styles - The styles for applying.
 */
function setStyle(element, styles) {
  var style = element.style;
  forEach(styles, function (value, property) {
    if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
      value = "".concat(value, "px");
    }
    style[property] = value;
  });
}

/**
 * Check if the given element has a special class.
 * @param {Element} element - The element to check.
 * @param {string} value - The class to search.
 * @returns {boolean} Returns `true` if the special class was found.
 */
function hasClass(element, value) {
  return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
}

/**
 * Add classes to the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be added.
 */
function addClass(element, value) {
  if (!value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      addClass(elem, value);
    });
    return;
  }
  if (element.classList) {
    element.classList.add(value);
    return;
  }
  var className = element.className.trim();
  if (!className) {
    element.className = value;
  } else if (className.indexOf(value) < 0) {
    element.className = "".concat(className, " ").concat(value);
  }
}

/**
 * Remove classes from the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be removed.
 */
function removeClass(element, value) {
  if (!value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      removeClass(elem, value);
    });
    return;
  }
  if (element.classList) {
    element.classList.remove(value);
    return;
  }
  if (element.className.indexOf(value) >= 0) {
    element.className = element.className.replace(value, '');
  }
}

/**
 * Add or remove classes from the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be toggled.
 * @param {boolean} added - Add only.
 */
function toggleClass(element, value, added) {
  if (!value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      toggleClass(elem, value, added);
    });
    return;
  }

  // IE10-11 doesn't support the second parameter of `classList.toggle`
  if (added) {
    addClass(element, value);
  } else {
    removeClass(element, value);
  }
}
var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;

/**
 * Transform the given string from camelCase to kebab-case
 * @param {string} value - The value to transform.
 * @returns {string} The transformed value.
 */
function toParamCase(value) {
  return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
}

/**
 * Get data from the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to get.
 * @returns {string} The data value.
 */
function getData(element, name) {
  if (isObject(element[name])) {
    return element[name];
  }
  if (element.dataset) {
    return element.dataset[name];
  }
  return element.getAttribute("data-".concat(toParamCase(name)));
}

/**
 * Set data to the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to set.
 * @param {string} data - The data value.
 */
function setData(element, name, data) {
  if (isObject(data)) {
    element[name] = data;
  } else if (element.dataset) {
    element.dataset[name] = data;
  } else {
    element.setAttribute("data-".concat(toParamCase(name)), data);
  }
}

/**
 * Remove data from the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to remove.
 */
function removeData(element, name) {
  if (isObject(element[name])) {
    try {
      delete element[name];
    } catch (error) {
      element[name] = undefined;
    }
  } else if (element.dataset) {
    // #128 Safari not allows to delete dataset property
    try {
      delete element.dataset[name];
    } catch (error) {
      element.dataset[name] = undefined;
    }
  } else {
    element.removeAttribute("data-".concat(toParamCase(name)));
  }
}
var REGEXP_SPACES = /\s\s*/;
var onceSupported = function () {
  var supported = false;
  if (IS_BROWSER) {
    var once = false;
    var listener = function listener() {};
    var options = Object.defineProperty({}, 'once', {
      get: function get() {
        supported = true;
        return once;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function set(value) {
        once = value;
      }
    });
    WINDOW.addEventListener('test', listener, options);
    WINDOW.removeEventListener('test', listener, options);
  }
  return supported;
}();

/**
 * Remove event listener from the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Function} listener - The event listener.
 * @param {Object} options - The event options.
 */
function removeListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function (event) {
    if (!onceSupported) {
      var listeners = element.listeners;
      if (listeners && listeners[event] && listeners[event][listener]) {
        handler = listeners[event][listener];
        delete listeners[event][listener];
        if (Object.keys(listeners[event]).length === 0) {
          delete listeners[event];
        }
        if (Object.keys(listeners).length === 0) {
          delete element.listeners;
        }
      }
    }
    element.removeEventListener(event, handler, options);
  });
}

/**
 * Add event listener to the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Function} listener - The event listener.
 * @param {Object} options - The event options.
 */
function addListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function (event) {
    if (options.once && !onceSupported) {
      var _element$listeners = element.listeners,
        listeners = _element$listeners === void 0 ? {} : _element$listeners;
      _handler = function handler() {
        delete listeners[event][listener];
        element.removeEventListener(event, _handler, options);
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        listener.apply(element, args);
      };
      if (!listeners[event]) {
        listeners[event] = {};
      }
      if (listeners[event][listener]) {
        element.removeEventListener(event, listeners[event][listener], options);
      }
      listeners[event][listener] = _handler;
      element.listeners = listeners;
    }
    element.addEventListener(event, _handler, options);
  });
}

/**
 * Dispatch event on the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Object} data - The additional event data.
 * @returns {boolean} Indicate if the event is default prevented or not.
 */
function dispatchEvent(element, type, data) {
  var event;

  // Event and CustomEvent on IE9-11 are global objects, not constructors
  if (isFunction(Event) && isFunction(CustomEvent)) {
    event = new CustomEvent(type, {
      detail: data,
      bubbles: true,
      cancelable: true
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(type, true, true, data);
  }
  return element.dispatchEvent(event);
}

/**
 * Get the offset base on the document.
 * @param {Element} element - The target element.
 * @returns {Object} The offset data.
 */
function getOffset(element) {
  var box = element.getBoundingClientRect();
  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var location = WINDOW.location;
var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;

/**
 * Check if the given URL is a cross origin URL.
 * @param {string} url - The target URL.
 * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
 */
function isCrossOriginURL(url) {
  var parts = url.match(REGEXP_ORIGINS);
  return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
}

/**
 * Add timestamp to the given URL.
 * @param {string} url - The target URL.
 * @returns {string} The result URL.
 */
function addTimestamp(url) {
  var timestamp = "timestamp=".concat(new Date().getTime());
  return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
}

/**
 * Get transforms base on the given object.
 * @param {Object} obj - The target object.
 * @returns {string} A string contains transform values.
 */
function getTransforms(_ref) {
  var rotate = _ref.rotate,
    scaleX = _ref.scaleX,
    scaleY = _ref.scaleY,
    translateX = _ref.translateX,
    translateY = _ref.translateY;
  var values = [];
  if (isNumber(translateX) && translateX !== 0) {
    values.push("translateX(".concat(translateX, "px)"));
  }
  if (isNumber(translateY) && translateY !== 0) {
    values.push("translateY(".concat(translateY, "px)"));
  }

  // Rotate should come first before scale to match orientation transform
  if (isNumber(rotate) && rotate !== 0) {
    values.push("rotate(".concat(rotate, "deg)"));
  }
  if (isNumber(scaleX) && scaleX !== 1) {
    values.push("scaleX(".concat(scaleX, ")"));
  }
  if (isNumber(scaleY) && scaleY !== 1) {
    values.push("scaleY(".concat(scaleY, ")"));
  }
  var transform = values.length ? values.join(' ') : 'none';
  return {
    WebkitTransform: transform,
    msTransform: transform,
    transform: transform
  };
}

/**
 * Get the max ratio of a group of pointers.
 * @param {string} pointers - The target pointers.
 * @returns {number} The result ratio.
 */
function getMaxZoomRatio(pointers) {
  var pointers2 = _objectSpread2({}, pointers);
  var maxRatio = 0;
  forEach(pointers, function (pointer, pointerId) {
    delete pointers2[pointerId];
    forEach(pointers2, function (pointer2) {
      var x1 = Math.abs(pointer.startX - pointer2.startX);
      var y1 = Math.abs(pointer.startY - pointer2.startY);
      var x2 = Math.abs(pointer.endX - pointer2.endX);
      var y2 = Math.abs(pointer.endY - pointer2.endY);
      var z1 = Math.sqrt(x1 * x1 + y1 * y1);
      var z2 = Math.sqrt(x2 * x2 + y2 * y2);
      var ratio = (z2 - z1) / z1;
      if (Math.abs(ratio) > Math.abs(maxRatio)) {
        maxRatio = ratio;
      }
    });
  });
  return maxRatio;
}

/**
 * Get a pointer from an event object.
 * @param {Object} event - The target event object.
 * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
 * @returns {Object} The result pointer contains start and/or end point coordinates.
 */
function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX,
    pageY = _ref2.pageY;
  var end = {
    endX: pageX,
    endY: pageY
  };
  return endOnly ? end : _objectSpread2({
    startX: pageX,
    startY: pageY
  }, end);
}

/**
 * Get the center point coordinate of a group of pointers.
 * @param {Object} pointers - The target pointers.
 * @returns {Object} The center point coordinate.
 */
function getPointersCenter(pointers) {
  var pageX = 0;
  var pageY = 0;
  var count = 0;
  forEach(pointers, function (_ref3) {
    var startX = _ref3.startX,
      startY = _ref3.startY;
    pageX += startX;
    pageY += startY;
    count += 1;
  });
  pageX /= count;
  pageY /= count;
  return {
    pageX: pageX,
    pageY: pageY
  };
}

/**
 * Get the max sizes in a rectangle under the given aspect ratio.
 * @param {Object} data - The original sizes.
 * @param {string} [type='contain'] - The adjust type.
 * @returns {Object} The result sizes.
 */
function getAdjustedSizes(_ref4) {
  var aspectRatio = _ref4.aspectRatio,
    height = _ref4.height,
    width = _ref4.width;
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
  var isValidWidth = isPositiveNumber(width);
  var isValidHeight = isPositiveNumber(height);
  if (isValidWidth && isValidHeight) {
    var adjustedWidth = height * aspectRatio;
    if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
      height = width / aspectRatio;
    } else {
      width = height * aspectRatio;
    }
  } else if (isValidWidth) {
    height = width / aspectRatio;
  } else if (isValidHeight) {
    width = height * aspectRatio;
  }
  return {
    width: width,
    height: height
  };
}

/**
 * Get the new sizes of a rectangle after rotated.
 * @param {Object} data - The original sizes.
 * @returns {Object} The result sizes.
 */
function getRotatedSizes(_ref5) {
  var width = _ref5.width,
    height = _ref5.height,
    degree = _ref5.degree;
  degree = Math.abs(degree) % 180;
  if (degree === 90) {
    return {
      width: height,
      height: width
    };
  }
  var arc = degree % 90 * Math.PI / 180;
  var sinArc = Math.sin(arc);
  var cosArc = Math.cos(arc);
  var newWidth = width * cosArc + height * sinArc;
  var newHeight = width * sinArc + height * cosArc;
  return degree > 90 ? {
    width: newHeight,
    height: newWidth
  } : {
    width: newWidth,
    height: newHeight
  };
}

/**
 * Get a canvas which drew the given image.
 * @param {HTMLImageElement} image - The image for drawing.
 * @param {Object} imageData - The image data.
 * @param {Object} canvasData - The canvas data.
 * @param {Object} options - The options.
 * @returns {HTMLCanvasElement} The result canvas.
 */
function getSourceCanvas(image, _ref6, _ref7, _ref8) {
  var imageAspectRatio = _ref6.aspectRatio,
    imageNaturalWidth = _ref6.naturalWidth,
    imageNaturalHeight = _ref6.naturalHeight,
    _ref6$rotate = _ref6.rotate,
    rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
    _ref6$scaleX = _ref6.scaleX,
    scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
    _ref6$scaleY = _ref6.scaleY,
    scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
  var aspectRatio = _ref7.aspectRatio,
    naturalWidth = _ref7.naturalWidth,
    naturalHeight = _ref7.naturalHeight;
  var _ref8$fillColor = _ref8.fillColor,
    fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
    _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
    imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
    _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
    imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
    _ref8$maxWidth = _ref8.maxWidth,
    maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
    _ref8$maxHeight = _ref8.maxHeight,
    maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
    _ref8$minWidth = _ref8.minWidth,
    minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
    _ref8$minHeight = _ref8.minHeight,
    minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  var maxSizes = getAdjustedSizes({
    aspectRatio: aspectRatio,
    width: maxWidth,
    height: maxHeight
  });
  var minSizes = getAdjustedSizes({
    aspectRatio: aspectRatio,
    width: minWidth,
    height: minHeight
  }, 'cover');
  var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
  var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight));

  // Note: should always use image's natural sizes for drawing as
  // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
  var destMaxSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: maxWidth,
    height: maxHeight
  });
  var destMinSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: minWidth,
    height: minHeight
  }, 'cover');
  var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
  var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
  var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
  canvas.width = normalizeDecimalNumber(width);
  canvas.height = normalizeDecimalNumber(height);
  context.fillStyle = fillColor;
  context.fillRect(0, 0, width, height);
  context.save();
  context.translate(width / 2, height / 2);
  context.rotate(rotate * Math.PI / 180);
  context.scale(scaleX, scaleY);
  context.imageSmoothingEnabled = imageSmoothingEnabled;
  context.imageSmoothingQuality = imageSmoothingQuality;
  context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
    return Math.floor(normalizeDecimalNumber(param));
  }))));
  context.restore();
  return canvas;
}
var fromCharCode = String.fromCharCode;

/**
 * Get string from char code in data view.
 * @param {DataView} dataView - The data view for read.
 * @param {number} start - The start index.
 * @param {number} length - The read length.
 * @returns {string} The read result.
 */
function getStringFromCharCode(dataView, start, length) {
  var str = '';
  length += start;
  for (var i = start; i < length; i += 1) {
    str += fromCharCode(dataView.getUint8(i));
  }
  return str;
}
var REGEXP_DATA_URL_HEAD = /^data:.*,/;

/**
 * Transform Data URL to array buffer.
 * @param {string} dataURL - The Data URL to transform.
 * @returns {ArrayBuffer} The result array buffer.
 */
function dataURLToArrayBuffer(dataURL) {
  var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
  var binary = atob(base64);
  var arrayBuffer = new ArrayBuffer(binary.length);
  var uint8 = new Uint8Array(arrayBuffer);
  forEach(uint8, function (value, i) {
    uint8[i] = binary.charCodeAt(i);
  });
  return arrayBuffer;
}

/**
 * Transform array buffer to Data URL.
 * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
 * @param {string} mimeType - The mime type of the Data URL.
 * @returns {string} The result Data URL.
 */
function arrayBufferToDataURL(arrayBuffer, mimeType) {
  var chunks = [];

  // Chunk Typed Array for better performance (#435)
  var chunkSize = 8192;
  var uint8 = new Uint8Array(arrayBuffer);
  while (uint8.length > 0) {
    // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
    // eslint-disable-next-line prefer-spread
    chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
    uint8 = uint8.subarray(chunkSize);
  }
  return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
}

/**
 * Get orientation value from given array buffer.
 * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
 * @returns {number} The read orientation value.
 */
function resetAndGetOrientation(arrayBuffer) {
  var dataView = new DataView(arrayBuffer);
  var orientation;

  // Ignores range error when the image does not have correct Exif information
  try {
    var littleEndian;
    var app1Start;
    var ifdStart;

    // Only handle JPEG image (start by 0xFFD8)
    if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
      var length = dataView.byteLength;
      var offset = 2;
      while (offset + 1 < length) {
        if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
          app1Start = offset;
          break;
        }
        offset += 1;
      }
    }
    if (app1Start) {
      var exifIDCode = app1Start + 4;
      var tiffOffset = app1Start + 10;
      if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
        var endianness = dataView.getUint16(tiffOffset);
        littleEndian = endianness === 0x4949;
        if (littleEndian || endianness === 0x4D4D /* bigEndian */) {
          if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
            if (firstIFDOffset >= 0x00000008) {
              ifdStart = tiffOffset + firstIFDOffset;
            }
          }
        }
      }
    }
    if (ifdStart) {
      var _length = dataView.getUint16(ifdStart, littleEndian);
      var _offset;
      var i;
      for (i = 0; i < _length; i += 1) {
        _offset = ifdStart + i * 12 + 2;
        if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */) {
          // 8 is the offset of the current tag's value
          _offset += 8;

          // Get the original orientation value
          orientation = dataView.getUint16(_offset, littleEndian);

          // Override the orientation with its default value
          dataView.setUint16(_offset, 1, littleEndian);
          break;
        }
      }
    }
  } catch (error) {
    orientation = 1;
  }
  return orientation;
}

/**
 * Parse Exif Orientation value.
 * @param {number} orientation - The orientation to parse.
 * @returns {Object} The parsed result.
 */
function parseOrientation(orientation) {
  var rotate = 0;
  var scaleX = 1;
  var scaleY = 1;
  switch (orientation) {
    // Flip horizontal
    case 2:
      scaleX = -1;
      break;

    // Rotate left 180°
    case 3:
      rotate = -180;
      break;

    // Flip vertical
    case 4:
      scaleY = -1;
      break;

    // Flip vertical and rotate right 90°
    case 5:
      rotate = 90;
      scaleY = -1;
      break;

    // Rotate right 90°
    case 6:
      rotate = 90;
      break;

    // Flip horizontal and rotate right 90°
    case 7:
      rotate = 90;
      scaleX = -1;
      break;

    // Rotate left 90°
    case 8:
      rotate = -90;
      break;
  }
  return {
    rotate: rotate,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

var render = {
  render: function render() {
    this.initContainer();
    this.initCanvas();
    this.initCropBox();
    this.renderCanvas();
    if (this.cropped) {
      this.renderCropBox();
    }
  },
  initContainer: function initContainer() {
    var element = this.element,
      options = this.options,
      container = this.container,
      cropper = this.cropper;
    var minWidth = Number(options.minContainerWidth);
    var minHeight = Number(options.minContainerHeight);
    addClass(cropper, CLASS_HIDDEN);
    removeClass(element, CLASS_HIDDEN);
    var containerData = {
      width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
      height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
    };
    this.containerData = containerData;
    setStyle(cropper, {
      width: containerData.width,
      height: containerData.height
    });
    addClass(element, CLASS_HIDDEN);
    removeClass(cropper, CLASS_HIDDEN);
  },
  // Canvas (image wrapper)
  initCanvas: function initCanvas() {
    var containerData = this.containerData,
      imageData = this.imageData;
    var viewMode = this.options.viewMode;
    var rotated = Math.abs(imageData.rotate) % 180 === 90;
    var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
    var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
    var aspectRatio = naturalWidth / naturalHeight;
    var canvasWidth = containerData.width;
    var canvasHeight = containerData.height;
    if (containerData.height * aspectRatio > containerData.width) {
      if (viewMode === 3) {
        canvasWidth = containerData.height * aspectRatio;
      } else {
        canvasHeight = containerData.width / aspectRatio;
      }
    } else if (viewMode === 3) {
      canvasHeight = containerData.width / aspectRatio;
    } else {
      canvasWidth = containerData.height * aspectRatio;
    }
    var canvasData = {
      aspectRatio: aspectRatio,
      naturalWidth: naturalWidth,
      naturalHeight: naturalHeight,
      width: canvasWidth,
      height: canvasHeight
    };
    this.canvasData = canvasData;
    this.limited = viewMode === 1 || viewMode === 2;
    this.limitCanvas(true, true);
    canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
    canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
    canvasData.left = (containerData.width - canvasData.width) / 2;
    canvasData.top = (containerData.height - canvasData.height) / 2;
    canvasData.oldLeft = canvasData.left;
    canvasData.oldTop = canvasData.top;
    this.initialCanvasData = assign({}, canvasData);
  },
  limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
    var options = this.options,
      containerData = this.containerData,
      canvasData = this.canvasData,
      cropBoxData = this.cropBoxData;
    var viewMode = options.viewMode;
    var aspectRatio = canvasData.aspectRatio;
    var cropped = this.cropped && cropBoxData;
    if (sizeLimited) {
      var minCanvasWidth = Number(options.minCanvasWidth) || 0;
      var minCanvasHeight = Number(options.minCanvasHeight) || 0;
      if (viewMode > 1) {
        minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
        minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
        if (viewMode === 3) {
          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          } else {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          }
        }
      } else if (viewMode > 0) {
        if (minCanvasWidth) {
          minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
        } else if (minCanvasHeight) {
          minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
        } else if (cropped) {
          minCanvasWidth = cropBoxData.width;
          minCanvasHeight = cropBoxData.height;
          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          } else {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          }
        }
      }
      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: minCanvasWidth,
        height: minCanvasHeight
      });
      minCanvasWidth = _getAdjustedSizes.width;
      minCanvasHeight = _getAdjustedSizes.height;
      canvasData.minWidth = minCanvasWidth;
      canvasData.minHeight = minCanvasHeight;
      canvasData.maxWidth = Infinity;
      canvasData.maxHeight = Infinity;
    }
    if (positionLimited) {
      if (viewMode > (cropped ? 0 : 1)) {
        var newCanvasLeft = containerData.width - canvasData.width;
        var newCanvasTop = containerData.height - canvasData.height;
        canvasData.minLeft = Math.min(0, newCanvasLeft);
        canvasData.minTop = Math.min(0, newCanvasTop);
        canvasData.maxLeft = Math.max(0, newCanvasLeft);
        canvasData.maxTop = Math.max(0, newCanvasTop);
        if (cropped && this.limited) {
          canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
          canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
          canvasData.maxLeft = cropBoxData.left;
          canvasData.maxTop = cropBoxData.top;
          if (viewMode === 2) {
            if (canvasData.width >= containerData.width) {
              canvasData.minLeft = Math.min(0, newCanvasLeft);
              canvasData.maxLeft = Math.max(0, newCanvasLeft);
            }
            if (canvasData.height >= containerData.height) {
              canvasData.minTop = Math.min(0, newCanvasTop);
              canvasData.maxTop = Math.max(0, newCanvasTop);
            }
          }
        }
      } else {
        canvasData.minLeft = -canvasData.width;
        canvasData.minTop = -canvasData.height;
        canvasData.maxLeft = containerData.width;
        canvasData.maxTop = containerData.height;
      }
    }
  },
  renderCanvas: function renderCanvas(changed, transformed) {
    var canvasData = this.canvasData,
      imageData = this.imageData;
    if (transformed) {
      var _getRotatedSizes = getRotatedSizes({
          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
          degree: imageData.rotate || 0
        }),
        naturalWidth = _getRotatedSizes.width,
        naturalHeight = _getRotatedSizes.height;
      var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
      var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
      canvasData.left -= (width - canvasData.width) / 2;
      canvasData.top -= (height - canvasData.height) / 2;
      canvasData.width = width;
      canvasData.height = height;
      canvasData.aspectRatio = naturalWidth / naturalHeight;
      canvasData.naturalWidth = naturalWidth;
      canvasData.naturalHeight = naturalHeight;
      this.limitCanvas(true, false);
    }
    if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
      canvasData.left = canvasData.oldLeft;
    }
    if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
      canvasData.top = canvasData.oldTop;
    }
    canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
    canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
    this.limitCanvas(false, true);
    canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
    canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
    canvasData.oldLeft = canvasData.left;
    canvasData.oldTop = canvasData.top;
    setStyle(this.canvas, assign({
      width: canvasData.width,
      height: canvasData.height
    }, getTransforms({
      translateX: canvasData.left,
      translateY: canvasData.top
    })));
    this.renderImage(changed);
    if (this.cropped && this.limited) {
      this.limitCropBox(true, true);
    }
  },
  renderImage: function renderImage(changed) {
    var canvasData = this.canvasData,
      imageData = this.imageData;
    var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
    var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
    assign(imageData, {
      width: width,
      height: height,
      left: (canvasData.width - width) / 2,
      top: (canvasData.height - height) / 2
    });
    setStyle(this.image, assign({
      width: imageData.width,
      height: imageData.height
    }, getTransforms(assign({
      translateX: imageData.left,
      translateY: imageData.top
    }, imageData))));
    if (changed) {
      this.output();
    }
  },
  initCropBox: function initCropBox() {
    var options = this.options,
      canvasData = this.canvasData;
    var aspectRatio = options.aspectRatio || options.initialAspectRatio;
    var autoCropArea = Number(options.autoCropArea) || 0.8;
    var cropBoxData = {
      width: canvasData.width,
      height: canvasData.height
    };
    if (aspectRatio) {
      if (canvasData.height * aspectRatio > canvasData.width) {
        cropBoxData.height = cropBoxData.width / aspectRatio;
      } else {
        cropBoxData.width = cropBoxData.height * aspectRatio;
      }
    }
    this.cropBoxData = cropBoxData;
    this.limitCropBox(true, true);

    // Initialize auto crop area
    cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
    cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);

    // The width/height of auto crop area must large than "minWidth/Height"
    cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
    cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
    cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
    cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
    cropBoxData.oldLeft = cropBoxData.left;
    cropBoxData.oldTop = cropBoxData.top;
    this.initialCropBoxData = assign({}, cropBoxData);
  },
  limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
    var options = this.options,
      containerData = this.containerData,
      canvasData = this.canvasData,
      cropBoxData = this.cropBoxData,
      limited = this.limited;
    var aspectRatio = options.aspectRatio;
    if (sizeLimited) {
      var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
      var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
      var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
      var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height;

      // The min/maxCropBoxWidth/Height must be less than container's width/height
      minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
      minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
      if (aspectRatio) {
        if (minCropBoxWidth && minCropBoxHeight) {
          if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }
        } else if (minCropBoxWidth) {
          minCropBoxHeight = minCropBoxWidth / aspectRatio;
        } else if (minCropBoxHeight) {
          minCropBoxWidth = minCropBoxHeight * aspectRatio;
        }
        if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
          maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
        } else {
          maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
        }
      }

      // The minWidth/Height must be less than maxWidth/Height
      cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
      cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
      cropBoxData.maxWidth = maxCropBoxWidth;
      cropBoxData.maxHeight = maxCropBoxHeight;
    }
    if (positionLimited) {
      if (limited) {
        cropBoxData.minLeft = Math.max(0, canvasData.left);
        cropBoxData.minTop = Math.max(0, canvasData.top);
        cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
        cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
      } else {
        cropBoxData.minLeft = 0;
        cropBoxData.minTop = 0;
        cropBoxData.maxLeft = containerData.width - cropBoxData.width;
        cropBoxData.maxTop = containerData.height - cropBoxData.height;
      }
    }
  },
  renderCropBox: function renderCropBox() {
    var options = this.options,
      containerData = this.containerData,
      cropBoxData = this.cropBoxData;
    if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
      cropBoxData.left = cropBoxData.oldLeft;
    }
    if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
      cropBoxData.top = cropBoxData.oldTop;
    }
    cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
    cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
    this.limitCropBox(false, true);
    cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
    cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
    cropBoxData.oldLeft = cropBoxData.left;
    cropBoxData.oldTop = cropBoxData.top;
    if (options.movable && options.cropBoxMovable) {
      // Turn to move the canvas when the crop box is equal to the container
      setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
    }
    setStyle(this.cropBox, assign({
      width: cropBoxData.width,
      height: cropBoxData.height
    }, getTransforms({
      translateX: cropBoxData.left,
      translateY: cropBoxData.top
    })));
    if (this.cropped && this.limited) {
      this.limitCanvas(true, true);
    }
    if (!this.disabled) {
      this.output();
    }
  },
  output: function output() {
    this.preview();
    dispatchEvent(this.element, EVENT_CROP, this.getData());
  }
};

var preview = {
  initPreview: function initPreview() {
    var element = this.element,
      crossOrigin = this.crossOrigin;
    var preview = this.options.preview;
    var url = crossOrigin ? this.crossOriginUrl : this.url;
    var alt = element.alt || 'The image to preview';
    var image = document.createElement('img');
    if (crossOrigin) {
      image.crossOrigin = crossOrigin;
    }
    image.src = url;
    image.alt = alt;
    this.viewBox.appendChild(image);
    this.viewBoxImage = image;
    if (!preview) {
      return;
    }
    var previews = preview;
    if (typeof preview === 'string') {
      previews = element.ownerDocument.querySelectorAll(preview);
    } else if (preview.querySelector) {
      previews = [preview];
    }
    this.previews = previews;
    forEach(previews, function (el) {
      var img = document.createElement('img');

      // Save the original size for recover
      setData(el, DATA_PREVIEW, {
        width: el.offsetWidth,
        height: el.offsetHeight,
        html: el.innerHTML
      });
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.src = url;
      img.alt = alt;

      /**
       * Override img element styles
       * Add `display:block` to avoid margin top issue
       * Add `height:auto` to override `height` attribute on IE8
       * (Occur only when margin-top <= -height)
       */
      img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
      el.innerHTML = '';
      el.appendChild(img);
    });
  },
  resetPreview: function resetPreview() {
    forEach(this.previews, function (element) {
      var data = getData(element, DATA_PREVIEW);
      setStyle(element, {
        width: data.width,
        height: data.height
      });
      element.innerHTML = data.html;
      removeData(element, DATA_PREVIEW);
    });
  },
  preview: function preview() {
    var imageData = this.imageData,
      canvasData = this.canvasData,
      cropBoxData = this.cropBoxData;
    var cropBoxWidth = cropBoxData.width,
      cropBoxHeight = cropBoxData.height;
    var width = imageData.width,
      height = imageData.height;
    var left = cropBoxData.left - canvasData.left - imageData.left;
    var top = cropBoxData.top - canvasData.top - imageData.top;
    if (!this.cropped || this.disabled) {
      return;
    }
    setStyle(this.viewBoxImage, assign({
      width: width,
      height: height
    }, getTransforms(assign({
      translateX: -left,
      translateY: -top
    }, imageData))));
    forEach(this.previews, function (element) {
      var data = getData(element, DATA_PREVIEW);
      var originalWidth = data.width;
      var originalHeight = data.height;
      var newWidth = originalWidth;
      var newHeight = originalHeight;
      var ratio = 1;
      if (cropBoxWidth) {
        ratio = originalWidth / cropBoxWidth;
        newHeight = cropBoxHeight * ratio;
      }
      if (cropBoxHeight && newHeight > originalHeight) {
        ratio = originalHeight / cropBoxHeight;
        newWidth = cropBoxWidth * ratio;
        newHeight = originalHeight;
      }
      setStyle(element, {
        width: newWidth,
        height: newHeight
      });
      setStyle(element.getElementsByTagName('img')[0], assign({
        width: width * ratio,
        height: height * ratio
      }, getTransforms(assign({
        translateX: -left * ratio,
        translateY: -top * ratio
      }, imageData))));
    });
  }
};

var events = {
  bind: function bind() {
    var element = this.element,
      options = this.options,
      cropper = this.cropper;
    if (isFunction(options.cropstart)) {
      addListener(element, EVENT_CROP_START, options.cropstart);
    }
    if (isFunction(options.cropmove)) {
      addListener(element, EVENT_CROP_MOVE, options.cropmove);
    }
    if (isFunction(options.cropend)) {
      addListener(element, EVENT_CROP_END, options.cropend);
    }
    if (isFunction(options.crop)) {
      addListener(element, EVENT_CROP, options.crop);
    }
    if (isFunction(options.zoom)) {
      addListener(element, EVENT_ZOOM, options.zoom);
    }
    addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
    if (options.zoomable && options.zoomOnWheel) {
      addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
        passive: false,
        capture: true
      });
    }
    if (options.toggleDragModeOnDblclick) {
      addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
    }
    addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
    addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
    if (options.responsive) {
      addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
    }
  },
  unbind: function unbind() {
    var element = this.element,
      options = this.options,
      cropper = this.cropper;
    if (isFunction(options.cropstart)) {
      removeListener(element, EVENT_CROP_START, options.cropstart);
    }
    if (isFunction(options.cropmove)) {
      removeListener(element, EVENT_CROP_MOVE, options.cropmove);
    }
    if (isFunction(options.cropend)) {
      removeListener(element, EVENT_CROP_END, options.cropend);
    }
    if (isFunction(options.crop)) {
      removeListener(element, EVENT_CROP, options.crop);
    }
    if (isFunction(options.zoom)) {
      removeListener(element, EVENT_ZOOM, options.zoom);
    }
    removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
    if (options.zoomable && options.zoomOnWheel) {
      removeListener(cropper, EVENT_WHEEL, this.onWheel, {
        passive: false,
        capture: true
      });
    }
    if (options.toggleDragModeOnDblclick) {
      removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
    }
    removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
    removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
    if (options.responsive) {
      removeListener(window, EVENT_RESIZE, this.onResize);
    }
  }
};

var handlers = {
  resize: function resize() {
    if (this.disabled) {
      return;
    }
    var options = this.options,
      container = this.container,
      containerData = this.containerData;
    var ratioX = container.offsetWidth / containerData.width;
    var ratioY = container.offsetHeight / containerData.height;
    var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY;

    // Resize when width changed or height changed
    if (ratio !== 1) {
      var canvasData;
      var cropBoxData;
      if (options.restore) {
        canvasData = this.getCanvasData();
        cropBoxData = this.getCropBoxData();
      }
      this.render();
      if (options.restore) {
        this.setCanvasData(forEach(canvasData, function (n, i) {
          canvasData[i] = n * ratio;
        }));
        this.setCropBoxData(forEach(cropBoxData, function (n, i) {
          cropBoxData[i] = n * ratio;
        }));
      }
    }
  },
  dblclick: function dblclick() {
    if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
      return;
    }
    this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
  },
  wheel: function wheel(event) {
    var _this = this;
    var ratio = Number(this.options.wheelZoomRatio) || 0.1;
    var delta = 1;
    if (this.disabled) {
      return;
    }
    event.preventDefault();

    // Limit wheel speed to prevent zoom too fast (#21)
    if (this.wheeling) {
      return;
    }
    this.wheeling = true;
    setTimeout(function () {
      _this.wheeling = false;
    }, 50);
    if (event.deltaY) {
      delta = event.deltaY > 0 ? 1 : -1;
    } else if (event.wheelDelta) {
      delta = -event.wheelDelta / 120;
    } else if (event.detail) {
      delta = event.detail > 0 ? 1 : -1;
    }
    this.zoom(-delta * ratio, event);
  },
  cropStart: function cropStart(event) {
    var buttons = event.buttons,
      button = event.button;
    if (this.disabled

    // Handle mouse event and pointer event and ignore touch event
    || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && (
    // No primary button (Usually the left button)
    isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0

    // Open context menu
    || event.ctrlKey)) {
      return;
    }
    var options = this.options,
      pointers = this.pointers;
    var action;
    if (event.changedTouches) {
      // Handle touch event
      forEach(event.changedTouches, function (touch) {
        pointers[touch.identifier] = getPointer(touch);
      });
    } else {
      // Handle mouse event and pointer event
      pointers[event.pointerId || 0] = getPointer(event);
    }
    if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
      action = ACTION_ZOOM;
    } else {
      action = getData(event.target, DATA_ACTION);
    }
    if (!REGEXP_ACTIONS.test(action)) {
      return;
    }
    if (dispatchEvent(this.element, EVENT_CROP_START, {
      originalEvent: event,
      action: action
    }) === false) {
      return;
    }

    // This line is required for preventing page zooming in iOS browsers
    event.preventDefault();
    this.action = action;
    this.cropping = false;
    if (action === ACTION_CROP) {
      this.cropping = true;
      addClass(this.dragBox, CLASS_MODAL);
    }
  },
  cropMove: function cropMove(event) {
    var action = this.action;
    if (this.disabled || !action) {
      return;
    }
    var pointers = this.pointers;
    event.preventDefault();
    if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
      originalEvent: event,
      action: action
    }) === false) {
      return;
    }
    if (event.changedTouches) {
      forEach(event.changedTouches, function (touch) {
        // The first parameter should not be undefined (#432)
        assign(pointers[touch.identifier] || {}, getPointer(touch, true));
      });
    } else {
      assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
    }
    this.change(event);
  },
  cropEnd: function cropEnd(event) {
    if (this.disabled) {
      return;
    }
    var action = this.action,
      pointers = this.pointers;
    if (event.changedTouches) {
      forEach(event.changedTouches, function (touch) {
        delete pointers[touch.identifier];
      });
    } else {
      delete pointers[event.pointerId || 0];
    }
    if (!action) {
      return;
    }
    event.preventDefault();
    if (!Object.keys(pointers).length) {
      this.action = '';
    }
    if (this.cropping) {
      this.cropping = false;
      toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
    }
    dispatchEvent(this.element, EVENT_CROP_END, {
      originalEvent: event,
      action: action
    });
  }
};

var change = {
  change: function change(event) {
    var options = this.options,
      canvasData = this.canvasData,
      containerData = this.containerData,
      cropBoxData = this.cropBoxData,
      pointers = this.pointers;
    var action = this.action;
    var aspectRatio = options.aspectRatio;
    var left = cropBoxData.left,
      top = cropBoxData.top,
      width = cropBoxData.width,
      height = cropBoxData.height;
    var right = left + width;
    var bottom = top + height;
    var minLeft = 0;
    var minTop = 0;
    var maxWidth = containerData.width;
    var maxHeight = containerData.height;
    var renderable = true;
    var offset;

    // Locking aspect ratio in "free mode" by holding shift key
    if (!aspectRatio && event.shiftKey) {
      aspectRatio = width && height ? width / height : 1;
    }
    if (this.limited) {
      minLeft = cropBoxData.minLeft;
      minTop = cropBoxData.minTop;
      maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
      maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
    }
    var pointer = pointers[Object.keys(pointers)[0]];
    var range = {
      x: pointer.endX - pointer.startX,
      y: pointer.endY - pointer.startY
    };
    var check = function check(side) {
      switch (side) {
        case ACTION_EAST:
          if (right + range.x > maxWidth) {
            range.x = maxWidth - right;
          }
          break;
        case ACTION_WEST:
          if (left + range.x < minLeft) {
            range.x = minLeft - left;
          }
          break;
        case ACTION_NORTH:
          if (top + range.y < minTop) {
            range.y = minTop - top;
          }
          break;
        case ACTION_SOUTH:
          if (bottom + range.y > maxHeight) {
            range.y = maxHeight - bottom;
          }
          break;
      }
    };
    switch (action) {
      // Move crop box
      case ACTION_ALL:
        left += range.x;
        top += range.y;
        break;

      // Resize crop box
      case ACTION_EAST:
        if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = false;
          break;
        }
        check(ACTION_EAST);
        width += range.x;
        if (width < 0) {
          action = ACTION_WEST;
          width = -width;
          left -= width;
        }
        if (aspectRatio) {
          height = width / aspectRatio;
          top += (cropBoxData.height - height) / 2;
        }
        break;
      case ACTION_NORTH:
        if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = false;
          break;
        }
        check(ACTION_NORTH);
        height -= range.y;
        top += range.y;
        if (height < 0) {
          action = ACTION_SOUTH;
          height = -height;
          top -= height;
        }
        if (aspectRatio) {
          width = height * aspectRatio;
          left += (cropBoxData.width - width) / 2;
        }
        break;
      case ACTION_WEST:
        if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = false;
          break;
        }
        check(ACTION_WEST);
        width -= range.x;
        left += range.x;
        if (width < 0) {
          action = ACTION_EAST;
          width = -width;
          left -= width;
        }
        if (aspectRatio) {
          height = width / aspectRatio;
          top += (cropBoxData.height - height) / 2;
        }
        break;
      case ACTION_SOUTH:
        if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = false;
          break;
        }
        check(ACTION_SOUTH);
        height += range.y;
        if (height < 0) {
          action = ACTION_NORTH;
          height = -height;
          top -= height;
        }
        if (aspectRatio) {
          width = height * aspectRatio;
          left += (cropBoxData.width - width) / 2;
        }
        break;
      case ACTION_NORTH_EAST:
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
            renderable = false;
            break;
          }
          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;
          width = height * aspectRatio;
        } else {
          check(ACTION_NORTH);
          check(ACTION_EAST);
          if (range.x >= 0) {
            if (right < maxWidth) {
              width += range.x;
            } else if (range.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width += range.x;
          }
          if (range.y <= 0) {
            if (top > minTop) {
              height -= range.y;
              top += range.y;
            }
          } else {
            height -= range.y;
            top += range.y;
          }
        }
        if (width < 0 && height < 0) {
          action = ACTION_SOUTH_WEST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_NORTH_WEST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_SOUTH_EAST;
          height = -height;
          top -= height;
        }
        break;
      case ACTION_NORTH_WEST:
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
            renderable = false;
            break;
          }
          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;
          width = height * aspectRatio;
          left += cropBoxData.width - width;
        } else {
          check(ACTION_NORTH);
          check(ACTION_WEST);
          if (range.x <= 0) {
            if (left > minLeft) {
              width -= range.x;
              left += range.x;
            } else if (range.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width -= range.x;
            left += range.x;
          }
          if (range.y <= 0) {
            if (top > minTop) {
              height -= range.y;
              top += range.y;
            }
          } else {
            height -= range.y;
            top += range.y;
          }
        }
        if (width < 0 && height < 0) {
          action = ACTION_SOUTH_EAST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_NORTH_EAST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_SOUTH_WEST;
          height = -height;
          top -= height;
        }
        break;
      case ACTION_SOUTH_WEST:
        if (aspectRatio) {
          if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
            renderable = false;
            break;
          }
          check(ACTION_WEST);
          width -= range.x;
          left += range.x;
          height = width / aspectRatio;
        } else {
          check(ACTION_SOUTH);
          check(ACTION_WEST);
          if (range.x <= 0) {
            if (left > minLeft) {
              width -= range.x;
              left += range.x;
            } else if (range.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width -= range.x;
            left += range.x;
          }
          if (range.y >= 0) {
            if (bottom < maxHeight) {
              height += range.y;
            }
          } else {
            height += range.y;
          }
        }
        if (width < 0 && height < 0) {
          action = ACTION_NORTH_EAST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_SOUTH_EAST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_NORTH_WEST;
          height = -height;
          top -= height;
        }
        break;
      case ACTION_SOUTH_EAST:
        if (aspectRatio) {
          if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
            renderable = false;
            break;
          }
          check(ACTION_EAST);
          width += range.x;
          height = width / aspectRatio;
        } else {
          check(ACTION_SOUTH);
          check(ACTION_EAST);
          if (range.x >= 0) {
            if (right < maxWidth) {
              width += range.x;
            } else if (range.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width += range.x;
          }
          if (range.y >= 0) {
            if (bottom < maxHeight) {
              height += range.y;
            }
          } else {
            height += range.y;
          }
        }
        if (width < 0 && height < 0) {
          action = ACTION_NORTH_WEST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_SOUTH_WEST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_NORTH_EAST;
          height = -height;
          top -= height;
        }
        break;

      // Move canvas
      case ACTION_MOVE:
        this.move(range.x, range.y);
        renderable = false;
        break;

      // Zoom canvas
      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), event);
        renderable = false;
        break;

      // Create crop box
      case ACTION_CROP:
        if (!range.x || !range.y) {
          renderable = false;
          break;
        }
        offset = getOffset(this.cropper);
        left = pointer.startX - offset.left;
        top = pointer.startY - offset.top;
        width = cropBoxData.minWidth;
        height = cropBoxData.minHeight;
        if (range.x > 0) {
          action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
        } else if (range.x < 0) {
          left -= width;
          action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
        }
        if (range.y < 0) {
          top -= height;
        }

        // Show the crop box if is hidden
        if (!this.cropped) {
          removeClass(this.cropBox, CLASS_HIDDEN);
          this.cropped = true;
          if (this.limited) {
            this.limitCropBox(true, true);
          }
        }
        break;
    }
    if (renderable) {
      cropBoxData.width = width;
      cropBoxData.height = height;
      cropBoxData.left = left;
      cropBoxData.top = top;
      this.action = action;
      this.renderCropBox();
    }

    // Override
    forEach(pointers, function (p) {
      p.startX = p.endX;
      p.startY = p.endY;
    });
  }
};

var methods = {
  // Show the crop box manually
  crop: function crop() {
    if (this.ready && !this.cropped && !this.disabled) {
      this.cropped = true;
      this.limitCropBox(true, true);
      if (this.options.modal) {
        addClass(this.dragBox, CLASS_MODAL);
      }
      removeClass(this.cropBox, CLASS_HIDDEN);
      this.setCropBoxData(this.initialCropBoxData);
    }
    return this;
  },
  // Reset the image and crop box to their initial states
  reset: function reset() {
    if (this.ready && !this.disabled) {
      this.imageData = assign({}, this.initialImageData);
      this.canvasData = assign({}, this.initialCanvasData);
      this.cropBoxData = assign({}, this.initialCropBoxData);
      this.renderCanvas();
      if (this.cropped) {
        this.renderCropBox();
      }
    }
    return this;
  },
  // Clear the crop box
  clear: function clear() {
    if (this.cropped && !this.disabled) {
      assign(this.cropBoxData, {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      });
      this.cropped = false;
      this.renderCropBox();
      this.limitCanvas(true, true);

      // Render canvas after crop box rendered
      this.renderCanvas();
      removeClass(this.dragBox, CLASS_MODAL);
      addClass(this.cropBox, CLASS_HIDDEN);
    }
    return this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function replace(url) {
    var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!this.disabled && url) {
      if (this.isImg) {
        this.element.src = url;
      }
      if (hasSameSize) {
        this.url = url;
        this.image.src = url;
        if (this.ready) {
          this.viewBoxImage.src = url;
          forEach(this.previews, function (element) {
            element.getElementsByTagName('img')[0].src = url;
          });
        }
      } else {
        if (this.isImg) {
          this.replaced = true;
        }
        this.options.data = null;
        this.uncreate();
        this.load(url);
      }
    }
    return this;
  },
  // Enable (unfreeze) the cropper
  enable: function enable() {
    if (this.ready && this.disabled) {
      this.disabled = false;
      removeClass(this.cropper, CLASS_DISABLED);
    }
    return this;
  },
  // Disable (freeze) the cropper
  disable: function disable() {
    if (this.ready && !this.disabled) {
      this.disabled = true;
      addClass(this.cropper, CLASS_DISABLED);
    }
    return this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function destroy() {
    var element = this.element;
    if (!element[NAMESPACE]) {
      return this;
    }
    element[NAMESPACE] = undefined;
    if (this.isImg && this.replaced) {
      element.src = this.originalUrl;
    }
    this.uncreate();
    return this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function move(offsetX) {
    var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
    var _this$canvasData = this.canvasData,
      left = _this$canvasData.left,
      top = _this$canvasData.top;
    return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function moveTo(x) {
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
    var canvasData = this.canvasData;
    var changed = false;
    x = Number(x);
    y = Number(y);
    if (this.ready && !this.disabled && this.options.movable) {
      if (isNumber(x)) {
        canvasData.left = x;
        changed = true;
      }
      if (isNumber(y)) {
        canvasData.top = y;
        changed = true;
      }
      if (changed) {
        this.renderCanvas(true);
      }
    }
    return this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function zoom(ratio, _originalEvent) {
    var canvasData = this.canvasData;
    ratio = Number(ratio);
    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }
    return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
    var options = this.options,
      canvasData = this.canvasData;
    var width = canvasData.width,
      height = canvasData.height,
      naturalWidth = canvasData.naturalWidth,
      naturalHeight = canvasData.naturalHeight;
    ratio = Number(ratio);
    if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
      var newWidth = naturalWidth * ratio;
      var newHeight = naturalHeight * ratio;
      if (dispatchEvent(this.element, EVENT_ZOOM, {
        ratio: ratio,
        oldRatio: width / naturalWidth,
        originalEvent: _originalEvent
      }) === false) {
        return this;
      }
      if (_originalEvent) {
        var pointers = this.pointers;
        var offset = getOffset(this.cropper);
        var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        };

        // Zoom from the triggering point of the event
        canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
        canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
      } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
        canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
        canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
      } else {
        // Zoom from the center of the canvas
        canvasData.left -= (newWidth - width) / 2;
        canvasData.top -= (newHeight - height) / 2;
      }
      canvasData.width = newWidth;
      canvasData.height = newHeight;
      this.renderCanvas(true);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function rotate(degree) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function rotateTo(degree) {
    degree = Number(degree);
    if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
      this.imageData.rotate = degree % 360;
      this.renderCanvas(true, true);
    }
    return this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function scaleX(_scaleX) {
    var scaleY = this.imageData.scaleY;
    return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function scaleY(_scaleY) {
    var scaleX = this.imageData.scaleX;
    return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function scale(scaleX) {
    var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
    var imageData = this.imageData;
    var transformed = false;
    scaleX = Number(scaleX);
    scaleY = Number(scaleY);
    if (this.ready && !this.disabled && this.options.scalable) {
      if (isNumber(scaleX)) {
        imageData.scaleX = scaleX;
        transformed = true;
      }
      if (isNumber(scaleY)) {
        imageData.scaleY = scaleY;
        transformed = true;
      }
      if (transformed) {
        this.renderCanvas(true, true);
      }
    }
    return this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function getData() {
    var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var options = this.options,
      imageData = this.imageData,
      canvasData = this.canvasData,
      cropBoxData = this.cropBoxData;
    var data;
    if (this.ready && this.cropped) {
      data = {
        x: cropBoxData.left - canvasData.left,
        y: cropBoxData.top - canvasData.top,
        width: cropBoxData.width,
        height: cropBoxData.height
      };
      var ratio = imageData.width / imageData.naturalWidth;
      forEach(data, function (n, i) {
        data[i] = n / ratio;
      });
      if (rounded) {
        // In case rounding off leads to extra 1px in right or bottom border
        // we should round the top-left corner and the dimension (#343).
        var bottom = Math.round(data.y + data.height);
        var right = Math.round(data.x + data.width);
        data.x = Math.round(data.x);
        data.y = Math.round(data.y);
        data.width = right - data.x;
        data.height = bottom - data.y;
      }
    } else {
      data = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    }
    if (options.rotatable) {
      data.rotate = imageData.rotate || 0;
    }
    if (options.scalable) {
      data.scaleX = imageData.scaleX || 1;
      data.scaleY = imageData.scaleY || 1;
    }
    return data;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function setData(data) {
    var options = this.options,
      imageData = this.imageData,
      canvasData = this.canvasData;
    var cropBoxData = {};
    if (this.ready && !this.disabled && isPlainObject(data)) {
      var transformed = false;
      if (options.rotatable) {
        if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
          imageData.rotate = data.rotate;
          transformed = true;
        }
      }
      if (options.scalable) {
        if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
          imageData.scaleX = data.scaleX;
          transformed = true;
        }
        if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
          imageData.scaleY = data.scaleY;
          transformed = true;
        }
      }
      if (transformed) {
        this.renderCanvas(true, true);
      }
      var ratio = imageData.width / imageData.naturalWidth;
      if (isNumber(data.x)) {
        cropBoxData.left = data.x * ratio + canvasData.left;
      }
      if (isNumber(data.y)) {
        cropBoxData.top = data.y * ratio + canvasData.top;
      }
      if (isNumber(data.width)) {
        cropBoxData.width = data.width * ratio;
      }
      if (isNumber(data.height)) {
        cropBoxData.height = data.height * ratio;
      }
      this.setCropBoxData(cropBoxData);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function getContainerData() {
    return this.ready ? assign({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function getImageData() {
    return this.sized ? assign({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function getCanvasData() {
    var canvasData = this.canvasData;
    var data = {};
    if (this.ready) {
      forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
        data[n] = canvasData[n];
      });
    }
    return data;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function setCanvasData(data) {
    var canvasData = this.canvasData;
    var aspectRatio = canvasData.aspectRatio;
    if (this.ready && !this.disabled && isPlainObject(data)) {
      if (isNumber(data.left)) {
        canvasData.left = data.left;
      }
      if (isNumber(data.top)) {
        canvasData.top = data.top;
      }
      if (isNumber(data.width)) {
        canvasData.width = data.width;
        canvasData.height = data.width / aspectRatio;
      } else if (isNumber(data.height)) {
        canvasData.height = data.height;
        canvasData.width = data.height * aspectRatio;
      }
      this.renderCanvas(true);
    }
    return this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function getCropBoxData() {
    var cropBoxData = this.cropBoxData;
    var data;
    if (this.ready && this.cropped) {
      data = {
        left: cropBoxData.left,
        top: cropBoxData.top,
        width: cropBoxData.width,
        height: cropBoxData.height
      };
    }
    return data || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function setCropBoxData(data) {
    var cropBoxData = this.cropBoxData;
    var aspectRatio = this.options.aspectRatio;
    var widthChanged;
    var heightChanged;
    if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
      if (isNumber(data.left)) {
        cropBoxData.left = data.left;
      }
      if (isNumber(data.top)) {
        cropBoxData.top = data.top;
      }
      if (isNumber(data.width) && data.width !== cropBoxData.width) {
        widthChanged = true;
        cropBoxData.width = data.width;
      }
      if (isNumber(data.height) && data.height !== cropBoxData.height) {
        heightChanged = true;
        cropBoxData.height = data.height;
      }
      if (aspectRatio) {
        if (widthChanged) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else if (heightChanged) {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }
      this.renderCropBox();
    }
    return this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function getCroppedCanvas() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement) {
      return null;
    }
    var canvasData = this.canvasData;
    var source = getSourceCanvas(this.image, this.imageData, canvasData, options);

    // Returns the source canvas if it is not cropped.
    if (!this.cropped) {
      return source;
    }
    var _this$getData = this.getData(options.rounded),
      initialX = _this$getData.x,
      initialY = _this$getData.y,
      initialWidth = _this$getData.width,
      initialHeight = _this$getData.height;
    var ratio = source.width / Math.floor(canvasData.naturalWidth);
    if (ratio !== 1) {
      initialX *= ratio;
      initialY *= ratio;
      initialWidth *= ratio;
      initialHeight *= ratio;
    }
    var aspectRatio = initialWidth / initialHeight;
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: options.maxWidth || Infinity,
      height: options.maxHeight || Infinity
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: options.minWidth || 0,
      height: options.minHeight || 0
    }, 'cover');
    var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.width || (ratio !== 1 ? source.width : initialWidth),
        height: options.height || (ratio !== 1 ? source.height : initialHeight)
      }),
      width = _getAdjustedSizes.width,
      height = _getAdjustedSizes.height;
    width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
    height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);
    context.fillStyle = options.fillColor || 'transparent';
    context.fillRect(0, 0, width, height);
    var _options$imageSmoothi = options.imageSmoothingEnabled,
      imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
      imageSmoothingQuality = options.imageSmoothingQuality;
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    if (imageSmoothingQuality) {
      context.imageSmoothingQuality = imageSmoothingQuality;
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
    var sourceWidth = source.width;
    var sourceHeight = source.height;

    // Source canvas parameters
    var srcX = initialX;
    var srcY = initialY;
    var srcWidth;
    var srcHeight;

    // Destination canvas parameters
    var dstX;
    var dstY;
    var dstWidth;
    var dstHeight;
    if (srcX <= -initialWidth || srcX > sourceWidth) {
      srcX = 0;
      srcWidth = 0;
      dstX = 0;
      dstWidth = 0;
    } else if (srcX <= 0) {
      dstX = -srcX;
      srcX = 0;
      srcWidth = Math.min(sourceWidth, initialWidth + srcX);
      dstWidth = srcWidth;
    } else if (srcX <= sourceWidth) {
      dstX = 0;
      srcWidth = Math.min(initialWidth, sourceWidth - srcX);
      dstWidth = srcWidth;
    }
    if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
      srcY = 0;
      srcHeight = 0;
      dstY = 0;
      dstHeight = 0;
    } else if (srcY <= 0) {
      dstY = -srcY;
      srcY = 0;
      srcHeight = Math.min(sourceHeight, initialHeight + srcY);
      dstHeight = srcHeight;
    } else if (srcY <= sourceHeight) {
      dstY = 0;
      srcHeight = Math.min(initialHeight, sourceHeight - srcY);
      dstHeight = srcHeight;
    }
    var params = [srcX, srcY, srcWidth, srcHeight];

    // Avoid "IndexSizeError"
    if (dstWidth > 0 && dstHeight > 0) {
      var scale = width / initialWidth;
      params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
    }

    // All the numerical parameters should be integer for `drawImage`
    // https://github.com/fengyuanchen/cropper/issues/476
    context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    return canvas;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function setAspectRatio(aspectRatio) {
    var options = this.options;
    if (!this.disabled && !isUndefined(aspectRatio)) {
      // 0 -> NaN
      options.aspectRatio = Math.max(0, aspectRatio) || NaN;
      if (this.ready) {
        this.initCropBox();
        if (this.cropped) {
          this.renderCropBox();
        }
      }
    }
    return this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function setDragMode(mode) {
    var options = this.options,
      dragBox = this.dragBox,
      face = this.face;
    if (this.ready && !this.disabled) {
      var croppable = mode === DRAG_MODE_CROP;
      var movable = options.movable && mode === DRAG_MODE_MOVE;
      mode = croppable || movable ? mode : DRAG_MODE_NONE;
      options.dragMode = mode;
      setData(dragBox, DATA_ACTION, mode);
      toggleClass(dragBox, CLASS_CROP, croppable);
      toggleClass(dragBox, CLASS_MOVE, movable);
      if (!options.cropBoxMovable) {
        // Sync drag mode to crop box when it is not movable
        setData(face, DATA_ACTION, mode);
        toggleClass(face, CLASS_CROP, croppable);
        toggleClass(face, CLASS_MOVE, movable);
      }
    }
    return this;
  }
};

var AnotherCropper = WINDOW.Cropper;
var Cropper = /*#__PURE__*/function () {
  /**
   * Create a new Cropper.
   * @param {Element} element - The target element for cropping.
   * @param {Object} [options={}] - The configuration options.
   */
  function Cropper(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Cropper);
    if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
      throw new Error('The first argument is required and must be an <img> or <canvas> element.');
    }
    this.element = element;
    this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
    this.cropped = false;
    this.disabled = false;
    this.pointers = {};
    this.ready = false;
    this.reloading = false;
    this.replaced = false;
    this.sized = false;
    this.sizing = false;
    this.init();
  }
  return _createClass(Cropper, [{
    key: "init",
    value: function init() {
      var element = this.element;
      var tagName = element.tagName.toLowerCase();
      var url;
      if (element[NAMESPACE]) {
        return;
      }
      element[NAMESPACE] = this;
      if (tagName === 'img') {
        this.isImg = true;

        // e.g.: "img/picture.jpg"
        url = element.getAttribute('src') || '';
        this.originalUrl = url;

        // Stop when it's a blank image
        if (!url) {
          return;
        }

        // e.g.: "https://example.com/img/picture.jpg"
        url = element.src;
      } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
        url = element.toDataURL();
      }
      this.load(url);
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this = this;
      if (!url) {
        return;
      }
      this.url = url;
      this.imageData = {};
      var element = this.element,
        options = this.options;
      if (!options.rotatable && !options.scalable) {
        options.checkOrientation = false;
      }

      // Only IE10+ supports Typed Arrays
      if (!options.checkOrientation || !window.ArrayBuffer) {
        this.clone();
        return;
      }

      // Detect the mime type of the image directly if it is a Data URL
      if (REGEXP_DATA_URL.test(url)) {
        // Read ArrayBuffer from Data URL of JPEG images directly for better performance
        if (REGEXP_DATA_URL_JPEG.test(url)) {
          this.read(dataURLToArrayBuffer(url));
        } else {
          // Only a JPEG image may contains Exif Orientation information,
          // the rest types of Data URLs are not necessary to check orientation at all.
          this.clone();
        }
        return;
      }

      // 1. Detect the mime type of the image by a XMLHttpRequest.
      // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
      var xhr = new XMLHttpRequest();
      var clone = this.clone.bind(this);
      this.reloading = true;
      this.xhr = xhr;

      // 1. Cross origin requests are only supported for protocol schemes:
      // http, https, data, chrome, chrome-extension.
      // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
      // in some browsers as IE11 and Safari.
      xhr.onabort = clone;
      xhr.onerror = clone;
      xhr.ontimeout = clone;
      xhr.onprogress = function () {
        // Abort the request directly if it not a JPEG image for better performance
        if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
          xhr.abort();
        }
      };
      xhr.onload = function () {
        _this.read(xhr.response);
      };
      xhr.onloadend = function () {
        _this.reloading = false;
        _this.xhr = null;
      };

      // Bust cache when there is a "crossOrigin" property to avoid browser cache error
      if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
        url = addTimestamp(url);
      }

      // The third parameter is required for avoiding side-effect (#682)
      xhr.open('GET', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.withCredentials = element.crossOrigin === 'use-credentials';
      xhr.send();
    }
  }, {
    key: "read",
    value: function read(arrayBuffer) {
      var options = this.options,
        imageData = this.imageData;

      // Reset the orientation value to its default value 1
      // as some iOS browsers will render image with its orientation
      var orientation = resetAndGetOrientation(arrayBuffer);
      var rotate = 0;
      var scaleX = 1;
      var scaleY = 1;
      if (orientation > 1) {
        // Generate a new URL which has the default orientation value
        this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
        var _parseOrientation = parseOrientation(orientation);
        rotate = _parseOrientation.rotate;
        scaleX = _parseOrientation.scaleX;
        scaleY = _parseOrientation.scaleY;
      }
      if (options.rotatable) {
        imageData.rotate = rotate;
      }
      if (options.scalable) {
        imageData.scaleX = scaleX;
        imageData.scaleY = scaleY;
      }
      this.clone();
    }
  }, {
    key: "clone",
    value: function clone() {
      var element = this.element,
        url = this.url;
      var crossOrigin = element.crossOrigin;
      var crossOriginUrl = url;
      if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
        if (!crossOrigin) {
          crossOrigin = 'anonymous';
        }

        // Bust cache when there is not a "crossOrigin" property (#519)
        crossOriginUrl = addTimestamp(url);
      }
      this.crossOrigin = crossOrigin;
      this.crossOriginUrl = crossOriginUrl;
      var image = document.createElement('img');
      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }
      image.src = crossOriginUrl || url;
      image.alt = element.alt || 'The image to crop';
      this.image = image;
      image.onload = this.start.bind(this);
      image.onerror = this.stop.bind(this);
      addClass(image, CLASS_HIDE);
      element.parentNode.insertBefore(image, element.nextSibling);
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;
      var image = this.image;
      image.onload = null;
      image.onerror = null;
      this.sizing = true;

      // Match all browsers that use WebKit as the layout engine in iOS devices,
      // such as Safari for iOS, Chrome for iOS, and in-app browsers.
      var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
      var done = function done(naturalWidth, naturalHeight) {
        assign(_this2.imageData, {
          naturalWidth: naturalWidth,
          naturalHeight: naturalHeight,
          aspectRatio: naturalWidth / naturalHeight
        });
        _this2.initialImageData = assign({}, _this2.imageData);
        _this2.sizing = false;
        _this2.sized = true;
        _this2.build();
      };

      // Most modern browsers (excepts iOS WebKit)
      if (image.naturalWidth && !isIOSWebKit) {
        done(image.naturalWidth, image.naturalHeight);
        return;
      }
      var sizingImage = document.createElement('img');
      var body = document.body || document.documentElement;
      this.sizingImage = sizingImage;
      sizingImage.onload = function () {
        done(sizingImage.width, sizingImage.height);
        if (!isIOSWebKit) {
          body.removeChild(sizingImage);
        }
      };
      sizingImage.src = image.src;

      // iOS WebKit will convert the image automatically
      // with its orientation once append it into DOM (#279)
      if (!isIOSWebKit) {
        sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
        body.appendChild(sizingImage);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var image = this.image;
      image.onload = null;
      image.onerror = null;
      image.parentNode.removeChild(image);
      this.image = null;
    }
  }, {
    key: "build",
    value: function build() {
      if (!this.sized || this.ready) {
        return;
      }
      var element = this.element,
        options = this.options,
        image = this.image;

      // Create cropper elements
      var container = element.parentNode;
      var template = document.createElement('div');
      template.innerHTML = TEMPLATE;
      var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
      var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
      var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
      var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
      var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
      this.container = container;
      this.cropper = cropper;
      this.canvas = canvas;
      this.dragBox = dragBox;
      this.cropBox = cropBox;
      this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
      this.face = face;
      canvas.appendChild(image);

      // Hide the original image
      addClass(element, CLASS_HIDDEN);

      // Inserts the cropper after to the current image
      container.insertBefore(cropper, element.nextSibling);

      // Show the hidden image
      removeClass(image, CLASS_HIDE);
      this.initPreview();
      this.bind();
      options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
      options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
      options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
      addClass(cropBox, CLASS_HIDDEN);
      if (!options.guides) {
        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
      }
      if (!options.center) {
        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
      }
      if (options.background) {
        addClass(cropper, "".concat(NAMESPACE, "-bg"));
      }
      if (!options.highlight) {
        addClass(face, CLASS_INVISIBLE);
      }
      if (options.cropBoxMovable) {
        addClass(face, CLASS_MOVE);
        setData(face, DATA_ACTION, ACTION_ALL);
      }
      if (!options.cropBoxResizable) {
        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
      }
      this.render();
      this.ready = true;
      this.setDragMode(options.dragMode);
      if (options.autoCrop) {
        this.crop();
      }
      this.setData(options.data);
      if (isFunction(options.ready)) {
        addListener(element, EVENT_READY, options.ready, {
          once: true
        });
      }
      dispatchEvent(element, EVENT_READY);
    }
  }, {
    key: "unbuild",
    value: function unbuild() {
      if (!this.ready) {
        return;
      }
      this.ready = false;
      this.unbind();
      this.resetPreview();
      var parentNode = this.cropper.parentNode;
      if (parentNode) {
        parentNode.removeChild(this.cropper);
      }
      removeClass(this.element, CLASS_HIDDEN);
    }
  }, {
    key: "uncreate",
    value: function uncreate() {
      if (this.ready) {
        this.unbuild();
        this.ready = false;
        this.cropped = false;
      } else if (this.sizing) {
        this.sizingImage.onload = null;
        this.sizing = false;
        this.sized = false;
      } else if (this.reloading) {
        this.xhr.onabort = null;
        this.xhr.abort();
      } else if (this.image) {
        this.stop();
      }
    }

    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function noConflict() {
      window.Cropper = AnotherCropper;
      return Cropper;
    }

    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function setDefaults(options) {
      assign(DEFAULTS, isPlainObject(options) && options);
    }
  }]);
}();
assign(Cropper.prototype, render, preview, events, handlers, change, methods);

class ReactCropperHelpers {
  constructor(cropperOrRefObject) {
    this.cropperOrRefObject = cropperOrRefObject;
  }
  get cropper() {
    var _a;
    if (this.cropperOrRefObject instanceof Cropper) {
      return this.cropperOrRefObject;
    }
    if (!((_a = this.cropperOrRefObject.current) === null || _a === void 0 ? void 0 : _a.cropper)) {
      throw new TypeError("Passed reference React.RefObject<ReactCropperElement> is null or undefined");
    }
    return this.cropperOrRefObject.current.cropper;
  }
  get containerWidth() {
    return this.cropper.getContainerData().width;
  }
  get containerHeight() {
    return this.cropper.getContainerData().height;
  }
  get canvasWidth() {
    return this.cropper.getCanvasData().width;
  }
  get canvasHeight() {
    return this.cropper.getCanvasData().height;
  }
  get canvasImageWidth() {
    return this.cropper.getCanvasData().naturalWidth;
  }
  get canvasImageHeight() {
    return this.cropper.getCanvasData().naturalHeight;
  }
  get isImagePortrait() {
    return this.canvasImageHeight >= this.canvasImageWidth;
  }
  get isImageLandscape() {
    return !this.isImagePortrait;
  }
  get isImageHorizontallyOverflowed() {
    return this.canvasWidth > this.containerWidth;
  }
  get isImageHorizontallySmaller() {
    return this.containerWidth > this.canvasWidth;
  }
  get isImageVerticallyOverflowed() {
    return this.canvasHeight > this.containerHeight;
  }
  get isImageVerticallySmaller() {
    return this.containerHeight > this.canvasHeight;
  }
  /**
   * @description this will try to set the cropping area to center
   * of container but if image is not covering the center it
   * will be set to the closest corner to the center
   */
  setCroppingAreaToCenterOfContainerAndMinimize() {
    this.cropper.setCropBoxData({
      left: this.containerWidth / 2,
      top: this.containerHeight / 2,
      width: 0,
      height: 0
    });
  }
  /**
   * @description It will set the location of image based on container.
   * Will not effect in viewMode 1 if cropping area is blocking it.
   * When viewMode is on 1 it will set the location of image based on cropping area.
   * height and width dont effect
   */
  setImageToCenterOfContainer() {
    const left = this.containerWidth / 2 - this.canvasWidth / 2;
    const top = this.containerHeight / 2 - this.canvasHeight / 2;
    this.cropper.setCanvasData({
      left,
      top
    });
  }
  /**
   * @description When viewMode is on 1 and cropping area is covering the image it will be blocked
   */
  setZoomToFit() {
    if (this.isImageLandscape) {
      if (this.isImageHorizontallyOverflowed) {
        const ratio = this.containerWidth / this.canvasImageWidth;
        this.cropper.zoomTo(ratio);
      } else if (this.isImageHorizontallySmaller) {
        const ratio = this.canvasImageWidth / this.containerWidth;
        this.cropper.zoomTo(ratio);
      }
      return;
    }
    if (this.isImageVerticallyOverflowed) {
      const ratio = this.containerHeight / this.canvasImageHeight;
      this.cropper.zoomTo(ratio);
    } else if (this.isImageVerticallySmaller) {
      const ratio = this.canvasImageHeight / this.containerHeight;
      this.cropper.zoomTo(ratio);
    }
    return;
  }
  setCropAreaToImageFullSize() {
    if (!this.cropper) {
      return;
    }
    const canvasData = this.cropper.getCanvasData();
    this.cropper.setCropBoxData({
      left: canvasData.left,
      top: canvasData.top,
      width: this.canvasWidth,
      height: this.canvasHeight
    });
  }
  rotateAndFitToScreen(degree) {
    this.cropper.rotate(degree);
    this.setZoomToFit();
    this.setCroppingAreaToCenterOfContainerAndMinimize();
    this.setImageToCenterOfContainer();
    this.setZoomToFit();
    this.setCropAreaToImageFullSize();
  }
  /**
   * @description this is for situations where image rotation is needed without opening the editor
   * it will create a cropperjs instance and attach it to root element (hidden) and after rotation will return the data
   *
   * @param image image to rotate. Checks for src and if it doesnt exists uses cropperSource param
   * @param degree rotation degree
   * @param cropperSource url for the image, convert the image.id to url and pass it here
   */
  static rotate(image, degree, cropperSource = "") {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise(resolve => {
        const instaCropperWrapper = document.createElement("div");
        const instaCropper = document.createElement("img");
        instaCropper.style.display = "block";
        instaCropper.style.maxWidth = "100%";
        instaCropper.style.maxHeight = "100%";
        instaCropperWrapper.style.opacity = "0";
        instaCropperWrapper.style.zIndex = "-1000";
        instaCropperWrapper.style.pointerEvents = "none";
        instaCropperWrapper.style.position = "fixed";
        document.getElementById("root").appendChild(instaCropperWrapper);
        instaCropperWrapper.appendChild(instaCropper);
        instaCropper.src = image.src || cropperSource;
        const cropper = new Cropper(instaCropper, {
          viewMode: 1,
          scalable: false,
          ready(event) {
            const helper = new ReactCropperHelpers(cropper);
            helper.rotateAndFitToScreen(degree);
            image.src = cropper.getCroppedCanvas().toDataURL(image.type) || "";
            cropper.destroy();
            instaCropperWrapper.remove();
            resolve(image);
          }
        });
      });
    });
  }
}

//Autogenerated
class ImageInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([new Language("en", "English"), new Language("es", "Español"), new Language("nl", "Nederlands"), new Language("it", "Italiano"), new Language("nb", "Norsk bokmål"), new Language("pl", "Polski"), new Language("fr", "Français"), new Language("sv", "Svenska"), new Language("de", "Deutsch"), new Language("fi", "Suomi"), new Language("da", "Dansk"), new Language("uk", "Українська"), new Language("ru", "Русский")], "en");
    //Constants
    this.documentTypeNotSupportedLanguageItemName = `_42:0`;
    this.imageLanguageItemName = `_42:1`;
    this.documentTooBigLanguageItemName = `_42:2`;
    this.saveLanguageItemName = `_42:3`;
    this.browseLanguageItemName = `_42:4`;
    this.rotateLeftLanguageItemName = `_42:5`;
    this.rotateRightLanguageItemName = `_42:6`;
    this.deleteLanguageItemName = `_42:7`;
    this.editLanguageItemName = `_42:8`;
    this.cameraLanguageItemName = `_42:9`;
    this.backLanguageItemName = `_42:A`;
    this.previewLanguageItemName = `_42:B`;
    this.dropItLanguageItemName = `_42:C`;
    this.moveToTopLanguageItemName = `_42:D`;
    this.moveUpLanguageItemName = `_42:E`;
    this.moveDownLanguageItemName = `_42:F`;
  }
  initialize() {
    super.initialize(true);
    this.set(`_42:0`, {
      l: `en`,
      v: `Document type is not supported, choose file with type: {0}`
    }, {
      l: `uk`,
      v: `Тип документа не підтримується, виберіть файл з типом: {0}`
    }, {
      l: `sv`,
      v: `Dokumenttyp stöds inte. Välj fil med typ: {0}.`
    }, {
      l: `ru`,
      v: `Тип документа не поддерживается, выберите файл с типом: {0}`
    }, {
      l: `pl`,
      v: `Format dokumentu nieprawidłowy. Wybierz plik z typem: {0}`
    }, {
      l: `nl`,
      v: `Documenttype wordt niet ondersteund. Kies een bestand met type: {0}`
    }, {
      l: `nb`,
      v: `Dokumenttype støttes ikke. Velg fil med filtypen: {0}`
    }, {
      l: `it`,
      v: `Il tipo di documento non è supportato, scegli il file con il tipo: {0}`
    }, {
      l: `fr`,
      v: `Le type de document n'est pas pris en charge, sélectionnez le fichier avec le type: {0}`
    }, {
      l: `fi`,
      v: `Dokumentin tyyppi ei ole tuettu. Valitse tiedosto tyypin mukaan: {0}`
    }, {
      l: `es`,
      v: `El tipo de documento no es compatible; elija un archivo con el tipo: {0}`
    }, {
      l: `de`,
      v: `Der Dokumenttyp wird nicht unterstützt. Wählen Sie die Datei mit dem Typ {0} aus.`
    }, {
      l: `da`,
      v: `Dokumenttype understøttes ikke. Vælg fil med type: {0}`
    });
    this.set(`_42:1`, {
      l: `en`,
      v: `image`
    }, {
      l: `uk`,
      v: `зображення`
    }, {
      l: `sv`,
      v: `bild`
    }, {
      l: `ru`,
      v: `изображение`
    }, {
      l: `pl`,
      v: `obraz`
    }, {
      l: `nl`,
      v: `afbeelding`
    }, {
      l: `nb`,
      v: `bilde`
    }, {
      l: `it`,
      v: `Immagine`
    }, {
      l: `fr`,
      v: `image`
    }, {
      l: `fi`,
      v: `kuva`
    }, {
      l: `es`,
      v: `imagen`
    }, {
      l: `de`,
      v: `Bild`
    }, {
      l: `da`,
      v: `billede`
    });
    this.set(`_42:2`, {
      l: `en`,
      v: `Document file is too big`
    }, {
      l: `uk`,
      v: `Файл документа занадто великий`
    }, {
      l: `sv`,
      v: `Dokument filen är för stor`
    }, {
      l: `ru`,
      v: `Файл документа слишком большой`
    }, {
      l: `pl`,
      v: `Dokument jest za duży`
    }, {
      l: `nl`,
      v: `Documentbestand is te groot`
    }, {
      l: `nb`,
      v: `Dokumentfilen er for stor`
    }, {
      l: `it`,
      v: `Il file del documento è troppo grande`
    }, {
      l: `fr`,
      v: `Le fichier de document est trop volumineux`
    }, {
      l: `fi`,
      v: `Dokumentti tiedosto liian iso`
    }, {
      l: `es`,
      v: `El archivo del documento es demasiado grande`
    }, {
      l: `de`,
      v: `Die Dokumentdatei ist zu groß`
    }, {
      l: `da`,
      v: `Dokumentfilen er for stor`
    });
    this.set(`_42:3`, {
      l: `en`,
      v: `Save`
    }, {
      l: `uk`,
      v: `Зберегти`
    }, {
      l: `sv`,
      v: `Spara`
    }, {
      l: `ru`,
      v: `Сохранить`
    }, {
      l: `pl`,
      v: `Zapisać`
    }, {
      l: `nl`,
      v: `Opslaan`
    }, {
      l: `nb`,
      v: `Lagre`
    }, {
      l: `it`,
      v: `Salva`
    }, {
      l: `fr`,
      v: `Sauvegarder`
    }, {
      l: `fi`,
      v: `Tallenna`
    }, {
      l: `es`,
      v: `Ahorrar`
    }, {
      l: `de`,
      v: `Speichern`
    }, {
      l: `da`,
      v: `Gemme`
    });
    this.set(`_42:4`, {
      l: `en`,
      v: `Browse`
    }, {
      l: `uk`,
      v: `Перегляд`
    }, {
      l: `sv`,
      v: `Bläddra`
    }, {
      l: `ru`,
      v: `Просмотр`
    }, {
      l: `pl`,
      v: `Przeglądaj`
    }, {
      l: `nl`,
      v: `Blader`
    }, {
      l: `nb`,
      v: `Bla gjennom`
    }, {
      l: `it`,
      v: `Navigare`
    }, {
      l: `fr`,
      v: `Parcourir`
    }, {
      l: `fi`,
      v: `Selaa`
    }, {
      l: `es`,
      v: `Navegar`
    }, {
      l: `de`,
      v: `Durchsuche`
    }, {
      l: `da`,
      v: `Gennemse`
    });
    this.set(`_42:5`, {
      l: `en`,
      v: `Rotate left`
    }, {
      l: `uk`,
      v: `Повернути наліво`
    }, {
      l: `sv`,
      v: `Rotera vänster`
    }, {
      l: `ru`,
      v: `Повернуть налево`
    }, {
      l: `pl`,
      v: `Obrót w lewo`
    }, {
      l: `nl`,
      v: `Draai naar links`
    }, {
      l: `nb`,
      v: `Rotér mot venstre`
    }, {
      l: `it`,
      v: `Gira a sinistra`
    }, {
      l: `fr`,
      v: `Tourne à gauche`
    }, {
      l: `fi`,
      v: `Kierrä vasemmalle`
    }, {
      l: `es`,
      v: `Girar a la izquierda`
    }, {
      l: `de`,
      v: `Nach links drehen`
    }, {
      l: `da`,
      v: `Rotere venstre`
    });
    this.set(`_42:6`, {
      l: `en`,
      v: `Rotate right`
    }, {
      l: `uk`,
      v: `Повернути праворуч`
    }, {
      l: `sv`,
      v: `Vrid höger`
    }, {
      l: `ru`,
      v: `Повернуть вправо`
    }, {
      l: `pl`,
      v: `Obróć w prawo`
    }, {
      l: `nl`,
      v: `Draai naar rechts`
    }, {
      l: `nb`,
      v: `Roter til høyre`
    }, {
      l: `it`,
      v: `Ruota a destra`
    }, {
      l: `fr`,
      v: `Tourner à droite`
    }, {
      l: `fi`,
      v: `Kierrä oikealle`
    }, {
      l: `es`,
      v: `Gira a la derecha`
    }, {
      l: `de`,
      v: `Drehe nach rechts`
    }, {
      l: `da`,
      v: `Drej til højre`
    });
    this.set(`_42:7`, {
      l: `en`,
      v: `Delete`
    }, {
      l: `uk`,
      v: `Видалити`
    }, {
      l: `sv`,
      v: `Radera`
    }, {
      l: `ru`,
      v: `Удалить`
    }, {
      l: `pl`,
      v: `Kasować`
    }, {
      l: `nl`,
      v: `Verwijderen`
    }, {
      l: `nb`,
      v: `Slett`
    }, {
      l: `it`,
      v: `Eliminare`
    }, {
      l: `fr`,
      v: `Supprimer`
    }, {
      l: `fi`,
      v: `Poista`
    }, {
      l: `es`,
      v: `Borrar`
    }, {
      l: `de`,
      v: `Löschen`
    }, {
      l: `da`,
      v: `Delete`
    });
    this.set(`_42:8`, {
      l: `en`,
      v: `Edit`
    }, {
      l: `uk`,
      v: `Змінити`
    }, {
      l: `sv`,
      v: `Redigera`
    }, {
      l: `ru`,
      v: `Изменить`
    }, {
      l: `pl`,
      v: `Edytować`
    }, {
      l: `nl`,
      v: `Bewerking`
    }, {
      l: `nb`,
      v: `Redigere`
    }, {
      l: `it`,
      v: `Modificare`
    }, {
      l: `fr`,
      v: `Modifier`
    }, {
      l: `fi`,
      v: `Muokkaa`
    }, {
      l: `es`,
      v: `Editar`
    }, {
      l: `de`,
      v: `Bearbeiten`
    }, {
      l: `da`,
      v: `Redigere`
    });
    this.set(`_42:9`, {
      l: `en`,
      v: `Camera`
    }, {
      l: `uk`,
      v: `Камера`
    }, {
      l: `sv`,
      v: `Kamera`
    }, {
      l: `ru`,
      v: `Камера`
    }, {
      l: `pl`,
      v: `Kamera`
    }, {
      l: `nl`,
      v: `Camera`
    }, {
      l: `nb`,
      v: `Kamera`
    }, {
      l: `it`,
      v: `Telecamera`
    }, {
      l: `fr`,
      v: `Caméra`
    }, {
      l: `fi`,
      v: `Kamera`
    }, {
      l: `es`,
      v: `Cámara`
    }, {
      l: `de`,
      v: `Kamera`
    }, {
      l: `da`,
      v: `Kamera`
    });
    this.set(`_42:A`, {
      l: `en`,
      v: `Back`
    }, {
      l: `uk`,
      v: `Назад`
    }, {
      l: `sv`,
      v: `Tillbaka`
    }, {
      l: `ru`,
      v: `Назад`
    }, {
      l: `pl`,
      v: `Plecy`
    }, {
      l: `nl`,
      v: `Rug`
    }, {
      l: `nb`,
      v: `Tilbake`
    }, {
      l: `it`,
      v: `Indietro`
    }, {
      l: `fr`,
      v: `Dos`
    }, {
      l: `fi`,
      v: `Takaisin`
    }, {
      l: `es`,
      v: `Atrás`
    }, {
      l: `de`,
      v: `Zurück`
    }, {
      l: `da`,
      v: `Tilbage`
    });
    this.set(`_42:B`, {
      l: `en`,
      v: `Preview`
    }, {
      l: `uk`,
      v: `Переглянути`
    }, {
      l: `sv`,
      v: `Förhandsvisning`
    }, {
      l: `ru`,
      v: `Предпросмотр`
    }, {
      l: `pl`,
      v: `Zapowiedź`
    }, {
      l: `nl`,
      v: `Voorbeeld`
    }, {
      l: `nb`,
      v: `Forhåndsvisning`
    }, {
      l: `it`,
      v: `Anteprima`
    }, {
      l: `fr`,
      v: `Aperçu`
    }, {
      l: `fi`,
      v: `Esikatsele`
    }, {
      l: `es`,
      v: `Avance`
    }, {
      l: `de`,
      v: `Vorschau`
    }, {
      l: `da`,
      v: `Preview`
    });
    this.set(`_42:C`, {
      l: `en`,
      v: `Drop it`
    }, {
      l: `uk`,
      v: `Перетягніть сюди`
    }, {
      l: `sv`,
      v: `Släppa`
    }, {
      l: `ru`,
      v: `Перетащите сюда`
    }, {
      l: `pl`,
      v: `Upuszczać`
    }, {
      l: `nl`,
      v: `Laat vallen`
    }, {
      l: `nb`,
      v: `Miste`
    }, {
      l: `it`,
      v: `Lascialo perdere`
    }, {
      l: `fr`,
      v: `Laisse tomber`
    }, {
      l: `fi`,
      v: `Pudota`
    }, {
      l: `es`,
      v: `Déjalo caer`
    }, {
      l: `de`,
      v: `Lass es fallen`
    }, {
      l: `da`,
      v: `Dråbe`
    });
    this.set(`_42:D`, {
      l: `en`,
      v: `Move to top`
    }, {
      l: `uk`,
      v: `На початок`
    }, {
      l: `sv`,
      v: `Flytta upp`
    }, {
      l: `ru`,
      v: `В начало`
    }, {
      l: `pl`,
      v: `Podnieść`
    }, {
      l: `nl`,
      v: `Ga naar boven`
    }, {
      l: `nb`,
      v: `Flytte opp`
    }, {
      l: `it`,
      v: `Sposta in alto`
    }, {
      l: `fr`,
      v: `Déplacer vers le haut`
    }, {
      l: `fi`,
      v: `Siirrä huipulle`
    }, {
      l: `es`,
      v: `Mover hacia arriba`
    }, {
      l: `de`,
      v: `Nach oben verschieben`
    }, {
      l: `da`,
      v: `Flytte op`
    });
    this.set(`_42:E`, {
      l: `en`,
      v: `Move up`
    }, {
      l: `uk`,
      v: `Піднятися`
    }, {
      l: `sv`,
      v: `Flytta till toppen`
    }, {
      l: `ru`,
      v: `Подняться`
    }, {
      l: `pl`,
      v: `Przejdź do góry`
    }, {
      l: `nl`,
      v: `Ga omhoog`
    }, {
      l: `nb`,
      v: `Flytt til toppen`
    }, {
      l: `it`,
      v: `Andare avanti`
    }, {
      l: `fr`,
      v: `Déplacer vers le haut`
    }, {
      l: `fi`,
      v: `Siirrä ylös`
    }, {
      l: `es`,
      v: `Ascender`
    }, {
      l: `de`,
      v: `Bewegen Sie sich nach oben`
    }, {
      l: `da`,
      v: `Flyt til toppen`
    });
    this.set(`_42:F`, {
      l: `en`,
      v: `Move below`
    }, {
      l: `uk`,
      v: `Опуститись нижче`
    }, {
      l: `sv`,
      v: `Flytta ner`
    }, {
      l: `ru`,
      v: `Опуститься ниже`
    }, {
      l: `pl`,
      v: `Padnij`
    }, {
      l: `nl`,
      v: `Ga naar beneden`
    }, {
      l: `nb`,
      v: `Flytte ned`
    }, {
      l: `it`,
      v: `Spostati sotto`
    }, {
      l: `fr`,
      v: `Se déplacer ci-dessous`
    }, {
      l: `fi`,
      v: `Siirrä alas`
    }, {
      l: `es`,
      v: `Mover abajo`
    }, {
      l: `de`,
      v: `Bewegen Sie sich nach unten`
    }, {
      l: `da`,
      v: `Flyt ned`
    });
  }
  /**
  /* "DocumentTypeNotSupported" (Document type is not supported, choose file with type: {0})
  /* "Localizer.documentTypeNotSupported"
  /* "Localizer.documentTypeNotSupportedLanguageItemName"
  */
  get documentTypeNotSupported() {
    return this.get(`_42:0`);
  }
  /**
  /* "Image" (image)
  /* "Localizer.image"
  /* "Localizer.imageLanguageItemName"
  */
  get image() {
    return this.get(`_42:1`);
  }
  /**
  /* "DocumentTooBig" (Document file is too big)
  /* "Localizer.documentTooBig"
  /* "Localizer.documentTooBigLanguageItemName"
  */
  get documentTooBig() {
    return this.get(`_42:2`);
  }
  /**
  /* "Save" (Save)
  /* "Localizer.save"
  /* "Localizer.saveLanguageItemName"
  */
  get save() {
    return this.get(`_42:3`);
  }
  /**
  /* "Browse" (Browse)
  /* "Localizer.browse"
  /* "Localizer.browseLanguageItemName"
  */
  get browse() {
    return this.get(`_42:4`);
  }
  /**
  /* "RotateLeft" (Rotate left)
  /* "Localizer.rotateLeft"
  /* "Localizer.rotateLeftLanguageItemName"
  */
  get rotateLeft() {
    return this.get(`_42:5`);
  }
  /**
  /* "RotateRight" (Rotate right)
  /* "Localizer.rotateRight"
  /* "Localizer.rotateRightLanguageItemName"
  */
  get rotateRight() {
    return this.get(`_42:6`);
  }
  /**
  /* "Delete" (Delete)
  /* "Localizer.delete"
  /* "Localizer.deleteLanguageItemName"
  */
  get delete() {
    return this.get(`_42:7`);
  }
  /**
  /* "Edit" (Edit)
  /* "Localizer.edit"
  /* "Localizer.editLanguageItemName"
  */
  get edit() {
    return this.get(`_42:8`);
  }
  /**
  /* "Camera" (Camera)
  /* "Localizer.camera"
  /* "Localizer.cameraLanguageItemName"
  */
  get camera() {
    return this.get(`_42:9`);
  }
  /**
  /* "Back" (Back)
  /* "Localizer.back"
  /* "Localizer.backLanguageItemName"
  */
  get back() {
    return this.get(`_42:A`);
  }
  /**
  /* "Preview" (Preview)
  /* "Localizer.preview"
  /* "Localizer.previewLanguageItemName"
  */
  get preview() {
    return this.get(`_42:B`);
  }
  /**
  /* "DropIt" (Drop it)
  /* "Localizer.dropIt"
  /* "Localizer.dropItLanguageItemName"
  */
  get dropIt() {
    return this.get(`_42:C`);
  }
  /**
  /* "MoveToTop" (Move to top)
  /* "Localizer.moveToTop"
  /* "Localizer.moveToTopLanguageItemName"
  */
  get moveToTop() {
    return this.get(`_42:D`);
  }
  /**
  /* "MoveUp" (Move up)
  /* "Localizer.moveUp"
  /* "Localizer.moveUpLanguageItemName"
  */
  get moveUp() {
    return this.get(`_42:E`);
  }
  /**
  /* "MoveDown" (Move below)
  /* "Localizer.moveDown"
  /* "Localizer.moveDownLanguageItemName"
  */
  get moveDown() {
    return this.get(`_42:F`);
  }
}
//Singleton
var ImageInputLocalizer$1 = new ImageInputLocalizer();

var css_248z$2 = "/*!\n * Cropper.js v1.6.2\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2024-04-21T07:43:02.731Z\n */\n\n.cropper-container {\n  direction: ltr;\n  font-size: 0;\n  line-height: 0;\n  position: relative;\n  -ms-touch-action: none;\n      touch-action: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.cropper-container img {\n    backface-visibility: hidden;\n    display: block;\n    height: 100%;\n    image-orientation: 0deg;\n    max-height: none !important;\n    max-width: none !important;\n    min-height: 0 !important;\n    min-width: 0 !important;\n    width: 100%;\n  }\n\n.cropper-wrap-box,\n.cropper-canvas,\n.cropper-drag-box,\n.cropper-crop-box,\n.cropper-modal {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.cropper-wrap-box,\n.cropper-canvas {\n  overflow: hidden;\n}\n\n.cropper-drag-box {\n  background-color: #fff;\n  opacity: 0;\n}\n\n.cropper-modal {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.cropper-view-box {\n  display: block;\n  height: 100%;\n  outline: 1px solid #39f;\n  outline-color: rgba(51, 153, 255, 0.75);\n  overflow: hidden;\n  width: 100%;\n}\n\n.cropper-dashed {\n  border: 0 dashed #eee;\n  display: block;\n  opacity: 0.5;\n  position: absolute;\n}\n\n.cropper-dashed.dashed-h {\n    border-bottom-width: 1px;\n    border-top-width: 1px;\n    height: calc(100% / 3);\n    left: 0;\n    top: calc(100% / 3);\n    width: 100%;\n  }\n\n.cropper-dashed.dashed-v {\n    border-left-width: 1px;\n    border-right-width: 1px;\n    height: 100%;\n    left: calc(100% / 3);\n    top: 0;\n    width: calc(100% / 3);\n  }\n\n.cropper-center {\n  display: block;\n  height: 0;\n  left: 50%;\n  opacity: 0.75;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n\n.cropper-center::before,\n  .cropper-center::after {\n    background-color: #eee;\n    content: ' ';\n    display: block;\n    position: absolute;\n  }\n\n.cropper-center::before {\n    height: 1px;\n    left: -3px;\n    top: 0;\n    width: 7px;\n  }\n\n.cropper-center::after {\n    height: 7px;\n    left: 0;\n    top: -3px;\n    width: 1px;\n  }\n\n.cropper-face,\n.cropper-line,\n.cropper-point {\n  display: block;\n  height: 100%;\n  opacity: 0.1;\n  position: absolute;\n  width: 100%;\n}\n\n.cropper-face {\n  background-color: #fff;\n  left: 0;\n  top: 0;\n}\n\n.cropper-line {\n  background-color: #39f;\n}\n\n.cropper-line.line-e {\n    cursor: ew-resize;\n    right: -3px;\n    top: 0;\n    width: 5px;\n  }\n\n.cropper-line.line-n {\n    cursor: ns-resize;\n    height: 5px;\n    left: 0;\n    top: -3px;\n  }\n\n.cropper-line.line-w {\n    cursor: ew-resize;\n    left: -3px;\n    top: 0;\n    width: 5px;\n  }\n\n.cropper-line.line-s {\n    bottom: -3px;\n    cursor: ns-resize;\n    height: 5px;\n    left: 0;\n  }\n\n.cropper-point {\n  background-color: #39f;\n  height: 5px;\n  opacity: 0.75;\n  width: 5px;\n}\n\n.cropper-point.point-e {\n    cursor: ew-resize;\n    margin-top: -3px;\n    right: -3px;\n    top: 50%;\n  }\n\n.cropper-point.point-n {\n    cursor: ns-resize;\n    left: 50%;\n    margin-left: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-w {\n    cursor: ew-resize;\n    left: -3px;\n    margin-top: -3px;\n    top: 50%;\n  }\n\n.cropper-point.point-s {\n    bottom: -3px;\n    cursor: s-resize;\n    left: 50%;\n    margin-left: -3px;\n  }\n\n.cropper-point.point-ne {\n    cursor: nesw-resize;\n    right: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-nw {\n    cursor: nwse-resize;\n    left: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-sw {\n    bottom: -3px;\n    cursor: nesw-resize;\n    left: -3px;\n  }\n\n.cropper-point.point-se {\n    bottom: -3px;\n    cursor: nwse-resize;\n    height: 20px;\n    opacity: 1;\n    right: -3px;\n    width: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.cropper-point.point-se {\n      height: 15px;\n      width: 15px;\n  }\n    }\n\n@media (min-width: 992px) {\n\n.cropper-point.point-se {\n      height: 10px;\n      width: 10px;\n  }\n    }\n\n@media (min-width: 1200px) {\n\n.cropper-point.point-se {\n      height: 5px;\n      opacity: 0.75;\n      width: 5px;\n  }\n    }\n\n.cropper-point.point-se::before {\n    background-color: #39f;\n    bottom: -50%;\n    content: ' ';\n    display: block;\n    height: 200%;\n    opacity: 0;\n    position: absolute;\n    right: -50%;\n    width: 200%;\n  }\n\n.cropper-invisible {\n  opacity: 0;\n}\n\n.cropper-bg {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');\n}\n\n.cropper-hide {\n  display: block;\n  height: 0;\n  position: absolute;\n  width: 0;\n}\n\n.cropper-hidden {\n  display: none !important;\n}\n\n.cropper-move {\n  cursor: move;\n}\n\n.cropper-crop {\n  cursor: crosshair;\n}\n\n.cropper-disabled .cropper-drag-box,\n.cropper-disabled .cropper-face,\n.cropper-disabled .cropper-line,\n.cropper-disabled .cropper-point {\n  cursor: not-allowed;\n}\n";
styleInject(css_248z$2);

var css_248z$1 = ".cropper-point {\n  width: 10px !important;\n  height: 10px !important;\n  background: white;\n}";
styleInject(css_248z$1);

var css_248z = ".athenaeum-image-input-ImageInput {\n  position: relative;\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 0.5rem;\n  gap: 0.5rem;\n  height: 400px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-fileInput {\n  display: none;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel .athenaeum-image-input-controlPanelMiniButtonWrap {\n  flex: 1;\n  min-width: 120px;\n  max-width: 150px;\n  display: flex;\n  justify-content: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel .athenaeum-image-input-controlPanelMiniButtonWrap button:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  flex: 1;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel .athenaeum-image-input-controlPanelMiniButtonWrap button:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  flex: 1;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel .athenaeum-image-input-controlPanelButton {\n  flex: 1;\n  min-width: 120px;\n  max-width: 150px;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel {\n  flex-grow: 1;\n  display: flex;\n  overflow: hidden;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea {\n  transition: 0.4s all;\n  opacity: 0;\n  pointer-events: none;\n  border: 2px dashed black;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.9);\n  z-index: 100;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea .athenaeum-image-input-dragDropAreaStaticText {\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea .athenaeum-image-input-dragDropAreaOverlay {\n  background: rgba(0, 0, 0, 0.1);\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropAreaActive {\n  opacity: 1;\n  pointer-events: fill;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-cropper {\n  flex-grow: 1;\n  overflow: hidden;\n  position: relative;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-cropper .athenaeum-image-input-reactCropper .athenaeum-image-input-cropper-container .athenaeum-image-input-cropper-crop-box .athenaeum-image-input-cropper-point {\n  width: 10px !important;\n  height: 10px !important;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-thumbnails {\n  position: absolute;\n  left: 2px;\n  bottom: 2px;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-thumbnails .athenaeum-image-input-thumbnail {\n  display: flex;\n  border: solid 2px rgba(0, 0, 0, 0.6);\n  border-radius: 4px;\n  overflow: hidden;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-thumbnails .athenaeum-image-input-thumbnail:not(:last-child) {\n  margin-bottom: 2px;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-thumbnails .athenaeum-image-input-thumbnail > img {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView {\n  flex-grow: 1;\n  overflow-y: auto;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewItem {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0 0.5rem;\n  margin: 0.5rem;\n  border: 1px solid transparent;\n  overflow-wrap: anywhere;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewItem:hover {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewItem .athenaeum-image-input-listViewItemThumbnail {\n  width: 100px;\n  height: 100px;\n  min-width: 100px;\n  min-height: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewItem .athenaeum-image-input-listViewItemThumbnail img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-activeListViewItem {\n  border: 1px solid rgba(0, 0, 0, 0.3) !important;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-preview {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-preview > img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.athenaeum-image-input-ImageInput.athenaeum-image-input-fullScreen {\n  background-color: darkgray;\n  z-index: 999;\n  position: fixed;\n  top: 45px;\n  left: 0;\n  margin: 0;\n  padding: 0 0 0.5rem 0;\n  width: 100%;\n  height: calc(100% - 45px);\n}\n.athenaeum-image-input-ImageInput.athenaeum-image-input-fullScreen .athenaeum-image-input-viewPanel .athenaeum-image-input-cropper .athenaeum-image-input-reactCropper .athenaeum-image-input-cropper-container {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.athenaeum-image-input-fillAbsolute, .athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea, .athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea .athenaeum-image-input-dragDropAreaStaticText, .athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea .athenaeum-image-input-dragDropAreaOverlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.athenaeum-image-input-minimize {\n  height: 200px;\n}";
var styles = {"ImageInput":"athenaeum-image-input-ImageInput","fileInput":"athenaeum-image-input-fileInput","controlPanel":"athenaeum-image-input-controlPanel","controlPanelMiniButtonWrap":"athenaeum-image-input-controlPanelMiniButtonWrap","controlPanelButton":"athenaeum-image-input-controlPanelButton","viewPanel":"athenaeum-image-input-viewPanel","dragDropArea":"athenaeum-image-input-dragDropArea","dragDropAreaStaticText":"athenaeum-image-input-dragDropAreaStaticText","dragDropAreaOverlay":"athenaeum-image-input-dragDropAreaOverlay","dragDropAreaActive":"athenaeum-image-input-dragDropAreaActive","cropper":"athenaeum-image-input-cropper","reactCropper":"athenaeum-image-input-reactCropper","cropper-container":"athenaeum-image-input-cropper-container","cropper-crop-box":"athenaeum-image-input-cropper-crop-box","cropper-point":"athenaeum-image-input-cropper-point","thumbnails":"athenaeum-image-input-thumbnails","thumbnail":"athenaeum-image-input-thumbnail","listView":"athenaeum-image-input-listView","listViewItem":"athenaeum-image-input-listViewItem","listViewItemThumbnail":"athenaeum-image-input-listViewItemThumbnail","activeListViewItem":"athenaeum-image-input-activeListViewItem","preview":"athenaeum-image-input-preview","fullScreen":"athenaeum-image-input-fullScreen","fillAbsolute":"athenaeum-image-input-fillAbsolute","minimize":"athenaeum-image-input-minimize"};
styleInject(css_248z);

var ImageInputView;
(function (ImageInputView) {
  /**
   * If no uploaded files, display nothing.
   * If single-input and uploaded picture, display small preview of the picture.
   * If multi-input and uploaded picture(s), display list of pictures.
   */
  ImageInputView[ImageInputView["Default"] = 0] = "Default";
  /**
   * Display full-screen preview of the selected picture.
   */
  ImageInputView[ImageInputView["Preview"] = 1] = "Preview";
  /**
   * Display full-screen editor of the selected picture.
   */
  ImageInputView[ImageInputView["Edit"] = 2] = "Edit";
})(ImageInputView || (ImageInputView = {}));
class ImageInput extends BaseComponent {
  constructor() {
    super(...arguments);
    this._fileInputRef = React.createRef();
    this._cameraFileInputRef = React.createRef();
    this._cropperRef = React.createRef();
    this._cropperHelper = new ReactCropperHelpers(this._cropperRef);
    this.state = {
      currentView: ImageInputView.Default,
      isDragOver: false,
      previousView: ImageInputView.Default,
      selectedPictureIndex: null,
      pictures: [],
      thumbnailSrc: null
    };
  }
  //  Getters
  get hasSelectedPictureIndex() {
    return this.state.selectedPictureIndex != null;
  }
  get selectedPictureIndex() {
    return this.state.selectedPictureIndex;
  }
  get currentView() {
    return this.state.currentView;
  }
  get previousView() {
    return this.state.previousView;
  }
  get isDragOver() {
    return this.state.isDragOver;
  }
  get editOnAddInSingleMode() {
    return this.props.editOnAddInSingleMode == true;
  }
  get isFullscreen() {
    return this.currentView == ImageInputView.Preview || this.currentView == ImageInputView.Edit;
  }
  get minimizeOnEmpty() {
    return this.props.minimizeOnEmpty == true;
  }
  get multi() {
    return this.props.multi == true;
  }
  get pictures() {
    return this.state.pictures;
  }
  get activePicture() {
    return this.hasSelectedPictureIndex ? this.pictures[this.selectedPictureIndex] : null;
  }
  get cropperSource() {
    if (!this.hasSelectedPictureIndex || !this.activePicture) {
      return "";
    }
    if (this.activePicture.id) {
      if (this.props.imageUrl) {
        return this.props.imageUrl(this.activePicture);
      }
      return this.getImageUrl(this.activePicture);
    }
    return this.activePicture.src;
  }
  getImageUrl(image) {
    return this.props.imageUrl ? this.props.imageUrl(image) : ImageProvider.getImageUrl(image);
  }
  getPreviewName(index) {
    const picture = this.pictures[index];
    if (!picture) {
      return "";
    }
    return picture.name;
  }
  getPreviewSource(index) {
    const picture = this.pictures[index];
    if (!picture) {
      return "";
    }
    if (picture.id) {
      if (this.props.imageUrl) {
        return this.props.imageUrl(picture);
      }
      return this.getImageUrl(picture);
    }
    return picture.src;
  }
  get maxImageRequestSizeInBytes() {
    return this.props.maxImageRequestSizeInBytes || AthenaeumComponentsConstants.maxImageRequestSizeInBytes;
  }
  get acceptedTypes() {
    return this.props.fileTypes != null && this.props.fileTypes.length > 0 ? this.props.fileTypes.join(",") : "image/*";
  }
  //  ViewIfStatements
  get toolbar() {
    var _a, _b, _c, _d;
    switch (this.currentView) {
      case ImageInputView.Default:
        return this.hasSelectedPictureIndex ? (_a = this.props.selectionToolbar) !== null && _a !== void 0 ? _a : ImageInput.defaultSelectionToolbar : (_b = this.props.noSelectionToolbar) !== null && _b !== void 0 ? _b : ImageInput.defaultNoSelectionToolbar;
      case ImageInputView.Preview:
        return (_c = this.props.previewToolbar) !== null && _c !== void 0 ? _c : ImageInput.defaultPreviewToolbar;
      case ImageInputView.Edit:
        return (_d = this.props.editToolbar) !== null && _d !== void 0 ? _d : ImageInput.defaultEditToolbar;
      default:
        throw new TypeError(`Non-existing enum value '${this.currentView}'`);
    }
  }
  get showBackButton() {
    return this.isFullscreen;
  }
  get showSaveButton() {
    return this.currentView == ImageInputView.Edit;
  }
  get miniRotateButtons() {
    // TODO: get from props?
    return this.hasSelectedPictureIndex && this.currentView == ImageInputView.Default;
  }
  //  Control panel button Click Events
  onBrowseButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._fileInputRef) {
        return;
      }
      const ref = this._fileInputRef;
      if (!ref.current) {
        return;
      }
      ref.current.click();
    });
  }
  onCameraButtonClick() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._cameraFileInputRef) {
        return;
      }
      const ref = this._cameraFileInputRef;
      if (!ref.current) {
        return;
      }
      ref.current.click();
    });
  }
  onSaveButtonClickAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._cropperRef.current || this.currentView !== ImageInputView.Edit) {
        return;
      }
      if (!this.hasSelectedPictureIndex || !this.activePicture) {
        return;
      }
      let newFileModel = Object.assign({}, this.activePicture);
      newFileModel.src = ((_a = this._cropperRef.current) === null || _a === void 0 ? void 0 : _a.cropper.getCroppedCanvas().toDataURL()) || "";
      if (this.props.convertImage) {
        newFileModel = yield this.props.convertImage(newFileModel);
        if (newFileModel == null) {
          yield ch.alertErrorAsync(ImageInputLocalizer$1.documentTypeNotSupported, true);
          return;
        }
      }
      yield this.updatePictureAsync(newFileModel, this.selectedPictureIndex);
      yield this.setCurrentViewAsync(this.previousView);
    });
  }
  onEditButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex) {
        return;
      }
      yield this.setCurrentViewAsync(ImageInputView.Edit);
    });
  }
  onBackButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const newView = this.currentView == ImageInputView.Edit ? this.previousView : ImageInputView.Default;
      yield this.setCurrentViewAsync(newView);
    });
  }
  onPreviewButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex) {
        return;
      }
      yield this.setCurrentViewAsync(ImageInputView.Preview);
    });
  }
  onDeleteButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex) {
        return;
      }
      yield this.removePictureAsync(this.selectedPictureIndex);
    });
  }
  onRotateButtonClickAsync(degrees) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._cropperRef.current) {
        return;
      }
      this._cropperHelper.rotateAndFitToScreen(degrees);
    });
  }
  onRotateMiniButtonClickAsync(degrees) {
    return __awaiter(this, void 0, void 0, function* () {
      const selectedPicture = this.pictures[this.selectedPictureIndex];
      let rotated = yield ReactCropperHelpers.rotate(selectedPicture, degrees, this.getPreviewSource(this.selectedPictureIndex));
      if (this.props.convertImage) {
        rotated = yield this.props.convertImage(rotated);
        if (rotated == null) {
          yield ch.alertErrorAsync(ImageInputLocalizer$1.documentTypeNotSupported, true);
          return;
        }
      }
      yield this.updatePictureAsync(rotated, this.selectedPictureIndex);
    });
  }
  onMoveToTopButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex || this.selectedPictureIndex <= 0) {
        return;
      }
      yield this.moveSelectedImageToTopAsync();
    });
  }
  onMoveUpButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex || this.selectedPictureIndex <= 0) {
        return;
      }
      yield this.moveSelectedImageUpDownAsync(true);
    });
  }
  onMoveDownButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex || this.selectedPictureIndex >= this.pictures.length) {
        return;
      }
      yield this.moveSelectedImageUpDownAsync(false);
    });
  }
  onListViewItemClick(index) {
    const selectedPictureIndex = this.hasSelectedPictureIndex && this.selectedPictureIndex == index ? null : index;
    this.setState({
      selectedPictureIndex
    });
  }
  //  DragAndDrop Functionality Events
  onImageInputDragEnterAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (!this.isDragOver) {
        yield this.setState({
          isDragOver: true
        });
      }
    });
  }
  onDropDownAreaDragEnterAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (!this.isDragOver) {
        yield this.setState({
          isDragOver: true
        });
      }
    });
  }
  onDropDownAreaDragOverAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
    });
  }
  onDropDownAreaDragLeaveAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (this.isDragOver) {
        yield this.setState({
          isDragOver: false
        });
      }
    });
  }
  onDropDownAreaDropAsync(event) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      event.persist();
      if (this.isDragOver) {
        yield this.setState({
          isDragOver: false
        });
      }
      if (!((_a = event === null || event === void 0 ? void 0 : event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files)) {
        return;
      }
      yield this.addFileListAsync(event.dataTransfer.files);
    });
  }
  onFileInputChangeAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (!event.target.files) {
        return;
      }
      yield this.addFileListAsync(event.target.files);
    });
  }
  initializePicturesAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let pictures;
      let selectedPictureIndex;
      const input = this.props.pictures;
      if (Array.isArray(input) && input.length > 0) {
        pictures = input;
        selectedPictureIndex = typeof this.selectedPictureIndex === "number" ? this.selectedPictureIndex : 0;
      } else if (typeof input === "string") {
        pictures = [new FileModel(input)];
        selectedPictureIndex = 0;
      } else if (FileModel.is(input)) {
        pictures = [input];
        selectedPictureIndex = 0;
      } else {
        pictures = [];
        selectedPictureIndex = null;
      }
      yield this.setState({
        pictures,
        selectedPictureIndex
      });
    });
  }
  //  Logic
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newPictures = !Comparator.isEqual(this.props.pictures, nextProps.pictures);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newPictures) {
        yield this.initializePicturesAsync();
      }
    });
  }
  onGlobalKeydown(event) {
    return __awaiter(this, void 0, void 0, function* () {
      const isEsc = event.key == "Escape";
      if (isEsc && (this.currentView == ImageInputView.Edit || this.currentView == ImageInputView.Preview)) {
        yield this.onBackButtonClickAsync();
      }
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializePicturesAsync();
    });
  }
  setCurrentViewAsync(currentView) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.currentView != currentView) {
        yield this.setState({
          previousView: this.currentView,
          currentView,
          thumbnailSrc: null
        });
      }
    });
  }
  addFileListAsync(fileList) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      let fileListAsArray = Array.from(fileList);
      if (fileListAsArray.length == 0) {
        return;
      }
      if (!this.multi && fileListAsArray.length > 1) {
        fileListAsArray = [fileListAsArray[0]];
      }
      let fileModels = yield Promise.all(fileListAsArray.map(file => __awaiter(this, void 0, void 0, function* () {
        return yield ImageInput.fileToFileModel(file);
      })));
      fileModels = fileModels.filter(fileModel => {
        if (fileModel.size < this.maxImageRequestSizeInBytes) {
          return true;
        }
        ch.alertErrorAsync(ImageInputLocalizer$1.documentTooBig, true);
        return false;
      });
      const fileTypes = (_a = this.props.fileTypes) !== null && _a !== void 0 ? _a : [];
      const acceptedTypes = this.acceptedTypes;
      fileModels = fileModels.filter(fileModel => {
        if (FileModel.hasType(fileModel, acceptedTypes)) {
          return true;
        }
        const expectedType = fileTypes.length > 0 ? fileTypes.join(", ") : ImageInputLocalizer$1.image;
        ch.alertErrorAsync(ImageInputLocalizer$1.documentTypeNotSupported.format(expectedType), true);
        return false;
      });
      fileModels = yield Promise.all(fileModels.map(fileModel => __awaiter(this, void 0, void 0, function* () {
        if (!this.props.convertImage) {
          return fileModel;
        }
        const converted = yield this.props.convertImage(fileModel);
        if (converted == null) {
          yield ch.alertErrorAsync(ImageInputLocalizer$1.documentTypeNotSupported, true);
          return fileModel;
        }
        return converted;
      })));
      yield this.addPicturesAsync(fileModels);
    });
  }
  addPicturesAsync(fileModels) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (fileModels.length == 0) {
        return;
      }
      if (this.props.onChange) {
        if (this.multi) {
          yield this.props.onChange(this, [...this.state.pictures, ...fileModels]);
          yield this.setState({
            selectedPictureIndex: (_a = this.selectedPictureIndex) !== null && _a !== void 0 ? _a : 0
          });
          yield this.setCurrentViewAsync(ImageInputView.Default);
        } else {
          yield this.props.onChange(this, fileModels.slice(0, 1));
          yield this.setState({
            selectedPictureIndex: 0
          });
          const selectedView = this.editOnAddInSingleMode ? ImageInputView.Edit : ImageInputView.Default;
          yield this.setCurrentViewAsync(selectedView);
        }
      }
    });
  }
  updatePictureAsync(fileModel, index) {
    return __awaiter(this, void 0, void 0, function* () {
      const pictures = this.pictures.map((picture, i) => {
        if (index == i) {
          return fileModel;
        }
        return picture;
      });
      if (this.props.onChange) {
        yield this.props.onChange(this, pictures);
      }
    });
  }
  moveSelectedImageToTopAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex || this.selectedPictureIndex == 0) {
        return;
      }
      const oldImage = this.pictures[this.selectedPictureIndex];
      const imagesAfter = this.pictures.slice();
      imagesAfter.remove(oldImage);
      yield this.setState({
        pictures: [oldImage, ...imagesAfter],
        selectedPictureIndex: 0
      });
      if (this.props.onChange) {
        yield this.props.onChange(this, this.pictures);
      }
    });
  }
  moveSelectedImageUpDownAsync(up) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex || up && this.selectedPictureIndex == 0 || !up && this.selectedPictureIndex == this.pictures.length - 1) {
        return;
      }
      const oldIndex = this.selectedPictureIndex;
      const oldImage = this.pictures[oldIndex];
      let newIndex = up ? oldIndex - 1 : oldIndex + 1;
      this.pictures[oldIndex] = this.pictures[newIndex];
      this.pictures[newIndex] = oldImage;
      if (this.props.onChange) {
        yield this.props.onChange(this, this.pictures);
      }
      yield this.setState({
        selectedPictureIndex: newIndex
      });
    });
  }
  removePictureAsync(index) {
    return __awaiter(this, void 0, void 0, function* () {
      const pictures = [...this.pictures];
      pictures.splice(index, 1);
      const newIndex = pictures.length <= 0 ? null : index <= 0 ? 0 : index - 1;
      yield this.setState({
        selectedPictureIndex: newIndex
      });
      yield this.setCurrentViewAsync(ImageInputView.Default);
      if (this.props.onChange) {
        yield this.props.onChange(this, pictures);
      }
    });
  }
  //  Renders
  renderControlPanel() {
    return React.createElement(React.Fragment, null, (this.toolbar.rotateLeftButton || this.toolbar.rotateRightButton) && (this.miniRotateButtons ? React.createElement("div", {
      className: styles.controlPanelMiniButtonWrap
    }, this.toolbar.rotateLeftButton && React.createElement(Button, {
      small: true,
      icon: {
        name: "undo"
      },
      type: ButtonType.Info,
      onClick: () => this.onRotateMiniButtonClickAsync(-90)
    }), this.toolbar.rotateRightButton && React.createElement(Button, {
      small: true,
      icon: {
        name: "redo"
      },
      type: ButtonType.Info,
      onClick: () => this.onRotateMiniButtonClickAsync(90)
    })) : React.createElement(React.Fragment, null, this.toolbar.rotateLeftButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "undo"
      },
      type: ButtonType.Light,
      label: ImageInputLocalizer$1.rotateLeft,
      onClick: () => this.onRotateButtonClickAsync(-90)
    }), this.toolbar.rotateRightButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "redo"
      },
      type: ButtonType.Light,
      label: ImageInputLocalizer$1.rotateRight,
      onClick: () => this.onRotateButtonClickAsync(90)
    }))), this.toolbar.moveToTopButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "level-up"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.moveToTop,
      onClick: () => this.onMoveToTopButtonClickAsync()
    }), this.toolbar.moveUpButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "arrow-up"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.moveUp,
      onClick: () => this.onMoveUpButtonClickAsync()
    }), this.toolbar.moveDownButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "arrow-down"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.moveDown,
      onClick: () => this.onMoveDownButtonClickAsync()
    }), this.toolbar.editButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "crop"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.edit,
      onClick: () => this.onEditButtonClickAsync()
    }), this.toolbar.previewButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "eye"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.preview,
      onClick: () => this.onPreviewButtonClickAsync()
    }), this.toolbar.uploadButton && React.createElement(Button, {
      small: true,
      right: true,
      className: styles.controlPanelButton,
      icon: {
        name: "file-import"
      },
      type: ButtonType.Orange,
      label: ImageInputLocalizer$1.browse,
      onClick: () => this.onBrowseButtonClickAsync()
    }), this.toolbar.takePictureButton && React.createElement(Button, {
      small: true,
      right: true,
      className: styles.controlPanelButton,
      icon: {
        name: "camera"
      },
      type: ButtonType.Orange,
      label: ImageInputLocalizer$1.camera,
      onClick: () => this.onCameraButtonClick()
    }), this.showSaveButton && React.createElement(Button, {
      small: true,
      right: true,
      className: styles.controlPanelButton,
      icon: {
        name: "save"
      },
      type: ButtonType.Success,
      label: ImageInputLocalizer$1.save,
      onClick: () => this.onSaveButtonClickAsync()
    }), this.showBackButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "arrow-left"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.back,
      onClick: () => this.onBackButtonClickAsync()
    }), this.toolbar.deleteButton && React.createElement(Button, {
      small: true,
      className: styles.controlPanelButton,
      icon: {
        name: "trash"
      },
      type: ButtonType.Warning,
      label: ImageInputLocalizer$1.delete,
      onClick: () => this.onDeleteButtonClickAsync()
    }));
  }
  renderListViewItem(fileModel, index) {
    const activeListViewItemStyle = this.hasSelectedPictureIndex && this.selectedPictureIndex == index && styles.activeListViewItem;
    const key = `${index}_${fileModel.id}_${fileModel.name}`;
    return React.createElement("div", {
      key: key,
      className: this.css(styles.listViewItem, activeListViewItemStyle),
      onClick: () => this.onListViewItemClick(index)
    }, React.createElement("div", {
      className: styles.listViewItemThumbnail
    }, React.createElement("img", {
      src: this.getPreviewSource(index),
      alt: this.getPreviewName(index)
    })), this.getPreviewName(index));
  }
  renderListView() {
    return React.createElement("div", {
      className: styles.listView
    }, this.pictures.map((picture, index) => this.renderListViewItem(picture, index)));
  }
  onCropEndAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      const thumbnailSrc = ((_a = this._cropperRef.current) === null || _a === void 0 ? void 0 : _a.cropper.getCroppedCanvas().toDataURL()) || null;
      yield this.setState({
        thumbnailSrc
      });
    });
  }
  renderThumbnails() {
    var _a;
    const thumbnails = this.props.thumbnails != null ? typeof this.props.thumbnails === "boolean" ? this.props.thumbnails == true ? [{
      width: 400,
      height: 160
    }] : [] : Array.isArray(this.props.thumbnails) ? this.props.thumbnails : [this.props.thumbnails] : [];
    const selectedPictureIndex = (_a = this.selectedPictureIndex) !== null && _a !== void 0 ? _a : 0;
    return React.createElement("div", {
      className: styles.thumbnails
    }, thumbnails.map((thumbnail, index) => React.createElement("div", {
      className: styles.thumbnail,
      key: index,
      style: {
        width: thumbnail.width,
        height: thumbnail.height,
        borderRadius: thumbnail.borderRadius || undefined
      }
    }, React.createElement("img", {
      src: this.state.thumbnailSrc || this.cropperSource,
      alt: this.getPreviewName(selectedPictureIndex) + `thumbnail #${index + 1}`
    }))));
  }
  renderPreviewPanel() {
    var _a;
    const index = (_a = this.selectedPictureIndex) !== null && _a !== void 0 ? _a : 0;
    const src = this.getPreviewSource(index);
    const alt = this.getPreviewName(index);
    return React.createElement("div", {
      className: styles.preview
    }, React.createElement("img", {
      src: src,
      alt: alt
    }), this.currentView == ImageInputView.Preview && this.renderThumbnails());
  }
  renderCropperPanel() {
    return React.createElement("div", {
      className: styles.cropper
    }, React.createElement(Cropper$1, {
      ref: this._cropperRef,
      className: styles.reactCropper,
      style: {
        height: "100%",
        width: "100%"
      },
      src: this.cropperSource,
      viewMode: 1,
      guides: false,
      ready: () => this._cropperHelper.setCropAreaToImageFullSize(),
      cropend: () => this.onCropEndAsync()
    }), this.renderThumbnails());
  }
  render() {
    const minimizeStyle = this.minimizeOnEmpty && this.pictures.length <= 0 ? styles.minimize : null;
    const fullScreenStyle = this.isFullscreen ? styles.fullScreen : null;
    return React.createElement("div", {
      className: this.css(styles.ImageInput, minimizeStyle, fullScreenStyle, this.props.className),
      onDragEnter: event => this.onImageInputDragEnterAsync(event)
    }, React.createElement("input", {
      ref: this._fileInputRef,
      className: styles.fileInput,
      type: "file",
      accept: this.acceptedTypes,
      multiple: this.multi,
      onChange: event => this.onFileInputChangeAsync(event)
    }), React.createElement("input", {
      ref: this._cameraFileInputRef,
      className: styles.fileInput,
      type: "file",
      accept: this.acceptedTypes,
      capture: "environment",
      multiple: this.multi,
      onChange: event => this.onFileInputChangeAsync(event)
    }), React.createElement("div", {
      className: styles.controlPanel
    }, this.renderControlPanel()), React.createElement("div", {
      className: styles.viewPanel
    }, React.createElement("div", {
      className: this.css(styles.dragDropArea, this.isDragOver && styles.dragDropAreaActive),
      onDrop: event => this.onDropDownAreaDropAsync(event),
      onDragOver: event => this.onDropDownAreaDragOverAsync(event),
      onDragEnter: event => this.onDropDownAreaDragEnterAsync(event),
      onDragLeave: event => this.onDropDownAreaDragLeaveAsync(event)
    }, React.createElement("span", {
      className: styles.dragDropAreaOverlay
    }, ImageInputLocalizer$1.dropIt)), this.currentView == ImageInputView.Edit && this.renderCropperPanel(), this.multi && this.currentView == ImageInputView.Default && this.renderListView(), (this.currentView == ImageInputView.Preview || !this.multi && this.currentView == ImageInputView.Default && this.hasSelectedPictureIndex) && this.renderPreviewPanel()));
  }
  //  Statics
  /**
   * Following functionality is enabled:
   * {@link IImageInputToolbar.uploadButton}
   * {@link IImageInputToolbar.takePictureButton}
   */
  static get defaultNoSelectionToolbar() {
    return {
      takePictureButton: true,
      uploadButton: true
    };
  }
  /**
   * Following functionality is enabled:
   * {@link IImageInputToolbar.rotateLeftButton}
   * {@link IImageInputToolbar.rotateRightButton}
   * {@link IImageInputToolbar.editButton}
   * {@link IImageInputToolbar.previewButton}
   * {@link IImageInputToolbar.uploadButton}
   * {@link IImageInputToolbar.takePictureButton}
   * {@link IImageInputToolbar.deleteButton}
   */
  static get defaultSelectionToolbar() {
    return {
      deleteButton: true,
      editButton: true,
      previewButton: true,
      rotateLeftButton: true,
      rotateRightButton: true,
      takePictureButton: true,
      uploadButton: true
    };
  }
  /**
   * Following functionality is enabled:
   * {@link IImageInputToolbar.editButton}
   * {@link IImageInputToolbar.uploadButton}
   * {@link IImageInputToolbar.takePictureButton}
   * {@link IImageInputToolbar.deleteButton}.
   *
   * A "Back"-button which returns the user back to the previous view is also displayed.
   */
  static get defaultPreviewToolbar() {
    return {
      deleteButton: true,
      editButton: true,
      uploadButton: true,
      takePictureButton: true
    };
  }
  /**
   * Following functionality is enabled:
   * {@link IImageInputToolbar.rotateLeftButton}
   * {@link IImageInputToolbar.rotateRightButton}
   * {@link IImageInputToolbar.deleteButton}.
   *
   * A "Save"-button which saves the changes and a "Back"-button which returns the user back to the previous view are also displayed.
   */
  static get defaultEditToolbar() {
    return {
      rotateLeftButton: true,
      rotateRightButton: true,
      deleteButton: true
    };
  }
  static fileToFileModel(file) {
    return __awaiter(this, void 0, void 0, function* () {
      const fileData = yield Utility.readUploadedFileAsDataUrl(file);
      const fileModel = new FileModel(fileData);
      fileModel.type = file.type;
      fileModel.name = file.name;
      fileModel.size = file.size;
      fileModel.lastModified = new Date(file.lastModified);
      return fileModel;
    });
  }
}

export { Accordion, AddressDivider, AddressDividerColumns, AddressHelper, AddressInput, Alert, AmountListItem, AthenaeumComponentsConstants, AutoSuggest, AutoSuggestItem, BannerPosition, Comparator as BaseComparator, BaseExpandableWidget, BaseFileValidator, BaseInput, BaseRegexValidator, BaseRegexValidatorErrorMessage, BaseRouteWidget, BaseValidator, BaseWidget, BaseWidgetContainer, BorderType, Button, ButtonAction, ButtonContainer, ButtonType, Carousel, CarouselNavigation, CarouselPagination, Cell, CellAction, CellActionComponent, CellModel, CellPaddingType, CheckHeaderCell, CheckStepWidget, Checkbox, CheckboxNullable, CheckboxWidget, ColorInput, ColumnAction, ColumnActionDefinition, ColumnActionType, ColumnDefinition, ColumnModel, ColumnSettings, ColumnSettingsDefinition, ColumnSubAction, ColumnSubActionDefinition, ColumnType, ConfirmationDialog, CookieConsent, DateInput, DateInputWidget, DateRangeInput, Description, DescriptionCellAction, DocumentPreview, DocumentPreviewModal, Dropdown, DropdownAlign, DropdownCell, DropdownListItem, DropdownOrderBy, DropdownRequiredType, DropdownSchema, DropdownSelectType, DropdownSubtextType, DropdownType, DropdownVerticalAlign, DropdownWidget, EmailInput, EmailValidator, Expander, ExpanderType, FileInput, FileSizeValidator, FileTypeValidator, FilesSizeValidator, Footer, Form, FourColumns, GoogleMap, Grid, GridHoveringType, GridModel, GridOddType, GridSelectableType, GridSpinner, GridTransformer, Hamburger, HeaderCell, Icon, IconSize, IconStyle, ImageFilterType, ImageInput, ImageModal, ImageProvider, Inline, InlineType, JustifyContent, LanguageDropdown, Layout, LdDataHeader, LeftNav, LengthValidator, Link, LinkWidget, List, LiveValidator, LocationPicker, LocationPickerModal, MessageBox, Modal, ModalSize, NavigationWidget, NumberInput, NumberInputBehaviour, NumberRangeValidator, NumberWidget, OneColumn, PageContainer, PageHeader, PageRow, Pagination, Panel, PanelCollapseType, PasswordForm, PasswordFormType, PasswordInput, PasswordValidator, PhoneInput, PhoneValidator, Popover, QrFormat, QrInput, QrWidget, QrWidgetConstraints, QrWidgetHighResolutionType, QrWidgetType, Range, RegexValidator, RequiredValidator, RouteWidget, Row, RowModel, Scroller, SelectListGroup, SelectListItem, SelectListSeparator, SignatureWidget, Skeleton, Slider, Spinner, StatusListItem, StepsWidget, Switch, SwitchNullable, SwitchWidget, Tab, TabContainer, TabContainerHeaderStyleType, TabContainerModel, TabHeader, TabModel, TabRenderType, TabTransformer, TextAreaInput, TextAreaWidget, TextInput, TextInputWidget, ThreeColumns, TimeWidget, TitleWidget, TogglerPosition, ToolbarButton, ToolbarContainer, ToolbarRow, TopMenuContainer, TopNav, TotalRow, TwoColumns, UrlInput, UrlValidator, ValidationRow, VirtualAddressDivider, WidgetContainer, WizardContainer };
